webpackJsonp([65],{

/***/ "+++F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_dashboardNotification__ = __webpack_require__("Qoh4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__ = __webpack_require__("a0yF");


/*
  Generic component used to display notifications coming from
  notifications API endpoint. It's also used by notification-items.js
  to display those generic components in top right corner of the app
  if user has notifications turned on.
 */







var NOTIFICATION_CLASS_SETTLED = 'settled';
var NOTIFICATION_CLASS_PRICE_UP = 'price-up';
var NOTIFICATION_CLASS_PRICE_DOWN = 'price-down';
var NOTIFICATION_CLASS_MATCHED = 'matched';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_dashboardNotification__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__["a" /* default */]],
  props: {
    showTimeElapsed: {
      type: Boolean,
      default: false
    }
  },
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  computed: {
    iconTargetClass: function iconTargetClass() {
      switch (this.data.notificationType) {
        case __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["b" /* NOTIFICATION_MATCHED */]:
          return NOTIFICATION_CLASS_MATCHED;
        case __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["c" /* NOTIFICATION_SETTLED */]:
          return NOTIFICATION_CLASS_SETTLED;
        case __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["d" /* NOTIFICATION_PRICE_CHANGE */]:
          return this.data.contentJson.PriceDelta > 0 ? NOTIFICATION_CLASS_PRICE_UP : NOTIFICATION_CLASS_PRICE_DOWN;
        default:
          return NOTIFICATION_CLASS_SETTLED;
      }
    },
    classModifiers: function classModifiers() {
      var _ref;

      var isUnread = this.theme !== 'notifications' && this.data && typeof this.data.isRead !== 'undefined' && !this.data.isRead;
      return _ref = {
        'notification-item-dashboard': true,
        'notification-item-dashboard--unread': isUnread
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'notification-item-dashboard--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'notification-item-dashboard--clickable', this.marketId), _ref;
    },
    marketId: function marketId() {
      return this.data.contentJson ? this.data.contentJson.MarketId : null;
    },
    iconClassModifiers: function iconClassModifiers() {
      return {
        'notification-item-dashboard__icon': true
      };
    },
    iconStyleModifiers: function iconStyleModifiers() {
      return {
        'background-image': 'url(' + this.data.contentJson.ImageUrl + ')'
      };
    },
    showContractName: function showContractName() {
      return this.data.notificationType === __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["d" /* NOTIFICATION_PRICE_CHANGE */];
    },
    showPayout: function showPayout() {
      return this.data.notificationType === __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["c" /* NOTIFICATION_SETTLED */];
    },
    showSellInfo: function showSellInfo() {
      return this.data.notificationType === __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["b" /* NOTIFICATION_MATCHED */];
    },
    showSharesOwned: function showSharesOwned() {
      return this.data.notificationType === __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["d" /* NOTIFICATION_PRICE_CHANGE */];
    },
    showPriceChange: function showPriceChange() {
      return this.data.notificationType === __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["d" /* NOTIFICATION_PRICE_CHANGE */];
    },
    showLevelChanged: function showLevelChanged() {
      return this.data.notificationType === __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["e" /* NOTIFICATION_LEVEL */];
    },
    showNextLevelInfo: function showNextLevelInfo() {
      return this.data.contentJson.NewTraderLevel < 7;
    },
    quantity: function quantity() {
      return this.data.contentJson.Quantity;
    },
    sharesOwned: function sharesOwned() {
      return this.data.contentJson.SharesOwned;
    },
    isYes: function isYes() {
      var tradeType = this.data.contentJson.TradeType;
      return tradeType === 1 || tradeType === 3;
    },
    yesNoText: function yesNoText() {
      return this.isYes ? 'YES' : 'NO';
    },
    pricePerShare: function pricePerShare() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["h" /* toCents */])(this.data.contentJson.PricePerShare);
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["k" /* isMarketSingle */])(this.data.contentJson);
    },
    tradeTypeShare: function tradeTypeShare() {
      return typeof this.data.contentJson.MarketType === 'undefined' || this.isMarketSingle ? '' : this.data.contentJson.ContractName || '';
    },
    tradeTypeOperation: function tradeTypeOperation() {
      return this.data.contentJson.TradeType <= 1 ? 'Bought' : 'Sold';
    },
    lastTradePriceAsCents: function lastTradePriceAsCents() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["h" /* toCents */])(this.data.contentJson.LastTradePrice);
    },
    routeTo: function routeTo() {
      if (this.marketId) {
        return {
          name: 'market-details',
          params: {
            marketId: this.marketId
          }
        };
      }
      return {};
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['closeNotificationsWidget']), {
    onInteract: function onInteract() {
      this.closeNotificationsWidget();
    }
  })
});

/***/ }),

/***/ "+1tr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_research_widget_research_widget_vue__ = __webpack_require__("/yTp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_twitter_twitter_timeline_twitter_timeline_vue__ = __webpack_require__("FM5G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_insight_insight_widget_insight_widget_vue__ = __webpack_require__("w0Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_biggest_gains_market_biggest_gains_vue__ = __webpack_require__("XqpO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_money_widget_market_money_widget_vue__ = __webpack_require__("JVxM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_market_currently_predicting_market_currently_predicting_vue__ = __webpack_require__("Dksu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_market_key_stats_market_key_stats_vue__ = __webpack_require__("aHny");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_market_market_top_comments_market_top_comments_vue__ = __webpack_require__("KvDS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_insight_insight_news_insight_news_vue__ = __webpack_require__("rjQl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_cms_preview_carousel_preview_carousel_vue__ = __webpack_require__("7WHf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_seoMeta__ = __webpack_require__("08z+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_pages_page_election_map_new_election_map_election_map_vue__ = __webpack_require__("nYw4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_daily_markets_daily_markets_vue__ = __webpack_require__("B/8G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_pages_page_markets_page_markets_vue__ = __webpack_require__("CIck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_canonical_url__ = __webpack_require__("9XaW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_json_ld__ = __webpack_require__("oE+L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__news_feed_news_feed_vue__ = __webpack_require__("xJ4c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__podcasts_podcasts_vue__ = __webpack_require__("QrTx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__hero_unit_slider_hero_unit_slider_vue__ = __webpack_require__("RQ5D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__quotes_quotes_vue__ = __webpack_require__("PElc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__how_it_works_how_it_works_vue__ = __webpack_require__("Z05w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__most_predicted_most_predicted_vue__ = __webpack_require__("UqqE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__most_predicted_list_most_predicted_list_vue__ = __webpack_require__("4p0o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__home_videos__ = __webpack_require__("CPvM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__helpers_reloadOnChunkError__ = __webpack_require__("tkA1");































var HOME_JSON_LD_VMID = 'jsonld-home';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_13__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__mixins_seoMeta__["a" /* default */]],
  components: {
    electionMap: __WEBPACK_IMPORTED_MODULE_16__components_pages_page_election_map_new_election_map_election_map_vue__["a" /* default */],
    heroUnitSlider: __WEBPACK_IMPORTED_MODULE_23__hero_unit_slider_hero_unit_slider_vue__["a" /* default */],
    quotes: __WEBPACK_IMPORTED_MODULE_24__quotes_quotes_vue__["a" /* default */],
    howItWorks: __WEBPACK_IMPORTED_MODULE_25__how_it_works_how_it_works_vue__["a" /* default */],
    mostPredicted: __WEBPACK_IMPORTED_MODULE_26__most_predicted_most_predicted_vue__["a" /* default */],
    podcasts: __WEBPACK_IMPORTED_MODULE_22__podcasts_podcasts_vue__["a" /* default */],
    researchWidget: __WEBPACK_IMPORTED_MODULE_2__components_research_widget_research_widget_vue__["a" /* default */],
    inTheNews: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__helpers_reloadOnChunkError__["d" /* lazyWithReload */])(function () {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "y1jZ"));
    }),
    twitterTimeline: __WEBPACK_IMPORTED_MODULE_3__components_twitter_twitter_timeline_twitter_timeline_vue__["default"],
    newsFeed: __WEBPACK_IMPORTED_MODULE_21__news_feed_news_feed_vue__["default"],
    mostPredictedList: __WEBPACK_IMPORTED_MODULE_27__most_predicted_list_most_predicted_list_vue__["a" /* default */],
    insightWidget: __WEBPACK_IMPORTED_MODULE_4__components_insight_insight_widget_insight_widget_vue__["a" /* default */],
    marketBiggestGains: __WEBPACK_IMPORTED_MODULE_5__components_market_market_biggest_gains_market_biggest_gains_vue__["a" /* default */],
    marketMoneyWidget: __WEBPACK_IMPORTED_MODULE_6__components_market_market_money_widget_market_money_widget_vue__["a" /* default */],
    marketCurrentlyPredicting: __WEBPACK_IMPORTED_MODULE_7__components_market_market_currently_predicting_market_currently_predicting_vue__["a" /* default */],
    marketKeyStats: __WEBPACK_IMPORTED_MODULE_8__components_market_market_key_stats_market_key_stats_vue__["a" /* default */],
    marketTopComments: __WEBPACK_IMPORTED_MODULE_9__components_market_market_top_comments_market_top_comments_vue__["a" /* default */],
    homeVideos: __WEBPACK_IMPORTED_MODULE_28__home_videos__["a" /* default */],
    insightNews: __WEBPACK_IMPORTED_MODULE_10__components_insight_insight_news_insight_news_vue__["a" /* default */],
    dailyMarkets: __WEBPACK_IMPORTED_MODULE_17__components_daily_markets_daily_markets_vue__["a" /* default */],
    pageMarkets: __WEBPACK_IMPORTED_MODULE_18__components_pages_page_markets_page_markets_vue__["default"],
    previewCarousel: __WEBPACK_IMPORTED_MODULE_11__components_cms_preview_carousel_preview_carousel_vue__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    var canonicalUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_canonical_url__["a" /* default */])(this.$router, 'home');
    var homeTitle = 'PredictIt: The Original Political Prediction Market';
    var homeDescription = 'Trade political prediction markets on PredictIt. Follow election odds, track political events and see how real people price what happens next.';
    var jsonLdSchema = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_json_ld__["f" /* buildOrganizationWebsiteSchema */])({
      origin: window.location.origin,
      homeName: homeTitle,
      websiteDescription: homeDescription,
      sameAs: ["https://www.facebook.com/PredictIt/", "https://www.instagram.com/PredictIt/", "https://twitter.com/PredictIt", "https://www.youtube.com/c/predictitofficial"]
    });
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.buildSeoMeta({
      title: homeTitle,
      description: homeDescription,
      url: canonicalUrl
    }), {
      script: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_json_ld__["b" /* buildJsonLdTag */])(jsonLdSchema, HOME_JSON_LD_VMID)],
      __dangerouslyDisableSanitizersByTagID: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_json_ld__["c" /* jsonLdSanitizerOverride */])(HOME_JSON_LD_VMID)
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile', 'isShutdownModeOn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isUserRestricted', 'isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('popup', ['currentPopup']), {
    classModifiers: function classModifiers() {
      return {
        'home-old': true,
        'home-old--shutdown': this.isShutdownModeOn
      };
    },
    showMap: function showMap() {
      return false;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    showHomepageInitialLoader: function showHomepageInitialLoader() {
      if (this.homepageInitialLoaderVisible) {
        return;
      }
      this.loaderAdd(document.body);
      this.homepageInitialLoaderVisible = true;
    },
    hideHomepageInitialLoader: function hideHomepageInitialLoader() {
      if (!this.homepageInitialLoaderVisible) {
        return;
      }
      this.loaderRemove(document.body);
      this.homepageInitialLoaderVisible = false;
    },
    onEmbeddedInitialLoadStateChange: function onEmbeddedInitialLoadStateChange(isLoading) {
      if (this.initialHomepageMarketLoadComplete) {
        return;
      }
      if (isLoading) {
        this.showHomepageInitialLoader();
      } else {
        this.hideHomepageInitialLoader();
        this.initialHomepageMarketLoadComplete = true;
      }
    }
  }),
  data: function data() {
    return {
      initialHomepageMarketLoadComplete: false,
      homepageInitialLoaderVisible: false
    };
  },
  mounted: function mounted() {
    if (!this.initialHomepageMarketLoadComplete) {
      this.showHomepageInitialLoader();
    }
    if (this.isUserRestricted && !this.currentPopup) {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_modals_constants__["a" /* MODALS */].LOGIN);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.hideHomepageInitialLoader();
  }
});

/***/ }),

/***/ "+6DW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractInfoLoader_vue__ = __webpack_require__("Zdfa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_781a0632_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractInfoLoader_vue__ = __webpack_require__("egIo");
function injectStyle (ssrContext) {
  __webpack_require__("Ng05")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractInfoLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_781a0632_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractInfoLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+88x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


function setLargeNumber(el, binding) {
  el.innerHTML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["x" /* largeNumberDisplay */])(binding.value || 0);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    setLargeNumber(el, binding);
  },
  update: function update(el, binding) {
    setLargeNumber(el, binding);
  }
});

/***/ }),

/***/ "+CKl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-done-links"},[_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onDone($event)}}},[_vm._v("\n    Done\n  ")]),_vm._v(" "),(_vm.showPendingLink)?_c('span',{staticClass:"deposit-done-links__link",on:{"click":function($event){$event.preventDefault();return _vm.onViewPendingDeposits($event)}}},[_vm._v("\n    View Pending Deposits\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+COC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+CQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_small_js__ = __webpack_require__("S1Yq");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42c04a95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_small_vue__ = __webpack_require__("B3yl");
function injectStyle (ssrContext) {
  __webpack_require__("+COC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_small_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42c04a95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_small_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+Cz8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_alert_box_js__ = __webpack_require__("qYhg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdf3861e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_box_vue__ = __webpack_require__("n5Uq");
function injectStyle (ssrContext) {
  __webpack_require__("OCEH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_alert_box_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdf3861e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+Rub":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_amount_picker_js__ = __webpack_require__("NRuh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8fbc45c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_amount_picker_vue__ = __webpack_require__("vGIz");
function injectStyle (ssrContext) {
  __webpack_require__("HqyC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_amount_picker_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8fbc45c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_amount_picker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+ZRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__ = __webpack_require__("k37b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");

/* eslint-disable no-unused-vars */





var searchMixin = {
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('search', ['toggleSearchBar', 'getSearch', 'resetSearchResults']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['closeMobileMenu']), {
    onSearchResults: function onSearchResults(data) {
      this.closeMobileMenu();
    },
    formatQuery: function formatQuery(query) {
      return query.trim();
    },
    doSearch: function doSearch(query) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { reset: true };

      if (this.isLoading) return;
      this.loaderAddLegacy(document.body);
      if (options.reset) {
        this.resetSearchResults(query);
      }

      this.getSearch(this.formatQuery(query)).then(function (data) {
        _this.loaderRemoveLegacy(document.body);
        _this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__["a" /* withMeta */])({
          event: 'Search',
          SearchNumTotalMarketsFound: data.totalMarkets
        }));
        _this.onSearchResults(data);

        if (_this.$router.currentRoute.query.query !== query) {
          _this.$router.push({
            name: 'market-search',
            query: {
              query: query
            }
          });
        }
      }).catch(function () {
        return _this.loaderRemoveLegacy(document.body);
      });
    }
  })
};

/* harmony default export */ __webpack_exports__["a"] = (searchMixin);

/***/ }),

/***/ "+j07":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"processing-transaction"},[(_vm.showTimeout)?[_c('div',{staticClass:"processing-transaction__headline"},[_c('h5',{staticClass:"processing-transaction__title processing-transaction__title--warn"},[_vm._v("\n        Processing Timeout\n      ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width processing-transaction__button",on:{"click":_vm.openDepositHistory}},[_vm._v("\n        Open Deposit History\n      ")])])]:[_c('div',{staticClass:"processing-transaction__loader"}),_vm._v(" "),_c('div',{staticClass:"processing-transaction__processing"},[_vm._v("\n      Processing Transaction...\n    ")])]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("\n          It looks like we are having some communication issues. Don't worry, we will keep trying to complete your deposit. Please check your Deposit History as usually these issues resolve within a few minutes.\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+jU6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_validators__ = __webpack_require__("SVQh");





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'AccountPhoneUpdate',
    mixins: [__WEBPACK_IMPORTED_MODULE_2_vuelidate__["validationMixin"]],
    props: {
        bankLink: {
            type: Boolean,
            default: false
        }
    },
    validations: {
        phoneNumber: __WEBPACK_IMPORTED_MODULE_3__helpers_validators__["a" /* default */].phone
    },
    data: function data() {
        return {
            phoneNumber: '',
            verificationCode: '',
            step: 'input', // 'input', 'verify'
            isSending: false,
            isVerifying: false,
            isDestroyed: false,
            error: null,
            secondsUntilResend: 0,
            resendTimer: null
        };
    },

    computed: {
        canSendCode: function canSendCode() {
            return !this.$v.phoneNumber.$invalid && !this.isSending && this.secondsUntilResend === 0;
        },
        canVerify: function canVerify() {
            return this.verificationCode.length >= 6 && !this.isVerifying;
        },
        phoneError: function phoneError() {
            if (this.$v.phoneNumber.$error) {
                return 'Enter a valid phone number';
            }
            return '';
        },
        inputDescription: function inputDescription() {
            return this.bankLink ? 'Enter a mobile phone number to receive a verification code.' : 'Verify your phone number via SMS code.';
        },
        verificationActionText: function verificationActionText() {
            return this.bankLink ? 'Verify and Continue' : 'Verify & Update';
        },
        verificationDestination: function verificationDestination() {
            if (!this.bankLink) return this.phoneNumber;
            var digits = (this.phoneNumber || '').replace(/[^0-9]/g, '');
            if (digits.length < 4) return this.phoneNumber;
            return '***-***-' + digits.slice(-4);
        }
    },
    methods: {
        sendCode: function sendCode() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this.canSendCode) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:

                                _this.isSending = true;
                                _this.error = null;

                                _context.prev = 4;
                                _context.next = 7;
                                return _this.$store.dispatch('user/phoneUpdate', {
                                    phoneNumber: _this.phoneNumber
                                });

                            case 7:
                                response = _context.sent;

                                if (!_this.isDestroyed) {
                                    _context.next = 10;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 10:
                                _this.step = 'verify';
                                _this.secondsUntilResend = response && response.seconds_til_resend_available || 60;
                                _this.startResendTimer();
                                _context.next = 20;
                                break;

                            case 15:
                                _context.prev = 15;
                                _context.t0 = _context['catch'](4);

                                if (!_this.isDestroyed) {
                                    _context.next = 19;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 19:
                                _this.error = _this.extractErrorMessage(_context.t0, 'Failed to send verification code.');

                            case 20:
                                _context.prev = 20;

                                if (!_this.isDestroyed) {
                                    _this.isSending = false;
                                }
                                return _context.finish(20);

                            case 23:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[4, 15, 20, 23]]);
            }))();
        },
        verifyCode: function verifyCode() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (_this2.canVerify) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:

                                _this2.isVerifying = true;
                                _this2.error = null;

                                _context2.prev = 4;
                                _context2.next = 7;
                                return _this2.$store.dispatch('user/phoneVerify', {
                                    phoneNumber: _this2.phoneNumber,
                                    code: _this2.verificationCode
                                });

                            case 7:
                                if (!_this2.isDestroyed) {
                                    _context2.next = 9;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 9:
                                _context2.next = 11;
                                return _this2.$store.dispatch('user/getAccountDetail');

                            case 11:
                                if (!_this2.isDestroyed) {
                                    _context2.next = 13;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 13:
                                _this2.$emit('verified');
                                _context2.next = 22;
                                break;

                            case 16:
                                _context2.prev = 16;
                                _context2.t0 = _context2['catch'](4);

                                if (!_this2.isDestroyed) {
                                    _context2.next = 20;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 20:
                                _this2.error = _this2.extractErrorMessage(_context2.t0, 'Incorrect code. Please try again.');
                                _this2.verificationCode = '';

                            case 22:
                                _context2.prev = 22;

                                if (!_this2.isDestroyed) {
                                    _this2.isVerifying = false;
                                }
                                return _context2.finish(22);

                            case 25:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[4, 16, 22, 25]]);
            }))();
        },
        startResendTimer: function startResendTimer() {
            var _this3 = this;

            this.clearResendTimer();
            this.resendTimer = setInterval(function () {
                if (_this3.secondsUntilResend > 0) {
                    _this3.secondsUntilResend -= 1;
                } else {
                    _this3.clearResendTimer();
                }
            }, 1000);
        },
        clearResendTimer: function clearResendTimer() {
            if (this.resendTimer) {
                clearInterval(this.resendTimer);
                this.resendTimer = null;
            }
        },
        extractErrorMessage: function extractErrorMessage(error, defaultMessage) {
            if (error.response && error.response.data) {
                var data = error.response.data;
                if (Array.isArray(data) && data.length > 0 && data[0].message) {
                    return data[0].message;
                }
                if (data.errors && Array.isArray(data.errors) && data.errors.length > 0) {
                    return data.errors[0].message;
                }
                if (data.message) {
                    return data.message;
                }
            }
            return defaultMessage;
        },
        onCancel: function onCancel() {
            this.$emit('close');
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.isDestroyed = true;
        this.clearResendTimer();
    }
});

/***/ }),

/***/ "+kDG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_chart_models__ = __webpack_require__("Q+EN");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    chartData: {
      type: Array,
      required: true,
      default: null
    },
    chartDataLoaded: {
      type: Boolean,
      default: false
    },
    chartOptions: {
      type: Object,
      default: null
    },
    market: {
      type: Object,
      required: true
    },
    timeline: {
      type: String,
      required: false
    },
    chartType: {
      type: String,
      required: false
    },
    chartSystemOptions: {
      type: Object,
      default: function _default() {}
    },
    showVolume: {
      type: Boolean,
      default: false
    },
    showPriceAxisZoom: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      chart: null
    };
  },

  computed: {
    containerStyleModifiers: function containerStyleModifiers() {
      var height = '390px';
      if (this.chartOptions && this.chartOptions.maxHeight) {
        height = this.chartOptions.maxHeight;
      }
      if (this.chartSystemOptions && this.chartSystemOptions.maxHeight) {
        height = this.chartSystemOptions.maxHeight;
      }
      return {
        height: height
      };
    }
  },
  watch: {
    showVolume: function showVolume() {
      this.renderChart();
    },
    showPriceAxisZoom: function showPriceAxisZoom() {
      this.renderChart();
    },
    chartType: function chartType() {
      this.renderChart();
    },
    chartData: function chartData(value) {
      this.createChart(value);
    }
  },
  methods: {
    createChart: function createChart(data) {
      var _this = this;

      if (data && data.length > 0) {
        setTimeout(function () {
          _this.renderChart();
        }, __WEBPACK_IMPORTED_MODULE_0__utils_chart_models__["a" /* ContractChartGroup */].renderTimeout());
      } else if (this.$refs.chart) {
        this.$refs.chart.innerHTML = '';
      }
    },
    renderChart: function renderChart() {
      if (!this.$refs.chart) return;
      if (this.chart !== null) {
        this.chart.destroy();
      }
      var ClassName = this.chartType === 'candle' ? __WEBPACK_IMPORTED_MODULE_0__utils_chart_models__["b" /* ContractChartGroupStock */] : __WEBPACK_IMPORTED_MODULE_0__utils_chart_models__["a" /* ContractChartGroup */];
      var options = this.chartOptions || {};
      options.showVolume = this.showVolume;
      options.showPriceAxisZoom = this.showPriceAxisZoom;
      var group = new ClassName({
        market: this.market,
        timeline: this.timeline,
        data: this.chartData,
        chartOptions: options
      });
      this.chart = group.draw(this.$refs.chart);
    }
  }
});

/***/ }),

/***/ "+oQ1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+poj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_recaptcha__ = __webpack_require__("dSZ5");











var CAPTCHA_FIELD = 'g-recaptcha-response';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* formMixin */], __WEBPACK_IMPORTED_MODULE_6__mixins_popupPageModeMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_userAgent__["a" /* default */]],
  props: {
    email: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function data() {
    return {
      // login attempt counter (for v2 fallback rerenders)
      attempt: 1,
      fieldTypePassword: 'password',
      fields: {
        email: this.email,
        password: '',
        rememberMe: true
      },
      timeout: null,
      // Pending payload for v2 fallback retry
      pendingPayload: null
    };
  },

  validations: {
    fields: {
      email: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["b" /* validators */].emailNoMessage,
      password: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["b" /* validators */].requiredNoMessage
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('user', ['isUserRestricted']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('popup', ['currentPopupOptions']), {
    loginButtonDisabled: function loginButtonDisabled() {
      return this.invalidOrDisabled;
    }
  }),
  mounted: function mounted() {
    // Check if we were redirected here with a login error (e.g., from registration flow)
    if (this.currentPopupOptions && this.currentPopupOptions.loginError) {
      this.formHandleErrors(this.currentPopupOptions.loginError);
      // Clear the error from options so it doesn't show again on re-render
      this.setCurrentPopupOptions({});
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('user', ['login', 'setUseDisqus', 'loginDisqus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentPopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('profile', ['setProfileStatus']), {
    showPassword: function showPassword() {
      this.fieldTypePassword = this.fieldTypePassword === 'password' ? 'text' : 'password';
    },
    onForgotten: function onForgotten() {
      if (this.isPage) {
        this.$router.push({ name: 'account-password-forgotten' });
      } else {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_modals_constants__["a" /* MODALS */].FORGOTTEN);
      }
    },
    getRedirectPath: function getRedirectPath() {
      if (this.$router.currentRoute.query.redirect) return this.$router.currentRoute.query.redirect;
      if (this.$router.currentRoute.name === 'home' || this.isPage) return { name: 'portfolio' };
      return null;
    },
    triggerRedirect: function triggerRedirect(redirect) {
      this.$router.push(redirect);
      if (this.isIos) {
        this.$nextTick(function () {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 100);
        });
      }
    },
    onLogin: function onLogin() {
      var _this = this;

      this.setProfileStatus({ event: 'login' });
      if (this.$route && this.$route.name === 'disqus-auth') {
        this.loginDisqus().then(function () {
          _this.setUseDisqus(true);
          window.close();
        });
      } else {
        var redirect = this.getRedirectPath();
        this.setCurrentPopup();
        if (redirect) {
          this.triggerRedirect(redirect);
        }
      }
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _payload, v3Token, payload;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.formIsValid() && _this2.formDisable())) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_9__services_recaptcha__["a" /* default */].executeV3('login');

              case 4:
                v3Token = _context.sent;
                payload = (_payload = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, CAPTCHA_FIELD, v3Token), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'recaptcha-version', 'v3'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'email', _this2.fields.email), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'password', _this2.fields.password), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'grant_type', 'password'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'rememberMe', _this2.fields.rememberMe), _payload);


                _this2.login(payload).then(function (result) {
                  _this2.formEnable();

                  // Check if 2FA challenge is required
                  if (result.requiresTwoFactor) {
                    // Switch to 2FA verification modal
                    _this2.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_modals_constants__["a" /* MODALS */].TWO_FACTOR);
                    return;
                  }

                  _this2.onLogin();
                }).catch(function (error) {
                  // Step 2: Check if v3 failed and v2 challenge is needed
                  if (__WEBPACK_IMPORTED_MODULE_9__services_recaptcha__["a" /* default */].isV3ScoreFailure(error)) {
                    _this2.pendingPayload = payload;
                    _this2.attempt += 1;
                    _this2.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_modals_constants__["a" /* MODALS */].RECAPTCHA_CHALLENGE);
                    _this2.setCurrentPopupOptions({
                      attempt: _this2.attempt,
                      onVerified: _this2.onRecaptchaV2Verified
                    });
                    _this2.formEnable();
                    return;
                  }

                  _this2.attempt += 1;
                  _this2.formHandleErrors(error);
                });
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

                // Error getting v3 token - fall back to showing error
                _this2.formEnable();
                _this2.formHandleErrors(_context.t0);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 9]]);
      }))();
    },
    onRecaptchaV2Verified: function onRecaptchaV2Verified(v2Token) {
      var _extends2,
          _this3 = this;

      // Called when user completes v2 challenge in modal
      // Don't switch to login modal yet - keep reCAPTCHA visible during API call
      // to avoid "flash" of login form before 2FA or success transition

      var payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.pendingPayload, (_extends2 = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, CAPTCHA_FIELD, v2Token), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, 'recaptcha-version', 'v2'), _extends2));

      this.login(payload).then(function (result) {
        _this3.formEnable();

        if (result.requiresTwoFactor) {
          _this3.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_modals_constants__["a" /* MODALS */].TWO_FACTOR);
          return;
        }

        // Success - close modal and proceed
        _this3.onLogin();
      }).catch(function (error) {
        // On error, pass error via popup options so new login modal can display it
        // (calling formHandleErrors here won't work as this component is destroyed)
        _this3.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_modals_constants__["a" /* MODALS */].LOGIN);
        _this3.setCurrentPopupOptions({ loginError: error });
      });
    }
  })
});

/***/ }),

/***/ "+sDo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_modules_app__ = __webpack_require__("WSTi");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    currentStepIndexFlow1: 1,
    optionSecondStepSelectedFlow1: __WEBPACK_IMPORTED_MODULE_0__store_modules_app__["a" /* APP_COLOR_PALETTE */].GREEN_RED,
    optionThirdStepSelectedFlow1: __WEBPACK_IMPORTED_MODULE_0__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].CONDENSED
  },
  mutations: {
    nextStepFlow1: function nextStepFlow1(state) {
      state.currentStepIndexFlow1 += 1;
    },
    prevStepFlow1: function prevStepFlow1(state) {
      state.currentStepIndexFlow1 -= 1;
    },
    selectOptionThirdStepFlow1: function selectOptionThirdStepFlow1(state, value) {
      state.optionThirdStepSelectedFlow1 = value;
    },
    selectOptionSecondStepFlow1: function selectOptionSecondStepFlow1(state, value) {
      state.optionSecondStepSelectedFlow1 = value;
    }
  },
  actions: {
    nextStepFlow1: function nextStepFlow1(_ref) {
      var commit = _ref.commit;

      commit('nextStepFlow1');
    },
    prevStepFlow1: function prevStepFlow1(_ref2) {
      var commit = _ref2.commit;

      commit('prevStepFlow1');
    },
    selectOptionSecondStepFlow1: function selectOptionSecondStepFlow1(_ref3, value) {
      var commit = _ref3.commit;

      commit('selectOptionSecondStepFlow1', value);
    },
    selectOptionThirdStepFlow1: function selectOptionThirdStepFlow1(_ref4, value) {
      var commit = _ref4.commit;

      commit('selectOptionThirdStepFlow1', value);
    }
  }
});

/***/ }),

/***/ "//pC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/3CK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader content-loader--dashboard-notifications"},[_c('notification-loader'),_vm._v(" "),_c('notification-loader'),_vm._v(" "),_c('notification-loader')],1):[_c('div',{staticClass:"notifications-list__content"},[_vm._l((_vm.items),function(notification,index){return _c('notification-item-dashboard',{key:notification.notificationId,staticClass:"notifications-list__item",attrs:{"theme":_vm.theme,"showTimeElapsed":true,"index":index,"data":notification}})}),_vm._v(" "),(_vm.isScrollMore)?_c('div',{staticClass:"notifications-list__scroll-down"},[_vm._v("Scroll down for more notifications")]):_vm._e(),_vm._v(" "),(_vm.showInfiniteLoading)?_c('infinite-loading',{attrs:{"distance":150},on:{"infinite":_vm.goInfinite}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('div',{staticClass:"notifications-list__spinner"})]),_vm._v(" "),_c('span',{attrs:{"slot":"no-results"},slot:"no-results"}),_vm._v(" "),_c('span',{attrs:{"slot":"no-more"},slot:"no-more"})]):_vm._e()],2),_vm._v(" "),(_vm.notificationsCount === 0)?_c('div',{staticClass:"notifications-list__footer-no-notifications"},[_vm._v("\n      There are no notifications to display\n    ")]):_vm._e(),_vm._v(" "),(_vm.limit !== null && _vm.notificationsCount > 0)?_c('div',{staticClass:"notifications-list__link",on:{"click":_vm.onSeeAllClick}},[_vm._v("\n      See All Notifications\n    ")]):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/7LY":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTQgOCI+CiAgICA8cGF0aCBmaWxsPSIjMjYzQjNGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xMy42NjcuOTAybC0uNjczLS42MDRBMS4yMjQgMS4yMjQgMCAwIDAgMTIuMTc2IDBjLS4zMTggMC0uNTg3LjEtLjgwOS4yOThMNyA0LjIxMiAyLjYzMy4yOThBMS4xNjkgMS4xNjkgMCAwIDAgMS44MjQgMGMtLjMxMSAwLS41ODQuMS0uODE4LjI5OEwuMzQxLjkwMkEuOTUxLjk1MSAwIDAgMCAwIDEuNjM1YzAgLjI5LjExNC41MzIuMzQxLjcyNWw1Ljg1IDUuMjQzYy4yMTYuMjA0LjQ4NS4zMDYuODA5LjMwNi4zMTggMCAuNTktLjEwMi44MTgtLjMwNmw1Ljg1LTUuMjQzQS45MzguOTM4IDAgMCAwIDE0IDEuNjM1YzAtLjI4LS4xMS0uNTIzLS4zMzMtLjczM3oiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "/96V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/ELm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"no-data-dashed-box__icon"}),_vm._v(" "),_c('div',{staticClass:"no-data-dashed-box__text"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Fc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObject},[_c('div',{staticClass:"check-option__box"},[_c('form-checkbox',{staticClass:"checkbox--settings-option",attrs:{"label":_vm.obj.info,"name":_vm.checkboxName,"disabled":_vm.disabled},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1),_vm._v(" "),(_vm.withValue)?_c('div',{staticClass:"check-option__input"},[_c('currency-input',{attrs:{"initial":_vm.obj.currencyInitial,"disabled":_vm.disabled,"validate":_vm.obj.validate},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/JWN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__ = __webpack_require__("k37b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_documentUpload__ = __webpack_require__("9xQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_getValidationMessage__ = __webpack_require__("U7Hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_promoCode__ = __webpack_require__("nPqm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_depositWarningMixin__ = __webpack_require__("Scap");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_wallet_shared_deposit_disclaimer_deposit_disclaimer_vue__ = __webpack_require__("SmIQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_wallet_shared_deposit_amount_picker_deposit_amount_picker_vue__ = __webpack_require__("+Rub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_wallet_shared_fee_waived_banner_fee_waived_banner_vue__ = __webpack_require__("TBZZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_wallet_shared_depositMethodTypes__ = __webpack_require__("LQTn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_contentLoader__ = __webpack_require__("P71F");



















var AMOUNT_STEP_ONE = 10;
var AMOUNT_STEP_THREE = 50;
var AMOUNT_STEP_FOUR = 100;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["a" /* formMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_promoCode__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_depositWarningMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__mixins_contentLoader__["a" /* default */]],
  components: {
    depositDisclaimer: __WEBPACK_IMPORTED_MODULE_12__components_wallet_shared_deposit_disclaimer_deposit_disclaimer_vue__["a" /* default */],
    depositAmountPicker: __WEBPACK_IMPORTED_MODULE_13__components_wallet_shared_deposit_amount_picker_deposit_amount_picker_vue__["a" /* default */],
    feeWaivedBanner: __WEBPACK_IMPORTED_MODULE_14__components_wallet_shared_fee_waived_banner_fee_waived_banner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      depositMethodType: __WEBPACK_IMPORTED_MODULE_15__components_wallet_shared_depositMethodTypes__["a" /* DEPOSIT_METHOD_TYPE */].CRYPTO,
      errorMessage: '',
      canDeposit: false,
      isComponentReady: false,
      fields: {
        amount: ''
      },
      depositAmounts: [AMOUNT_STEP_ONE, AMOUNT_STEP_THREE, AMOUNT_STEP_FOUR]
    };
  },
  validations: function validations() {
    return {
      fields: {
        amount: __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["b" /* validators */].depositAmountCoinbase(this.minimumDepositAmount, this.maximumDepositAmount)
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('wallet', ['getDepositUSDCoin', 'getDepositMethods']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentSmallPopup', 'setCurrentPopupOptions']), {
    handleAmountBlur: function handleAmountBlur() {
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'fill',
        label: 'Amount'
      }));
    },
    onUpdateAmount: function onUpdateAmount(amount) {
      if (this.fields.amount === '') {
        this.fields.amount = amount;
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["F" /* isNumber */])(this.fields.amount)) {
        this.fields.amount = Number(this.fields.amount) + amount;
      }
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'click',
        label: 'Amount ' + amount + ' Button'
      }));
    },
    onSubmit: function onSubmit() {
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Deposit Confirm',
        action: 'submit',
        label: 'Confirm Deposit'
      }));
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_modals_constants__["a" /* MODALS */].COINBASE);
      this.setCurrentPopupOptions({ depositPayload: this.depositPayload });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('wallet', ['minimumDepositAmount']), {
    maximumDepositAmount: function maximumDepositAmount() {
      return 99999;
    },
    depositPayload: function depositPayload() {
      return {
        amount: this.fields.amount,
        depositPromoCode: '',
        marketingSource: '',
        marketingProgram: ''
      };
    },
    amountHasError: function amountHasError() {
      return this.$v.fields.amount.$error;
    },
    amountValidationMessage: function amountValidationMessage() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_getValidationMessage__["a" /* default */])(this.$v.fields.amount);
    },
    isConfirmDisabled: function isConfirmDisabled() {
      return this.invalidOrDisabled || !this.canDeposit;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.getDepositMethods();
    this.getDepositUSDCoin().then(function (data) {
      _this.checkDocumentUploadFlags(data);
      _this.promoCodeDetail = data.promoCodeDetail || {};
      _this.canDeposit = data.canDeposit;
      _this.errorMessage = data.errorMessage || '';
      _this.isComponentReady = true;
    }).catch(function (error) {
      _this.isComponentReady = true;
      _this.errorMessage = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', null);
      _this.checkDocumentUploadFlags(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data', {}));
    });
  }
});

/***/ }),

/***/ "/Q1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-tabs"},[(_vm.showNavigationArrows)?_c('button',{staticClass:"deposit-tabs__arrow deposit-tabs__arrow--left",attrs:{"disabled":!_vm.canScrollLeft,"aria-label":"Scroll left"},on:{"click":_vm.scrollLeft}}):_vm._e(),_vm._v(" "),_c('div',{ref:"tabsList",staticClass:"deposit-tabs__nav-container"},[_c('tabs',{attrs:{"items":_vm.items,"theme":_vm.theme,"active-tab":_vm.activeTab},on:{"tabChange":_vm.onTabChange}})],1),_vm._v(" "),(_vm.showNavigationArrows)?_c('button',{staticClass:"deposit-tabs__arrow deposit-tabs__arrow--right",attrs:{"disabled":!_vm.canScrollRight,"aria-label":"Scroll right"},on:{"click":_vm.scrollRight}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Tgi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_icons_sidebar_icon__ = __webpack_require__("rm2b");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiperSlide"],
    sidebarIcon: __WEBPACK_IMPORTED_MODULE_4__components_icons_sidebar_icon__["a" /* default */]
  },
  data: function data() {
    return {
      isCategoriesLabelVisible: false,
      swiperOption: {
        roundLengths: true, // Fixes blurry text
        slidesPerView: 8,
        breakpoints: {
          320: { // iPhone 5
            slidesPerView: 3.5
          },
          640: {
            slidesPerView: 4.5
          },
          1024: {
            slidesPerView: 6.5
          }
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('browse', ['userBrowseHeaders']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop', 'isPinboardSingleModeVisible', 'sidebarVisible']), {
    externalBrowseHeaders: function externalBrowseHeaders() {
      return this.userBrowseHeaders.filter(function (item) {
        return item.external;
      });
    },
    categoryBrowseHeaders: function categoryBrowseHeaders() {
      return this.userBrowseHeaders.filter(function (item) {
        return !item.external;
      });
    },
    categoriesIcon: function categoriesIcon() {
      // if (this.isLayoutDesktop) {
      //   return this.iconClassModifiers({ icon: 'globe' });
      // }
      return this.iconClassModifiers({ icon: 'categories' });
    },
    isAllMarketsLinkActive: function isAllMarketsLinkActive() {
      return this.$route.name === 'market-list' && !parseInt(this.$route.params.headerId, 10);
    },
    classModifiers: function classModifiers() {
      return {
        'nav-browse': true,
        'nav-browse--desktop': !this.isLayoutMobile,
        'nav-browse--mobile': this.isLayoutMobile
      };
    },
    isOnPinboardRoute: function isOnPinboardRoute() {
      return ['home', 'trends', 'market-details'].includes(this.$route.name);
    },
    showSidebarToggle: function showSidebarToggle() {
      return this.isLayoutDesktop && this.isPinboardSingleModeVisible && this.isOnPinboardRoute;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['toggleNavBrowseCategoriesOverlay']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('app', ['toggleSidebarVisible']), {
    toggleCategoriesLabel: function toggleCategoriesLabel() {
      if (this.isLayoutMobile) {
        this.toggleNavBrowseCategoriesOverlay();
      }
    },
    iconClassModifiers: function iconClassModifiers(item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'nav-browse__link-icon': true
      }, 'nav-browse__link-icon--' + item.icon, item.icon);
    },
    toggleSidebar: function toggleSidebar() {
      this.toggleSidebarVisible();
    }
  }),
  mounted: function mounted() {
    if (this.isLayoutDesktop) {
      this.isCategoriesLabelVisible = true;
    }
  }
});

/***/ }),

/***/ "/awr":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMC41IDQuNSA3LjEyNSA5bDMuMzAyIDQuNSIgc3Ryb2tlPSIjNTU1NzVBIiBzdHJva2Utd2lkdGg9IjIuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ "/b9a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_externalLinks__ = __webpack_require__("ys9T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contentLoader__ = __webpack_require__("P71F");



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_externalLinks__["a" /* default */]],
  props: {
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    availableSocials: function availableSocials() {
      var availableSocials = [];
      if (this.facebookLink) {
        availableSocials.push('Facebook');
      }
      if (this.googleLink) {
        availableSocials.push('Google');
      }
      if (this.twitterLink) {
        availableSocials.push('X');
      }

      if (availableSocials.length === 0) {
        return '';
      }

      if (availableSocials.length === 1) {
        return availableSocials[0];
      }

      if (availableSocials.length === 2) {
        return availableSocials.join(' or ');
      }

      if (availableSocials.length === 3) {
        return availableSocials[0] + ', ' + availableSocials[1] + ' or ' + availableSocials[2];
      }
    }
  },
  created: function created() {
    var _this = this;

    this.getExternalLogins({}).then(function (response) {
      _this.links = response.data;
      _this.isComponentReady = true;
    });
  }
});

/***/ }),

/***/ "/rSU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/s1U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/sWl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/u+B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contract-horizontal-sushi-orders"},[(_vm.hasOffers)?[_c('div',{staticClass:"market-contract-horizontal-sushi-orders__values"},[_c('span',{class:_vm.buyValueClass,attrs:{"data-tooltip":("Buy: " + _vm.buyQuantityFormatted)}},[_vm._v(_vm._s(_vm.buyQuantityDisplay))]),_vm._v(" "),_c('span',{staticClass:"market-contract-horizontal-sushi-orders__sep"},[_vm._v("/")]),_vm._v(" "),_c('span',{class:_vm.sellValueClass,attrs:{"data-tooltip":("Sell: " + _vm.sellQuantityFormatted)}},[_vm._v(_vm._s(_vm.sellQuantityDisplay))])])]:_c('span',{staticClass:"market-dash-symbol"},[_vm._v("-")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/v52":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_desktop_header_js__ = __webpack_require__("U91k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02d17b20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_desktop_header_vue__ = __webpack_require__("SpUV");
function injectStyle (ssrContext) {
  __webpack_require__("LGCP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_desktop_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02d17b20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_desktop_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/xcM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.currentPopupOptions.icon)?_c('div',{staticClass:"popup-generic-small__icon"},[(_vm.currentPopupOptions.icon === 'error')?_c('img',{attrs:{"src":__webpack_require__("z6fO"),"alt":""}}):_vm._e(),_vm._v(" "),(_vm.currentPopupOptions.icon === 'success')?_c('img',{attrs:{"src":__webpack_require__("ihRI"),"alt":""}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"popup-generic-small__content"},[_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/yTp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_research_widget_js__ = __webpack_require__("5RCZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1016bcda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_research_widget_vue__ = __webpack_require__("MWul");
function injectStyle (ssrContext) {
  __webpack_require__("I1/e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_research_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1016bcda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_research_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/z+u":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDYgMTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjc1IDAuODMzMjUyTDQuODMyOTcgNC44MDM2MkM0Ljg1OTUgNC44MjkzOSA0Ljg4MDU1IDQuODU5OTkgNC44OTQ5MSA0Ljg5MzY3QzQuOTA5MjcgNC45MjczNSA0LjkxNjY3IDQuOTYzNDYgNC45MTY2NyA0Ljk5OTkyQzQuOTE2NjcgNS4wMzYzOCA0LjkwOTI3IDUuMDcyNDkgNC44OTQ5MSA1LjEwNjE3QzQuODgwNTUgNS4xMzk4NSA0Ljg1OTUgNS4xNzA0NSA0LjgzMjk3IDUuMTk2MjJMMC43NSA5LjE2NjU5IiBzdHJva2U9IiMwQzBDMEMiIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "06wT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.chartData.length > 0)?_c('div',{ref:"chart",staticClass:"charts-container",style:(_vm.containerStyleModifiers)}):(_vm.chartDataLoaded)?_c('div',{staticClass:"charts-container__no-data"},[_vm._v("\n    No data to display\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "07Ut":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-funds-coinbase"},[(!_vm.isComponentReady)?_c('account-form-loader',{attrs:{"theme":"deposit"}}):(_vm.documentUploadInfoVisible)?_c('account-upload-document',{attrs:{"source":_vm.documentUploadSource,"isPending":_vm.documentUploadInfoPending,"theme":"page-padded"}}):(_vm.collectSsnInfo)?_c('account-ssn-info-upload'):[(_vm.showPromoNotification && false)?_c('fee-waived-banner',{staticClass:"add-funds-coinbase__alert-box",attrs:{"level":"success","text":_vm.promoCodeDetail.friendlyDescription}}):_vm._e(),_vm._v(" "),(_vm.showInstantCreditNotification && false)?_c('fee-waived-banner',{attrs:{"level":_vm.instantCreditBoxLevel,"text":_vm.instantCreditBoxMessage}}):_vm._e(),_vm._v(" "),(_vm.depositWarning)?_c('div',{staticClass:"predictit-embedded-alert",domProps:{"innerHTML":_vm._s(_vm.depositWarning)}}):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('alert-box',{staticClass:"add-funds-coinbase__alert-box",attrs:{"level":"warning"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})]):[_c('form',{staticClass:"add-funds-coinbase__form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('h5',{staticClass:"add-funds-coinbase__title"},[_vm._v("Deposit ($"+_vm._s(_vm.minimumDepositAmount.toFixed(2))+" Minimum)")]),_vm._v(" "),_c('deposit-amount-picker',{attrs:{"deposit-amounts":_vm.depositAmounts,"has-error":_vm.amountHasError,"error-message":_vm.amountValidationMessage},on:{"add":_vm.onUpdateAmount,"blur":_vm.handleAmountBlur,"input":_vm.$v.fields.amount.$touch},model:{value:(_vm.fields.amount),callback:function ($$v) {_vm.$set(_vm.fields, "amount", $$v)},expression:"fields.amount"}}),_vm._v(" "),_c('p',{staticClass:"add-funds-coinbase__note"},[_vm._v("\n          You can deposit funds into your PredictIt account using a "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":"https://www.coinbase.com/usdc"}},[_vm._v("USD Coin")]),_vm._v(" wallet. After clicking on the Confirm button below, you will be taken to Coinbase to complete your transaction.\n        ")]),_vm._v(" "),_c('p',{staticClass:"add-funds-coinbase__note"},[_vm._v("\n          Please note that "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":"https://www.coinbase.com"}},[_vm._v("Coinbase")]),_vm._v(" charges a network fee to transfer funds. You should expect a delay between the time you transfer funds from your wallet and the time you receive a credit in your PredictIt account.\n        ")]),_vm._v(" "),_c('div',{staticClass:"add-funds-coinbase__submit"},[_c('form-submit',{attrs:{"label":"Confirm","disabled":_vm.isConfirmDisabled}})],1)],1),_vm._v(" "),(_vm.disclaimer)?[_c('br'),_vm._v(" "),_c('deposit-disclaimer',{attrs:{"disclaimer":_vm.disclaimer}})]:_vm._e()]]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "08z+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_DESCRIPTION */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_brand_name_brand_name__ = __webpack_require__("9IfM");


var DEFAULT_DESCRIPTION = 'PredictIt is a real-money political prediction market, where you can buy and sell shares in the outcome of elections and other political events.';
var TWITTER_SITE =  true ? '@' + "PredictIt" : '';

var seoMetaMixin = {
  methods: {
    buildSeoMeta: function buildSeoMeta() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var title = options.title || __WEBPACK_IMPORTED_MODULE_0__components_brand_name_brand_name__["a" /* BRAND */];
      var description = options.description || DEFAULT_DESCRIPTION;
      var image = options.image || '';
      var type = options.type || 'website';
      var url = options.url || (typeof window !== 'undefined' ? '' + window.location.origin + window.location.pathname : '');
      var siteName = options.siteName || __WEBPACK_IMPORTED_MODULE_0__components_brand_name_brand_name__["a" /* BRAND */];
      var article = options.article || null;
      var extraMeta = options.extraMeta || [];

      var meta = [{ name: 'description', content: description }, { itemprop: 'name', content: title }, { itemprop: 'description', content: description }, image && { itemprop: 'image', content: image }, { property: 'og:title', content: title }, { property: 'og:type', content: type }, { property: 'og:description', content: description }, { property: 'og:site_name', content: siteName }, { property: 'og:url', content: url }, image && { property: 'og:image', content: image }, { name: 'twitter:card', content: image ? 'summary_large_image' : 'summary' }, TWITTER_SITE && { name: 'twitter:site', content: TWITTER_SITE }, TWITTER_SITE && { name: 'twitter:creator', content: TWITTER_SITE }, { name: 'twitter:title', content: title }, { name: 'twitter:description', content: description }, image && { name: 'twitter:image', content: image }];

      if (type === 'article' && article) {
        if (article.publishedTime) {
          meta.push({ property: 'article:published_time', content: article.publishedTime });
        }
        if (article.modifiedTime) {
          meta.push({ property: 'article:modified_time', content: article.modifiedTime });
        }
      }

      return {
        title: title,
        link: [{ rel: 'canonical', href: url }],
        meta: meta.concat(extraMeta).filter(Boolean)
      };
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (seoMetaMixin);

/***/ }),

/***/ "09V6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    disabled: Boolean,
    name: {
      type: String,
      required: true
    },
    required: Boolean,
    placeholder: String,
    maxLength: Number,
    value: String,
    validator: String
  },
  data: function data() {
    return {
      focus: false
    };
  },

  computed: {
    textAreaModifiers: function textAreaModifiers() {
      return {
        'textarea--has-value': this.value,
        'textarea--is-focused': this.focus
      };
    }
  },
  methods: {
    handleBlur: function handleBlur(e) {
      this.focus = false;
      this.$emit('blur', e.target.name);
    },
    handleFocus: function handleFocus(e) {
      this.focus = true;
      this.$emit('focus', e.target.name);
    },
    updateValue: function updateValue(e) {
      this.$emit('input', e.target.value);
    }
  }
});

/***/ }),

/***/ "09fK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_special_js__ = __webpack_require__("OprK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0db37b2d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_special_vue__ = __webpack_require__("hmLK");
function injectStyle (ssrContext) {
  __webpack_require__("e69X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_special_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0db37b2d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_special_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0Dp4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0IxP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len */
var pageDashboardSushi = function pageDashboardSushi() {
  return Promise.all/* import() */([__webpack_require__.e(3), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "9/FY"));
};
var pageSushiInviteFriends = function pageSushiInviteFriends() {
  return Promise.all/* import() */([__webpack_require__.e(3), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "IlLP"));
};
var pageSushiLeaderboardInfo = function pageSushiLeaderboardInfo() {
  return Promise.all/* import() */([__webpack_require__.e(3), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "l+Fm"));
};
var pageSushiMyMarkets = function pageSushiMyMarkets() {
  return Promise.all/* import() */([__webpack_require__.e(3), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "Nd9h"));
};
var pageSushiNotifications = function pageSushiNotifications() {
  return Promise.all/* import() */([__webpack_require__.e(3), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "Z+nZ"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/dashboard',
  component: pageDashboardSushi,
  props: true,
  meta: {
    requiresAuth: true,
    appContentFullWidth: true
  },
  children: [{
    path: '',
    name: 'portfolio',
    component: pageSushiMyMarkets,
    meta: {
      appContentFullWidth: true
    }
  }, {
    path: 'leaderboard-info',
    name: 'dashboard-leaderboard-info',
    component: pageSushiLeaderboardInfo,
    meta: {
      appContentFullWidth: true
    }
  }, {
    path: 'invite-friends',
    name: 'dashboard-invite-friends',
    component: pageSushiInviteFriends,
    meta: {
      appContentFullWidth: true
    }
  }, {
    path: 'notifications',
    name: 'dashboard-notifications',
    component: pageSushiNotifications,
    meta: {
      appContentFullWidth: true
    }
  }]
}]);

/***/ }),

/***/ "0Jvk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contract-image",style:(_vm.imageStyleModifiers)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0KBQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_throttle__ = __webpack_require__("+X65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_sortBy__ = __webpack_require__("KBYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_without__ = __webpack_require__("yI9a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isString__ = __webpack_require__("JDN0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_intersection__ = __webpack_require__("Aemx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_intersection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_intersection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_notifications__ = __webpack_require__("tjp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__filters_consts__ = __webpack_require__("OJH0");












 /* eslint-disable */








var DEFAULT_FILTERED_MARKETS = {
  data: [],
  page: 0,
  firstPage: 0,
  totalCount: 0,
  totalPages: 0,
  canLoadMore: true,
  canLoadPrevious: false
};

var TWENTY_FOUR_GAINS = 'Biggest 24 hour Gains';
var TWENTY_FOUR_LOSS = 'Biggest 24 hour Losses';
var WEEK_GAINS = 'Biggest 7 day Gains';
var WEEK_LOSS = 'Biggest 7 day Losses';

var prepareBiggestGains = function prepareBiggestGains(items, sectionTitle) {
  var isGain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  items.forEach(function (el) {
    el.sectionTitle = sectionTitle;
    el.isGain = isGain;
  });
  return items;
};

var TITLE_PREDICTED = 'Most Predicted';
var TITLE_TRENDING = 'Top Trending';
var TITLE_MOVERS = 'Biggest Movers';
var TITLE_NEW_ARRIVALS = 'New Arrivals';

var prepareMostPredicted = function prepareMostPredicted(markets, sectionTitle) {
  markets.forEach(function (el) {
    el.sectionTitle = sectionTitle;
  });
  return markets;
};

var THROTTLE_TIME = 1750;

var getCachedStoriesByIndexes = function getCachedStoriesByIndexes(storyMap, indexes) {
  return indexes.map(function (index) {
    return storyMap[index];
  }).filter(function (story) {
    return typeof story !== 'undefined';
  });
};

var getMissingStoryIndexes = function getMissingStoryIndexes(storyMap, indexes) {
  return indexes.filter(function (index) {
    return typeof storyMap[index] === 'undefined';
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    headers: [],
    headersReady: false,
    filters: null,
    orders: __WEBPACK_IMPORTED_MODULE_17__filters_consts__["a" /* ORDERS */],
    timespans: __WEBPACK_IMPORTED_MODULE_17__filters_consts__["b" /* TIMESPANS */],
    filteredMarkets: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_FILTERED_MARKETS),
    selectedFilters: [],
    selectedOrder: __WEBPACK_IMPORTED_MODULE_17__filters_consts__["a" /* ORDERS */][0],
    selectedTimespan: __WEBPACK_IMPORTED_MODULE_17__filters_consts__["c" /* AVAILABLE_TIMESPANS */].TODAY,
    shouldShowTimespanFilter: true,
    twentyFourGains: [],
    twentyFourLoss: [],
    weekGains: [],
    weekLoss: [],
    newArrivalMarkets: [],
    mostPredictedMarkets: [],
    trendingMarkets: [],
    biggestMoverMarkets: [],
    widgets: {},
    latestHeaderId: null,
    storiesNav: [],
    currentStory: null,
    currentStoryIndex: null,
    currentStoryDetail: null,
    storyDetailMap: {},
    storyMap: {},
    storiesList: [],
    storiesUseLegacyPreload: false,
    showNavBrowseOverlay: false,
    marketsPageInitialLoadDone: false,
    marketListCachedHeaderId: null
  },
  getters: {
    areUserBrowseHeadersEmpty: function areUserBrowseHeadersEmpty(state, getters) {
      return state.headersReady && getters.userBrowseHeaders.length === 0;
    },
    userBrowseHeaders: function userBrowseHeaders(state, getters, rootState, rootGetters) {
      var baseHeaders = [];

      if (false) {
        baseHeaders.push({
          headerId: -2,
          external: true,
          href: process.env.TOURNAMENT_LINK,
          title: 'Tournament',
          icon: 'star'
        });
      }

      if (rootGetters['user/isLoggedIn']) {
        baseHeaders.push({
          headerId: -1,
          external: true,
          name: 'market-watchlist',
          title: 'Watchlist',
          icon: 'watch'
        });
      }

      return [].concat(baseHeaders, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(state.headers));
    }
  },
  mutations: {
    clearCurrentStoryDetail: function clearCurrentStoryDetail(state) {
      state.currentStoryDetail = null;
    },
    setCurrentStoryDetail: function setCurrentStoryDetail(state, data) {
      state.currentStoryDetail = data;
    },
    clearCurrentStory: function clearCurrentStory(state) {
      state.currentStory = null;
    },
    setCurrentStory: function setCurrentStory(state, data) {
      state.currentStory = data;
    },
    setCurrentStoryIndex: function setCurrentStoryIndex(state, data) {
      state.currentStoryIndex = data;
    },
    setStoriesNav: function setStoriesNav(state, data) {
      state.storiesNav = data;
    },
    updateStoryDetailMap: function updateStoryDetailMap(state, data) {
      var index = data.index,
          obj = data.obj;

      state.storyDetailMap = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.storyDetailMap, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, index, obj));
    },
    updateStoryMap: function updateStoryMap(state, data) {
      var index = data.index,
          obj = data.obj;

      state.storyMap = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.storyMap, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, index, obj));
    },
    updateStoriesList: function updateStoriesList(state, data) {
      state.storiesList = data;
    },
    setLatestHeaderId: function setLatestHeaderId(state, data) {
      state.latestHeaderId = data;
    },
    setMarketsPageInitialLoadDone: function setMarketsPageInitialLoadDone(state, data) {
      state.marketsPageInitialLoadDone = data;
    },
    setMarketListCachedHeaderId: function setMarketListCachedHeaderId(state, id) {
      state.marketListCachedHeaderId = id;
    },
    setHeaders: function setHeaders(state, payload) {
      state.headers = payload;
      state.headersReady = true;
    },
    setFilters: function setFilters(state, payload) {
      state.filters = payload;
      if (payload) {
        // check if we have selected filters available
        var filterIds = payload.reduce(function (c, filters) {
          return c.concat(filters.filters.map(function (f) {
            return f.filterId;
          }));
        }, []);
        var selectedFilters = __WEBPACK_IMPORTED_MODULE_12_lodash_intersection___default()(state.selectedFilters, filterIds);
        if (state.selectedFilters.length !== selectedFilters.length) {
          state.selectedFilters = [];
        }
      } else {
        state.selectedFilters = [];
      }
    },
    updateFilteredMarkets: function updateFilteredMarkets(state, payload) {
      var markets = payload.markets || [];
      var excludedStatuses = [__WEBPACK_IMPORTED_MODULE_16__constants__["a" /* default */].MARKET_SETTLED, __WEBPACK_IMPORTED_MODULE_16__constants__["a" /* default */].MARKET_EXPIRED, __WEBPACK_IMPORTED_MODULE_16__constants__["a" /* default */].MARKET_SUSPENDED];
      var firstVisibleMarket = markets.find(function (m) {
        return !excludedStatuses.includes(m.status);
      });
      if (firstVisibleMarket) {
        firstVisibleMarket.pageBoundary = payload.page;
      }
      var data = payload.replace ? markets : payload.prepend ? markets.concat(state.filteredMarkets.data) : state.filteredMarkets.data.concat(markets);
      var page = payload.page;
      var totalCount = payload.totalMarkets;
      var totalPages = payload.totalPages;
      // Based on page/totalPages, not totalCount > data.length: a jump/replace
      // load's `data` only holds the single fetched page, so a count-based
      // comparison never reflects true completion once you've jumped past page 1.
      var canLoadMore = payload.prepend ? state.filteredMarkets.canLoadMore : totalPages ? page < totalPages : totalCount > data.length;
      // `page` tracks the highest page loaded (used by loadMore); `firstPage` tracks
      // the lowest page loaded (used by loadPrevious) - a prepend only moves firstPage.
      var lastPage = payload.prepend ? state.filteredMarkets.page : page;
      var firstPage = payload.prepend || !payload.replace ? Math.min(page, state.filteredMarkets.firstPage || page) : page;
      var canLoadPrevious = firstPage > 1;

      state.filteredMarkets = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.filteredMarkets, {
        data: data,
        page: lastPage,
        firstPage: firstPage,
        totalCount: totalCount,
        totalPages: totalPages,
        canLoadMore: canLoadMore,
        canLoadPrevious: canLoadPrevious
      });
    },
    resetFilteredMarkets: function resetFilteredMarkets(state) {
      state.filteredMarkets = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_FILTERED_MARKETS);
    },
    updateGainsLossMarketFromNotification: function updateGainsLossMarketFromNotification(state, data) {
      if (state.twentyFourGains.length > 0) {
        var markets = state.twentyFourGains.slice();
        state.twentyFourGains = markets.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
      if (state.twentyFourLoss.length > 0) {
        var _markets = state.twentyFourLoss.slice();
        state.twentyFourLoss = _markets.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
      if (state.weekGains.length > 0) {
        var _markets2 = state.weekGains.slice();
        state.weekGains = _markets2.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
      if (state.weekLoss.length > 0) {
        var _markets3 = state.weekLoss.slice();
        state.weekLoss = _markets3.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
    },
    updateGainsLossContractFromNotification: function updateGainsLossContractFromNotification(state, data) {
      if (state.twentyFourGains.length > 0) {
        var markets = state.twentyFourGains.slice();
        state.twentyFourGains = markets.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }
      if (state.twentyFourLoss.length > 0) {
        var _markets4 = state.twentyFourLoss.slice();
        state.twentyFourLoss = _markets4.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }
      if (state.weekGains.length > 0) {
        var _markets5 = state.weekGains.slice();
        state.weekGains = _markets5.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }
      if (state.weekLoss.length > 0) {
        var _markets6 = state.weekLoss.slice();
        state.weekLoss = _markets6.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }
    },
    updatePredictedTrendingMarketFromNotification: function updatePredictedTrendingMarketFromNotification(state, data) {
      if (state.mostPredictedMarkets.length > 0) {
        var markets = state.mostPredictedMarkets.slice();
        state.mostPredictedMarkets = markets.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
      if (state.trendingMarkets.length > 0) {
        var _markets7 = state.trendingMarkets.slice();
        state.trendingMarkets = _markets7.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
      if (state.biggestMoverMarkets.length > 0) {
        var _markets8 = state.biggestMoverMarkets.slice();
        state.biggestMoverMarkets = _markets8.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
      if (state.newArrivalMarkets.length > 0) {
        var _markets9 = state.newArrivalMarkets.slice();
        state.newArrivalMarkets = _markets9.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
    },
    updatePredictedTrendingContractsFromNotification: function updatePredictedTrendingContractsFromNotification(state, data) {
      if (state.mostPredictedMarkets.length > 0) {
        var markets = state.mostPredictedMarkets.slice();
        state.mostPredictedMarkets = markets.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(market, data);
        });
      }
      if (state.trendingMarkets.length > 0) {
        var _markets10 = state.trendingMarkets.slice();
        state.trendingMarkets = _markets10.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(market, data);
        });
      }
      if (state.biggestMoverMarkets.length > 0) {
        var _markets11 = state.biggestMoverMarkets.slice();
        state.biggestMoverMarkets = _markets11.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(market, data);
        });
      }
      if (state.newArrivalMarkets.length > 0) {
        var _markets12 = state.newArrivalMarkets.slice();
        state.newArrivalMarkets = _markets12.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(market, data);
        });
      }
    },
    updateMarketWidgetsContractsFromNotification: function updateMarketWidgetsContractsFromNotification(state, data) {
      if (state.widgets.most) {
        state.widgets = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.widgets, {
          most: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["d" /* updateContract */])(state.widgets.most, data)
        });
      }

      if (state.widgets.smart) {
        state.widgets = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.widgets, {
          smart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["d" /* updateContract */])(state.widgets.smart, data)
        });
      }
    },
    updateMarketFromNotification: function updateMarketFromNotification(state, data) {
      if (state.filteredMarkets.data) {
        state.filteredMarkets = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.filteredMarkets, {
          data: state.filteredMarkets.data.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
          })
        });
      }
    },
    updateContractFromNotification: function updateContractFromNotification(state, data) {
      if (state.filteredMarkets.data) {
        state.filteredMarkets = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.filteredMarkets, {
          data: state.filteredMarkets.data.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(market, data);
          })
        });
      }
    },
    updateStoryMapFromMarketNotification: function updateStoryMapFromMarketNotification(state, data) {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.storyMap).forEach(function (key) {
        var story = state.storyMap[key];
        var desktopContent = story.desktopContent;
        var mobileContent = story.mobileContent;

        if (desktopContent && desktopContent.cmsContent) {
          if (desktopContent.cmsContent.marketTileMarkets) {
            desktopContent.cmsContent.marketTileMarkets = desktopContent.cmsContent.marketTileMarkets.map(function (market) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
            });
          }
          if (desktopContent.cmsContent.contractListMarkets) {
            desktopContent.cmsContent.contractListMarkets = desktopContent.cmsContent.contractListMarkets.map(function (market) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
            });
          }
        }

        if (mobileContent && mobileContent.cmsContent) {
          if (mobileContent.cmsContent.marketTileMarkets) {
            mobileContent.cmsContent.marketTileMarkets = mobileContent.cmsContent.marketTileMarkets.map(function (market) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
            });
          }
          if (mobileContent.cmsContent.contractListMarkets) {
            mobileContent.cmsContent.contractListMarkets = mobileContent.cmsContent.contractListMarkets.map(function (market) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(market, data);
            });
          }
        }
      });

      if (state.currentStoryDetail && state.currentStoryDetail.cmsContentObject) {
        var cms = state.currentStoryDetail.cmsContentObject;
        if (cms.marketTileMarkets) {
          cms.marketTileMarkets = cms.marketTileMarkets.map(function (m) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(m, data);
          });
        }
        if (cms.contractListMarkets) {
          cms.contractListMarkets = cms.contractListMarkets.map(function (m) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["a" /* updateMarket */])(m, data);
          });
        }
      }
    },
    updateStoryMapFromContractNotification: function updateStoryMapFromContractNotification(state, data) {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.storyMap).forEach(function (key) {
        var story = state.storyMap[key];
        var desktopContent = story.desktopContent;
        var mobileContent = story.mobileContent;

        if (desktopContent && desktopContent.cmsContent) {
          if (desktopContent.cmsContent.marketTileMarkets) {
            desktopContent.cmsContent.marketTileMarkets = desktopContent.cmsContent.marketTileMarkets.map(function (market) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(market, data);
            });
          }
          if (desktopContent.cmsContent.contractListMarkets) {
            desktopContent.cmsContent.contractListMarkets = desktopContent.cmsContent.contractListMarkets.map(function (market) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(market, data);
            });
          }
        }

        if (mobileContent && mobileContent.cmsContent) {
          if (mobileContent.cmsContent.marketTileMarkets) {
            mobileContent.cmsContent.marketTileMarkets = mobileContent.cmsContent.marketTileMarkets.map(function (market) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(market, data);
            });
          }
          if (mobileContent.cmsContent.contractListMarkets) {
            mobileContent.cmsContent.contractListMarkets = mobileContent.cmsContent.contractListMarkets.map(function (market) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(market, data);
            });
          }
        }
      });

      if (state.currentStoryDetail && state.currentStoryDetail.cmsContentObject) {
        var cms = state.currentStoryDetail.cmsContentObject;
        if (cms.marketTileMarkets) {
          cms.marketTileMarkets = cms.marketTileMarkets.map(function (m) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(m, data);
          });
        }
        if (cms.contractListMarkets) {
          cms.contractListMarkets = cms.contractListMarkets.map(function (m) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_notifications__["b" /* updateMarketContracts */])(m, data);
          });
        }
      }
    },
    addFilter: function addFilter(state, filterId) {
      if (!state.selectedFilters.includes(filterId)) {
        state.selectedFilters.push(filterId);
      }
    },
    clearFilters: function clearFilters(state) {
      state.selectedFilters = [];
    },
    clearOrder: function clearOrder(state) {
      state.selectedOrder = __WEBPACK_IMPORTED_MODULE_17__filters_consts__["a" /* ORDERS */][0];
    },
    setOrderFromQuery: function setOrderFromQuery(state, order) {
      var found = __WEBPACK_IMPORTED_MODULE_17__filters_consts__["a" /* ORDERS */].find(function (i) {
        return i.sort === order;
      });
      if (found) {
        state.selectedOrder = __WEBPACK_IMPORTED_MODULE_17__filters_consts__["a" /* ORDERS */].find(function (i) {
          return i.sort === order;
        });
        state.shouldShowTimespanFilter = __WEBPACK_IMPORTED_MODULE_17__filters_consts__["e" /* ORDERS_WITH_TIMESPAN_FILTER */].indexOf(order) !== -1;
      }
    },
    clearTimespan: function clearTimespan(state) {
      state.selectedTimespan = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__filters_consts__["f" /* withDateRange */])(__WEBPACK_IMPORTED_MODULE_17__filters_consts__["c" /* AVAILABLE_TIMESPANS */].TODAY, new Date());
      state.shouldShowTimespanFilter = true;
    },
    setTimespanFromQuery: function setTimespanFromQuery(state) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          parameter = _ref.parameter,
          dateFrom = _ref.dateFrom,
          dateTo = _ref.dateTo;

      var found = __WEBPACK_IMPORTED_MODULE_17__filters_consts__["c" /* AVAILABLE_TIMESPANS */][parameter];
      if (found) {
        state.selectedTimespan = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__filters_consts__["f" /* withDateRange */])(found, new Date(), { dateFrom: dateFrom, dateTo: dateTo });
      }
    },
    removeFilter: function removeFilter(state, filterId) {
      state.selectedFilters = __WEBPACK_IMPORTED_MODULE_10_lodash_without___default()(state.selectedFilters, filterId);
    },

    selectOrder: __WEBPACK_IMPORTED_MODULE_17__filters_consts__["g" /* selectOrder */],
    selectTimespan: __WEBPACK_IMPORTED_MODULE_17__filters_consts__["h" /* selectTimespan */],
    setWidgets: function setWidgets(state, payload) {
      var mapping = {
        currentlyPredictingWidget: 'currently',
        smartMoneyWidget: 'smart',
        todaysMostPredictedWidget: 'most',
        keyStatsWidget: 'key',
        topCommentsWidget: 'comments'
      };
      var widgets = {};
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
        var value = payload[key];
        var name = mapping[key];
        if (name) {
          widgets[name] = value;
        }
      });
      state.widgets = widgets;
    },
    setTwentyFourGains: function setTwentyFourGains(state, data) {
      state.twentyFourGains = prepareBiggestGains(data, TWENTY_FOUR_GAINS, true);
    },
    setTwentyFourLoss: function setTwentyFourLoss(state, data) {
      state.twentyFourLoss = prepareBiggestGains(data, TWENTY_FOUR_LOSS, false);
    },
    setWeekGains: function setWeekGains(state, data) {
      state.weekGains = prepareBiggestGains(data, WEEK_GAINS, true);
    },
    setWeekLoss: function setWeekLoss(state, data) {
      state.weekLoss = prepareBiggestGains(data, WEEK_LOSS, false);
    },
    setNewArrivalMarkets: function setNewArrivalMarkets(state, data) {
      state.newArrivalMarkets = prepareMostPredicted(data.markets, TITLE_NEW_ARRIVALS);
    },
    setMostPredictedMarkets: function setMostPredictedMarkets(state, data) {
      state.mostPredictedMarkets = prepareMostPredicted(data.markets, TITLE_PREDICTED);
    },
    setTrendingMarkets: function setTrendingMarkets(state, data) {
      state.trendingMarkets = prepareMostPredicted(data.markets, TITLE_TRENDING);
    },
    setBiggestMoverMarkets: function setBiggestMoverMarkets(state, data) {
      state.biggestMoverMarkets = prepareMostPredicted(data.markets, TITLE_MOVERS);
    },
    toggleNavBrowseCategoriesOverlay: function toggleNavBrowseCategoriesOverlay(state) {
      state.showNavBrowseOverlay = !state.showNavBrowseOverlay;
    },
    updateMarketNotWatched: function updateMarketNotWatched(state, marketId) {
      state.filteredMarkets = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.filteredMarkets, {
        data: [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(state.filteredMarkets.data)).map(function (i) {
          if (i.marketId === marketId) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, i, {
              isMarketWatched: false
            });
          }
          return i;
        })
      });
    },
    updateMarketWatched: function updateMarketWatched(state, marketId) {
      state.filteredMarkets = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.filteredMarkets, {
        data: [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(state.filteredMarkets.data)).map(function (i) {
          if (i.marketId === marketId) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, i, {
              isMarketWatched: true
            });
          }
          return i;
        })
      });
    }
  },
  actions: {
    getHeaders: function getHeaders(_ref2) {
      var commit = _ref2.commit;

      var cached = __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].get('browseHeaders');
      var prom = cached ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({ data: cached }) : __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getHeaders();
      return prom.then(function (response) {
        if (!__WEBPACK_IMPORTED_MODULE_11_lodash_isString___default()(response.data)) {
          var sorted = __WEBPACK_IMPORTED_MODULE_9_lodash_sortBy___default()(response.data, ['sortOrder']);
          __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].set('browseHeaders', response.data, "3600");
          commit('setHeaders', sorted);
        }
        return response;
      });
    },
    getFilters: function getFilters(_ref3, headerId) {
      var commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getFilters(headerId).then(function (response) {
        var sorted = __WEBPACK_IMPORTED_MODULE_9_lodash_sortBy___default()(response.data, ['sortOrder']);
        sorted.map(function (item) {
          item.filters = __WEBPACK_IMPORTED_MODULE_9_lodash_sortBy___default()(item.filters, ['sortOrder']);
          return item;
        });
        commit('setFilters', sorted);
        return response;
      });
    },

    getFilteredMarkets: __WEBPACK_IMPORTED_MODULE_8_lodash_throttle___default()(function (_ref4, _ref5) {
      var state = _ref4.state,
          commit = _ref4.commit;
      var headerId = _ref5.headerId,
          _ref5$reset = _ref5.reset,
          reset = _ref5$reset === undefined ? false : _ref5$reset,
          _ref5$page = _ref5.page,
          explicitPage = _ref5$page === undefined ? null : _ref5$page,
          _ref5$prepend = _ref5.prepend,
          prepend = _ref5$prepend === undefined ? false : _ref5$prepend;

      var filterIds = state.selectedFilters.join(',');
      var sort = state.selectedOrder.sort;
      var sortParameter = state.selectedTimespan.parameter;
      var dateFrom = state.selectedTimespan.dateFrom;
      var dateTo = state.selectedTimespan.dateTo;
      var page = prepend ? state.filteredMarkets.firstPage - 1 : explicitPage || (reset ? 1 : state.filteredMarkets.page + 1);
      var isJump = !!explicitPage && reset;
      var canLoadMore = reset ? true : prepend ? state.filteredMarkets.canLoadPrevious : state.filteredMarkets.canLoadMore;
      if (canLoadMore) {
        return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getFilteredMarkets(headerId, 20, page, filterIds, sort, sortParameter, dateFrom, dateTo).then(function (response) {
          // resetting takes place here so markets are 'swapped'
          if (reset) commit('resetFilteredMarkets');
          commit('updateFilteredMarkets', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(response.data, { page: page, replace: isJump, prepend: prepend }));
          return response;
        });
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(1);
    }, THROTTLE_TIME),
    resetFilteredMarkets: function resetFilteredMarkets(_ref6) {
      var commit = _ref6.commit;

      commit('resetFilteredMarkets');
    },
    getNewArrivalMarkets: function getNewArrivalMarkets(_ref7, _ref8) {
      var commit = _ref7.commit;
      var limit = _ref8.limit;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getNewArrivalMarkets(limit).then(function (response) {
        commit('setNewArrivalMarkets', response.data);
        return response.data;
      });
    },
    getMostPredictedMarkets: function getMostPredictedMarkets(_ref9, _ref10) {
      var commit = _ref9.commit;
      var limit = _ref10.limit;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getMostPredictedMarkets(limit).then(function (response) {
        commit('setMostPredictedMarkets', response.data);
        return response.data;
      });
    },
    getTrendingMarkets: function getTrendingMarkets(_ref11, _ref12) {
      var commit = _ref11.commit;
      var limit = _ref12.limit;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getTrendingMarkets(limit).then(function (response) {
        commit('setTrendingMarkets', response.data);
        return response.data;
      });
    },
    getBiggestMoverMarkets: function getBiggestMoverMarkets(_ref13, _ref14) {
      var commit = _ref13.commit;
      var limit = _ref14.limit;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getBiggestMoverMarkets(limit).then(function (response) {
        commit('setBiggestMoverMarkets', response.data);
        return response.data;
      });
    },
    addFilter: function addFilter(_ref15, filterId) {
      var commit = _ref15.commit;

      commit('addFilter', filterId);
    },
    removeFilter: function removeFilter(_ref16, filterId) {
      var commit = _ref16.commit;

      commit('removeFilter', filterId);
    },
    selectOrder: function selectOrder(_ref17, sort) {
      var commit = _ref17.commit;

      commit('selectOrder', sort);
    },
    selectTimespan: function selectTimespan(_ref18, parameter) {
      var commit = _ref18.commit;

      commit('selectTimespan', parameter);
    },
    getCarousel: function getCarousel() {
      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getCarousel().then(function (response) {
        return response.data;
      });
    },
    getTwentyFourGains: function getTwentyFourGains(_ref19, _ref20) {
      var commit = _ref19.commit;
      var _ref20$isLoss = _ref20.isLoss,
          isLoss = _ref20$isLoss === undefined ? false : _ref20$isLoss,
          _ref20$days = _ref20.days,
          days = _ref20$days === undefined ? 1 : _ref20$days,
          _ref20$contracts = _ref20.contracts,
          contracts = _ref20$contracts === undefined ? 2 : _ref20$contracts;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getHomePageGainModule(isLoss, days, contracts).then(function (response) {
        commit('setTwentyFourGains', response.data);
        return response.data;
      });
    },
    getTwentyFourLoss: function getTwentyFourLoss(_ref21, _ref22) {
      var commit = _ref21.commit;
      var _ref22$isLoss = _ref22.isLoss,
          isLoss = _ref22$isLoss === undefined ? true : _ref22$isLoss,
          _ref22$days = _ref22.days,
          days = _ref22$days === undefined ? 1 : _ref22$days,
          _ref22$contracts = _ref22.contracts,
          contracts = _ref22$contracts === undefined ? 2 : _ref22$contracts;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getHomePageGainModule(isLoss, days, contracts).then(function (response) {
        commit('setTwentyFourLoss', response.data);
        return response.data;
      });
    },
    getWeekGains: function getWeekGains(_ref23, _ref24) {
      var commit = _ref23.commit;
      var _ref24$isLoss = _ref24.isLoss,
          isLoss = _ref24$isLoss === undefined ? false : _ref24$isLoss,
          _ref24$days = _ref24.days,
          days = _ref24$days === undefined ? 7 : _ref24$days,
          _ref24$contracts = _ref24.contracts,
          contracts = _ref24$contracts === undefined ? 2 : _ref24$contracts;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getHomePageGainModule(isLoss, days, contracts).then(function (response) {
        commit('setWeekGains', response.data);
        return response.data;
      });
    },
    getWeekLoss: function getWeekLoss(_ref25, _ref26) {
      var commit = _ref25.commit;
      var _ref26$isLoss = _ref26.isLoss,
          isLoss = _ref26$isLoss === undefined ? true : _ref26$isLoss,
          _ref26$days = _ref26.days,
          days = _ref26$days === undefined ? 7 : _ref26$days,
          _ref26$contracts = _ref26.contracts,
          contracts = _ref26$contracts === undefined ? 2 : _ref26$contracts;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getHomePageGainModule(isLoss, days, contracts).then(function (response) {
        commit('setWeekLoss', response.data);
        return response.data;
      });
    },
    clearFilters: function clearFilters(_ref27) {
      var commit = _ref27.commit;

      commit('clearFilters');
    },
    clearTimespan: function clearTimespan(_ref28) {
      var commit = _ref28.commit;

      commit('clearTimespan');
    },
    setTimespanFromQuery: function setTimespanFromQuery(_ref29, payload) {
      var commit = _ref29.commit;

      commit('setTimespanFromQuery', payload);
    },
    clearOrder: function clearOrder(_ref30) {
      var commit = _ref30.commit;

      commit('clearOrder');
    },
    setOrderFromQuery: function setOrderFromQuery(_ref31, payload) {
      var commit = _ref31.commit;

      commit('setOrderFromQuery', payload);
    },
    updateMarketFromNotification: function updateMarketFromNotification(_ref32, payload) {
      var commit = _ref32.commit;

      commit('updateMarketFromNotification', payload);
    },
    updateContractFromNotification: function updateContractFromNotification(_ref33, payload) {
      var commit = _ref33.commit;

      commit('updateContractFromNotification', payload);
    },
    updateGainsLossMarketFromNotification: function updateGainsLossMarketFromNotification(_ref34, payload) {
      var commit = _ref34.commit;

      commit('updateGainsLossMarketFromNotification', payload);
    },
    updateGainsLossContractFromNotification: function updateGainsLossContractFromNotification(_ref35, payload) {
      var commit = _ref35.commit;

      commit('updateGainsLossContractFromNotification', payload);
    },
    updatePredictedTrendingMarketFromNotification: function updatePredictedTrendingMarketFromNotification(_ref36, payload) {
      var commit = _ref36.commit;

      commit('updatePredictedTrendingMarketFromNotification', payload);
    },
    updatePredictedTrendingContractsFromNotification: function updatePredictedTrendingContractsFromNotification(_ref37, payload) {
      var commit = _ref37.commit;

      commit('updatePredictedTrendingContractsFromNotification', payload);
    },
    updateMarketWidgetsContractsFromNotification: function updateMarketWidgetsContractsFromNotification(_ref38, payload) {
      var commit = _ref38.commit;

      commit('updateMarketWidgetsContractsFromNotification', payload);
    },
    updateStoryMapFromMarketNotification: function updateStoryMapFromMarketNotification(_ref39, payload) {
      var commit = _ref39.commit;

      commit('updateStoryMapFromMarketNotification', payload);
    },
    updateStoryMapFromContractNotification: function updateStoryMapFromContractNotification(_ref40, payload) {
      var commit = _ref40.commit;

      commit('updateStoryMapFromContractNotification', payload);
    },
    getWidgets: function getWidgets(_ref41) {
      var commit = _ref41.commit;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getWidgets().then(function (response) {
        commit('setWidgets', response.data);
        return response;
      });
    },
    setLatestHeaderId: function setLatestHeaderId(_ref42, data) {
      var commit = _ref42.commit;

      commit('setLatestHeaderId', data);
    },
    setMarketsPageInitialLoadDone: function setMarketsPageInitialLoadDone(_ref43, data) {
      var commit = _ref43.commit;

      commit('setMarketsPageInitialLoadDone', data);
    },
    setMarketListCachedHeaderId: function setMarketListCachedHeaderId(_ref44, id) {
      var commit = _ref44.commit;

      commit('setMarketListCachedHeaderId', id);
    },
    getStoriesList: function getStoriesList(_ref45, _ref46) {
      var commit = _ref45.commit,
          state = _ref45.state;
      var indexes = _ref46.indexes,
          _ref46$cache = _ref46.cache,
          cache = _ref46$cache === undefined ? false : _ref46$cache;

      if (!Array.isArray(indexes) || indexes.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve([]);
      }

      var missingIndexes = cache ? getMissingStoryIndexes(state.storyMap, indexes) : indexes;

      if (cache && missingIndexes.length === 0) {
        var cachedStories = getCachedStoriesByIndexes(state.storyMap, indexes);
        commit('updateStoriesList', cachedStories);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(cachedStories);
      }

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getStoriesList(missingIndexes).then(function (response) {
        var stories = [];
        if (Array.isArray(response.data)) {
          stories = response.data;
        } else {
          stories = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(response, 'data.stories', []);
        }

        stories.forEach(function (obj, position) {
          commit('updateStoryMap', {
            index: missingIndexes[position],
            obj: obj
          });
        });

        var orderedStories = getCachedStoriesByIndexes(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.storyMap, missingIndexes.reduce(function (accumulator, index, position) {
          accumulator[index] = stories[position];
          return accumulator;
        }, {})), indexes);

        commit('updateStoriesList', orderedStories);
        return orderedStories;
      });
    },
    getStoriesNav: function getStoriesNav(_ref47) {
      var commit = _ref47.commit,
          state = _ref47.state;

      var _ref48 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref48$cache = _ref48.cache,
          cache = _ref48$cache === undefined ? true : _ref48$cache;

      if (cache && state.storiesNav.length > 0) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(state.storiesNav);
      }
      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getStoriesNav().then(function (response) {
        commit('setStoriesNav', response.data);
        return response.data;
      });
    },
    getStory: function getStory(_ref49, _ref50) {
      var commit = _ref49.commit,
          state = _ref49.state;
      var index = _ref50.index,
          _ref50$cache = _ref50.cache,
          cache = _ref50$cache === undefined ? true : _ref50$cache;

      commit('clearCurrentStory');
      if (cache && typeof state.storyMap[index] !== 'undefined') {
        var obj = state.storyMap[index];
        commit('setCurrentStory', obj);
        commit('setCurrentStoryIndex', index);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(obj);
      }
      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getStory(index).then(function (response) {
        var obj = response.data;
        commit('updateStoryMap', {
          index: index,
          obj: obj
        });
        commit('setCurrentStory', obj);
        commit('setCurrentStoryIndex', index);
        return obj;
      });
    },
    getStoryDetail: function getStoryDetail(_ref51, _ref52) {
      var commit = _ref51.commit,
          state = _ref51.state;
      var index = _ref52.index,
          _ref52$cache = _ref52.cache,
          cache = _ref52$cache === undefined ? true : _ref52$cache;

      commit('clearCurrentStoryDetail');
      if (cache && typeof state.storyDetailMap[index] !== 'undefined') {
        var obj = state.storyDetailMap[index];
        commit('setCurrentStoryDetail', obj);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(obj);
      }
      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getStoryDetail(index).then(function (response) {
        var obj = response.data;
        commit('updateStoryDetailMap', {
          index: index,
          obj: obj
        });
        commit('setCurrentStoryDetail', obj);
        return obj;
      });
    },
    getStaticPageFull: function getStaticPageFull(_ref53, key) {
      var commit = _ref53.commit;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getStaticPageDetail(key).then(function (response) {
        return response.data;
      });
    },
    getStaticPagePreview: function getStaticPagePreview(_ref54, id) {
      var commit = _ref54.commit;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getStaticPagePreview(id).then(function (response) {
        return response.data;
      });
    },
    getStoryFullPreview: function getStoryFullPreview(_ref55, id) {
      var commit = _ref55.commit;

      return __WEBPACK_IMPORTED_MODULE_14__services_api__["a" /* default */].browse.getStoryFullPreview(id).then(function (response) {
        return response.data;
      });
    },
    clearCurrentStoryDetail: function clearCurrentStoryDetail(_ref56) {
      var commit = _ref56.commit;

      commit('clearCurrentStoryDetail');
    },
    toggleNavBrowseCategoriesOverlay: function toggleNavBrowseCategoriesOverlay(_ref57) {
      var commit = _ref57.commit;

      commit('toggleNavBrowseCategoriesOverlay');
    },
    updateMarketNotWatched: function updateMarketNotWatched(_ref58, marketId) {
      var commit = _ref58.commit;

      commit('updateMarketNotWatched', marketId);
    },
    updateMarketWatched: function updateMarketWatched(_ref59, marketId) {
      var commit = _ref59.commit;

      commit('updateMarketWatched', marketId);
    }
  }
});

/***/ }),

/***/ "0O9D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_dataLayer__ = __webpack_require__("k37b");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onLogin: function onLogin() {
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Registration',
        action: 'click',
        label: 'Login to My Account'
      }));
      if (this.isPage) {
        this.$router.push({ name: 'account-page-login' });
      } else {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_modals_constants__["a" /* MODALS */].LOGIN);
      }
    }
  })
});

/***/ }),

/***/ "0OLA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isDark: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),

/***/ "0X7F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getForumUrl: function getForumUrl() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/About/ForumURL');
  },
  getTicketsTypes: function getTicketsTypes() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Support/Tickets/Types');
  },
  postTicket: function postTicket(payload) {
    var options = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    };
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Support/Ticket', payload, options);
  },
  getReportUser: function getReportUser() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Support/ReportUser');
  },
  postReportUser: function postReportUser(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Support/ReportUser', payload);
  },
  getAnnouncements: function getAnnouncements() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/About/Announcements');
  }
});

/***/ }),

/***/ "0XAA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fee-waived-banner",class:_vm.levelModifier},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"}},[_c('rect',{attrs:{"width":"18","height":"18","rx":"9","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M11.8356 6.14931C11.6699 5.54157 10.8677 4.32611 8.98479 4.32611C8.07871 4.30401 6.26656 4.65746 6.16711 6.54691C6.07289 8.33702 8.18921 8.76808 8.98479 9.06642C9.93507 9.24318 11.8356 9.97459 11.8356 11.4862C11.8356 13.3757 9.48203 13.7735 8.98479 13.7735C8.48755 13.7735 6.46546 13.6077 6.16711 11.9834M8.98479 3L8.98478 15","stroke":"white","stroke-linecap":"round"}})]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0fyw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0i9X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0syx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-loader"},[_c('div',{staticClass:"market-loader__data"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0tSq":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0yMi41OSAwSDEuNDExQzEuMDM3LjAwMS42OC4xNS40MTUuNDE1LjE1LjY3OSAwIDEuMDM3IDAgMS40MXYyMS4xOGMuMDAyLjM3My4xNS43MzEuNDE1Ljk5NXMuNjIzLjQxMy45OTYuNDE0aDIxLjE4Yy4zNzMtLjAwMi43My0uMTUuOTk0LS40MTRzLjQxMy0uNjIyLjQxNS0uOTk1VjEuNDFjLS4wMDEtLjM3NC0uMTUtLjczMi0uNDE0LS45OTZTMjIuOTY0LjAwMSAyMi41OSAwem0tNy42MzYgOC4wNzVoLTEuNDNjLS4yNzkgMC0uNTY3LjI5Ny0uNTY3LjUxN3YxLjQ4aDEuOTk0Yy0uMDggMS4xMzQtLjI0NCAyLjE3MS0uMjQ0IDIuMTcxaC0xLjc2djUuOTM3aC0yLjYyM3YtNS45MzdIOS4wNDdWMTAuMDhoMS4yNzdWOC4zMWMwLS4zMjMtLjA2NS0yLjQ5IDIuNjg3LTIuNDloMS45NDN2Mi4yNTZ6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "1/qb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_userAgent__ = __webpack_require__("GZXJ");
/* eslint-disable no-bitwise */


var listenAction = void 0;
var stickyTop = void 0;
var zIndex = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    var elStyle = el.style;
    var params = binding.value || {};
    stickyTop = params.stickyTop || 0;
    zIndex = params.zIndex || 1000;
    // uncomment this line and import in case disabling on ios is necessary
    // if (isIos) return;

    if (__WEBPACK_IMPORTED_MODULE_0__mixins_userAgent__["j" /* isWindows */]) return;
    elStyle.position = '-webkit-sticky';
    elStyle.position = 'sticky';

    // if the browser support css sticky（Currently Safari, Firefox and Chrome Canary）
    if (~elStyle.position.indexOf('sticky')) {
      elStyle.top = stickyTop + 'px';
      elStyle.zIndex = zIndex;
      return;
    }

    elStyle.position = 'relative';

    var childStyle = el.firstElementChild.style;
    childStyle.cssText = 'left: 0; right: 0; top: ' + stickyTop + 'px; z-index: ' + zIndex + '; ' + childStyle.cssText;

    var active = false;

    var sticky = function sticky() {
      if (active) {
        return;
      }
      if (!elStyle.height) {
        elStyle.height = el.offsetHeight + 'px';
      }
      childStyle.willChange = 'transform';
      childStyle.position = 'fixed';
      active = true;
    };

    var reset = function reset() {
      if (!active) {
        return;
      }
      childStyle.position = 'absolute';
      active = false;
    };

    var check = function check() {
      var offsetTop = el.getBoundingClientRect().top;
      if (offsetTop <= stickyTop) {
        sticky();
        return;
      }
      reset();
    };

    listenAction = function listenAction() {
      if (!window.requestAnimationFrame) {
        return setTimeout(check, 16);
      }

      window.requestAnimationFrame(check);
      return null;
    };

    window.addEventListener('scroll', listenAction);
  },
  unbind: function unbind() {
    window.removeEventListener('scroll', listenAction);
  },
  update: function update(el, binding) {
    var params = binding.value || {};
    stickyTop = params.stickyTop || 0;
    zIndex = params.zIndex || 1000;

    var childStyle = el.firstElementChild.style;
    el.style.top = stickyTop + 'px';
    el.style.zIndex = zIndex;
    childStyle.top = el.style.top;
    childStyle.zIndex = el.style.zIndex;
  }
});

/***/ }),

/***/ "154o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code-input",class:{
    'code-input--complete': _vm.isComplete,
    'code-input--error': _vm.error,
    'code-input--disabled': _vm.disabled,
    'code-input--loading': _vm.loading,
  }},_vm._l((_vm.digits),function(digit,index){return _c('input',{key:index,ref:"inputs",refInFor:true,staticClass:"code-input__digit",style:({ '--index': index }),attrs:{"type":"text","inputmode":"numeric","autocomplete":"one-time-code","maxlength":_vm.length,"disabled":_vm.disabled},domProps:{"value":digit},on:{"input":function($event){return _vm.handleInput($event, index)},"change":function($event){return _vm.handleInput($event, index)},"keydown":function($event){return _vm.handleKeydown($event, index)},"paste":_vm.handlePaste,"focus":_vm.handleFocus}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1EIf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1F6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__ = __webpack_require__("UKic");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4f95c66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("fI94");
function injectStyle (ssrContext) {
  __webpack_require__("APZR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4f95c66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1Lmp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_chart_models__ = __webpack_require__("Q+EN");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contract: {
      type: Object,
      required: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('chart', ['getContractChartData']), {
    createChart: function createChart(data) {
      var _this = this;

      if (data) {
        setTimeout(function () {
          _this.renderChart(data);
        }, __WEBPACK_IMPORTED_MODULE_2__utils_chart_models__["c" /* PriceChangeChart */].renderTimeout());
      }
    },
    renderChart: function renderChart(data) {
      if (!this.$refs.chart) return;
      var chart = new __WEBPACK_IMPORTED_MODULE_2__utils_chart_models__["c" /* PriceChangeChart */](this.contract, data);
      chart.draw(this.$refs.chart);
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    var payload = {
      contractId: this.contract.contractId
    };
    this.getContractChartData(payload).then(function (data) {
      return _this2.createChart(data);
    });
  }
});

/***/ }),

/***/ "1P9U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_detail_charts_js__ = __webpack_require__("1pzP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a068177_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_detail_charts_vue__ = __webpack_require__("H2VB");
function injectStyle (ssrContext) {
  __webpack_require__("o9eX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_detail_charts_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a068177_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_detail_charts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1b1z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1deZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1gzC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1l9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay",class:_vm.classObject,on:{"click":_vm.hide}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1lzi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hovered: false
    };
  },

  props: {
    text: {
      type: String,
      required: true
    },
    price: {
      type: Number,
      required: true
    },
    layout: {
      type: String,
      default: ''
    },
    win: {
      default: null
    },
    sell: {
      default: null
    },
    active: {
      type: Boolean,
      default: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'button-price': true,
        'button-price--hovered': this.hovered
      }, 'button-price--' + this.layout, this.layout);
    },
    isWin: function isWin() {
      return this.win !== null;
    },
    isSell: function isSell() {
      return this.sell !== null && this.sell > 0;
    },
    showWinOrSell: function showWinOrSell() {
      return this.isLayoutDesktop && (this.isWin || this.isSell);
    },
    multiple: function multiple() {
      var result = 100 / this.price;
      var rounded = Math.round(result * 100) / 100;
      return rounded % 1 === 0 ? Math.round(rounded) : rounded;
    }
  }),
  methods: {
    onMouseOver: function onMouseOver() {
      this.hovered = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.hovered = false;
    }
  }
});

/***/ }),

/***/ "1pzP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INITIAL_MAX_CONTRACTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep__ = __webpack_require__("kvU2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEqual__ = __webpack_require__("hygk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_market_market_detail_charts_container_container_vue__ = __webpack_require__("M8zO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_market_market_detail_charts_header_header_vue__ = __webpack_require__("4pyq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_market_market_detail_charts_table_table_vue__ = __webpack_require__("ZJhQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_market_market_detail_charts_timeline_timeline_vue__ = __webpack_require__("GebD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_market_market_contracts_stats_market_contracts_stats_vue__ = __webpack_require__("Y/q+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils__ = __webpack_require__("jPoG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helpers_dataLayer__ = __webpack_require__("k37b");








 /* eslint-disable */















// const YES_CONTRACT_TYPE = 'Yes';
// const NO_CONTRACT_TYPE = 'No';
// const NO_CONTRACT_LINE_COLOR = '#F27130';
var MARKET_SINGLE_CONTRACT_NAME = 'Closing Price';
var INITIAL_SHOW_CONTRACTS = 3;
var INITIAL_MAX_CONTRACTS = 6;

var CHART_TYPES = {
  LINE: 'line',
  CANDLE: 'candle'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_15__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__mixins_contentLoader__["a" /* default */]],
  props: {
    market: {
      type: Object,
      required: false
    },
    chartOptions: {
      type: Object,
      default: null
    },
    theme: {
      type: String,
      default: ''
    },
    cache: {
      type: Boolean,
      default: false
    },
    chartSystemOptions: {
      type: Object,
      default: function _default() {}
    },
    suppressGlobalLoader: {
      type: Boolean,
      default: false
    },
    trackingContext: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var contractIds = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(this.chartOptions, 'contractIds', []) || [];

    return {
      hasMarketHiddenContracts: __WEBPACK_IMPORTED_MODULE_16__utils_helpers__["u" /* hasMarketHiddenContracts */],
      initialised: false,
      chartType: CHART_TYPES.LINE,
      preparedContractIds: null,
      toggled: false,
      disabledContracts: new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(),
      availableContractIds: contractIds,
      chartShowContractsInitial: contractIds.length > 0 ? contractIds.length : INITIAL_SHOW_CONTRACTS,
      chartMaxContracts: contractIds.length > 0 ? null : INITIAL_MAX_CONTRACTS,
      chartTimeline: null,
      chartDataLoaded: false,
      chartData: [],
      originalChartData: [],
      showStats: false,
      showVolume: false,
      showPriceAxisZoom: true,
      volumeToggleInitialized: false,
      priceAxisZoomToggleInitialized: false,
      timelineToggleInitialized: false
    };
  },

  components: {
    chartsContainer: __WEBPACK_IMPORTED_MODULE_10__components_market_market_detail_charts_container_container_vue__["a" /* default */],
    chartsHeader: __WEBPACK_IMPORTED_MODULE_11__components_market_market_detail_charts_header_header_vue__["a" /* default */],
    chartsTable: __WEBPACK_IMPORTED_MODULE_12__components_market_market_detail_charts_table_table_vue__["a" /* default */],
    chartsTimeline: __WEBPACK_IMPORTED_MODULE_13__components_market_market_detail_charts_timeline_timeline_vue__["a" /* default */],
    marketContractsStats: __WEBPACK_IMPORTED_MODULE_14__components_market_market_contracts_stats_market_contracts_stats_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapState */])('market', ['marketContractsStats']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({
        'market-detail-charts': true
      }, 'market-detail-charts--' + this.theme, this.theme);
    },
    title: function title() {
      return __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(this.chartOptions, 'chartTitle', null);
    },
    caption: function caption() {
      return __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(this.chartOptions, 'chartCaption', null);
    },
    chartContracts: function chartContracts() {
      var results = [];
      var contractIdDataGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_helpers__["v" /* groupByKeepOrder */])(this.chartData, 'contractId');

      // show contracts that represent selected point on time on the chart
      contractIdDataGroup.forEach(function (data) {
        results.push(data[data.length - 1]);
      });

      var marketContracts = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(this.market.contracts || this.market.marketContracts);
      return results.map(function (item) {
        var contract = marketContracts.find(function (i) {
          return i.contractId === item.contractId;
        }) || {};
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, item, {
          contractImageUrl: contract.contractImageUrl,
          contractImageSmallUrl: contract.contractImageSmallUrl
        });
      });
    },
    showChartsTable: function showChartsTable() {
      var noChartOptionOrLegendOn = this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(this.chartOptions, 'includeLegend', false);
      return this.chartContracts.length > 1 && noChartOptionOrLegendOn;
    },
    filteredChartData: function filteredChartData() {
      return this.chartData.filter(function (el) {
        return el.checked;
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapActions */])('chart', ['getMarketChartData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapActions */])('market', ['getMarketContractsStats', 'clearMarketContractsStats']), {
    prepareDisabledContracts: function prepareDisabledContracts(data) {
      var _this = this;

      if (this.availableContractIds.length > 0) {
        this.disabledContracts = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_6_lodash_uniqBy___default()(data, function (el) {
          return el.contractId;
        }).map(function (el) {
          return el.contractId;
        }).filter(function (i) {
          return !_this.availableContractIds.includes(i);
        }));
      } else {
        var results = [];
        var contractIdDataGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_helpers__["v" /* groupByKeepOrder */])(data, 'contractId');
        // show contracts that represent selected point on time on the art
        contractIdDataGroup.forEach(function (groupData) {
          results.push(groupData[groupData.length - 1]);
        });

        results.forEach(function (el, index) {
          if (index >= _this.chartShowContractsInitial) {
            _this.disabledContracts.add(el.contractId);
          }
        });
      }
    },
    prepareChartData: function prepareChartData(source) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(source);
      var contractIds = this.availableContractIds.length > 0 ? this.availableContractIds : __WEBPACK_IMPORTED_MODULE_6_lodash_uniqBy___default()(data, function (el) {
        return el.contractId;
      }).map(function (el) {
        return el.contractId;
      });

      var isYesNoMarket = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_helpers__["k" /* isMarketSingle */])(this.market);
      if (!__WEBPACK_IMPORTED_MODULE_7_lodash_isEqual___default()(contractIds, this.preparedContractIds)) {
        this.prepareDisabledContracts(data);
        this.preparedContractIds = contractIds;
      }

      data.forEach(function (el) {
        el.additional = false;
        el.checked = _this2.checkIsContractEnabled(el);
        el.chartPrice = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils__["a" /* regularContractPrice */])(el);

        if (isYesNoMarket) {
          el.contractName = MARKET_SINGLE_CONTRACT_NAME;
        }
      });

      return data;
    },
    checkIsContractEnabled: function checkIsContractEnabled(el) {
      return !this.disabledContracts.has(el.contractId);
    },
    getChartLoaderTarget: function getChartLoaderTarget() {
      return this.$refs.chartLoadingScope || this.$el;
    },
    beginChartRequestLoad: function beginChartRequestLoad() {
      if (this.suppressGlobalLoader) {
        this.loaderAddLegacy(this.getChartLoaderTarget());
        return;
      }
      this.loaderAdd();
    },
    endChartRequestLoad: function endChartRequestLoad() {
      if (this.suppressGlobalLoader) {
        this.loaderRemoveLegacy(this.getChartLoaderTarget());
        return;
      }
      this.loaderRemove();
    },
    loadStats: function loadStats() {
      var _this3 = this;

      this.beginChartRequestLoad();
      this.getMarketContractsStats(this.market.marketId).then(function () {
        return _this3.endChartRequestLoad();
      }).catch(function () {
        return _this3.endChartRequestLoad();
      });
    },
    loadChartData: function loadChartData(_ref2) {
      var _this4 = this;

      var _ref2$useOriginalData = _ref2.useOriginalData,
          useOriginalData = _ref2$useOriginalData === undefined ? false : _ref2$useOriginalData;

      if (useOriginalData) {
        this.chartData = this.prepareChartData(this.originalChartData);
      } else {
        var params = {
          marketId: this.market.marketId,
          maxContracts: this.chartMaxContracts,
          timespan: this.chartTimeline
        };
        var storyId = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(this.chartOptions, 'cmsStoryId', null);
        if (storyId) {
          params.storyId = storyId;
          params.chartStoryVersionId = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(this.chartOptions, 'cmsVersionId', null);
          params.regionUUID = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(this.chartOptions, 'regionUUID', null);
          params.sectionType = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(this.chartOptions, 'sectionType', null);
        }
        this.beginChartRequestLoad();
        this.getMarketChartData({ params: params, cache: this.cache }).then(function (data) {
          _this4.originalChartData = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data));
          _this4.chartData = _this4.prepareChartData(_this4.originalChartData);
          _this4.endChartRequestLoad();
          if (_this4.chartData.length === 0 && !_this4.initialised) {
            _this4.$emit('no-data');
          }
          _this4.chartDataLoaded = true;
          _this4.isComponentReady = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_helpers__["w" /* isHighChartsReady */])();
          _this4.initialised = true;
        }).catch(function (e) {
          console.error('Chart error', e);
          _this4.initialised = true;
          _this4.endChartRequestLoad();
        });
      }
    },
    onShowKey: function onShowKey() {
      this.toggled = true;
    },
    fireChartInteraction: function fireChartInteraction() {
      if (!this.trackingContext.storyId) return;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__helpers_dataLayer__["d" /* pushStoryInteraction */])(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ interactionType: __WEBPACK_IMPORTED_MODULE_20__helpers_dataLayer__["e" /* INTERACTION_TYPE */].CHART_INTERACTION }, this.trackingContext));
    },
    volumeChartToggle: function volumeChartToggle(value) {
      this.showVolume = value;
      if (!this.volumeToggleInitialized) {
        this.volumeToggleInitialized = true;
        return;
      }
      this.fireChartInteraction();
    },
    priceAxisZoomToggle: function priceAxisZoomToggle(value) {
      this.showPriceAxisZoom = value;
      if (!this.priceAxisZoomToggleInitialized) {
        this.priceAxisZoomToggleInitialized = true;
        return;
      }
      this.fireChartInteraction();
    },
    onTimelineChange: function onTimelineChange(timeline) {
      if (!this.timelineToggleInitialized) {
        this.timelineToggleInitialized = true;
      } else {
        this.fireChartInteraction();
      }
      if (timeline === 'stats') {
        this.showStats = true;
        this.loadStats();
      } else {
        this.showStats = false;
        this.chartTimeline = timeline;
        this.loadChartData({});
      }
    },
    onTypeChange: function onTypeChange(type) {
      var _this5 = this;

      this.fireChartInteraction();
      this.chartType = type;

      if (type === CHART_TYPES.CANDLE && this.chartData) {
        var contracts = __WEBPACK_IMPORTED_MODULE_6_lodash_uniqBy___default()(this.chartData, function (el) {
          return el.contractId;
        });
        var enabled = contracts.find(function (i) {
          return _this5.checkIsContractEnabled(i);
        }) || contracts[0];
        var contractIds = contracts.map(function (i) {
          return i.contractId;
        }).filter(function (i) {
          return i !== enabled.contractId;
        });
        this.disabledContracts = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(contractIds);
        this.loadChartData({ useOriginalData: true });
      }
    },
    onContractToggle: function onContractToggle(item, checked) {
      this.fireChartInteraction();
      var contractId = item.contractId;
      // const contractsNum = Math.min(this.market.contracts.length, INITIAL_MAX_CONTRACTS);
      // const disabledContractsMaxSize = contractsNum;

      if (this.chartType === CHART_TYPES.CANDLE) {
        if (!checked) {
          this.disabledContracts.add(contractId);
        } else {
          var contractIds = __WEBPACK_IMPORTED_MODULE_6_lodash_uniqBy___default()(this.chartData, function (el) {
            return el.contractId;
          }).map(function (i) {
            return i.contractId;
          }).filter(function (i) {
            return i !== contractId;
          });
          this.disabledContracts = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(contractIds);
        }
      } else {
        if (!checked) {
          this.disabledContracts.add(contractId);
        } else {
          this.disabledContracts.delete(contractId);
        }
      }

      this.loadChartData({ useOriginalData: true });
    }
  }),
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_18__logger__["a" /* default */].info('[CHART] Rendering chart: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.chartOptions || {}) + ' for ' + this.market.marketId);
  },
  beforeDestroy: function beforeDestroy() {
    this.clearMarketContractsStats();
  }
});

/***/ }),

/***/ "1tQB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2+il":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__market_key_stats_element_market_key_stats_element_vue__ = __webpack_require__("GVWc");





function getOrderMobile(arr) {
  var odd = [];
  var even = arr.reduce(function (prev, curr, idx) {
    if (idx % 2) {
      odd.push(curr);
      return prev;
    }
    prev.push(curr);
    return prev;
  }, []);
  return even.concat(odd);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_loader__["a" /* default */]],
  props: {
    widget: Object
  },
  components: {
    marketKeyStatsElement: __WEBPACK_IMPORTED_MODULE_3__market_key_stats_element_market_key_stats_element_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    obj: function obj() {
      return this.widget ? this.widget : {};
    },
    items: function items() {
      if (!this.widget) {
        return [];
      }
      return this.isLayoutMobile ? getOrderMobile(this.widget.widgetKeyStats) : this.widget.widgetKeyStats;
    }
  }),
  watch: {
    widget: function widget(val) {
      if (val) {
        this.loaderRemove();
      }
    }
  },
  methods: {},
  mounted: function mounted() {
    if (!this.widget) {
      this.loaderAdd();
    }
  }
});

/***/ }),

/***/ "2/KR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "21pt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_animated_number_js__ = __webpack_require__("DsFz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43d7163a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_animated_number_vue__ = __webpack_require__("yoSF");
function injectStyle (ssrContext) {
  __webpack_require__("XyfZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_animated_number_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43d7163a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_animated_number_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "28Cy":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNhKSI+CiAgICAgICAgPHBhdGggZD0iTTkuNTMzIDguMTJhLjE2Ny4xNjcgMCAwIDEgMC0uMjM2bDYuMTc2LTYuMTc1QTEgMSAwIDEgMCAxNC4yOTMuMjk1TDguMTE4IDYuNDY3YS4xNjcuMTY3IDAgMCAxLS4yMzYgMEwxLjcwNy4yOTVBMSAxIDAgMCAwIC4yOTMgMS43MWw2LjE3NCA2LjE3NWEuMTY3LjE2NyAwIDAgMSAwIC4yMzZMLjI5MyAxNC4yOTVhMSAxIDAgMCAwIDEuNDE0IDEuNDE0bDYuMTc1LTYuMTc1YS4xNjcuMTY3IDAgMCAxIC4yMzYgMGw2LjE3NSA2LjE3NWExIDEgMCAwIDAgMS40MTQtMS40MTRMOS41MzMgOC4xMnoiIGZpbGw9IiM1NTU3NUEiLz4KICAgIDwvZz4KICAgIDxkZWZzPgogICAgICAgIDxjbGlwUGF0aCBpZD0iYSI+CiAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMTZ2MTZIMHoiLz4KICAgICAgICA8L2NsaXBQYXRoPgogICAgPC9kZWZzPgo8L3N2Zz4K"

/***/ }),

/***/ "2A6V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contract: {},
    market: {},
    handleJourneyOpened: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'hasMaintenance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('trade', ['tradeOptions']), {
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["k" /* isMarketSingle */])(this.market);
    },
    isMarketSettled: function isMarketSettled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["o" /* isMarketSettled */])(this.market);
    },
    classModifiers: function classModifiers() {
      var isPurchaseJourneyOpened = this.handleJourneyOpened && this.tradeOptions.contractId === this.contract.contractId;

      return {
        'market-disabled-outcome-v2': true,
        'market-disabled-outcome-v2--settled': this.isMarketSettled,
        'market-disabled-outcome-v2--journey-opened': isPurchaseJourneyOpened,
        'market-disabled-outcome-v2--journey-opened--yes': isPurchaseJourneyOpened && this.tradeOptions.operationValue === 'yes',
        'market-disabled-outcome-v2--journey-opened--no': isPurchaseJourneyOpened && this.tradeOptions.operationValue === 'no'
      };
    },
    iconClassModifiers: function iconClassModifiers() {
      return {
        'market-disabled-outcome-v2__icon': true,
        'market-disabled-outcome-v2__icon--yes': this.isMarketSettled && this.isWinnerYes,
        'market-disabled-outcome-v2__icon--no': this.isMarketSettled && this.isWinnerNo
      };
    },
    buttonText: function buttonText() {
      if (this.isMarketSettled) {
        if (this.contract.settledStatus === 1) {
          return 'Yes';
          // this.contract.payoutType === 0
        } else if (this.contract.settledStatus === 2) {
          return 'No';
        }
        return 'N/A';
      }
      if (this.hasMaintenance) {
        return 'Trading Paused';
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["B" /* isMarketExpired */])(this.market)) {
        return this.isLayoutMobile ? 'Pending' : 'Pending Settlement';
      }

      return this.market.status;
    },
    isWinnerYes: function isWinnerYes() {
      // this.contract.payoutType === 1
      return this.contract.settledStatus === 1;
    },
    isWinnerNo: function isWinnerNo() {
      // this.contract.payoutType === 0
      return this.isMarketSingle && this.contract.settledStatus === 2;
    }
  })
});

/***/ }),

/***/ "2Eqs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2LR/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Pqz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return connect; });
/* unused harmony export addListener */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addOrderBookListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clearOrderBookListeners; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setupMessaging; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cleanupMessaging; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__ = __webpack_require__("GZXJ");

/* eslint-disable */






var MESSAGING_TOKEN_FLAG_NAME = 'firebase-token-sent';
var MESSAGING_TOKEN_EXPIRES_AT = 31536000;
var REF_ORDER_BOOK = 'contractOrderBook';
var REF_MARKETS = 'marketStats';
var REF_CONTRACTS = 'contractStats';

var EVENT_ADDED = 'child_added';
var EVENT_CHANGED = 'child_changed';
var EVENT_INIT = 'value';

var DATA_METHOD = 'update';
var DATA_MARKETS = 'market_data';
var DATA_CONTRACTS = 'contract_data';

var setSentTokenFlag = function setSentTokenFlag(flag) {
  return __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].set(MESSAGING_TOKEN_FLAG_NAME, flag, MESSAGING_TOKEN_EXPIRES_AT);
};
var sendTokenToServer = function sendTokenToServer(token) {
  if (!__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['user/isLoggedIn']) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'sendTokenToServer skipped', 'User is not logged in');
    return;
  }

  var isTokenSent = __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get(MESSAGING_TOKEN_FLAG_NAME, false);
  if (isTokenSent) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'sendTokenToServer skipped', 'Token was already sent');
    return;
  }

  __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.putMessagingToken(token).then(function () {
    return setSentTokenFlag(true);
  }).catch(function () {
    return setSentTokenFlag(false);
  });
};

var connect = function connect() {
  var apiToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var listenerOptions = arguments[1];

  var isAnonymous = apiToken === null;
  var config = {
    apiKey: "AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA",
    authDomain: "predictit-f497e.firebaseapp.com",
    databaseURL: "https://predictit-f497e.firebaseio.com",
    projectId: "predictit-f497e",
    messagingSenderId: "76708845910",
    appId: "1:76708845910:web:a2746a4abbe584b1911ef7"
  };
  __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'init', 'anonymous mode: ' + isAnonymous, config);
  if (window.firebase.apps.length > 0) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'reinitializing app');
    window.firebase.app().delete().then(function () {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'reinitialized app succesfully');
      try {
        window.firebase.initializeApp(config);
      } catch (e) {}
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('app/setFirebaseInitialized', true);
      addListener(listenerOptions);
    });
  } else {
    try {
      window.firebase.initializeApp(config);
    } catch (e) {}
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('app/setFirebaseInitialized', true);
    addListener(listenerOptions);
  }
};

var triggerUpdate = function triggerUpdate(_ref) {
  var _ref$loaded = _ref.loaded,
      loaded = _ref$loaded === undefined ? false : _ref$loaded,
      callback = _ref.callback,
      _ref$method = _ref.method,
      method = _ref$method === undefined ? DATA_METHOD : _ref$method,
      name = _ref.name,
      data = _ref.data;

  if (loaded) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', method + ' of ' + name + ' with ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
    callback(method, name, data);
  } else {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'skipping ' + method + ' of ' + name);
  }
};

var addOrderBookListener = function addOrderBookListener(contractId, listener) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  /* so initial snapshot is ignored -it should come from API */
  var loaded = false;
  var orderBook = window.firebase.database().ref(REF_ORDER_BOOK + '/' + contractId);
  orderBook.on(EVENT_INIT, function (snapshot) {
    var data = snapshot.val();
    if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['user/isLoggedIn'] && !loaded) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'skipping initial order book update ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
    } else if (data) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'update order book ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      listener(data);
    } else if (defaultValue !== null) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'update order book with default value');
      listener(defaultValue);
    } else {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'order book is empty');
    }
    loaded = true;
  });
};

var clearOrderBookListeners = function clearOrderBookListeners(contractId) {
  try {
    window.firebase.database().ref(REF_ORDER_BOOK + '/' + contractId).off();
  } catch (e) {}
};

var addListener = function addListener(options) {
  __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'adding listener');
  var _options$onUpdate = options.onUpdate,
      onUpdate = _options$onUpdate === undefined ? function () {
    return null;
  } : _options$onUpdate;

  var marketDataLoaded = false;
  var contractDataLoaded = false;

  var markets = window.firebase.database().ref(REF_MARKETS).orderByChild('TimeStamp').startAt((+new Date() / 1000).toFixed(5).toString());
  markets.on(EVENT_ADDED, function (data) {
    triggerUpdate({
      loaded: marketDataLoaded,
      callback: onUpdate,
      name: DATA_MARKETS,
      data: data.val()
    });
  });
  markets.on(EVENT_CHANGED, function (data) {
    triggerUpdate({
      loaded: marketDataLoaded,
      callback: onUpdate,
      name: DATA_MARKETS,
      data: data.val()
    });
  });
  markets.once(EVENT_INIT, function () {
    marketDataLoaded = true;
  });

  var contracts = window.firebase.database().ref(REF_CONTRACTS).orderByChild('TimeStamp').startAt((+new Date() / 1000).toFixed(5).toString());

  contracts.on(EVENT_ADDED, function (data) {
    triggerUpdate({
      loaded: contractDataLoaded,
      callback: onUpdate,
      name: DATA_CONTRACTS,
      data: data.val()
    });
  });
  contracts.on(EVENT_CHANGED, function (data) {
    triggerUpdate({
      loaded: contractDataLoaded,
      callback: onUpdate,
      name: DATA_CONTRACTS,
      data: data.val()
    });
  });
  contracts.once(EVENT_INIT, function () {
    contractDataLoaded = true;
  });
};

var setupMessaging = function setupMessaging() {
  if (__WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__["d" /* isAndroid */] || __WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__["c" /* isIos */] || __WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__["f" /* isIE */]) return;

  var messaging = window.firebase.messaging();
  __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'setting up messaging');
  messaging.requestPermission().then(function (data) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'permission granted', data);
    messaging.getToken().then(function (token) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'messaging token received');
      if (token) {
        sendTokenToServer(token);
      } else {
        setSentTokenFlag(false);
      }
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'error requesting token', error);
      setSentTokenFlag(false);
    });
    messaging.onTokenRefresh(function () {
      messaging.getToken().then(function (token) {
        __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'messaging token refreshed');
        if (token) {
          setSentTokenFlag(false);
          sendTokenToServer(token);
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'error requesting refresh token', error);
        setSentTokenFlag(false);
      });
    });
  }).catch(function (error) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'error requesting permission', error);
  });
};

var cleanupMessaging = function cleanupMessaging() {
  return __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].del(MESSAGING_TOKEN_FLAG_NAME);
};



/***/ }),

/***/ "2SRW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_search__ = __webpack_require__("+ZRi");





var SEARCH_BAR_VISIBLE_FOCUS_TIMEOUT = 500;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_search__["a" /* default */]],
  props: {
    theme: {
      type: String,
      default: 'default'
    }
  },
  data: function data() {
    return {
      focused: false,
      searchQuery: '',
      searchFor: '',
      searchTotal: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('search', ['searchBarVisible']), {
    show: function show() {
      return this.theme === 'default' && this.searchBarVisible || this.theme !== 'default';
    },
    showSummary: function showSummary() {
      return this.searchTotal === 0;
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'search-bar': true
      }, 'search-bar--' + this.theme, this.theme);
    },
    summaryClassModifiers: function summaryClassModifiers() {
      return {
        'search-bar__summary': true,
        'search-bar__summary--no-results': !this.searchTotal
      };
    },
    inputClassModifiers: function inputClassModifiers() {
      return {
        'search-bar__input': true,
        'search-bar__input--focused': this.focused
      };
    }
  }),
  watch: {
    $route: function $route() {
      if (this.show) {
        this.onClose();
      }
    },
    show: function show(value) {
      var _this = this;

      if (value) {
        setTimeout(function () {
          _this.$refs.searchInput.focus();
        }, SEARCH_BAR_VISIBLE_FOCUS_TIMEOUT);
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('app', ['toggleMobileMenu']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('search', ['toggleSearchBar']), {
    handleFocus: function handleFocus() {
      this.focused = true;
    },
    handleBlur: function handleBlur() {
      this.focused = false;
    },
    onSearchResults: function onSearchResults(data) {
      if (data.totalMarkets > 0) {
        // close when there are results
        this.onClose();
      } else if (this.theme === 'menu') {
        this.toggleMobileMenu();
      }
      this.searchTotal = data.totalMarkets;
    },
    onClose: function onClose() {
      if (this.theme === 'default') {
        this.toggleSearchBar();
      } else if (this.theme === 'menu') {
        this.toggleMobileMenu();
      }
      this.searchFor = '';
      this.searchQuery = '';
      this.searchTotal = null;
    },
    onSubmit: function onSubmit() {
      this.searchTotal = null;
      if (this.searchQuery === '') return;
      this.searchFor = this.searchQuery;
      this.doSearch(this.searchQuery);
    }
  })
});

/***/ }),

/***/ "2YJ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document-table-view"},[_c('table',{staticClass:"document-table-view__table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.documentData.displayDocuments),function(document,index){return _c('tr',{key:index,class:_vm.rowClassModifiers(document, index),on:{"click":function($event){return _vm.onOpen(document, index)}}},[_c('td',[_vm._v("\n          "+_vm._s(document.displayDocumentTitle)+"\n        ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(document.displayDocumentDescription)+"\n        ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(_vm.parseDate(document))+"\n        ")])])}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',[_c('th',[_vm._v("Title")]),_vm._v(" "),_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',[_vm._v("Date")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2ZYw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2uhI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeaderboardsInfoLoader_vue__ = __webpack_require__("OIwd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46dc6efc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeaderboardsInfoLoader_vue__ = __webpack_require__("Uepp");
function injectStyle (ssrContext) {
  __webpack_require__("PQLn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeaderboardsInfoLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46dc6efc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeaderboardsInfoLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2uxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"password-requirements"},[_c('p',{staticClass:"password-requirements__label"},[_vm._v("Minimum password requirements")]),_vm._v(" "),_c('div',{staticClass:"password-requirements__req"},[_c('form-checkbox',{staticClass:"password-requirements__6plus",attrs:{"name":"password-requirements-min-length","label":"6+characters","disabled":true,"checked":this.validation.minLength,"small":true}}),_vm._v(" "),_c('form-checkbox',{staticClass:"password-requirements__letter",attrs:{"name":"password-requirements-lower","label":"Upper & Lower Case","disabled":true,"checked":_vm.hasOneUpperLower,"small":true}}),_vm._v(" "),_c('form-checkbox',{staticClass:"password-requirements__digit",attrs:{"name":"password-requirements-digit","label":"Number","disabled":true,"checked":this.validation.hasOneDigit,"small":true}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2wse":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "2zfn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_side_notification_js__ = __webpack_require__("4RVP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f56c44b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_side_notification_vue__ = __webpack_require__("EOrx");
function injectStyle (ssrContext) {
  __webpack_require__("hM2Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_side_notification_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f56c44b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_side_notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "39kf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



var CLASS_IS_LOADING = 'is-loading';

var loaderMixin = {
  data: function data() {
    return {
      isLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['newLoaderIsLoading', 'isLayoutMobile', 'isLayoutDesktop'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['incrNewLoaderCounter', 'decrNewLoaderCounter']), {
    loaderAddLegacy: function loaderAddLegacy() {
      var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var loadingClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CLASS_IS_LOADING;
      var changeFlag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var target = el || this.$el;
      if (target) {
        target.classList.add(loadingClass);
      }
      if (changeFlag) {
        this.isLoading = true;
      }
    },
    loaderRemoveLegacy: function loaderRemoveLegacy() {
      var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var loadingClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CLASS_IS_LOADING;
      var changeFlag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var target = el || this.$el;
      if (target) {
        target.classList.remove(loadingClass);
      }
      if (changeFlag) {
        this.isLoading = false;
      }
    },
    loaderAdd: function loaderAdd() {
      var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var loadingClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CLASS_IS_LOADING;
      var changeFlag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (this.isLayoutMobile) {
        this.incrNewLoaderCounter();
        if (changeFlag) {
          this.isLoading = true;
        }
      } else {
        this.loaderAddLegacy(el, loadingClass, changeFlag);
      }
    },
    loaderRemove: function loaderRemove() {
      var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var loadingClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CLASS_IS_LOADING;
      var changeFlag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (this.isLayoutMobile) {
        this.decrNewLoaderCounter();
        if (changeFlag) {
          this.isLoading = false;
        }
      } else {
        this.loaderRemoveLegacy(el, loadingClass, changeFlag);
      }
    }
  })
};

/* harmony default export */ __webpack_exports__["a"] = (loaderMixin);

/***/ }),

/***/ "3FZB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('h1',{staticClass:"visually-hidden"},[_vm._v("PredictIt — Real-Money Political Prediction Markets")]),_vm._v(" "),_c('div',{staticClass:"home-old__preview-carousel"},[_c('preview-carousel')],1),_vm._v(" "),_c('div',{staticClass:"home-old__markets"},[_c('page-markets',{attrs:{"headerId":0,"embedded":true},on:{"embeddedInitialLoadStateChange":_vm.onEmbeddedInitialLoadStateChange}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3GDC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_filter_button_js__ = __webpack_require__("JSIy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42e28373_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filter_button_vue__ = __webpack_require__("OqUx");
function injectStyle (ssrContext) {
  __webpack_require__("QgYw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_filter_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42e28373_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filter_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3USW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_upload_document_js__ = __webpack_require__("MluJ");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_067b0f8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_upload_document_vue__ = __webpack_require__("7JgB");
function injectStyle (ssrContext) {
  __webpack_require__("S2j1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_upload_document_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_067b0f8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_upload_document_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3Uxo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_home_old_js__ = __webpack_require__("+1tr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_feebf970_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_old_vue__ = __webpack_require__("3FZB");
function injectStyle (ssrContext) {
  __webpack_require__("/rSU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_home_old_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_feebf970_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_old_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3cKl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_main_nav_js__ = __webpack_require__("ASm9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e792242_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_main_nav_vue__ = __webpack_require__("XLAI");
function injectStyle (ssrContext) {
  __webpack_require__("e1V1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_main_nav_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e792242_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_main_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3ggI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_textarea_js__ = __webpack_require__("09V6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69a39100_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_textarea_vue__ = __webpack_require__("DJt/");
function injectStyle (ssrContext) {
  __webpack_require__("q/wu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_textarea_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69a39100_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_textarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3kul":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "3vft":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3yfD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");





var PROGRESS_LEFT_RIGHT_THRESHOLD = 15;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_socialLevel__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    avatarTheme: function avatarTheme() {
      return this.isLayoutDesktop ? 'large' : '';
    },
    username: function username() {
      return this.userData && this.userData.userName ? '' + this.userData.userName : '';
    },
    backgroundModifiers: function backgroundModifiers() {
      var num = this.level.num;
      return {
        'account-social-badge': true
        // [`account-social-badge--level-${num}`]: num,
      };
    },
    progressBarStyleModifiers: function progressBarStyleModifiers() {
      return {
        width: this.progressPercentage + '%'
      };
    },
    progressBarClassModifiers: function progressBarClassModifiers() {
      return {
        'account-social-badge__progress-num': true,
        'account-social-badge__progress-num--right  ': true
      };
    },
    levelColor: function levelColor() {
      return '#55575A';
    },
    progressColor: function progressColor() {
      return '#259EBB';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    showBadgesPopup: function showBadgesPopup() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_modals_constants__["a" /* MODALS */].SMALL_BADGES);
    }
  })
});

/***/ }),

/***/ "4/Ye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    text: {
      type: String
    },
    reversed: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('showPopup');
    }
  }
});

/***/ }),

/***/ "44Nf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multiselect",class:{ 'multiselect--active': _vm.isOpen, 'multiselect--disabled': _vm.disabled, 'multiselect--above': _vm.isAbove },attrs:{"tabindex":_vm.searchable ? -1 : _vm.tabindex},on:{"focus":function($event){return _vm.activate()},"blur":function($event){_vm.searchable ? false : _vm.deactivate()},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }if($event.target !== $event.currentTarget){ return null; }$event.preventDefault();return _vm.pointerForward()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }if($event.target !== $event.currentTarget){ return null; }$event.preventDefault();return _vm.pointerBackward()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }$event.stopPropagation();if($event.target !== $event.currentTarget){ return null; }return _vm.addPointerElement($event)}],"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.deactivate()}}},[_vm._t("caret",[_c('div',{staticClass:"multiselect__select",on:{"mousedown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggle()}}})],{"toggle":_vm.toggle}),_vm._v(" "),_vm._t("clear",null,{"search":_vm.search}),_vm._v(" "),_c('div',{ref:"tags",staticClass:"multiselect__tags"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visibleValue.length > 0),expression:"visibleValue.length > 0"}],staticClass:"multiselect__tags-wrap"},[_vm._l((_vm.visibleValue),function(option){return [_vm._t("tag",[_c('span',{staticClass:"multiselect__tag"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getOptionLabel(option))}}),_vm._v(" "),_c('i',{staticClass:"multiselect__tag-icon",attrs:{"aria-hidden":"true","tabindex":"1"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.removeElement(option)},"mousedown":function($event){$event.preventDefault();return _vm.removeElement(option)}}})])],{"option":option,"search":_vm.search,"remove":_vm.removeElement})]})],2),_vm._v(" "),(_vm.internalValue && _vm.internalValue.length > _vm.limit)?[_c('strong',{staticClass:"multiselect__strong",domProps:{"textContent":_vm._s(_vm.limitText(_vm.internalValue.length - _vm.limit))}})]:_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"multiselect__loading"}},[_vm._t("loading",[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"multiselect__spinner"})])],2),_vm._v(" "),(_vm.searchable)?_c('input',{ref:"search",staticClass:"multiselect__input",style:(_vm.inputStyle),attrs:{"name":_vm.name,"id":_vm.id,"type":"text","autocomplete":"off","placeholder":_vm.placeholder,"disabled":_vm.disabled,"tabindex":_vm.tabindex},domProps:{"value":_vm.isOpen ? _vm.search : _vm.currentOptionLabel},on:{"input":function($event){return _vm.updateSearch($event.target.value)},"focus":function($event){$event.preventDefault();return _vm.activate()},"blur":function($event){$event.preventDefault();return _vm.deactivate()},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.deactivate()},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.pointerForward()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.pointerBackward()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();if($event.target !== $event.currentTarget){ return null; }return _vm.addPointerElement($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){ return null; }$event.stopPropagation();return _vm.removeLastElement()}]}}):_vm._e(),_vm._v(" "),(!_vm.searchable)?_c('span',{staticClass:"multiselect__single",domProps:{"innerHTML":_vm._s(_vm.currentOptionLabel)},on:{"mousedown":function($event){$event.preventDefault();return _vm.toggle($event)}}}):_vm._e()],2),_vm._v(" "),_c('transition',{attrs:{"name":"multiselect"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],ref:"list",staticClass:"multiselect__content-wrapper",style:({ maxHeight: _vm.optimizedHeight + 'px' }),on:{"focus":_vm.activate,"mousedown":function($event){$event.preventDefault();}}},[_c('ul',{staticClass:"multiselect__content",style:(_vm.contentStyle)},[_vm._t("beforeList"),_vm._v(" "),(_vm.multiple && _vm.max === _vm.internalValue.length)?_c('li',[_c('span',{staticClass:"multiselect__option"},[_vm._t("maxElements",[_vm._v("Maximum of "+_vm._s(_vm.max)+" options selected. First remove a selected option to select another.")])],2)]):_vm._e(),_vm._v(" "),(!_vm.max || _vm.internalValue.length < _vm.max)?_vm._l((_vm.filteredOptions),function(option,index){return _c('li',{key:index,staticClass:"multiselect__element"},[(!(option && (option.$isLabel || option.$isDisabled)))?_c('span',{staticClass:"multiselect__option",class:_vm.optionHighlight(index, option),attrs:{"data-select":option && option.isTag ? _vm.tagPlaceholder : _vm.selectLabelText,"data-selected":_vm.selectedLabelText,"data-deselect":_vm.deselectLabelText},on:{"click":function($event){$event.stopPropagation();return _vm.select(option)},"mouseenter":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.pointerSet(index, option)}}},[_vm._t("option",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getOptionLabel(option))}})],{"option":option,"search":_vm.search})],2):_vm._e(),_vm._v(" "),(option && (option.$isLabel || option.$isDisabled))?_c('span',{staticClass:"multiselect__option multiselect__option--disabled",class:_vm.optionHighlight(index, option)},[_vm._t("option",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getOptionLabel(option))}})],{"option":option,"search":_vm.search})],2):_vm._e()])}):_vm._e(),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNoResults && (_vm.filteredOptions.length === 0 && _vm.search && !_vm.loading)),expression:"showNoResults && (filteredOptions.length === 0 && search && !loading)"}]},[_c('span',{staticClass:"multiselect__option"},[_vm._t("noResult",[_vm._v("No elements found. Consider changing the search query.")])],2)]),_vm._v(" "),_vm._t("afterList")],2)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4DPA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"static-page-loader"},[_c('div',{staticClass:"static-page-loader__content"},[_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-2"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-3"}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"static-page-loader__text-1"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Iyt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showNewsFeed)?_c('div',{class:_vm.classModifiers},[(!_vm.collapsible)?[(_vm.showTitle)?_c('div',{staticClass:"news-feed__header"},[_c('div',{staticClass:"news-feed__header-title"},[_vm._v("\n        News Feed\n      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"news-feed__line"}),_vm._v(" "),_c('div',{class:_vm.contentClassModifiers},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"news-feed__item"},[_c('news-feed-item',{attrs:{"data":item}})],1)}),0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMoreButton),expression:"showMoreButton"}],staticClass:"news-feed__more-button",on:{"click":_vm.loadMore}},[_vm._v("\n      More News\n    ")])]:[_c('collapsible-panel',{key:_vm.isOpen,attrs:{"noPadding":true,"darkHeader":true,"canClose":false,"isOpen":_vm.isOpen,"theme":"small-header"},on:{"toggle":function($event){return _vm.$emit('toggle-news')}}},[_c('div',{staticClass:"news-feed__collapsible-title",attrs:{"slot":"title"},slot:"title"},[_c('span',{staticClass:"news-feed__collapsible-title-text"},[_vm._v("News Feed")])]),_vm._v(" "),_c('div',{staticClass:"news-feed__collapsible-content"},[_c('div',{class:_vm.contentClassModifiers},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"news-feed__item"},[_c('news-feed-item',{attrs:{"data":item}})],1)}),0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMoreButton),expression:"showMoreButton"}],staticClass:"news-feed__more-button",on:{"click":_vm.loadMore}},[_vm._v("\n          More News\n        ")])])])]],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4OEB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_cash_js__ = __webpack_require__("9rUd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69054c3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_cash_vue__ = __webpack_require__("mkEI");
function injectStyle (ssrContext) {
  __webpack_require__("4x8B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_cash_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69054c3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_cash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4RVP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logger__ = __webpack_require__("G/BR");






var levels = ['success', 'danger', 'warning', 'info'];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    level: {
      type: String,
      default: 'success',
      validator: function validator(value) {
        return levels.indexOf(value) !== -1;
      }
    },
    autoClose: {
      type: Boolean,
      required: false,
      default: true
    },
    closeTimeout: {
      type: Number,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
    },
    onCloseCallback: {
      default: null
    },
    text: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      interacted: false
    };
  },

  computed: {
    contentModifiers: function contentModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'side-notification__content': true
      }, 'side-notification__content--' + this.level, this.level);
    },
    iconModifiers: function iconModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'side-notification__icon': true
      }, 'side-notification__icon--' + this.level, this.level);
    },
    isDebug: function isDebug() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__logger__["b" /* isDebugOn */])();
    },
    showAutoCloseLoader: function showAutoCloseLoader() {
      return this.autoClose && this.closeTimeout > 0 && !this.interacted && !this.isDebug;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['clearSideNotification']), {
    onClose: function onClose() {
      this.clearSideNotification();
      if (typeof this.onCloseCallback !== 'undefined' && this.onCloseCallback !== null) {
        this.onCloseCallback.apply(this);
      }
    },
    onInteract: function onInteract() {
      this.interacted = true;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.$el.addEventListener('click', function () {
      return _this.onInteract();
    });
    if (this.autoClose && !this.isDebug) {
      this.timeout = setTimeout(function () {
        if (!_this.interacted) _this.onClose();
      }, this.closeTimeout);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
});

/***/ }),

/***/ "4cn4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal","appear":""},on:{"after-enter":_vm.afterEnter}},[_c('div',{class:_vm.overlayClassModifiers},[_c('div',{staticClass:"modal__wrapper"},[_c('div',{staticClass:"modal__body",class:_vm.bodyClass},[(_vm.hasHeader())?_c('div',{staticClass:"modal__header",class:_vm.headerClass},[_vm._t("header"),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.closeButton),expression:"closeButton"}],staticClass:"modal__close",on:{"mousedown":function($event){$event.preventDefault();},"click":function($event){$event.preventDefault();return _vm.close($event)}}})],2):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],staticClass:"modal__content",class:[_vm.classModifier, { 'modal__content--with-footer': _vm.hasFooter() }]},[_vm._t("content")],2),_vm._v(" "),(_vm.hasFooter())?_c('div',{staticClass:"modal__footer"},[_vm._t("footer")],2):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4eDX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_settings_button_js__ = __webpack_require__("WF/p");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cc282c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_settings_button_vue__ = __webpack_require__("HQPR");
function injectStyle (ssrContext) {
  __webpack_require__("na9c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_settings_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cc282c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_settings_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4p0o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_most_predicted_list_js__ = __webpack_require__("Zi8f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_accc2a06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_most_predicted_list_vue__ = __webpack_require__("epoI");
function injectStyle (ssrContext) {
  __webpack_require__("d1aY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_most_predicted_list_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_accc2a06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_most_predicted_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4pyq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_header_js__ = __webpack_require__("Ufge");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a97db65_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("emeG");
function injectStyle (ssrContext) {
  __webpack_require__("7aYA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a97db65_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4uR/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4v//":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4v/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "4vD6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_biggest_gains_element_js__ = __webpack_require__("OLUT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_064052a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_biggest_gains_element_vue__ = __webpack_require__("8vMm");
function injectStyle (ssrContext) {
  __webpack_require__("Y8LD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_biggest_gains_element_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_064052a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_biggest_gains_element_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4x8B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "52iG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(!_vm.isComponentReady)?_c('preview-carousel-loader'):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNav),expression:"showNav"}],class:_vm.tabsClassModifiers},[(_vm.showNavigationArrows)?_c('button',{staticClass:"preview-carousel__arrow preview-carousel__arrow--left",attrs:{"disabled":!_vm.canScrollLeft,"aria-label":"Scroll left"},on:{"click":_vm.scrollLeft}}):_vm._e(),_vm._v(" "),_c('div',{ref:"tabsList",staticClass:"preview-carousel__nav-container"},[_c('tabs',{attrs:{"items":_vm.navigationTabs,"theme":"carousel","activeTab":_vm.activeTab},on:{"tabChange":_vm.navigationTabChange},nativeOn:{"click":function($event){return _vm.tabsClicked($event)}}})],1),_vm._v(" "),(_vm.showNavigationArrows)?_c('button',{staticClass:"preview-carousel__arrow preview-carousel__arrow--right",attrs:{"disabled":!_vm.canScrollRight,"aria-label":"Scroll right"},on:{"click":_vm.scrollRight}}):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isComponentReady),expression:"isComponentReady"}],ref:"content",class:_vm.contentClassModifiers,style:(_vm.contentStyleModifiers)},_vm._l((_vm.storyMap),function(data,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(parseInt(index, 10) === _vm.currentStoryIndex),expression:"parseInt(index, 10) === currentStoryIndex"}],key:(_vm.refreshIndex + "-" + index),staticClass:"preview-carousel__story"},[_c('div',{staticClass:"preview-carousel__story-html",domProps:{"innerHTML":_vm._s(_vm.storyContentMap[index])}})])}),0),_vm._v(" "),(_vm.showExpandControl)?_c('div',{class:_vm.expandClassModifiers,on:{"click":_vm.toggleExpand}},[(!_vm.isExpanded)?_c('span',[_vm._v("Read More ▾")]):_c('span',[_vm._v("Show Less ▴")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5CwS":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "5IfR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Oj8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CONTRACTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COLOR_INDEXES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PRICE_FACTORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COLOR_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getColorForPalletteCandidate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


var CONTRACTS = {
  REPUBLICAN: 'Republican',
  DEMOCRATIC: 'Democratic',
  TRUMP: 'Trump'
};

var COLOR_INDEXES = {
  LOW: 0,
  MEDIUM: 1,
  HIGH: 2
};

var PRICE_FACTORS = {
  DELTA: 0.01,
  LOW: 0.64,
  MEDIUM: 0.79,
  HIGH: 1
};

var COLOR_MAP = {
  GRAY: [{ from: 0, to: PRICE_FACTORS.LOW, color: '#dddddd' }, { from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])(PRICE_FACTORS.LOW + PRICE_FACTORS.DELTA), to: PRICE_FACTORS.MEDIUM, color: '#bbbbbb' }, { from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])(PRICE_FACTORS.MEDIUM + PRICE_FACTORS.DELTA), to: PRICE_FACTORS.HIGH, color: '#888888' }],
  BLUE: [{ from: 30, to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])(30 + PRICE_FACTORS.LOW), color: '#8aafff' }, { from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])(30 + PRICE_FACTORS.LOW + PRICE_FACTORS.DELTA), to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])(30 + PRICE_FACTORS.MEDIUM), color: '#5c80dc' }, { from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])(30 + PRICE_FACTORS.MEDIUM + PRICE_FACTORS.DELTA), to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])(30 + PRICE_FACTORS.HIGH), color: '#244999' }],
  RED: [{ from: 40, to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])(40 + PRICE_FACTORS.LOW), color: '#ff8b98' }, { from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])(40 + PRICE_FACTORS.LOW + PRICE_FACTORS.DELTA), to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])(40 + PRICE_FACTORS.MEDIUM), color: '#ff5865' }, { from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])(40 + PRICE_FACTORS.MEDIUM + PRICE_FACTORS.DELTA), to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])(40 + PRICE_FACTORS.HIGH), color: '#d22532' }]
};

var getColorForPalletteCandidate = function getColorForPalletteCandidate(contractName) {
  var name = (contractName || '').toLowerCase();
  var isRepublican = name.includes(CONTRACTS.REPUBLICAN.toLowerCase()) || name.includes(CONTRACTS.TRUMP.toLowerCase());

  if (isRepublican) {
    return COLOR_MAP.RED;
  }
  return COLOR_MAP.BLUE;
};

/***/ }),

/***/ "5RCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    shutdown: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClick: function onClick() {
      if (this.shutdown) {
        window.location.href = 'https://twitter.com/PredictIt';
      } else {
        this.$router.push({ name: 'research' });
      }
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'research-widget': true
      }, 'research-widget--' + this.theme, this.theme);
    }
  }
});

/***/ }),

/***/ "5Wmq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_map_widget_view_js__ = __webpack_require__("KFTB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c48ac82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_map_widget_view_vue__ = __webpack_require__("HDku");
function injectStyle (ssrContext) {
  __webpack_require__("2Eqs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_map_widget_view_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c48ac82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_map_widget_view_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5X5i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio"},[_c('label',{attrs:{"for":_vm.name}},[_c('div',{staticClass:"radio__input"},[_c('input',{attrs:{"type":"radio","name":_vm.name,"required":_vm.required,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checked === _vm.value},on:{"change":_vm.onChange}})]),_vm._v(" "),_c('div',{staticClass:"radio__label",on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5XgW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"socials-loader"},[_c('div',{staticClass:"socials-loader__item"}),_vm._v(" "),_c('div',{staticClass:"socials-loader__item"}),_vm._v(" "),_c('div',{staticClass:"socials-loader__item"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5aqh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationLoader_vue__ = __webpack_require__("U7LV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_738afbd0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationLoader_vue__ = __webpack_require__("J6HH");
function injectStyle (ssrContext) {
  __webpack_require__("lPAh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_738afbd0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5eKf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showPendingLink: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onDone: function onDone() {
      this.$emit('done');
    },
    onViewPendingDeposits: function onViewPendingDeposits() {
      this.$router.push({ name: 'wallet', query: { tabId: 'pending', subTab: 'deposits' } });
    }
  }
});

/***/ }),

/***/ "5haK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(!_vm.isComponentReady)?_c('account-form-loader',{attrs:{"theme":"deposit"}}):(_vm.documentUploadInfoVisible)?_c('account-upload-document',{attrs:{"source":_vm.documentUploadSource,"isPending":_vm.documentUploadInfoPending,"theme":_vm.accountUploadDocumentTheme,"type":"card"}}):(_vm.collectSsnInfo)?_c('account-ssn-info-upload',{attrs:{"isPopup":_vm.isPopup,"theme":_vm.accountUploadDocumentTheme}}):[(_vm.isStep('INITIAL'))?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onConfirmDeposit($event)}}},[(_vm.errorMessage)?_c('alert-box',{staticClass:"add-funds-credit-card__alert-box",attrs:{"level":"warning"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})]):_vm._e(),_vm._v(" "),(_vm.avsMessage)?_c('alert-box',{staticClass:"add-funds-credit-card__alert-box",attrs:{"level":"warning"}},[_vm._v("\n        Please provide a billing address.\n      ")]):_vm._e(),_vm._v(" "),(_vm.showPromoNotification && false)?_c('fee-waived-banner',{staticClass:"add-funds-credit-card__alert-box",attrs:{"level":"success","text":_vm.promoCodeDetail.friendlyDescription}}):_vm._e(),_vm._v(" "),(_vm.depositWarning)?_c('div',{staticClass:"predictit-embedded-alert",domProps:{"innerHTML":_vm._s(_vm.depositWarning)}}):_vm._e(),_vm._v(" "),(_vm.showInstantCreditNotification && false)?_c('fee-waived-banner',{attrs:{"level":_vm.instantCreditBoxLevel,"text":_vm.instantCreditBoxMessage}}):_vm._e(),_vm._v(" "),(!_vm.errorMessage)?[_c('div',{staticClass:"add-funds-credit-card__amount-section"},[_c('div',{staticClass:"add-funds-credit-card__section-label add-funds-credit-card__section-label--center"},[_vm._v("Deposit")]),_vm._v(" "),_c('deposit-amount-picker',{attrs:{"deposit-amounts":_vm.depositAmounts,"has-error":_vm.amountHasError,"error-message":_vm.amountValidationMessage,"disabled":_vm.isFormDisabled},on:{"add":_vm.onUpdateAmount,"blur":_vm.handleAmountBlur,"input":_vm.$v.fields.amount.$touch},model:{value:(_vm.fields.amount),callback:function ($$v) {_vm.$set(_vm.fields, "amount", $$v)},expression:"fields.amount"}})],1),_vm._v(" "),_c('fee-status-message',{staticClass:"add-funds-credit-card__no-fee-message",attrs:{"amount":_vm.fields.amount,"fee-percent":_vm.processingFeePercent,"fee-free-cap":_vm.feeFreeCap,"fee-discount-eligibility":_vm.feeDiscountEligibility,"fee-cap":_vm.feeCap,"prefix":_vm.noFeeMessagePrefix}}),_vm._v(" "),_c('div',{staticClass:"add-funds-credit-card__section-label"},[_vm._v("Card details")]),_vm._v(" "),_c('div',{staticClass:"add-funds-credit-card__card-fields"},[_c('div',{staticClass:"add-funds-credit-card__field-row"},[_c('form-input',{attrs:{"tabindex":2,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.name,"name":_vm.fieldName('name'),"autocomplete":"name","type":"text","required":true,"gtm":"Deposit,Credit Card Name","placeholder":"Name on Card"},on:{"input":_vm.$v.fields.name.$touch},model:{value:(_vm.fields.name),callback:function ($$v) {_vm.$set(_vm.fields, "name", $$v)},expression:"fields.name"}})],1),_vm._v(" "),_c('div',{staticClass:"add-funds-credit-card__field-row"},[_c('form-input',{ref:"cnumber",attrs:{"theme":"card-type","tabindex":4,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.number,"name":_vm.fieldName('number'),"autocomplete":"off","type":"text","gtm":"Deposit,Credit Card Number","hideIconOnValue":false,"required":true,"placeholder":"Card Number"},on:{"input":_vm.$v.fields.number.$touch},model:{value:(_vm.fields.number),callback:function ($$v) {_vm.$set(_vm.fields, "number", $$v)},expression:"fields.number"}},[_c('img',{staticClass:"add-funds-credit-card__card-type-img",attrs:{"slot":"icon","src":_vm.cardTypeImage},slot:"icon"})]),_vm._v(" "),(_vm.cardTypeHasError)?_c('div',{staticClass:"add-funds-credit-card__error add-funds-credit-card__error--no-margin-bottom"},[_vm._v("\n              "+_vm._s(_vm.cardTypeValidationMessage)+"\n            ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"add-funds-credit-card__expiry-row"},[_c('div',{staticClass:"add-funds-credit-card__expiry-month"},[_c('form-select',{attrs:{"searchable":_vm.isLayoutDesktop,"tabindex":5,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.expiryDateMonth,"placeholder":"MM","options":_vm.months,"track-by":"value","label":"label","gtm":"Deposit,Credit Card Expiry Month","required":true},on:{"select":function (e) { return _vm.tabTo(e, 'year'); },"input":_vm.$v.fields.expiryDateMonth.$touch},model:{value:(_vm.fields.expiryDateMonth),callback:function ($$v) {_vm.$set(_vm.fields, "expiryDateMonth", $$v)},expression:"fields.expiryDateMonth"}})],1),_vm._v(" "),_c('div',{staticClass:"add-funds-credit-card__expiry-year"},[_c('form-select',{ref:"year",attrs:{"searchable":_vm.isLayoutDesktop,"tabindex":6,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.expiryDateYear,"placeholder":"YYYY","options":_vm.years,"track-by":"value","label":"label","gtm":"Deposit,Credit Card Expiry Year","required":true},on:{"select":function (e) { return _vm.tabTo(e, 'cvv'); },"input":_vm.$v.fields.expiryDateYear.$touch},model:{value:(_vm.fields.expiryDateYear),callback:function ($$v) {_vm.$set(_vm.fields, "expiryDateYear", $$v)},expression:"fields.expiryDateYear"}})],1),_vm._v(" "),_c('div',{staticClass:"add-funds-credit-card__cvv"},[_c('form-input',{ref:"cvv",attrs:{"tabindex":7,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.cvv,"name":_vm.fieldName('cvv'),"autocomplete":"off","type":"text","required":true,"gtm":"Deposit,Security Code","placeholder":"CVV","hideIconOnValue":false},on:{"input":_vm.$v.fields.cvv.$touch},model:{value:(_vm.fields.cvv),callback:function ($$v) {_vm.$set(_vm.fields, "cvv", $$v)},expression:"fields.cvv"}},[_c('notification-icon',{attrs:{"slot":"icon","reversed":true},on:{"showPopup":_vm.showCVVModal},slot:"icon"})],1)],1)])]),_vm._v(" "),(_vm.avsFlag)?[_c('div',{staticClass:"add-funds-credit-card__section-label add-funds-credit-card__section-label--margin-top"},[_vm._v("\n            Billing Address\n          ")]),_vm._v(" "),_c('div',{staticClass:"add-funds-credit-card__card-fields"},[_c('div',{staticClass:"add-funds-credit-card__field-row"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.address,"disabled":_vm.isFormDisabled,"name":"street","type":"text","required":true,"autocomplete":"street-address","placeholder":"Street Address"},on:{"input":_vm.$v.fields.address.$touch},model:{value:(_vm.fields.address),callback:function ($$v) {_vm.$set(_vm.fields, "address", $$v)},expression:"fields.address"}})],1),_vm._v(" "),_c('div',{staticClass:"add-funds-credit-card__avs-row"},[_c('div',{staticClass:"add-funds-credit-card__avs-city"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.city,"disabled":_vm.isFormDisabled,"name":"city","type":"text","required":true,"autocomplete":"address-line1","placeholder":"City"},on:{"input":_vm.$v.fields.city.$touch},model:{value:(_vm.fields.city),callback:function ($$v) {_vm.$set(_vm.fields, "city", $$v)},expression:"fields.city"}})],1),_vm._v(" "),_c('div',{staticClass:"add-funds-credit-card__avs-zip"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.zipCode,"disabled":_vm.isFormDisabled,"name":"zipCode","type":"text","required":true,"autocomplete":"postal-code","placeholder":"Zip/Postal Code"},on:{"input":_vm.$v.fields.zipCode.$touch},model:{value:(_vm.fields.zipCode),callback:function ($$v) {_vm.$set(_vm.fields, "zipCode", $$v)},expression:"fields.zipCode"}})],1)])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"add-funds-credit-card__line"}),_vm._v(" "),(_vm.isDepositPromoInputBoxEnabled)?[_c('div',{staticClass:"add-funds-credit-card__promo-section"},[_c('promo-code-input',{attrs:{"is-initial":_vm.promoInit,"is-loading":_vm.promoApplying,"is-applied":_vm.promoApplied,"has-error":_vm.promoHasError,"applied-code":_vm.promoAppliedCode,"applied-amount":_vm.promoBonus},on:{"initialised":_vm.onInitialisedPromoCode,"apply":_vm.onApplyPromoCode,"remove":_vm.onRemovePromoCode}})],1),_vm._v(" "),_c('div',{staticClass:"add-funds-credit-card__line"})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"add-funds-credit-card__submit"},[_c('form-submit',{attrs:{"label":"Review and Confirm","disabled":_vm.isConfirmDisabled}})],1)]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.isStep('CONFIRM'))?_c('div',{staticClass:"add-funds-credit-card__confirm"},[_c('div',{staticClass:"add-funds-credit-card__back",on:{"click":function($event){$event.preventDefault();return _vm.onBack($event)}}},[_c('span',{staticClass:"add-funds-credit-card__back-arrow"}),_vm._v(" "),_c('span',{staticClass:"add-funds-credit-card__back-label"},[_vm._v("BACK")])]),_vm._v(" "),_c('deposit-amount-overview',{attrs:{"amount":_vm.fields.amount}},[_c('template',{slot:"title"},[_vm._v("Deposit")]),_vm._v(" "),_c('template',{slot:"subtitle"},[_vm._v(_vm._s(_vm.cardMasked))])],2),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('deposit-info-overview',{staticClass:"add-funds-credit-card__overview",attrs:{"card-masked":_vm.cardMasked,"amount":_vm.fields.amount,"fee-percent":_vm.processingFeePercent,"fee-amount":_vm.processingFeeAmount,"was-fee-discount-applied":_vm.wasFeeDiscountApplied,"is-fee-waived":_vm.isFeeWaived || _vm.wasFeeDiscountApplied,"fee-free-amount":_vm.feeFreeAmount,"fee-cap":_vm.feeCap,"separate-credit-code":_vm.promoAppliedCode,"separate-credit-amount":_vm.promoApplied ? _vm.promoBonus : 0,"promotional-credit-amount":_vm.promotionalCreditAmount,"total-to-wallet":_vm.totalToWallet,"arrives-text":_vm.timeframeMsg || 'Instant'}}),_vm._v(" "),_c('div',{staticClass:"add-funds-credit-card__confirm-actions"},[_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"disabled":_vm.isConfirmDisabled},on:{"click":function($event){$event.preventDefault();return _vm.onSubmitDeposit($event)}}},[_vm._v("\n          Confirm Deposit\n        ")]),_vm._v(" "),_c('button',{staticClass:"button button--large button--inverted button--full-width",on:{"click":function($event){$event.preventDefault();return _vm.onBack($event)}}},[_vm._v("\n          Edit Amount\n        ")])])],1):_vm._e(),_vm._v(" "),(_vm.isStep('TRY_AGAIN'))?_c('deposit-result',[_c('template',{slot:"heading"},[_vm._v("\n        Deposit Failed\n      ")]),_vm._v(" "),_c('template',{slot:"icon"},[_c('img',{attrs:{"src":__webpack_require__("6StG"),"alt":"Payment failed"}})]),_vm._v(" "),_c('template',{slot:"body"},[_c('div',{staticClass:"add-funds-credit-card__fail-subtitle"},[_vm._v("\n          We couldn’t complete your deposit\n        ")]),_vm._v(" "),(_vm.errorMessageDepositFail)?_c('p',{staticClass:"add-funds-credit-card__fail-message",domProps:{"innerHTML":_vm._s(_vm.errorMessageDepositFail)}}):_c('p',{staticClass:"add-funds-credit-card__fail-message"},[_vm._v("No money has been released."),_c('br'),_vm._v(" Your card wasn't charged.")])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('button',{staticClass:"button button--large button--primary button--full-width",on:{"click":function($event){$event.preventDefault();return _vm.onBack($event)}}},[_vm._v("\n          Try Again\n        ")]),_vm._v(" "),_c('button',{staticClass:"button button--large button--full-width button--inverted",on:{"click":function($event){$event.preventDefault();return _vm.onUseDifferentCard($event)}}},[_vm._v("\n          Use a Different Card\n        ")])])],2):_vm._e(),_vm._v(" "),(_vm.isStep('SUCCESS'))?_c('deposit-result',[_c('template',{slot:"heading"},[_vm._v("\n        Deposit Successful\n      ")]),_vm._v(" "),_c('template',{slot:"icon"},[_c('img',{attrs:{"src":__webpack_require__("ha/Z"),"alt":"Deposit successful"}})]),_vm._v(" "),_c('template',{slot:"body"},[_c('div',{staticClass:"add-funds-credit-card__success-amount"},[_vm._v(_vm._s(_vm.successAmount))]),_vm._v(" "),_c('div',{staticClass:"add-funds-credit-card__success-subtitle"},[_vm._v("Added to your wallet")]),_vm._v(" "),_c('div',{staticClass:"add-funds-credit-card__success-note"},[_vm._v("Your funds are available now.")]),_vm._v(" "),_c('deposit-info-overview',{staticClass:"add-funds-credit-card__overview add-funds-credit-card__overview--full-margin",attrs:{"card-masked":_vm.cardMasked,"amount":_vm.fields.amount,"fee-percent":_vm.processingFeePercent,"fee-amount":_vm.processingFeeAmount,"was-fee-discount-applied":_vm.wasFeeDiscountApplied,"is-fee-waived":_vm.isFeeWaived || _vm.wasFeeDiscountApplied,"fee-free-amount":_vm.feeFreeAmount,"fee-cap":_vm.feeCap,"separate-credit-code":_vm.promoAppliedCode,"separate-credit-amount":_vm.promoApplied ? _vm.promoBonus : 0,"promotional-credit-amount":_vm.promotionalCreditAmount,"total-to-wallet":_vm.totalToWallet,"arrives-text":_vm.timeframeMsg || 'Instant'}})],1),_vm._v(" "),_c('template',{slot:"actions"},[_c('deposit-done-links',{attrs:{"show-pending-link":false},on:{"done":_vm.onSuccessDone}})],1)],2):_vm._e(),_vm._v(" "),(!_vm.errorMessage && !_vm.documentUploadInfoVisible)?_c('deposit-disclaimer',{attrs:{"disclaimer":_vm.disclaimer}}):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5jEk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_video_view_js__ = __webpack_require__("8ofP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f90ab0ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_view_vue__ = __webpack_require__("MnG9");
function injectStyle (ssrContext) {
  __webpack_require__("PSnM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_video_view_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f90ab0ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_view_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5jLI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo-code-input"},[(_vm.isInitial)?[_c('div',{staticClass:"promo-code-input__initial-row"},[_c('span',{staticClass:"promo-code-input__initial-row-label",on:{"click":function($event){return _vm.$emit('initialised')}}},[_vm._v("Have a promo code?")])])]:(_vm.isApplied)?[_c('div',{staticClass:"promo-code-input__applied-row"},[_c('div',{staticClass:"promo-code-input__applied-content"},[_c('span',{staticClass:"promo-code-input__applied-icon"}),_vm._v(" "),_c('span',{staticClass:"promo-code-input__applied-label"},[_vm._v("Code applied")]),_vm._v(" "),_c('span',{staticClass:"promo-code-input__badge",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onRemove($event)}}},[_vm._v("\n          "+_vm._s(_vm.appliedCode)+"\n          "),_c('button',{staticClass:"promo-code-input__remove-icon",attrs:{"type":"button"}})]),_vm._v(" "),_c('span',{staticClass:"promo-code-input__applied-amount"},[_vm._v("\n          +$"+_vm._s(_vm.appliedAmount)+"\n        ")])])])]:[_c('div',{staticClass:"promo-code-input__row-label"},[_vm._v("Promo code")]),_vm._v(" "),_c('div',{staticClass:"promo-code-input__row"},[_c('form-input',{staticClass:"promo-code-input__form-input",attrs:{"name":"promoCode","placeholder":"Enter code","disabled":_vm.isLoading,"validation":_vm.hasError ? { $error: true } : null},model:{value:(_vm.localCode),callback:function ($$v) {_vm.localCode=$$v},expression:"localCode"}}),_vm._v(" "),_c('button',{staticClass:"button button--inverted promo-code-input__apply-btn",attrs:{"type":"button","disabled":_vm.isLoading || !_vm.localCode.trim()},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onApply($event)}}},[(_vm.isLoading)?_c('span',{staticClass:"promo-code-input__spinner"}):_c('span',[_vm._v("Apply")])])],1),_vm._v(" "),(_vm.hasError)?_c('div',{staticClass:"promo-code-input__error"},[_c('svg',{staticClass:"promo-code-input__error-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12","width":"12","height":"12"}},[_c('circle',{attrs:{"cx":"6","cy":"6","r":"5.5","stroke":"currentColor","fill":"none"}}),_vm._v(" "),_c('line',{attrs:{"x1":"6","y1":"3.5","x2":"6","y2":"6.5","stroke":"currentColor","stroke-linecap":"round"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"6","cy":"8.5","r":"0.5","fill":"currentColor"}})]),_vm._v("\n      "+_vm._s(_vm.errorMessage)+"\n    ")]):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5n65":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_settings_modal_js__ = __webpack_require__("Vgn4");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09488ef8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_settings_modal_vue__ = __webpack_require__("f+P6");
function injectStyle (ssrContext) {
  __webpack_require__("pfo7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_settings_modal_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09488ef8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_settings_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5r1F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_bank_account_js__ = __webpack_require__("h/F2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78366694_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bank_account_vue__ = __webpack_require__("wLE9");
function injectStyle (ssrContext) {
  __webpack_require__("XaR5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_bank_account_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78366694_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bank_account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5v01":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-withdrawal-loader"},[_c('div',{staticClass:"account-withdrawal-loader__row account-withdrawal-loader__row--first"},[_c('div',{staticClass:"account-withdrawal-loader__row-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row-col-2"})]),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row"},[_c('div',{staticClass:"account-withdrawal-loader__row-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row-col-2"})]),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row"},[_c('div',{staticClass:"account-withdrawal-loader__row-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row-col-2"})]),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row"},[_c('div',{staticClass:"account-withdrawal-loader__row-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row-col-2"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5y3J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    colorDisabled: {
      type: String,
      default: '#263b1e'
    },
    color: {
      type: String,
      default: '#000000'
    },
    name: {
      type: String,
      required: true
    },
    checked: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: true
    };
  },

  computed: {
    classModifiers: function classModifiers() {
      return {
        'charts-checkbox': true,
        'charts-checkbox--checked': this.checked
      };
    },
    tickClassModifiers: function tickClassModifiers() {
      return {
        'charts-checkbox__tick': true,
        'charts-checkbox__tick--checked': this.checked
      };
    },
    styleModifiers: function styleModifiers() {
      return {
        'background-color': this.color
      };
    }
  },
  methods: {
    onChange: function onChange(e) {
      var _this = this;

      this.show = false;
      this.$emit('change', e.target.checked);
      setTimeout(function () {
        _this.show = true;
      }, 0);
    }
  }
});

/***/ }),

/***/ "5yVZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_vue__ = __webpack_require__("PUmN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_market_contract_horizontal_sushi_common_betslip_market_contract_horizontal_sushi_common_betslip_vue__ = __webpack_require__("M+zr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_contracts_list_header_sushi_market_contracts_list_header_sushi_vue__ = __webpack_require__("uN8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_dataLayer__ = __webpack_require__("k37b");








var NARROW_CONTAINER_WIDTH = 900;

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    openNewTab: {
      type: Boolean,
      default: false
    },
    market: {
      type: Object,
      required: true
    },
    trackingContext: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      isNarrowContainer: false,
      containerResizeObserver: null
    };
  },

  components: {
    marketContractHorizontalSushi: __WEBPACK_IMPORTED_MODULE_2__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_vue__["a" /* default */],
    marketContractHorizontalSushiMobile: __WEBPACK_IMPORTED_MODULE_3__components_market_market_contract_horizontal_sushi_common_betslip_market_contract_horizontal_sushi_common_betslip_vue__["a" /* default */],
    marketContractsListHeaderSushi: __WEBPACK_IMPORTED_MODULE_4__components_market_market_contracts_list_header_sushi_market_contracts_list_header_sushi_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('onboarding', ['showOnboardingStep']), {
    updateContainerLayoutMode: function updateContainerLayoutMode() {
      var containerWidth = this.$el ? this.$el.clientWidth : 0;
      this.isNarrowContainer = containerWidth > 0 && containerWidth < NARROW_CONTAINER_WIDTH;
    },
    teardownResizeObserver: function teardownResizeObserver() {
      if (this.containerResizeObserver) {
        this.containerResizeObserver.disconnect();
        this.containerResizeObserver = null;
      }
    },
    setupResizeObserver: function setupResizeObserver() {
      var _this = this;

      this.teardownResizeObserver();
      this.updateContainerLayoutMode();
      if (typeof ResizeObserver === 'undefined' || !this.$el) {
        return;
      }
      this.containerResizeObserver = new ResizeObserver(function () {
        _this.updateContainerLayoutMode();
      });
      this.containerResizeObserver.observe(this.$el);
    },
    onContractClick: function onContractClick(data) {
      var contractId = data.contractId,
          operationValue = data.operationValue;

      var no = operationValue === 'no' ? true : undefined;
      var route = {
        name: 'market-details',
        params: {
          marketId: this.market.marketId,
          marketUrl: this.market.marketUrl
        },
        query: {
          contractId: contractId,
          no: no
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_dataLayer__["d" /* pushStoryInteraction */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        interactionType: __WEBPACK_IMPORTED_MODULE_6__helpers_dataLayer__["e" /* INTERACTION_TYPE */].CONTRACT_CURRENT_PRICE_LIST
      }, this.trackingContext));
      if (!this.openNewTab || __WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__["h" /* isWrapperApp */]) {
        this.$router.push(route);
      } else {
        var resolved = this.$router.resolve(route);
        window.open(resolved.href, "_blank");
      }
    }
  }),
  mounted: function mounted() {
    this.setupResizeObserver();
  },
  beforeDestroy: function beforeDestroy() {
    this.teardownResizeObserver();
  }
});

/***/ }),

/***/ "61DT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_register_js__ = __webpack_require__("NSIw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a6be292_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_register_vue__ = __webpack_require__("Km0y");
function injectStyle (ssrContext) {
  __webpack_require__("//pC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_register_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a6be292_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "63Fj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

function set(key, value) {
  var data = {
    value: value
  };
  sessionStorage.setItem(key.toString(), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
}

function get(key, defaultValue) {
  try {
    var data = JSON.parse(sessionStorage.getItem(key.toString()));
    if (data !== null) {
      return data.value;
    }
  } catch (e) {
    sessionStorage.removeItem(key.toString());
  }
  return defaultValue || null;
}

function del(key) {
  sessionStorage.removeItem(key.toString());
}

/* harmony default export */ __webpack_exports__["a"] = ({
  set: set,
  get: get,
  del: del
});

/***/ }),

/***/ "6ALX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6Bn/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


function setSrc(el, binding) {
  el.setAttribute('src', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["E" /* getAssetPath */])(binding.value));
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    setSrc(el, binding);
  }
});

/***/ }),

/***/ "6DHL":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIzMSIgdmlld0JveD0iMCAwIDE0IDMxIj4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEzLjQzNiAxNS4xNTRIOS4yODR2MTUuMjEzSDIuOTkyVjE1LjE1NEgwVjkuODA4aDIuOTkydi0zLjQ2QzIuOTkyIDMuODc0IDQuMTY3IDAgOS4zNCAwTDE0IC4wMnY1LjE5aC0zLjM4MWMtLjU1NSAwLTEuMzM1LjI3Ni0xLjMzNSAxLjQ1NnYzLjE0N2g0LjcwMmwtLjU1IDUuMzQxeiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "6Fjk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_table_js__ = __webpack_require__("AZoq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e8121c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_table_vue__ = __webpack_require__("OFlW");
function injectStyle (ssrContext) {
  __webpack_require__("+oQ1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_table_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e8121c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6M/o":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "6Ngg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    content: String,
    isOpen: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    darkHeader: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'default'
    },
    accordion: {
      default: null
    },
    id: {
      default: null
    },
    canClose: {
      type: Boolean,
      default: true
    },
    showChevron: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      isOpenState: this.isOpen
    };
  },

  computed: {
    hasSlotTitle: function hasSlotTitle() {
      return !!this.$slots.title;
    },
    hasSlotContent: function hasSlotContent() {
      return !!this.$slots.default;
    },
    wrapperModifier: function wrapperModifier() {
      if (this.id !== null) {
        this.isOpenState = this.accordion === this.id;
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'collapsible-panel--no-chevron': !this.showChevron,
        'collapsible-panel--is-open': this.isOpenState
      }, 'collapsible-panel--theme-' + this.theme, true);
    },
    noPaddingModifier: function noPaddingModifier() {
      return {
        'collapsible-panel--no-padding': this.noPadding
      };
    },
    darkHeaderModifier: function darkHeaderModifier() {
      return {
        'collapsible-panel--dark-header': this.darkHeader
      };
    }
  },
  methods: {
    toggle: function toggle() {
      if (this.isOpenState === true && !this.canClose) return;

      this.isOpenState = !this.isOpenState;
      if (this.id !== null) {
        this.$emit('open', this.isOpenState ? this.id : null);
      } else {
        this.$emit('toggle', this.isOpenState);
      }
    }
  }
});

/***/ }),

/***/ "6StG":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "6WA/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-comment",on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.showUserDetails(_vm.comment)}}},[_c('div',{staticClass:"top-comment__avatar"},[_c('account-social-avatar',{attrs:{"avatar":_vm.comment.avatarImage,"showProgress":false,"percentage":100,"showEdit":false,"theme":"markets"}})],1),_vm._v(" "),_c('div',{staticClass:"top-comment__info"},[_c('div',{staticClass:"top-comment__name"},[_vm._v("\n        "+_vm._s(_vm.comment.userName)+"\n      ")]),_vm._v(" "),(_vm.comment.profitablePredictions)?_c('div',{staticClass:"top-comment__active"},[_vm._v("\n        "+_vm._s(_vm.traderLevelDisplay(_vm.comment))+"\n      ")]):_vm._e()])]),_vm._v(" "),(_vm.comment.marketTitle)?_c('div',{staticClass:"top-comment__market",domProps:{"innerHTML":_vm._s(_vm.comment.marketTitle)}}):_vm._e(),_vm._v(" "),_c('div',{ref:"text",staticClass:"top-comment__comment",domProps:{"innerHTML":_vm._s(_vm.comment.comment)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6X+t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"close-button",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.close($event)}}},[(!_vm.isDark)?_c('img',{attrs:{"src":__webpack_require__("srjS"),"alt":"Close"}}):_vm._e(),_vm._v(" "),(_vm.isDark)?_c('img',{attrs:{"src":__webpack_require__("gJ7L"),"alt":"Close"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Zmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BRAND */
var BRAND = 'PredictIt';

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      brand: BRAND
    };
  }
});

/***/ }),

/***/ "6b6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-container"},[_vm._t("parallax-bg"),_vm._v(" "),_c('div',{class:_vm.defaultSwiperClasses.wrapperClass},[_vm._t("default")],2),_vm._v(" "),_vm._t("pagination"),_vm._v(" "),_vm._t("button-prev"),_vm._v(" "),_vm._t("button-next"),_vm._v(" "),_vm._t("scrollbar")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6iaa":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDI0IDE3Ij4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojMDdhMGJiO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDt9Cgkuc3Qxe2ZpbGw6bm9uZTtzdHJva2U6IzA3YTBiYjtzdHJva2Utd2lkdGg6MjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7fQoJLnN0MntmaWxsOm5vbmU7c3Ryb2tlOiMwN2EwYmI7c3Ryb2tlLXdpZHRoOjI7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQo8L3N0eWxlPgoKICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjMDdhMGJiIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxwYXRoIGQ9Ik0xNC42MTkgOC41YzAgMS40OC0xLjE3MyAyLjY3OS0yLjYxOSAyLjY3OS0xLjQ0NiAwLTIuNjE5LTEuMi0yLjYxOS0yLjY3OSAwLTEuNDggMS4xNzMtMi42NzkgMi42MTktMi42NzkgMS40NDYgMCAyLjYxOSAxLjIgMi42MTkgMi42Nzl6Ii8+CiAgICAgICAgPHBhdGggc3Ryb2tlLXdpZHRoPSIyIiBkPSJNMSA4LjVDMi41NyA0LjMyNiA3Ljg1IDEgMTIuMDIgMVMyMS4zOCA0LjI3IDIzIDguMzk2TTEgOC41QzIuNTcgMTIuNjc0IDcuODUgMTYgMTIuMDIgMTZTMjEuMzggMTIuNzMgMjMgOC42MDQiLz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "6iuM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "7DOx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"captcha",staticClass:"captcha"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7DQ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_settings_option_js__ = __webpack_require__("mThu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5169a6d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_option_vue__ = __webpack_require__("8rDO");
function injectStyle (ssrContext) {
  __webpack_require__("Ivs/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_settings_option_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5169a6d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_option_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7GI3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_combined_login_js__ = __webpack_require__("nlkt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fdc7702_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_combined_login_vue__ = __webpack_require__("FUh1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_combined_login_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fdc7702_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_combined_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7IYw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_fee_status_message_js__ = __webpack_require__("xz2f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_741ef679_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fee_status_message_vue__ = __webpack_require__("hL+e");
function injectStyle (ssrContext) {
  __webpack_require__("4uR/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_fee_status_message_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_741ef679_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fee_status_message_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7JgB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_vm._m(0),_vm._v(" "),(_vm.isPending)?[(_vm.isCard)?[_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n        Your identification documents are under review. We will notify you by email regarding your status within 72 hours of submission. You will be able to deposit funds once your identity has been confirmed.\n      ")]),_vm._v(" "),(false)?_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n        Don’t want to wait? Try Online Banking instead. No document upload required. Start trading now!\n      ")]):_vm._e()]:(_vm.isPopup)?_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n      Your identification documents are under review. We will notify you by email regarding your status within 72 hours of submission. You will be able to deposit funds once your identify has been confirmed. Thank you for your patience.\n    ")]):_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n      Your identification documents are under review. We will notify you by email regarding your status within 72 hours of submission. You will be able to deposit funds once your identify has been confirmed. Thank you for your patience.\n    ")])]:[(_vm.isCard)?[_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n        To use a credit card, PredictIt requires all traders to upload a proof of identity document. We will then review the document as quickly as possible so that you can start trading.\n      ")]),_vm._v(" "),(false)?_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n        Don’t want to wait? Try Online Banking instead. No document upload required. Start trading now!\n      ")]):_vm._e()]:(_vm.isPopup)?_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n      We are required to collect further documentation in order to process your transaction. Please click to upload an identity document.\n    ")]):_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n      We are required to collect documentation in order to process further deposits or withdrawals. Please click to upload an identity document.\n    ")]),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width",on:{"click":function($event){$event.preventDefault();return _vm.onButtonClick($event)}}},[_vm._v("\n      Upload Document\n    ")])]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-upload-document__icon"},[_c('img',{attrs:{"src":__webpack_require__("xgaP")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7P0N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.brand))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7P8z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.hasServerMessage)?[(_vm.maintenance.suspendedMessage)?_c('div',{staticClass:"app-header-notification app-header-notification--with-close app-header-notification--not-clickable"},[_c('div',{staticClass:"app-header-notification__content",domProps:{"innerHTML":_vm._s(_vm.maintenanceMessageText)}})]):(_vm.maintenance.systemMessage)?_c('div',{staticClass:"app-header-notification app-header-notification--with-close app-header-notification--system",on:{"click":function($event){$event.stopPropagation();return _vm.onSystemMessageClick($event)}}},[_c('div',{staticClass:"app-header-notification__content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.maintenanceMessageText)}}),_vm._v(" "),_c('div',{staticClass:"app-header-notification__close",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onCloseMaintenanceMessage($event)}}},[_c('div',{staticClass:"app-header-notification__close-icon"})])])]):_vm._e()]:(_vm.liveUpdatesDisabled)?_c('div',{staticClass:"app-header-notification app-header-notification--system",on:{"click":function($event){$event.stopPropagation();return _vm.onErrorClick($event)}}},[_c('div',{staticClass:"app-header-notification__content"},[_vm._v("\n      Due to page inactivity, live updates, including account balance, have been disabled on this page. To re-enable live updates please refresh the page.\n    ")])]):(_vm.showErrorNotification)?_c('div',{staticClass:"app-header-notification",on:{"click":function($event){$event.stopPropagation();return _vm.onErrorClick($event)}}},[_vm._m(0)]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-header-notification__content"},[_vm._v("\n      An error has occurred.\n      Click "),_c('a',{staticClass:"app-header-notification__link",attrs:{"href":"#"}},[_vm._v("here")]),_vm._v(" to reload the page.\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7RdL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.loading)?_c('div',{staticClass:"twittertimeline__spinner"}):_vm._e(),_vm._v(" "),_c('div',{class:_vm.contentClassModifiers},[_c('div',{ref:"init",class:_vm.initClassModifiers})]),_vm._v(" "),(_vm.showFooter)?_c('div',{staticClass:"twittertimeline__footer"},[_c('div',{staticClass:"twittertimeline__more-button",on:{"click":_vm.onFooterMoreButtonClick}},[_vm._v("\n      "+_vm._s(_vm.getMoreTweetsLabel)+"\n    ")])]):_vm._e(),_vm._v(" "),_c('div',{ref:"more",staticClass:"twittertimeline__content"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7WHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_preview_carousel_js__ = __webpack_require__("oV6X");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41091ed2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preview_carousel_vue__ = __webpack_require__("52iG");
function injectStyle (ssrContext) {
  __webpack_require__("KAwH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_preview_carousel_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41091ed2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preview_carousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Wq7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__top_comment_top_comment_vue__ = __webpack_require__("bFAx");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    widget: Object
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_loader__["a" /* default */]],
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"],
    topComment: __WEBPACK_IMPORTED_MODULE_2__top_comment_top_comment_vue__["a" /* default */]
  },
  data: function data() {
    var _this = this;

    return {
      rightDis: false,
      leftDis: true,
      swiperOptions: {
        spaceBetween: 0,
        autoplay: 10 * 1000,
        slidesPerColumn: 1,
        loop: true,
        direction: 'horizontal',
        onTransitionStart: function onTransitionStart(swp) {
          var ax = swp.activeIndex % _this.lastIndex;
          _this.leftDis = ax === 1;
          _this.rightDis = ax === 0;
        }
      }
    };
  },

  computed: {
    obj: function obj() {
      return !this.widget ? {} : this.widget;
    },
    items: function items() {
      return this.widget.widgetTopComments || [];
    },
    lastIndex: function lastIndex() {
      return this.items.length;
    },
    prevArrowModifiers: function prevArrowModifiers() {
      return {
        'market-top-comments__arrow': true,
        'market-top-comments__arrow--left': true
      };
    },
    nextArrowModifiers: function nextArrowModifiers() {
      return {
        'market-top-comments__arrow': true,
        'market-top-comments__arrow--right': true
      };
    }
  },
  methods: {
    prevSlide: function prevSlide() {
      this.$refs.swiper.swiper.slidePrev();
    },
    nextSlide: function nextSlide() {
      this.$refs.swiper.swiper.slideNext();
    }
  },
  watch: {
    widget: function widget(val) {
      if (val) {
        this.loaderRemove();
      }
    }
  },
  mounted: function mounted() {
    if (!this.widget) {
      this.loaderAdd();
    }
  }
});

/***/ }),

/***/ "7Ymm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    theme: {
      type: String,
      default: ''
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'market-widget-loader': true
      }, 'market-widget-loader--' + this.theme, this.theme);
    }
  })
});

/***/ }),

/***/ "7aYA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7fpX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__("c/9r");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    hideDelay: {
      type: Number,
      default: 300
    }
  },
  data: function data() {
    return {
      isVisible: false,
      hideTimeout: null,
      watchdogTimeout: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['newLoaderCounter']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['newLoaderIsLoading'])),
  watch: {
    newLoaderIsLoading: {
      handler: 'newLoaderIsLoadingHandler',
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isVisible) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["c" /* unlockScroll */])();
    }
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
    if (this.watchdogTimeout) {
      clearTimeout(this.watchdogTimeout);
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['resetLoaderCounter']), {
    newLoaderIsLoadingHandler: function newLoaderIsLoadingHandler(value) {
      if (value) {
        this.showLoader();
      } else {
        this.hideLoader();
      }
    },
    showLoader: function showLoader() {
      var _this = this;

      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      if (this.watchdogTimeout) {
        clearTimeout(this.watchdogTimeout);
      }
      this.watchdogTimeout = setTimeout(function () {
        _this.resetLoaderCounter();
      }, 5000);

      if (!this.isVisible) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["d" /* lockScroll */])();
      }

      this.isVisible = true;
    },
    hideLoader: function hideLoader() {
      var _this2 = this;

      if (this.watchdogTimeout) {
        clearTimeout(this.watchdogTimeout);
      }
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
      }
      this.hideTimeout = setTimeout(function () {
        if (_this2.isVisible) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["c" /* unlockScroll */])();
        }
        _this2.isVisible = false;
        _this2.hideTimeout = null;
      }, this.hideDelay);
    }
  })
});

/***/ }),

/***/ "7lSu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7okt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_generic_js__ = __webpack_require__("DFsO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3635d095_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_vue__ = __webpack_require__("LkCa");
function injectStyle (ssrContext) {
  __webpack_require__("ZBib")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_generic_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3635d095_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7trC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_onboarding_document_to_review_document_to_review_vue__ = __webpack_require__("e0++");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    documentData: {
      type: Object,
      required: true
    }
  },
  components: {
    documentToReview: __WEBPACK_IMPORTED_MODULE_0__components_onboarding_document_to_review_document_to_review_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "7wmZ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTEuMTYgOC44NjNoMy4xMzl2Ni42MDFIMS4xNnpNMTQuNjkxIDEyLjI3NGgzLjEzOXYzLjE5MWgtMy4xMzl6Ii8+CiAgICAgICAgPHRleHQgZmlsbD0iIzY3OTk5RiIgZm9udC1mYW1pbHk9IlJvYm90by1Cb2xkLCBSb2JvdG8iIGZvbnQtc2l6ZT0iMTIiIGZvbnQtd2VpZ2h0PSJib2xkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDEpIj4KICAgICAgICAgICAgPHRzcGFuIHg9IjE0LjA4IiB5PSIxNCI+wqI8L3RzcGFuPgogICAgICAgIDwvdGV4dD4KICAgICAgICA8cGF0aCBmaWxsPSIjNjc5OTlGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xOC40MSAxOEguNThjLS4zMiAwLS41OC4yNjQtLjU4LjU5IDAgLjMyNS4yNi41OS41OC41OWgxNy44M2MuMzIgMCAuNTgtLjI2NS41OC0uNTkgMC0uMzI2LS4yNi0uNTktLjU4LS41OXoiLz4KICAgICAgICA8cGF0aCBzdHJva2U9IiM2Nzk5OUYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiIGQ9Ik0xIDE0bDUtNyA1IDQgNi41MTMtOS41MTMiLz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "8/3H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = checkResponseForMaintenance;
/* harmony export (immutable) */ __webpack_exports__["c"] = checkResponseForTaxInfo;
/* harmony export (immutable) */ __webpack_exports__["d"] = checkResponseForDocumentUpload;
/* harmony export (immutable) */ __webpack_exports__["a"] = checkResponseForApiGoingOffline;
/* harmony export (immutable) */ __webpack_exports__["e"] = checkResponseVersion;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some__ = __webpack_require__("mGzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__("JDN0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");






var TAX_INFO_STATUS_CODE = 403;
var TAX_INFO_MESSAGE_CODE = 'requireTax1099Redirect';

var DOCUMENT_UPLOAD_SKIP_POPUP_URLS = ['Wallet/DepositCard', 'Wallet/ConfirmDepositCard', 'Wallet/SubmitDepositCard', 'Wallet/WithdrawAch', 'Wallet/WithdrawCheck', 'Wallet/DepositUSDCoin', 'Wallet/WithdrawWire', 'Wallet/WithdrawUSDC', 'Wallet/DepositPWMB'];

function checkResponseForMaintenance(response) {
  var maintenanceMessage = response.headers['pi-maintenancemessage'];
  var suspendedMessage = response.headers['pi-tradingsuspendedmessage'];
  var systemMessage = response.headers['pi-systemmessages'];

  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('app/setMaintenance', {
    isMaintenanceEnabled: typeof maintenanceMessage !== 'undefined',
    isTradingEnabled: typeof maintenanceMessage === 'undefined',
    maintenanceMessage: maintenanceMessage || '',
    suspendedMessage: suspendedMessage || '',
    systemMessage: systemMessage || ''
  });
}

function checkResponseForTaxInfo(response) {
  if (!(response.status === TAX_INFO_STATUS_CODE && response.data.code && response.data.code === TAX_INFO_MESSAGE_CODE)) return;
  setTimeout(function () {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_modals_constants__["a" /* MODALS */].TAX_INFO);
  }, 1000);
}

function checkResponseForDocumentUpload(response) {
  var dontAct = response.config.method.toLowerCase() === 'get' && __WEBPACK_IMPORTED_MODULE_0_lodash_some___default()(DOCUMENT_UPLOAD_SKIP_POPUP_URLS, function (x) {
    return response.config.url.includes(x);
  });

  if (!(response.data.duRequired || response.data.duPending) || dontAct) return;

  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_modals_constants__["a" /* MODALS */].UPLOAD_DOCUMENT);
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('popup/setCurrentPopupOptions', {
    isPending: !!response.data.duPending,
    source: response.data.duSource
  });
}

function checkResponseForApiGoingOffline(response) {
  if (!(response.data && __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(response.data) && response.data.includes('MaintenanceMessage'))) return;
  // When error response includes MaintenanceMessage redirect to home
  // This situation means API is offline
  window.location.href = "/";
}

function checkResponseVersion(response) {
  var version = response.headers['x-version'];
  if (!version) return;
  if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.app.initialVersion === null) {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('app/setInitialVersion', version);
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('app/setServerVersion', version);
    return;
  }
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('app/confirmServerVersion', version);
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  checkResponseForMaintenance: checkResponseForMaintenance,
  checkResponseForTaxInfo: checkResponseForTaxInfo,
  checkResponseForApiGoingOffline: checkResponseForApiGoingOffline,
  checkResponseVersion: checkResponseVersion
});

/***/ }),

/***/ "87t0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"notification-item-trade-confirmed__content"},[_c('div',{staticClass:"notification-item-trade-confirmed__container"},[_c('div',{staticClass:"notification-item-trade-confirmed__icon"},[(_vm.isProcessedOrMatched)?_c('img',{attrs:{"src":__webpack_require__("uDSN")}}):_c('img',{attrs:{"src":__webpack_require__("U+El")}})]),_vm._v(" "),_c('h4',{staticClass:"notification-item-trade-confirmed__title"},[_vm._v(_vm._s(_vm.offerStatusLongText))]),_vm._v(" "),(_vm.showAutoCloseLoader)?_c('div',{staticClass:"notification-item-trade-confirmed__loader",style:({ '--close-timeout': (_vm.closeTimeout + "ms") })},[_c('svg',{attrs:{"width":"32","height":"32","viewBox":"0 0 32 32"}},[_c('circle',{staticClass:"notification-item-trade-confirmed__loader-ring",attrs:{"cx":"16","cy":"16","r":"13"}})])]):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.closeButton),expression:"closeButton"}],staticClass:"notification-item-trade-confirmed__close",on:{"click":_vm.onClose}})]),_vm._v(" "),_c('div',{staticClass:"notification-item-trade-confirmed__container notification-item-trade-confirmed__container--simple"},[_c('div',{staticClass:"notification-item-trade-confirmed__market"},[_vm._v("\n        "+_vm._s(_vm.marketName)+"\n      ")])]),_vm._v(" "),(_vm.showHistory)?_c('div',_vm._l((_vm.history),function(stock){return _c('div',{staticClass:"row notification-item-trade-confirmed__container notification-item-trade-confirmed__container--simple"},[_c('div',{staticClass:"notification-item-trade-confirmed__info"},[_c('div',[_vm._v("\n            "+_vm._s(_vm.soldOrBoughtText(stock.TradeType))+"\n            "),_c('span',[_vm._v(_vm._s(stock.Quantity)+" "+_vm._s(_vm.yesNoText(stock.TradeType)))]),_vm._v(" "),(!_vm.isMarketSingle)?_c('span',{staticClass:"notification-item-trade-confirmed__contract"},[_vm._v("\n              in "),_c('span',{directives:[{name:"contract-name",rawName:"v-contract-name"}]},[_vm._v(_vm._s(_vm.contractName))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"notification-item-trade-confirmed__min-price"},[_vm._v("\n              at "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(stock.PricePerShare),expression:"stock.PricePerShare",modifiers:{"cents":true}}]})])])])])}),0):_vm._e(),_vm._v(" "),(_vm.showCashFooter)?_c('div',{staticClass:"notification-item-trade-confirmed__container notification-item-trade-confirmed__container--footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6 text-left"},[(_vm.showProfitLoss)?_c('div',[_vm._v("\n            "+_vm._s(_vm.profitOrLossText)+": "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.profit),expression:"profit",modifiers:{"fixed3":true}}]})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column small-6 text-right"},[(_vm.showFees)?_c('div',[_vm._v("\n            Fees: "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.fee),expression:"fee",modifiers:{"fixed3":true}}]})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.offerId && _vm.dateCreated)?[_c('div',{staticClass:"column small-12"},[_c('div',[_vm._v("\n              Date: "+_vm._s(_vm.dateCreated)+"\n            ")])])]:_vm._e(),_vm._v(" "),(_vm.offerId)?[_c('div',{staticClass:"column small-6 text-left"},[_c('div',[_vm._v("\n              Confirmation: "+_vm._s(_vm._f("base32")(_vm.offerId))+"\n            ")])]),_vm._v(" "),_vm._m(0)]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"column small-6 text-left"},[(_vm.showRisk)?_c('div',[_vm._v("\n            Risk Adj.: "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.risk),expression:"risk",modifiers:{"fixed3":true}}]})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column small-6 text-right"},[_c('div',[_c('strong',[_c('plus-minus-sign'),_vm._v(" Cash: "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.cost),expression:"cost",modifiers:{"fixed3":true}}]})],1)])])],2)]):(_vm.showOpenOfferRecordedFooter && _vm.offerId)?_c('div',{staticClass:"notification-item-trade-confirmed__container notification-item-trade-confirmed__container--footer"},[_c('div',{staticClass:"row"},[(_vm.dateCreated)?[_c('div',{staticClass:"column small-12"},[_c('div',[_vm._v("\n              Date: "+_vm._s(_vm.dateCreated)+"\n            ")])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"column small-6 text-left"},[_c('div',[_vm._v("\n            Confirmation: "+_vm._s(_vm._f("base32")(_vm.offerId))+"\n          ")])]),_vm._v(" "),_vm._m(1)],2)]):_vm._e(),_vm._v(" "),(_vm.remainingQuantity > 0)?_c('div',{class:_vm.bottomContainerClassModifiers},[(false)?_c('div',{staticClass:"notification-item-trade-confirmed__icon"},[_c('img',{attrs:{"src":require("assets/icons/pending-large.svg")}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"notification-item-trade-confirmed__info"},[_c('div',[_vm._v("\n          "+_vm._s(_vm.soldOrBoughtTextOffer())+"\n          "),_c('span',[_vm._v(_vm._s(_vm.remainingQuantity)+" "+_vm._s(_vm.yesNoText(_vm.offerType)))]),_vm._v(" "),(!_vm.isMarketSingle)?_c('span',{staticClass:"notification-item-trade-confirmed__contract"},[_vm._v("\n            in "),_c('span',{directives:[{name:"contract-name",rawName:"v-contract-name"}]},[_vm._v(_vm._s(_vm.contractName))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"notification-item-trade-confirmed__min-price"},[_vm._v("\n            at "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.minPrice),expression:"minPrice",modifiers:{"cents":true}}]})])])])]):_vm._e(),_vm._v(" "),(_vm.showFooter)?_c('div',{staticClass:"notification-item-trade-confirmed__footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6"},[(_vm.showToggle)?_c('div',{staticClass:"notification-item-trade-confirmed__toggle",on:{"click":_vm.onToggle}},[(_vm.advanced)?[_vm._v("Hide")]:[_vm._v("Details")]],2):_c('div',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"column small-6 text-right notification-item-trade-confirmed__share"},[_c('div',{staticClass:"notification-item-trade-confirmed__share-buttons"},[_c('a',{staticClass:"notification-item-trade-confirmed__share-link notification-item-trade-confirmed__share-link--x",on:{"click":function($event){$event.preventDefault();return _vm.onTwitterShare($event)}}}),_vm._v(" "),_c('a',{staticClass:"notification-item-trade-confirmed__share-link notification-item-trade-confirmed__share-link--facebook",on:{"click":function($event){$event.preventDefault();return _vm.onFacebookShare($event)}}}),_vm._v(" "),(!_vm.isWrapperApp)?_c('a',{staticClass:"notification-item-trade-confirmed__share-link notification-item-trade-confirmed__share-link--email",attrs:{"href":_vm.mailto},on:{"click":_vm.onEmailShare}}):_vm._e()])])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-6 text-right"},[_c('div',[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-6 text-right"},[_c('div',[_vm._v(" ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8EqH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8KbT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_how_it_works_old_market_svg__ = __webpack_require__("K0uo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_how_it_works_old_market_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_icons_how_it_works_old_market_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_how_it_works_old_prediction_svg__ = __webpack_require__("LmU5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_how_it_works_old_prediction_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_icons_how_it_works_old_prediction_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_how_it_works_old_shares_svg__ = __webpack_require__("htEh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_how_it_works_old_shares_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_icons_how_it_works_old_shares_svg__);






/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isShutdownModeOn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isUserRestricted']), {
    items: function items() {
      if (this.isShutdownModeOn) {
        return [{
          title: 'Browsing Questions',
          description: 'Markets offer a range of questions for traders to test their skills.',
          icon: __WEBPACK_IMPORTED_MODULE_2__assets_icons_how_it_works_old_market_svg___default.a
        }, {
          title: 'Making Predictions',
          description: 'Traders make predictions by buying and selling shares in potential outcomes.',
          icon: __WEBPACK_IMPORTED_MODULE_3__assets_icons_how_it_works_old_prediction_svg___default.a
        }, {
          title: 'Trading Shares',
          description: 'Prices will rise and fall with political events, giving traders the opportunity to cash in shares for a profit.',
          icon: __WEBPACK_IMPORTED_MODULE_4__assets_icons_how_it_works_old_shares_svg___default.a
        }];
      }
      return [{
        title: 'Browse Markets',
        description: 'Check out the range of available markets on which you can try and predict the outcome.',
        icon: __WEBPACK_IMPORTED_MODULE_2__assets_icons_how_it_works_old_market_svg___default.a
      }, {
        title: 'Make A Prediction',
        description: 'Think everyone’s got it wrong? Put your money where your mouth is and buy shares for or against an event taking place.',
        icon: __WEBPACK_IMPORTED_MODULE_3__assets_icons_how_it_works_old_prediction_svg___default.a
      }, {
        title: 'Trade Your Shares',
        description: 'Buy your shares low and sell them high once the crowd figures out you were right.',
        icon: __WEBPACK_IMPORTED_MODULE_4__assets_icons_how_it_works_old_shares_svg___default.a
      }];
    }
  })
});

/***/ }),

/***/ "8V4D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8YSH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountFormLoader_vue__ = __webpack_require__("h1Ye");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d4c8682_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountFormLoader_vue__ = __webpack_require__("bBr+");
function injectStyle (ssrContext) {
  __webpack_require__("U2mR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountFormLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d4c8682_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountFormLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8hek":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_js__ = __webpack_require__("bYWr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d067a66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__ = __webpack_require__("dSDn");
function injectStyle (ssrContext) {
  __webpack_require__("4v//")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d067a66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8mrx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TIME_OPTIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api__ = __webpack_require__("H/Zg");






var DEFAULT_LOAD_LEADERBOARD = {
  data: [],
  trader: null,
  page: 0,
  totalCount: 0,
  canLoadMore: true
};

var TIME_OPTIONS = {
  PAST_WEEK: { label: 'Past Week', value: 7 },
  PAST_MONTH: { label: 'Past Month', value: 30 },
  PAST_YEAR: { label: 'Past Year', value: 365 }
};

/* harmony default export */ __webpack_exports__["b"] = ({
  namespaced: true,
  state: {
    selectedLeaderboardId: null,
    playerLeaderboards: [],
    leaderboards: [],
    leaderboardsResults: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_LOAD_LEADERBOARD),
    leaderboardsDateRange: TIME_OPTIONS.PAST_WEEK.value
  },
  getters: {
    selectedLeaderboard: function selectedLeaderboard(state) {
      return state.leaderboards.find(function (i) {
        return i.leaderBoardId === state.selectedLeaderboardId;
      });
    }
  },
  mutations: {
    setSelectedLeaderboardId: function setSelectedLeaderboardId(state, data) {
      state.selectedLeaderboardId = data;
    },
    setPlayerLeaderboards: function setPlayerLeaderboards(state, data) {
      state.playerLeaderboards = data;
    },
    setLeaderboards: function setLeaderboards(state, data) {
      state.leaderboards = data;
    },
    clearSelectedLeaderboardId: function clearSelectedLeaderboardId(state) {
      state.selectedLeaderboardId = null;
    },
    resetLeaderboardsResults: function resetLeaderboardsResults(state) {
      state.leaderboardsResults = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_LOAD_LEADERBOARD);
    },
    setLeaderboardsResults: function setLeaderboardsResults(state, payload) {
      var sourceData = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.leaderboardsResults.data));
      var data = sourceData.concat(payload.data.traders || []);
      var page = payload.data.page;
      var totalCount = payload.data.totalTraders;
      var canLoadMore = totalCount > data.length;

      state.leaderboardsResults = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.leaderboardsResults, {
        trader: payload.data.trader,
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    setLeaderboardsDateRange: function setLeaderboardsDateRange(state, data) {
      state.leaderboardsDateRange = data;
    },
    resetLeaderboardsDateRange: function resetLeaderboardsDateRange(state) {
      state.leaderboardsDateRange = TIME_OPTIONS.PAST_WEEK.value;
    }
  },
  actions: {
    getLeaderboardsResults: function getLeaderboardsResults(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      if (state.selectedLeaderboardId !== null && state.leaderboardsResults.canLoadMore) {
        var page = state.leaderboardsResults.page + 1;
        return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].leaderboards.getLeaderboard({
          dateRange: state.leaderboardsDateRange,
          id: state.selectedLeaderboardId,
          page: page
        }).then(function (response) {
          commit('setLeaderboardsResults', {
            page: page,
            data: response.data
          });
          return response.data;
        });
      }
      return null;
    },
    getLeaderboards: function getLeaderboards(_ref2) {
      var state = _ref2.state,
          commit = _ref2.commit;

      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref3$cache = _ref3.cache,
          cache = _ref3$cache === undefined ? true : _ref3$cache;

      if (cache && state.leaderboards.length > 0) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.leaderboards);
      }
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].leaderboards.getLeaderboards().then(function (response) {
        commit('setLeaderboards', response.data);
        return response.data;
      });
    },
    getPlayerLeaderboards: function getPlayerLeaderboards(_ref4) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].leaderboards.getPlayerLeaderboards().then(function (response) {
        commit('setPlayerLeaderboards', response.data);
        return response.data;
      });
    },
    setSelectedLeaderboardId: function setSelectedLeaderboardId(_ref5, data) {
      var commit = _ref5.commit;

      commit('setSelectedLeaderboardId', data);
    },
    clearSelectedLeaderboardId: function clearSelectedLeaderboardId(_ref6) {
      var commit = _ref6.commit;

      commit('clearSelectedLeaderboardId');
    },
    resetLeaderboardsResults: function resetLeaderboardsResults(_ref7) {
      var commit = _ref7.commit;

      commit('resetLeaderboardsResults');
    },
    setLeaderboardsDateRange: function setLeaderboardsDateRange(_ref8, data) {
      var commit = _ref8.commit;

      commit('setLeaderboardsDateRange', data);
    },
    resetLeaderboardsDateRange: function resetLeaderboardsDateRange(_ref9) {
      var commit = _ref9.commit;

      commit('resetLeaderboardsDateRange');
    }
  }
});

/***/ }),

/***/ "8ofP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__("JDN0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_youtube_embed__ = __webpack_require__("5/be");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_dataLayer__ = __webpack_require__("k37b");






var VIDEO_PLAY_THRESHOLD_MS = 10000;

var SOURCES = {
  YOUTUBE: 1,
  VIMEO: 2
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    autoPlay: {},
    loop: {},
    mute: {},
    source: {},
    startTime: {},
    videoUrl: {},
    maxHeight: {},
    trackingContext: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      playedThresholdTimer: null,
      hasFiredPlay: false
    };
  },

  computed: {
    classModifiers: function classModifiers() {
      return {
        'video-view': true,
        'video-view--responsive': !this.playerHeight
      };
    },
    isYoutube: function isYoutube() {
      return this.source === SOURCES.YOUTUBE;
    },
    isVimeo: function isVimeo() {
      return this.source === SOURCES.VIMEO;
    },
    youtubeVideoId: function youtubeVideoId() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vue_youtube_embed__["b" /* getIdFromURL */])(this.videoUrl);
    },
    youtubePlayerVars: function youtubePlayerVars() {
      return {
        rel: 0,
        start: this.startTime,
        autoplay: this.autoPlay ? 1 : 0
      };
    },
    playerHeight: function playerHeight() {
      if (this.maxHeight) {
        return this.maxHeight;
      }
      return undefined;
    },
    playerWidth: function playerWidth() {
      if (!this.playerHeight) {
        return '100%';
      }
      var height = __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(this.playerHeight) && this.playerHeight.endsWith('px') ? Number(this.playerHeight.replace('px', '').trim()) : this.playerHeight;
      var ratio = this.isVimeo ? 2 : 1.78;
      return height * ratio;
    },
    vimeoVideoId: function vimeoVideoId() {
      return (/(vimeo(pro)?\.com)\/(?:[^\d]+)?(\d+)\??(.*)?$/.exec(this.videoUrl)[3]
      );
    },
    vimeoPlayerVars: function vimeoPlayerVars() {
      var params = {
        responsive: !this.playerHeight,
        muted: this.mute,
        start_time: this.startTime
      };
      return params;
    }
  },
  methods: {
    youtubeEnded: function youtubeEnded() {
      if (this.loop && this.$refs.youtubePlayer) {
        this.$refs.youtubePlayer.player.seekTo(0);
      }
    },
    onPlaying: function onPlaying() {
      var _this = this;

      if (this.hasFiredPlay || this.playedThresholdTimer || !this.trackingContext.storyId) return;
      this.playedThresholdTimer = setTimeout(function () {
        _this.hasFiredPlay = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_dataLayer__["d" /* pushStoryInteraction */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ interactionType: __WEBPACK_IMPORTED_MODULE_3__helpers_dataLayer__["e" /* INTERACTION_TYPE */].VIDEO_PLAY }, _this.trackingContext));
      }, VIDEO_PLAY_THRESHOLD_MS);
    },
    onPaused: function onPaused() {
      if (this.playedThresholdTimer) {
        clearTimeout(this.playedThresholdTimer);
        this.playedThresholdTimer = null;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.playedThresholdTimer) {
      clearTimeout(this.playedThresholdTimer);
      this.playedThresholdTimer = null;
    }
  }
});

/***/ }),

/***/ "8p/V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UX_OPTIONS_BUTTON_COLOR_SCHEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UX_OPTIONS_PRICE_MOBILE_CONTRACT_LAYOUT; });
/* unused harmony export UX_OPTIONS_PRICE_DISPLAY */
/* unused harmony export UX_OPTIONS_MOBILE_ORDERBOOK_DISPLAY */
/* unused harmony export UX_OPTIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UX_OPTIONS_WITHOUT_MOBILE_ORDERBOOK_SETTING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_checkbox_checkbox_vue__ = __webpack_require__("vXhB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_profile_profile_vue__ = __webpack_require__("lmGd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generics_switch_button_switch_button_vue__ = __webpack_require__("ed4I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_externalLinks__ = __webpack_require__("ys9T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_account_account_desktop_header_account_desktop_header_vue__ = __webpack_require__("Tp6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__settings_option_settings_option_vue__ = __webpack_require__("7DQ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__settings_option_switch_settings_option_switch_vue__ = __webpack_require__("OdBi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__check_option_check_option_vue__ = __webpack_require__("9zdy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__security_settings_security_settings_vue__ = __webpack_require__("lyr+");


/* eslint-disable no-console */


















var PROVIDER_FACEBOOK = 'Facebook';
var PROVIDER_TWITTER = 'Twitter';
var PROVIDER_GOOGLE = 'Google';

var optionPush = {
  key: 'AllowPushNotifications',
  info: 'Push Notifications'
};

var sectionNotifications = [{
  key: 'OpenOfferMatched',
  info: 'One of my orders has been matched'
}, {
  key: 'MarketClosed',
  info: 'One of my markets has closed'
}];

if (false) {
  sectionNotifications.push({
    key: 'ContractPriceChange',
    info: 'One of my contracts changes in price by:',
    withValue: 'ContractPriceChangeAmount',
    validate: function validate(x) {
      return x >= 5 && x < 100;
    },
    currencyInitial: 5
  });
}

var sectionGeneral = [
  // {
  //   key: 'ShowBalanceHeader',
  //   info: 'Show my available balances in header',
  // },
];

var UX_OPTIONS_BUTTON_COLOR_SCHEME = {
  key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme,
  info: 'Buy Button Color Scheme',
  defaultValue: 1,
  options: [{
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["a" /* APP_COLOR_PALETTE */].GREEN_RED,
    info: 'Green/Red'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["a" /* APP_COLOR_PALETTE */].BLUE_GREY,
    info: 'Blue/Grey'
  }]
};

var UX_OPTIONS_PRICE_MOBILE_CONTRACT_LAYOUT = {
  key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout,
  info: 'Mobile Contract Layout',
  defaultValue: 1,
  options: [{
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].STANDARD,
    info: 'Tile'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].SIMPLIFIED,
    info: 'Simplified'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].CONDENSED,
    info: 'Condensed'
  }]
};

var UX_OPTIONS_PRICE_DISPLAY = {
  key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay,
  info: 'Price Display',
  defaultValue: 1,
  options: [{
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["d" /* APP_PRICE_DISPLAY */].TRADE_PRICES,
    info: 'Trade Prices'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["d" /* APP_PRICE_DISPLAY */].ODDS,
    info: 'Odds'
  }]
};

var UX_OPTIONS_MOBILE_ORDERBOOK_DISPLAY = {
  key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["b" /* UX_CATEGORY */].UXSettingIsOBCollapsedOnOS,
  info: 'Orderbook Layout (Mobile Only)',
  defaultValue: 1,
  options: [{
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["e" /* APP_MOBILE_ORDERBOOK_DISPLAY */].COLLAPSED,
    info: 'Collapsed'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["e" /* APP_MOBILE_ORDERBOOK_DISPLAY */].EXPANDED,
    info: 'Expanded'
  }]
};

var UX_OPTIONS = [UX_OPTIONS_BUTTON_COLOR_SCHEME, UX_OPTIONS_PRICE_MOBILE_CONTRACT_LAYOUT, UX_OPTIONS_PRICE_DISPLAY];

var UX_OPTIONS_WITHOUT_MOBILE_ORDERBOOK_SETTING = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(UX_OPTIONS.filter(function (option) {
  return option.key !== __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["b" /* UX_CATEGORY */].UXSettingIsOBCollapsedOnOS;
})));

/* unused harmony default export */ var _unused_webpack_default_export = ({
  components: {
    accountDesktopHeader: __WEBPACK_IMPORTED_MODULE_12__components_account_account_desktop_header_account_desktop_header_vue__["a" /* default */],
    alertBox: __WEBPACK_IMPORTED_MODULE_7__components_generics_alert_box_alert_box_vue__["a" /* default */],
    contentHeader: __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__["a" /* default */],
    formCheckbox: __WEBPACK_IMPORTED_MODULE_4__components_forms_checkbox_checkbox_vue__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_5__components_account_profile_profile_vue__["a" /* default */],
    switchButton: __WEBPACK_IMPORTED_MODULE_6__components_generics_switch_button_switch_button_vue__["a" /* default */],
    settingsOption: __WEBPACK_IMPORTED_MODULE_15__settings_option_settings_option_vue__["a" /* default */],
    checkOption: __WEBPACK_IMPORTED_MODULE_17__check_option_check_option_vue__["a" /* default */],
    securitySettings: __WEBPACK_IMPORTED_MODULE_18__security_settings_security_settings_vue__["a" /* default */],
    settingsOptionSwitch: __WEBPACK_IMPORTED_MODULE_16__settings_option_switch_settings_option_switch_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_externalLinks__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_userAgent__["a" /* default */]],
  data: function data() {
    return {
      manageInfoLoaded: false,
      correspondence: false,
      logins: [],
      hasLocalPassword: false,
      sectionGeneral: sectionGeneral,
      sectionNotifications: sectionNotifications,
      optionPush: optionPush,
      sectionPushEnabled: false,
      categories: {
        privacy: 'privacy',
        general: 'display',
        push: 'PushNotifications',
        inApp: 'InAppNotifications',
        ux: 'ux'
      },
      sectionUX: UX_OPTIONS
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Settings'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'leaderboardsEnabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('profile', ['settingsReady']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('profile', ['settings']), {
    sectionPrivacy: function sectionPrivacy() {
      var results = [{
        key: 'ShowTradeHistory',
        info: "Show my trade activity in 'Currently Predicting'"
      }];
      if (this.leaderboardsEnabled) {
        results.push({
          key: 'AllowLeaderboard',
          info: 'Show my ranking in the Leaderboards'
        });
      }
      return results;
    },
    gridRowModifier: function gridRowModifier() {
      return {
        row: this.isLayoutMobile,
        'row-x': !this.isLayoutMobile
      };
    },
    isFacebookDisabled: function isFacebookDisabled() {
      return !this.hasLocalPassword;
    },
    isTwitterDisabled: function isTwitterDisabled() {
      return !this.hasLocalPassword;
    },
    isGoogleDisabled: function isGoogleDisabled() {
      return !this.hasLocalPassword;
    },
    hasFacebook: function hasFacebook() {
      return this.checkLogin(PROVIDER_FACEBOOK);
    },
    hasTwitter: function hasTwitter() {
      return this.checkLogin(PROVIDER_TWITTER);
    },
    hasGoogle: function hasGoogle() {
      return this.checkLogin(PROVIDER_GOOGLE);
    },
    hasGeneral: function hasGeneral() {
      if (this.settings.display && typeof this.settings.display.ShowBalanceHeader !== 'undefined') {
        return true;
      }
      return false;
    },
    hasPrivacy: function hasPrivacy() {
      if (this.settings.privacy && typeof this.settings.privacy.ShowTradeHistory !== 'undefined' && typeof this.settings.privacy.AllowLeaderboard !== 'undefined') {
        return true;
      }
      return false;
    },
    hasUX: function hasUX() {
      return this.settings.ux && typeof this.settings.ux.UXSettingBuyColorScheme !== 'undefined' && typeof this.settings.ux.UXSettingMobileContractLayout !== 'undefined' && typeof this.settings.ux.UXSettingPriceDisplay !== 'undefined';
    },
    hasPush: function hasPush() {
      if (this.settings.PushNotifications && typeof this.settings.PushNotifications.AllowPushNotifications !== 'undefined') {
        this.sectionPushEnabled = this.settings.PushNotifications.AllowPushNotifications;
        return true;
      }
      return false;
    },
    isPushDisabled: function isPushDisabled() {
      return !this.sectionPushEnabled;
    },
    haveSettingsLoaded: function haveSettingsLoaded() {
      return this.hasGeneral || this.hasPrivacy || this.hasPush;
    }
  }),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.clearSettings();
    this.getAllSettings().then(this.checkManageInfo).then(function () {
      _this.manageInfoLoaded = true;
    }).then(function () {
      return _this.getExternalLogins({
        type: __WEBPACK_IMPORTED_MODULE_10__constants__["a" /* default */].SOCIAL_LOGIN_ADD
      });
    }).then(function (response) {
      _this.links = response.data;
    }).then(function () {
      _this.loaderRemove(document.body);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getManageInfo', 'removeExternal', 'logout']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('profile', ['getAllSettings', 'clearSettings']), {
    checkProvider: function checkProvider(x, target) {
      return x.loginProvider.toLowerCase() === target.toLowerCase();
    },
    checkLogin: function checkLogin(target) {
      var _this2 = this;

      return this.logins && this.logins.length > 0 && this.logins.filter(function (x) {
        return _this2.checkProvider(x, target);
      }).length === 1;
    },
    getProviderKey: function getProviderKey(target) {
      var _this3 = this;

      if (this.logins && this.logins.length > 0) {
        var login = this.logins.filter(function (x) {
          return _this3.checkProvider(x, target);
        })[0];
        return login ? login.providerKey : {};
      }
      return {};
    },
    checkManageInfo: function checkManageInfo() {
      var _this4 = this;

      return this.getManageInfo().then(function (data) {
        _this4.hasLocalPassword = data.hasLocalPassword;
        _this4.logins = data.logins;
      });
    },
    onToggleProvider: function onToggleProvider(provider, value) {
      var _this5 = this;

      if (value) {
        if (!this.isWrapperApp) {
          this.loaderAdd(document.body);
        }
        try {
          if (provider === PROVIDER_FACEBOOK) this.facebookLinkClick();
          if (provider === PROVIDER_TWITTER) this.twitterLinkClick();
          if (provider === PROVIDER_GOOGLE) this.googleLinkClick();
        } catch (err) {
          this.loaderRemove(document.body);
          console.error(err);
        }
      } else {
        var payload = {
          loginProvider: provider,
          providerKey: this.getProviderKey(provider)
        };
        this.removeExternal(payload).then(function () {
          return _this5.setSuccessSideNotification('Settings updated successfully.');
        }).then(this.getAllSettings).then(this.checkManageInfo).catch(function () {
          return _this5.setErrorSideNotification('Error has occured.');
        });
      }
    },
    onToggleSetting: function onToggleSetting(item) {
      if (item.key === 'AllowLeaderboard') {
        this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_modals_constants__["a" /* MODALS */].SMALL_LEADERBOARDS_UPDATE_INFO);
      }
    },
    onSetPassword: function onSetPassword() {
      this.$router.push({ name: 'password-set' });
    },
    doError: function doError(e) {
      this.setErrorSideNotification(e);
    },
    togglePush: function togglePush(e) {
      this.sectionPushEnabled = e;
    }
  })
});

/***/ }),

/***/ "8rDO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-option"},[_c('div',{staticClass:"settings-option__left"},[_c('div',{staticClass:"settings-option__wrap"},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{staticClass:"settings-option__right"},[_c('switch-button',{attrs:{"black":""},on:{"toggle":_vm.toggle},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8sRt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__("H/Zg");



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    ticketTypes: null,
    reportReasons: []
  },
  mutations: {
    updateTicketTypes: function updateTicketTypes(state, payload) {
      state.ticketTypes = payload;
    },
    setReportReasons: function setReportReasons(state, data) {
      state.reportReasons = data.reasons || [];
    }
  },
  actions: {
    getForumUrl: function getForumUrl() {
      return __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].support.getForumUrl().then(function (response) {
        return response.data;
      });
    },
    getTicketsTypes: function getTicketsTypes(_ref) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].support.getTicketsTypes().then(function (response) {
        return commit('updateTicketTypes', response.data.map(function (o) {
          return { label: o, value: o };
        }));
      });
    },
    postTicket: function postTicket(_ref2, payload) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].support.postTicket(payload);
    },
    getReportUserReasons: function getReportUserReasons(_ref3) {
      var state = _ref3.state,
          commit = _ref3.commit;

      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$cache = _ref4.cache,
          cache = _ref4$cache === undefined ? true : _ref4$cache;

      if (cache && state.reportReasons.length > 0) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.reportReasons);
      }
      return __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].support.getReportUser().then(function (response) {
        commit('setReportReasons', response.data);
        return response.data;
      });
    },
    reportUser: function reportUser(_ref5, payload) {
      var commit = _ref5.commit;

      return __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].support.postReportUser(payload).then(function (response) {
        return response.data;
      });
    },
    getAnnouncements: function getAnnouncements() {
      return __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].support.getAnnouncements().then(function (response) {
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "8vMm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"market-biggest-gains-element",attrs:{"tag":"div","to":{name: 'market-details', params: {marketId: _vm.promo.marketId, marketUrl: _vm.promo.marketUrl}}}},[(_vm.header)?_c('div',{staticClass:"market-biggest-gains-element__header"},[_vm._v("\n    "+_vm._s(_vm.promo.sectionTitle)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-biggest-gains-element__content"},[_c('div',{staticClass:"market-biggest-gains-element__market"},[_vm._v("\n      "+_vm._s(_vm.promo.marketName)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"market-biggest-gains-element__wrapper"},[_c('div',{staticClass:"market-biggest-gains-element__contract"},[_vm._v("\n        "+_vm._s(_vm.promo.contractName)+"\n      ")]),_vm._v(" "),_c('div',[_c('span',{staticClass:"market-biggest-gains-element__current-price"},[(_vm.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":_vm.contract.lastTradePriceAsCents}})]:[_vm._v("\n            -"),_c('span',{domProps:{"innerHTML":_vm._s('&cent;')}})]],2),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.contract.changePriceAsCents,"lastClosePrice":_vm.contract.lastClosePrice}})],1),_vm._v(" "),(_vm.hasLastTradePrice)?_c('div',{class:_vm.iconModifiers}):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8zAU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverviewMapLoader_vue__ = __webpack_require__("sCGU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_267a84b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverviewMapLoader_vue__ = __webpack_require__("WxRi");
function injectStyle (ssrContext) {
  __webpack_require__("iHgG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverviewMapLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_267a84b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverviewMapLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "95qB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_insight_insight_panel_insight_panel_vue__ = __webpack_require__("QgOX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_insight_insight_link_insight_link_vue__ = __webpack_require__("DXdo");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    insightPanel: __WEBPACK_IMPORTED_MODULE_2__components_insight_insight_panel_insight_panel_vue__["a" /* default */],
    insightLink: __WEBPACK_IMPORTED_MODULE_3__components_insight_insight_link_insight_link_vue__["a" /* default */]
  },
  props: {
    numArticles: {
      type: Number,
      default: 4
    }
  },
  data: function data() {
    return {
      linkBack: {
        name: 'insight'
      },
      createLink: function createLink(url) {
        return {
          path: '/insight/' + btoa(encodeURI(url))
        };
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('insight', ['analysis']), {
    allArticlesAway: function allArticlesAway() {
      return !this.isLayoutMobile;
    },
    allArticlesLink: function allArticlesLink() {
      if (!this.isLayoutMobile) {
        return 'https://analysis.predictit.org/';
      }
      return {
        path: '/insight/' + btoa(encodeURI('//analysis.predictit.org/'))
      };
    },
    tumblr: function tumblr() {
      return this.analysis === null ? [] : this.analysis;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('insight', ['getMostPopular', 'getAnalysis'])),
  mounted: function mounted() {
    this.getAnalysis({
      limit: this.numArticles
    });
  }
});

/***/ }),

/***/ "9B+r":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "9IfM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BRAND; });
var BRAND = 'PredictIt';

/* unused harmony default export */ var _unused_webpack_default_export = ({
  data: function data() {
    return {
      brand: BRAND
    };
  }
});

/***/ }),

/***/ "9MVc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DAILY_PAGES; });
var DAILY_PAGES = {
  MONDAY: {
    id: 'market-focus',
    path: '/market-focus',
    pageId: 'DailyMarketsMonday',
    title: 'Market Focus'
  },
  TUESDAY: {
    id: 'daily-market-updates',
    path: '/daily-market-updates',
    pageId: 'DailyMarketsTuesday',
    title: 'Daily Market Updates'
  },
  WEDNESDAY: {
    id: 'daily-markets-wednesday',
    path: '/daily-markets-wednesday',
    pageId: 'DailyMarketsWednesday',
    title: 'Daily Markets Wednesday'
  },
  THURSDAY: {
    id: 'daily-markets-thursday',
    path: '/daily-markets-thursday',
    pageId: 'DailyMarketsThursday',
    title: 'Daily Markets Thursday'
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (DAILY_PAGES);

/***/ }),

/***/ "9XaW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildCanonicalUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

function buildCanonicalUrl(router, routeName) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var currentQuery = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var allowedParams = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  var _router$resolve = router.resolve({ name: routeName, params: params }),
      route = _router$resolve.route;

  var keptQuery = allowedParams.reduce(function (acc, key) {
    if (currentQuery[key] !== undefined) {
      acc[key] = currentQuery[key];
    }
    return acc;
  }, {});
  var queryKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(keptQuery);
  var queryString = queryKeys.length ? '?' + queryKeys.map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(keptQuery[key]);
  }).join('&') : '';
  return '' + window.location.origin + route.fullPath + queryString;
}

/***/ }),

/***/ "9Z8S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:_vm.checkboxModifiers},[_c('label',{attrs:{"for":_vm.name}},[_c('input',{attrs:{"type":"checkbox","name":_vm.name,"id":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_vm._v(" "),_c('div',{staticClass:"checkbox__tick",class:_vm.classIsChecked}),_vm._v(" "),_c('div',{staticClass:"checkbox__label"},[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9hG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_http__ = __webpack_require__("p1CT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__ = __webpack_require__("DECz");





function bankRequestConfig(timeout) {
  var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ timeout: timeout }, extra);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getBalance: function getBalance() {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/Balance');
  },
  getDepositCard: function getDepositCard() {
    var utmCodeParam = __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__["a" /* default */].get('utm_code');
    if (utmCodeParam) {
      return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/DepositCard?' + utmCodeParam.name + '=' + encodeURIComponent(utmCodeParam.value));
    }
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/DepositCard');
  },
  postConfirmDepositCard: function postConfirmDepositCard(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__["a" /* default */].payload(payload, 'utm_code', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/ConfirmDepositCard', marketingPayload);
  },
  postSubmitDepositCard: function postSubmitDepositCard(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__["a" /* default */].payload(payload, 'utm_code', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/SubmitDepositCard', marketingPayload);
  },
  getPayNearMe: function getPayNearMe(page) {
    var utmCodeParam = __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__["a" /* default */].get('utm_code');
    if (utmCodeParam) {
      return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/PayNearMe?page=' + page + '&' + utmCodeParam.name + '=' + encodeURIComponent(utmCodeParam.value));
    }
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/PayNearMe?page=' + page);
  },
  getDepositUSDCoin: function getDepositUSDCoin() {
    var utmCodeParam = __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__["a" /* default */].get('utm_code');
    if (utmCodeParam) {
      return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/DepositUSDCoin?' + utmCodeParam.name + '=' + encodeURIComponent(utmCodeParam.value));
    }
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/DepositUSDCoin');
  },
  postSubmitDepositUSDCoin: function postSubmitDepositUSDCoin(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__["a" /* default */].payload(payload, 'utm_code', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/DepositUSDCoin', marketingPayload);
  },
  getWithdrawAch: function getWithdrawAch() {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/WithdrawAch');
  },
  getWithdrawCheck: function getWithdrawCheck() {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/WithdrawCheck');
  },
  getWithdrawUSDC: function getWithdrawUSDC() {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/WithdrawUSDC');
  },
  postWithdrawAch: function postWithdrawAch(payload) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/WithdrawAch', payload);
  },
  postWithdrawCheck: function postWithdrawCheck(payload) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/WithdrawCheck', payload);
  },
  postWithdrawUSDC: function postWithdrawUSDC(payload) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/WithdrawUSDC', payload);
  },
  getPendingWithdrawals: function getPendingWithdrawals() {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/PendingWithdrawals');
  },
  getPendingDeposits: function getPendingDeposits() {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/PendingDeposits');
  },
  postCancelWithdrawal: function postCancelWithdrawal(payload) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/CancelWithdrawal', payload);
  },
  getDepositMethods: function getDepositMethods() {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/DepositMethods');
  },
  getWithdrawalMethods: function getWithdrawalMethods() {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/WithdrawalMethods');
  },
  getWithdrawWire: function getWithdrawWire() {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/WithdrawWire');
  },
  getWithdrawWireBankSearch: function getWithdrawWireBankSearch(page, query) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/WithdrawWireBankSearch?page=' + page + '&query=' + encodeURIComponent(query));
  },
  postWithdrawWireBankInfo: function postWithdrawWireBankInfo(payload) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/WithdrawWireBankInfo', payload);
  },
  postWithdrawWireConfirm: function postWithdrawWireConfirm(payload) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/WithdrawWireConfirm', payload);
  },
  postWithdrawWireSubmit: function postWithdrawWireSubmit(payload) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/WithdrawWireSubmit', payload);
  },
  getDepositPWMB: function getDepositPWMB(_ref) {
    var authorizationId = _ref.authorizationId,
        returnUrl = _ref.returnUrl,
        cancelUrl = _ref.cancelUrl;

    var utmCodeParam = __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__["a" /* default */].get('utm_code');
    if (utmCodeParam) {
      return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/DepositPWMB?AuthorizationIdToRefresh=' + authorizationId + '&requestedReturnUrl=' + returnUrl + '&requestedCancelUrl=' + cancelUrl + '&' + utmCodeParam.name + '=' + encodeURIComponent(utmCodeParam.value));
    }
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/DepositPWMB?AuthorizationIdToRefresh=' + authorizationId + '&requestedReturnUrl=' + returnUrl + '&requestedCancelUrl=' + cancelUrl);
  },
  deletePWMBAuthorization: function deletePWMBAuthorization(authorizationId) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].delete('api/User/Wallet/PWMBAuthorization/' + authorizationId);
  },
  postConfirmDepositPWMB: function postConfirmDepositPWMB(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__["a" /* default */].payload(payload, 'utm_code', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/ConfirmDepositPWMB', marketingPayload);
  },
  postSubmitDepositPWMB: function postSubmitDepositPWMB(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__["a" /* default */].payload(payload, 'utm_code', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/DepositPWMB', marketingPayload);
  },
  getPWMBAuthorization: function getPWMBAuthorization() {
    var queryPart = decodeURIComponent(window.location.search.replace('?pwmbDeposit=success&', '').replace('?pwmbDeposit=cancel&', ''));
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/PWMBAuthorization?redirectQueryStringPWMBPart=' + queryPart);
  },
  postInstantCredit: function postInstantCredit(payload) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/InstantCredit', payload);
  },
  postBankLinkCreateSession: function postBankLinkCreateSession(payload) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/BankLinks/CreateSession', payload || {}, bankRequestConfig(35000));
  },
  postBankLinkStartProviderConfirmation: function postBankLinkStartProviderConfirmation(payload) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/BankLinks/StartProviderConfirmation', payload, bankRequestConfig(35000));
  },
  postBankLinkConfirmProviderUser: function postBankLinkConfirmProviderUser(payload) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/BankLinks/ConfirmProviderUser', payload, bankRequestConfig(35000));
  },
  postBankLinkCreateReconnectSession: function postBankLinkCreateReconnectSession(payload) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/BankLinks/CreateReconnectSession', payload, bankRequestConfig(35000));
  },
  postBankLinkComplete: function postBankLinkComplete(payload) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/BankLinks/Complete', payload, bankRequestConfig(35000));
  },
  postBankLinkCompletionStatus: function postBankLinkCompletionStatus(payload) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/BankLinks/CompletionStatus', payload, bankRequestConfig(5000));
  },
  postBankLinkDiagnostic: function postBankLinkDiagnostic(payload) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/BankLinks/Diagnostics', payload, bankRequestConfig(2000, { bankDiagnostic: true }));
  },
  getLinkedBankAccounts: function getLinkedBankAccounts(config) {
    var utmCodeParam = __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__["a" /* default */].get('utm_code');
    var requestConfig = utmCodeParam ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, config || {}, {
      params: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, config && config.params || {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, utmCodeParam.name, utmCodeParam.value))
    }) : config;
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/User/Wallet/BankLinks/Accounts', bankRequestConfig(config && config.timeout || 10000, requestConfig));
  },
  postRemoveLinkedBankAccount: function postRemoveLinkedBankAccount(payload) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/BankLinks/RemoveAccount', payload, bankRequestConfig(15000));
  },
  postDepositBankTransferForm: function postDepositBankTransferForm(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__["a" /* default */].payload(payload, 'utm_code', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/DepositBankTransferForm', marketingPayload, bankRequestConfig(15000));
  },
  postConfirmDepositBankTransfer: function postConfirmDepositBankTransfer(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__["a" /* default */].payload(payload, 'utm_code', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/ConfirmDepositBankTransfer', marketingPayload, bankRequestConfig(35000));
  },
  postDepositBankTransfer: function postDepositBankTransfer(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__["a" /* default */].payload(payload, 'utm_code', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/DepositBankTransfer', marketingPayload, bankRequestConfig(45000));
  },
  postDepositBankTransferStatus: function postDepositBankTransferStatus(payload) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].post('api/User/Wallet/DepositBankTransferStatus', payload, bankRequestConfig(10000));
  }
});

/***/ }),

/***/ "9poZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9pxA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");
/* eslint-disable max-len */


var DEFAULT_TIMELINE = '30d';

/* harmony default export */ __webpack_exports__["a"] = ({
  getMarketChartData: function getMarketChartData(_ref) {
    var marketId = _ref.marketId,
        _ref$timespan = _ref.timespan,
        timespan = _ref$timespan === undefined ? DEFAULT_TIMELINE : _ref$timespan,
        _ref$maxContracts = _ref.maxContracts,
        maxContracts = _ref$maxContracts === undefined ? 4 : _ref$maxContracts,
        _ref$storyId = _ref.storyId,
        storyId = _ref$storyId === undefined ? null : _ref$storyId,
        _ref$regionUUID = _ref.regionUUID,
        regionUUID = _ref$regionUUID === undefined ? null : _ref$regionUUID,
        _ref$sectionType = _ref.sectionType,
        sectionType = _ref$sectionType === undefined ? null : _ref$sectionType,
        _ref$chartStoryVersio = _ref.chartStoryVersionId,
        chartStoryVersionId = _ref$chartStoryVersio === undefined ? null : _ref$chartStoryVersio;

    var isTimespanInHours = timespan.includes('h');
    var finalTimespan = timespan.replace('h', '').replace('d', '');
    if (finalTimespan === '0') {
      finalTimespan = '';
    }
    if (storyId) {
      return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Public/GetMarketChartData/' + marketId + '?timespan=' + finalTimespan + '&maxContracts=' + maxContracts + '&isTimespanInHours=' + isTimespanInHours + '&chartUUID=' + regionUUID + '&chartStoryId=' + storyId + '&sectionType=' + (sectionType || '') + '&chartStoryVersionId=' + (chartStoryVersionId || ''));
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Public/GetMarketChartData/' + marketId + '?timespan=' + finalTimespan + '&maxContracts=' + maxContracts + '&isTimespanInHours=' + isTimespanInHours);
  },
  getContractChartData: function getContractChartData(contractId) {
    var timespan = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_TIMELINE;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Public/GetContractChartData/' + contractId + '?timespan=' + timespan);
  }
});

/***/ }),

/***/ "9rUd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__ = __webpack_require__("k37b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_promoCode__ = __webpack_require__("nPqm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_depositWarningMixin__ = __webpack_require__("Scap");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_wallet_shared_deposit_disclaimer_deposit_disclaimer_vue__ = __webpack_require__("SmIQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_wallet_shared_fee_waived_banner_fee_waived_banner_vue__ = __webpack_require__("TBZZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_wallet_shared_depositMethodTypes__ = __webpack_require__("LQTn");













/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_promoCode__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_depositWarningMixin__["a" /* default */]],
  components: {
    depositDisclaimer: __WEBPACK_IMPORTED_MODULE_8__components_wallet_shared_deposit_disclaimer_deposit_disclaimer_vue__["a" /* default */],
    feeWaivedBanner: __WEBPACK_IMPORTED_MODULE_9__components_wallet_shared_fee_waived_banner_fee_waived_banner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      depositMethodType: __WEBPACK_IMPORTED_MODULE_10__components_wallet_shared_depositMethodTypes__["a" /* DEPOSIT_METHOD_TYPE */].CASH,
      buttonDisabled: false,
      url: null,
      error: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.loaderAdd();
    this.getDepositMethods();
    this.getPayNearMe('').then(function (data) {
      _this.loaderRemove();
      _this.url = data.url;
      _this.promoCodeDetail = data.promoCodeDetail || {};
    }).catch(function (error) {
      _this.loaderRemove();
      _this.error = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', 'Your authorization to deposit by cash has been disabled.');
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('wallet', ['getPayNearMe', 'getDepositMethods']), {
    onDeposit: function onDeposit() {
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Deposit Confirm',
        action: 'submit',
        label: 'Confirm Cash Deposit'
      }));
      this.buttonDisabled = true;
      window.location.href = this.url;
    }
  })
});

/***/ }),

/***/ "9ub0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._b({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 16 16","fill":"none"}},'svg',_vm.$attrs,false),[_c('path',{attrs:{"d":"M12.6667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.403 2.59695 14 3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V3.33333C14 2.59695 13.403 2 12.6667 2Z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M10 2V14","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9xQS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_account_upload_document_account_upload_document_vue__ = __webpack_require__("3USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_account_account_ssn_info_upload_account_ssn_info_upload_vue__ = __webpack_require__("FHMi");



var documentUploadMixin = {
  data: function data() {
    return {
      documentUploadSource: 4,
      documentUploadInfoVisible: false,
      documentUploadInfoPending: false,
      collectSsnInfo: false
    };
  },

  components: {
    accountUploadDocument: __WEBPACK_IMPORTED_MODULE_0__components_account_account_upload_document_account_upload_document_vue__["default"],
    accountSsnInfoUpload: __WEBPACK_IMPORTED_MODULE_1__components_account_account_ssn_info_upload_account_ssn_info_upload_vue__["a" /* default */]
  },
  methods: {
    checkDocumentUploadFlags: function checkDocumentUploadFlags(data) {
      this.documentUploadInfoVisible = data.duRequired || data.duPending;
      this.documentUploadInfoPending = data.duPending;
      this.documentUploadSource = data.duSource || this.documentUploadSource;
      this.collectSsnInfo = data.requireSSN4;
      return data.duRequired || data.duPending;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (documentUploadMixin);

/***/ }),

/***/ "9xey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vimeo_player_js__ = __webpack_require__("spPB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52d61445_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vimeo_player_vue__ = __webpack_require__("Q4Vh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vimeo_player_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52d61445_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vimeo_player_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9zdy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_check_option_js__ = __webpack_require__("BEGL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15472aee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_check_option_vue__ = __webpack_require__("/Fc2");
function injectStyle (ssrContext) {
  __webpack_require__("bzSr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_check_option_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15472aee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_check_option_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A6L0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"charts-checkbox"}},[(_vm.show)?_c('div',{class:_vm.classModifiers},[_c('label',{staticClass:"charts-checkbox__label-container",attrs:{"for":_vm.name}},[_c('input',{attrs:{"type":"checkbox","name":_vm.name,"id":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_vm._v(" "),_c('div',{class:_vm.tickClassModifiers,style:(_vm.styleModifiers)}),_vm._v(" "),_c('div',{staticClass:"charts-checkbox__label"},[_vm._t("default")],2)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AJVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"plus-minus-sign"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AM9x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getPlayerLeaderboards: function getPlayerLeaderboards() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/leaderboards');
  },
  getLeaderboards: function getLeaderboards() {
    var url = __webpack_require__.i({"NODE_ENV":"production","SENTRY_ENVIRONMENT":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","PI_YOUTUBE_LINK":"https://www.youtube.com/c/predictitofficial","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_SIGNALR":false,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","ATTACH_TO_HOME_POPUP_ENABLED":false,"PINNING_ENABLED":false,"DEPOSIT_PROMO_INPUT_BOX_ENABLED":false,"STORIES_PAGE_ENABLED":false,"DISABLE_TWO_FACTOR_PROMPT":true,"COLLEGE_AFFILIATION_ENABLED":true}).USE_API_WRAPPER ? 'api/Public/GetLiveData?url=/api/Leaderboards' : 'api/Leaderboards';
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url);
  },
  getLeaderboard: function getLeaderboard(_ref) {
    var id = _ref.id,
        _ref$dateRange = _ref.dateRange,
        dateRange = _ref$dateRange === undefined ? 7 : _ref$dateRange,
        _ref$page = _ref.page,
        page = _ref$page === undefined ? 1 : _ref$page,
        _ref$itemsPerPage = _ref.itemsPerPage,
        itemsPerPage = _ref$itemsPerPage === undefined ? 30 : _ref$itemsPerPage;

    var encoded = encodeURIComponent('?daterange=' + dateRange + '&page=' + page + '&itemsPerPage=' + itemsPerPage);
    var url = __webpack_require__.i({"NODE_ENV":"production","SENTRY_ENVIRONMENT":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","PI_YOUTUBE_LINK":"https://www.youtube.com/c/predictitofficial","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_SIGNALR":false,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","ATTACH_TO_HOME_POPUP_ENABLED":false,"PINNING_ENABLED":false,"DEPOSIT_PROMO_INPUT_BOX_ENABLED":false,"STORIES_PAGE_ENABLED":false,"DISABLE_TWO_FACTOR_PROMPT":true,"COLLEGE_AFFILIATION_ENABLED":true}).USE_API_WRAPPER ? 'api/Public/GetLiveData?url=/api/Leaderboards/' + id + encoded : 'api/Leaderboards/' + id + '?daterange=' + dateRange + '&page=' + page + '&itemsPerPage=' + itemsPerPage;
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url);
  }
});

/***/ }),

/***/ "AORQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_phone_update_js__ = __webpack_require__("+jU6");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90ec4d52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_phone_update_vue__ = __webpack_require__("yncl");
function injectStyle (ssrContext) {
  __webpack_require__("EFuq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_phone_update_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90ec4d52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_phone_update_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AOlT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-login"},[_c('div',{staticClass:"account-login__socials"},[(!_vm.isWrapperApp)?_c('form-socials',{attrs:{"title":"Login with"}}):_vm._e()],1),_vm._v(" "),_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row-xy"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.email,"disabled":_vm.isFormDisabled,"name":"username","type":"email","required":true,"autocomplete":"off","placeholder":"Email"},on:{"input":_vm.$v.fields.email.$touch},model:{value:(_vm.fields.email),callback:function ($$v) {_vm.$set(_vm.fields, "email", $$v)},expression:"fields.email"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"hideIconOnValue":false,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.password,"name":"password","type":_vm.fieldTypePassword,"required":true,"autocomplete":"off","placeholder":"Password"},on:{"input":_vm.$v.fields.password.$touch},model:{value:(_vm.fields.password),callback:function ($$v) {_vm.$set(_vm.fields, "password", $$v)},expression:"fields.password"}},[(!_vm.isIE)?_c('show-password-icon',{attrs:{"slot":"icon"},on:{"showPassword":_vm.showPassword},slot:"icon"}):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"column small-12 account-login__forgotten-column"},[_c('div',{staticClass:"column small-6"},[_c('form-checkbox',{attrs:{"name":"rememberMe","label":"Keep Me Logged In"},model:{value:(_vm.fields.rememberMe),callback:function ($$v) {_vm.$set(_vm.fields, "rememberMe", $$v)},expression:"fields.rememberMe"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('div',{staticClass:"account-login__forgotten-password"},[_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.onForgotten($event)}}},[_vm._v("Forgot Password?")])])])])]),_vm._v(" "),_c('form-submit',{attrs:{"disabled":_vm.loginButtonDisabled,"loading":_vm.isFormDisabled,"label":"Login"}}),_vm._v(" "),_c('div',{staticClass:"recaptcha-terms"},[_vm._v("\n          Protected by reCAPTCHA ·\n          "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":"https://policies.google.com/privacy"}},[_vm._v("Privacy")]),_vm._v("\n          ·\n          "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":"https://policies.google.com/terms"}},[_vm._v("Terms")])])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('h5',{staticClass:"form__title form__title--new"},[_vm._v("\n          Login using your email\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "APZR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ASm9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__ = __webpack_require__("BL43");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__["a" /* default */]],
  props: {
    showIcons: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'leaderboardsEnabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    enabledLinks: function enabledLinks() {
      return this.links.filter(function (i) {
        return i.enabled;
      });
    },
    links: function links() {
      if (this.isLoggedIn) {
        return [{
          title: 'Markets',
          name: 'markets',
          href: { name: 'market-list' },
          enabled: true
        }, {
          title: 'News',
          name: 'news',
          href: '/news',
          enabled: true
        }, {
          title: 'Leaderboards',
          name: 'leaderboards',
          href: '/leaderboards',
          enabled: this.leaderboardsEnabled
        }, {
          title: 'Account',
          name: 'account',
          href: this.accountLink,
          enabled: true
        }, {
          title: 'Dashboard',
          name: 'dashboard',
          href: '/dashboard',
          enabled: true
        }];
      }

      return [{
        title: 'Markets',
        name: 'markets',
        href: { name: 'market-list' },
        enabled: true
      }, {
        title: 'News',
        name: 'news',
        href: '/news',
        enabled: true
      }, {
        title: 'Learn',
        name: 'learn',
        href: '/learn',
        enabled: true
      }, {
        title: 'Leaderboards',
        name: 'leaderboards',
        href: '/leaderboards',
        enabled: this.leaderboardsEnabled
      }];
    }
  }),
  methods: {
    classModifier: function classModifier(name) {
      var _ref;

      var routes = ['market-details'];
      var dontHighlight = routes.includes(this.$route.name);
      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'main-nav__link-with-icon main-nav__link-with-icon--' + name, this.showIcons), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'main-nav__link--no-highlight', dontHighlight), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'main-nav__link', true), _ref;
    },
    showSocialAvatarOnMobile: function showSocialAvatarOnMobile(item) {
      return this.isLayoutMobile && item.name === 'dashboard' && this.isLoggedIn;
    },
    onAvatarClick: function onAvatarClick() {
      this.$router.push({ name: 'portfolio' });
    },
    onLinkClick: function onLinkClick(href) {
      // scroll page to top if link is clicked again
      if (this.$route && this.$route.path === href) {
        window.scrollTo(0, 0);
      }
    }
  }
});

/***/ }),

/***/ "AZoq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__ = __webpack_require__("lHK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_constants__ = __webpack_require__("5Oj8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ready: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('market', ['mapStateData']), {
    meStyleModifiers: function meStyleModifiers() {
      return this.getContractInfo('ME');
    },
    me1StyleModifiers: function me1StyleModifiers() {
      return this.getContractInfo('ME-01');
    },
    me2StyleModifiers: function me2StyleModifiers() {
      return this.getContractInfo('ME-02');
    },
    me3StyleModifiers: function me3StyleModifiers() {
      return this.getContractInfo('ME-03');
    },
    neStyleModifiers: function neStyleModifiers() {
      return this.getContractInfo('NE');
    },
    ne1StyleModifiers: function ne1StyleModifiers() {
      return this.getContractInfo('NE-01');
    },
    ne2StyleModifiers: function ne2StyleModifiers() {
      return this.getContractInfo('NE-02');
    },
    ne3StyleModifiers: function ne3StyleModifiers() {
      return this.getContractInfo('NE-03');
    }
  }),
  watch: {
    mapStateData: {
      handler: 'mapStateDataHandler',
      immediate: true
    }
  },
  methods: {
    getContractInfo: function getContractInfo(key) {
      var data = this.mapStateData[key] || null;
      if (data === null) {
        return {
          background: __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].GRAY[__WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_constants__["c" /* COLOR_INDEXES */].MEDIUM].color
        };
      }
      var targetContract = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["s" /* getLeadingTradedContract */])(data.contracts || []);
      if (!targetContract) {
        return {
          background: __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].GRAY[__WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_constants__["c" /* COLOR_INDEXES */].MEDIUM].color
        };
      }
      var colorMap = targetContract.contractName === __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_constants__["d" /* CONTRACTS */].DEMOCRATIC ? __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].BLUE : __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].RED;
      var index = null;
      if (targetContract.lastTradePrice <= __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_constants__["e" /* PRICE_FACTORS */].LOW) {
        index = __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_constants__["c" /* COLOR_INDEXES */].LOW;
      } else if (targetContract.lastTradePrice <= __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_constants__["e" /* PRICE_FACTORS */].MEDIUM) {
        index = __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_constants__["c" /* COLOR_INDEXES */].MEDIUM;
      } else if (targetContract.lastTradePrice <= __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_constants__["e" /* PRICE_FACTORS */].HIGH) {
        index = __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_election_map_constants__["c" /* COLOR_INDEXES */].HIGH;
      }
      return {
        color: '#fff',
        background: colorMap[index].color
      };
    },
    mapStateDataHandler: function mapStateDataHandler(value) {
      if (!__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default()(value)) {
        this.ready = true;
      }
    }
  }
});

/***/ }),

/***/ "AdHZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AyQu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VERSION_SETTINGS_LOADING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VERSION_TO_MIGRATE_TO; });
/* unused harmony export getCurrentVersionNumber */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return shouldShowWhatsIsNewPopup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_app__ = __webpack_require__("WSTi");
 /* eslint-disable */




/*
  When new version is introduced to migrate to (e.g)
  change VERSION_TO_MIGRATE_TO to 2 and update what-is-new-popup and what-is-new-popup-footer
   to use different flow for instance whatIsNewFlowVersion2
*/

var VERSION_SETTINGS_LOADING = -1;
var VERSION_TO_MIGRATE_TO = 1;

var getCurrentVersionNumber = function getCurrentVersionNumber() {
  var version = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.profile.settings.ux, __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingAnnouncementCurState, VERSION_SETTINGS_LOADING.toString());
  return parseInt(version, 10);
};

var shouldShowWhatsIsNewPopup = function shouldShowWhatsIsNewPopup() {
  var versionNumber = getCurrentVersionNumber();
  return !!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['user/isLoggedIn'] && versionNumber !== VERSION_SETTINGS_LOADING && versionNumber < VERSION_TO_MIGRATE_TO;
};

/***/ }),

/***/ "AzCe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B/8G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_daily_markets_js__ = __webpack_require__("nGgz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e2f3713_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daily_markets_vue__ = __webpack_require__("CyJB");
function injectStyle (ssrContext) {
  __webpack_require__("p8N8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_daily_markets_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e2f3713_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daily_markets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B3yl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-small",class:_vm.classModifier},[(_vm.overlay)?_c('div',{staticClass:"modal-small__overlay",on:{"click":_vm.close}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-small__wrap"},[_c('div',{staticClass:"modal-small__header"},[_vm._t("header"),_vm._v(" "),(_vm.closeButton)?_c('button',{staticClass:"modal-small__close",on:{"click":_vm.close}}):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"modal-small__content"},[_vm._t("content")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BEGL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_checkbox_checkbox_vue__ = __webpack_require__("vXhB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_currency_input_currency_input_vue__ = __webpack_require__("xMYI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_loader__ = __webpack_require__("39kf");










var DEBOUNCE_TIME = 1000;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_loader__["a" /* default */]],
  components: {
    formCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_forms_checkbox_checkbox_vue__["a" /* default */],
    currencyInput: __WEBPACK_IMPORTED_MODULE_6__components_forms_currency_input_currency_input_vue__["a" /* default */]
  },
  props: {
    category: {
      type: String,
      required: true
    },
    obj: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      checked: false,
      errorChecked: null,
      value: this.initialValue,
      errorValue: null,
      debounceUpdate: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('profile', ['settings']), {
    name: function name() {
      return this.obj.key;
    },
    checkboxName: function checkboxName() {
      return '' + this.category + this.name;
    },
    withValue: function withValue() {
      return this.obj.withValue;
    },
    getSettingsChecked: function getSettingsChecked() {
      return this.settings[this.category][this.name];
    },
    getSettingsValue: function getSettingsValue() {
      return this.withValue ? this.settings[this.category][this.withValue] : 0;
    },
    classObject: function classObject() {
      return {
        'check-option': true,
        'check-option--with-value': this.withValue,
        'check-option--disabled': this.disabled
      };
    },
    initialValue: function initialValue() {
      return 10;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('profile', ['updateSettings'])),
  created: function created() {
    var _this = this;

    this.checked = this.getSettingsChecked;
    var parsed = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(this.getSettingsValue, 10);
    this.value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(parsed) ? this.initialValue : parsed;

    this.$watch('checked', function (val, old) {
      if (_this.errorChecked !== val) {
        _this.loaderAddLegacy();
        _this.updateSettings({
          category: _this.category,
          key: _this.name,
          value: val
        }).then(function () {
          return _this.loaderRemoveLegacy();
        }).catch(function () {
          _this.loaderRemoveLegacy();
          _this.errorChecked = old;
          _this.checked = _this.errorChecked;
          _this.$emit('error', 'Could not set "' + _this.obj.info + '"');
        });
      } else {
        _this.errorChecked = null;
      }
    });

    this.debounceUpdate = __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function (val) {
      _this.updateSettings({
        category: _this.category,
        key: _this.withValue,
        value: val
      }).catch(function () {
        _this.errorValue = _this.getSettingsValue;
        _this.value = _this.errorValue;
        _this.$emit('error', 'Could not set "' + _this.obj.info + '"');
      });
    }, DEBOUNCE_TIME, { trailing: true });

    if (this.withValue) {
      this.$watch('value', function (val) {
        // prevents watch endless loop
        if (_this.errorValue !== val) {
          _this.debounceUpdate(val);
        } else {
          _this.errorValue = null;
        }
      });
    }
  }
});

/***/ }),

/***/ "BGMy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_transfers_js__ = __webpack_require__("Ngld");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44e9c4a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_transfers_vue__ = __webpack_require__("nnUJ");
function injectStyle (ssrContext) {
  __webpack_require__("qFzA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_transfers_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44e9c4a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_transfers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BL43":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



// const ROUTES_TO_HIDE_COUNT = [
//   'portfolio',
// ];

var unreadNotificationMixin = {
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['userUnreadNotificationsCount']), {
    userUnreadNotificationsCountHeader: function userUnreadNotificationsCountHeader() {
      // if (this.$route && ROUTES_TO_HIDE_COUNT.includes(this.$route.name)) return 0;
      return this.userUnreadNotificationsCount;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('dashboard', ['markNotificationsAsRead']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['setUserUnreadNotificationsCount']), {
    clearAllNotifications: function clearAllNotifications() {
      this.markNotificationsAsRead();
      this.setUserUnreadNotificationsCount(0);
    }
  })
};

/* harmony default export */ __webpack_exports__["a"] = (unreadNotificationMixin);

/***/ }),

/***/ "BYVu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BiGr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_document_table_view_js__ = __webpack_require__("N2Hf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a6a1163_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_document_table_view_vue__ = __webpack_require__("2YJ6");
function injectStyle (ssrContext) {
  __webpack_require__("zeud")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_document_table_view_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a6a1163_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_document_table_view_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BmES":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__ = __webpack_require__("k37b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_appNotification__ = __webpack_require__("qtti");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_plus_minus_sign_plus_minus_sign_vue__ = __webpack_require__("T2le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_modules_notifications__ = __webpack_require__("t45u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);












var DATE_FORMAT = 'MM/DD/YYYY hh:mm a';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_appNotification__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["a" /* formMixin */]],
  components: {
    plusMinusSign: __WEBPACK_IMPORTED_MODULE_5__components_generics_plus_minus_sign_plus_minus_sign_vue__["a" /* default */]
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      dontShowAgain: false,
      advanced: false
    };
  },

  computed: {
    isWrapperApp: function isWrapperApp() {
      return __WEBPACK_IMPORTED_MODULE_4__mixins_userAgent__["h" /* isWrapperApp */];
    },
    classModifiers: function classModifiers() {
      return {
        'notification-item-trade-confirmed': true,
        'notification-item-trade-confirmed--processing': this.isProcessedOrMatched
      };
    },
    showFooter: function showFooter() {
      return !false;
    },
    minPrice: function minPrice() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["h" /* toCents */])(this.data.Offer.PricePerShare);
    },
    minPriceDisplay: function minPriceDisplay() {
      var suffix = this.minPrice === 1 ? 'cent' : 'cents';
      return this.minPrice + ' ' + suffix;
    },
    profit: function profit() {
      return this.data.TotalProfit;
    },
    fee: function fee() {
      return this.data.TotalFees;
    },
    cost: function cost() {
      return this.data.TotalCost;
    },
    risk: function risk() {
      return this.data.TotalRiskChange;
    },
    showRisk: function showRisk() {
      return this.data.ShowRisk;
    },
    contractName: function contractName() {
      return this.data.Name || this.data.LongName;
    },
    marketName: function marketName() {
      return this.data.MarketName;
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["k" /* isMarketSingle */])(this.data);
    },
    history: function history() {
      var source = this.data.History ? this.data.History.map(function (i) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, i);
      }) : [];
      return source.map(function (h) {
        h.PricePerShare = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["h" /* toCents */])(h.PricePerShare);
        return h;
      }) || [];
    },
    dateCreated: function dateCreated() {
      var v = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.data, 'Offer.DateCreated', null);
      return v !== null ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(v).format(DATE_FORMAT) + ' ET' : null;
    },
    defaultTradeType: function defaultTradeType() {
      return parseInt(this.data.Offer.TradeType, 10) || 0;
    },
    offerType: function offerType() {
      return this.data.Offer.TradeType;
    },
    offerId: function offerId() {
      return this.data.Offer.OfferId;
    },
    remainingQuantity: function remainingQuantity() {
      return this.data.Offer.RemainingQuantity;
    },
    isOfferProcessed: function isOfferProcessed() {
      return this.data.History !== null && this.data.History.length > 0 && this.data.Offer.RemainingQuantity !== 0;
    },
    isOfferMatched: function isOfferMatched() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_modules_notifications__["a" /* isOfferMatched */])(this.data);
    },
    isOpenOfferRecorded: function isOpenOfferRecorded() {
      return this.data.Offer.RemainingQuantity !== 0;
    },
    isProcessedOrMatched: function isProcessedOrMatched() {
      return this.isOfferProcessed || this.isOfferMatched;
    },
    offerStatusLongText: function offerStatusLongText() {
      if (this.isOfferProcessed) return 'Order Matched!';
      if (this.isOfferMatched) return 'Order Matched!';
      if (this.isOpenOfferRecorded) return 'Order Recorded';
      return null;
    },
    showHistory: function showHistory() {
      return this.isProcessedOrMatched && this.history && this.history.length > 0;
    },
    showCashFooter: function showCashFooter() {
      return this.isProcessedOrMatched && this.advanced;
    },
    showOpenOfferRecordedFooter: function showOpenOfferRecordedFooter() {
      return this.isOpenOfferRecorded && this.advanced;
    },
    showToggle: function showToggle() {
      return true;
      // return this.isProcessedOrMatched;
    },
    showProfitLoss: function showProfitLoss() {
      return this.defaultTradeType > 1;
    },
    showFees: function showFees() {
      return this.defaultTradeType > 1 && this.fee !== 0;
    },
    shareText: function shareText() {
      if (this.history.length > 0) {
        if (this.defaultTradeType <= 1) {
          // show max price when user buy shares
          var _h = this.history.reduce(function (prev, current) {
            return prev.PricePerShare > current.PricePerShare ? prev : current;
          });
          return this.getShareText('buy', _h.Quantity, _h.PricePerShare);
        }
        // show min price when user sell shares
        var h = this.history.reduce(function (prev, current) {
          return prev.PricePerShare < current.PricePerShare ? prev : current;
        });
        return this.getShareText('sell', h.Quantity, h.PricePerShare);
      }
      if (this.defaultTradeType <= 1) {
        return this.getShareText('buy-offer', this.remainingQuantity, this.minPrice);
      }
      return this.getShareText('sell-offer', this.remainingQuantity, this.minPrice);
    },
    shareUrl: function shareUrl() {
      var resolved = this.$router.resolve({
        name: 'market-details',
        params: {
          marketId: this.data.MarketId,
          marketUrl: this.data.MarketUrl
        }
      });
      return '' + window.location.origin + resolved.href;
    },
    facebookShareUrl: function facebookShareUrl() {
      var pictureUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["E" /* getAssetPath */])('/images/Contracts/' + this.data.ImageName);
      return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.shareUrl) + '&picture=' + encodeURIComponent(pictureUrl) + '&quote=' + encodeURIComponent(this.shareText);
    },
    twitterShareUrl: function twitterShareUrl() {
      return 'http://twitter.com/share?text=' + encodeURIComponent(this.shareText) + '&url=' + encodeURIComponent(this.shareUrl);
    },
    toggleButtonModifiers: function toggleButtonModifiers() {
      return {
        'notification-item-trade-confirmed__toggle': true,
        'notification-item-trade-confirmed__toggle--on': this.advanced
      };
    },
    profitOrLossText: function profitOrLossText() {
      return this.data.TotalProfit > 0 ? 'Profit' : 'Loss';
    },
    bottomContainerClassModifiers: function bottomContainerClassModifiers() {
      return {
        'notification-item-trade-confirmed__container': true,
        'notification-item-trade-confirmed__container--simple': !this.isProcessedOrMatched,
        'notification-item-trade-confirmed__container--border': this.isProcessedOrMatched
      };
    },
    mailto: function mailto() {
      var text = this.shareText;
      var newShareText = text.replace(' @PredictIt', '');
      return 'mailto:?body=' + newShareText + escape('\r\n') + escape('\r\n') + escape('\r\n') + this.shareUrl + '&subject=I just traded on PredictIt.org!';
    }
  },
  methods: {
    soldOrBoughtTextOffer: function soldOrBoughtTextOffer() {
      return this.defaultTradeType <= 1 ? 'Buy Order' : 'Sell Order';
    },
    soldOrBoughtText: function soldOrBoughtText() {
      var tradeType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var isHistoryPresent = !!this.data.History;
      if (tradeType === null) return this.soldOrBoughtText(this.defaultTradeType);
      if (tradeType <= 1) return isHistoryPresent ? 'Bought' : 'Buy';
      return isHistoryPresent ? 'Sold' : 'Sell';
    },
    isYes: function isYes(tradeType) {
      return tradeType === 1 || tradeType === 3;
    },
    yesNoText: function yesNoText(tradeType) {
      return this.isYes(tradeType) ? 'YES' : 'NO';
    },
    tradeTypeClassModifier: function tradeTypeClassModifier(tradeType) {
      return {
        'notification-item-trade-confirmed__num-shares': true,
        'notification-item-trade-confirmed__num-shares--yes': this.isYes(tradeType),
        'notification-item-trade-confirmed__num-shares--no': !this.isYes(tradeType)
      };
    },
    onToggle: function onToggle() {
      this.advanced = !this.advanced;
    },
    openShareDialog: function openShareDialog(url) {
      window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
    },
    onEmailShare: function onEmailShare() {
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__["a" /* withMeta */])({ event: 'Share-Email' }));
    },
    onFacebookShare: function onFacebookShare() {
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__["a" /* withMeta */])({ event: 'Share-Facebook' }));
      this.openShareDialog(this.facebookShareUrl);
    },
    onTwitterShare: function onTwitterShare() {
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__["a" /* withMeta */])({ event: 'Share-Twitter' }));
      this.openShareDialog(this.twitterShareUrl);
    },
    getShareText: function getShareText(type, quantity, pricePerShare) {
      var soldOrBoughtShareText = 'I just bought';
      switch (type) {
        default:
        case 'buy':
          break;
        case 'sell':
          soldOrBoughtShareText = 'I just sold';
          break;
        case 'buy-offer':
          soldOrBoughtShareText = "I'm placing an order to buy";
          break;
        case 'sell-offer':
          soldOrBoughtShareText = "I'm placing an order to sell";
          break;
      }

      var suffix = quantity > 1 ? 'shares' : 'share';
      var tradeTypeText = this.defaultTradeType === 0 || this.defaultTradeType === 2 ? 'No' : 'Yes';
      var contractSuffix = this.isMarketSingle ? '' : ' in \'' + this.contractName + '\'';
      var shares = quantity + ' ' + tradeTypeText + ' ' + suffix + contractSuffix;

      return soldOrBoughtShareText + ' ' + shares + ' for ' + pricePerShare + '\xA2 in this market. @PredictIt';
    }
  }
});

/***/ }),

/***/ "Bmi9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-key-stats"},[_c('div',{staticClass:"market-key-stats__title"},[_vm._v(_vm._s(_vm.obj.title))]),_vm._v(" "),_c('div',{staticClass:"market-key-stats__content"},_vm._l((_vm.items),function(elem,index){return _c('market-key-stats-element',{key:index,attrs:{"widget":elem}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bo+i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CAq+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__ = __webpack_require__("5Oj8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");

/* eslint-disable no-restricted-syntax,consistent-return */






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    stateCode: {
      type: String
    },
    stateName: {
      type: String
    },
    marketData: {
      type: Object
    },
    type: {}
  },
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_2__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  data: function data() {
    return {
      capitalizeFirstLetter: __WEBPACK_IMPORTED_MODULE_5__utils_helpers__["p" /* capitalizeFirstLetter */],
      toCents: __WEBPACK_IMPORTED_MODULE_5__utils_helpers__["h" /* toCents */]
    };
  },

  computed: {
    isSenate: function isSenate() {
      return this.type === 'senate';
    },
    color: function color() {
      return this.pallette.color;
    },
    showNote: function showNote() {
      var statesForNote = ['ME', 'NE'];
      return statesForNote.includes(this.stateCode) && !this.isSenate;
    },
    winnerMode: function winnerMode() {
      return this.targetContract !== null;
      // return get(this.marketData, 'status', 'Open') === constants.MARKET_CLOSED;
    },
    winnerBgColorStyleModifiers: function winnerBgColorStyleModifiers() {
      return {
        'background-color': this.color
      };
    },
    targetContract: function targetContract() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["s" /* getLeadingTradedContract */])(this.marketData.contracts || []);
    },
    targetContractInstance: function targetContractInstance() {
      return new __WEBPACK_IMPORTED_MODULE_3__models_contract__["a" /* default */](this.targetContract || {});
    },
    classModifiers: function classModifiers() {
      return {
        'market-state-tooltip': true
      };
    },
    styleModifiers: function styleModifiers() {
      return {
        border: '4px solid ' + this.color
      };
    },
    titleClassModifiers: function titleClassModifiers() {
      // const lightPallettes = [
      //   COLOR_MAP.GRAY[0],
      //   COLOR_MAP.BLUE[0],
      //   COLOR_MAP.RED[0],
      // ];
      return {
        'market-state-tooltip__state-name': true
        // 'market-state-tooltip__state-name--light': lightPallettes.includes(this.pallette),
      };
    },
    titleStyleModifiers: function titleStyleModifiers() {
      return {
        background: this.color
      };
    },
    pallette: function pallette() {
      if (!this.targetContract) {
        return __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].GRAY[1];
      }

      var pallette = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["a" /* getColorForPalletteCandidate */])(this.targetContract.contractName);
      var factor = pallette[0].from + this.targetContract.lastTradePrice;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(pallette), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (factor <= item.to) {
            return item;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return pallette[pallette.length - 1];
    },
    contracts: function contracts() {
      return (this.marketData.contracts || []).map(function (i) {
        return new __WEBPACK_IMPORTED_MODULE_3__models_contract__["a" /* default */](i);
      });
    }
  },
  methods: {
    getNameDisplay: function getNameDisplay(contract) {
      var parts = (contract.contractName || '').split(' ');
      return parts.length > 1 ? parts[1] : contract.contractName;
    },
    contractClassModifiers: function contractClassModifiers(contract, index) {
      return {
        'market-state-tooltip__contract': true,
        'market-state-tooltip__contract--with-border': index === 0
      };
    },
    imageStyleModifiers: function imageStyleModifiers(contract) {
      return {
        'background-image': 'url(' + contract.contractImageUrl + ')'
      };
    },
    onTooltipClick: function onTooltipClick() {
      if (this.marketData.marketId) {
        window.location.href = 'https://www.predictit.org/markets/detail/' + this.marketData.marketId;
      }
    }
  },
  created: function created() {
    if (this.stateCode !== 'GA2') {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('market/setMarketMapTooltipVisible', true);
    }
  }
});

/***/ }),

/***/ "CAth":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_page_election_map_new_election_map_toolbar_election_map_toolbar_vue__ = __webpack_require__("yhSh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_table_election_map_table_vue__ = __webpack_require__("6Fjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_special_election_map_special_vue__ = __webpack_require__("09fK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_chart_models__ = __webpack_require__("Q+EN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_page_election_map_new_overview_map_overview_map_vue__ = __webpack_require__("Shp1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__election_map_constants__ = __webpack_require__("5Oj8");
/* unused harmony reexport CONTRACTS */
/* unused harmony reexport COLOR_INDEXES */
/* unused harmony reexport PRICE_FACTORS */
/* unused harmony reexport COLOR_MAP */
/* unused harmony reexport getColorForPalletteCandidate */










// Moved to ./election-map-constants.js to break circular imports with the
// sibling components; re-exported here for backward compatibility.


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_loader__["a" /* default */]],
  components: {
    electionMapToolbar: __WEBPACK_IMPORTED_MODULE_2__components_pages_page_election_map_new_election_map_toolbar_election_map_toolbar_vue__["a" /* default */],
    electionMapTable: __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_table_election_map_table_vue__["a" /* default */],
    electionMapSpecial: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_special_election_map_special_vue__["a" /* default */],
    overviewMap: __WEBPACK_IMPORTED_MODULE_6__components_pages_page_election_map_new_overview_map_overview_map_vue__["a" /* default */]
  },
  data: function data() {
    return {
      type: 'senate'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('market', ['mapStateData', 'mapOverviewData', 'mapStateDataSenate', 'mapOverviewDataSenate']), {
    ChartClass: function ChartClass() {
      if (this.type === 'electoral') {
        return __WEBPACK_IMPORTED_MODULE_5__utils_chart_models__["d" /* ElectionMapChartParty */];
      }
      if (this.type === 'senate') {
        return __WEBPACK_IMPORTED_MODULE_5__utils_chart_models__["e" /* ElectionMapChartSenate */];
      }
      return __WEBPACK_IMPORTED_MODULE_5__utils_chart_models__["f" /* ElectionMapChartOverall */];
    }
  }),
  watch: {
    type: {
      handler: 'typeHandler',
      immediate: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('market', ['getMapStateData', 'getMapOverviewData', 'getMapOverviewDataSenate', 'getMapStateDataSenate']), {
    typeHandler: function typeHandler() {
      var _this = this;

      this.loaderAdd();
      if (this.type === 'electoral') {
        this.getMapOverviewData().then(function () {
          return _this.getMapStateData();
        }).then(function (data) {
          return _this.createChart(data);
        }).then(function () {
          return _this.loaderRemove();
        }).catch(function () {
          return _this.loaderRemove();
        });
      } else if (this.type === 'senate') {
        this.getMapOverviewDataSenate().then(function () {
          return _this.getMapStateDataSenate();
        }).then(function (data) {
          return _this.createChart(data);
        }).then(function () {
          return _this.loaderRemove();
        }).catch(function () {
          return _this.loaderRemove();
        });
      }
    },
    createChart: function createChart(data) {
      var _this2 = this;

      setTimeout(function () {
        _this2.renderChart(data);
      }, this.ChartClass.renderTimeout());
    },
    renderChart: function renderChart(data) {
      if (!this.$refs.chart) return;
      var group = new this.ChartClass(data);
      group.draw(this.$refs.chart);
    },
    onToggle: function onToggle() {
      this.type = this.type === 'electoral' ? 'senate' : 'electoral';
    }
  }),
  created: function created() {
    if (this.$route.query.map) {
      this.type = this.$route.query.map;
    }
  }
});

/***/ }),

/***/ "CAzF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_modal_js__ = __webpack_require__("Y+KT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a5cc634_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__ = __webpack_require__("4cn4");
function injectStyle (ssrContext) {
  __webpack_require__("dx0n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_modal_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a5cc634_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CIck":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_markets_js__ = __webpack_require__("i3z8");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67b59c4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_markets_vue__ = __webpack_require__("Lhbh");
function injectStyle (ssrContext) {
  __webpack_require__("Kg0Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_markets_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67b59c4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_markets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CLCK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.classModifiers,attrs:{"to":_vm.routeTo}},[_c('div',{class:_vm.iconClassModifiers,style:(_vm.iconStyleModifiers)}),_vm._v(" "),_c('div',{staticClass:"notification-item-dashboard__content"},[_c('div',{staticClass:"notification-item-dashboard__title"},[_c('div',{staticClass:"notification-item-dashboard__title-left"},[_vm._v("\n        "+_vm._s(_vm.data.contentJson.Title)+"\n      ")]),_vm._v(" "),(_vm.showPriceChange && !_vm.showTimeElapsed)?[_c('div',{staticClass:"notification-item-dashboard__title-right"},[_vm._v("\n          "+_vm._s(_vm.lastTradePriceAsCents)+"¢\n          "),_c('market-change-price',{attrs:{"price":_vm.data.contentJson.PriceDelta}})],1)]:_vm._e()],2),_vm._v(" "),(_vm.showContractName)?_c('h5',{directives:[{name:"contract-name",rawName:"v-contract-name"}],staticClass:"notification-item-dashboard__contract-name"},[_vm._v("\n      "+_vm._s(_vm.data.contentJson.ContractName)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.showLevelChanged)?[_c('h5',{staticClass:"notification-item-dashboard__market-name"},[_vm._v("\n        "+_vm._s(_vm.data.contentJson.Body)+"\n      ")]),_vm._v(" "),(_vm.showNextLevelInfo)?_c('h5',{staticClass:"notification-item-dashboard__level-changed-info"},[_vm._v("\n        "+_vm._s(_vm.getProgressInfoTextForLevel(_vm.data.contentJson.NewTraderLevel, _vm.data.contentJson.ProfitablePredictions))+"\n      ")]):_vm._e()]:_c('h5',{staticClass:"notification-item-dashboard__market-name"},[_vm._v("\n      "+_vm._s(_vm.data.contentJson.MarketName)+"\n    ")]),_vm._v(" "),(_vm.showPayout)?[_c('div',{staticClass:"notification-item-dashboard__payout"},[_vm._v("\n        Payout: "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.round2.fixed",value:(_vm.data.contentJson.Cash),expression:"data.contentJson.Cash",modifiers:{"round2":true,"fixed":true}}]})])]:_vm._e(),_vm._v(" "),(_vm.showSellInfo)?[_c('div',{staticClass:"notification-item-dashboard__sell-info"},[_vm._v("\n        "+_vm._s(_vm.tradeTypeOperation)+" "+_vm._s(_vm.quantity)+" "+_vm._s(_vm.yesNoText)+"\n        "),(_vm.tradeTypeShare)?_c('span',{staticClass:"notification-item-dashboard__sell-info-contract"},[_vm._v("\n          in "+_vm._s(_vm.tradeTypeShare)+"\n        ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"notification-item-dashboard__sell-info-price"},[_vm._v("\n          @ "+_vm._s(_vm.pricePerShare)+"¢\n        ")])])]:_vm._e(),_vm._v(" "),(_vm.showSharesOwned)?[_c('div',{staticClass:"notification-item-dashboard__shares"},[_vm._v("\n        "+_vm._s(_vm.sharesOwned)+" "+_vm._s(_vm.yesNoText)+" Share"),(_vm.sharesOwned >1)?[_vm._v("s")]:_vm._e(),_vm._v(" Owned\n      ")],2)]:_vm._e(),_vm._v(" "),(_vm.showTimeElapsed)?_c('div',{staticClass:"notification-item-dashboard__time-elapsed"},[_vm._v("\n      "+_vm._s(_vm.timeElapsed)+"\n    ")]):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.closeButton),expression:"closeButton"}],staticClass:"notification-item-dashboard__close",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onClose($event)}}})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CP5y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CPTB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__ = __webpack_require__("wU6a");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_526c5450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slide_vue__ = __webpack_require__("GH+k");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_526c5450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CPcE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__ = __webpack_require__("hygk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__("H/Zg");

 /* eslint-disable max-len */



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    chartData: [],
    latestChartParams: {}
  },
  mutations: {
    setLatestChartParams: function setLatestChartParams(state, value) {
      state.latestChartParams = value;
    },
    setChartData: function setChartData(state, value) {
      state.chartData = value;
    }
  },
  actions: {
    getMarketChartData: function getMarketChartData(_ref, _ref2) {
      var commit = _ref.commit,
          state = _ref.state;
      var params = _ref2.params,
          _ref2$cache = _ref2.cache,
          cache = _ref2$cache === undefined ? false : _ref2$cache;

      if (cache && state.latestChartParams && __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default()(params, state.latestChartParams)) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.chartData);
      }
      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].chart.getMarketChartData(params).then(function (response) {
        var data = response.data;
        commit('setLatestChartParams', params);
        commit('setChartData', data);
        return data;
      });
    },
    getContractChartData: function getContractChartData(_ref3, _ref4) {
      var commit = _ref3.commit;
      var contractId = _ref4.contractId,
          timeline = _ref4.timeline;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].chart.getContractChartData(contractId, timeline).then(function (response) {
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "CPvM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_videos_vue__ = __webpack_require__("w1pb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c18a26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_videos_vue__ = __webpack_require__("JdRn");
function injectStyle (ssrContext) {
  __webpack_require__("hbUY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_videos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c18a26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_videos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CRTj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"insight-widget__header"},[_vm._v("\n    Insights\n  ")]),_vm._v(" "),_c('div',{staticClass:"insight-widget__line"}),_vm._v(" "),_c('div',{staticClass:"insight-widget__content"},[_c('insight-panel',{attrs:{"text":"All Articles","href":_vm.allArticlesLink,"away":_vm.allArticlesAway}},[_c('div',{staticClass:"insight-widget__articles"},_vm._l((_vm.tumblr),function(link){return _c('insight-link',{key:link.title,attrs:{"title":link.title,"href":_vm.createLink(link.url),"url":link.url}})}),1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CTjK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CyJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"daily-markets"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"daily-markets__info"},[_vm._v("\n    Access the Market Focus and Daily Markets newsletters to receive comprehensive market insights, news, data analysis, and key indicators at the intersection of politics and prediction markets.\n  ")]),_vm._v(" "),_c('div',{staticClass:"daily-markets__line"}),_vm._v(" "),_c('div',{staticClass:"daily-markets__articles"},_vm._l((_vm.items),function(item){return _c('div',{key:item.link},[_c('router-link',{staticClass:"daily-markets__link",attrs:{"to":_vm.dailyMarketPageLink(item)}},[_vm._v("\n        "+_vm._s(item.title)+"\n      ")])],1)}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"daily-markets__header"},[_c('div',{staticClass:"daily-markets__header-title"},[_vm._v("\n      Newsletters\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cyq+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D+Yn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_market_market_filters_market_filters_mixin_market_filters_mixin__ = __webpack_require__("kGlu");


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_market_market_filters_market_filters_mixin_market_filters_mixin__["a" /* default */]],
  computed: {
    mainClassName: function mainClassName() {
      return 'market-filters-desktop-grid';
    },
    menuClassModifier: function menuClassModifier() {
      return {
        'market-filters-desktop-grid__menu': true,
        'market-filters-desktop-grid__menu--with-timespan-filter': this.shouldShowTimespanFilter
      };
    },
    orderMenuName: function orderMenuName() {
      return this.selectedOrder.fullName;
    }
  }
});

/***/ }),

/***/ "D5rx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_v2_js__ = __webpack_require__("iYpn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_570cd222_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_v2_vue__ = __webpack_require__("tLhP");
function injectStyle (ssrContext) {
  __webpack_require__("FvKT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_v2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_570cd222_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D9Sb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DECz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__ = __webpack_require__("63Fj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__ = __webpack_require__("Moaq");





// maps url parameters to endpoint parameter names
var VARIABLES = {
  PIReferral: 'piReferral',
  utm_campaign: 'marketingProgram',
  utm_source: 'marketingSource',
  utm_code: 'depositPromoCode',
  instant_credit: '',
  mmpInstallId: 'mmpInstallId'
};

function getStorage(name) {
  var localStorageVariables = ['utm_code'];
  if (localStorageVariables.includes(name)) {
    return __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */];
  }
  return __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */];
}

function check(route) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(VARIABLES).forEach(function (key) {
    var value = route.query[key];
    if (value) {
      var storage = getStorage(key);
      storage.set(key, value);
    }
  });
}

function get(name) {
  var storage = getStorage(name);
  var value = storage.get(name, null);
  if (value !== null) {
    return {
      name: VARIABLES[name],
      value: value
    };
  }
  return null;
}

function payload(oldPayload) {
  var data = {};

  for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    names[_key - 1] = arguments[_key];
  }

  names.forEach(function (name) {
    var storage = getStorage(name);
    var value = storage.get(name, null);
    if (value !== null) {
      data[VARIABLES[name]] = value;
    }
  });
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, oldPayload, data);
}

function clear() {
  __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].del('PIReferral');
  __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].del('utm_campaign');
  __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].del('utm_source');
  __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].del('utm_code');
  __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].del('mmpInstallId');
  __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].del('utm_code');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  check: check,
  get: get,
  payload: payload,
  clear: clear
});

/***/ }),

/***/ "DFsO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('popup', ['currentPopupOptions']))
});

/***/ }),

/***/ "DIeW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DJt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textarea",class:_vm.textAreaModifiers},[_c('label',{staticClass:"textarea__label",attrs:{"for":_vm.name}},[_c('div',{staticClass:"textarea__placeholder"},[_vm._v(_vm._s(_vm.placeholder)),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('textarea',{staticClass:"textarea__value",attrs:{"disabled":_vm.disabled,"name":_vm.name,"id":_vm.name,"maxlenght":_vm.maxLength},domProps:{"value":_vm.value},on:{"input":_vm.updateValue,"blur":_vm.handleBlur,"focus":_vm.handleFocus}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DMbv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_info_overview_js__ = __webpack_require__("uHZs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b393450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_info_overview_vue__ = __webpack_require__("URxZ");
function injectStyle (ssrContext) {
  __webpack_require__("MjTP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_info_overview_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b393450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_info_overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DXdo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_link_js__ = __webpack_require__("w70/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77190578_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_link_vue__ = __webpack_require__("PlkO");
function injectStyle (ssrContext) {
  __webpack_require__("usGF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_link_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77190578_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dksu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_currently_predicting_js__ = __webpack_require__("u9HT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ada9a4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_currently_predicting_vue__ = __webpack_require__("Wx+w");
function injectStyle (ssrContext) {
  __webpack_require__("LDV9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_currently_predicting_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ada9a4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_currently_predicting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dlcl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"app-mobile-menu"}},[(_vm.mobileMenuOpened)?_c('div',{staticClass:"app-mobile-menu"},[_c('div',{staticClass:"app-mobile-menu__content-wrap"},[_c('div',{staticClass:"app-mobile-menu__content"},[_c('search-bar',{attrs:{"theme":"menu"}}),_vm._v(" "),(_vm.isLoggedIn && _vm.showBalanceHeader)?[_c('div',{staticClass:"app-mobile-menu__menu-item app-mobile-menu__menu-item--investment",attrs:{"id":"menu-investment"},on:{"click":function($event){$event.preventDefault();return _vm.onInvestmentClick($event)}}},[_c('div',{staticClass:"app-mobile-menu__menu-item-text"},[_vm._v("Investment")]),_vm._v(" "),_c('div',{directives:[{name:"price-display",rawName:"v-price-display.floor.fixed",value:(_vm.balance.portfolioBalanceDecimal),expression:"balance.portfolioBalanceDecimal",modifiers:{"floor":true,"fixed":true}}],staticClass:"app-mobile-menu__menu-item-value"})]),_vm._v(" "),_c('div',{staticClass:"app-mobile-menu__menu-item app-mobile-menu__menu-item--cash",attrs:{"id":"menu-cash"},on:{"click":function($event){$event.preventDefault();return _vm.onCashClick($event)}}},[_c('div',{staticClass:"app-mobile-menu__menu-item-text"},[_vm._v("Cash")]),_vm._v(" "),_c('div',{directives:[{name:"price-display",rawName:"v-price-display.floor.fixed",value:(_vm.balance.accountBalanceDecimal),expression:"balance.accountBalanceDecimal",modifiers:{"floor":true,"fixed":true}}],staticClass:"app-mobile-menu__menu-item-value"})]),_vm._v(" "),_c('div',{staticClass:"app-mobile-menu__menu-item app-mobile-menu__menu-item--deposit",attrs:{"id":"menu-deposit"},on:{"click":function($event){$event.preventDefault();return _vm.openDepositPopup($event)}}},[_c('div',{staticClass:"app-mobile-menu__menu-item-text"},[_vm._v("Deposit")]),_vm._v(" "),_c('div',{staticClass:"app-mobile-menu__menu-item-icon app-mobile-menu__menu-item-icon--deposit"})])]:(!_vm.isLoggedIn)?[(!_vm.isUserRestricted)?_c('div',{staticClass:"app-mobile-menu__menu-item app-mobile-menu__menu-item--register",attrs:{"id":"menu-signup"},on:{"click":_vm.onSignUp}},[_c('div',{staticClass:"app-mobile-menu__menu-item-text"},[_vm._v("Sign Up")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-mobile-menu__menu-item app-mobile-menu__menu-item--login",attrs:{"id":"menu-login"},on:{"click":_vm.onLogin}},[_c('div',{staticClass:"app-mobile-menu__menu-item-text"},[_vm._v("Login")])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-mobile-menu__nav"},[_vm._l((_vm.enabledLinks),function(item){return _c('router-link',{key:("menu-nav-" + (item.name)),class:_vm.itemClassModifiers(item),attrs:{"tag":"div","id":("menu-nav-" + (item.name)),"to":item.href},nativeOn:{"click":function($event){return _vm.onLinkClick(item.href)}}},[_c('div',{staticClass:"app-mobile-menu__nav-item-text"},[_vm._v("\n              "+_vm._s(item.title.toString())+"\n            ")]),_vm._v(" "),(item.name === 'dashboard')?_c('account-social-avatar',{attrs:{"theme":"mobile-menu","avatar":_vm.userAvatar,"showProgress":true,"percentage":100,"progressStrokeColor":_vm.levelColorWithRespectToNav,"showEdit":false}}):_c('div',{class:_vm.itemIconClassModifiers(item)})],1)}),_vm._v(" "),(_vm.isLoggedIn)?_c('div',{staticClass:"app-mobile-menu__nav-item",on:{"click":_vm.logoutButton}},[_c('div',{staticClass:"app-mobile-menu__nav-item-text"},[_vm._v("LOGOUT")]),_vm._v(" "),_c('div',{staticClass:"app-mobile-menu__nav-item-icon app-mobile-menu__nav-item-icon--logout"})]):_vm._e()],2)],2),_vm._v(" "),(false)?_c('div',{staticClass:"app-mobile-menu__classic-exchange"},[_c('div',{staticClass:"app-mobile-menu__classic-exchange__content"},[_c('div',{staticClass:"app-mobile-menu__classic-exchange__mask",on:{"click":_vm.showLeavingPopup}}),_vm._v(" "),_c('div',{staticClass:"app-mobile-menu__classic-exchange__bar"})])]):_vm._e()])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DsFz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      type: Number
    },
    symbol: {
      type: String,
      default: '&cent;'
    }
  },
  data: function data() {
    return {
      isNewValueGreater: false
    };
  },

  watch: {
    value: {
      handler: function handler(newValue, oldValue) {
        this.isNewValueGreater = newValue > oldValue;
      },

      deep: false
    }
  },
  computed: {
    transitionName: function transitionName() {
      return this.isNewValueGreater ? 'animated-number--high' : 'animated-number--low';
    }
  }
});

/***/ }),

/***/ "DvJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_bottom_nav_js__ = __webpack_require__("uo5Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b1c0876_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_bottom_nav_vue__ = __webpack_require__("fHHP");
function injectStyle (ssrContext) {
  __webpack_require__("8EqH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_bottom_nav_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b1c0876_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_bottom_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DvL7":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEyLjI0IDEwLjI4NVYxNC40aDYuODA2Yy0uMjc1IDEuNzY1LTIuMDU2IDUuMTc0LTYuODA2IDUuMTc0LTQuMDk1IDAtNy40MzktMy4zODktNy40MzktNy41NzRzMy4zNDUtNy41NzQgNy40MzktNy41NzRjMi4zMyAwIDMuODkxLjk4OSA0Ljc4NSAxLjg0OWwzLjI1NC0zLjEzOEMxOC4xODkgMS4xODYgMTUuNDc5IDAgMTIuMjQgMGMtNi42MzUgMC0xMiA1LjM2NS0xMiAxMnM1LjM2NSAxMiAxMiAxMmM2LjkyNiAwIDExLjUyLTQuODY5IDExLjUyLTExLjcyNiAwLS43ODgtLjA4NS0xLjM5LS4xODktMS45ODlIMTIuMjR6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "Dwlj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_notifications__ = __webpack_require__("tjp7");


/* eslint-disable */



var DEFAULT_TOP_POSITION = 0;
var DEFAULT_RESET_POSITION_TIMEOUT = 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    lastTopPosition: DEFAULT_TOP_POSITION,
    currentPopup: null,
    currentSmallPopup: null,
    tradePopupOptions: {},
    currentPopupOptions: {},
    formDataCache: null,
    remember: {}
  },
  mutations: {
    setCurrentPopup: function setCurrentPopup(state, popupName) {
      if (popupName) {
        state.lastTopPosition = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
      }
      state.currentPopup = popupName;
      state.currentPopupOptions = {};
    },
    setCurrentSmallPopup: function setCurrentSmallPopup(state, popupName) {
      if (popupName) {
        state.lastTopPosition = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
      }
      state.currentSmallPopup = popupName;
    },
    setTradePopupOptions: function setTradePopupOptions(state, options) {
      state.tradePopupOptions = options;
    },
    setCurrentPopupOptions: function setCurrentPopupOptions(state, options) {
      state.currentPopupOptions = options;
    },
    cacheFormData: function cacheFormData(state, payload) {
      state.formDataCache = payload;
    },
    rememberPopup: function rememberPopup(state, _ref) {
      var route = _ref.route,
          popup = _ref.popup;

      state.remember = {
        route: route,
        popup: popup
      };
    },
    restorePopup: function restorePopup(state, payload) {
      if (state.remember.route === payload) {
        state.currentPopup = state.remember.popup;
      }
      state.remember = {};
    },
    resetLastTopPosition: function resetLastTopPosition(state) {
      state.lastTopPosition = DEFAULT_TOP_POSITION;
    },
    updateTradePopupOptionsMarketFromNotification: function updateTradePopupOptionsMarketFromNotification(state, data) {
      if (state.tradePopupOptions && state.tradePopupOptions.market) {
        state.tradePopupOptions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.tradePopupOptions, {
          market: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_notifications__["a" /* updateMarket */])(state.tradePopupOptions.market, data)
        });
      }
    },
    updateTradePopupOptionsContractsFromNotification: function updateTradePopupOptionsContractsFromNotification(state, data) {
      if (state.tradePopupOptions && state.tradePopupOptions.market) {
        state.tradePopupOptions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.tradePopupOptions, {
          market: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_notifications__["b" /* updateMarketContracts */])(state.tradePopupOptions.market, data)
        });
      }
    }
  },
  actions: {
    setCurrentPopupWithDelay: function setCurrentPopupWithDelay(_ref2, _ref3) {
      var commit = _ref2.commit;
      var name = _ref3.name,
          _ref3$options = _ref3.options,
          options = _ref3$options === undefined ? {} : _ref3$options;

      commit('setCurrentPopup', null);
      setTimeout(function () {
        commit('setCurrentPopup', name);
        commit('setCurrentPopupOptions', options);
      }, 1000);
    },
    setTradePopup: function setTradePopup(_ref4, _ref5) {
      var commit = _ref4.commit;
      var name = _ref5.name,
          options = _ref5.options;

      commit('setCurrentPopup', name);
      commit('setTradePopupOptions', options);
    },
    setCurrentPopup: function setCurrentPopup(_ref6) {
      var commit = _ref6.commit,
          state = _ref6.state;
      var popupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        commit('setCurrentPopup', popupName);
        if (!popupName && state.lastTopPosition !== DEFAULT_TOP_POSITION) {
          resolve();
        } else {
          resolve();
        }
      });
    },
    setCurrentSmallPopup: function setCurrentSmallPopup(_ref7) {
      var commit = _ref7.commit,
          state = _ref7.state;
      var popupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      commit('setCurrentSmallPopup', popupName);
    },
    setTradePopupOptions: function setTradePopupOptions(_ref8, options) {
      var commit = _ref8.commit;

      commit('setTradePopupOptions', options);
    },
    setCurrentPopupOptions: function setCurrentPopupOptions(_ref9, options) {
      var commit = _ref9.commit;

      commit('setCurrentPopupOptions', options);
    },
    setGenericPopup: function setGenericPopup(_ref10, popup) {
      var commit = _ref10.commit;

      commit('setCurrentPopup', popup.name);
      commit('setCurrentPopupOptions', popup.options);
    },
    setGenericSmallPopup: function setGenericSmallPopup(_ref11, popup) {
      var commit = _ref11.commit;

      commit('setCurrentSmallPopup', popup.name);
      commit('setCurrentPopupOptions', popup.options);
    },
    setErrorPopup: function setErrorPopup(_ref12) {
      var commit = _ref12.commit;
      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      commit('setCurrentSmallPopup', 'generic-small');
      commit('setCurrentPopupOptions', {
        title: 'Error',
        icon: 'error',
        iconTitle: 'Error!',
        content: content
      });
    },
    setSuccessPopup: function setSuccessPopup(_ref13) {
      var commit = _ref13.commit;
      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Operation successful.';

      commit('setCurrentSmallPopup', 'generic-small');
      commit('setCurrentPopupOptions', {
        title: 'Success',
        icon: 'success',
        iconTitle: 'Success!',
        content: content
      });
    },
    setSuccessPopupWithTimeoutCallback: function setSuccessPopupWithTimeoutCallback(_ref14, _ref15) {
      var _this = this;

      var commit = _ref14.commit;
      var _ref15$content = _ref15.content,
          content = _ref15$content === undefined ? 'Operation successful.' : _ref15$content,
          _ref15$callback = _ref15.callback,
          callback = _ref15$callback === undefined ? function () {} : _ref15$callback;

      var callBackApplied = false;
      var timeout = setTimeout(function () {
        callBackApplied = true;
        callback.apply(_this);
      }, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DEFAULT_SMALL_POPUP_TIMEOUT);
      commit('setCurrentSmallPopup', 'generic-small');
      commit('setCurrentPopupOptions', {
        title: 'Success',
        icon: 'success',
        iconTitle: 'Success!',
        onClose: function onClose() {
          if (!callBackApplied) {
            clearTimeout(timeout);
            callback.apply(_this);
          }
        },
        content: content
      });
    },
    cacheFormData: function cacheFormData(_ref16, payload) {
      var commit = _ref16.commit;

      commit('cacheFormData', payload);
    },
    rememberPopup: function rememberPopup(_ref17, route) {
      var commit = _ref17.commit,
          state = _ref17.state;

      commit('rememberPopup', route);
    },
    restorePopup: function restorePopup(_ref18, route) {
      var commit = _ref18.commit;

      commit('restorePopup', route);
    },
    updateTradePopupOptionsMarketFromNotification: function updateTradePopupOptionsMarketFromNotification(_ref19, data) {
      var commit = _ref19.commit;

      commit('updateTradePopupOptionsMarketFromNotification', data);
    },
    updateTradePopupOptionsContractsFromNotification: function updateTradePopupOptionsContractsFromNotification(_ref20, data) {
      var commit = _ref20.commit;

      commit('updateTradePopupOptionsContractsFromNotification', data);
    }
  }
});

/***/ }),

/***/ "Dz7g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E0tW":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "E5wa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_page_election_map_new_election_map_election_map_constants__ = __webpack_require__("5Oj8");








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    item: {
      type: Object,
      required: true
    },
    type: {
      type: String
    }
  },
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'overview-map-contract': true
      }, 'overview-map-contract--' + this.type, this.type);
    },
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_4__models_contract__["a" /* default */](this.item);
    },
    color: function color() {
      var pallette = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__components_pages_page_election_map_new_election_map_election_map_constants__["a" /* getColorForPalletteCandidate */])(this.item.shortName);
      return pallette[__WEBPACK_IMPORTED_MODULE_6__components_pages_page_election_map_new_election_map_election_map_constants__["c" /* COLOR_INDEXES */].HIGH].color;
    },
    bgColorStyleModifiers: function bgColorStyleModifiers() {
      return {
        'background-color': this.color
      };
    },
    imageStyleModifiers: function imageStyleModifiers() {
      return {
        'background-image': 'url(\'' + this.item.contractImageUrl + '\')'
      };
    },
    marketDetailUrl: function marketDetailUrl() {
      if (!__WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__["i" /* isStandalone */]) {
        return this.type === 'senate' ? 'https://www.predictit.org/markets/detail/6874' : 'https://www.predictit.org/markets/detail/3698';
      }
      return '#';
    }
  })
});

/***/ }),

/***/ "EAXV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('div',{staticClass:"deposit-promotions-banner",class:_vm.bannerLevelClass},[(_vm.showHeader)?_c('div',{staticClass:"deposit-promotions-banner__header"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"}},[_c('rect',{attrs:{"width":"18","height":"18","rx":"9","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M11.8356 6.14931C11.6699 5.54157 10.8677 4.32611 8.98479 4.32611C8.07871 4.30401 6.26656 4.65746 6.16711 6.54691C6.07289 8.33702 8.18921 8.76808 8.98479 9.06642C9.93507 9.24318 11.8356 9.97459 11.8356 11.4862C11.8356 13.3757 9.48203 13.7735 8.98479 13.7735C8.48755 13.7735 6.46546 13.6077 6.16711 11.9834M8.98479 3L8.98478 15","stroke":"white","stroke-linecap":"round"}})]),_vm._v(" "),_c('span',[_vm._v("Available Promotions")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('div',{key:item.key,staticClass:"deposit-promotions-banner__item",class:_vm.itemClass(item)},[(_vm.showHeader)?_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 19 19","fill":"none"}},[_c('path',{attrs:{"d":"M13.875 5.625L8.625 12.75L4.875 9.75","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M9.375 18C14.1385 18 18 14.1385 18 9.375C18 4.61154 14.1385 0.75 9.375 0.75C4.61154 0.75 0.75 4.61154 0.75 9.375C0.75 14.1385 4.61154 18 9.375 18Z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})]):_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"}},[_c('rect',{attrs:{"width":"18","height":"18","rx":"9","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M11.8356 6.14931C11.6699 5.54157 10.8677 4.32611 8.98479 4.32611C8.07871 4.30401 6.26656 4.65746 6.16711 6.54691C6.07289 8.33702 8.18921 8.76808 8.98479 9.06642C9.93507 9.24318 11.8356 9.97459 11.8356 11.4862C11.8356 13.3757 9.48203 13.7735 8.98479 13.7735C8.48755 13.7735 6.46546 13.6077 6.16711 11.9834M8.98479 3L8.98478 15","stroke":"white","stroke-linecap":"round"}})]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(item.text)}})])})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EFuq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EGLE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__("c/9r");



/*
  Use this component as <captcha :key="parentVar"></captcha>
  and update var on error, so it rerenders properly.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      key: '',
      widgetId: undefined
    };
  },

  computed: {
    styleModifiers: function styleModifiers() {
      return {
        transform: 'scale(0.95)'
      };
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['getCaptchaSiteKey']), {
    onSuccess: function onSuccess(value) {
      this.$emit('input', value);
    },
    onExpired: function onExpired() {
      this.$emit('input', null);
    }
  }),
  mounted: function mounted() {
    var _this = this;

    var url = 'https://www.google.com/recaptcha/api.js';
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["f" /* loadScript */])(url, 'grecaptcha').then(function (grecaptcha) {
      _this.getCaptchaSiteKey().then(function (data) {
        _this.key = data;
        grecaptcha.ready(function () {
          _this.widgetId = grecaptcha.render(_this.$refs.captcha, {
            sitekey: _this.key,
            callback: _this.onSuccess,
            'expired-callback': _this.onExpired
          });
        });
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (window.grecaptcha && typeof this.widgetId !== 'undefined') {
      window.grecaptcha.reset(this.widgetId);
    }
  }
});

/***/ }),

/***/ "EIVR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_loader_js__ = __webpack_require__("7fpX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_448d5fde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_loader_vue__ = __webpack_require__("xpMb");
function injectStyle (ssrContext) {
  __webpack_require__("Fokc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_loader_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_448d5fde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EKBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    showHeader: function showHeader() {
      return this.items.length > 1;
    },
    bannerLevel: function bannerLevel() {
      return this.items.length && this.items.every(function (item) {
        return item.level === 'warning';
      }) ? 'warning' : 'success';
    },
    bannerLevelClass: function bannerLevelClass() {
      return 'deposit-promotions-banner--' + this.bannerLevel;
    }
  },
  methods: {
    itemClass: function itemClass(item) {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'deposit-promotions-banner__item--' + (item.level || 'success'), true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'deposit-promotions-banner__item--single', !this.showHeader), _ref;
    }
  }
});

/***/ }),

/***/ "ENdH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setToken */
/* unused harmony export addListener */
/* unused harmony export connect */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return forceReconnect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createConnection; });
/* unused harmony export isConnected */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return forceDisconnect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* global $ */
/* eslint-disable */



var STATES = ['connecting', 'connected', 'reconnecting', '', 'disconnected'];
var reconnectTimeout = 5 * 1000;
var channelMarketHub = null;
var connection = null;
var reconnectDisabled = false;

function createConnection(_ref) {
  var apiToken = _ref.apiToken,
      onUpdate = _ref.onUpdate;

  __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'createConnection::', apiToken);
  if (typeof $ !== 'undefined' && typeof $.hubConnection !== 'undefined') {
    connection = $.hubConnection("https://hub.predictit.org/signalr", {
      useDefaultPath: false
    });
    channelMarketHub = connection.createHubProxy('marketHub');
    if (apiToken) {
      setToken({ apiToken: apiToken });
    }
    if (isConnected()) {
      addListener({ onUpdate: onUpdate });
      connect();
    }
    return true;
  }
  return false;
}

var isConnected = function isConnected() {
  return connection !== null;
};

var connect = function connect() {
  if (!isConnected()) return;
  channelMarketHub.on('update', function (objectType, object) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'marketHub::', 'update::', objectType, object);
  });
  connection.start().done(function (state) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'connection::', 'connected::', state.id, state);
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('app/setSignalrInitialized', true);
  }).fail(function (error) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'connection::', 'errored::', error);
    if (reconnectDisabled) {
      __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: reconnect-disabled::');
    } else {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: reconnect::');
        connection.start();
      }, reconnectTimeout);
    }
  });
  connection.starting(function () {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: starting::');
  });
  connection.received(function (data) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'received::', data);
  });
  connection.connectionSlow(function () {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: connectionSlow::');
  });
  connection.reconnecting(function () {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: reconnecting::');
  });
  connection.reconnected(function () {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: reconnected::');
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('app/setSignalrInitialized', true);
  });
  connection.stateChanged(function (change) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: stateChanged::', STATES[change.oldState], ' => ', STATES[change.newState]);
  });
  connection.disconnected(function () {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: disconnected::', connection.lastError);
    if (reconnectDisabled) {
      __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: reconnect-disabled::');
    } else {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: reconnect::');
        connection.start();
      }, reconnectTimeout);
    }
  });
  window.onbeforeunload = function () {
    if (connection !== null) {
      connection.stop();
    }
  };
};

var addListener = function addListener(options) {
  __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'adding listener');
  var _options$onUpdate = options.onUpdate,
      onUpdate = _options$onUpdate === undefined ? function () {
    return null;
  } : _options$onUpdate;

  channelMarketHub.on('update', function (objectType, object) {
    onUpdate('update', objectType, object);
  });
};

var setToken = function setToken(options) {
  var _options$apiToken = options.apiToken,
      apiToken = _options$apiToken === undefined ? null : _options$apiToken;

  if (apiToken !== null && connection !== null) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: token present, add bearer');
    connection.qs = { bearer: apiToken };
  }
};

var forceReconnect = function forceReconnect(_ref2) {
  var apiToken = _ref2.apiToken,
      onUpdate = _ref2.onUpdate;

  if (document.readyState !== 'complete') return;
  if (!isConnected()) return;
  __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'forceReconnect::');
  reconnectDisabled = true;
  connection.stop();
  connection = null;
  channelMarketHub = null;
  if (!apiToken) return;
  var created = createConnection({ apiToken: apiToken, onUpdate: onUpdate });
  if (created) {
    reconnectDisabled = false;
  }
};

var forceDisconnect = function forceDisconnect() {
  if (!isConnected()) return;
  __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: forceDisconnect::');
  reconnectDisabled = true;
  connection.stop();
  connection = null;
  channelMarketHub = null;
};



/***/ }),

/***/ "EOaG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    text: {
      type: String,
      required: true
    },
    level: {
      type: String,
      default: 'success'
    }
  },
  computed: {
    levelModifier: function levelModifier() {
      return 'fee-waived-banner--' + this.level;
    }
  }
});

/***/ }),

/***/ "EOrx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-notification"},[_c('div',{class:_vm.iconModifiers}),_vm._v(" "),_c('div',{class:_vm.contentModifiers,domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),_c('div',{staticClass:"side-notification__close-wrapper",on:{"click":_vm.onClose}},[(_vm.showAutoCloseLoader)?_c('div',{staticClass:"side-notification__loader",style:({ '--close-timeout': (_vm.closeTimeout + "ms") })},[_c('svg',{attrs:{"width":"32","height":"32","viewBox":"0 0 32 32"}},[_c('circle',{staticClass:"side-notification__loader-ring",attrs:{"cx":"16","cy":"16","r":"13"}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"side-notification__close"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EOu+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return waitForFirebaseInitialized; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return waitForStatusReady; });
/* unused harmony export waitForSignalrInitialized */
/* unused harmony export waitForHighCharts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__("c/9r");

/* eslint-disable */



var waitForFirebaseInitialized = function waitForFirebaseInitialized() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    var check = function check() {
      if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.app.firebaseInitialized) {
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
};

var waitForStatusReady = function waitForStatusReady() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    var check = function check() {
      if (typeof __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.user.status.hasBeenFunded !== 'undefined') {
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
};

var waitForSignalrInitialized = function waitForSignalrInitialized() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    var check = function check() {
      if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.app.signalrInitialized || !__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['user/isLoggedIn']) {
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
};

var waitForHighCharts = function waitForHighCharts() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    var check = function check() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["w" /* isHighChartsReady */])()) {
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
};

/***/ }),

/***/ "EZP0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_item_simple_js__ = __webpack_require__("OHuv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427d1980_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_simple_vue__ = __webpack_require__("UV+D");
function injectStyle (ssrContext) {
  __webpack_require__("o5X3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_item_simple_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427d1980_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_simple_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EcaT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_notification_items_notification_item_simple_notification_item_simple_vue__ = __webpack_require__("EZP0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_notification_items_notification_item_trade_confirmed_notification_item_trade_confirmed_vue__ = __webpack_require__("uVqX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_notification_items_notifcation_item_dashboard_notification_item_dashboard_vue__ = __webpack_require__("MJqx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__ = __webpack_require__("a0yF");

/* eslint-disable no-unused-vars */
/*
  Display List of notifications in top right side of the page, reuses many components.
  One of used components is dashboard notification which for now is used to display:
  - NOTIFICATION_SHARES_TRADED
 */






var ROUTE_PORTFOLIO = 'portfolio';

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    notificationItemDashboard: __WEBPACK_IMPORTED_MODULE_4__components_notification_items_notifcation_item_dashboard_notification_item_dashboard_vue__["a" /* default */],
    notificationItemSimple: __WEBPACK_IMPORTED_MODULE_2__components_notification_items_notification_item_simple_notification_item_simple_vue__["a" /* default */],
    notificationItemTradeConfirmed: __WEBPACK_IMPORTED_MODULE_3__components_notification_items_notification_item_trade_confirmed_notification_item_trade_confirmed_vue__["a" /* default */]
  },
  data: function data() {
    return {
      NOTIFICATION_SHARES_TRADED_CLOSE_DELAY: __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["g" /* NOTIFICATION_SHARES_TRADED_CLOSE_DELAY */],
      NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY: __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["h" /* NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY */],
      activeNotification: null,
      currentRoute: this.$router.currentRoute
    };
  },

  watch: {
    notificationList: function notificationList(value) {
      this.activeNotification = value[value.length - 1];
    },
    $route: function $route(to, from) {
      this.currentRoute = to;
      if (from.name !== to.name) {
        this.clear();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('notifications', ['notificationList']), {
    mockNotifications: function mockNotifications() {
      return [{
        index: 1,
        method: 'asd',
        type: __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["i" /* NOTIFICATION_SIMPLE */],
        data: {
          closeTimeout: 3500,
          icon: 'pending',
          text: 'You will be notified when processing is complete.',
          title: 'Order Received'
        }
      }, {
        index: 2,
        method: 'asd',
        type: __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["j" /* NOTIFICATION_TRADE_CONFIRMED */],
        data: { "ContractId": 18492, "Name": "test1", "MarketId": 7458, "MarketName": "Placeholder Test Market Multi Outcome", "MarketUrl": "Placeholder-Test-Market-Multi-Outcome", "MarketType": 3, "ImageName": "default.jpg", "TotalProfit": 0, "TotalFees": 0, "ShowRisk": false, "TotalRiskChange": 0, "TotalCost": 0, "Offer": { "OfferId": 285028, "ContractId": 18492, "Quantity": 1, "RemainingQuantity": 1, "DateCreated": "2023-05-17T11:27:42.14", "TradeType": 1, "PricePerShare": 0.99 }, "History": [], "TimeStamp": "1684322862.08828", "Guid": "460c5426-b273-461b-a067-3a7256202edc", "UpdateType": "tradeConfirmed_data" }
      }, {
        index: 3,
        method: 'asd',
        type: __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["i" /* NOTIFICATION_SIMPLE */],
        data: {
          closeTimeout: 3500,
          title: 'Error Occurred',
          icon: 'cancel',
          text: 'Order Received. You will be notified when processing is complete.'
        }
      }, {
        index: 4,
        method: 'asd',
        type: __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["j" /* NOTIFICATION_TRADE_CONFIRMED */],
        data: { "ContractId": 18492, "Name": "test1", "MarketId": 7458, "MarketName": "Placeholder Test Market Multi Outcome", "MarketUrl": "Placeholder-Test-Market-Multi-Outcome", "MarketType": 3, "ImageName": "default.jpg", "TotalProfit": 0, "TotalFees": 0, "ShowRisk": false, "TotalRiskChange": 0, "TotalCost": 0, "Offer": { "OfferId": 285028, "ContractId": 18492, "Quantity": 1, "RemainingQuantity": 0, "DateCreated": "2023-05-17T11:27:42.14", "TradeType": 1, "PricePerShare": 0.99 }, "History": [{}], "TimeStamp": "1684322862.08828", "Guid": "460c5426-b273-461b-a067-3a7256202edc", "UpdateType": "tradeConfirmed_data" }
      }];
    },
    notificationsToDisplay: function notificationsToDisplay() {
      // TODO
      // return this.mockNotifications
      return this.notificationList.filter(this.isNotificationDisplayable);
    },
    shouldDisplayNotifications: function shouldDisplayNotifications() {
      return this.notificationsToDisplay.length > 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['clear']), {
    onClose: function onClose() {
      // TODO
      this.clear();
    },
    isNotificationDisplayable: function isNotificationDisplayable(notification) {
      return this.shouldDisplayNotificationSimple(notification) || this.shouldDisplayNotificationTradeConfirmed(notification) || this.shouldDisplayDashboardNotification(notification);
    },
    shouldDisplayNotificationSimple: function shouldDisplayNotificationSimple(notification) {
      return notification.type === __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["i" /* NOTIFICATION_SIMPLE */];
    },
    shouldDisplayNotificationTradeConfirmed: function shouldDisplayNotificationTradeConfirmed(notification) {
      // TODO
      // return true;
      var displayRouteNames = ['market-details', 'market-details-sushi', 'market-detail-contracts', 'market-detail-rules', 'market-detail-charts', 'market-detail-history', 'market-detail-discussion', 'market-details-legacy'];
      if (displayRouteNames.includes(this.currentRoute.name)) {
        return notification.type === __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["j" /* NOTIFICATION_TRADE_CONFIRMED */] && notification.data.MarketId.toString() === this.currentRoute.params.marketId.toString();
      } else if (this.currentRoute.name === ROUTE_PORTFOLIO) {
        return notification.type === __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["j" /* NOTIFICATION_TRADE_CONFIRMED */];
      }
      return false;
    },
    shouldDisplayDashboardNotification: function shouldDisplayDashboardNotification(notification) {
      var types = [__WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["k" /* NOTIFICATION_SHARES_TRADED */], __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["l" /* NOTIFICATION_TRADER_LEVEL_CHANGED */]];
      return types.includes(notification.type);
    }
  })
});

/***/ }),

/***/ "Ed2X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Efhk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_insights__ = __webpack_require__("95qB");



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_insights__["a" /* default */]],
  props: {
    theme: {
      type: String,
      default: ''
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'insight-widget': true
      }, 'insight-widget--' + this.theme, this.theme);
    }
  }
});

/***/ }),

/***/ "EjHU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_password_requirements_js__ = __webpack_require__("LHdv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a84d262_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_password_requirements_vue__ = __webpack_require__("2uxq");
function injectStyle (ssrContext) {
  __webpack_require__("/sWl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_password_requirements_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a84d262_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_password_requirements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ellf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_validators__ = __webpack_require__("SVQh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generics_switch_button_switch_button_vue__ = __webpack_require__("ed4I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generics_code_input_code_input_vue__ = __webpack_require__("l8Or");









/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_4_vuelidate__["validationMixin"]],
    components: {
        switchButton: __WEBPACK_IMPORTED_MODULE_6__components_generics_switch_button_switch_button_vue__["a" /* default */],
        CodeInput: __WEBPACK_IMPORTED_MODULE_7__components_generics_code_input_code_input_vue__["a" /* default */]
    },
    validations: {
        phoneNumber: __WEBPACK_IMPORTED_MODULE_5__helpers_validators__["a" /* default */].phone
    },
    data: function data() {
        return {
            loading: true,
            error: null,
            status: null,

            // Setup states
            setupMode: null, // 'email', 'phone', 'authenticator'
            setupStep: 'select', // 'select', 'send', 'verify', 'phone-input'

            // Email/Phone setup
            verificationCode: '',
            isSendingCode: false,
            isVerifying: false,
            codeSent: false,
            secondsUntilResend: 0,
            resendTimer: null,

            // Phone number input (for adding new phone)
            phoneNumber: '',
            pendingPhoneNumber: '',

            // Authenticator setup
            authenticatorData: null,
            codeCopied: false,

            // Confirmation modal for disabling 2FA
            showDisableConfirmation: false,
            isDisabling: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['userData']), {
        is2FAEnabled: function is2FAEnabled() {
            return this.status && this.status.is_two_factor_enabled || false;
        },
        isEmailVerified: function isEmailVerified() {
            return this.status && this.status.is_email_verified || false;
        },
        isPhoneVerified: function isPhoneVerified() {
            return this.status && this.status.is_phone_verified || false;
        },
        isAuthenticatorEnabled: function isAuthenticatorEnabled() {
            return this.status && this.status.is_authenticator_enabled || false;
        },
        emailHint: function emailHint() {
            return this.status && this.status.email_hint || '';
        },
        phoneHint: function phoneHint() {
            return this.status && this.status.phone_hint || '';
        },
        hasPhone: function hasPhone() {
            return !!this.phoneHint;
        },
        canEnable2FA: function canEnable2FA() {
            return this.status && this.status.can_enable_two_factor || false;
        },
        hasAnyMethod: function hasAnyMethod() {
            return this.isEmailVerified || this.isPhoneVerified || this.isAuthenticatorEnabled;
        },
        canSendCode: function canSendCode() {
            return !this.isSendingCode && this.secondsUntilResend === 0;
        },
        canVerify: function canVerify() {
            return this.verificationCode.length >= 6 && !this.isVerifying;
        },
        phoneError: function phoneError() {
            if (this.$v.phoneNumber.$error) {
                return 'Enter a valid phone number';
            }
            return '';
        },
        canSubmitPhone: function canSubmitPhone() {
            return !this.$v.phoneNumber.$invalid && !this.isSendingCode;
        },
        hasCodeError: function hasCodeError() {
            return this.error !== null && this.verificationCode === '';
        },
        currentStep: function currentStep() {
            // Returns step number for stepper indicator
            if (!this.setupMode) return 0;
            if (this.setupStep === 'phone-input') return 1;
            if (this.setupStep === 'send') return 1;
            if (this.setupStep === 'verify') return 2;
            return 1;
        },
        totalSteps: function totalSteps() {
            // Email/Phone: Send -> Verify (2 steps)
            // Authenticator: Scan -> Verify (2 steps)
            // Phone with input: Input -> Send -> Verify (3 steps, but we show 2)
            return 2;
        }
    }),
    mounted: function mounted() {
        this.loadStatus();

        // Clear the navigation flag now that we've arrived
        this.setNavigatingToTwoFactorSetup(false);
    },
    beforeDestroy: function beforeDestroy() {
        this.clearResendTimer();
    },

    methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('user', ['getTwoFactorStatus', 'twoFactorSetupEmailSendCode', 'twoFactorSetupEmailVerify', 'twoFactorSetupPhoneSendCode', 'twoFactorSetupPhoneVerify', 'getTwoFactorSetupAuthenticator', 'twoFactorSetupAuthenticatorVerify', 'twoFactorEnable', 'twoFactorDisable', 'phoneUpdate', 'phoneVerify', 'setNavigatingToTwoFactorSetup']), {
        loadStatus: function loadStatus() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.loading = true;
                                _this.error = null;
                                _context.prev = 2;
                                _context.next = 5;
                                return _this.getTwoFactorStatus();

                            case 5:
                                _this.status = _context.sent;
                                _context.next = 11;
                                break;

                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context['catch'](2);

                                _this.error = 'Failed to load security settings.';

                            case 11:
                                _context.prev = 11;

                                _this.loading = false;
                                return _context.finish(11);

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[2, 8, 11, 14]]);
            }))();
        },
        startSetup: function startSetup(method) {
            this.setupMode = method;
            this.verificationCode = '';
            this.codeSent = false;
            this.error = null;
            this.phoneNumber = '';
            this.pendingPhoneNumber = '';
            this.secondsUntilResend = 0;
            this.clearResendTimer();

            if (method === 'authenticator') {
                this.setupStep = 'send';
                this.loadAuthenticatorSetup();
            } else if (method === 'phone' && !this.hasPhone) {
                // User needs to enter a phone number first
                this.setupStep = 'phone-input';
            } else {
                // Auto-send code for email/phone methods (if phone exists)
                // Set both states synchronously to show spinner immediately (avoids button flash)
                this.isSendingCode = true;
                this.setupStep = 'send';
                this.doSendCode();
            }
        },


        // Internal method that skips the canSendCode guard (for initial auto-send)
        doSendCode: function doSendCode() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.isSendingCode = true;
                                _this2.error = null;

                                _context2.prev = 2;
                                response = void 0;

                                if (!(_this2.setupMode === 'email')) {
                                    _context2.next = 10;
                                    break;
                                }

                                _context2.next = 7;
                                return _this2.twoFactorSetupEmailSendCode();

                            case 7:
                                response = _context2.sent;
                                _context2.next = 20;
                                break;

                            case 10:
                                if (!(_this2.setupMode === 'phone')) {
                                    _context2.next = 20;
                                    break;
                                }

                                if (!_this2.pendingPhoneNumber) {
                                    _context2.next = 17;
                                    break;
                                }

                                _context2.next = 14;
                                return _this2.phoneUpdate({ phoneNumber: _this2.pendingPhoneNumber });

                            case 14:
                                response = _context2.sent;
                                _context2.next = 20;
                                break;

                            case 17:
                                _context2.next = 19;
                                return _this2.twoFactorSetupPhoneSendCode();

                            case 19:
                                response = _context2.sent;

                            case 20:

                                _this2.codeSent = true;
                                _this2.setupStep = 'verify';
                                _this2.secondsUntilResend = response && response.seconds_til_resend_available || 60;
                                _this2.startResendTimer();

                                // Focus the code input after it appears
                                _this2.$nextTick(function () {
                                    if (_this2.$refs.codeInput) {
                                        _this2.$refs.codeInput.focusFirst();
                                    }
                                });
                                _context2.next = 30;
                                break;

                            case 27:
                                _context2.prev = 27;
                                _context2.t0 = _context2['catch'](2);

                                _this2.error = _this2.extractErrorMessage(_context2.t0, 'Failed to send verification code.');

                            case 30:
                                _context2.prev = 30;

                                _this2.isSendingCode = false;
                                return _context2.finish(30);

                            case 33:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[2, 27, 30, 33]]);
            }))();
        },
        cancelSetup: function cancelSetup() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this3.setupMode = null;
                                _this3.setupStep = 'select';
                                _this3.verificationCode = '';
                                _this3.codeSent = false;
                                _this3.authenticatorData = null;
                                _this3.secondsUntilResend = 0;
                                _this3.clearResendTimer();
                                _this3.codeCopied = false;
                                _context3.next = 10;
                                return _this3.loadStatus();

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        loadAuthenticatorSetup: function loadAuthenticatorSetup() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this4.loading = true;
                                _this4.codeCopied = false;
                                _context4.prev = 2;
                                _context4.next = 5;
                                return _this4.getTwoFactorSetupAuthenticator();

                            case 5:
                                _this4.authenticatorData = _context4.sent;

                                _this4.setupStep = 'verify';
                                _context4.next = 12;
                                break;

                            case 9:
                                _context4.prev = 9;
                                _context4.t0 = _context4['catch'](2);

                                _this4.error = _this4.extractErrorMessage(_context4.t0, 'Failed to load authenticator setup.');

                            case 12:
                                _context4.prev = 12;

                                _this4.loading = false;
                                return _context4.finish(12);

                            case 15:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4, [[2, 9, 12, 15]]);
            }))();
        },
        copyManualCode: function copyManualCode() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
                var textArea;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (!(!_this5.authenticatorData || !_this5.authenticatorData.manual_code)) {
                                    _context5.next = 2;
                                    break;
                                }

                                return _context5.abrupt('return');

                            case 2:
                                _context5.prev = 2;
                                _context5.next = 5;
                                return navigator.clipboard.writeText(_this5.authenticatorData.manual_code);

                            case 5:
                                _this5.codeCopied = true;

                                // Reset copied state after 2 seconds
                                setTimeout(function () {
                                    _this5.codeCopied = false;
                                }, 2000);
                                _context5.next = 19;
                                break;

                            case 9:
                                _context5.prev = 9;
                                _context5.t0 = _context5['catch'](2);

                                // Fallback for older browsers
                                textArea = document.createElement('textarea');

                                textArea.value = _this5.authenticatorData.manual_code;
                                document.body.appendChild(textArea);
                                textArea.select();
                                document.execCommand('copy');
                                document.body.removeChild(textArea);
                                _this5.codeCopied = true;

                                setTimeout(function () {
                                    _this5.codeCopied = false;
                                }, 2000);

                            case 19:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5, [[2, 9]]);
            }))();
        },
        sendCode: function sendCode() {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (_this6.canSendCode) {
                                    _context6.next = 2;
                                    break;
                                }

                                return _context6.abrupt('return');

                            case 2:
                                _context6.next = 4;
                                return _this6.doSendCode();

                            case 4:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this6);
            }))();
        },
        submitPhoneNumber: function submitPhoneNumber() {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _this7.$v.phoneNumber.$touch();

                                if (!_this7.$v.phoneNumber.$invalid) {
                                    _context7.next = 4;
                                    break;
                                }

                                _this7.error = 'Please enter a valid phone number.';
                                return _context7.abrupt('return');

                            case 4:

                                _this7.isSendingCode = true;
                                _this7.error = null;

                                _context7.prev = 6;
                                _context7.next = 9;
                                return _this7.phoneUpdate({ phoneNumber: _this7.phoneNumber });

                            case 9:
                                response = _context7.sent;

                                _this7.pendingPhoneNumber = _this7.phoneNumber;
                                _this7.codeSent = true;
                                _this7.setupStep = 'verify';
                                _this7.secondsUntilResend = response && response.seconds_til_resend_available || 60;
                                _this7.startResendTimer();
                                _context7.next = 20;
                                break;

                            case 17:
                                _context7.prev = 17;
                                _context7.t0 = _context7['catch'](6);

                                _this7.error = _this7.extractErrorMessage(_context7.t0, 'Failed to send verification code.');

                            case 20:
                                _context7.prev = 20;

                                _this7.isSendingCode = false;
                                return _context7.finish(20);

                            case 23:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this7, [[6, 17, 20, 23]]);
            }))();
        },
        onCodeComplete: function onCodeComplete(code) {
            // Auto-submit when 6 digits are entered
            if (code && code.length === 6 && !this.isVerifying) {
                this.verifyCode();
            }
        },
        verifyCode: function verifyCode() {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (_this8.canVerify) {
                                    _context8.next = 2;
                                    break;
                                }

                                return _context8.abrupt('return');

                            case 2:

                                _this8.isVerifying = true;
                                _this8.error = null;

                                _context8.prev = 4;

                                if (!(_this8.setupMode === 'email')) {
                                    _context8.next = 10;
                                    break;
                                }

                                _context8.next = 8;
                                return _this8.twoFactorSetupEmailVerify({ code: _this8.verificationCode });

                            case 8:
                                _context8.next = 23;
                                break;

                            case 10:
                                if (!(_this8.setupMode === 'phone')) {
                                    _context8.next = 20;
                                    break;
                                }

                                if (!_this8.pendingPhoneNumber) {
                                    _context8.next = 16;
                                    break;
                                }

                                _context8.next = 14;
                                return _this8.phoneVerify({ phoneNumber: _this8.pendingPhoneNumber, code: _this8.verificationCode });

                            case 14:
                                _context8.next = 18;
                                break;

                            case 16:
                                _context8.next = 18;
                                return _this8.twoFactorSetupPhoneVerify({ code: _this8.verificationCode });

                            case 18:
                                _context8.next = 23;
                                break;

                            case 20:
                                if (!(_this8.setupMode === 'authenticator')) {
                                    _context8.next = 23;
                                    break;
                                }

                                _context8.next = 23;
                                return _this8.twoFactorSetupAuthenticatorVerify({
                                    code: _this8.verificationCode,
                                    encryptedSecret: _this8.authenticatorData.encrypted_secret
                                });

                            case 23:
                                _context8.next = 25;
                                return _this8.loadStatus();

                            case 25:
                                _this8.cancelSetup();
                                _context8.next = 32;
                                break;

                            case 28:
                                _context8.prev = 28;
                                _context8.t0 = _context8['catch'](4);

                                _this8.error = _this8.extractErrorMessage(_context8.t0, 'Incorrect code. Please try again.');
                                _this8.verificationCode = '';

                            case 32:
                                _context8.prev = 32;

                                _this8.isVerifying = false;
                                return _context8.finish(32);

                            case 35:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this8, [[4, 28, 32, 35]]);
            }))();
        },
        toggleTwoFactor: function toggleTwoFactor(enabled) {
            var _this9 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                if (!(enabled && !_this9.is2FAEnabled)) {
                                    _context9.next = 13;
                                    break;
                                }

                                _context9.prev = 1;
                                _context9.next = 4;
                                return _this9.twoFactorEnable();

                            case 4:
                                _context9.next = 6;
                                return _this9.loadStatus();

                            case 6:
                                _context9.next = 11;
                                break;

                            case 8:
                                _context9.prev = 8;
                                _context9.t0 = _context9['catch'](1);

                                _this9.error = _this9.extractErrorMessage(_context9.t0, 'Failed to enable 2FA.');

                            case 11:
                                _context9.next = 14;
                                break;

                            case 13:
                                if (!enabled && _this9.is2FAEnabled) {
                                    // Show confirmation modal before disabling
                                    _this9.showDisableConfirmation = true;
                                }

                            case 14:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this9, [[1, 8]]);
            }))();
        },
        cancelDisable: function cancelDisable() {
            this.showDisableConfirmation = false;
            // Force the toggle-button back to the correct "enabled" state
            // since is2FAEnabled didn't change, the watcher won't fire automatically
            if (this.$refs.twoFactorToggle) {
                this.$refs.twoFactorToggle.isChecked = this.is2FAEnabled;
            }
        },
        confirmDisable: function confirmDisable() {
            var _this10 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _this10.isDisabling = true;
                                _this10.error = null;
                                _context10.prev = 2;
                                _context10.next = 5;
                                return _this10.twoFactorDisable();

                            case 5:
                                _context10.next = 7;
                                return _this10.loadStatus();

                            case 7:
                                _this10.showDisableConfirmation = false;
                                _context10.next = 13;
                                break;

                            case 10:
                                _context10.prev = 10;
                                _context10.t0 = _context10['catch'](2);

                                _this10.error = _this10.extractErrorMessage(_context10.t0, 'Failed to disable 2FA.');

                            case 13:
                                _context10.prev = 13;

                                _this10.isDisabling = false;
                                return _context10.finish(13);

                            case 16:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, _this10, [[2, 10, 13, 16]]);
            }))();
        },
        startResendTimer: function startResendTimer() {
            var _this11 = this;

            this.clearResendTimer();
            this.resendTimer = setInterval(function () {
                if (_this11.secondsUntilResend > 0) {
                    _this11.secondsUntilResend -= 1;
                } else {
                    _this11.clearResendTimer();
                }
            }, 1000);
        },
        clearResendTimer: function clearResendTimer() {
            if (this.resendTimer) {
                clearInterval(this.resendTimer);
                this.resendTimer = null;
            }
        },
        extractErrorMessage: function extractErrorMessage(error, defaultMessage) {
            // API returns errors as a direct array: response.data = [{ code, message, ... }]
            if (error.response && error.response.data) {
                var data = error.response.data;

                // Handle direct array of errors (API format)
                if (Array.isArray(data) && data.length > 0 && data[0].message) {
                    return data[0].message;
                }

                // Handle nested errors array
                if (data.errors && Array.isArray(data.errors) && data.errors.length > 0) {
                    return data.errors[0].message;
                }

                // Handle direct message property
                if (data.message) {
                    return data.message;
                }
            }
            return defaultMessage;
        },
        getMethodStatusText: function getMethodStatusText(isVerified) {
            return isVerified ? 'Verified' : 'Not Set Up';
        },
        getMethodStatusClass: function getMethodStatusClass(isVerified) {
            return isVerified ? 'security-settings__status--verified' : 'security-settings__status--not-verified';
        }
    })
});

/***/ }),

/***/ "EoBZ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDIxIDIxIj4KICAgIDxnIGZpbGw9IiM2Nzk5OUYiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgPHBhdGggZD0iTTEwLjUgMEM0LjcxIDAgMCA0LjcxIDAgMTAuNVM0LjcxIDIxIDEwLjUgMjEgMjEgMTYuMjkgMjEgMTAuNSAxNi4yOSAwIDEwLjUgMHptMCAxOS4yYy00Ljc5NyAwLTguNy0zLjkwMy04LjctOC43IDAtNC43OTcgMy45MDMtOC43IDguNy04LjcgNC43OTcgMCA4LjcgMy45MDMgOC43IDguNyAwIDQuNzk3LTMuOTAzIDguNy04LjcgOC43eiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMC42NyA4LjQ5NWMuNjgyLjAwNiAxLjI0My0uNTcgMS4yNS0xLjI3NGExLjI2NiAxLjI2NiAwIDAgMC0xLjI0My0xLjI5M2MtLjY5NSAwLTEuMjY0LjU2Mi0xLjI3IDEuMjczIDAgLjcwNC41NjEgMS4yODcgMS4yNjMgMS4yOTR6TTEyLjE3NCAxNC4yNzJjLS4xMi4wNDctLjIzNC4xMzUtLjM1NC4xODJhMS45NDIgMS45NDIgMCAwIDEtLjQ2OC4xMzZjLS4xOTQuMDItLjMzNC0uMDgxLS4zODEtLjI3MWExLjQwNiAxLjQwNiAwIDAgMS0uMDQtLjQ0Yy4wMzMtLjMwNS4wOTMtLjYwMy4xNDctLjkwOC4xNi0uOTA3LjMzNC0xLjgxNS40ODgtMi43MjkuMDQtLjI0NC4wODctLjQ5NC4wOC0uNzQ1LS4wMDctLjI5OC0uMTgtLjQ0LS40NzUtLjQ0SDguNzkyYTIuMDUgMi4wNSAwIDAgMC0uMjg4LjAyYy0uMTguMDM0LS4yNjcuMTIyLS4yOC4yNjQtLjAxNC4xMjkuMDUzLjI1OC4yMi4zMTkuMTM0LjA0Ny4yNzQuMDYuNDE1LjA4LjMyLjA0OC40MjguMTYzLjQyOC40OTUgMCAuMDU0LS4wMDcuMTAyLS4wMTQuMTU2LS4xMzQuOC0uMjggMS41OTEtLjQxNCAyLjM5LS4wNzQuNDYxLS4xNDcuOTE1LS4yMDcgMS4zNzUtLjA5NC42Ny41NDggMS4zMDggMS4wNDkgMS4zNzUuMy4wNC42MDguMDU0LjkxNi4wNDguNjU1LS4wMDcgMS4yMDMtLjI5MiAxLjY2NC0uNzU5YS42OTYuNjk2IDAgMCAwIC4xNzQtLjMwNWMuMDUzLS4xOS0uMDk0LS4zMTgtLjI4MS0uMjQzeiIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "EvOh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_mobile_js__ = __webpack_require__("tE+S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f80081c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_mobile_vue__ = __webpack_require__("bFdm");
function injectStyle (ssrContext) {
  __webpack_require__("2ZYw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_mobile_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f80081c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_mobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ExBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    disclaimer: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "EyLR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_header_app_header_vue__ = __webpack_require__("8hek");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_secondary_nav_app_secondary_nav_vue__ = __webpack_require__("O8vu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_app_app_main_nav_app_main_nav_vue__ = __webpack_require__("3cKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_app_app_bottom_nav_app_bottom_nav_vue__ = __webpack_require__("DvJB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_app_app_mobile_menu_app_mobile_menu_vue__ = __webpack_require__("IKgY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app_footer_app_footer_vue__ = __webpack_require__("bkfp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_notification_items_notification_items_vue__ = __webpack_require__("rEDR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_app_app_header_notification_app_header_notification_vue__ = __webpack_require__("dMVO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_maintenance_notification_maintenance_notification_vue__ = __webpack_require__("T7ic");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_app_app_header_search_bar_search_bar_vue__ = __webpack_require__("OL8g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_generics_side_notification_side_notification_vue__ = __webpack_require__("2zfn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_app_app_secondary_nav_nav_browse_categories_overlay_nav_browse_categories_overlay_vue__ = __webpack_require__("w4vL");




















var SIMPLE_LAYOUT_ROUTES = ['disqus-auth', 'disqus-logout'];

var DEBOUNCE_INTERVAL = 500;
var PINBOARD_SINGLE_MIN_WIDTH = 1459;
var PINBOARD_DUAL_MIN_WIDTH = 1894;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    appHeader: __WEBPACK_IMPORTED_MODULE_3__components_app_app_header_app_header_vue__["a" /* default */],
    appHeaderNotification: __WEBPACK_IMPORTED_MODULE_10__components_app_app_header_notification_app_header_notification_vue__["b" /* default */],
    appSecondaryNav: __WEBPACK_IMPORTED_MODULE_4__components_app_app_secondary_nav_app_secondary_nav_vue__["a" /* default */],
    appMainNav: __WEBPACK_IMPORTED_MODULE_5__components_app_app_main_nav_app_main_nav_vue__["a" /* default */],
    appBottomNav: __WEBPACK_IMPORTED_MODULE_6__components_app_app_bottom_nav_app_bottom_nav_vue__["a" /* default */],
    appFooter: __WEBPACK_IMPORTED_MODULE_8__components_app_app_footer_app_footer_vue__["a" /* default */],
    appMobileMenu: __WEBPACK_IMPORTED_MODULE_7__components_app_app_mobile_menu_app_mobile_menu_vue__["a" /* default */],
    maintenanceNotification: __WEBPACK_IMPORTED_MODULE_11__components_maintenance_notification_maintenance_notification_vue__["a" /* default */],
    notificationItems: __WEBPACK_IMPORTED_MODULE_9__components_notification_items_notification_items_vue__["a" /* default */],
    searchBar: __WEBPACK_IMPORTED_MODULE_12__components_app_app_header_search_bar_search_bar_vue__["a" /* default */],
    sideNotification: __WEBPACK_IMPORTED_MODULE_13__components_generics_side_notification_side_notification_vue__["a" /* default */],
    navBrowseCategoriesOverlay: __WEBPACK_IMPORTED_MODULE_17__components_app_app_secondary_nav_nav_browse_categories_overlay_nav_browse_categories_overlay_vue__["a" /* default */]
  },  false ? { pinboardPanel: require('@/components/pinning/pinboard-panel/pinboard-panel.vue').default } : {}),
  data: function data() {
    return {
      isStandalone: __WEBPACK_IMPORTED_MODULE_15__mixins_userAgent__["i" /* isStandalone */],
      isTransitioning: false,
      pinboardObserver: null,
      panelScrollHandler: null
    };
  },

  watch: {
    $route: function $route() {
      var _this = this;

      setTimeout(function () {
        _this.isTransitioning = false;
      }, 1000);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('app', ['setPinboardModeVisible']), {
    onBeforeLeave: function onBeforeLeave() {
      this.isTransitioning = true;
    },
    onAfterEnter: function onAfterEnter() {
      this.isTransitioning = false;
      if (__WEBPACK_IMPORTED_MODULE_16__router__["b" /* scrollState */].pendingPosition) {
        var _scrollState$pendingP = __WEBPACK_IMPORTED_MODULE_16__router__["b" /* scrollState */].pendingPosition,
            x = _scrollState$pendingP.x,
            y = _scrollState$pendingP.y;

        __WEBPACK_IMPORTED_MODULE_16__router__["b" /* scrollState */].pendingPosition = null;
        window.scrollTo(x, y);
      } else {
        window.scrollTo(0, 0);
      }
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    if (!this.isPinningEnabled) return;

    var update = __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
      var w = window.innerWidth;
      _this2.setPinboardModeVisible({ single: w >= PINBOARD_SINGLE_MIN_WIDTH, dual: w >= PINBOARD_DUAL_MIN_WIDTH });
    }, DEBOUNCE_INTERVAL);

    this.pinboardObserver = new window.ResizeObserver(update);
    this.pinboardObserver.observe(document.documentElement);
    var w = window.innerWidth;
    this.setPinboardModeVisible({ single: w >= PINBOARD_SINGLE_MIN_WIDTH, dual: w >= PINBOARD_DUAL_MIN_WIDTH });

    var footer = this.$el.querySelector('.app-layout__footer');
    if (footer) {
      var updatePanelBottom = function updatePanelBottom() {
        var footerTop = footer.getBoundingClientRect().top;
        var bottom = Math.max(0, window.innerHeight - footerTop);
        _this2.$el.style.setProperty('--panel-bottom', bottom + 'px');
      };
      this.panelScrollHandler = updatePanelBottom;
      window.addEventListener('scroll', updatePanelBottom, { passive: true });
      updatePanelBottom();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.pinboardObserver) this.pinboardObserver.disconnect();
    if (this.panelScrollHandler) {
      window.removeEventListener('scroll', this.panelScrollHandler);
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['hasBanner', 'hasMaintenanceMessage', 'isLayoutDesktop', 'isPinningEnabled', 'isPinboardSingleModeVisible', 'isPinboardDualModeVisible', 'sidebarVisible']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('app', ['hasServerErrorOccurred', 'liveUpdatesDisabled', 'mobileMenuOpened']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('popup', ['currentPopup', 'currentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('notifications', ['sideNotificationLevel', 'sideNotificationText', 'sideNotificationOnCloseCallback', 'showNotificationsWidget']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isUserRestricted']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('search', ['searchBarVisible']), {
    isSimpleLayout: function isSimpleLayout() {
      return SIMPLE_LAYOUT_ROUTES.includes(this.$route.name);
    },
    appModifiers: function appModifiers() {
      return {
        'app-layout': true,
        'app-layout--with-overflow': (this.currentPopup !== null || this.currentSmallPopup !== null) && this.isTransitioning,
        'app-layout--full-width': this.$route.meta.appContentFullWidth,
        'app-layout--bg-white': true,
        'app-layout--pinboard': this.isPinboardLayoutEnabled,
        'app-layout--single-left-open': this.showLeftPanel && this.inSinglePanelMode,
        'app-layout--dual-open': this.isPinboardDualModeVisible && this.sidebarVisible && this.isPinboardLayoutEnabled
      };
    },
    headerModifiers: function headerModifiers() {
      return {
        'app-layout__header': true,
        'app-layout__header--secondary': true,
        'app-layout__header--error': this.hasServerErrorOccurred || this.hasMaintenanceMessage || this.hasBanner || this.liveUpdatesDisabled,
        'app-layout__header--notifications-widget-open': this.showNotificationsWidget
      };
    },
    contentModifiers: function contentModifiers() {
      return {
        'app-layout__content': true,
        'app-layout__content--secondary': !this.isSimpleLayout,
        'app-layout__content--simple': this.isSimpleLayout,
        'app-layout__content--error': this.hasServerErrorOccurred || this.hasMaintenanceMessage || this.hasBanner || this.liveUpdatesDisabled,
        'app-layout__content--with-overflow': this.$route.meta.appContentOverflowed,
        'app-layout__content--full-width': this.$route.meta.appContentFullWidth,
        'app-layout__content--pinboard': this.isPinboardLayoutEnabled
      };
    },
    sideNotificationShouldDisplay: function sideNotificationShouldDisplay() {
      return this.sideNotificationLevel && this.sideNotificationText;
    },
    isPinboardLayoutEnabled: function isPinboardLayoutEnabled() {
      return this.isPinningEnabled && ['home', 'trends', 'market-details'].includes(this.$route.name);
    },
    inSinglePanelMode: function inSinglePanelMode() {
      return this.isPinboardSingleModeVisible && !this.isPinboardDualModeVisible;
    },
    showLeftPanel: function showLeftPanel() {
      return (this.isPinboardDualModeVisible || this.isPinboardSingleModeVisible && this.activePinboardConfig.singlePanelSide === 'left') && this.isPinboardLayoutEnabled && this.sidebarVisible;
    },
    showRightPanel: function showRightPanel() {
      return (this.isPinboardDualModeVisible || this.isPinboardSingleModeVisible && this.activePinboardConfig.singlePanelSide === 'right') && this.isPinboardLayoutEnabled && this.sidebarVisible;
    },
    activePinboardConfig: function activePinboardConfig() {
      return { singlePanelSide: 'left' };
    }
  })
});

/***/ }),

/***/ "EyqK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_notifications__ = __webpack_require__("tjp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filters_consts__ = __webpack_require__("OJH0");




 /* eslint-disable arrow-body-style, max-len */








var KEY_SHOULD_SHOW_TIMESPAN = 'should-show-timespan';
var KEY_SELECTED_ORDER = 'selected-order';
var KEY_SELECTED_TIMESPAN = 'selected-timespan';

var DEFAULT_NOTIFICATIONS = {
  data: [],
  page: 0,
  totalCount: -1,
  canLoadMore: true
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    markReadIsBeingCalled: false,
    marketsToggle: null,
    myShares: null,
    mySharesReady: false,
    notifications: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(DEFAULT_NOTIFICATIONS),
    notificationsToggle: false,
    orders: __WEBPACK_IMPORTED_MODULE_9__filters_consts__["a" /* ORDERS */],
    timespans: __WEBPACK_IMPORTED_MODULE_9__filters_consts__["b" /* TIMESPANS */],
    selectedOrder: __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].get(KEY_SELECTED_ORDER, __WEBPACK_IMPORTED_MODULE_9__filters_consts__["a" /* ORDERS */][0]),
    selectedTimespan: __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].get(KEY_SELECTED_TIMESPAN, __WEBPACK_IMPORTED_MODULE_9__filters_consts__["c" /* AVAILABLE_TIMESPANS */].ALL),
    shouldShowTimespanFilter: __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].get(KEY_SHOULD_SHOW_TIMESPAN, true)
  },
  getters: {
    mySharesCount: function mySharesCount(state) {
      return state.myShares ? state.myShares.markets.length : 0;
    },
    mySharesTotalGainLoss: function mySharesTotalGainLoss(state) {
      if (state.myShares && state.myShares.markets) {
        return __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy___default()(state.myShares.markets, __WEBPACK_IMPORTED_MODULE_7__utils_helpers__["J" /* marketUserGainLoss */]);
      }
      return 0;
    }
  },
  mutations: {
    setMarketsToggle: function setMarketsToggle(state, flag) {
      state.marketsToggle = flag;
    },
    setMyShares: function setMyShares(state, payload) {
      state.myShares = payload;
      state.mySharesReady = true;
    },
    setSummaryChartData: function setSummaryChartData(state, payload) {
      state.summaryChart = payload;
    },
    updateNotifications: function updateNotifications(state, payload) {
      var sourceNotifications = payload.data.notificationItems || [];
      sourceNotifications.forEach(function (el) {
        el.contentJson = typeof el.contentJson === 'string' ? JSON.parse(el.contentJson) : el.contentJson;
      });
      var data = state.notifications.data.concat(sourceNotifications);
      var page = payload.data.page;
      var totalCount = payload.data.totalItems;
      var canLoadMore = totalCount > data.length;

      state.notifications = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.notifications, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    resetNotifications: function resetNotifications(state) {
      state.notifications = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(DEFAULT_NOTIFICATIONS);
    },
    updateMySharesFromNotification: function updateMySharesFromNotification(state, data) {
      if (state.myShares && state.myShares.markets) {
        state.myShares = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.myShares, {
          markets: state.myShares.markets.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_notifications__["c" /* updateMySharesMarket */])(market, data);
          })
        });
      }
    },
    updateMySharesContractFromNotification: function updateMySharesContractFromNotification(state, data) {
      if (state.myShares && state.myShares.markets) {
        state.myShares = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.myShares, {
          markets: state.myShares.markets.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_notifications__["b" /* updateMarketContracts */])(market, data);
          })
        });
      }
    },
    toggleNotifications: function toggleNotifications(state) {
      state.notificationsToggle = !state.notificationsToggle;
    },
    selectOrder: function selectOrder(state, sort) {
      var selectedOrder = __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(state.orders, { sort: sort });
      var selectedTimespan = __WEBPACK_IMPORTED_MODULE_9__filters_consts__["d" /* DEFAULT_TIMESPANS */][sort] || __WEBPACK_IMPORTED_MODULE_9__filters_consts__["c" /* AVAILABLE_TIMESPANS */].EMPTY;
      var shouldShowTimespan = __WEBPACK_IMPORTED_MODULE_9__filters_consts__["e" /* ORDERS_WITH_TIMESPAN_FILTER */].indexOf(selectedOrder.sort) !== -1;
      state.selectedOrder = selectedOrder;
      state.selectedTimespan = selectedTimespan;
      state.shouldShowTimespanFilter = shouldShowTimespan;
      __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].set(KEY_SELECTED_TIMESPAN, selectedTimespan);
      __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].set(KEY_SHOULD_SHOW_TIMESPAN, shouldShowTimespan);
      __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].set(KEY_SELECTED_ORDER, selectedOrder);
    },
    selectTimespan: function selectTimespan(state, parameter) {
      var selectedTimespan = __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(state.timespans, { parameter: parameter });
      state.selectedTimespan = selectedTimespan;
      __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].set(KEY_SELECTED_TIMESPAN, selectedTimespan);
    },
    setMarkReadBeingCalled: function setMarkReadBeingCalled(state, value) {
      state.markReadIsBeingCalled = value;
    }
  },
  actions: {
    getMyShares: function getMyShares(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].profile.getMyShares(state.selectedOrder.sort, state.selectedTimespan.parameter).then(function (response) {
        commit('setMyShares', response.data);
        return response.data;
      });
    },
    resetNotifications: function resetNotifications(_ref2) {
      var commit = _ref2.commit;

      commit('resetNotifications');
    },
    getNotifications: function getNotifications(_ref3) {
      var state = _ref3.state,
          commit = _ref3.commit;

      if (state.notifications.canLoadMore) {
        var page = state.notifications.page + 1;
        return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].profile.getNotifications(page).then(function (response) {
          commit('updateNotifications', {
            page: page,
            data: response.data
          });
          return response.data;
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(null);
    },
    markNotificationsAsRead: function markNotificationsAsRead(_ref4) {
      var commit = _ref4.commit,
          state = _ref4.state;

      if (state.markReadIsBeingCalled) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({});

      commit('setMarkReadBeingCalled', true);
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].profile.putNotifications().then(function (response) {
        commit('setMarkReadBeingCalled', false);
        return response.data;
      }).catch(function (error) {
        commit('setMarkReadBeingCalled', false);
        throw error;
      });
    },
    updateMySharesFromNotification: function updateMySharesFromNotification(_ref5, payload) {
      var commit = _ref5.commit;

      commit('updateMySharesFromNotification', payload);
    },
    updateMySharesContractFromNotification: function updateMySharesContractFromNotification(_ref6, payload) {
      var commit = _ref6.commit;

      commit('updateMySharesContractFromNotification', payload);
    },
    selectOrder: function selectOrder(_ref7, sort) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      commit('selectOrder', sort);
      return dispatch('getMyShares');
    },
    selectTimespan: function selectTimespan(_ref8, timespan) {
      var state = _ref8.state,
          dispatch = _ref8.dispatch,
          commit = _ref8.commit;

      commit('selectTimespan', timespan);
      return dispatch('getMyShares');
    },
    toggleNotifications: function toggleNotifications(_ref9) {
      var commit = _ref9.commit;

      commit('toggleNotifications');
    },
    setMarketsToggle: function setMarketsToggle(_ref10, flag) {
      var commit = _ref10.commit;

      commit('setMarketsToggle', flag);
    }
  }
});

/***/ }),

/***/ "F+2w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document-tile-view"},_vm._l((_vm.documentData.displayDocuments),function(document,index){return _c('document-to-review',{key:index,attrs:{"title":document.displayDocumentDescription,"link":document.displayDocumentPath,"num":0,"markOpened":false,"showLabel":_vm.documentData.settingsShowOpenStatus === 1}},[_c('span',{attrs:{"slot":"suffix"},slot:"suffix"},[_vm._v("\n      "+_vm._s(document.displayDocumentTitle)+"\n    ")])])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F06B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F76i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.maintenance.isMaintenanceEnabled)?_c('div',{staticClass:"maintenance-notification"},[_c('img',{staticClass:"maintenance-notification__logo",attrs:{"src":__webpack_require__("Kcew")}}),_vm._v(" "),_c('p',{staticClass:"maintenance-notification__info"},[(_vm.maintenance.maintenanceMessage)?[_vm._v("\n      "+_vm._s(_vm.maintenance.maintenanceMessage)+"\n    ")]:[_vm._v("\n      We are currently undergoing scheduled maintenance.\n    ")]],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FCbW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIndex2RedirectUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__ = __webpack_require__("DECz");



var INDEX2_REDIRECT_RULES = [{ params: { utm_code: 'PREDICTIT25', utm_source: 'scan', utm_campaign: 'chips' }, url: 'https://www.predictit.org/stories/detail/84/Poker-Chips-Landing-Page' }];

var INDEX2_REDIRECT_PATH = '/index2';

function getIndex2RedirectUrl() {
  if (window.location.pathname !== INDEX2_REDIRECT_PATH) return null;
  var params = new URL(window.location.href).searchParams;
  var rule = INDEX2_REDIRECT_RULES.find(function (_ref) {
    var ruleParams = _ref.params;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(ruleParams).every(function (key) {
      return params.get(key) === ruleParams[key];
    });
  });
  if (!rule) return null;
  __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].check({ query: rule.params });
  return rule.url;
}

/***/ }),

/***/ "FGQd":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzQ3MF8zODk4KSI+CjxwYXRoIGQ9Ik0yMi41ODk4IDBDMjIuOTYzOCAwLjAwMSAyMy4zMjE5IDAuMTUwMDYzIDIzLjU4NTkgMC40MTQwNjJDMjMuODQ5OSAwLjY3ODA2MiAyMy45OTkgMS4wMzYxNiAyNCAxLjQxMDE2VjIyLjU4OThDMjMuOTk4IDIyLjk2MjggMjMuODQ5IDIzLjMyMSAyMy41ODUgMjMuNTg1QzIzLjMyMSAyMy44NDkgMjIuOTYzOCAyMy45OTcgMjIuNTkwOCAyMy45OTlIMS40MTExM0MxLjAzODEzIDIzLjk5OCAwLjY4MDAzOSAyMy44NDkgMC40MTUwMzkgMjMuNTg1QzAuMTUwMDM5IDIzLjMyMSAwLjAwMiAyMi45NjI4IDAgMjIuNTg5OFYxLjQxMDE2QzAgMS4wMzcxNiAwLjE1MDAzOSAwLjY3OTAzOSAwLjQxNTAzOSAwLjQxNTAzOUMwLjY4MDAzOSAwLjE1MDAzOSAxLjAzNzEzIDAuMDAxIDEuNDExMTMgMEgyMi41ODk4Wk00IDRMMTAuMDQ3OSAxMi4yMDQxTDQuMzE2NDEgMTlINi43Njk1M0wxMS4xOTYzIDEzLjc1NjhMMTUuMDYxNSAxOUgyMEwxMy42OTYzIDEwLjM1MzVMMTkuMDU0NyA0SDE2LjYwMDZMMTIuNTU4NiA4Ljc5Mzk1TDkuMDYzNDggNEg0Wk04LjMyMzI0IDUuNDQ1MzFMMTcuMDk4NiAxNy40Nzc1SDE1Ljc0MDJMNi44NjYyMSA1LjQ0NTMxSDguMzIzMjRaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzQ3MF8zODk4Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),

/***/ "FGdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  multipleEmails: 'Invalid email',
  email: 'Enter a valid email',
  sameAs: 'Doesn’t Match',
  minLength: 'At least %v characters',
  maxLength: '%v characters maximum',
  exactLength: 'Exactly %v digits required',
  required: 'This field is required',
  alphaNum: 'Only letters and numbers are allowed',
  hasOneLower: 'At least one lowercase letter',
  hasOneUpper: 'At least one uppercase letter',
  hasOneDigit: 'At least one number',
  validateIsAdult: 'You must be at least 18 years old',
  alpha: 'Only letters are allowed',
  onlyCharacters: 'Only letters are allowed',
  validateUSZipCode: 'Enter a valid code',
  validateCardNumber: '',
  validateSSN: '4 digits are required',
  numeric: 'Numbers only',
  price: 'Invalid amount',
  between: 'Amount must be between $%v1 and $%v2',
  minValue: 'Minimum amount is $%v',
  minLengthDigit: 'Min. %v digits',
  maxLengthDigit: 'Max. %v digits',
  minValueDeposit: 'Minimum amount is $%v',
  maxValueDeposit: 'Maximum amount is $%v',
  usernameIsValid: 'Enter a valid username',
  greaterThan: 'Value must be greater than %v',
  noSpaces: 'No spaces',
  phone: 'Enter a valid phone number',
  phoneOptional: 'Enter a valid phone number'
});

/***/ }),

/***/ "FHMi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_ssn_info_upload_js__ = __webpack_require__("MeDD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05703b7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_ssn_info_upload_vue__ = __webpack_require__("X6LQ");
function injectStyle (ssrContext) {
  __webpack_require__("1b1z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_ssn_info_upload_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05703b7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_ssn_info_upload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FITW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{
        id: 1,
        text: 'The most exciting engine in terms of political opinion',
        author: 'James Carville, Political Pundit'
      }],
      swiperOptions: {
        autoplay: 3000,
        direction: 'horizontal'
      }
    };
  },

  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
  }
});

/***/ }),

/***/ "FM5G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_twitter_timeline_js__ = __webpack_require__("tumW");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d85e700_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_twitter_timeline_vue__ = __webpack_require__("7RdL");
function injectStyle (ssrContext) {
  __webpack_require__("OFB4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_twitter_timeline_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d85e700_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_twitter_timeline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FMYX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifier},[_c('transition',{attrs:{"name":"slide"}},[_c('nav-browse',{key:(_vm.rotationIndex + "-" + _vm.isLayoutMobile)})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FOkx":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "FP0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getOrderBook: function getOrderBook(contractId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Trade/' + contractId + '/OrderBook');
  },
  postConfirmTrade: function postConfirmTrade(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Trade/ConfirmTrade', payload); // Confirm trade create order for confirmation
  },
  postSubmitTrade: function postSubmitTrade(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Trade/SubmitTrade', payload); // Submit trade create order without confirmation
  },
  postCancelAllOffers: function postCancelAllOffers(contractId, payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Trade/CancelAllOffers/' + contractId, payload);
  },
  postCancelOffer: function postCancelOffer(offerId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Trade/CancelOffer/' + offerId);
  },
  getOrderBookTradeInfo: function getOrderBookTradeInfo(contractId, tradeType, price) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Trade/' + contractId + '/OrderBook/' + tradeType + '/' + price);
  }
});

/***/ }),

/***/ "FUh1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-combined-login"},[_c('account-login'),_vm._v(" "),_c('account-login-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FcIm":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfQAAAH0CAMAAAD8CC+4AAAAh1BMVEX///9ycnL9/f15eXl0dHT4+PiCgoLz8/Obm5uWlpalpaV3d3eOjo6urq6+vr5/f3/f39/u7u7Ozs76+vqpqamFhYXp6enS0tLGxsafn5+0tLT19fXDw8OJiYm5ubnW1tbr6+vc3NySkpKLi4t8fHzm5ubj4+OdnZ3w8PDKysqhoaGxsbHY2Ng+RJswAAANcklEQVR42uzdiXaaQBSA4bkgoEFBERQXYtLkqFne//maNk3TJu6yzAz/9wpzvHM3RgUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwGGjdZ5Hadrrvwnlt7D/ppemUZ6vRwoWmSRR2ivkqKKXRslawWze/TLtd+Q8DzfRq6dgolGSFnKxIk2I92YZ5bNYrhbPcg7eDM7rPJPSZPOVo6A1L9m4UjJ3k3DFa2s8nYVSiXA2HSvoZ/XsSoXc55WCVoJbXyrn3wYKmnCmXalJd0papwMnz6RGWc6xN2289KVm/pKkrkleFEsD4ltquKYs5q40xJ0vFOoXvLjSIPeFVL5uo0EoDQsHdObr5ESuaMCNyORrc1+IJop7hToEN6KRG6726jlLLSL7J3dJjK/YsC/a6Q8VqrNIRUspVXtlnh5FU49PClXwZqKxGZ3ZCqwz0VrGxnzplh3RXGepUCZvIwbYEOJLNNQ8tH/IKN5KE2kf2j90IoX2hHZCfJmGvhjFJ8Rfbdr43Pxc4VThKpEYiIv9Gs5AjDRg8HYxryuG6pLOXWih4Rj1VH3mbhcJtFmKukTBRs0FRoZ04fbJ2JU9251h5fl3/p3CWSaxGC+eKJzhzoIzF4n5rZ9ha3xsf+dvFU4UGJ7DfcrI4U8UPIg1Hjj1k4wN7sl81+cFgxM4Ro3Pj9vQhz/O0BnLfgMFG2epTFqvMhULJQoHDI3bkzlFyAbVAYElTZmvfAq3vZyeWKpHCr/Pi1iLFH6PRCxGMrfTxMok7kPInHWHsdHbUccV9GNb0InjWj9qJdbjryG+CKxYlTksplr/n7GfNZyjq/CPXFohV/hrq9krkFVx2Zn7pPVjYWWaKdg8T92Nb9f/WFg6W9vF58PGd5o++FqNVOHNWlqFhYpffkir/FCwe6DKkHUnr0VZ3Dufp0nm0jpz1XJbY14ALU/Y9r5cq8q1n+zd7WrbQBBG4RlHNrROMMYkNKTNB7F/JM39X19L6irWriAphVLmnOcWhFar2Zl3/W17dQ980TMHdljBf3XF2r/zOcCukC965kDuknxOqOfAOkBf9MzhEFTQLzr6q77FvuiZAzVPEliMw5fllpDGuHlnzAp8waARQ0nescAdr02tiCProG5IeyR/K5s68VGfAuc+8XjHLuj/Nehf2wIwpfqeDW0rBxhHdyuHnV5zsm20LB0q9FFrVlXuKfXTU5AggieMppi4AR+qnhpIM6yu7sD13dWdt77v3LsfrTkxklZmgIGC1t2B9fdCl+39rceA2KZGlK5YSDykIZIetsAPXfap0SYQDilc05SfdGAlFjy2yM0iKX5Bz5/6FgA3qQnC8epLauIl6oPPLTInGd3HAUMpzlMT51HewgaKxrr+oMtVqlE/VA4X724AfMRtqnEb1SFjn+mFWHwABTGS4jLVuIziFg40dYbq/2w2RQKbIx9SnYeoDZ8eR4whsVdqxteozdoMsDpzkepcRG2epgNP1I0jAEYT2EIBbKNwShnYBW3pfcYqaoNf5zBvH7UZ/jzjLGpD39DkQ9ebqC3lQxfgobu8+9CVWX8j5y8b8KFbnOnUL85Yhu3UL8N64NKpf+Di0Wqn/tGqTRSd+k0Utkt16rdL2RjZqd8YaQt0p34LtMMOnfrDDo41deqPNTnA2Kk/wOiocqf+qLKhBC1AKIHF9xYgfsSgoRYhaMhIsQYhUszqDK42Y0xohxATaiBwgxAIbPQ374/NNgpcC4Un6sDTdC/u6TAu7vGKrgnGFV1exjfBuIzP6jur/9mdHLIIa8dUg3KVtpfmn6Bcmh/71GgTDNep0XUw+FE/8SUYbI4ENUU6r9x7DAoH2kbfg+IudXQXFDsbKY7Wu8AwmgASR2B3JLIn8s3S9f3VehkgFuVQ5TjXd+jq7v6dt3d3fUeu7tZnYJWZXxYmA+cKMNri9CpuWrW1xeeQDJhTVSMpkCVYE+Ug6XFu5dzGOckImVvsLdE3N/1g7160EoeBMAA3vVDKxRYRVG4iCIj7/u+3q3s8KNI2La0nM///vUJPk8nMZBJA1VpOZgbYzMOEfGpDPK/BX2VEGD/BW21ndh4s2FobWn3tqynorh7qHx3HXZ07On/1EOROOn91/ujQZ3XcMzpwWg41GXcSwRXbOqBZd+gWeKxmd46FRhn6XC4zUDKP0I5t6Me1T3OgwXIvEON/bRwNDIyhoGyHxnp3z94IpF0ugM/FAQ6RRBkPydFD2HdaisSpUS+NPUK7sI52HZ2zQ40ZenRuvDSqLcEGzNjZqR4+1AdueoYtsrKgiretc0PP42+MUhvIy+jYp3We0ItkKptjQzZO4AVzDOLwhpJgDhrBDuEZuJfzlRXcugzcLUSqeqIHvNpgJVb0WN+WhzVLrxOjxOTVI0sjJRfcOuyJq2CtIjWXgg8fqGqq4Kun0JNl6liLX+E7/M8rGwmP5ibcz2uIRfdPLXlWq2UuOEsz4EXFmiKxGdku83C1+UKrL3fMt8NVWllLvdK9uMboPuKLPA3LhB3YO+yNasBcVDjXZdjejBsx7ZIht3O4JZ5Le5OigxHgwKUdbYnn0t68zPECzIRL+wekJf7AxGs7HpydPBZwblRr5o6Oke0xgmtT5mB79Ja7ecv8hWNrfLBgSa198ZtxyBs7ZH7FqOfMmT3ssRPuF4yPjo2MTo6cFdau6dCxHf1dMGSDe3tuHfvJTxIOm2hFtHA6DztZMCXXtHjm4Lr+XTBjIN+knTvxenEsz1mgTXl2div/KXn26HqZoE/+LmFS9lp7UV2R/yV7j+rbO11Cz3fgZ69r92jEemRIV0d8Z0S74wGuqmjl/Lm8TLBiuqaSo4KRM8akfFnV3l7NsP8NIzo7kdBL6ZcNucZbuFWxsp+kLMCVeRV6Mi/S5azQQq51PTYjWHiUZ6omgDu3YW/NZf5KRP20nnDFRukLpg5eY2jSlj/7Dw/iBgpV1efO/l0ssIJaXZfp+C+elJ3N86R8N//TWFUKrtiQNyM+TEVPe65qyXjun3uV+Zh8AdOy/szA+QN+ZI+Ftbo2I4GO4qUMBfzEIYPXe1Ccdy0Wog4m8oV3Pl6nB7mxR5Db+UkC2FIzUl5fKbeFm1ySgSRei6Rg4dyT+pqajT5UKn4BG7Z/FwJVW4EKLGWGHgbf0QGv9nh0q8oXfBe1DY8AX30M0SNTRVd9iX0MnpK5JFH+1SO1ne3X2KhOzsWCH8du00BxrTWGT73m2ar96hH/81wDpSv8mPt5gY3KaI5xO14M7/N8XqKrLkvDPBxgbo75dgs9TxXW1fBqbjeGrCh6mPnWkCU1d56e2SdjLVTySMD6xZC1YO0pMHf6kaW/7N3dVtpAFIbhbxIQUaqsBYpFQWFVRbz/+2sP6kGtTiYhmczsvM89BPbs3/TcGEjDFyTiaprm/1wf9OxSM0tl7s6htsynG18I3BsYZT36Mhno/PmpzjIO5gjiBhjMvTs09K5MrRwaWylLtwPbFdauMst9c8WgdgK2b5Nj+xQl9OEV1x8dTpTdyoIJ60VOdp3ba53e1xacKysPDi3IajvJLXuEWnGZ0butYGitJbN80rFbh5ZslYlb6qmtGWXyA18wndqifR4/8ETubnAR/IE6S6vKHG4yk5b5Y2ApGkaY/hrQqNM9OffWXd8rbRRUPwynyErLcxdGL0oZUdyH4cRydE58MoB+ioIB1Y7cpJuXY8vIJwPYSzIhF9eZMtXWKZ5r/xrCs42K6n/s11jZCdmpn0rQi0OnUszQvDp06lXJmTt0LL39FOwf6NxUieFD/4L1T50P/Su2P/WdQwRpLY6lpPotsyXWZ4conpUOjnVUsXfwY0LWPZJROsW2tUMkayViTB09mjKV85wMr1UyN9pWsPU3orM0uuUYZApia8iJDGw1a7nYJ4eoUjjnxHstgLFXW8GYamTX/YdyLHUPZGkVPPW1QIZqbQfS7tGNDmqEPYE526o+snGZa5KVo00qdzs1wiXVnC3Vo4LT6L34VageHukGrFQXvXHZu1BvFrTM9KRcqB6WSRnwqHD8uhtxoXDE7kbUjN+ZVDVhrjrYJmXCD/WDvHuPzlQHU4s2PCscS0GNuFIwemasOFcPFtxT7dXlQmEopRuyUyD63e1YKz4uJ/dspugWtMH2bDRWNf7SjXlUEHqfLVkrBK90U/YKQVnVlMtClUi8WzNXXHcOvXtQCDqlTDkqLm4tJuBGUd07JGCsKqRmzNmpEksirXlQAKZVbVkqpr1DAvaKqGCILQlloSpsiTTnSZWYS7dmJT/qqgZtVY2r2cYcVY3+OGNmiofgPRGlojk4JOKgCmTe7dkpljeHRLzJixebRVv5UW4xaKkK3GeyZ6pYNg6J2MiHZ7pJpSIZOyRjIQ8KqzY9yY+lgQbN5UE13aaVfBhpMulOfiyQM+hKPqwYMmktD7KwNi0Vx9EhGUd5kHq3aSovxlss2suHtkiTZvoeRTajNvLjosPv9u7lBGAYBoLoBEMubsP915gG5EAuRmzmtbAXfUAKdHOG18QaWbxwnZ5pUDL0ZIMzfOnQyOSMS41QMvRolAw9GiVDj0bNQi7YZMeWLZZ9+g8NdhzDxlp89wC96zoJVgBLhQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "Fem6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_done_links_js__ = __webpack_require__("5eKf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ff77377_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_done_links_vue__ = __webpack_require__("+CKl");
function injectStyle (ssrContext) {
  __webpack_require__("s+vV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_done_links_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ff77377_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_done_links_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ffa9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['maintenance']))
});

/***/ }),

/***/ "Fm43":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkwMjVfMTk4MDUpIj4KPHBhdGggZD0iTTEgM0gxNSIgc3Ryb2tlPSIjNTU1NzVBIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkuNSAxSDYuNUM2LjIzNDc4IDEgNS45ODA0MyAxLjEwNTM2IDUuNzkyODkgMS4yOTI4OUM1LjYwNTM2IDEuNDgwNDMgNS41IDEuNzM0NzggNS41IDJWM0gxMC41VjJDMTAuNSAxLjczNDc4IDEwLjM5NDYgMS40ODA0MyAxMC4yMDcxIDEuMjkyODlDMTAuMDE5NiAxLjEwNTM2IDkuNzY1MjIgMSA5LjUgMVoiIHN0cm9rZT0iIzU1NTc1QSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik02LjUgMTEuNVY2LjUiIHN0cm9rZT0iIzU1NTc1QSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik05LjUgMTEuNVY2LjUiIHN0cm9rZT0iIzU1NTc1QSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMi41NzY3IDE0LjA4MjdDMTIuNTU1OSAxNC4zMzI3IDEyLjQ0MTkgMTQuNTY1OSAxMi4yNTczIDE0LjczNThDMTIuMDcyNyAxNC45MDU3IDExLjgzMDkgMTUgMTEuNTggMTVINC40MjA2N0M0LjE2OTc1IDE1IDMuOTI3OTggMTQuOTA1NyAzLjc0MzM2IDE0LjczNThDMy41NTg3NCAxNC41NjU5IDMuNDQ0NzQgMTQuMzMyNyAzLjQyNCAxNC4wODI3TDIuNSAzSDEzLjVMMTIuNTc2NyAxNC4wODI3WiIgc3Ryb2tlPSIjNTU1NzVBIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF85MDI1XzE5ODA1Ij4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),

/***/ "Fn63":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'submit'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "Fokc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FvKT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G/7i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_horizontal_sushi_orders_js__ = __webpack_require__("U9Lo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4360c9c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_horizontal_sushi_orders_vue__ = __webpack_require__("/u+B");
function injectStyle (ssrContext) {
  __webpack_require__("ZKfp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_horizontal_sushi_orders_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4360c9c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_horizontal_sushi_orders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G/BR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isDebugOn;
function hasConsoleQueryParam() {
  if (typeof window === 'undefined' || !window.location) {
    return false;
  }

  return window.location.search.replace(/^\?/, '').split('&').some(function (pair) {
    return pair.split('=')[0] === 'console';
  });
}

function isDebugOn() {
  return hasConsoleQueryParam() || "production" === 'development';
}

function info() {
  if (isDebugOn()) {
    var _console;

    (_console = console).info.apply(_console, arguments); // eslint-disable-line no-console
  }
}

function warn() {
  if (isDebugOn()) {
    var _console2;

    (_console2 = console).warn.apply(_console2, arguments); // eslint-disable-line no-console
  }
}

function error() {
  if (isDebugOn()) {
    var _console3;

    (_console3 = console).error.apply(_console3, arguments); // eslint-disable-line no-console
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  info: info,
  warn: warn,
  error: error
});

/***/ }),

/***/ "G3f5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"header-search",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('label',{staticClass:"header-search__label"},[_c('span',{staticClass:"header-search__visually-hidden"},[_vm._v("Search")]),_vm._v(" "),_c('button',{staticClass:"header-search__icon",attrs:{"type":"submit","aria-label":"Search"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],staticClass:"header-search__input",attrs:{"id":"search-query","name":"search-query","type":"search","placeholder":"Search"},domProps:{"value":(_vm.query)},on:{"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GH+k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.slideClass},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GMue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__ = __webpack_require__("GZXJ");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    text: {
      type: String,
      required: true
    },
    more: {
      type: Boolean,
      default: false
    },
    href: {
      type: [Object, String]
    },
    showBottom: {
      type: Boolean,
      default: true
    },
    away: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      open: false
    };
  },

  computed: {
    moreModifier: function moreModifier() {
      return { 'insight-panel__link--more': this.more };
    },
    openModifier: function openModifier() {
      return { 'insight-panel--open': this.open };
    }
  },
  methods: {
    onClick: function onClick() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.href) === 'object') {
        this.$router.push(this.href);
      } else if (this.away) {
        if (__WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__["h" /* isWrapperApp */]) {
          window.location.href = this.href;
        } else {
          window.open(this.href, '_blank');
        }
      }
    }
  }
});

/***/ }),

/***/ "GOBe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_account_account_social_avatar_account_social_avatar_vue__ = __webpack_require__("ROsZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_default_avatar_png__ = __webpack_require__("FcIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_default_avatar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_default_avatar_png__);

/* eslint-disable no-unused-vars */






var LEVEL_BRONZE_THRESHOLD = 10;
var LEVEL_SILVER_THRESHOLD = 135;
var LEVEL_GOLD_THRESHOLD = 915;
var LEVEL_PLATINUM_THRESHOLD = 4950;
var LEVEL_DIAMOND_THRESHOLD = 30000;
var LEVEL_BLACK_THRESHOLD = 375000;

var LEVEL_MAP = {
  LEVEL_LOADING: { num: 100, text: '', progressColor: 'transparent', currentColor: 'transparent' },
  LEVEL_BLUE_THRESHOLD: { num: 1, text: 'Novice', next: LEVEL_BRONZE_THRESHOLD, progressColor: '#e2a779', currentColor: '#0c96ae' },
  LEVEL_BRONZE_THRESHOLD: { num: 2, text: 'Prognosticator', next: LEVEL_SILVER_THRESHOLD, progressColor: '#cdcdcd', currentColor: '#e2a779' },
  LEVEL_SILVER_THRESHOLD: { num: 3, text: 'Diviner', next: LEVEL_GOLD_THRESHOLD, progressColor: '#fadf7c', currentColor: '#cdcdcd' },
  LEVEL_GOLD_THRESHOLD: { num: 4, text: 'Soothsayer', next: LEVEL_PLATINUM_THRESHOLD, progressColor: '#4f4e4e', currentColor: '#fadf7c' },
  LEVEL_PLATINUM_THRESHOLD: { num: 5, text: 'Fortune Teller', next: LEVEL_DIAMOND_THRESHOLD, progressColor: '#88b9ce', currentColor: '#4f4e4e' },
  LEVEL_DIAMOND_THRESHOLD: { num: 6, text: 'Prophet', next: LEVEL_BLACK_THRESHOLD, progressColor: '#000000', currentColor: '#88b9ce' },
  LEVEL_BLACK_THRESHOLD: { num: 7, text: 'Oracle', next: null, currentColor: '#000000' }
};

var ACTIVE_COLOR = '#07a0bb';
var ACTIVE_ROUTES = ['portfolio'];

var socialLevelMixin = {
  components: {
    accountSocialAvatar: __WEBPACK_IMPORTED_MODULE_3__components_account_account_social_avatar_account_social_avatar_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['profileDetail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['userData']), {
    // computed properties are in user context
    level: function level() {
      if (this.isSocialReady) {
        return this.getLevelByPredictions(this.profileDetail.profitablePredictions);
      }
      return LEVEL_MAP.LEVEL_LOADING;
    },
    activeFor: function activeFor() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(this.userData.dateRegistered).fromNow(true);
    },
    toNextLevel: function toNextLevel() {
      var next = this.level.next;
      if (next !== null) return (next - this.profileDetail.profitablePredictions).toLocaleString();
      return null;
    },
    progressPercentage: function progressPercentage() {
      var next = this.level.next;
      var predictionsNormalized = 100 * this.profileDetail.profitablePredictions;
      if (next !== null) return Math.floor(predictionsNormalized / next);
      return 0;
    },
    progressColor: function progressColor() {
      return this.level.progressColor ? this.level.progressColor : null;
    },
    progressInfoText: function progressInfoText() {
      return 'You are ' + this.progressPercentage + '% of the way to Level ' + (this.level.num + 1);
    },
    levelColor: function levelColor() {
      return this.level.currentColor;
    },
    levelColorWithRespectToNav: function levelColorWithRespectToNav() {
      return this.levelColor;
    },
    isTopLevelTrader: function isTopLevelTrader() {
      return this.toNextLevel === null;
    },
    userAvatar: function userAvatar() {
      if (this.isSocialReady && this.userData.avatarImage) {
        return this.userData.avatarImage;
      }
      return __WEBPACK_IMPORTED_MODULE_4__assets_images_default_avatar_png___default.a;
    },
    isSocialReady: function isSocialReady() {
      return this.userData && this.userData.userName !== undefined && this.profileDetail && this.profileDetail.userGuid !== undefined;
    }
  }),
  methods: {
    getProgressInfoTextForLevel: function getProgressInfoTextForLevel(num, profitablePredictions) {
      var nextLevel = this.getLevelByNumber(num);
      var predictionsNormalized = 100 * profitablePredictions;
      if (num === LEVEL_MAP.LEVEL_BLACK_THRESHOLD.num) {
        return "You've reached Top Level.";
      }

      var progressPercentage = Math.floor(predictionsNormalized / nextLevel.next);
      return 'You are ' + progressPercentage + '% of the way to Level ' + (num + 1);
    },
    getThresholdByNumber: function getThresholdByNumber(num) {
      if (num === LEVEL_MAP.LEVEL_BLACK_THRESHOLD) return '-';
      var previousLevel = this.getLevelByNumber(num - 1);
      var currentLevel = this.getLevelByNumber(num);

      return currentLevel.next - previousLevel.next;
    },
    getLevelByNumber: function getLevelByNumber(num) {
      if (num === LEVEL_MAP.LEVEL_BLUE_THRESHOLD.num) return LEVEL_MAP.LEVEL_BLUE_THRESHOLD;
      if (num === LEVEL_MAP.LEVEL_BRONZE_THRESHOLD.num) return LEVEL_MAP.LEVEL_BRONZE_THRESHOLD;
      if (num === LEVEL_MAP.LEVEL_SILVER_THRESHOLD.num) return LEVEL_MAP.LEVEL_SILVER_THRESHOLD;
      if (num === LEVEL_MAP.LEVEL_GOLD_THRESHOLD.num) return LEVEL_MAP.LEVEL_GOLD_THRESHOLD;
      if (num === LEVEL_MAP.LEVEL_PLATINUM_THRESHOLD.num) return LEVEL_MAP.LEVEL_PLATINUM_THRESHOLD;
      if (num === LEVEL_MAP.LEVEL_DIAMOND_THRESHOLD.num) return LEVEL_MAP.LEVEL_DIAMOND_THRESHOLD;
      return LEVEL_MAP.LEVEL_BLACK_THRESHOLD;
    },
    getLevelByPredictions: function getLevelByPredictions(threshold) {
      if (!threshold) return LEVEL_MAP.LEVEL_BLUE_THRESHOLD;
      if (threshold < LEVEL_BRONZE_THRESHOLD) return LEVEL_MAP.LEVEL_BLUE_THRESHOLD;
      if (threshold < LEVEL_SILVER_THRESHOLD) return LEVEL_MAP.LEVEL_BRONZE_THRESHOLD;
      if (threshold < LEVEL_GOLD_THRESHOLD) return LEVEL_MAP.LEVEL_SILVER_THRESHOLD;
      if (threshold < LEVEL_PLATINUM_THRESHOLD) return LEVEL_MAP.LEVEL_GOLD_THRESHOLD;
      if (threshold < LEVEL_DIAMOND_THRESHOLD) return LEVEL_MAP.LEVEL_PLATINUM_THRESHOLD;
      if (threshold < LEVEL_BLACK_THRESHOLD) return LEVEL_MAP.LEVEL_DIAMOND_THRESHOLD;
      return LEVEL_MAP.LEVEL_BLACK_THRESHOLD;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (socialLevelMixin);

/***/ }),

/***/ "GSOF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_v2_button_price_button_price_vue__ = __webpack_require__("al65");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { buttonPrice: __WEBPACK_IMPORTED_MODULE_1__components_market_v2_button_price_button_price_vue__["a" /* default */] },

  props: {
    // button-price content
    price: { type: Number, default: 0 },
    text: { type: String, required: true },
    win: { default: null },
    sell: { default: null },

    // visual variant: 'buy-yes' | 'sell-yes' | 'buy-no' | 'sell-no'
    variant: { type: String, required: true },

    // active / selection state
    isActive: { type: Boolean, default: false },
    isOn: { type: Boolean, default: false },
    operationValue: { type: String, default: null },

    // sell-disabled guard
    saleDisabled: { type: Boolean, default: false },
    disabledTooltip: { type: String, default: "You don't have any shares available to sell." }
  },

  computed: {
    buttonClass: function buttonClass() {
      var _ref;

      return _ref = {
        'market-button-direction': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-button-direction--' + this.variant, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-button-direction--active', this.isActive), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-button-direction--on', this.isOn), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-button-direction--off', !this.isOn), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-button-direction--off-yes', this.operationValue === 'yes'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-button-direction--off-no', this.operationValue === 'no'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-button-direction--sale-disabled', this.saleDisabled), _ref;
    }
  },

  methods: {
    onClick: function onClick() {
      if (!this.saleDisabled) {
        this.$emit('click');
      }
    }
  }
});

/***/ }),

/***/ "GVWc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_key_stats_element_js__ = __webpack_require__("wWzM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52307cf3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_key_stats_element_vue__ = __webpack_require__("iuvl");
function injectStyle (ssrContext) {
  __webpack_require__("rreX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_key_stats_element_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52307cf3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_key_stats_element_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GY5o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GZXJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return _isStandalone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _isIos; });
/* unused harmony export isMacOs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return _isWindows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _isAndroid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _isIE; });
/* unused harmony export isEdge */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _iOSWrapper; });
/* unused harmony export androidWrapper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return _isWrapperApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getWrapperForTracking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _isTablet; });
/* unused harmony export getOrientation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ua_parser_js__ = __webpack_require__("GCDA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ua_parser_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ua_parser_js__);


var uaParsed = __WEBPACK_IMPORTED_MODULE_0_ua_parser_js___default()(window.navigator.userAgent);
var _isStandalone = !!window.navigator.standalone;

var _isIos = uaParsed && uaParsed.os && uaParsed.os.name === 'iOS';

var _isMacOs = uaParsed && uaParsed.os && uaParsed.os.name === 'Mac OS';

var _isWindows = uaParsed && uaParsed.os && uaParsed.os.name.includes('Windows');

var _isAndroid = uaParsed && uaParsed.os && uaParsed.os.name === 'Android';

var _isIE = uaParsed && uaParsed.browser && (uaParsed.browser.name === 'IE' || uaParsed.browser.name === 'IEMobile');

var _isEdge = uaParsed && uaParsed.browser && uaParsed.browser.name === 'Edge';

var _iOSWrapper = window.navigator.userAgent && window.navigator.userAgent.includes('iOSWrapper');

var _androidWrapper = window.navigator.userAgent && window.navigator.userAgent.includes('AndroidWrapper');

var _isWrapperApp = _androidWrapper || _iOSWrapper;

var getWrapperForTracking = function getWrapperForTracking() {
  if (_iOSWrapper) return 'iOS';
  if (_androidWrapper) return 'Android';
  return 'None';
};

var _isTablet = uaParsed && uaParsed.device && uaParsed.device.type === 'tablet';


var _getOrientation = function _getOrientation() {
  if (window.screen.orientation) {
    if (window.screen.orientation.type.includes('portrait')) return 'portrait';
    return 'landscape';
  }
  if (Math.abs(window.orientation) === 90) return 'landscape';
  return 'portrait';
};


var userAgentMixin = {
  computed: {
    isTablet: function isTablet() {
      return _isTablet;
    },
    isWindows: function isWindows() {
      return _isWindows;
    },
    isIos: function isIos() {
      return _isIos;
    },
    isMacOs: function isMacOs() {
      return _isMacOs;
    },
    isStandalone: function isStandalone() {
      return _isStandalone;
    },
    isAndroid: function isAndroid() {
      return _isAndroid;
    },
    isIE: function isIE() {
      return _isIE;
    },
    iOSWrapper: function iOSWrapper() {
      return _iOSWrapper;
    },
    isEdge: function isEdge() {
      return _isEdge;
    },
    androidWrapper: function androidWrapper() {
      return _androidWrapper;
    },
    isWrapperApp: function isWrapperApp() {
      return _isWrapperApp;
    },
    version: function version() {
      return '1.0.67';
    }
  },
  methods: {
    getWrapperForTracking: getWrapperForTracking,
    getWindowSize: function getWindowSize() {
      return [Math.min(document.documentElement.clientWidth, window.innerWidth || 0), Math.min(document.documentElement.clientHeight, window.innerHeight || 0)];
    },
    getOrientation: function getOrientation() {
      return _getOrientation();
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (userAgentMixin);

/***/ }),

/***/ "GbUI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ge07":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObject},[_c('fieldset',{staticClass:"settings-option-switch__fieldset"},[_c('div',{staticClass:"settings-option-switch__legend-wrapper"},[_c('legend',{staticClass:"settings-option-switch__legend"},[_vm._v(_vm._s(_vm.obj.info))])]),_vm._v(" "),_c('div',{staticClass:"settings-option-switch__options"},_vm._l((_vm.obj.options),function(value){return _c('label',{key:value.key,staticClass:"settings-option-switch__option",class:{ 'settings-option-switch__option--disabled': _vm.isOptionDisabled(value) }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modelValue),expression:"modelValue"}],attrs:{"type":"radio","name":_vm.obj.key,"disabled":_vm.isOptionDisabled(value)},domProps:{"value":value.key,"checked":value.key === _vm.modelValue,"checked":_vm._q(_vm.modelValue,value.key)},on:{"change":[function($event){_vm.modelValue=value.key},function($event){return _vm.change(value.key)}]}}),_vm._v(" "),_c('span',{staticClass:"settings-option-switch__label-text"},[_vm._v(_vm._s(value.info))])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GeXy":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xMC41NzkgMTQuMjNsMy42MzctMi4wNjctMy42MzctMi4wNzN2NC4xNHpNMjIuNTkgMEgxLjQxMUMxLjAzNy4wMDEuNjguMTUuNDE1LjQxNS4xNS42NzkgMCAxLjAzNyAwIDEuNDF2MjEuMThjLjAwMi4zNzMuMTUuNzMxLjQxNS45OTVzLjYyMy40MTMuOTk2LjQxNGgyMS4xOGMuMzczLS4wMDIuNzMtLjE1Ljk5NC0uNDE0cy40MTMtLjYyMi40MTUtLjk5NVYxLjQxYy0uMDAxLS4zNzQtLjE1LS43MzItLjQxNC0uOTk2UzIyLjk2NC4wMDEgMjIuNTkgMHptLTMuOTE4IDE1LjUzNGMtLjA3OS4yOTYtLjIzNC41NjYtLjQ1Ljc4NC0uMjE2LjIxNy0uNDg2LjM3NC0uNzgxLjQ1NS0xLjA4Ni4yOTMtNS40NC4yOTMtNS40NC4yOTNzLTQuMzU1IDAtNS40NC0uMjkzYy0uMjk2LS4wOC0uNTY1LS4yMzgtLjc4MS0uNDU1LS4yMTYtLjIxOC0uMzcxLS40ODgtLjQ1LS43ODQtLjI5LTEuMDkzLS4yOS0zLjM3My0uMjktMy4zNzNzMC0yLjI4LjI5LTMuMzczYy4wNzktLjI5Ni4yMzQtLjU2Ny40NS0uNzg0LjIxNi0uMjE3LjQ4NS0uMzc0Ljc4LS40NTRDNy42NDcgNy4yNTYgMTIgNy4yNTYgMTIgNy4yNTZzNC4zNTUgMCA1LjQ0LjI5NGMuMjk3LjA4LjU2Ni4yMzcuNzgyLjQ1NC4yMTYuMjE4LjM3MS40ODguNDUuNzg1LjI5IDEuMDkuMjkgMy4zNzQuMjkgMy4zNzRzMCAyLjI3OC0uMjkgMy4zN3oiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "GebD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_timeline_js__ = __webpack_require__("ucfx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df18bb8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_timeline_vue__ = __webpack_require__("cRkn");
function injectStyle (ssrContext) {
  __webpack_require__("OOZ5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_timeline_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df18bb8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_timeline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GgQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_submit_js__ = __webpack_require__("Fn63");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfc8b932_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_submit_vue__ = __webpack_require__("MKka");
function injectStyle (ssrContext) {
  __webpack_require__("w9QL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_submit_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfc8b932_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_submit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gumd":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Gz6C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H/Zg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_about__ = __webpack_require__("L3N8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_account__ = __webpack_require__("cW54");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_browse__ = __webpack_require__("R6p5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_chart__ = __webpack_require__("9pxA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api_insight__ = __webpack_require__("gatU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api_market__ = __webpack_require__("d3y4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_api_profile__ = __webpack_require__("aeoD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_api_support__ = __webpack_require__("0X7F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_api_trade__ = __webpack_require__("FP0m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_api_wallet__ = __webpack_require__("9hG0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_api_dashboard__ = __webpack_require__("OfZf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_api_leaderboards__ = __webpack_require__("AM9x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_api_map__ = __webpack_require__("JoM+");














/* harmony default export */ __webpack_exports__["a"] = ({
  about: __WEBPACK_IMPORTED_MODULE_0__services_api_about__["a" /* default */],
  account: __WEBPACK_IMPORTED_MODULE_1__services_api_account__["a" /* default */],
  browse: __WEBPACK_IMPORTED_MODULE_2__services_api_browse__["a" /* default */],
  chart: __WEBPACK_IMPORTED_MODULE_3__services_api_chart__["a" /* default */],
  insight: __WEBPACK_IMPORTED_MODULE_4__services_api_insight__["a" /* default */],
  market: __WEBPACK_IMPORTED_MODULE_5__services_api_market__["a" /* default */],
  profile: __WEBPACK_IMPORTED_MODULE_6__services_api_profile__["a" /* default */],
  support: __WEBPACK_IMPORTED_MODULE_7__services_api_support__["a" /* default */],
  trade: __WEBPACK_IMPORTED_MODULE_8__services_api_trade__["a" /* default */],
  wallet: __WEBPACK_IMPORTED_MODULE_9__services_api_wallet__["a" /* default */],
  dashboard: __WEBPACK_IMPORTED_MODULE_10__services_api_dashboard__["a" /* default */],
  leaderboards: __WEBPACK_IMPORTED_MODULE_11__services_api_leaderboards__["a" /* default */],
  map: __WEBPACK_IMPORTED_MODULE_12__services_api_map__["a" /* default */]
});

/***/ }),

/***/ "H1Lz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "H2VB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isComponentReady),expression:"!isComponentReady"}],staticClass:"market-detail-charts__content-loader"},[_c('market-chart-loader')],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isComponentReady),expression:"isComponentReady"}]},[_c('div',{staticClass:"market-detail-charts__timeline"},[_c('charts-timeline',{attrs:{"market":_vm.market,"chartOptions":_vm.chartOptions,"isChartLoading":_vm.isLoading,"showVolume":_vm.showVolume,"showPriceAxisZoom":_vm.showPriceAxisZoom},on:{"timelineChange":_vm.onTimelineChange,"typeChange":_vm.onTypeChange,"volumeChartToggle":_vm.volumeChartToggle,"priceAxisZoomToggle":_vm.priceAxisZoomToggle}})],1),_vm._v(" "),_c('div',{ref:"chartLoadingScope",staticClass:"market-detail-charts__body"},[(!_vm.showStats)?[(_vm.title)?_c('div',{staticClass:"market-detail-charts__title",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_c('charts-container',{attrs:{"market":_vm.market,"timeline":_vm.chartTimeline,"chartOptions":_vm.chartOptions,"showVolume":_vm.showVolume,"showPriceAxisZoom":_vm.showPriceAxisZoom,"chartType":_vm.chartType,"chartData":_vm.filteredChartData,"chartDataLoaded":_vm.chartDataLoaded,"chartSystemOptions":_vm.chartSystemOptions}}),_vm._v(" "),(_vm.showChartsTable)?_c('charts-table',{staticClass:"market-detail-charts__table",attrs:{"chartOptions":_vm.chartOptions,"contracts":_vm.chartContracts},on:{"toggleItem":_vm.onContractToggle}}):_vm._e(),_vm._v(" "),(_vm.caption)?_c('div',{staticClass:"market-detail-charts__caption",domProps:{"innerHTML":_vm._s(_vm.caption)}}):_vm._e()]:[_c('div',{staticClass:"market-detail-charts__stats-container"},[(_vm.marketContractsStats.length > 0)?_c('market-contracts-stats',{attrs:{"isFixed":_vm.hasMarketHiddenContracts(_vm.market),"stats":_vm.marketContractsStats}}):(!_vm.isLoading)?_c('div',{staticClass:"market-detail-charts__stats-no-data"},[_vm._v("\n            No data to display\n          ")]):_vm._e()],1)]],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HDku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cms-map-widget",class:_vm.classModifiers},[(_vm.hasError)?_c('div',{staticClass:"cms-map-widget__message"},[_vm._v("\n    Unable to load this map right now.\n  ")]):[(_vm.mapTitle)?_c('div',{staticClass:"cms-map-widget__title"},[_vm._v("\n      "+_vm._s(_vm.mapTitle)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.showElectionToolbar)?_c('div',{staticClass:"cms-map-widget__toolbar"},[_c('div',{staticClass:"cms-map-widget__toolbar-labels"},[_c('div',{staticClass:"cms-map-widget__toolbar-label cms-map-widget__toolbar-label--democratic"},[_vm._v("\n          Democratic "+_vm._s(_vm.democraticToolbarCounter.total)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"cms-map-widget__toolbar-label cms-map-widget__toolbar-label--republican"},[_vm._v("\n          "+_vm._s(_vm.republicanToolbarCounter.total)+" Republican\n        ")])]),_vm._v(" "),_c('div',{staticClass:"cms-map-widget__toolbar-bar"},[(_vm.showMajorityLabel)?_c('div',{staticClass:"cms-map-widget__toolbar-majority"},[_vm._v("\n          "+_vm._s(_vm.majorityLabel)+"\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.toolbarSegments),function(segment){return _c('div',{key:segment.key,staticClass:"cms-map-widget__toolbar-segment",class:[
            'cms-map-widget__toolbar-segment--' + segment.party,
            { 'cms-map-widget__toolbar-segment--striped': segment.striped }
          ],style:({ width: segment.width + '%', backgroundColor: segment.color })},[(segment.showText)?_c('span',[(segment.striped)?[(segment.party === 'republican')?_c('span',{staticClass:"cms-map-widget__toolbar-segment-label cms-map-widget__toolbar-segment-label--left"},[_vm._v("\n                "+_vm._s(segment.label)+"\n              ")]):_vm._e(),_vm._v("\n              "+_vm._s(segment.displayText)+"\n              "),(segment.party === 'democratic')?_c('span',{staticClass:"cms-map-widget__toolbar-segment-label cms-map-widget__toolbar-segment-label--right"},[_vm._v("\n                "+_vm._s(segment.label)+"\n              ")]):_vm._e()]:[_vm._v("\n              "+_vm._s(segment.displayText)+"\n            ")]],2):_vm._e()])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cms-map-widget__body",class:{ 'cms-map-widget__body--with-overview': _vm.showOverviewPanel }},[_c('div',{staticClass:"cms-map-widget__main"},[_c('div',{ref:"chart",staticClass:"cms-map-widget__chart"}),_vm._v(" "),(_vm.showPinchHint)?_c('div',{staticClass:"cms-map-widget__pinch-hint",on:{"click":_vm.dismissPinchHint}},[_vm._v("\n          Pinch to zoom\n        ")]):_vm._e()]),_vm._v(" "),(_vm.showOverviewPanel)?_c('aside',{staticClass:"cms-map-widget__overview"},[_c('div',{staticClass:"cms-map-widget__overview-title"},[_c('span',{staticClass:"cms-map-widget__overview-title-desktop"},[_vm._v("\n            "+_vm._s(_vm.overviewTitleDesktop)+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"cms-map-widget__overview-title-mobile"},[_vm._v("\n            "+_vm._s(_vm.overviewTitleMobile)+"\n          ")])]),_vm._v(" "),_vm._l((_vm.overviewContracts),function(item){return _c('a',{key:item.contractId,staticClass:"cms-map-widget__overview-contract",attrs:{"href":'/markets/detail/' + item.marketId}},[(item.contractImageUrl)?_c('span',{staticClass:"cms-map-widget__overview-image",style:({ backgroundImage: 'url(' + item.contractImageUrl + ')' })}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"cms-map-widget__overview-content"},[_c('span',{staticClass:"cms-map-widget__overview-name",style:(_vm.getOverviewNameStyle(item))},[_vm._v("\n              "+_vm._s(item.shortName || item.contractName || item.name)+"\n            ")]),_vm._v(" "),_c('span',{staticClass:"cms-map-widget__overview-price"},[(_vm.hasTradePrice(item))?[_c('animated-number',{attrs:{"value":_vm.toCents(item.lastTradePrice)}}),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.getChangeCents(item),"lastClosePrice":item.lastClosePrice}})]:[_vm._v("-")]],2)])])})],2):_vm._e()]),_vm._v(" "),(_vm.showDataTable)?_c('div',{staticClass:"cms-map-widget__table-panel"},[_c('div',{staticClass:"cms-map-widget__table-header"},[_c('div',{staticClass:"cms-map-widget__table-title"},[_vm._v("Map data")]),_vm._v(" "),_c('button',{staticClass:"cms-map-widget__table-close",attrs:{"type":"button"},on:{"click":_vm.hideDataTable}},[_vm._v("\n          Close\n        ")])]),_vm._v(" "),_c('div',{staticClass:"cms-map-widget__table-scroll"},[(_vm.mapTableRows.length > 0)?_c('table',{staticClass:"cms-map-widget__table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.mapTableRows),function(row){return _c('tr',{key:row.key},[_c('td',[(row.color)?_c('span',{staticClass:"cms-map-widget__table-swatch",style:({ backgroundColor: row.color })}):_vm._e(),_vm._v("\n                "+_vm._s(row.stateCode || '-')+"\n              ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.marketName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.contractName || '-'))]),_vm._v(" "),_c('td',[(row.lastTradePrice !== null)?_c('span',[_vm._v(_vm._s(_vm.toCents(row.lastTradePrice))+"¢")]):_c('span',[_vm._v("-")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.status || '-'))])])}),0)]):_c('div',{staticClass:"cms-map-widget__table-empty"},[_vm._v("\n          No map data available.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"cms-map-widget__loading"},[_vm._v("\n      Loading map...\n    ")]):_vm._e(),_vm._v(" "),(_vm.showLegend)?_c('div',{staticClass:"cms-map-widget__legend"},_vm._l((_vm.legendData),function(item){return _c('div',{key:item.contractId,staticClass:"cms-map-widget__legend-item"},[_c('span',{staticClass:"cms-map-widget__legend-swatch",style:({ backgroundColor: item.color || '#cccccc' })}),_vm._v(" "),_c('span',{staticClass:"cms-map-widget__legend-name"},[_vm._v(_vm._s(item.shortName))]),_vm._v(" "),_c('span',{staticClass:"cms-map-widget__legend-price"},[_vm._v(_vm._s(_vm.toCents(item.lastTradePrice))+"¢")])])}),0):_vm._e()]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("State")]),_vm._v(" "),_c('th',[_vm._v("Market")]),_vm._v(" "),_c('th',[_vm._v("Contract")]),_vm._v(" "),_c('th',[_vm._v("Price")]),_vm._v(" "),_c('th',[_vm._v("Status")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HP6i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__ = __webpack_require__("k37b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_modal_modal_vue__ = __webpack_require__("CAzF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_modal_layouts_generic_vue__ = __webpack_require__("7okt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_modal_layouts_generic_small_vue__ = __webpack_require__("WRh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generics_modal_small_small_vue__ = __webpack_require__("+CQ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_account_account_login_account_login_vue__ = __webpack_require__("V3zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_account_account_login_footer_footer_vue__ = __webpack_require__("ULMz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_account_account_register_account_register_vue__ = __webpack_require__("61DT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_account_account_register_footer_footer_vue__ = __webpack_require__("cVuz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_wallet_add_funds_combined_add_funds_combined_vue__ = __webpack_require__("l9wN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_wallet_add_funds_combined_footer_footer_vue__ = __webpack_require__("1F6f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_what_is_new_popup_helpers__ = __webpack_require__("AyQu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_reloadOnChunkError__ = __webpack_require__("tkA1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");

/* eslint-disable import/extensions */


















// Lazy modal bodies, each wrapped so a failed chunk fetch (e.g. a stale client
// after a deploy) reloads the page once instead of silently failing to open.
var lazyModalBodies = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__helpers_reloadOnChunkError__["a" /* lazyComponents */])({
  accountForgotten: function accountForgotten() {
    return Promise.all/* import() */([__webpack_require__.e(8), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "8TeC"));
  },
  accountForgottenFooter: function accountForgottenFooter() {
    return Promise.all/* import() */([__webpack_require__.e(8), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "koWp"));
  },
  accountRegisterExternal: function accountRegisterExternal() {
    return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, "E9c5"));
  },
  accountDetailsVerify: function accountDetailsVerify() {
    return Promise.all/* import() */([__webpack_require__.e(61), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "EKqI"));
  },
  accountUploadId: function accountUploadId() {
    return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, "flEW"));
  },
  accountUploadDocument: function accountUploadDocument() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "3USW"));
  },
  accountDetailsUpdateModal: function accountDetailsUpdateModal() {
    return Promise.all/* import() */([__webpack_require__.e(63), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "IUvR"));
  },
  accountUpdateImage: function accountUpdateImage() {
    return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, "Aqlg"));
  },
  deposited: function deposited() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "WXHk"));
  },
  potentialPayouts: function potentialPayouts() {
    return Promise.all/* import() */([__webpack_require__.e(14), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "gTQM"));
  },
  exportHistory: function exportHistory() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "cgtd"));
  },
  insightModal: function insightModal() {
    return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, "TJ+c"));
  },
  research: function research() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "eNmc"));
  },
  taxInfoNotification: function taxInfoNotification() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "wQDz"));
  },
  twitterTimeline: function twitterTimeline() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "FM5G"));
  },
  newsFeed: function newsFeed() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "xJ4c"));
  },
  attachToHome: function attachToHome() {
    return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "r6f4"));
  },
  offersIndicatorPopup: function offersIndicatorPopup() {
    return Promise.all/* import() */([__webpack_require__.e(44), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "zyut"));
  },
  marketContractsStatsPopup: function marketContractsStatsPopup() {
    return Promise.all/* import() */([__webpack_require__.e(48), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "ETXZ"));
  },
  accountResetPassword: function accountResetPassword() {
    return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, "TMp7"));
  },
  orientationInfo: function orientationInfo() {
    return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "v0Cj"));
  },
  accountBadgesList: function accountBadgesList() {
    return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "yeq6"));
  },
  userProfileOverview: function userProfileOverview() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "M6xY"));
  },
  userProfileOverviewHeader: function userProfileOverviewHeader() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "nNeU"));
  },
  userReport: function userReport() {
    return Promise.all/* import() */([__webpack_require__.e(20), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "0RmI"));
  },
  leaderboardsTrophyPyramid: function leaderboardsTrophyPyramid() {
    return Promise.all/* import() */([__webpack_require__.e(49), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "mgKt"));
  },
  messagingJourneyInfo: function messagingJourneyInfo() {
    return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, "sIse"));
  },
  coinbaseProcessOverview: function coinbaseProcessOverview() {
    return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "MbhW"));
  },
  announcement: function announcement() {
    return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, "Mz4K"));
  },
  affiliationsPopup: function affiliationsPopup() {
    return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "jI1b"));
  },
  accountAlreadyExists: function accountAlreadyExists() {
    return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "QSM8"));
  },
  accountAlreadyExistsFooter: function accountAlreadyExistsFooter() {
    return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "Z/tr"));
  },
  accountEnableClassicPredictit: function accountEnableClassicPredictit() {
    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "Y6Bb"));
  },
  accountEnableClassicPredictitFooter: function accountEnableClassicPredictitFooter() {
    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "nBxi"));
  },
  marketOwnershipConflictModal: function marketOwnershipConflictModal() {
    return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, "nEDX"));
  },
  accountTwoFactorVerify: function accountTwoFactorVerify() {
    return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, "b8Ry"));
  },
  accountTwoFactorPrompt: function accountTwoFactorPrompt() {
    return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, "aUi2"));
  },
  accountPhoneUpdate: function accountPhoneUpdate() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "AORQ"));
  },
  marketRules: function marketRules() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "bynG"));
  },
  purchaseReviewAndConfirmSushi: function purchaseReviewAndConfirmSushi() {
    return Promise.all/* import() */([__webpack_require__.e(22), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "rJdw"));
  },
  shareInfoPopup: function shareInfoPopup() {
    return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "8O0X"));
  },
  captcha: function captcha() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "aDe5"));
  },
  priceOddsTogglePopup: function priceOddsTogglePopup() {
    return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, "QHOr"));
  },
  whatIsNewPopup: function whatIsNewPopup() {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "NwTj"));
  },
  whatIsNewPopupFooter: function whatIsNewPopupFooter() {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "mHXl"));
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_16__mixins_loader__["a" /* default */]],
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    modal: __WEBPACK_IMPORTED_MODULE_3__components_generics_modal_modal_vue__["a" /* default */],
    genericPopup: __WEBPACK_IMPORTED_MODULE_4__components_generics_modal_layouts_generic_vue__["a" /* default */],
    genericSmallPopup: __WEBPACK_IMPORTED_MODULE_5__components_generics_modal_layouts_generic_small_vue__["a" /* default */],
    smallModal: __WEBPACK_IMPORTED_MODULE_6__components_generics_modal_small_small_vue__["default"],
    accountLogin: __WEBPACK_IMPORTED_MODULE_7__components_account_account_login_account_login_vue__["a" /* default */],
    accountLoginFooter: __WEBPACK_IMPORTED_MODULE_8__components_account_account_login_footer_footer_vue__["a" /* default */],
    accountRegister: __WEBPACK_IMPORTED_MODULE_9__components_account_account_register_account_register_vue__["a" /* default */],
    accountRegisterFooter: __WEBPACK_IMPORTED_MODULE_10__components_account_account_register_footer_footer_vue__["a" /* default */],
    addFundsCombined: __WEBPACK_IMPORTED_MODULE_11__components_wallet_add_funds_combined_add_funds_combined_vue__["a" /* default */],
    addFundsCombinedFooter: __WEBPACK_IMPORTED_MODULE_12__components_wallet_add_funds_combined_footer_footer_vue__["a" /* default */]
  }, lazyModalBodies),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['isTaxNotificationMandatory']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('popup', ['currentPopup', 'currentSmallPopup', 'currentPopupOptions', 'lastTopPosition', 'tradePopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isShutdownModeOn', 'collegeAffiliationEnabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isUserRestricted']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['status', 'registrationFlowActive', 'twoFactorEnabled']), {
    canCloseAuth: function canCloseAuth() {
      return this.$route.name !== 'disqus-auth';
    },
    footerHideBodyClass: function footerHideBodyClass() {
      return this.currentPopupOptions.hideFooter ? 'modal__body--medium modal__footer--hide' : 'modal__body--medium';
    }
  }),
  watch: {
    // Reset loading state when reCAPTCHA modal closes
    currentPopup: function currentPopup(newVal) {
      if (newVal !== __WEBPACK_IMPORTED_MODULE_17__components_app_app_modals_modals_constants__["a" /* MODALS */].RECAPTCHA_CHALLENGE) {
        this.recaptchaVerifying = false;
      }
    },

    // Reset loading state when popup options change (new v2 challenge)
    currentPopupOptions: function currentPopupOptions() {
      // Always reset verifying state when options change - this handles the case
      // where we show a new v2 challenge while the modal is already showing
      if (this.currentPopup === __WEBPACK_IMPORTED_MODULE_17__components_app_app_modals_modals_constants__["a" /* MODALS */].RECAPTCHA_CHALLENGE) {
        this.recaptchaVerifying = false;
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['setSettingsAnnouncementCurState']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentSmallPopup', 'setCurrentPopupWithDelay']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['setCurrentDeposit', 'markFirstDepositDone']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['logout', 'endRegistrationFlow']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('overlay', { hideOverlay: 'hide' }), {
    isCurrentModal: function isCurrentModal(name) {
      return this.currentPopup === name;
    },
    isCurrentSmallModal: function isCurrentSmallModal(name) {
      return this.currentSmallPopup === name;
    },
    closeModal: function closeModal() {
      this.setCurrentPopup();
      this.onClose();
    },
    closeSmallModal: function closeSmallModal() {
      this.setCurrentSmallPopup();
      this.onClose();
    },
    closeModalWithLogout: function closeModalWithLogout() {
      this.logout();
      this.setCurrentPopup();
      this.onClose();
    },
    closePaymentSuccessModal: function closePaymentSuccessModal() {
      this.markFirstDepositDone();
      this.setCurrentPopup();
      this.setCurrentDeposit(null);
      this.onClose();
    },
    closeModalHideOverlay: function closeModalHideOverlay() {
      this.setCurrentPopup();
      this.hideOverlay();
      this.onClose();
    },
    closeUserReportModal: function closeUserReportModal() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_17__components_app_app_modals_modals_constants__["a" /* MODALS */].SMALL_USER_PROFILE);
    },
    closeWhatIsNewPopup: function closeWhatIsNewPopup() {
      var _this = this;

      this.loaderAdd(document.body);
      this.setSettingsAnnouncementCurState(__WEBPACK_IMPORTED_MODULE_14__components_what_is_new_popup_helpers__["b" /* VERSION_TO_MIGRATE_TO */]).then(function () {
        _this.loaderRemove(document.body);
        _this.closeModal();
      }).catch(function () {
        _this.closeModal();
        _this.loaderRemove(document.body);
      });
    },
    onClose: function onClose() {
      if (this.currentPopupOptions && typeof this.currentPopupOptions.onClose !== 'undefined') {
        this.currentPopupOptions.onClose.apply(this);
      }
    },
    onRecaptchaChallengeComplete: function onRecaptchaChallengeComplete(token) {
      // When v2 captcha is completed, show loading state while API processes
      if (token && this.currentPopupOptions && typeof this.currentPopupOptions.onVerified === 'function') {
        this.recaptchaVerifying = true;
        this.currentPopupOptions.onVerified(token);
      }
    },
    addFundsClose: function addFundsClose() {
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'click',
        label: 'Closing/Cancel Deposit Modal'
      }));
      // Chain to next modal in priority order: COLLEGE_AFFILIATION → TWO_FACTOR_PROMPT
      if (this.collegeAffiliationEnabled && this.status && this.status.isUCAffilSet === null) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_17__components_app_app_modals_modals_constants__["a" /* MODALS */].COLLEGE_AFFILIATION);
      } else if (this.twoFactorEnabled !== true && !__WEBPACK_IMPORTED_MODULE_13__constants__["a" /* default */].DISABLE_TWO_FACTOR_PROMPT) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_17__components_app_app_modals_modals_constants__["a" /* MODALS */].TWO_FACTOR_PROMPT);
      } else {
        this.closeModal();
      }
    },

    // Called when ACCOUNT_VERIFY (Personal Details) modal is closed during registration
    closeAccountVerifyModal: function closeAccountVerifyModal() {
      // Closed without completion - check 2FA as final step
      if (this.twoFactorEnabled !== true && !__WEBPACK_IMPORTED_MODULE_13__constants__["a" /* default */].DISABLE_TWO_FACTOR_PROMPT) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_17__components_app_app_modals_modals_constants__["a" /* MODALS */].TWO_FACTOR_PROMPT);
      } else {
        this.closeModal();
      }
    },
    paymentSuccessDone: function paymentSuccessDone() {
      // Chain to next modal in priority order: COLLEGE_AFFILIATION → TWO_FACTOR_PROMPT
      if (this.collegeAffiliationEnabled && this.status && this.status.isUCAffilSet === null) {
        this.setCurrentPopupWithDelay({ name: __WEBPACK_IMPORTED_MODULE_17__components_app_app_modals_modals_constants__["a" /* MODALS */].COLLEGE_AFFILIATION });
      } else if (this.twoFactorEnabled !== true && !__WEBPACK_IMPORTED_MODULE_13__constants__["a" /* default */].DISABLE_TWO_FACTOR_PROMPT) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_17__components_app_app_modals_modals_constants__["a" /* MODALS */].TWO_FACTOR_PROMPT);
      } else {
        this.closeModal();
      }
    },

    // Called when COLLEGE_AFFILIATION modal is closed during registration
    closeAffiliationsModal: function closeAffiliationsModal() {
      // College affiliation is second-to-last - 2FA prompt is final step
      if (this.twoFactorEnabled !== true && !__WEBPACK_IMPORTED_MODULE_13__constants__["a" /* default */].DISABLE_TWO_FACTOR_PROMPT) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_17__components_app_app_modals_modals_constants__["a" /* MODALS */].TWO_FACTOR_PROMPT);
      } else {
        this.closeModal();
      }
    },

    // Called when affiliations form is submitted successfully
    onAffiliationsSubmitted: function onAffiliationsSubmitted() {
      // Same as close - 2FA prompt is final step
      if (this.twoFactorEnabled !== true && !__WEBPACK_IMPORTED_MODULE_13__constants__["a" /* default */].DISABLE_TWO_FACTOR_PROMPT) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_17__components_app_app_modals_modals_constants__["a" /* MODALS */].TWO_FACTOR_PROMPT);
      } else {
        this.closeModal();
      }
    }
  }),
  data: function data() {
    return {
      MODALS: __WEBPACK_IMPORTED_MODULE_17__components_app_app_modals_modals_constants__["a" /* MODALS */],
      constants: __WEBPACK_IMPORTED_MODULE_13__constants__["a" /* default */],
      recaptchaVerifying: false,
      gtmAddFunds: {
        virtualPage: '/Account/_DptFrmUsSgnUp',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'Deposit',
          action: 'click',
          label: 'Closing Deposit Modal'
        }
      },
      gtmAccountVerify: {
        virtualPage: '_SgnUpDptIDV',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'ID Verification',
          action: 'click',
          label: 'Closing ID Verification Modal'
        }
      },
      gtmLogin: {
        name: 'login',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'Login',
          action: 'click',
          label: 'Closing Login Modal'
        }
      },
      gtmSignUp: {
        virtualPage: '/Account/SignUp',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'Registration',
          action: 'click',
          label: 'Closing Registration Modal'
        }
      }
    };
  }
});

/***/ }),

/***/ "HPJt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "HQPR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"market-settings-button",class:{
    'market-settings-button--disabled': _vm.disabled,
    'market-settings-button--theme-details': _vm.theme === 'details',
  },attrs:{"aria-label":"Open Trade Experience Settings"},on:{"click":_vm.onToggle}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hi7N":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyNCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIyMyIgaGVpZ2h0PSIxNSIgcng9IjcuNSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLW9wYWNpdHk9IjAuMSIvPgo8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iNiIgZmlsbD0iI0NFRDJEQiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "HqNE":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAuMzg0IiBoZWlnaHQ9IjQyLjU0MSIgdmlld0JveD0iMCAwIDMwLjM4NCA0Mi41NDEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMTUuMTkyIDRWMzguNTQxTTMuNSAyNi44NDlMMTUuMTkyIDM4LjU0MUwyNi44ODQgMjYuODQ5IiBzdHJva2U9IiNEOTUzNEYiIHN0cm9rZS13aWR0aD0iNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "HqyC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HvTw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_shares_bar_js__ = __webpack_require__("Paoj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c2fa3c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_shares_bar_vue__ = __webpack_require__("IvC7");
function injectStyle (ssrContext) {
  __webpack_require__("BYVu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_shares_bar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c2fa3c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_shares_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HzXs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_biggest_gains_element_market_biggest_gains_element_vue__ = __webpack_require__("4vD6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_content_loader__ = __webpack_require__("SHAV");









var REFRESH_ENABLED = true;
var REFRESH_INTERVAL = 10 * 60 * 1000;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__["swiperSlide"],
    marketBiggestGainsElement: __WEBPACK_IMPORTED_MODULE_5__components_market_market_biggest_gains_element_market_biggest_gains_element_vue__["a" /* default */],
    biggestGainsLoader: __WEBPACK_IMPORTED_MODULE_6__components_content_loader__["h" /* BiggestGainsLoader */]
  },
  props: {
    extended: { type: Boolean, default: false }
  },
  data: function data() {
    var _this = this;

    return {
      isComponentReady: false,
      activeIndex: 0,
      interval: null,
      swiperOptions: {
        spaceBetween: 0,
        autoplay: 10 * 1000,
        slidesPerColumn: 1,
        loop: true,
        direction: 'horizontal',
        onTransitionStart: function onTransitionStart(swp) {
          _this.activeIndex = swp.activeIndex;
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('widgets', ['getWidget']), {
    gainsData: function gainsData() {
      return this.getWidget('biggest-gains').data || [];
    },
    lossesData: function lossesData() {
      return this.getWidget('biggest-losses').data || [];
    },
    classModifiers: function classModifiers() {
      return {
        'market-biggest-gains': true,
        'market-biggest-gains--extended': this.extended
      };
    },
    dummyComponents: function dummyComponents() {
      if (this.isLayoutMobile) return __WEBPACK_IMPORTED_MODULE_2_lodash_range___default()(0, 1);
      return __WEBPACK_IMPORTED_MODULE_2_lodash_range___default()(0, 2);
    },
    items: function items() {
      var results = [];
      if (this.isLayoutDesktop) {
        if (this.gainsData.length) results.push(this.gainsData[0]);
        if (this.lossesData.length) results.push(this.lossesData[0]);
      } else {
        if (this.gainsData.length) results.push(this.gainsData);
        if (this.lossesData.length) results.push(this.lossesData);
      }
      return results;
    },
    shouldShowMobileSlider: function shouldShowMobileSlider() {
      return this.items.length > 0 && !this.isLayoutDesktop;
    },
    shouldShowDesktopList: function shouldShowDesktopList() {
      return this.items.length > 0 && this.isLayoutDesktop;
    },
    prevArrowModifiers: function prevArrowModifiers() {
      return {
        'market-biggest-gains__swiper-arrows__arrow': true,
        'market-biggest-gains__swiper-arrows__arrow--left': true
      };
    },
    nextArrowModifiers: function nextArrowModifiers() {
      return {
        'market-biggest-gains__swiper-arrows__arrow': true,
        'market-biggest-gains__swiper-arrows__arrow--right': true
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('widgets', ['fetchBiggestGains', 'fetchBiggestLoss']), {
    prevSlide: function prevSlide() {
      this.$refs['market-biggest-gains-slider'].swiper.slidePrev();
    },
    nextSlide: function nextSlide() {
      this.$refs['market-biggest-gains-slider'].swiper.slideNext();
    },
    fetchData: function fetchData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.fetchBiggestGains(), this.fetchBiggestLoss()]).then(function () {
        _this2.isComponentReady = true;
      });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    this.fetchData();
    if (REFRESH_ENABLED) {
      this.interval = setInterval(function () {
        _this3.fetchData();
      }, REFRESH_INTERVAL);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.interval) clearInterval(this.interval);
  }
});

/***/ }),

/***/ "I+ky":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_shares_bar_market_shares_bar_vue__ = __webpack_require__("HvTw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_v2_button_price_button_price_vue__ = __webpack_require__("al65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_market_v2_market_disabled_outcome_v2_market_disabled_outcome_v2_vue__ = __webpack_require__("tRmv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_market_v2_market_trading_unavailable_v2_market_trading_unavailable_v2_vue__ = __webpack_require__("azKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__ = __webpack_require__("X4WA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_modules_trade__ = __webpack_require__("fmhl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_market_market_ownership_and_orders_bar_market_ownership_and_orders_bar_vue__ = __webpack_require__("Pf5Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_modules_app__ = __webpack_require__("WSTi");


/* eslint-disable */














var firstNonEmptyString = function firstNonEmptyString() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.find(function (value) {
    return typeof value === 'string' && value.trim() !== '';
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_accountVerify__["a" /* default */]],
  components: {
    buttonPrice: __WEBPACK_IMPORTED_MODULE_6__components_market_v2_button_price_button_price_vue__["a" /* default */],
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_4__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    marketSharesBar: __WEBPACK_IMPORTED_MODULE_5__components_market_market_shares_bar_market_shares_bar_vue__["a" /* default */],
    marketDisabledOutcomeV2: __WEBPACK_IMPORTED_MODULE_9__components_market_v2_market_disabled_outcome_v2_market_disabled_outcome_v2_vue__["a" /* default */],
    marketTradingUnavailableV2: __WEBPACK_IMPORTED_MODULE_10__components_market_v2_market_trading_unavailable_v2_market_trading_unavailable_v2_vue__["a" /* default */],
    marketOwnershipAndOrdersBar: __WEBPACK_IMPORTED_MODULE_13__components_market_market_ownership_and_orders_bar_market_ownership_and_orders_bar_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    contract: {
      type: Object,
      required: true
    },
    forCmsWidget: {
      type: Boolean,
      default: false
    },
    dashboardMode: {
      type: Boolean,
      default: false
    },
    showOwnershipAndOrdersBar: {
      type: Boolean,
      default: false
    },
    mobileLayout: {
      type: Number,
      default: null
    },
    showSharesOwnedIconOnImage: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hovered: false,
      BUTTONS: __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */],
      OPERATIONS: __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["b" /* OPERATIONS */],
      VALUES: __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */],
      isWaiting: false,
      activeButton: __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].BUY_YES.id,
      chart: null,
      sellDisabledTooltipText: "You don't have any shares available to sell."
    };
  },
  mounted: function mounted() {
    this.initializePurchaseButtons();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop', 'currentPriceSymbol']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'tradeOperationToggle', 'isInConfirmationMode', 'hidePurchaseForContractId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('trade', ['tradeDirectionForMarket']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['status']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('app', ['settingShowOdds', 'settingMobileLayout']), {
    hasExplicitMobileLayout: function hasExplicitMobileLayout() {
      return this.mobileLayout !== null;
    },
    effectiveMobileLayout: function effectiveMobileLayout() {
      if (this.hasExplicitMobileLayout) {
        return this.mobileLayout;
      }

      return this.settingMobileLayout;
    },
    isSimplifiedMobileLayout: function isSimplifiedMobileLayout() {
      return this.isLayoutMobile && this.effectiveMobileLayout === __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].SIMPLIFIED;
    },
    isStandardMobileLayout: function isStandardMobileLayout() {
      if (this.forCmsWidget) {
        return true;
      }
      return this.isLayoutMobile && this.effectiveMobileLayout === __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].STANDARD;
    },
    isCondensedMobileLayout: function isCondensedMobileLayout() {
      return this.isLayoutMobile && this.effectiveMobileLayout === __WEBPACK_IMPORTED_MODULE_14__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].CONDENSED && !this.forCmsWidget;
    },
    hideButtons: function hideButtons() {
      if (this.forCmsWidget && this.isMarketDisabled) {
        return true;
      }
      if (this.isLayoutMobile && this.isMarketDisabled) {
        return true;
      }

      return this.isSimplifiedMobileLayout && !this.isMarketDisabled && (!this.isContractActive || this.hidePurchaseForContractId === this.contract.contractId);
    },
    isContractActive: function isContractActive() {
      return this.tradeOptions && this.tradeOptions.contractId === this.contract.contractId;
    },
    isButtonPriceActive: function isButtonPriceActive() {
      return this.isContractActive;
    },
    showActiveButtonSecondaryPrice: function showActiveButtonSecondaryPrice() {
      return this.isButtonPriceActive && !this.isCondensedMobileLayout;
    },
    tradeOperationAndValue: function tradeOperationAndValue() {
      return {
        type: this.tradeOptions.operationType,
        value: this.tradeOptions.operationValue
      };
    },
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_3__models_contract__["a" /* default */](this.contract);
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["k" /* isMarketSingle */])(this.market);
    },
    singleMarketTitle: function singleMarketTitle() {
      return firstNonEmptyString(this.market && this.market.marketShortName, this.contractModel.contractName, this.contractModel.name);
    },
    title: function title() {
      return this.isMarketSingle ? this.singleMarketTitle : this.contractModel.contractName || this.contractModel.name;
    },
    classModifiers: function classModifiers() {
      return {
        'market-contract-horizontal-sushi-common-betslip': true,
        'market-contract-horizontal-sushi-common-betslip--show-shares-owned-on-image': this.showSharesOwnedIconOnImage,
        'market-contract-horizontal-sushi-common-betslip--disabled': this.isMarketDisabled,
        'market-contract-horizontal-sushi-common-betslip--hovered': this.hovered,
        'market-contract-horizontal-sushi-common-betslip--settled': this.isMarketSettled,
        'market-contract-horizontal-sushi-common-betslip--settled-yes': this.isMarketSettled && this.isWinnerYes,
        'market-contract-horizontal-sushi-common-betslip--settled-no': this.isMarketSettled && this.isWinnerNo,
        'market-contract-horizontal-sushi-common-betslip--should-close': this.isContractActive,
        'market-contract-horizontal-sushi-common-betslip--with-ownership-and-orders': this.showOwnershipAndOrdersSummary,
        'market-contract-horizontal-sushi-common-betslip--dashboard': this.dashboardMode,
        'market-contract-horizontal-sushi-common-betslip--cms-widget': this.forCmsWidget,
        'market-contract-horizontal-sushi-common-betslip--standard': this.hasExplicitMobileLayout && this.isStandardMobileLayout,
        'market-contract-horizontal-sushi-common-betslip--simplified': this.hasExplicitMobileLayout && this.isSimplifiedMobileLayout,
        'market-contract-horizontal-sushi-common-betslip--condensed': this.isCondensedMobileLayout
      };
    },
    imageUrl: function imageUrl() {
      return this.contractModel.contractImageSmallUrl || this.contractModel.contractImageUrl;
    },
    contractImageStyleModifiers: function contractImageStyleModifiers() {
      return {
        'background-image': 'url(' + this.imageUrl + ')'
      };
    },
    sharesOwnedStyleModifiers: function sharesOwnedStyleModifiers() {
      return {
        'market-contract-horizontal-sushi-common-betslip__image-shares-owned': true,
        'market-contract-horizontal-sushi-common-betslip__image-shares-owned--no': this.contractModel.mode === 'no'
      };
    },
    showOpenOffers: function showOpenOffers() {
      return !this.isMarketSettled && this.contractModel.userOpenOrders > 0;
    },
    showSharesBar: function showSharesBar() {
      return !this.isMarketSettled && this.contractModel.userQuantity > 0;
    },
    showSharesBarBottom: function showSharesBarBottom() {
      return this.showSharesBar && this.isMarketDisabled;
    },
    showOwnershipAndOrdersSummary: function showOwnershipAndOrdersSummary() {
      return this.showOwnershipAndOrdersBar && !this.isMarketSettled && (this.showSharesBar || this.showOpenOffers);
    },
    isMarketDisabled: function isMarketDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["z" /* isMarketDisabled */])(this.market);
    },
    isMarketSettled: function isMarketSettled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["o" /* isMarketSettled */])(this.market);
    },
    isMarketJourneyDisabled: function isMarketJourneyDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["A" /* isMarketJourneyDisabled */])(this.market);
    },
    currentPrice: function currentPrice() {
      if (!this.contractModel.hasLastTradePrice) {
        return 0;
      }

      if (this.dashboardMode && this.contractModel.mode === 'no') {
        return 100 - this.contractModel.lastTradePriceAsCents;
      }
      return this.contractModel.lastTradePriceAsCents;
    },
    isWinnerYes: function isWinnerYes() {
      return this.contract.settledStatus === 1;
    },
    isWinnerNo: function isWinnerNo() {
      return this.isMarketSingle && this.contract.settledStatus === 2;
    },
    isContractSaleDisabled: function isContractSaleDisabled() {
      return this.contractModel.userQuantity === 0;
    },
    showChangePriceIndicator: function showChangePriceIndicator() {
      if (!this.contractModel.changePriceAsCents) {
        return false;
      }
      if (this.contractModel.lastClosePrice === null) {
        return false;
      }
      if (this.isMarketSingle) {
        return false;
      }
      return true;
    },
    showNoPriceHintTitle: function showNoPriceHintTitle() {
      return this.dashboardMode && this.isLayoutMobile && this.contractModel.mode === __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].NO && this.currentPrice > 0;
    },
    noPriceHintTitle: function noPriceHintTitle() {
      return this.settingShowOdds ? 'NO Odds' : 'NO Price';
    }
  }),
  watch: {
    // isContractActive(value) {
    //   if (this.isLayoutDesktop) {
    //     if (!value) {
    //       this.activeButton = BUTTONS.BUY_YES.id;
    //     }
    //   }
    // },
    'tradeOperationAndValue': function tradeOperationAndValue(v) {
      if (this.contract.contractId !== this.tradeOptions.contractId) {
        return;
      }
      var type = v.type,
          value = v.value;

      if (type && value) {
        if (type === __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["b" /* OPERATIONS */].SELL) {
          this.activeButton = value === __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].YES ? __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].SELL_YES.id : __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].SELL_NO.id;
        } else {
          this.activeButton = value === __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].YES ? __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].BUY_YES.id : __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].BUY_NO.id;
        }
      }
    },
    tradeOperationToggle: function tradeOperationToggle(switchTo) {
      if (this.contract.contractId !== this.tradeOptions.contractId || !switchTo) return;
      var button = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["d" /* getActiveButtonAfterSwitch */])(this.contractModel, switchTo);
      this.toggleTradeOperation(null);
      this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'toggleTradeOperation', 'toggleHidePurchaseForContractId', 'setBottomBetSlipExtendedMode', 'setBottomWidgetFooterMode', 'setBottomWidgetFooterModeContractsSection']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('market', ['pushSessionHistoryContract']), {
    getDefaultButtonForContract: function getDefaultButtonForContract() {
      // A held position or open order on the contract dictates the side the user
      // can act on: 'yes' -> buy/sell YES only, 'no' -> buy/sell NO only.
      if (this.contractModel.mode === __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].YES) {
        return __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].BUY_YES;
      }
      if (this.contractModel.mode === __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].NO) {
        return __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].BUY_NO;
      }
      // No position/orders: fall back to the direction last traded in this market.
      var marketDirection = this.market && this.tradeDirectionForMarket(this.market.marketId);
      return marketDirection === __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].NO ? __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].BUY_NO : __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */].BUY_YES;
    },
    getButtonForTradeOptions: function getButtonForTradeOptions() {
      var _this = this;

      if (!this.tradeOptions || !this.tradeOptions.operationType || !this.tradeOptions.operationValue) {
        return this.getDefaultButtonForContract();
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */]).find(function (button) {
        return button.type === _this.tradeOptions.operationType && button.value === _this.tradeOptions.operationValue;
      }) || this.getDefaultButtonForContract();
    },
    findActiveButton: function findActiveButton() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["a" /* BUTTONS */]).find(function (i) {
        return i.id === _this2.activeButton;
      });
    },
    getTypeAndValueIfButtonActiveOrDefaults: function getTypeAndValueIfButtonActiveOrDefaults() {
      var type = this.tradeOptions.operationType;
      var value = this.tradeOptions.operationValue;
      if (this.activeButton) {
        var button = this.findActiveButton();
        type = button.type;
        value = button.value;
      }
      return { type: type, value: value };
    },
    onClickOpenOffers: function onClickOpenOffers() {
      var _getTypeAndValueIfBut = this.getTypeAndValueIfButtonActiveOrDefaults(),
          type = _getTypeAndValueIfBut.type,
          value = _getTypeAndValueIfBut.value;

      this.openPurchaseJourney(this.contractModel.contractId, type, value);
    },
    initializePurchaseButtons: function initializePurchaseButtons() {
      var button = this.getDefaultButtonForContract();
      this.activeButton = button.id;

      if ((!this.isMarketSingle || this.isLayoutMobile) && this.tradeOptions && this.contract.contractId === this.tradeOptions.contractId && (button.type !== this.tradeOptions.operationType || button.value !== this.tradeOptions.operationValue)) {
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value);
      }
    },
    onMouseOver: function onMouseOver() {
      this.hovered = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.hovered = false;
    },
    onContractClick: function onContractClick() {
      if (this.isCondensedMobileLayout) {
        var _getTypeAndValueIfBut2 = this.getTypeAndValueIfButtonActiveOrDefaults(),
            type = _getTypeAndValueIfBut2.type,
            value = _getTypeAndValueIfBut2.value;

        this.openPurchaseJourney(this.contractModel.contractId, type, value);
        return;
      }

      if (this.isContractActive && this.isLayoutMobile) {
        if (this.dashboardMode) {
          this.setTradeOptions(null);
          return;
        }
      }

      if (this.tradeOptions.contractId !== this.contract.contractId) {
        var button = this.getDefaultButtonForContract();
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, true);
      } else {
        this.toggleHidePurchaseForContractId(this.contractModel.contractId);
      }
    },
    isButtonActiveClassModifiers: function isButtonActiveClassModifiers(index) {
      var selectedButton = this.isContractActive ? this.getButtonForTradeOptions() : null;
      var isOn = !!selectedButton && selectedButton.id === index;

      return {
        'market-contract-horizontal-sushi-common-betslip__button-single--active': this.isContractActive,
        'market-contract-horizontal-sushi-common-betslip__button-single--on': isOn,
        'market-contract-horizontal-sushi-common-betslip__button-single--off': !isOn,
        'market-contract-horizontal-sushi-common-betslip__button-single--off-yes': this.tradeOptions.operationValue === __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].YES,
        'market-contract-horizontal-sushi-common-betslip__button-single--off-no': this.tradeOptions.operationValue === __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].NO
      };
    },
    openPurchaseJourney: function openPurchaseJourney(contractId, operationType, operationValue) {
      var dontExtendMobileBetslip = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (this.isWaiting) {
        return;
      }

      // this.isWaiting = true;
      // waitForFirebaseInitialized()
      //   .then(() => {
      //   if (this.isLoggedIn) {
      //     return waitForStatusReady();
      //   }
      //   return Promise.resolve(1);
      // })
      //   .then(() => {
      //
      //   });

      this.isWaiting = false;
      // contract does not modify tradeOptions, is simply used as a widget somewhere
      if (this.forCmsWidget) {
        this.$emit('contractClicked', { contractId: contractId, operationType: operationType, operationValue: operationValue });
        return;
      }
      // if (this.isLoggedIn && !this.isUserVerified) {
      //   this.showAccountVerifyPopup();
      //   return;
      // }
      // if (this.isLoggedIn && !this.status.hasBeenFunded) {
      //   this.showAddFundsPopup({ delay: false });
      //   return;
      // }
      if (this.isMarketJourneyDisabled) return;

      this.pushSessionHistoryContract({
        value: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.contract, {
          marketName: this.market.marketShortName || this.market.marketName
        })
      });
      this.setTradeOptions({
        contractId: contractId,
        operationType: operationType,
        operationValue: operationValue !== null ? operationValue : this.contractModel.mode || __WEBPACK_IMPORTED_MODULE_11__components_market_market_contract_horizontal_sushi_market_contract_horizontal_sushi_js__["c" /* VALUES */].YES
      });
      if (!dontExtendMobileBetslip) {
        this.setBottomWidgetFooterMode(__WEBPACK_IMPORTED_MODULE_12__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].BETSLIP);
        if (this.isLayoutMobile) {
          this.setBottomWidgetFooterModeContractsSection(__WEBPACK_IMPORTED_MODULE_12__store_modules_trade__["a" /* BOTTOM_WIDGET_FOOTER_MODES */].BETSLIP);
        }
        this.setBottomBetSlipExtendedMode(true);
      }
    }
  })
});

/***/ }),

/***/ "I1/e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I4Gm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IKgY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_mobile_menu_js__ = __webpack_require__("hPGJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60f93c9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_mobile_menu_vue__ = __webpack_require__("Dlcl");
function injectStyle (ssrContext) {
  __webpack_require__("erdd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_mobile_menu_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60f93c9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_mobile_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IMxR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IS7d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"how-it-works-old"},[_c('h2',{staticClass:"how-it-works-old__title"},[(_vm.isUserRestricted)?[_vm._v("\n      Coming Soon\n    ")]:(_vm.isShutdownModeOn)?[_vm._v("\n      How Prediction Markets Work\n    ")]:[_vm._v("\n      How It Works\n    ")]],2),_vm._v(" "),_c('div',{staticClass:"how-it-works-old__items row"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"how-it-works-old__item column small-12 large-4"},[_c('div',{staticClass:"how-it-works-old__item-image-container"},[_c('img',{staticClass:"how-it-works-old__item-image",attrs:{"src":item.icon}})]),_vm._v(" "),_c('h4',{staticClass:"how-it-works-old__item-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"how-it-works-old__item-description"},[_vm._v("\n        "+_vm._s(item.description)+"\n      ")])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IW6G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IYz5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_js__ = __webpack_require__("b4Ty");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a11af04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__("TD6b");
function injectStyle (ssrContext) {
  __webpack_require__("Vngw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a11af04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_about__ = __webpack_require__("Ke/w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_browse__ = __webpack_require__("0KBQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_chart__ = __webpack_require__("CPcE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_market__ = __webpack_require__("L09H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_overlay__ = __webpack_require__("X/Fy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_popup__ = __webpack_require__("Dwlj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_search__ = __webpack_require__("dI8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_support__ = __webpack_require__("8sRt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_trade__ = __webpack_require__("fmhl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_user__ = __webpack_require__("bREw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_wallet__ = __webpack_require__("XWIj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_profile__ = __webpack_require__("PMOm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_notifications__ = __webpack_require__("t45u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_insight__ = __webpack_require__("bwq/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_dashboard__ = __webpack_require__("EyqK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_leaderboards__ = __webpack_require__("8mrx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_watchlist__ = __webpack_require__("UtW7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_onboarding__ = __webpack_require__("PQ7o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_whatisnew__ = __webpack_require__("+sDo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modules_widgets__ = __webpack_require__("V1Kx");

























__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* default */].Store({
  modules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    about: __WEBPACK_IMPORTED_MODULE_3__modules_about__["a" /* default */],
    app: __WEBPACK_IMPORTED_MODULE_4__modules_app__["f" /* default */],
    browse: __WEBPACK_IMPORTED_MODULE_5__modules_browse__["a" /* default */],
    chart: __WEBPACK_IMPORTED_MODULE_6__modules_chart__["a" /* default */],
    market: __WEBPACK_IMPORTED_MODULE_7__modules_market__["a" /* default */],
    overlay: __WEBPACK_IMPORTED_MODULE_8__modules_overlay__["a" /* default */],
    popup: __WEBPACK_IMPORTED_MODULE_9__modules_popup__["a" /* default */],
    search: __WEBPACK_IMPORTED_MODULE_10__modules_search__["a" /* default */],
    support: __WEBPACK_IMPORTED_MODULE_11__modules_support__["a" /* default */],
    trade: __WEBPACK_IMPORTED_MODULE_12__modules_trade__["b" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_13__modules_user__["a" /* default */],
    wallet: __WEBPACK_IMPORTED_MODULE_14__modules_wallet__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_15__modules_profile__["c" /* default */],
    notifications: __WEBPACK_IMPORTED_MODULE_16__modules_notifications__["b" /* default */],
    insight: __WEBPACK_IMPORTED_MODULE_17__modules_insight__["a" /* default */],
    dashboard: __WEBPACK_IMPORTED_MODULE_18__modules_dashboard__["a" /* default */],
    leaderboards: __WEBPACK_IMPORTED_MODULE_19__modules_leaderboards__["b" /* default */],
    watchlist: __WEBPACK_IMPORTED_MODULE_20__modules_watchlist__["a" /* default */],
    onboarding: __WEBPACK_IMPORTED_MODULE_21__modules_onboarding__["a" /* default */],
    whatisnew: __WEBPACK_IMPORTED_MODULE_22__modules_whatisnew__["a" /* default */]
  },  false ? { pinning: require('./modules/pinning').default } : {}, {
    widgets: __WEBPACK_IMPORTED_MODULE_23__modules_widgets__["a" /* default */]
  }),
  strict: "production" !== 'production'
}));

/***/ }),

/***/ "Ijuz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"row news-feed-item",class:_vm.containerModifier,attrs:{"href":_vm.url,"target":_vm.target}},[(_vm.shouldShowImage)?_c('div',{staticClass:"column small-4 news-feed-item__image"},[_c('img',{attrs:{"src":_vm.getItemImage(_vm.data)},on:{"error":_vm.onImageLoadError}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column news-feed-item__content",class:_vm.contentModifier},[_c('h4',[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),(_vm.showSubtitle)?_c('h5',{staticClass:"news-feed-item__subtitle"},[_vm._v("\n      "+_vm._s(_vm.data.origin.title)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.data.summary)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.data.summary.content)}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IvC7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.onClickNumber($event)}}},[_c('span',{staticClass:"market-shares-bar__number"},[_vm._v(_vm._s(_vm.number.toLocaleString()))]),_vm._v(" "),_c('span',{staticClass:"market-shares-bar__mode"},[_vm._v(_vm._s(_vm.mode))])]),_vm._v(" "),_c('div',{staticClass:"market-shares-bar__bottom"},[_c('span',{staticClass:"market-shares-bar__info"},[_vm._v("\n      at "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.average),expression:"average",modifiers:{"cents":true}}]}),_vm._v(" avg.\n    ")]),_vm._v(" "),_c('div',{staticClass:"market-shares-bar__change-price-wrap"},[_c('market-change-price',{attrs:{"price":_vm.difference}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ivan":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile"},[_c('account-social-badge'),_vm._v(" "),_c('div',{staticClass:"profile__menu"},_vm._l((_vm.enabledLinks),function(link){return _c('div',{key:link.name},[(link.type === 'header' && _vm.isLinkAvailable(link))?_c('div',{staticClass:"profile__menu-header"},[_vm._v("\n        "+_vm._s(link.name)+"\n      ")]):(link.type === 'line' && _vm.isLinkAvailable(link))?_c('div',{staticClass:"profile__menu-line"}):(link.type === 'logout')?_c('div',{staticClass:"profile__menu-logout",on:{"click":_vm.logoutButton}},[_c('div',{staticClass:"profile__menu-logout-icon"}),_vm._v(" "),_c('div',{staticClass:"profile__menu-logout-text"},[_vm._v("\n          "+_vm._s(link.name)+"\n        ")])]):(link.type === 'link' && _vm.isLinkAvailable(link))?_c('router-link',{class:_vm.profileButtonClass(link),attrs:{"to":link.to,"tag":"div"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-11"},[_c('div',{staticClass:"profile__button-link-name"},[_vm._v("\n              "+_vm._s(link.name)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"column small-1"},[_c('div',{staticClass:"profile__button-nav-icon  profile__button-arrow-right"})])])]):_vm._e()],1)}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ivs/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J+13":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contract: {
      type: Object,
      required: true
    },
    color: {}
  },
  computed: {
    imageStyleModifiers: function imageStyleModifiers() {
      return {
        'border-color': this.color,
        'background-image': 'url(' + this.contract.contractImageSmallUrl + ')'
      };
    }
  }
});

/***/ }),

/***/ "J2kF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_list_header_sushi_item2_js__ = __webpack_require__("eFwA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b304d50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_list_header_sushi_item2_vue__ = __webpack_require__("bAqS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_list_header_sushi_item2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b304d50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_list_header_sushi_item2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J4k6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-section-header"},[_c('div',{staticClass:"market-section-header__title"},[_c(_vm.embedded ? 'h2' : 'h1',{tag:"component",staticClass:"market-section-header__text"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"market-section-header__counter"},[(_vm.count === 1)?[_vm._v("\n        1 Market\n      ")]:[_vm._v("\n        "+_vm._s(_vm.count)+" Markets\n      ")]],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J6HH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-loader"},[_c('div',{staticClass:"notification-loader__avatar"},[_c('div',{staticClass:"notification-loader__avatar-circle"})]),_vm._v(" "),_c('div',{staticClass:"notification-loader__content"},[_c('div',{staticClass:"notification-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"notification-loader__text-2"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JD5z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors.length > 0)?_c('div',{staticClass:"form-errors"},_vm._l((_vm.errors),function(error,index){return _c('p',{key:index,staticClass:"form-errors__entry",domProps:{"innerHTML":_vm._s(error)}})}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JJDO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");



var SCROLL_BUTTON_UPDATE_DELAY = 250;
var SCROLL_EDGE_TOLERANCE = 25;
var TAB_BOUNDARY_TOLERANCE = 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    tabs: __WEBPACK_IMPORTED_MODULE_1__components_generics_tabs_tabs_vue__["a" /* default */]
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      default: 'wallet'
    },
    activeTab: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      showNavigationArrows: false,
      canScrollLeft: false,
      canScrollRight: false
    };
  },

  watch: {
    items: function items() {
      var _this = this;

      this.$nextTick(function () {
        return _this.checkOverflow();
      });
    }
  },
  methods: {
    onTabChange: function onTabChange(name) {
      this.$emit('tabChange', name);
    },
    checkScrollButtons: function checkScrollButtons() {
      var tabsList = this.$refs.tabsList;
      if (tabsList) {
        this.canScrollLeft = tabsList.scrollLeft > SCROLL_EDGE_TOLERANCE;
        this.canScrollRight = tabsList.scrollLeft < tabsList.scrollWidth - tabsList.clientWidth - SCROLL_EDGE_TOLERANCE;
      }
    },
    checkOverflow: function checkOverflow() {
      var _this2 = this;

      var tabsList = this.$refs.tabsList;
      if (tabsList) {
        this.showNavigationArrows = tabsList.scrollWidth > tabsList.clientWidth;
        setTimeout(function () {
          _this2.checkScrollButtons();
        }, SCROLL_BUTTON_UPDATE_DELAY);
      }
    },
    scrollToNextTabBoundary: function scrollToNextTabBoundary(direction) {
      var _this3 = this;

      var tabsList = this.$refs.tabsList;
      if (!tabsList) return;
      var items = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(tabsList.querySelectorAll('.tabs__item'));
      var current = tabsList.scrollLeft;
      var target = current;
      if (items.length > 0) {
        if (direction > 0) {
          var next = items.find(function (item) {
            return item.offsetLeft > current + TAB_BOUNDARY_TOLERANCE;
          });
          target = next ? next.offsetLeft : tabsList.scrollWidth;
        } else {
          var previous = items.filter(function (item) {
            return item.offsetLeft < current - TAB_BOUNDARY_TOLERANCE;
          }).pop();
          target = previous ? previous.offsetLeft : 0;
        }
      }
      tabsList.scrollTo({ left: target, behavior: 'smooth' });
      setTimeout(function () {
        _this3.checkScrollButtons();
      }, SCROLL_BUTTON_UPDATE_DELAY);
    },
    scrollLeft: function scrollLeft() {
      this.scrollToNextTabBoundary(-1);
    },
    scrollRight: function scrollRight() {
      this.scrollToNextTabBoundary(1);
    },
    handleWindowResize: function handleWindowResize() {
      this.checkOverflow();
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    window.addEventListener('resize', this.handleWindowResize);
    this.$nextTick(function () {
      _this4.checkOverflow();
      var tabsList = _this4.$refs.tabsList;
      if (tabsList) {
        tabsList.addEventListener('scroll', _this4.checkScrollButtons);
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
    var tabsList = this.$refs.tabsList;
    if (tabsList) {
      tabsList.removeEventListener('scroll', this.checkScrollButtons);
    }
  }
});

/***/ }),

/***/ "JKVZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_wallet_shared_depositMethodTypes__ = __webpack_require__("LQTn");


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    feeWaivedBannerTxt: function feeWaivedBannerTxt() {
      var method = this.methods.find(function (m) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_wallet_shared_depositMethodTypes__["c" /* isMethodFeeWaived */])(m) && m.feeStateBannerTxt;
      });
      return method ? method.feeStateBannerTxt : '';
    }
  }
});

/***/ }),

/***/ "JLrH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-funds-combined"},[_c('deposit-promotions-banner',{staticClass:"add-funds-combined__promotions-banner",attrs:{"items":_vm.notifications}}),_vm._v(" "),(_vm.feeWaivedBannerTxt && false)?_c('fee-waived-banner',{staticClass:"add-funds-combined__fee-waived-banner",attrs:{"text":_vm.feeWaivedBannerTxt}}):_vm._e(),_vm._v(" "),(_vm.showTabs && !_vm.hideTabs)?_c('div',{staticClass:"add-funds-combined__tabs",class:{ 'add-funds-combined__tabs--no-top-margin': _vm.notifications.length }},[_c('deposit-tabs',{attrs:{"items":_vm.tabs,"theme":"wallet"},on:{"tabChange":_vm.tabChange}})],1):_vm._e(),_vm._v(" "),(!_vm.showTabs)?_c('div',{staticClass:"add-funds-combined__content add-funds-combined__content--loading"}):_c('div',{staticClass:"add-funds-combined__content"},[(_vm.showBankingTab)?_c('add-funds-bank-transfer',{attrs:{"instantCreditData":_vm.instantCreditData,"isPopup":true},on:{"step":_vm.onBankTransferStep,"notification":_vm.onChildNotification}}):_vm._e(),_vm._v(" "),(_vm.showCardTab)?_c('add-funds-credit-card',{attrs:{"instantCreditData":_vm.instantCreditData},on:{"notification":_vm.onChildNotification}}):_vm._e(),_vm._v(" "),(_vm.showTransfersTab)?_c('add-funds-transfers',{attrs:{"instantCreditData":_vm.instantCreditData},on:{"notification":_vm.onChildNotification}}):_vm._e(),_vm._v(" "),(_vm.showCashTab)?_c('add-funds-cash',{attrs:{"instantCreditData":_vm.instantCreditData},on:{"notification":_vm.onChildNotification}}):_vm._e(),_vm._v(" "),(_vm.showCoinBaseTab)?_c('add-funds-coinbase',{attrs:{"instantCreditData":_vm.instantCreditData},on:{"notification":_vm.onChildNotification}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JNNW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JNgs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"election-map"},[(_vm.type === 'electoral')?_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12 large-9"},[_c('div',{staticClass:"election-map__content"},[_c('div',{staticClass:"election-map__title"},[_vm._v("\n          Which party will win the Electoral College?\n        ")]),_vm._v(" "),_c('div',{staticClass:"election-map__toolbar"},[_c('election-map-toolbar',{attrs:{"mapStateData":_vm.mapStateData,"type":"electoral"}})],1),_vm._v(" "),_c('div',{ref:"chart",staticClass:"election-map__chart"})])]),_vm._v(" "),_c('div',{staticClass:"column small-12 large-3"},[_c('overview-map',{attrs:{"mapOverviewData":_vm.mapOverviewData,"type":"electoral"}})],1)]):_vm._e(),_vm._v(" "),(_vm.type === 'senate')?_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12 large-9"},[_c('div',{staticClass:"election-map__content"},[_c('div',{staticClass:"election-map__title"},[_vm._v("\n          Which party will win the Senate?\n        ")]),_vm._v(" "),_c('div',{staticClass:"election-map__toolbar"},[_c('election-map-toolbar',{attrs:{"mapStateData":_vm.mapStateDataSenate,"type":"senate"}})],1),_vm._v(" "),_c('div',{ref:"chart",staticClass:"election-map__chart"}),_vm._v(" "),(false)?_c('div',{staticClass:"election-map__special"},[_c('election-map-special')],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"column small-12 large-3"},[_c('overview-map',{attrs:{"mapOverviewData":_vm.mapOverviewDataSenate,"type":"senate"}})],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JSIy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'sushi'
    }
  },
  data: function data() {
    return {
      isSelected: this.selected
    };
  },

  computed: {
    buttonModifier: function buttonModifier() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'filter-button--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'filter-button--selected', this.isSelected), _ref;
    }
  },
  methods: {
    toggleFilter: function toggleFilter(e) {
      e.stopPropagation();
      this.isSelected = !this.isSelected;
      if (this.isSelected) {
        this.$emit('addFilter', this.id);
      } else {
        this.$emit('removeFilter', this.id);
      }
    }
  }
});

/***/ }),

/***/ "JSpR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_item_v2_embed_js__ = __webpack_require__("WhZX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28d011fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_item_v2_embed_vue__ = __webpack_require__("cQOb");
function injectStyle (ssrContext) {
  __webpack_require__("n1jK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_item_v2_embed_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28d011fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_item_v2_embed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JVxM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_money_widget_js__ = __webpack_require__("qXT1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38b3e446_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_money_widget_vue__ = __webpack_require__("Zn+p");
function injectStyle (ssrContext) {
  __webpack_require__("itDa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_money_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38b3e446_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_money_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JdRn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-videos"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"home-videos__line"}),_vm._v(" "),_c('div',{staticClass:"home-videos__content"},[_c('youtube',{staticClass:"home-videos__player",attrs:{"player-width":"100%","player-height":240,"video-id":_vm.getYoutubeUrl}}),_vm._v(" "),_c('div',{staticClass:"home-videos__note"},[_vm._v("\n      For more information on how to trade on PredictIt, visit our "),_c('router-link',{staticClass:"home-videos__note-link",attrs:{"to":{name: 'HelpAndSupport'}}},[_vm._v("Support")]),_vm._v(" page.\n    ")],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-videos__header"},[_c('div',{staticClass:"home-videos__header-title"},[_vm._v("\n      How to Open an Account\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jmi9":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyNCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgOEMwIDMuNTgxNzIgMy41ODE3MiAwIDggMEgxNkMyMC40MTgzIDAgMjQgMy41ODE3MiAyNCA4QzI0IDEyLjQxODMgMjAuNDE4MyAxNiAxNiAxNkg4QzMuNTgxNzIgMTYgMCAxMi40MTgzIDAgOFoiIGZpbGw9IiNFNEU0RTQiLz4KPHBhdGggZD0iTTggMC41SDE2QzIwLjE0MjEgMC41IDIzLjUgMy44NTc4NiAyMy41IDhDMjMuNSAxMi4xNDIxIDIwLjE0MjEgMTUuNSAxNiAxNS41SDhDMy44NTc4NiAxNS41IDAuNSAxMi4xNDIxIDAuNSA4QzAuNSAzLjg1Nzg2IDMuODU3ODYgMC41IDggMC41WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLW9wYWNpdHk9IjAuMSIvPgo8Y2lyY2xlIGN4PSIxNiIgY3k9IjgiIHI9IjYiIGZpbGw9IiMwMDAiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS4xNzEgNi40OTMxTDE1LjMyODMgMTAuNDIwOUMxNS4yNzAyIDEwLjQ4MDkgMTUuMjAwNyAxMC41Mjg2IDE1LjEyMzggMTAuNTYxMkMxNS4wNDY5IDEwLjU5MzggMTQuOTY0MiAxMC42MTA2IDE0Ljg4MDcgMTAuNjEwNkMxNC43OTcyIDEwLjYxMDYgMTQuNzE0NSAxMC41OTM4IDE0LjYzNzYgMTAuNTYxMkMxNC41NjA3IDEwLjUyODYgMTQuNDkxMiAxMC40ODA5IDE0LjQzMzEgMTAuNDIwOUwxMi44Mjc3IDguNzgwNzVDMTIuNzA5IDguNjU3OTggMTIuNjQyNiA4LjQ5Mzg3IDEyLjY0MjYgOC4zMjMwN0MxMi42NDI2IDguMTUyMjggMTIuNzA5IDcuOTg4MTcgMTIuODI3NyA3Ljg2NTM5QzEyLjg4NTggNy44MDU0NyAxMi45NTU0IDcuNzU3ODQgMTMuMDMyMyA3LjcyNTMxQzEzLjEwOTIgNy42OTI3OCAxMy4xOTE4IDcuNjc2MDIgMTMuMjc1MyA3LjY3NjAyQzEzLjM1ODggNy42NzYwMiAxMy40NDE0IDcuNjkyNzggMTMuNTE4MyA3LjcyNTMxQzEzLjU5NTIgNy43NTc4NCAxMy42NjQ4IDcuODA1NDcgMTMuNzIyOSA3Ljg2NTM5TDE0Ljg4MDcgOS4wNDg1N0wxOC4yNzYyIDUuNTc4ODZDMTguMzM0MyA1LjUxODg1IDE4LjQwMzggNS40NzExMyAxOC40ODA3IDUuNDM4NTRDMTguNTU3NiA1LjQwNTk1IDE4LjY0MDMgNS4zODkxNiAxOC43MjM4IDUuMzg5MTZDMTguODA3MyA1LjM4OTE2IDE4Ljg5IDUuNDA1OTUgMTguOTY2OSA1LjQzODU0QzE5LjA0MzggNS40NzExMyAxOS4xMTMzIDUuNTE4ODUgMTkuMTcxNCA1LjU3ODg2QzE5LjI5MDQgNS43MDEzOCAxOS4zNTY5IDUuODY1NDEgMTkuMzU2OSA2LjAzNjE3QzE5LjM1NjkgNi4yMDY5MyAxOS4yOTA0IDYuMzcwOTYgMTkuMTcxNCA2LjQ5MzQ4IiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "JoM+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


var getMapUrl = function getMapUrl(route, useBrowseFilter) {
  var apiRoute = 'api/Public/' + route;
  if (__webpack_require__.i({"NODE_ENV":"production","SENTRY_ENVIRONMENT":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","PI_YOUTUBE_LINK":"https://www.youtube.com/c/predictitofficial","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_SIGNALR":false,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","ATTACH_TO_HOME_POPUP_ENABLED":false,"PINNING_ENABLED":false,"DEPOSIT_PROMO_INPUT_BOX_ENABLED":false,"STORIES_PAGE_ENABLED":false,"DISABLE_TWO_FACTOR_PROMPT":true,"COLLEGE_AFFILIATION_ENABLED":true}).USE_API_WRAPPER && useBrowseFilter) {
    return 'api/Public/GetLiveData?url=' + encodeURIComponent('/' + apiRoute);
  }

  return apiRoute;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getMapLegend: function getMapLegend(mapName) {
    var useBrowseFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var flag = useBrowseFilter ? 'true' : 'false';
    var route = 'MapDataLegend/' + encodeURIComponent(mapName) + '?useBrowseFilter=' + flag;
    var url = getMapUrl(route, useBrowseFilter);

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url);
  },
  getMapData: function getMapData(mapName) {
    var useBrowseFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var flag = useBrowseFilter ? 'true' : 'false';
    var route = 'MapData/' + encodeURIComponent(mapName) + '?useBrowseFilter=' + flag;
    var url = getMapUrl(route, useBrowseFilter);

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url);
  },
  getContracts: function getContracts() {
    return this.getMapLegend('EC', true);
  },
  getStateData: function getStateData() {
    return this.getMapData('EC', true);
  },
  getContractsSenate: function getContractsSenate() {
    return this.getMapLegend('SEN', true);
  },
  getStateDataSenate: function getStateDataSenate() {
    return this.getMapData('SEN', true);
  }
});

/***/ }),

/***/ "JqZZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jub8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"market-contract-info-v2",attrs:{"to":_vm.detailsLink},nativeOn:{"click":function($event){return _vm.fireContractPriceListClick($event)}}},[(_vm.isCompactLayout)?_c('div',{staticClass:"market-contract-info-v2__compact"},[(_vm.imageUrl)?_c('div',{staticClass:"market-contract-info-v2__image",style:(_vm.imageStyleModifiers)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__main"},[(!!_vm.$slots.title || _vm.title)?_c('div',{staticClass:"market-contract-info-v2__title"},[(!!_vm.$slots.title)?_vm._t("title"):(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e()],2):_vm._e(),_vm._v(" "),(!!_vm.$slots.subtitle)?_c('div',{staticClass:"market-contract-info-v2__subtitle"},[_vm._t("subtitle")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__content"},[_vm._t("preContent"),_vm._v(" "),(_vm.layout === _vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK)?[_vm._t("content")]:_vm._e(),_vm._v(" "),(_vm.layout === _vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.CONTRACTS_SUMMARY)?_vm._l((_vm.marketContracts),function(item){return _c('div',{key:_vm.contractKey(item),staticClass:"market-contract-info-v2__row"},[_c('div',{directives:[{name:"contract-name",rawName:"v-contract-name"}],staticClass:"market-contract-info-v2__value-light"},[_vm._v("\n                "+_vm._s(_vm.contractTitle (item))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__value-dark market-contract-info-v2--mono"},[(_vm.contractChanePrice (item))?_c('market-change-price',{attrs:{"price":_vm.contractChanePrice (item),"lastClosePrice":_vm.contractLastClosePrice (item),"symbol":_vm.priceSymbol}}):_vm._e(),_vm._v(" "),(_vm.contractHasLastTradePrice(item))?[_c('animated-number',{attrs:{"value":_vm.contractPrice(item),"symbol":_vm.priceSymbol}})]:[_vm._v("\n                  NEW\n                ")]],2)])}):_vm._e(),_vm._v(" "),_vm._t("afterContent")],2)])]):(_vm.isDetailedLayout)?_c('div',{staticClass:"market-contract-info-v2__detailed"},[(_vm.imageUrl)?_c('div',{staticClass:"market-contract-info-v2__detailed-image",style:(_vm.imageStyleModifiers)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__detailed-main"},[(!!_vm.$slots.title || _vm.title)?_c('div',{staticClass:"market-contract-info-v2__detailed-title"},[(!!_vm.$slots.title)?_vm._t("title"):(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__detailed-content"},[_vm._t("preContent"),_vm._v(" "),(_vm.layout === _vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK_DETAILED)?[_vm._t("content")]:_vm._e(),_vm._v(" "),_vm._t("afterContent")],2)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JwZy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.showProgress)?_c('div',{staticClass:"account-social-avatar__progress-container",on:{"click":_vm.onShowEditPopup}},[_c('svg',{staticClass:"account-social-avatar__progress",attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 120 120"}},[(_vm.percentage < 100)?_c('circle',{staticClass:"account-social-avatar__progress-meter",attrs:{"cx":"60","cy":"60","r":_vm.radius,"stroke-width":_vm.strokeWidth,"stroke":_vm.backgroundStrokeColor}}):_vm._e(),_vm._v(" "),_c('circle',{staticClass:"account-social-avatar__progress-value",style:(_vm.styleModifiers),attrs:{"cx":"60","cy":"60","r":_vm.radius,"stroke-width":_vm.strokeWidth}})])]):_vm._e(),_vm._v(" "),(_vm.avatar)?_c('div',{class:_vm.imageClassModifiers,style:(_vm.imageStyleModifiers),on:{"click":_vm.onShowEditPopup}}):_vm._e(),_vm._v(" "),(_vm.showNotificationsCount)?_c('div',{staticClass:"account-social-avatar__notifications-count"},[_vm._v("\n    "+_vm._s(_vm.notificationsCount)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.hasLabel)?_c('div',{class:_vm.labelClassModifiers},[_vm._t("label"),_vm._v(" "),_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.isEditEnabled)?_c('span',{staticClass:"account-social-avatar__edit-photo"}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K0uo":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDQiIGhlaWdodD0iNTIiIHZpZXdCb3g9IjAgMCAxMDQgNTIiPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBmaWxsPSIjMjYzQjNGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik05NS4wMSA0MC4xMzJhMi4zMyAyLjMzIDAgMCAwLTEuOTE0LS42NjRsLTEuMTA2LTEuMWMzLjY5NS00LjE3NiA1LjczNC05LjQ2MSA1LjczNC0xNS4wNzMgMC02LjEwMS0yLjM4Ni0xMS44NC02LjcyMS0xNi4xNTZDODYuNjYgMi44MTQgODAuODk0LjQ0MiA3NC43NTMuNDQyYy02LjEzIDAtMTEuODk2IDIuMzc1LTE2LjIzNiA2LjY5Ny00LjM0NSA0LjMxNi02LjczNCAxMC4wNTUtNi43MzQgMTYuMTU2IDAgNi4xMDIgMi4zOTQgMTEuODQzIDYuNzM0IDE2LjE1OSA0LjM0IDQuMzIgMTAuMTA2IDYuNjkyIDE2LjIzNyA2LjY5MmEyMi44MTkgMjIuODE5IDAgMCAwIDE1LjE1LTUuNzA3bDEuMTExIDEuMDk3YTIuMzEgMi4zMSAwIDAgMCAuNjY4IDEuOTFsNy45MTMgNy44NzNjLjQ2MS40NTggMS4wNjIuNjggMS42NjguNjguNTk4IDAgMS4yMDQtLjIyNSAxLjY2Ny0uNjhhMi4zMzcgMi4zMzcgMCAwIDAgMC0zLjMxbC03LjkyLTcuODc3em0tNy4zNC0zLjk5OWExOC4xOTUgMTguMTk1IDAgMCAxLTEyLjkxNiA1LjMzIDE4LjE4IDE4LjE4IDAgMCAxLTEyLjkwNy01LjMyNWMtMy40NDYtMy40MjgtNS4zNS03Ljk5My01LjM1LTEyLjg0NSAwLTQuODUgMS45LTkuNDEyIDUuMzUtMTIuODQzYTE4LjE4OSAxOC4xODkgMCAwIDEgMTIuOTA3LTUuMzI1YzQuODggMCA5LjQ2OCAxLjg5IDEyLjkxNiA1LjMyNSAzLjQ0NCAzLjQzIDUuMzQ1IDcuOTkzIDUuMzQ1IDEyLjg0MyAwIDQuODUyLTEuOTAxIDkuNDEtNS4zNDUgMTIuODR6Ii8+CiAgICAgICAgPGcgc3Ryb2tlPSIjMjYzQjNGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iNCI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMSA0OGExIDEgMCAwIDEtMSAxSDNhMSAxIDAgMCAxLTEtMVYyM2ExIDEgMCAwIDEgMS0xaDdhMSAxIDAgMCAxIDEgMXYyNXpNNDUgNDhhMSAxIDAgMCAxLTEgMWgtN2ExIDEgMCAwIDEtMS0xVjMzYTEgMSAwIDAgMSAxLTFoN2ExIDEgMCAwIDEgMSAxdjE1ek0yOCA0OGExIDEgMCAwIDEtMSAxaC03YTEgMSAwIDAgMS0xLTFWOGExIDEgMCAwIDEgMS0xaDdhMSAxIDAgMCAxIDEgMXY0MHoiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "K1rd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K2ud":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_radio_js__ = __webpack_require__("joAC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db4207cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radio_vue__ = __webpack_require__("5X5i");
function injectStyle (ssrContext) {
  __webpack_require__("zKe2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_radio_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db4207cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KAwH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KFTB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");



/* global Highcharts:false */





var PINCH_HINT_STORAGE_KEY = 'cms-map-widget-pinch-hint-dismissed';
var DEFAULT_EMPTY_COLOR = '#d9d9d9';
var MAP_WIDGET_CONTEXT_MENU_ITEMS = ['viewFullscreen', 'printChart', 'separator', 'downloadPNG', 'downloadJPEG', 'downloadSVG', 'downloadPDF', 'separator', 'downloadCSV', 'downloadXLS', 'separator', 'viewMapDataTable'];
var DEFAULT_CONTEXT_MENU_ITEMS = MAP_WIDGET_CONTEXT_MENU_ITEMS.filter(function (item) {
  return item !== 'viewMapDataTable';
});
var RENDERER_TYPE_ELECTION_ELECTORAL = 'electionelectoral';
var RENDERER_TYPE_ELECTION_SENATE = 'electionsenate';
var CONTEXT_MENU_OVERFLOW_CLASS = 'cms-map-widget-menu-overflow-open';
var CONTEXT_MENU_VIEWPORT_PADDING = 12;
var CONTEXT_MENU_BOTTOM_UI_SELECTORS = ['.app-privacy-statement', '.app-layout__bottom-nav'];
var PARTY_DEMOCRATIC = 'democratic';
var PARTY_REPUBLICAN = 'republican';
var WIDTH_PERCENTAGE_THRESHOLD = 5;
var PRICE_FACTORS = {
  LOW: 0.64,
  MEDIUM: 0.79
};
var DEFAULT_PALETTE = {
  gray: [{ from: 0, to: PRICE_FACTORS.LOW, color: '#dddddd' }, { from: PRICE_FACTORS.LOW, to: PRICE_FACTORS.MEDIUM, color: '#bbbbbb' }, { from: PRICE_FACTORS.MEDIUM, to: 1, color: '#888888' }],
  democratic: [{ from: 0, to: PRICE_FACTORS.LOW, color: '#8aafff' }, { from: PRICE_FACTORS.LOW, to: PRICE_FACTORS.MEDIUM, color: '#5c80dc' }, { from: PRICE_FACTORS.MEDIUM, to: 1, color: '#244999' }],
  republican: [{ from: 0, to: PRICE_FACTORS.LOW, color: '#ff8b98' }, { from: PRICE_FACTORS.LOW, to: PRICE_FACTORS.MEDIUM, color: '#ff5865' }, { from: PRICE_FACTORS.MEDIUM, to: 1, color: '#d22532' }]
};
var DENSE_STATE_LABELS = ['VT', 'NH', 'MA', 'RI', 'CT', 'NJ', 'DE', 'MD', 'DC'];

var roundToTwo = function roundToTwo(value) {
  return Math.round(value * 100) / 100;
};
var HTML_ESCAPE_CHARACTERS = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};
var SAFE_TOOLTIP_COLOR = /^#[0-9a-f]{6}$/i;

function escapeTooltipHtml(value) {
  return String(value === null || typeof value === 'undefined' ? '' : value).replace(/[&<>"']/g, function (character) {
    return HTML_ESCAPE_CHARACTERS[character];
  });
}

function getSafeTooltipImageUrl(value) {
  if (typeof value !== 'string' || !value.trim()) {
    return '';
  }

  try {
    var baseUrl = typeof window !== 'undefined' && window.location ? window.location.href : 'https://www.predictit.org/';
    var imageUrl = new URL(value.trim(), baseUrl);
    var isHttps = imageUrl.protocol === 'https:';
    var isSameOriginHttp = imageUrl.protocol === 'http:' && typeof window !== 'undefined' && imageUrl.origin === window.location.origin;
    return isHttps || isSameOriginHttp ? imageUrl.href : '';
  } catch (error) {
    return '';
  }
}

function getSafeTooltipColor(value) {
  return typeof value === 'string' && SAFE_TOOLTIP_COLOR.test(value) ? value : DEFAULT_EMPTY_COLOR;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_6__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  props: {
    mapName: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      isLoading: true,
      hasError: false,
      mapData: [],
      legendData: [],
      chart: null,
      showPinchHint: false,
      showDataTable: false,
      isContextMenuOpen: false,
      shouldShowPinchHint: false,
      interactionDismissHandler: null,
      contextMenuObserver: null,
      contextMenuOverflowContainers: []
    };
  },

  computed: {
    mapConfig: function mapConfig() {
      return this.mapData && this.mapData.length > 0 ? this.mapData[0] : {};
    },
    rendererType: function rendererType() {
      return (this.mapConfig && this.mapConfig.rendererType || '').toLowerCase();
    },
    isElectionMap: function isElectionMap() {
      return this.rendererType === RENDERER_TYPE_ELECTION_ELECTORAL || this.rendererType === RENDERER_TYPE_ELECTION_SENATE;
    },
    isSenateMap: function isSenateMap() {
      return this.rendererType === RENDERER_TYPE_ELECTION_SENATE;
    },
    mapTitle: function mapTitle() {
      return this.mapConfig && this.mapConfig.title || '';
    },
    classModifiers: function classModifiers() {
      return {
        'cms-map-widget--menu-open': this.isContextMenuOpen,
        'cms-map-widget--election': this.isElectionMap,
        'cms-map-widget--with-overview': this.showOverviewPanel,
        'cms-map-widget--with-legend': this.showLegend
      };
    },
    showLegend: function showLegend() {
      var defaultValue = !this.isElectionMap || !this.showOverviewPanel;
      return this.getMapFlag('showLegend', defaultValue) && this.legendData.length > 0;
    },
    canShowDataTable: function canShowDataTable() {
      return this.getMapFlag('showDataTable', true);
    },
    showElectionToolbar: function showElectionToolbar() {
      return this.isElectionMap && this.getMapFlag('showToolbar', true) && this.toolbarSegments.length > 0;
    },
    showMajorityLabel: function showMajorityLabel() {
      return this.isElectionMap && this.getMapFlag('showMajorityLabel', false);
    },
    showOverviewPanel: function showOverviewPanel() {
      return this.isElectionMap && this.getMapFlag('showOverview', true) && this.overviewContracts.length > 0;
    },
    overviewTitleDesktop: function overviewTitleDesktop() {
      if (this.mapConfig && this.mapConfig.overviewTitle) {
        return this.mapConfig.overviewTitle;
      }

      return this.isSenateMap ? 'Control of the Senate' : 'Presidential Election Winner?';
    },
    overviewTitleMobile: function overviewTitleMobile() {
      if (this.mapConfig && (this.mapConfig.overviewMobileTitle || this.mapConfig.overviewTitle)) {
        return this.mapConfig.overviewMobileTitle || this.mapConfig.overviewTitle;
      }

      return this.isSenateMap ? 'Control of the Senate' : 'Who will win the presidential election?';
    },
    overviewContracts: function overviewContracts() {
      var itemWithOverview = (this.mapData || []).find(function (item) {
        return Array.isArray(item.overviewContracts) && item.overviewContracts.length > 0;
      });
      return itemWithOverview ? itemWithOverview.overviewContracts.slice(0, 2) : [];
    },
    predefinedGroups: function predefinedGroups() {
      var groups = this.mapConfig && this.mapConfig.predefinedGroups || [];
      return Array.isArray(groups) ? groups : [];
    },
    toolbarBaselines: function toolbarBaselines() {
      var baselines = this.mapConfig && this.mapConfig.toolbarBaselines || [];
      return Array.isArray(baselines) ? baselines : [];
    },
    electionRows: function electionRows() {
      var _this = this;

      var groupedByStateCode = this.groupLocationsByStateCode();
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(groupedByStateCode).reduce(function (rows, stateCode) {
        var predefinedGroup = _this.getPredefinedGroupForState(stateCode);
        if (predefinedGroup && predefinedGroup.isLocked) {
          return rows;
        }

        var representative = _this.getRepresentativeLocation(groupedByStateCode[stateCode]);
        var leadingContract = _this.getLeadingContract(representative);
        rows.push({
          stateCode: stateCode,
          locationData: representative,
          leadingContract: leadingContract,
          party: _this.getContractParty(leadingContract),
          stateValue: _this.getStateValue(stateCode, representative)
        });
        return rows;
      }, []);
    },
    democraticToolbarCounter: function democraticToolbarCounter() {
      return this.buildToolbarCounter(PARTY_DEMOCRATIC);
    },
    republicanToolbarCounter: function republicanToolbarCounter() {
      return this.buildToolbarCounter(PARTY_REPUBLICAN);
    },
    toolbarTotalWidth: function toolbarTotalWidth() {
      var total = this.democraticToolbarCounter.widthTotal + this.republicanToolbarCounter.widthTotal;
      return total > 0 ? total : 1;
    },
    majorityLabel: function majorityLabel() {
      if (this.mapConfig && this.mapConfig.majorityLabel) {
        return this.mapConfig.majorityLabel;
      }

      if (this.mapConfig && this.mapConfig.majorityTarget) {
        return this.isSenateMap ? this.mapConfig.majorityTarget + ' Seats' : '' + this.mapConfig.majorityTarget;
      }

      return this.isSenateMap ? '50 Seats' : 'Majority';
    },
    toolbarSegments: function toolbarSegments() {
      var democratic = this.democraticToolbarCounter;
      var republican = this.republicanToolbarCounter;
      var segments = [this.createToolbarSegment(democratic, 'predefined', PARTY_DEMOCRATIC, true), this.createToolbarSegment(democratic, 'high', PARTY_DEMOCRATIC), this.createToolbarSegment(democratic, 'medium', PARTY_DEMOCRATIC), this.createToolbarSegment(democratic, 'low', PARTY_DEMOCRATIC), this.createToolbarSegment(republican, 'low', PARTY_REPUBLICAN), this.createToolbarSegment(republican, 'medium', PARTY_REPUBLICAN), this.createToolbarSegment(republican, 'high', PARTY_REPUBLICAN), this.createToolbarSegment(republican, 'predefined', PARTY_REPUBLICAN, true)];

      return segments.filter(function (segment) {
        return segment.value > 0 && segment.width > 0;
      });
    },
    mapTableRows: function mapTableRows() {
      var _this2 = this;

      return (this.mapData || []).reduce(function (rows, item, locationIndex) {
        var locationCode = _this2.normalizeLocationCode(item.locationCode);
        var markets = Array.isArray(item.markets) && item.markets.length > 0 ? item.markets : [item];

        markets.forEach(function (market, marketIndex) {
          var contracts = Array.isArray(market.contracts) ? market.contracts : [];
          if (contracts.length === 0) {
            rows.push({
              key: (locationCode || 'location') + '-' + locationIndex + '-' + (market.marketId || marketIndex),
              stateCode: locationCode,
              marketName: market.marketName || market.name || 'Market',
              contractName: '',
              lastTradePrice: null,
              status: market.status || item.status || '',
              color: item.overrideColor || ''
            });
            return;
          }

          contracts.forEach(function (contract, contractIndex) {
            rows.push({
              key: (locationCode || 'location') + '-' + locationIndex + '-' + (market.marketId || marketIndex) + '-' + (contract.contractId || contractIndex),
              stateCode: locationCode,
              marketName: market.marketName || market.name || 'Market',
              contractName: contract.contractName || contract.name || 'Contract',
              lastTradePrice: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["r" /* hasLastTradePrice */])(contract) ? contract.lastTradePrice : null,
              status: market.status || item.status || '',
              color: contract.color || item.overrideColor || (_this2.isElectionMap ? _this2.resolveElectionColor(item) : '')
            });
          });
        });

        return rows;
      }, []);
    }
  },
  methods: {
    toCents: function toCents(value) {
      var normalized = Number(value);
      if (isNaN(normalized)) {
        return 0;
      }
      return Math.round(normalized * 100);
    },
    hasTradePrice: function hasTradePrice(contract) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["r" /* hasLastTradePrice */])(contract);
    },
    dismissPinchHint: function dismissPinchHint() {
      this.showPinchHint = false;
      this.shouldShowPinchHint = false;
      try {
        localStorage.setItem(PINCH_HINT_STORAGE_KEY, 'true');
      } catch (e) {
        // localStorage can be unavailable in privacy-restricted browser contexts.
      }
    },
    toggleDataTable: function toggleDataTable() {
      if (!this.canShowDataTable) {
        return;
      }

      this.showDataTable = !this.showDataTable;
    },
    hideDataTable: function hideDataTable() {
      this.showDataTable = false;
    },
    clearContextMenuOverflowContainers: function clearContextMenuOverflowContainers() {
      (this.contextMenuOverflowContainers || []).forEach(function (element) {
        if (element && element.classList) {
          element.classList.remove(CONTEXT_MENU_OVERFLOW_CLASS);
        }
      });
      this.contextMenuOverflowContainers = [];
    },
    syncContextMenuOverflowContainers: function syncContextMenuOverflowContainers(isOpen) {
      this.clearContextMenuOverflowContainers();

      if (!isOpen || !this.$el || typeof window === 'undefined') {
        return;
      }

      var element = this.$el.parentElement;
      while (element && element !== document.body) {
        var style = window.getComputedStyle(element);
        if (style.overflowX !== 'visible' || style.overflowY !== 'visible') {
          element.classList.add(CONTEXT_MENU_OVERFLOW_CLASS);
          this.contextMenuOverflowContainers.push(element);
        }
        element = element.parentElement;
      }
    },
    positionContextMenu: function positionContextMenu() {
      if (!this.$el || typeof window === 'undefined') {
        return;
      }

      var contextMenu = this.$el.querySelector('.highcharts-contextmenu');
      if (!contextMenu) {
        return;
      }

      var bounds = contextMenu.getBoundingClientRect();
      var currentTop = parseFloat(contextMenu.style.top || '0') || contextMenu.offsetTop || 0;
      var currentLeft = parseFloat(contextMenu.style.left || '0') || contextMenu.offsetLeft || 0;
      var maxBottom = window.innerHeight - CONTEXT_MENU_VIEWPORT_PADDING;
      var maxRight = window.innerWidth - CONTEXT_MENU_VIEWPORT_PADDING;
      var nextTop = currentTop;
      var nextLeft = currentLeft;

      CONTEXT_MENU_BOTTOM_UI_SELECTORS.forEach(function (selector) {
        var element = document.querySelector(selector);
        if (!element) {
          return;
        }
        var style = window.getComputedStyle(element);
        var elementBounds = element.getBoundingClientRect();
        var isVisible = style.display !== 'none' && style.visibility !== 'hidden' && elementBounds.width > 0 && elementBounds.height > 0;

        if (isVisible && elementBounds.bottom >= window.innerHeight - 1) {
          maxBottom = Math.min(maxBottom, elementBounds.top - CONTEXT_MENU_VIEWPORT_PADDING);
        }
      });

      if (bounds.bottom > maxBottom) {
        nextTop -= bounds.bottom - maxBottom;
      }
      if (bounds.top + (nextTop - currentTop) < CONTEXT_MENU_VIEWPORT_PADDING) {
        nextTop += CONTEXT_MENU_VIEWPORT_PADDING - (bounds.top + (nextTop - currentTop));
      }
      if (bounds.right > maxRight) {
        nextLeft -= bounds.right - maxRight;
      }
      if (bounds.left + (nextLeft - currentLeft) < CONTEXT_MENU_VIEWPORT_PADDING) {
        nextLeft += CONTEXT_MENU_VIEWPORT_PADDING - (bounds.left + (nextLeft - currentLeft));
      }

      contextMenu.style.top = Math.round(nextTop) + 'px';
      contextMenu.style.left = Math.round(nextLeft) + 'px';
      contextMenu.style.maxHeight = Math.max(180, Math.round(window.innerHeight - CONTEXT_MENU_VIEWPORT_PADDING * 2)) + 'px';
      contextMenu.style.overflowY = 'auto';
    },
    syncContextMenuState: function syncContextMenuState() {
      if (!this.$el || typeof window === 'undefined') {
        return;
      }

      var contextMenu = this.$el.querySelector('.highcharts-contextmenu');
      var isOpen = false;
      if (contextMenu) {
        var style = window.getComputedStyle(contextMenu);
        var bounds = contextMenu.getBoundingClientRect();
        isOpen = style.display !== 'none' && style.visibility !== 'hidden' && bounds.width > 0 && bounds.height > 0;
      }

      if (this.isContextMenuOpen !== isOpen) {
        this.isContextMenuOpen = isOpen;
        this.syncContextMenuOverflowContainers(isOpen);
      }
      if (isOpen) {
        this.positionContextMenu();
      }
    },
    stopContextMenuObserver: function stopContextMenuObserver() {
      if (this.contextMenuObserver) {
        this.contextMenuObserver.disconnect();
        this.contextMenuObserver = null;
      }
      this.clearContextMenuOverflowContainers();
      this.isContextMenuOpen = false;
    },
    startContextMenuObserver: function startContextMenuObserver() {
      var _this3 = this;

      this.stopContextMenuObserver();
      if (!this.$el || typeof MutationObserver === 'undefined') {
        return;
      }

      this.contextMenuObserver = new MutationObserver(function () {
        return _this3.syncContextMenuState();
      });
      this.contextMenuObserver.observe(this.$el, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
      this.syncContextMenuState();
    },
    isMobileLayout: function isMobileLayout() {
      if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') {
        return false;
      }
      return window.matchMedia('(max-width: 767px)').matches;
    },
    getMapFlag: function getMapFlag(fieldName, defaultValue) {
      if (!this.mapConfig || this.mapConfig[fieldName] === null || typeof this.mapConfig[fieldName] === 'undefined') {
        return defaultValue;
      }

      return this.mapConfig[fieldName] !== false;
    },
    normalizeLocationCode: function normalizeLocationCode(code) {
      var normalized = (code || '').toUpperCase().replace(/-/g, '');
      if (!normalized) {
        return '';
      }

      if (normalized.length >= 2) {
        return normalized.substring(0, 2);
      }

      return normalized;
    },
    getContractsForLocation: function getContractsForLocation(marketData) {
      if (!marketData) {
        return [];
      }

      var linkedMarkets = Array.isArray(marketData.markets) ? marketData.markets : [];
      if (linkedMarkets.length > 0) {
        return linkedMarkets.reduce(function (contracts, market) {
          return contracts.concat(Array.isArray(market.contracts) ? market.contracts : []);
        }, []);
      }

      return Array.isArray(marketData.contracts) ? marketData.contracts : [];
    },
    getLeadingContract: function getLeadingContract(marketData) {
      var contracts = this.getContractsForLocation(marketData);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["s" /* getLeadingTradedContract */])(contracts);
    },
    getContractName: function getContractName(contract) {
      return (contract && (contract.contractName || contract.shortName || contract.name) || '').toLowerCase();
    },
    getContractParty: function getContractParty(contract) {
      var party = (contract && contract.party || '').toLowerCase();
      if (party.includes('dem')) {
        return PARTY_DEMOCRATIC;
      }
      if (party.includes('rep') || party.includes('gop')) {
        return PARTY_REPUBLICAN;
      }

      var name = this.getContractName(contract);
      if (name.includes('republican') || name.includes('trump') || name.includes('rubio')) {
        return PARTY_REPUBLICAN;
      }
      if (name.includes('democrat') || name.includes('biden') || name.includes('shapiro') || name.includes('whitmer') || name.includes('buttigieg')) {
        return PARTY_DEMOCRATIC;
      }

      return '';
    },
    getOverviewContractParty: function getOverviewContractParty(item) {
      var _this4 = this;

      var configuredContract = null;
      (this.mapData || []).some(function (location) {
        configuredContract = _this4.getContractsForLocation(location).find(function (contract) {
          return Number(contract.contractId) === Number(item.contractId);
        });
        return !!configuredContract;
      });

      return this.getContractParty(configuredContract || item);
    },
    getOverviewNameStyle: function getOverviewNameStyle(item) {
      return {
        backgroundColor: item.color || this.getPaletteColor(this.getOverviewContractParty(item) || 'gray', 1)
      };
    },
    getRepresentativeLocation: function getRepresentativeLocation(locations) {
      var _this5 = this;

      if (!Array.isArray(locations) || locations.length === 0) {
        return null;
      }

      var sorted = locations.slice().sort(function (a, b) {
        var contractA = _this5.getLeadingContract(a);
        var contractB = _this5.getLeadingContract(b);
        var scoreA = contractA ? Number(contractA.lastTradePrice) || 0 : 0;
        var scoreB = contractB ? Number(contractB.lastTradePrice) || 0 : 0;
        return scoreB - scoreA;
      });

      return sorted[0];
    },
    getPaletteThresholds: function getPaletteThresholds(party) {
      var customThresholds = this.mapConfig && this.mapConfig.paletteThresholds || [];
      var matchingThresholds = Array.isArray(customThresholds) ? customThresholds.filter(function (item) {
        return (item.party || '').toLowerCase() === party;
      }) : [];

      if (matchingThresholds.length > 0) {
        return matchingThresholds;
      }

      return DEFAULT_PALETTE[party] || DEFAULT_PALETTE.gray;
    },
    getPaletteColor: function getPaletteColor(party, price) {
      var normalizedParty = party || 'gray';
      var thresholds = this.getPaletteThresholds(normalizedParty);
      var normalizedPrice = Math.min(Math.max(Number(price) || 0, 0), 1);
      var match = thresholds.find(function (threshold) {
        var from = typeof threshold.from === 'number' ? threshold.from : 0;
        var to = typeof threshold.to === 'number' ? threshold.to : 1;
        return normalizedPrice >= from && normalizedPrice <= to;
      });

      return match && match.color || thresholds[thresholds.length - 1].color;
    },
    getPaletteBucket: function getPaletteBucket(price) {
      var normalizedPrice = Math.min(Math.max(Number(price) || 0, 0), 1);
      if (normalizedPrice <= PRICE_FACTORS.LOW) {
        return 'low';
      }
      if (normalizedPrice <= PRICE_FACTORS.MEDIUM) {
        return 'medium';
      }
      return 'high';
    },
    resolveBaseColor: function resolveBaseColor(contract) {
      var party = this.getContractParty(contract);
      if (party === PARTY_REPUBLICAN) {
        return '#bc1500';
      }
      if (party === PARTY_DEMOCRATIC) {
        return '#2f88dc';
      }
      return '#9a9a9a';
    },
    applyGradient: function applyGradient(color, contract, gradientSetting) {
      if (gradientSetting !== 2 || !contract) {
        return color;
      }

      var normalized = Math.min(Math.max(Number(contract.lastTradePrice) || 0, 0), 1);
      if (typeof color !== 'string' || !color.startsWith('#') || color.length !== 7) {
        return color;
      }

      var red = parseInt(color.substring(1, 3), 16);
      var green = parseInt(color.substring(3, 5), 16);
      var blue = parseInt(color.substring(5, 7), 16);
      var alpha = Math.max(0.35, Math.min(1, 0.35 + normalized * 0.65));

      return 'rgba(' + red + ', ' + green + ', ' + blue + ', ' + alpha + ')';
    },
    resolveColor: function resolveColor(locationData, emptyColor) {
      if (!locationData) {
        return emptyColor;
      }

      if (this.isElectionMap) {
        return this.resolveElectionColor(locationData);
      }

      if (locationData.overrideColor) {
        return locationData.overrideColor;
      }

      var leadingContract = this.getLeadingContract(locationData);
      var contractColor = leadingContract && leadingContract.color || '';
      var baseColor = contractColor || this.resolveBaseColor(leadingContract);

      return this.applyGradient(baseColor, leadingContract, Number(locationData.gradientSetting) || 0);
    },
    resolveElectionColor: function resolveElectionColor(locationData) {
      if (!locationData) {
        return this.getEmptyColor();
      }

      if (locationData.overrideColor) {
        return locationData.overrideColor;
      }

      var leadingContract = this.getLeadingContract(locationData);
      var contractColor = leadingContract && leadingContract.color || '';
      if (contractColor && (this.mapConfig.paletteMode || '').toLowerCase() !== 'partythreshold') {
        return contractColor;
      }

      var party = this.getContractParty(leadingContract);
      if (!party) {
        return this.getEmptyColor();
      }

      return this.getPaletteColor(party, leadingContract.lastTradePrice);
    },
    getEmptyColor: function getEmptyColor() {
      var itemWithEmptyColor = (this.mapData || []).find(function (item) {
        return !!item.emptyColor;
      });
      return itemWithEmptyColor ? itemWithEmptyColor.emptyColor : DEFAULT_EMPTY_COLOR;
    },
    groupLocationsByStateCode: function groupLocationsByStateCode() {
      var _this6 = this;

      return (this.mapData || []).reduce(function (acc, item) {
        var stateCode = _this6.normalizeLocationCode(item.locationCode);
        if (!stateCode) {
          return acc;
        }

        if (!acc[stateCode]) {
          acc[stateCode] = [];
        }
        acc[stateCode].push(item);
        return acc;
      }, {});
    },
    getPredefinedGroupForState: function getPredefinedGroupForState(stateCode) {
      var _this7 = this;

      return this.predefinedGroups.find(function (group) {
        var codes = Array.isArray(group.locationCodes) ? group.locationCodes : [];
        return codes.map(function (code) {
          return _this7.normalizeLocationCode(code);
        }).includes(stateCode);
      }) || null;
    },
    getPredefinedGroupColor: function getPredefinedGroupColor(group) {
      if (!group) {
        return this.getEmptyColor();
      }
      if (group.color) {
        return group.color;
      }

      var party = (group.party || '').toLowerCase().includes('rep') ? PARTY_REPUBLICAN : PARTY_DEMOCRATIC;
      return this.getPaletteColor(party, 1);
    },
    getStateName: function getStateName(stateCode, fallbackName) {
      return __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* default */].statesCodeToNameMap[stateCode] || fallbackName || stateCode;
    },
    getStateValue: function getStateValue(stateCode, locationData) {
      if (locationData && locationData.stateValue) {
        return Number(locationData.stateValue) || 1;
      }

      if (this.isSenateMap) {
        return 1;
      }

      return __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* default */].statesCodeToElectoralVotesMap[stateCode] || 1;
    },
    getTooltipHtml: function getTooltipHtml(point) {
      var _this8 = this;

      if (this.isElectionMap) {
        return this.getElectionTooltipHtml(point);
      }

      var marketData = point.marketData;
      if (!marketData) {
        return '<div class="cms-map-widget__tooltip-empty">' + escapeTooltipHtml(point.stateName) + '</div>';
      }

      var contracts = this.getContractsForLocation(marketData).slice(0, 2);
      var contractsHtml = contracts.map(function (contract) {
        return '<div><strong>' + escapeTooltipHtml(contract.contractName || contract.name || 'Contract') + '</strong>: ' + _this8.toCents(contract.lastTradePrice) + '&cent;</div>';
      }).join('');
      var marketName = escapeTooltipHtml(marketData.marketName || point.stateName);
      var stateName = escapeTooltipHtml(point.stateName);

      return '<div class="cms-map-widget__tooltip"><div class="cms-map-widget__tooltip-title">' + stateName + '</div><div>' + marketName + '</div>' + contractsHtml + '</div>';
    },
    getElectionTooltipHtml: function getElectionTooltipHtml(point) {
      var _this9 = this;

      var marketData = point.marketData;
      if (!marketData) {
        return false;
      }

      var stateCode = point.stateCode || '';
      var showSplitStateNote = !this.isSenateMap && (stateCode === 'ME' || stateCode === 'NE');
      var stateContext = ' (' + (point.stateValue || 0) + (showSplitStateNote ? ' STATEWIDE' : '') + ')';
      if (this.isSenateMap) {
        stateContext = stateCode === 'GA' ? ' (REGULAR)' : '';
      }

      var stateLabel = escapeTooltipHtml('' + point.stateName + stateContext);
      var leadingContract = this.getLeadingContract(marketData);
      var color = getSafeTooltipColor(this.resolveElectionColor(marketData));
      var contracts = this.getContractsForLocation(marketData).slice(0, 2);
      var marketName = escapeTooltipHtml(marketData.marketName || point.stateName);
      var contractsHtml = contracts.map(function (contract, index) {
        var imageUrl = getSafeTooltipImageUrl(contract.contractImageUrl);
        var image = imageUrl ? '<img class="cms-map-widget__tooltip-contract-image" src="' + escapeTooltipHtml(imageUrl) + '" alt="">' : '';
        var change = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["r" /* hasLastTradePrice */])(contract) ? _this9.getChangeCents(contract) : null;
        var changeHtml = change === null ? '' : '<span class="cms-map-widget__tooltip-change">' + (change > 0 ? '+' : '') + change + '&cent;</span>';
        var price = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["r" /* hasLastTradePrice */])(contract) ? _this9.toCents(contract.lastTradePrice) + '&cent;' : '-';
        var contractName = escapeTooltipHtml(contract.contractName || contract.name || 'Contract');
        return '<div class="cms-map-widget__tooltip-contract ' + (index === 0 ? 'cms-map-widget__tooltip-contract--primary' : '') + '">' + image + '<div><div class="cms-map-widget__tooltip-contract-name">' + contractName + '</div><div><span class="cms-map-widget__tooltip-price">' + price + '</span>' + changeHtml + '</div></div></div>';
      }).join('');
      var winner = leadingContract ? '<div class="cms-map-widget__tooltip-leader">' + escapeTooltipHtml(leadingContract.contractName || leadingContract.name || 'Leading contract') + '</div>' : '';
      var note = showSplitStateNote ? '<div class="cms-map-widget__tooltip-note">See separate markets for individual<br>congressional districts in ' + escapeTooltipHtml(this.getStateName(stateCode, point.stateName)) + '.</div>' : '';

      return '<div class="cms-map-widget__tooltip cms-map-widget__tooltip--election" style="border-color:' + color + '"><div class="cms-map-widget__tooltip-title" style="background:' + color + '">' + stateLabel + '</div><div class="cms-map-widget__tooltip-body"><div>' + marketName + '</div>' + winner + contractsHtml + note + '</div></div>';
    },
    getChangeCents: function getChangeCents(contract) {
      if (!contract || contract.lastClosePrice === null || typeof contract.lastClosePrice === 'undefined') {
        return null;
      }

      return this.toCents(Number(contract.lastTradePrice) - Number(contract.lastClosePrice));
    },
    getPointMarketId: function getPointMarketId(point) {
      var marketData = point.marketData;
      if (!marketData) {
        return null;
      }

      var interactionType = Number(marketData.interactionType) || 0;
      var linkedMarkets = Array.isArray(marketData.markets) ? marketData.markets : [];
      if (interactionType === 2 && linkedMarkets.length > 0) {
        return linkedMarkets[0].marketId || null;
      }

      return marketData.marketId || null;
    },
    getDataLabel: function getDataLabel(point) {
      if (!this.isElectionMap) {
        return point.stateCode || '';
      }

      var leadingContract = this.getLeadingContract(point.marketData);
      if (leadingContract) {
        return this.toCents(leadingContract.lastTradePrice) + '\xA2';
      }

      if (this.getContractsForLocation(point.marketData).length > 0) {
        return '-';
      }

      return DENSE_STATE_LABELS.includes(point.stateCode) ? point.stateCode : '';
    },
    getChartData: function getChartData(mapShapes) {
      var _this10 = this;

      var groupedByStateCode = this.groupLocationsByStateCode();
      var emptyColor = this.getEmptyColor();

      return mapShapes.map(function (shape) {
        var stateCode = (shape.properties['hc-a2'] || '').toUpperCase();
        shape.stateName = (shape.name || '').toUpperCase();
        var locations = groupedByStateCode[stateCode] || [];
        var representative = _this10.getRepresentativeLocation(locations);
        var configuredGroup = _this10.getPredefinedGroupForState(stateCode);
        var predefinedGroup = configuredGroup && (configuredGroup.isLocked || !representative) ? configuredGroup : null;
        var marketData = predefinedGroup ? null : representative;
        return {
          stateName: shape.stateName,
          stateCode: stateCode,
          stateValue: _this10.getStateValue(stateCode, marketData),
          marketData: marketData,
          predefinedGroup: predefinedGroup,
          color: predefinedGroup ? _this10.getPredefinedGroupColor(predefinedGroup) : _this10.resolveColor(marketData, emptyColor),
          value: marketData || predefinedGroup ? 1 : 0
        };
      });
    },
    buildToolbarCounter: function buildToolbarCounter(party) {
      var _this11 = this;

      var counter = {
        total: 0,
        widthTotal: 0,
        low: 0,
        medium: 0,
        high: 0,
        predefined: 0,
        lowWidth: 0,
        mediumWidth: 0,
        highWidth: 0,
        predefinedWidth: 0,
        predefinedLabel: 'No election',
        predefinedDisplayText: ''
      };

      this.toolbarBaselines.filter(function (baseline) {
        return _this11.getGroupParty(baseline) === party;
      }).forEach(function (baseline) {
        var requestedBucket = (baseline.bucket || '').toLowerCase();
        var bucket = ['low', 'medium', 'high'].includes(requestedBucket) ? requestedBucket : 'high';
        var count = Number(baseline.count) || 0;
        var reservedCount = baseline.reservedCount === null || typeof baseline.reservedCount === 'undefined' ? count : Number(baseline.reservedCount) || 0;
        counter[bucket] += count;
        counter[bucket + 'Width'] += reservedCount;
        counter.total += count;
        counter.widthTotal += reservedCount;
      });

      this.electionRows.filter(function (row) {
        return row.party === party;
      }).forEach(function (row) {
        var bucket = _this11.getPaletteBucket(row.leadingContract.lastTradePrice);
        var value = row.stateValue || 1;
        counter[bucket] += value;
        counter[bucket + 'Width'] += value;
        counter.total += value;
        counter.widthTotal += value;
      });

      this.predefinedGroups.filter(function (group) {
        return _this11.getGroupParty(group) === party;
      }).forEach(function (group) {
        var fallbackCount = Array.isArray(group.locationCodes) ? group.locationCodes.length : 0;
        var seatCount = group.seatCount === null || typeof group.seatCount === 'undefined' ? fallbackCount : Number(group.seatCount) || 0;
        var reservedSeatCount = group.reservedSeatCount === null || typeof group.reservedSeatCount === 'undefined' ? seatCount : Number(group.reservedSeatCount) || 0;
        counter.predefined += seatCount;
        counter.predefinedWidth += reservedSeatCount;
        counter.total += seatCount;
        counter.widthTotal += reservedSeatCount;
        if (group.label) {
          counter.predefinedLabel = group.label;
        }
        if (group.displayText) {
          counter.predefinedDisplayText = group.displayText;
        }
      });

      if (!counter.predefinedDisplayText) {
        counter.predefinedDisplayText = '' + counter.predefined;
      }

      return counter;
    },
    getGroupParty: function getGroupParty(group) {
      var party = (group && group.party || '').toLowerCase();
      if (party.includes('rep')) {
        return PARTY_REPUBLICAN;
      }
      return PARTY_DEMOCRATIC;
    },
    createToolbarSegment: function createToolbarSegment(counter, bucket, party) {
      var striped = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var value = counter[bucket] || 0;
      var widthValue = counter[bucket + 'Width'];
      var width = roundToTwo((typeof widthValue === 'number' ? widthValue : value) / this.toolbarTotalWidth * 100);
      var colorPrice = 1;
      if (bucket === 'low') {
        colorPrice = PRICE_FACTORS.LOW;
      } else if (bucket === 'medium') {
        colorPrice = PRICE_FACTORS.MEDIUM;
      }
      return {
        key: party + '-' + bucket,
        party: party,
        bucket: bucket,
        value: value,
        width: width,
        color: this.getPaletteColor(party, colorPrice),
        striped: striped,
        label: striped ? counter.predefinedLabel : '',
        displayText: striped ? counter.predefinedDisplayText : '' + value,
        showText: width >= WIDTH_PERCENTAGE_THRESHOLD
      };
    },
    renderChart: function renderChart() {
      var mapKey = 'countries/us/custom/us-small';
      if (!this.$refs.chart || typeof Highcharts === 'undefined' || !Highcharts.maps || !Highcharts.maps[mapKey]) {
        this.hasError = true;
        return;
      }

      var mapShapes = Highcharts.geojson(Highcharts.maps[mapKey]);
      var data = this.getChartData(mapShapes);
      var vm = this;

      if (this.chart) {
        this.chart.destroy();
      }

      this.chart = Highcharts.mapChart(this.$refs.chart, {
        chart: {
          spacing: [0, 0, 0, 0],
          margin: [0, 0, 0, 0]
        },
        title: {
          text: ''
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: this.getMapFlag('showExports', true),
          menuItemDefinitions: {
            viewMapDataTable: {
              text: 'View data table',
              onclick: function onclick() {
                vm.toggleDataTable();
              }
            }
          },
          buttons: {
            contextButton: {
              menuItems: this.canShowDataTable ? MAP_WIDGET_CONTEXT_MENU_ITEMS : DEFAULT_CONTEXT_MENU_ITEMS
            }
          }
        },
        mapNavigation: {
          enabled: true,
          enableButtons: false,
          enableDoubleClickZoomTo: true,
          enableTouchZoom: true,
          mouseWheelSensitivity: 1.1
        },
        tooltip: {
          useHTML: true,
          borderRadius: 0,
          borderWidth: 0,
          shadow: false,
          backgroundColor: 'white',
          formatter: function formatter() {
            return vm.getTooltipHtml(this.point);
          }
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: function onClick() {
                  var marketId = vm.getPointMarketId(this);
                  if (marketId) {
                    window.location.href = '/markets/detail/' + marketId;
                  }
                }
              }
            }
          }
        },
        series: [{
          mapData: mapShapes,
          data: data,
          joinBy: 'stateName',
          dataLabels: {
            enabled: true,
            formatter: function dataLabelFormatter() {
              return vm.getDataLabel(this.point);
            },
            useHTML: this.isElectionMap,
            style: {
              textOutline: 0,
              fontSize: this.isElectionMap ? '11px' : '10px',
              color: '#ffffff'
            }
          }
        }, {
          name: 'Separators',
          type: 'mapline',
          data: Highcharts.geojson(Highcharts.maps[mapKey], 'mapline'),
          color: '#c8c8c8',
          showInLegend: false,
          enableMouseTracking: false
        }]
      });

      this.startContextMenuObserver();

      if (this.shouldShowPinchHint) {
        this.showPinchHint = true;
      }
    },
    loadMapData: function loadMapData() {
      var _this12 = this;

      this.isLoading = true;
      this.hasError = false;
      this.showDataTable = false;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].map.getMapData(this.mapName, false), __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].map.getMapLegend(this.mapName, false)]).then(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            mapResponse = _ref2[0],
            legendResponse = _ref2[1];

        _this12.mapData = Array.isArray(mapResponse.data) ? mapResponse.data : [];
        _this12.legendData = Array.isArray(legendResponse.data) ? legendResponse.data : [];
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
          _this12.$nextTick(function () {
            _this12.renderChart();
            resolve();
          });
        });
      }).catch(function () {
        _this12.hasError = true;
      }).finally(function () {
        _this12.isLoading = false;
      });
    }
  },
  mounted: function mounted() {
    var _this13 = this;

    try {
      var dismissed = localStorage.getItem(PINCH_HINT_STORAGE_KEY) === 'true';
      this.shouldShowPinchHint = this.isMobileLayout() && !dismissed;
    } catch (e) {
      this.shouldShowPinchHint = this.isMobileLayout();
    }

    this.loadMapData();

    this.$nextTick(function () {
      if (_this13.$refs.chart) {
        _this13.interactionDismissHandler = function () {
          return _this13.dismissPinchHint();
        };
        _this13.$refs.chart.addEventListener('touchstart', _this13.interactionDismissHandler, { passive: true });
        _this13.$refs.chart.addEventListener('mousedown', _this13.interactionDismissHandler);
        _this13.$refs.chart.addEventListener('wheel', _this13.interactionDismissHandler, { passive: true });
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.stopContextMenuObserver();

    if (this.$refs.chart && this.interactionDismissHandler) {
      this.$refs.chart.removeEventListener('touchstart', this.interactionDismissHandler);
      this.$refs.chart.removeEventListener('mousedown', this.interactionDismissHandler);
      this.$refs.chart.removeEventListener('wheel', this.interactionDismissHandler);
    }

    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
});

/***/ }),

/***/ "KJ3Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KNAh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CodeInput',

    props: {
        value: {
            type: String,
            default: ''
        },
        error: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        length: {
            type: Number,
            default: 6
        }
    },

    data: function data() {
        return {
            digits: Array(this.length).fill('')
        };
    },


    computed: {
        isComplete: function isComplete() {
            return this.digits.every(function (d) {
                return d !== '';
            });
        },
        codeValue: function codeValue() {
            return this.digits.join('');
        }
    },

    watch: {
        value: {
            immediate: true,
            handler: function handler(newVal) {
                if (newVal !== this.codeValue) {
                    this.setCodeFromValue(newVal);
                }
            }
        }
    },

    methods: {
        /**
         * Handle input event - auto-advance to next input and distribute autofill content
         */
        handleInput: function handleInput(event, index) {
            var _this = this;

            var numericValue = this.getNumericValue(event.target.value);

            if (numericValue.length > 1) {
                // iOS one-time-code autofill injects the full code into the focused field.
                var startIndex = numericValue.length >= this.length ? 0 : index;
                this.applyCode(numericValue, startIndex);
                return;
            }

            if (numericValue.length > 0) {
                this.$set(this.digits, index, numericValue);

                // Auto-advance to next input
                if (index < this.length - 1) {
                    this.$nextTick(function () {
                        _this.focusInput(index + 1);
                    });
                }
            } else {
                this.$set(this.digits, index, '');
            }

            this.emitUpdate();
        },


        /**
         * Handle keydown events - backspace navigation and arrow keys
         */
        handleKeydown: function handleKeydown(event, index) {
            var key = event.key;

            if (key === 'Backspace') {
                if (this.digits[index] === '' && index > 0) {
                    // If current input is empty, go to previous and clear it
                    event.preventDefault();
                    this.$set(this.digits, index - 1, '');
                    this.focusInput(index - 1);
                    this.emitUpdate();
                } else if (this.digits[index] !== '') {
                    // Clear current input
                    this.$set(this.digits, index, '');
                    this.emitUpdate();
                }
            } else if (key === 'ArrowLeft' && index > 0) {
                event.preventDefault();
                this.focusInput(index - 1);
            } else if (key === 'ArrowRight' && index < this.length - 1) {
                event.preventDefault();
                this.focusInput(index + 1);
            } else if (key === 'Enter' && this.isComplete) {
                this.$emit('submit');
            }
        },


        /**
         * Handle paste event - fill all inputs from pasted content
         */
        handlePaste: function handlePaste(event) {
            event.preventDefault();

            var pastedData = (event.clipboardData || window.clipboardData).getData('text');
            this.applyCode(pastedData);
        },


        /**
         * Select content on focus for easy replacement
         */
        handleFocus: function handleFocus(event) {
            if (event.target.value) {
                event.target.select();
            }
        },
        getNumericValue: function getNumericValue(value) {
            return (value || '').replace(/\D/g, '');
        },
        applyCode: function applyCode(value) {
            var _this2 = this;

            var startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var numericValue = this.getNumericValue(value).slice(0, this.length - startIndex);

            if (numericValue.length === 0) {
                return;
            }

            for (var offset = 0; offset < numericValue.length; offset++) {
                this.$set(this.digits, startIndex + offset, numericValue[offset]);
            }

            if (startIndex === 0) {
                for (var i = numericValue.length; i < this.length; i++) {
                    this.$set(this.digits, i, '');
                }
            }

            this.$nextTick(function () {
                _this2.focusNextAvailableInput(startIndex);
            });

            this.emitUpdate();
        },
        focusNextAvailableInput: function focusNextAvailableInput() {
            var startIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            var nextEmptyIndex = this.digits.findIndex(function (digit, index) {
                return index >= startIndex && digit === '';
            });

            if (nextEmptyIndex !== -1) {
                this.focusInput(nextEmptyIndex);
                return;
            }

            this.focusInput(this.length - 1);
        },


        /**
         * Focus a specific input by index
         */
        focusInput: function focusInput(index) {
            var inputs = this.$refs.inputs;
            if (inputs && inputs[index]) {
                inputs[index].focus();
            }
        },


        /**
         * Public method: focus the first input
         */
        focusFirst: function focusFirst() {
            this.focusInput(0);
        },


        /**
         * Public method: clear all inputs
         */
        clear: function clear() {
            var _this3 = this;

            this.digits = Array(this.length).fill('');
            this.emitUpdate();
            this.$nextTick(function () {
                _this3.focusFirst();
            });
        },


        /**
         * Set digits from external value
         */
        setCodeFromValue: function setCodeFromValue(value) {
            var chars = (value || '').split('');
            for (var i = 0; i < this.length; i++) {
                this.$set(this.digits, i, chars[i] || '');
            }
        },


        /**
         * Emit update events
         */
        emitUpdate: function emitUpdate() {
            var code = this.codeValue;
            this.$emit('input', code);
            this.$emit('update:value', code);

            if (this.isComplete) {
                this.$emit('complete', code);
            }
        }
    }
});

/***/ }),

/***/ "KQy8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:_vm.classModifiers,on:{"click":_vm.handleSecretTap}},[_c('transition',{attrs:{"name":"footer-expand"},on:{"enter":_vm.onFooterExpandEnter,"after-enter":_vm.onFooterExpandStopFrame,"enter-cancelled":_vm.onFooterExpandStopFrame}},[(_vm.isLayoutMobile || _vm.expanded)?_c('div',{staticClass:"footer__top"},[_c('div',{staticClass:"footer__top-content"},[_c('div',{staticClass:"row row-y footer__row"},[_c('div',{staticClass:"column small-12 medium-12 large-4"},[_c('router-link',{staticClass:"footer__logo",attrs:{"to":{name: 'home'},"tag":"div"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-12 large-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12 medium-4"},[_c('div',{class:_vm.sectionClassModifiers('engage'),on:{"click":function($event){return _vm.toggleSection('engage')}}},[_vm._v("\n                  Engage\n                ")]),_vm._v(" "),_c('div',{staticClass:"footer__section-divider"}),_vm._v(" "),(_vm.isSectionVisible('engage'))?[_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'market-list' }}},[_vm._v("\n                    Markets\n                  ")]),_vm._v(" "),_c('a',{staticClass:"footer__link",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggleSearchBar($event)}}},[_vm._v("Search")]),_vm._v(" "),(_vm.leaderboardsEnabled)?_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'leaderboards' }}},[_vm._v("\n                    Leaderboards\n                  ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'news-stories' }}},[_vm._v("\n                    News\n                  ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'learn-stories' }}},[_vm._v("\n                  Learn\n                ")])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4"},[_c('div',{class:_vm.sectionClassModifiers('learn'),on:{"click":function($event){return _vm.toggleSection('learn')}}},[_vm._v("\n                  Support\n                ")]),_vm._v(" "),_c('div',{staticClass:"footer__section-divider"}),_vm._v(" "),(_vm.isSectionVisible('learn'))?[_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'WhatIsPredictIt' }}},[_vm._v("\n                    About\n                  ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'sitemap' }}},[_vm._v("\n                    Site Map\n                  ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'HelpAndSupport' }}},[_vm._v("\n                    Support\n                  ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'responsible-trading' }}},[_vm._v("\n                    Responsible Trading\n                  ")])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4"},[_c('div',{class:_vm.sectionClassModifiers('legal'),on:{"click":function($event){return _vm.toggleSection('legal')}}},[_vm._v("\n                  Legal\n                ")]),_vm._v(" "),_c('div',{staticClass:"footer__section-divider"}),_vm._v(" "),(_vm.isSectionVisible('legal'))?[_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'terms-and-conditions' }}},[_vm._v("\n                    Terms And Conditions\n                  ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'privacy-policy' }}},[_vm._v("\n                    Privacy\n                  ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__link",attrs:{"to":{ name: 'accessibility-statement' }}},[_vm._v("\n                    Accessibility Statement\n                  ")])]:_vm._e()],2)])])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"footer__bottom"},[(_vm.isLayoutDesktop)?_c('div',{staticClass:"footer__bottom-content"},[_c('div',{staticClass:"footer__bottom-details",on:{"click":_vm.onDetailsToggle}},[_c('div',[_vm._v("\n          Details\n        ")]),_vm._v(" "),_c('div',{class:_vm.footerBottomChevronModifiers})]),_vm._v(" "),_c('div',{staticClass:"footer__links"},[_c('router-link',{staticClass:"footer__links--item",attrs:{"to":{ name: 'market-list' }}},[_vm._v("\n          Markets\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__links--item",attrs:{"to":{ name: 'news-stories' }}},[_vm._v("\n          News\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__links--item",attrs:{"to":{ name: 'HelpAndSupport' }}},[_vm._v("\n          Support\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__links--item",attrs:{"to":{ name: 'platform-announcements' }}},[_vm._v("\n          Announcements\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"footer__bottom-side-nav"},[_c('div',{staticClass:"footer__bottom-copy"},[_vm._v("\n          The Truth Machine © "+_vm._s((new Date()).getFullYear())+" "),_c('brand-name'),_vm._v(". All rights reserved.\n        ")],1),_vm._v(" "),_c('div',{staticClass:"footer__logos"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"footer__logo-item"},[_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":item.href,"title":item.title}},[_c('img',{attrs:{"src":item.icon}})])])}),0)])]):_c('div',{staticClass:"footer__bottom-content"},[_c('div',{staticClass:"footer__links"},[_c('router-link',{staticClass:"footer__links--item",attrs:{"to":{ name: 'market-list' }}},[_vm._v("\n          Markets\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__links--item",attrs:{"to":{ name: 'news-stories' }}},[_vm._v("\n          News\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__links--item",attrs:{"to":{ name: 'HelpAndSupport' }}},[_vm._v("\n          Support\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"footer__links--item",attrs:{"to":{ name: 'platform-announcements' }}},[_vm._v("\n          Announcements\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"footer__logos"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"footer__logo-item"},[_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":item.href,"title":item.title}},[_c('img',{attrs:{"src":item.icon}})])])}),0),_vm._v(" "),_c('div',{staticClass:"footer__bottom-copy"},[_vm._v("\n        The Truth Machine\n      ")]),_vm._v(" "),_c('div',{staticClass:"footer__bottom-copy"},[_vm._v("\n         © "+_vm._s((new Date()).getFullYear())+" "),_c('brand-name'),_vm._v(". All rights reserved.\n      ")],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KRkG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__ = __webpack_require__("jLJc");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_001c5ad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_swiper_vue__ = __webpack_require__("6b6f");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_001c5ad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_swiper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KUSN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_notification_items_notifcation_item_dashboard_notification_item_dashboard_vue__ = __webpack_require__("MJqx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_unreadNotification__ = __webpack_require__("BL43");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_contentLoader__ = __webpack_require__("P71F");


 /*
                                       Display List of notifications in dashboard/account pages.
                                      */







var NOTIFICATION_COUNT_LIMIT = 99;
var NO_ITEMS_MESSAGE = 'There are no notifications';
var NO_MORE_ITEMS_MESSAGE = 'No more notifications to display';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_unreadNotification__["a" /* default */]],
  props: {
    limit: {
      type: Number,
      default: null
    },
    theme: {
      type: String,
      default: ''
    }
  },
  components: {
    notificationItemDashboard: __WEBPACK_IMPORTED_MODULE_5__components_notification_items_notifcation_item_dashboard_notification_item_dashboard_vue__["a" /* default */],
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a
  },
  data: function data() {
    return {
      loadedInfo: NO_ITEMS_MESSAGE,
      infiniteLoader: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('dashboard', ['notifications', 'notificationsToggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['userData']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'notifications-list': true
      }, 'notifications-list--' + this.theme, this.theme);
    },
    items: function items() {
      var data = this.notifications.data;

      if (this.limit) {
        data = this.notifications.data.slice(0, this.limit);
      }
      return __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy___default()(data, function (el) {
        return el.notificationId;
      });
    },
    notificationsCount: function notificationsCount() {
      var total = this.notifications.totalCount;
      return total > NOTIFICATION_COUNT_LIMIT ? NOTIFICATION_COUNT_LIMIT : total;
    },
    showInfiniteLoading: function showInfiniteLoading() {
      return this.notifications.canLoadMore && !this.limit;
    },
    isScrollMore: function isScrollMore() {
      return this.infiniteLoader && this.notifications.canLoadMore && this.items.length > 0;
    }
  }),
  watch: {
    notificationsToggle: function notificationsToggle() {
      this.infiniteLoader = null;
      this.resetNotifications();
      this.loadNotifications();
    },
    items: function items() {
      if (this.infiniteLoader) {
        this.infiniteLoader.loaded();
        if (!this.notifications.canLoadMore) {
          this.infiniteLoader.complete();
        }
      }
      this.loadedInfo = this.items.length > 0 ? NO_MORE_ITEMS_MESSAGE : NO_ITEMS_MESSAGE;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('dashboard', ['resetNotifications', 'getNotifications']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('notifications', ['toggleNotificationsWidget']), {
    onSeeAllClick: function onSeeAllClick() {
      this.toggleNotificationsWidget();
      this.$router.push({ name: 'dashboard-notifications' });
    },
    goInfinite: function goInfinite(infi) {
      this.infiniteLoader = infi;

      if (this.notifications.canLoadMore) {
        this.loadNotifications();
      }
    },
    loadNotifications: function loadNotifications() {
      var _this = this;

      if (this.loading) return;

      this.loading = true;
      this.getNotifications().then(function () {
        _this.loading = false;
        _this.isComponentReady = true;
      });
    }
  }),
  created: function created() {
    this.resetNotifications();
    this.loadNotifications();
  }
});

/***/ }),

/***/ "KWv7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_home_old_home_old_vue__ = __webpack_require__("3Uxo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_page_daily_markets_details_daily_pages_constants__ = __webpack_require__("9MVc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__account__ = __webpack_require__("Rlrl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__support__ = __webpack_require__("u0d3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dashboard__ = __webpack_require__("0IxP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static__ = __webpack_require__("gQ0Z");











var trends = function trends() {
  return Promise.all/* import() */([__webpack_require__.e(52), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "dywA"));
};
var pageMarkets = function pageMarkets() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "CIck"));
};
var pageStoryDetail = function pageStoryDetail() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(__webpack_require__.bind(null, "p+/I"));
};
var pageSearch = function pageSearch() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, "HK72"));
};
var pageWatchlist = function pageWatchlist() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "UwQr"));
};
var pagePrivacyPolicy = function pagePrivacyPolicy() {
  return Promise.all/* import() */([__webpack_require__.e(33), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "6V5V"));
};
var pageTermsAndConditions = function pageTermsAndConditions() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(__webpack_require__.bind(null, "v+Mv"));
};
var pagePlatformAnnouncements = function pagePlatformAnnouncements() {
  return Promise.all/* import() */([__webpack_require__.e(34), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "AyUZ"));
};
var pageDebug = function pageDebug() {
  return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, "V/Y1"));
};
var pageSitemap = function pageSitemap() {
  return Promise.all/* import() */([__webpack_require__.e(28), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "PVzo"));
};
var pageResearch = function pageResearch() {
  return Promise.all/* import() */([__webpack_require__.e(31), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "HLCK"));
};
var pageLeaderboards = function pageLeaderboards() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(__webpack_require__.bind(null, "LnYJ"));
};
var pageNotFound = function pageNotFound() {
  return Promise.all/* import() */([__webpack_require__.e(35), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "4kpQ"));
};
var pageStaticPreview = function pageStaticPreview() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "n58p"));
};
var pageStoryPreview = function pageStoryPreview() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "220P"));
};
var pageDailyMarketsDetails = function pageDailyMarketsDetails() {
  return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, "Ykf8"));
};
var pageAccessibilityStatement = function pageAccessibilityStatement() {
  return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, "aK6m"));
};
var pageResponsibleTrading = function pageResponsibleTrading() {
  return Promise.all/* import() */([__webpack_require__.e(30), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "0xF4"));
};
var pageMarketDetailSushi = function pageMarketDetailSushi() {
  return Promise.all/* import() */([__webpack_require__.e(9), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "rjLX"));
};
var pageUserStatus = function pageUserStatus() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "KFNs"));
};
var pageNewsStories = function pageNewsStories() {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, "jqqL"));
};
var pageNewsArchiveStories = function pageNewsArchiveStories() {
  return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, "jcwD"));
};
var pageLearnStories = function pageLearnStories() {
  return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, "gw34"));
};

var routes = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__account__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__support__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7__dashboard__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__static__["a" /* default */]), [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_1__components_home_home_old_home_old_vue__["a" /* default */],
  name: 'home',
  beforeEnter: function beforeEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('browse/setMarketsPageInitialLoadDone', false);
    next();
  }
}, {
  path: '/trends',
  component: trends,
  name: 'trends',
  meta: {
    requiresAuth: true,
    appContentFullWidth: true
  }
}, {
  path: '/research',
  component: pageResearch,
  name: 'research'
}, {
  path: '/privacy-policy',
  component: pagePrivacyPolicy,
  name: 'privacy-policy'
}, {
  path: '/accessibility-statement',
  name: 'accessibility-statement',
  component: pageAccessibilityStatement
}, {
  path: '/terms-and-conditions',
  component: pageTermsAndConditions,
  name: 'terms-and-conditions'
}, {
  path: '/responsible-trading',
  component: pageResponsibleTrading,
  name: 'responsible-trading'
}, {
  path: '/platform-announcements',
  component: pagePlatformAnnouncements,
  name: 'platform-announcements'
}, {
  path: '/markets/search',
  name: 'market-search',
  component: pageSearch
}, {
  path: '/markets/watchlist',
  name: 'market-watchlist',
  component: pageWatchlist,
  beforeEnter: function beforeEnter(to, from, next) {
    // browse.selectedOrder etc i shared by watchlist and markets page
    __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[WATCHLIST] Before enter setup');
    if (to.query.sortParameter) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('browse/setTimespanFromQuery', { parameter: to.query.sortParameter });
    } else {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('browse/setTimespanFromQuery', { parameter: 'ALL' });
    }
    if (to.query.sort) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('browse/setOrderFromQuery', to.query.sort);
    } else {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('browse/setOrderFromQuery', 'traded');
    }
    next();
  }
}, {
  path: '/markets/detail/:marketId/:marketUrl?',
  name: 'market-details',
  component: pageMarketDetailSushi,
  meta: {
    appContentFullWidth: true
  },
  props: function props(route) {
    return {
      marketId: parseInt(route.params.marketId, 10),
      showRules: !!route.params.showRules,
      prerendered: route.query.prerendered
    };
  }
}, {
  path: '/markets/:headerId?/:headerUrl?',
  name: 'market-list',
  component: pageMarkets,
  beforeEnter: function beforeEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[MARKETS] Before enter setup');
    var cachedHeaderId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.browse.marketListCachedHeaderId;
    var targetHeaderId = parseInt(to.params.headerId, 10) || 0;
    var returningWithValidCache = from.name === 'market-details' && cachedHeaderId === targetHeaderId;
    if (!returningWithValidCache && from.name !== 'market-list' && from.name !== 'payment-success' && from.name !== 'payment-fail') {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('browse/setMarketsPageInitialLoadDone', false);
    }
    if (to.query.filterIds) {
      to.query.filterIds.split(',').forEach(function (i) {
        var filterId = parseInt(i, 10);
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[MARKETS] filterId passed: ' + filterId);
        if (filterId) __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('browse/addFilter', filterId);
      });
    }
    if (to.query.sortParameter) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('browse/setTimespanFromQuery', {
        parameter: to.query.sortParameter,
        dateFrom: to.query.dateFrom,
        dateTo: to.query.dateTo
      });
    }
    if (to.query.sort) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('browse/setOrderFromQuery', to.query.sort);
    }
    next();
  },
  props: function props(route) {
    return {
      headerId: parseInt(route.params.headerId, 10) || 0,
      headerUrl: route.params.headerUrl,
      page: Math.max(1, parseInt(route.query.page, 10) || 1)
    };
  }
}, {
  path: '/stories/detail/:storyId/:storyUrl?',
  name: 'story-details',
  component: pageStoryDetail,
  props: function props(route) {
    return {
      storyId: parseInt(route.params.storyId, 10)
    };
  }
}, {
  path: '/payment/success',
  component: pageMarkets,
  name: 'payment-success',
  props: function props(route) {
    return {
      headerId: parseInt(route.params.headerId, 10) || 0,
      headerUrl: route.params.headerUrl,
      notificationText: 'Bitcoin Deposit Received',
      notificationLevel: 'success'
    };
  }
}, {
  path: '/payment/fail',
  component: pageMarkets,
  name: 'payment-fail',
  props: function props(route) {
    return {
      headerId: parseInt(route.params.headerId, 10) || 0,
      headerUrl: route.params.headerUrl
    };
  }
}, {
  path: '/static-page-preview',
  component: pageStaticPreview,
  name: 'static-page-preview',
  beforeEnter: function beforeEnter(to, from, next) {
    if (!to.query.previewId) {
      next({
        name: 'home'
      });
    } else {
      next();
    }
  },
  props: function props(route) {
    return {
      previewId: route.query.previewId
    };
  }
}, {
  path: '/story-full-preview',
  component: pageStoryPreview,
  name: 'story-full-preview',
  beforeEnter: function beforeEnter(to, from, next) {
    if (!to.query.previewId) {
      next({
        name: 'home'
      });
    } else {
      next();
    }
  },
  props: function props(route) {
    return {
      previewId: route.query.previewId
    };
  }
}, {
  path: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_daily_markets_details_daily_pages_constants__["a" /* DAILY_PAGES */].MONDAY.path,
  component: pageDailyMarketsDetails,
  name: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_daily_markets_details_daily_pages_constants__["a" /* DAILY_PAGES */].MONDAY.id,
  props: function props() {
    return {
      pageId: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_daily_markets_details_daily_pages_constants__["a" /* DAILY_PAGES */].MONDAY.pageId
    };
  }
}, {
  path: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_daily_markets_details_daily_pages_constants__["a" /* DAILY_PAGES */].TUESDAY.path,
  component: pageDailyMarketsDetails,
  name: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_daily_markets_details_daily_pages_constants__["a" /* DAILY_PAGES */].TUESDAY.id,
  props: function props() {
    return {
      pageId: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_daily_markets_details_daily_pages_constants__["a" /* DAILY_PAGES */].TUESDAY.pageId
    };
  }
}, {
  path: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_daily_markets_details_daily_pages_constants__["a" /* DAILY_PAGES */].WEDNESDAY.path,
  component: pageDailyMarketsDetails,
  name: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_daily_markets_details_daily_pages_constants__["a" /* DAILY_PAGES */].WEDNESDAY.id,
  props: function props() {
    return {
      pageId: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_daily_markets_details_daily_pages_constants__["a" /* DAILY_PAGES */].WEDNESDAY.pageId
    };
  }
}, {
  path: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_daily_markets_details_daily_pages_constants__["a" /* DAILY_PAGES */].THURSDAY.path,
  component: pageDailyMarketsDetails,
  name: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_daily_markets_details_daily_pages_constants__["a" /* DAILY_PAGES */].THURSDAY.id,
  props: function props() {
    return {
      pageId: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_daily_markets_details_daily_pages_constants__["a" /* DAILY_PAGES */].THURSDAY.pageId
    };
  }
}, {
  path: '/sitemap',
  component: pageSitemap,
  name: 'sitemap'
}, {
  path: '/user-status',
  component: pageUserStatus,
  name: 'user-status'
}, {
  path: '/news',
  component: pageNewsStories,
  name: 'news-stories'
}, {
  path: '/news/archive',
  component: pageNewsArchiveStories,
  name: 'news-archive-stories'
}, {
  path: '/learn',
  component: pageLearnStories,
  name: 'learn-stories'
}, {
  path: '*',
  component: pageNotFound,
  name: 'not-found'
}]);

if (false) {
  routes.push({
    path: '/debug',
    component: pageDebug,
    name: 'debug'
  });
}

if (false) {
  routes.push({
    path: '/leaderboards',
    component: pageLeaderboards,
    name: 'leaderboards',
    beforeEnter: function beforeEnter(to, from, next) {
      log.info('[LEADERBOARDS] Before enter setup');
      if (typeof to.query.leaderboardId !== 'undefined') {
        log.info('[LEADERBOARDS] settings leaderboardId: ' + to.query.leaderboardId);
        store.dispatch('leaderboards/setSelectedLeaderboardId', parseInt(to.query.leaderboardId, 10));
      }
      if (to.query.dateRange) {
        log.info('[LEADERBOARDS] settings dateRange: ' + to.query.dateRange);
        store.dispatch('leaderboards/setLeaderboardsDateRange', parseInt(to.query.dateRange, 10));
      }
      next();
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "Kcew":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Ke/w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__("H/Zg");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    faqs: null,
    sitemap: null
  },
  mutations: {
    setFaqs: function setFaqs(state, payload) {
      state.faqs = payload;
    },
    setSitemap: function setSitemap(state, payload) {
      state.sitemap = payload;
    }
  },
  actions: {
    getFaqs: function getFaqs(_ref) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].about.getFaqs().then(function (response) {
        commit('setFaqs', response.data);
        return response.data;
      });
    },
    getSitemap: function getSitemap(_ref2) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].about.getSitemap().then(function (response) {
        commit('setSitemap', response.data);
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "Ketp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kf7o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.showCloseButton)?_c('div',{staticClass:"content-header__close",on:{"click":_vm.close}}):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"content-header__title",on:{"click":_vm.closeTitle}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(_vm.subTitle)?_c('span',{staticClass:"content-header__sub-title"},[_vm._v(_vm._s(_vm.subTitle))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KfPg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"security-settings",attrs:{"id":"security"}},[(_vm.loading)?_c('div',{staticClass:"security-settings__loading-overlay"},[_c('div',{staticClass:"security-settings__spinner"}),_vm._v(" "),_c('span',[_vm._v("Loading security settings...")])]):(_vm.error && !_vm.setupMode)?_c('div',{staticClass:"security-settings__error"},[_vm._v("\n    "+_vm._s(_vm.error)+"\n    "),_c('button',{staticClass:"security-settings__retry-btn",on:{"click":_vm.loadStatus}},[_vm._v("Retry")])]):[_c('div',{staticClass:"security-settings__status-header"},[_c('div',{staticClass:"security-settings__status-info"},[_c('span',{staticClass:"security-settings__status-label"},[_vm._v("Two-Factor Authentication")]),_vm._v(" "),_c('span',{class:['security-settings__status-badge', _vm.is2FAEnabled ? 'security-settings__status-badge--active' : '']},[_vm._v("\n          "+_vm._s(_vm.is2FAEnabled ? 'Enabled' : 'Disabled')+"\n        ")])]),_vm._v(" "),(_vm.hasAnyMethod)?_c('switch-button',{ref:"twoFactorToggle",attrs:{"black":"","checked":_vm.is2FAEnabled,"disabled":!_vm.canEnable2FA},on:{"toggle":_vm.toggleTwoFactor}}):_vm._e()],1),_vm._v(" "),_c('p',{staticClass:"security-settings__description"},[_vm._v("\n      Add an extra layer of security to your account by requiring a verification code in addition to your password when you sign in.\n    ")]),_vm._v(" "),(_vm.setupMode)?_c('div',{staticClass:"security-settings__setup"},[_c('div',{staticClass:"security-settings__setup-header"},[_c('button',{staticClass:"security-settings__back-btn",on:{"click":_vm.cancelSetup}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polyline',{attrs:{"points":"15 18 9 12 15 6"}})]),_vm._v("\n          BACK\n        ")]),_vm._v(" "),_c('h5',{staticClass:"security-settings__setup-title"},[_vm._v("\n          Set Up "+_vm._s(_vm.setupMode === 'email' ? 'Email' : (_vm.setupMode === 'phone' ? 'Phone (SMS)' : 'Authenticator'))+" Verification\n        ")])]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"security-settings__error"},[_vm._v("\n        "+_vm._s(_vm.error)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.setupStep === 'phone-input' && _vm.setupMode === 'phone')?_c('div',{staticClass:"security-settings__step"},[_c('p',{staticClass:"security-settings__step-text"},[_vm._v("\n          Enter your phone number to receive a verification code via SMS.\n        ")]),_vm._v(" "),_c('div',{staticClass:"security-settings__input-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneNumber),expression:"phoneNumber"}],staticClass:"security-settings__input",attrs:{"type":"tel","placeholder":"+1 555-555-5555"},domProps:{"value":(_vm.phoneNumber)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.phoneNumber=$event.target.value},function($event){return _vm.$v.phoneNumber.$touch()}],"blur":function($event){return _vm.$v.phoneNumber.$touch()},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitPhoneNumber($event)}}}),_vm._v(" "),(_vm.phoneError)?_c('div',{staticClass:"security-settings__field-error"},[_vm._v("\n            "+_vm._s(_vm.phoneError)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width",class:{ 'button--loading': _vm.isSendingCode },attrs:{"disabled":!_vm.canSubmitPhone},on:{"click":_vm.submitPhoneNumber}},[(_vm.isSendingCode)?_c('span',{staticClass:"button__spinner"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"button__text"},[_vm._v(_vm._s(_vm.isSendingCode ? 'Sending...' : 'Send Verification Code'))])])]):_vm._e(),_vm._v(" "),(_vm.setupStep === 'send' && (_vm.setupMode === 'email' || _vm.setupMode === 'phone'))?_c('div',{staticClass:"security-settings__step"},[(_vm.isSendingCode)?_c('div',{staticClass:"security-settings__sending"},[_c('div',{staticClass:"security-settings__spinner"}),_vm._v(" "),_c('span',[_vm._v("Sending verification code...")])]):[_c('p',{staticClass:"security-settings__step-text"},[_vm._v("\n            We'll send a verification code to your "+_vm._s(_vm.setupMode === 'email' ? 'email address' : 'phone number')+".\n          ")]),_vm._v(" "),_c('button',{staticClass:"button button--primary button--full-width",attrs:{"disabled":!_vm.canSendCode},on:{"click":_vm.sendCode}},[_vm._v("\n            Send Code\n          ")])]],2):_vm._e(),_vm._v(" "),(_vm.setupMode === 'authenticator' && _vm.authenticatorData)?_c('div',{staticClass:"security-settings__authenticator"},[_c('p',{staticClass:"security-settings__step-text"},[_vm._v("\n          Scan the QR code with your authenticator app (Google Authenticator, Authy, etc.)\n        ")]),_vm._v(" "),_c('div',{staticClass:"security-settings__qr-container"},[_c('img',{staticClass:"security-settings__qr-code",attrs:{"src":_vm.authenticatorData.qr_code_url,"alt":"QR Code"}})]),_vm._v(" "),_c('p',{staticClass:"security-settings__manual-hint"},[_vm._v("Can't scan? Enter this code manually:")]),_vm._v(" "),_c('div',{staticClass:"security-settings__code-wrapper"},[_c('code',{staticClass:"security-settings__manual-code-value"},[_vm._v(_vm._s(_vm.authenticatorData.manual_code))]),_vm._v(" "),_c('button',{staticClass:"security-settings__copy-btn",class:{ 'security-settings__copy-btn--copied': _vm.codeCopied },on:{"click":_vm.copyManualCode}},[_vm._v("\n            "+_vm._s(_vm.codeCopied ? '✓ Copied' : 'Copy')+"\n          ")])])]):_vm._e(),_vm._v(" "),(_vm.setupStep === 'verify')?_c('div',{staticClass:"security-settings__verify"},[_c('label',{staticClass:"security-settings__label security-settings__label--centered"},[_vm._v("Enter verification code")]),_vm._v(" "),_c('code-input',{ref:"codeInput",attrs:{"error":_vm.hasCodeError,"disabled":_vm.isVerifying,"loading":_vm.isVerifying},on:{"submit":_vm.verifyCode,"complete":_vm.onCodeComplete},model:{value:(_vm.verificationCode),callback:function ($$v) {_vm.verificationCode=$$v},expression:"verificationCode"}}),_vm._v(" "),(_vm.setupMode !== 'authenticator')?_c('div',{staticClass:"security-settings__resend"},[_c('button',{staticClass:"security-settings__resend-btn",attrs:{"disabled":_vm.secondsUntilResend > 0},on:{"click":_vm.sendCode}},[(_vm.secondsUntilResend > 0)?[_c('span',{staticClass:"security-settings__resend-icon"},[_vm._v("⏱")]),_vm._v("\n              Resend in "+_vm._s(_vm.secondsUntilResend)+"s\n            ")]:[_vm._v(" Resend code ")]],2)]):_vm._e()],1):_vm._e()]):_c('div',{staticClass:"security-settings__methods"},[_c('div',{staticClass:"security-settings__method"},[_c('div',{staticClass:"security-settings__method-info"},[_c('span',{staticClass:"security-settings__method-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"}}),_vm._v(" "),_c('polyline',{attrs:{"points":"22,6 12,13 2,6"}})])]),_vm._v(" "),_c('div',{staticClass:"security-settings__method-details"},[_c('span',{staticClass:"security-settings__method-name"},[_vm._v("Email")]),_vm._v(" "),_c('span',{class:['security-settings__method-status', _vm.getMethodStatusClass(_vm.isEmailVerified)]},[_vm._v("\n              "+_vm._s(_vm.getMethodStatusText(_vm.isEmailVerified))+"\n              "),(_vm.isEmailVerified && _vm.emailHint)?[_vm._v(" - "+_vm._s(_vm.emailHint))]:_vm._e()],2)])]),_vm._v(" "),(!_vm.isEmailVerified)?_c('button',{staticClass:"security-settings__setup-btn",on:{"click":function($event){return _vm.startSetup('email')}}},[_vm._v("\n          Set Up\n        ")]):_c('span',{staticClass:"security-settings__check"},[_vm._v("✓")])]),_vm._v(" "),_c('div',{staticClass:"security-settings__method"},[_c('div',{staticClass:"security-settings__method-info"},[_c('span',{staticClass:"security-settings__method-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"x":"5","y":"2","width":"14","height":"20","rx":"2","ry":"2"}}),_vm._v(" "),_c('line',{attrs:{"x1":"12","y1":"18","x2":"12.01","y2":"18"}})])]),_vm._v(" "),_c('div',{staticClass:"security-settings__method-details"},[_c('span',{staticClass:"security-settings__method-name"},[_vm._v("Phone (SMS)")]),_vm._v(" "),_c('span',{class:['security-settings__method-status', _vm.getMethodStatusClass(_vm.isPhoneVerified)]},[_vm._v("\n              "+_vm._s(_vm.getMethodStatusText(_vm.isPhoneVerified))+"\n              "),(_vm.isPhoneVerified && _vm.phoneHint)?[_vm._v(" - "+_vm._s(_vm.phoneHint))]:_vm._e()],2)])]),_vm._v(" "),(!_vm.isPhoneVerified)?_c('button',{staticClass:"security-settings__setup-btn",on:{"click":function($event){return _vm.startSetup('phone')}}},[_vm._v("\n          Set Up\n        ")]):_c('span',{staticClass:"security-settings__check"},[_vm._v("✓")])]),_vm._v(" "),_c('div',{staticClass:"security-settings__method"},[_c('div',{staticClass:"security-settings__method-info"},[_c('span',{staticClass:"security-settings__method-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M9 12l2 2 4-4"}})])]),_vm._v(" "),_c('div',{staticClass:"security-settings__method-details"},[_c('span',{staticClass:"security-settings__method-name"},[_vm._v("Authenticator App")]),_vm._v(" "),_c('span',{class:['security-settings__method-status', _vm.getMethodStatusClass(_vm.isAuthenticatorEnabled)]},[_vm._v("\n              "+_vm._s(_vm.getMethodStatusText(_vm.isAuthenticatorEnabled))+"\n            ")])])]),_vm._v(" "),(!_vm.isAuthenticatorEnabled)?_c('button',{staticClass:"security-settings__setup-btn",on:{"click":function($event){return _vm.startSetup('authenticator')}}},[_vm._v("\n          Set Up\n        ")]):_c('span',{staticClass:"security-settings__check"},[_vm._v("✓")])])]),_vm._v(" "),(_vm.showDisableConfirmation)?_c('div',{staticClass:"security-settings__modal-overlay"},[_c('div',{staticClass:"security-settings__modal"},[_c('h4',{staticClass:"security-settings__modal-title"},[_vm._v("Disable Two-Factor Authentication?")]),_vm._v(" "),_c('p',{staticClass:"security-settings__modal-text"},[_vm._v("\n          Disabling 2FA will make your account less secure. Are you sure you want to continue?\n        ")]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"security-settings__error"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"security-settings__modal-actions"},[_c('button',{staticClass:"button button--secondary",attrs:{"disabled":_vm.isDisabling},on:{"click":_vm.cancelDisable}},[_vm._v("\n            Cancel\n          ")]),_vm._v(" "),_c('button',{staticClass:"button button--danger",attrs:{"disabled":_vm.isDisabling},on:{"click":_vm.confirmDisable}},[_vm._v("\n            "+_vm._s(_vm.isDisabling ? 'Disabling...' : 'Yes, Disable 2FA')+"\n          ")])])])]):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kg0Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Km0y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-register"},[_c('div',{staticClass:"account-register__socials"},[(!_vm.isWrapperApp)?_c('form-socials',{attrs:{"title":"Sign Up with"}}):_vm._e()],1),_vm._v(" "),_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row-xy"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column small-12 row-y"},[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"tabindex":1,"disabled":_vm.isFormDisabled,"name":"username","type":"email","required":true,"validation":_vm.$v.fields.email,"autocomplete":"off","gtm":"Registration,Email","placeholder":"Email"},on:{"input":_vm.$v.fields.email.$touch},model:{value:(_vm.fields.email),callback:function ($$v) {_vm.$set(_vm.fields, "email", $$v)},expression:"fields.email"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"tabindex":2,"disabled":_vm.isFormDisabled,"name":"emailConfirmation","type":"email","required":true,"validation":_vm.$v.fields.emailConfirmation,"autocomplete":"off","gtm":"Registration,Confirm Email","placeholder":"Confirm Email"},on:{"input":_vm.$v.fields.emailConfirmation.$touch},model:{value:(_vm.fields.emailConfirmation),callback:function ($$v) {_vm.$set(_vm.fields, "emailConfirmation", $$v)},expression:"fields.emailConfirmation"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{ref:"password",attrs:{"hideIconOnValue":false,"tabindex":3,"disabled":_vm.isFormDisabled,"name":"password","type":_vm.fieldTypePassword,"required":true,"validation":_vm.$v.fields.password,"autocomplete":"new-password","gtm":"Registration,Password","placeholder":"Password"},on:{"input":_vm.$v.fields.password.$touch},model:{value:(_vm.fields.password),callback:function ($$v) {_vm.$set(_vm.fields, "password", $$v)},expression:"fields.password"}},[(!_vm.isIE)?_c('show-password-icon',{attrs:{"slot":"icon"},on:{"showPassword":_vm.showPassword},slot:"icon"}):_vm._e()],1)],1),_vm._v(" "),(_vm.showUsername)?[_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"account-register__username-wraper"},[_c('form-input',{attrs:{"tabindex":4,"disabled":_vm.isFormDisabled,"name":"nickname","type":"text","required":true,"validation":_vm.$v.fields.username,"autocomplete":"off","gtm":"Registration,User Name","placeholder":"Username"},on:{"input":_vm.$v.fields.username.$touch},model:{value:(_vm.fields.username),callback:function ($$v) {_vm.$set(_vm.fields, "username", $$v)},expression:"fields.username"}})],1)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('p',{staticClass:"account-register__disclaimer"},[_vm._v("\n          By clicking \"Create Account\", you confirm that you are at least 18 years of age and have read the "),_c('router-link',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"to":{ name: 'terms-and-conditions' }}},[_vm._v("Terms and Conditions")]),_vm._v(". One account per person.\n        ")],1)])]),_vm._v(" "),_c('form-submit',{attrs:{"disabled":_vm.registerButtonDisabled,"loading":_vm.isFormDisabled,"label":"Create Account"}}),_vm._v(" "),_c('div',{staticClass:"recaptcha-terms"},[_vm._v("\n          Protected by reCAPTCHA ·\n          "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":"https://policies.google.com/privacy"}},[_vm._v("Privacy")]),_vm._v("\n          ·\n          "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":"https://policies.google.com/terms"}},[_vm._v("Terms")])])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('h5',{staticClass:"form__title form__title--new"},[_vm._v("Sign Up using your email")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KsCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_list_v2_embed_js__ = __webpack_require__("5yVZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d58f2c46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_list_v2_embed_vue__ = __webpack_require__("iocs");
function injectStyle (ssrContext) {
  __webpack_require__("K1rd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_list_v2_embed_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d58f2c46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_list_v2_embed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KvDS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_top_comments_js__ = __webpack_require__("7Wq7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_788c80ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_top_comments_vue__ = __webpack_require__("zhst");
function injectStyle (ssrContext) {
  __webpack_require__("GY5o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_top_comments_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_788c80ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_top_comments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KzG7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L09H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep__ = __webpack_require__("kvU2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_throttle__ = __webpack_require__("+X65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_notifications_proxy__ = __webpack_require__("a0yF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_notifications__ = __webpack_require__("tjp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_sessionHistory__ = __webpack_require__("zckU");










 /* eslint-disable max-len,no-unused-vars,arrow-body-style,no-restricted-syntax */








var PIN_KEY_DISCUSSION = 'discussion-pin-key';
var PIN_KEY_SESSION_HISTORY = 'session-history-pin-key';
var PIN_KEY_WATCHLIST = 'watchlist-pin-key';
var PIN_KEY_MARKET_HISTORY = 'market-history-pin-key';
var PIN_KEY_OPENED = 'pin-opened-key';

var MAX_RELATED_MARKETS = 3;
var MARKET_DEBOUNCE_INTERVAL = 750;
var debounceGetMarket = __WEBPACK_IMPORTED_MODULE_10_lodash_debounce___default()(function (dispatch, marketId) {
  dispatch('getMarket', { marketId: marketId, skipCache: true });
}, MARKET_DEBOUNCE_INTERVAL);

var ITEMS_PER_HISTORY_PAGE = 10;
var DEFAULT_HISTORY = {
  data: null,
  marketId: -1,
  totalCount: -1,
  canLoadMore: true
};
var DEFAULT_MARKET_SUMMARY_DATA = {
  data: [],
  page: 0,
  totalCount: 0,
  canLoadMore: true
};
var createDefaultTopComments = function createDefaultTopComments() {
  return {
    title: 'Top Recent Comments',
    comments: []
  };
};
var SUMMARY_DATA_THROTTLE_TIME = 500;

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    marketIsEngineBusy: false,
    marketIsEngineBusyMessage: null,
    marketLoadError: false,
    market: null,
    contracts: [],
    contract: null,
    history: DEFAULT_HISTORY,
    marketSummaryData: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_MARKET_SUMMARY_DATA),
    marketSummaryDataDate: '',
    marketSummaryLimitExceededMessage: '',
    isRulesOpen: false,
    related: [],
    chartTimeline: null,
    chartType: null,
    marketContractsStats: [],
    mapStateData: {},
    mapStateDataSenate: {},
    mapOverviewData: [],
    mapOverviewDataSenate: [],
    marketMapTooltipVisible: false,
    isDiscussionPinned: __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].get(PIN_KEY_DISCUSSION, false),
    isWatchlistPinned: __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].get(PIN_KEY_WATCHLIST, false),
    isSessionHistoryPinned: __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].get(PIN_KEY_SESSION_HISTORY, false),
    isMarketHistoryPinned: __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].get(PIN_KEY_MARKET_HISTORY, false),
    pinnedOpened: __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].get(PIN_KEY_OPENED, []),
    relatedContracts: [],
    relatedProducts: {
      active: [],
      closed: []
    },
    marketTopComments: createDefaultTopComments(),
    marketTopCommentsMarketId: null,
    marketTopCommentsLoaded: false,
    marketTopCommentsLoading: false,
    reloadHistoryToggle: 0,
    sessionHistory: __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_16__helpers_sessionHistory__["a" /* SESSION_HISTORY_KEY */], []),
    activeMarketTab: null
  },
  getters: {
    historyData: function historyData(state) {
      var historyData = state.history.data;
      return historyData === null ? [] : historyData;
    }
  },
  mutations: {
    setMarket: function setMarket(state, payload) {
      state.market = payload;
    },
    setContract: function setContract(state, payload) {
      state.contract = payload;
    },
    setContracts: function setContracts(state, payload) {
      state.contracts = payload;
    },
    setMarketLoadError: function setMarketLoadError(state, payload) {
      state.marketLoadError = payload;
    },
    setMarketEngineBusyMessage: function setMarketEngineBusyMessage(state, _ref) {
      var isEngineBusy = _ref.isEngineBusy,
          isEngineBusyMessage = _ref.isEngineBusyMessage;

      state.marketIsEngineBusy = isEngineBusy;
      state.marketIsEngineBusyMessage = isEngineBusyMessage;
    },
    updateMarketFromNotification: function updateMarketFromNotification(state, data) {
      state.market = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["a" /* updateMarket */])(state.market, data);
    },
    updateContractFromNotification: function updateContractFromNotification(state, data) {
      if (state.market !== null && typeof state.market.contracts !== 'undefined') {
        // CONTRACTS SORT
        // contracts.sort((prev, next) => {
        //   if (prev.lastTradePrice < next.lastTradePrice) {
        //     return 1;
        //   } else if (prev.lastTradePrice > next.lastTradePrice) {
        //     return -1;
        //   }
        //   return 0;
        // });
        state.market = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["b" /* updateMarketContracts */])(state.market, data);
      }
      if (state.contracts !== null) {
        // CONTRACTS SORT
        // state.contracts.sort((prev, next) => {
        //   if (prev.lastTradePrice < next.lastTradePrice) {
        //     return 1;
        //   } else if (prev.lastTradePrice > next.lastTradePrice) {
        //     return -1;
        //   }
        //   return 0;
        // });
        var contracts = state.contracts.slice();
        state.contracts = contracts.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }
      if (state.contract !== null) {
        state.contract = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["d" /* updateContract */])(state.contract, data);
      }
    },
    updateMapOverviewDataFromNotification: function updateMapOverviewDataFromNotification(state, data) {
      if (state.mapOverviewData.length > 0) {
        var mapOverviewData = state.mapOverviewData.slice();
        state.mapOverviewData = mapOverviewData.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }

      var mapStateData = __WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep___default()(state.mapStateData);

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(mapStateData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var stateCode = _step.value;

          mapStateData[stateCode] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["b" /* updateMarketContracts */])(mapStateData[stateCode], data);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      state.mapStateData = mapStateData;
    },
    updateMapOverviewDataSenateFromNotification: function updateMapOverviewDataSenateFromNotification(state, data) {
      if (state.mapOverviewDataSenate.length > 0) {
        var mapOverviewData = state.mapOverviewDataSenate.slice();
        state.mapOverviewDataSenate = mapOverviewData.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }

      var mapStateData = __WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep___default()(state.mapStateDataSenate);

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(mapStateData)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var stateCode = _step2.value;

          mapStateData[stateCode] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["b" /* updateMarketContracts */])(mapStateData[stateCode], data);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      state.mapStateDataSenate = mapStateData;
    },
    resetHistory: function resetHistory(state) {
      state.history = DEFAULT_HISTORY;
    },
    updateHistory: function updateHistory(state, payload) {
      state.history = {
        data: payload.data.historyList,
        marketId: payload.marketId,
        totalCount: payload.data.totalCount,
        canLoadMore: payload.data.totalCount > payload.data.historyList.length
      };
    },
    setMarketSummaryLimitExceeded: function setMarketSummaryLimitExceeded(state, message) {
      state.marketSummaryLimitExceededMessage = message;
    },
    updateMarketSummaryData: function updateMarketSummaryData(state, payload) {
      var data = __WEBPACK_IMPORTED_MODULE_8_lodash_uniqBy___default()(state.marketSummaryData.data.concat(payload.SummaryContractData || []), function (i) {
        return i.MarketSummaryDataId;
      });
      var page = payload.Page;
      var totalCount = payload.TotalItems;
      var canLoadMore = totalCount > data.length;

      state.marketSummaryData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.marketSummaryData, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    resetMarketSummaryData: function resetMarketSummaryData(state) {
      state.marketSummaryData = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_MARKET_SUMMARY_DATA);
      state.marketSummaryLimitExceededMessage = '';
    },
    setOpenRules: function setOpenRules(state, payload) {
      state.isRulesOpen = payload;
    },
    setRelatedMarkets: function setRelatedMarkets(state, payload) {
      state.related = payload;
    },
    clearRelatedMarkets: function clearRelatedMarkets(state) {
      state.related = [];
    },
    updateRelatedMarketFromNotification: function updateRelatedMarketFromNotification(state, data) {
      if (state.related.length > 0) {
        state.related = state.related.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
    },
    updateRelatedContractFromNotification: function updateRelatedContractFromNotification(state, data) {
      if (state.related.length > 0) {
        state.related = state.related.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_notifications__["b" /* updateMarketContracts */])(market, data);
        });
      }
    },
    setChartTimeline: function setChartTimeline(state, data) {
      state.chartTimeline = data;
    },
    setChartType: function setChartType(state, data) {
      state.chartType = data;
    },
    setMarketContractsStats: function setMarketContractsStats(state, data) {
      state.marketContractsStats = data;
    },
    clearMarketContractsStats: function clearMarketContractsStats(state) {
      state.marketContractsStats = [];
    },
    setMapOverviewData: function setMapOverviewData(state, data) {
      state.mapOverviewData = data;
    },
    setMapOverviewDataSenate: function setMapOverviewDataSenate(state, data) {
      state.mapOverviewDataSenate = data;
    },
    setMapStateData: function setMapStateData(state, data) {
      state.mapStateData = data;
    },
    setMapStateDataSenate: function setMapStateDataSenate(state, data) {
      state.mapStateDataSenate = data;
    },
    setMarketMapTooltipVisible: function setMarketMapTooltipVisible(state, flag) {
      state.marketMapTooltipVisible = flag;
    },
    setMarketSummaryDataDate: function setMarketSummaryDataDate(state, value) {
      state.marketSummaryDataDate = value;
    },
    toggleDiscussionPin: function toggleDiscussionPin(state) {
      if (state.isDiscussionPinned) {
        state.isDiscussionPinned = false;
        __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].set(PIN_KEY_DISCUSSION, false);
      } else {
        state.isDiscussionPinned = true;
        __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].set(PIN_KEY_DISCUSSION, true);
      }
    },
    toggleWatchlistPin: function toggleWatchlistPin(state) {
      if (state.isWatchlistPinned) {
        state.isWatchlistPinned = false;
        __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].set(PIN_KEY_WATCHLIST, false);
      } else {
        state.isWatchlistPinned = true;
        __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].set(PIN_KEY_WATCHLIST, true);
      }
    },
    toggleSessionHistoryPin: function toggleSessionHistoryPin(state) {
      if (state.isSessionHistoryPinned) {
        state.isSessionHistoryPinned = false;
        __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].set(PIN_KEY_SESSION_HISTORY, false);
      } else {
        state.isSessionHistoryPinned = true;
        __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].set(PIN_KEY_SESSION_HISTORY, true);
      }
    },
    toggleMarketHistoryPin: function toggleMarketHistoryPin(state) {
      if (state.isMarketHistoryPinned) {
        state.isMarketHistoryPinned = false;
        __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].set(PIN_KEY_MARKET_HISTORY, false);
      } else {
        state.isMarketHistoryPinned = true;
        __WEBPACK_IMPORTED_MODULE_15__helpers_localStorage__["a" /* default */].set(PIN_KEY_MARKET_HISTORY, true);
      }
    },
    clearRelatedContracts: function clearRelatedContracts(state) {
      state.relatedContracts = [];
    },
    setRelatedContracts: function setRelatedContracts(state, data) {
      state.relatedContracts = data;
    },
    setRelatedProducts: function setRelatedProducts(state, data) {
      state.relatedProducts = {
        active: data.activeMarkets || [],
        closed: data.closedMarkets || []
      };
    },
    setMarketTopComments: function setMarketTopComments(state, _ref2) {
      var marketId = _ref2.marketId,
          data = _ref2.data;

      state.marketTopCommentsMarketId = marketId;
      state.marketTopCommentsLoaded = true;
      state.marketTopCommentsLoading = false;
      state.marketTopComments = data || createDefaultTopComments();
    },
    setMarketTopCommentsLoading: function setMarketTopCommentsLoading(state, payload) {
      state.marketTopCommentsLoading = payload;
    },
    clearMarketTopComments: function clearMarketTopComments(state) {
      state.marketTopComments = createDefaultTopComments();
      state.marketTopCommentsMarketId = null;
      state.marketTopCommentsLoaded = false;
      state.marketTopCommentsLoading = false;
    },
    incrReloadHistoryToggle: function incrReloadHistoryToggle(state) {
      state.reloadHistoryToggle += 1;
    },
    toggleOpenPinSection: function toggleOpenPinSection(state, name) {
      var opened = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.pinnedOpened));
      if (opened.includes(name)) {
        state.pinnedOpened = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(opened.filter(function (i) {
          return i !== name;
        })));
      } else {
        state.pinnedOpened = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(opened), [name]);
      }
    },
    pushSessionHistoryContract: function pushSessionHistoryContract(state, data) {
      state.sessionHistory = __WEBPACK_IMPORTED_MODULE_16__helpers_sessionHistory__["b" /* default */].pushContract(data);
    },
    setActiveMarketTab: function setActiveMarketTab(state, tab) {
      state.activeMarketTab = tab;
    }
  },
  actions: {
    setActiveMarketTab: function setActiveMarketTab(_ref3, tab) {
      var commit = _ref3.commit;

      commit('setActiveMarketTab', tab);
    },
    updateHeaderHeightclearMarket: function updateHeaderHeightclearMarket(_ref4) {
      var commit = _ref4.commit;

      commit('setMarket', {});
      commit('setContracts', []);
    },
    clearMarketEngineBusyMessage: function clearMarketEngineBusyMessage(_ref5) {
      var commit = _ref5.commit;

      commit('setMarketEngineBusyMessage', {
        isEngineBusy: false,
        isEngineBusyMessage: null
      });
    },
    getMarket: function getMarket(_ref6, _ref7) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch,
          state = _ref6.state;
      var marketId = _ref7.marketId,
          _ref7$commentThreadId = _ref7.commentThreadId,
          commentThreadId = _ref7$commentThreadId === undefined ? '' : _ref7$commentThreadId,
          _ref7$skipCache = _ref7.skipCache,
          skipCache = _ref7$skipCache === undefined ? false : _ref7$skipCache,
          _ref7$modifyState = _ref7.modifyState,
          modifyState = _ref7$modifyState === undefined ? true : _ref7$modifyState;

      commit('setMarketLoadError', false);
      if (!skipCache && state.market !== null && state.market.marketId === marketId) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(state.market);
      }
      var marketData = {};
      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getMarket(marketId, commentThreadId).then(function (response) {
        marketData = response.data;
      }).then(function () {
        return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getMarketContracts(marketId);
      }).then(function (response) {
        marketData.contracts = response.data;
        if (modifyState) {
          commit('setContracts', marketData.contracts);
          commit('setMarket', marketData);
        }
        return marketData;
      }).catch(function (error) {
        if (modifyState) {
          commit('setMarketLoadError', true);
          dispatch('clearMarket');
        }
        throw error;
      });
    },
    getMarketContracts: function getMarketContracts(_ref8, marketId) {
      var commit = _ref8.commit,
          state = _ref8.state;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getMarketContracts(marketId).then(function (response) {
        commit('setContracts', response.data);
        commit('setMarket', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.market, {
          contracts: response.data
        }));
        return response.data;
      });
    },
    getMarketRules: function getMarketRules(_ref9, marketId) {
      var commit = _ref9.commit;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getMarketRules(marketId).then(function (response) {
        return response.data;
      });
    },
    getContract: function getContract(_ref10, contractId) {
      var commit = _ref10.commit,
          state = _ref10.state;

      if (state.contract !== null && state.contract.contractId === contractId) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(state.contract);
      }
      if (state.contracts !== null) {
        var contract = state.contracts.find(function (c) {
          return c.contractId === contractId;
        });
        if (typeof contract !== 'undefined') {
          commit('setContract', contract);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(contract);
        }
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
    },
    getMarketContractsStats: function getMarketContractsStats(_ref11, marketId) {
      var commit = _ref11.commit,
          dispatch = _ref11.dispatch;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getMarketContractsStats(marketId).then(function (response) {
        commit('setMarketContractsStats', response.data);
        return response.data;
      }).catch(function () {
        dispatch('clearMarketContractsStats');
      });
    },
    clearMarketContractsStats: function clearMarketContractsStats(_ref12) {
      var commit = _ref12.commit;

      commit('clearMarketContractsStats');
    },
    resetHistory: function resetHistory(_ref13) {
      var commit = _ref13.commit;

      commit('resetHistory');
    },
    getMarketHistory: function getMarketHistory(_ref14, _ref15) {
      var state = _ref14.state,
          commit = _ref14.commit;
      var marketId = _ref15.marketId,
          _ref15$reload = _ref15.reload,
          reload = _ref15$reload === undefined ? false : _ref15$reload;

      var history = state.history;
      if (history !== null && history.marketId === marketId && !reload) {
        return history.data;
      }
      // on new market but in history old data
      commit('resetHistory');
      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].profile.getTradeHistory(ITEMS_PER_HISTORY_PAGE, 1, marketId).then(function (response) {
        commit('updateHistory', {
          data: response.data,
          marketId: marketId
        });
        return response.data;
      });
    },
    getRelatedMarkets: function getRelatedMarkets(_ref16, marketId) {
      var commit = _ref16.commit;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getMarketRelated(marketId).then(function (response) {
        var data = response.data.slice(0, MAX_RELATED_MARKETS);
        commit('setRelatedMarkets', data);
        return data;
      });
    },
    clearRelatedMarkets: function clearRelatedMarkets(_ref17) {
      var commit = _ref17.commit;

      commit('clearRelatedMarkets');
    },
    updateMarketFromNotification: function updateMarketFromNotification(_ref18, payload) {
      var commit = _ref18.commit,
          dispatch = _ref18.dispatch,
          state = _ref18.state;

      var marketId = payload.MarketId;
      if (state.market !== null && state.market.marketId === marketId) {
        commit('updateMarketFromNotification', payload);
        // debounceGetMarket(dispatch, marketId);
      }
    },
    setMarketEngineBusyMessage: function setMarketEngineBusyMessage(_ref19, payload) {
      var commit = _ref19.commit;

      commit('setMarketEngineBusyMessage', payload);
    },
    updateRelatedMarketFromNotification: function updateRelatedMarketFromNotification(_ref20, payload) {
      var commit = _ref20.commit;

      commit('updateRelatedMarketFromNotification', payload);
    },
    updateRelatedContractFromNotification: function updateRelatedContractFromNotification(_ref21, payload) {
      var commit = _ref21.commit;

      commit('updateRelatedContractFromNotification', payload);
    },
    updateContractFromNotification: function updateContractFromNotification(_ref22, payload) {
      var commit = _ref22.commit;

      commit('updateContractFromNotification', payload);
    },
    updateMapOverviewDataFromNotification: function updateMapOverviewDataFromNotification(_ref23, payload) {
      var commit = _ref23.commit;

      commit('updateMapOverviewDataFromNotification', payload);
    },
    updateMapOverviewDataSenateFromNotification: function updateMapOverviewDataSenateFromNotification(_ref24, payload) {
      var commit = _ref24.commit;

      commit('updateMapOverviewDataSenateFromNotification', payload);
    },
    openRules: function openRules(_ref25) {
      var commit = _ref25.commit;
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      commit('setOpenRules', payload);
    },
    setMarket: function setMarket(_ref26, market) {
      var commit = _ref26.commit;

      commit('setMarket', market);
    },
    setContracts: function setContracts(_ref27, contracts) {
      var commit = _ref27.commit;

      commit('setContracts', contracts);
    },
    setMarketLoadError: function setMarketLoadError(_ref28, flag) {
      var commit = _ref28.commit;

      commit('setMarketLoadError', flag);
    },
    setChartTimeline: function setChartTimeline(_ref29, payload) {
      var commit = _ref29.commit;

      commit('setChartTimeline', payload);
    },
    setChartType: function setChartType(_ref30, payload) {
      var commit = _ref30.commit;

      commit('setChartType', payload);
    },
    getMapOverviewData: function getMapOverviewData(_ref31) {
      var commit = _ref31.commit;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].map.getContracts().then(function (response) {
        commit('setMapOverviewData', response.data);
        return response.data;
      });
    },
    getMapStateData: function getMapStateData(_ref32) {
      var commit = _ref32.commit;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].map.getStateData().then(function (response) {
        var data = (response.data || []).reduce(function (obj, item) {
          var stateCode = item.marketName.split(' ')[4];
          var stateName = __WEBPACK_IMPORTED_MODULE_14__constants__["a" /* default */].statesCodeToNameMap[stateCode];
          var stateVotes = __WEBPACK_IMPORTED_MODULE_14__constants__["a" /* default */].statesCodeToElectoralVotesMap[stateCode];
          obj[stateCode] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, item, {
            stateVotes: stateVotes,
            stateCode: stateCode,
            stateName: stateName
          });
          return obj;
        }, {});
        commit('setMapStateData', data);
        return data;
      });
    },
    getMapOverviewDataSenate: function getMapOverviewDataSenate(_ref33) {
      var commit = _ref33.commit;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].map.getContractsSenate().then(function (response) {
        commit('setMapOverviewDataSenate', response.data);
        return response.data;
      });
    },
    getMapStateDataSenate: function getMapStateDataSenate(_ref34) {
      var commit = _ref34.commit;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].map.getStateDataSenate().then(function (response) {
        var data = (response.data || []).reduce(function (obj, item) {
          var stateCode = item.marketName.match(/\b[A-Z]{2}\b/)[0];
          var stateName = __WEBPACK_IMPORTED_MODULE_14__constants__["a" /* default */].statesCodeToNameMap[stateCode];
          var stateVotes = __WEBPACK_IMPORTED_MODULE_14__constants__["a" /* default */].statesCodeToElectoralVotesMap[stateCode];
          var result = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, item, {
            stateVotes: stateVotes,
            stateCode: stateCode,
            stateName: stateName
          });
          if (stateCode === 'GA') {
            if (item.marketId === 6651) {
              obj[stateCode] = result;
            } else {
              obj.GA2 = result;
            }
          }
          obj[stateCode] = result;
          return obj;
        }, {});
        commit('setMapStateDataSenate', data);
        return data;
      });
    },
    setMarketMapTooltipVisible: function setMarketMapTooltipVisible(_ref35, flag) {
      var commit = _ref35.commit;

      commit('setMarketMapTooltipVisible', flag);
    },
    getCommentThread: function getCommentThread(_ref36, _ref37) {
      var commit = _ref36.commit;
      var marketId = _ref37.marketId,
          threadId = _ref37.threadId;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getCommentThread({ marketId: marketId, threadId: threadId }).then(function (response) {
        return response.data;
      });
    },
    getMarketTopComments: function getMarketTopComments(_ref38, marketId) {
      var commit = _ref38.commit;

      if (!marketId) {
        commit('clearMarketTopComments');
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(createDefaultTopComments());
      }

      commit('setMarketTopCommentsLoading', true);

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getMarketTopComments(marketId).then(function (response) {
        var data = response.data || createDefaultTopComments();
        commit('setMarketTopComments', {
          marketId: marketId,
          data: data
        });
        return data;
      }).catch(function () {
        commit('clearMarketTopComments');
        return createDefaultTopComments();
      });
    },

    getMarketSummaryData: __WEBPACK_IMPORTED_MODULE_9_lodash_throttle___default()(function (_ref39) {
      var state = _ref39.state,
          commit = _ref39.commit;

      var _ref40 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref40$reset = _ref40.reset,
          reset = _ref40$reset === undefined ? false : _ref40$reset;

      var page = reset ? 1 : state.marketSummaryData.page + 1;
      var canLoadMore = reset ? true : state.marketSummaryData.canLoadMore;
      if (canLoadMore) {
        return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].browse.getMarketSummaryData(page, state.marketSummaryDataDate).then(function (response) {
          var data = response.data;
          if (reset) commit('resetMarketSummaryData');
          commit('setMarketSummaryLimitExceeded', '');
          commit('updateMarketSummaryData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, { page: page }));
          return data;
        }).catch(function (error) {
          var response = error.response;
          if (response && response.data) {
            var data = Array.isArray(response.data) ? response.data[0] : response.data;
            var showLimitExceeded = data.code && data.code === 'LIMIT_EXCEEDED';
            var message = showLimitExceeded ? data.message : '';
            commit('setMarketSummaryLimitExceeded', message);
          }
        });
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(1);
    }, SUMMARY_DATA_THROTTLE_TIME),
    resetMarketSummaryData: function resetMarketSummaryData(_ref41) {
      var commit = _ref41.commit;

      commit('resetMarketSummaryData');
    },
    clearMarketTopComments: function clearMarketTopComments(_ref42) {
      var commit = _ref42.commit;

      commit('clearMarketTopComments');
    },
    setMarketSummaryDataDate: function setMarketSummaryDataDate(_ref43, value) {
      var commit = _ref43.commit;

      commit('setMarketSummaryDataDate', value);
    },
    toggleDiscussionPin: function toggleDiscussionPin(_ref44) {
      var commit = _ref44.commit;

      commit('toggleDiscussionPin');
    },
    toggleWatchlistPin: function toggleWatchlistPin(_ref45) {
      var commit = _ref45.commit;

      commit('toggleWatchlistPin');
    },
    toggleSessionHistoryPin: function toggleSessionHistoryPin(_ref46) {
      var commit = _ref46.commit;

      commit('toggleSessionHistoryPin');
    },
    toggleMarketHistoryPin: function toggleMarketHistoryPin(_ref47) {
      var commit = _ref47.commit;

      commit('toggleMarketHistoryPin');
    },
    clearRelatedContracts: function clearRelatedContracts(_ref48) {
      var commit = _ref48.commit;

      commit('clearRelatedContracts');
    },
    getRelatedContracts: function getRelatedContracts(_ref49, contractId) {
      var commit = _ref49.commit;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getRelatedContracts(contractId).then(function (response) {
        var data = response.data;
        commit('setRelatedContracts', data);
        return data;
      });
    },
    getRelatedProducts: function getRelatedProducts(_ref50, marketId) {
      var commit = _ref50.commit;

      return __WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].market.getMarketRelatedProducts(marketId).then(function (response) {
        var data = response.data;
        commit('setRelatedProducts', data);
        return data;
      });
    },
    incrReloadHistoryToggle: function incrReloadHistoryToggle(_ref51) {
      var commit = _ref51.commit;

      commit('incrReloadHistoryToggle');
    },
    toggleOpenPinSection: function toggleOpenPinSection(_ref52, name) {
      var commit = _ref52.commit;

      commit('toggleOpenPinSection', name);
    },
    pushSessionHistoryContract: function pushSessionHistoryContract(_ref53, data) {
      var commit = _ref53.commit;

      commit('pushSessionHistoryContract', data);
    },
    clearMarket: function clearMarket(_ref54) {
      var commit = _ref54.commit;

      commit('setMarket', {});
      commit('setContracts', []);
      commit('clearMarketTopComments');
    }
  }
});

/***/ }),

/***/ "L3N8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getFaqs: function getFaqs() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/about/faqs');
  },
  getSitemap: function getSitemap() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/About/sitemap');
  }
});

/***/ }),

/***/ "L6pp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "L8Dv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_contentLoader__ = __webpack_require__("P71F");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_contentLoader__["a" /* default */]],
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    return {
      items: [],
      swiperOptions: {
        loop: false,
        autoplay: 5000,
        direction: 'horizontal',
        pagination: '.hero-unit-slider__pagination',
        paginationClickable: true
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isShutdownModeOn']), {
    classModifiers: function classModifiers() {
      return {
        'hero-unit-slider': true,
        'hero-unit-slider--shutdown': this.isShutdownModeOn
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getCarousel']), {
    getBannerUrl: function getBannerUrl(banner) {
      if (banner.carouselData.carouselItemButton.url) {
        return banner.carouselData.carouselItemButton.url;
      } else if (banner.carouselData.marketId) {
        return { name: 'market-details', params: { marketId: banner.carouselData.marketId } };
      }
      return {};
    },
    isUrlExternal: function isUrlExternal(banner) {
      var url = banner.carouselData.carouselItemButton.url || '';
      return url.startsWith('http');
    },
    bannerImageStyleModifiers: function bannerImageStyleModifiers(url) {
      if (!url) return {};
      return {
        'background-image': 'url(\'' + url + '\')'
      };
    },
    buttonStyleModifiers: function buttonStyleModifiers(button) {
      var styles = {};
      if (button.backgroundColor) {
        styles.backgroundColor = button.backgroundColor;
        styles.borderColor = button.backgroundColor;
      }
      return styles;
    }
  }),
  created: function created() {
    var _this = this;

    this.getCarousel().then(function (data) {
      _this.items = data;
      _this.isComponentReady = _this.items.length > 0;
    });
  }
});

/***/ }),

/***/ "LDV9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LGCP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LHdv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_forms_checkbox_checkbox_vue__ = __webpack_require__("vXhB");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    validation: {
      type: Object,
      required: true
    }
  },
  components: {
    formCheckbox: __WEBPACK_IMPORTED_MODULE_0__components_forms_checkbox_checkbox_vue__["a" /* default */]
  },
  computed: {
    hasOneUpperLower: function hasOneUpperLower() {
      return this.validation.hasOneLower && this.validation.hasOneUpper;
    }
  }
});

/***/ }),

/***/ "LMIZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.objClass},[_c('span',{staticClass:"market-change-price__value",domProps:{"innerHTML":_vm._s(_vm.changeValue)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LQ9G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"biggest-gains-loader"},[_c('div',{staticClass:"biggest-gains-loader__header"},[_c('div',{staticClass:"biggest-gains-loader__header-text"})]),_vm._v(" "),_c('div',{staticClass:"biggest-gains-loader__content"},[_c('div',{staticClass:"biggest-gains-loader-text-1"}),_vm._v(" "),_c('div',{staticClass:"biggest-gains-loader-text-2"}),_vm._v(" "),_c('div',{staticClass:"biggest-gains-loader-text-3"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LQTn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEPOSIT_METHOD_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isMethodFeeWaived; });
/* unused harmony export getDepositMethodTitle */
/* unused harmony export getDepositMethodTimeframe */
/* unused harmony export getDepositMethodSubtitle */
/* harmony export (immutable) */ __webpack_exports__["b"] = buildDepositMethodTabs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


var DEPOSIT_METHOD_TYPE = {
  CREDIT_CARD: 1,
  CASH: 2,
  CRYPTO: 3,
  ONLINE_BANKING: 4,
  TRANSFERS: 5
};

var isMethodFeeWaived = function isMethodFeeWaived(method) {
  return !!method && method.feeState === 1 && method.feePercentage !== null && method.feePercentage !== undefined && method.feePercentage > 0;
};

function getDepositMethodTitle(method) {
  switch (method.type) {
    case DEPOSIT_METHOD_TYPE.ONLINE_BANKING:
      return 'Online Banking';
    case DEPOSIT_METHOD_TYPE.CREDIT_CARD:
      return 'Credit Card';
    case DEPOSIT_METHOD_TYPE.CASH:
      return 'Cash';
    case DEPOSIT_METHOD_TYPE.CRYPTO:
      return method.description || 'USDC';
    case DEPOSIT_METHOD_TYPE.TRANSFERS:
      return 'Bank Transfers';
    default:
      return '';
  }
}

function getDepositMethodTimeframe(method) {
  switch (method.type) {
    case DEPOSIT_METHOD_TYPE.ONLINE_BANKING:
    case DEPOSIT_METHOD_TYPE.CASH:
    case DEPOSIT_METHOD_TYPE.CREDIT_CARD:
      return 'Instant';
    case DEPOSIT_METHOD_TYPE.TRANSFERS:
    case DEPOSIT_METHOD_TYPE.CRYPTO:
      return 'Time Varies';
    default:
      return '';
  }
}

function getDepositMethodSubtitle(method) {
  var feePercent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])((method.feePercentage || 0) * 100);
  var feeText = 'No Fee';
  if (feePercent) {
    feeText = isMethodFeeWaived(method) ? '<s>' + feePercent + '% Fee</s> Free' : feePercent + '% Fee';
  }
  var timeframe = getDepositMethodTimeframe(method);
  return timeframe ? timeframe + ' \u2022 ' + feeText : feeText;
}

function buildDepositMethodTabs(methods) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$allowedTypes = _ref.allowedTypes,
      allowedTypes = _ref$allowedTypes === undefined ? null : _ref$allowedTypes;

  var results = [];
  (methods || []).forEach(function (method) {
    if (allowedTypes && !allowedTypes.includes(method.type)) {
      return;
    }
    results.push({
      name: method.type,
      title: getDepositMethodTitle(method),
      subtitle: getDepositMethodSubtitle(method)
    });
  });
  return results;
}

/***/ }),

/***/ "LTL3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_brand_name_js__ = __webpack_require__("6Zmy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0f6b6b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_brand_name_vue__ = __webpack_require__("7P0N");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_brand_name_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0f6b6b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_brand_name_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Lhbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-markets"},[(_vm.isLayoutDesktop)?[_c('div',{staticClass:"page-markets__desktop-header"},[(_vm.showInitialSpinner)?_c('div',{staticClass:"page-markets__desktop-header-skeleton"},[_c('div',{staticClass:"page-markets__desktop-header-line page-markets__desktop-header-line--title"}),_vm._v(" "),_vm._m(0)]):[_c('market-list-desktop-header',{ref:"desktopHeader",attrs:{"title":_vm.currentHeaderName,"count":_vm.filteredMarkets.totalCount,"layout":_vm.marketDisplay,"embedded":_vm.embedded},on:{"toggle":_vm.onLayoutToggle}})]],2)]:_c('div',{staticClass:"page-markets__mobile-header-wrapper"},[_c('div',{staticClass:"page-markets__mobile-header-container"},[(_vm.showInitialSpinner)?_c('div',{staticClass:"page-markets__mobile-header-skeleton"},[_c('div',{staticClass:"page-markets__mobile-header-line page-markets__mobile-header-line--title"}),_vm._v(" "),_c('div',{staticClass:"page-markets__mobile-header-line"})]):[_c('market-section-header',{ref:"mobileHeader",staticClass:"page-markets__mobile-header",attrs:{"title":_vm.currentHeaderName,"count":_vm.filteredMarkets.totalCount,"embedded":_vm.embedded}}),_vm._v(" "),_c('market-filters-mobile',{staticClass:"page-markets__mobile-filters",attrs:{"embedded":_vm.embedded}})]],2)]),_vm._v(" "),(_vm.filteredMarkets.canLoadPrevious && _vm.marketsPageInitialLoadDone)?_c('div',{ref:"loadPreviousSentinel",staticClass:"page-markets__load-more-sentinel"},[(_vm.isLoadingPrevious && _vm.showSpinner)?_c('div',{staticClass:"page-markets__spinner"}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.showInitialSpinner)?_c('div',{staticClass:"page-markets__grid page-markets__grid--loading"},_vm._l((_vm.marketSkeletonCount),function(index){return _c('div',{key:index,staticClass:"page-markets__grid-item"},[_vm._m(1,true)])}),0):(_vm.items.length > 0)?_c('div',{staticClass:"page-markets__grid"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"page-markets__grid-item",attrs:{"data-page-boundary":item.pageBoundary || null}},[_c('market-list-item',{key:item.marketId,attrs:{"watchIcon":item.isMarketWatched,"layout":_vm.marketDisplay,"market":item}})],1)}),0):_vm._e(),_vm._v(" "),(_vm.nextPageRouteLocation)?_c('router-link',{staticClass:"page-markets__next-page-link",attrs:{"to":_vm.nextPageRouteLocation}},[_vm._v("\n  Next Page\n")]):_vm._e(),_vm._v(" "),(_vm.filteredMarkets.canLoadMore && _vm.marketsPageInitialLoadDone)?_c('div',{ref:"loadMoreSentinel",staticClass:"page-markets__load-more-sentinel"},[(_vm.isInfiniteLoading && _vm.showSpinner)?_c('div',{staticClass:"page-markets__spinner"}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.showNoMarketsMessage)?_c('div',{staticClass:"page-markets__no-markets-found"},[_vm._v("\n  No Markets Found. "),_c('br'),_vm._v("\n  Please Adjust Filters\n")]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-markets__desktop-header-filters"},[_c('div',{staticClass:"page-markets__desktop-header-line page-markets__desktop-header-line--label"}),_vm._v(" "),_c('div',{staticClass:"page-markets__desktop-header-chip"}),_vm._v(" "),_c('div',{staticClass:"page-markets__desktop-header-chip"}),_vm._v(" "),_c('div',{staticClass:"page-markets__desktop-header-chip"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-markets__skeleton-card"},[_c('div',{staticClass:"page-markets__skeleton-card-inner"},[_c('div',{staticClass:"page-markets__skeleton-image"}),_vm._v(" "),_c('div',{staticClass:"page-markets__skeleton-main"},[_c('div',{staticClass:"page-markets__skeleton-title"}),_vm._v(" "),_c('div',{staticClass:"page-markets__skeleton-contract page-markets__skeleton-contract--primary"}),_vm._v(" "),_c('div',{staticClass:"page-markets__skeleton-contract"}),_vm._v(" "),_c('div',{staticClass:"page-markets__skeleton-meta"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LkCa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup-generic"},[(_vm.currentPopupOptions.icon)?_c('div',{staticClass:"popup-generic__icon"},[(_vm.currentPopupOptions.icon === 'error')?_c('img',{attrs:{"src":__webpack_require__("z6fO"),"alt":""}}):_vm._e(),_vm._v(" "),(_vm.currentPopupOptions.icon === 'success')?_c('img',{attrs:{"src":__webpack_require__("ihRI"),"alt":""}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.currentPopupOptions.iconTitle)?_c('h5',{staticClass:"popup-generic__icon-title",class:("popup-generic__icon-title--" + (_vm.currentPopupOptions.icon))},[_vm._v("\n    "+_vm._s(_vm.currentPopupOptions.iconTitle)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"popup-generic__content"},[_vm._t("content")],2),_vm._v(" "),(_vm.currentPopupOptions.actionCallback)?_c('div',{staticClass:"popup-generic__button-wrapper"},[_c('button',{staticClass:"popup-generic__button button button--large button--primary button--full-width",on:{"click":function($event){$event.preventDefault();return _vm.currentPopupOptions.actionCallback()}}},[_vm._v("\n      "+_vm._s(_vm.currentPopupOptions.actionTitle)+"\n    ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LmU5":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI3OCIgdmlld0JveD0iMCAwIDgwIDc4Ij4KICAgIDxnIGZpbGw9IiMyNjNCM0YiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgPHBhdGggZD0iTTQwLjg0MiAwQTEuODM5IDEuODM5IDAgMCAwIDM5IDEuODV2MzYuNjQ1YzAgMS4wMjguODE5IDEuODUgMS44NDIgMS44NWgzNi40OTZhMS44MzkgMS44MzkgMCAwIDAgMS44NDMtMS44NWMwLTkuNC0zLjQwNi0xOC40NDQtOS42MDMtMjUuNDg5QzYyLjMgNC43NDYgNTEuODIzIDAgNDAuODQyIDB6bTEuODQzIDM2LjY0NVYzLjc1NmEzNC43MiAzNC43MiAwIDAgMSAyNC4xMzggMTEuNzE3YzUuMTkzIDUuODg2IDguMjA4IDEzLjM2IDguNjM2IDIxLjE3Mkg0Mi42ODV6Ii8+CiAgICAgICAgPHBhdGggZD0iTTY0LjAwNiA0NS43ODZjMC0uNzk2LS42MzQtMS40MzMtMS40MjctMS40MzNIMzMuNDUzdi0yOS4yNmMwLS43OTYtLjYzNS0xLjQzMy0xLjQyOC0xLjQzM0MxNC4zNzYgMTMuNjYuMDI5IDI4LjA2Ni4wMjkgNDUuNzg2YzAgMTcuNzA3IDE0LjM0NyAzMi4xMjcgMzEuOTk2IDMyLjEyN3MzMS45ODEtMTQuNDIgMzEuOTgxLTMyLjEyN3ptLTMxLjk4MSAyOS4yNmMtMTYuMDYzIDAtMjkuMTQtMTMuMTMxLTI5LjE0LTI5LjI2IDAtMTUuNjUgMTIuMjk5LTI4LjQ3NyAyNy43MTMtMjkuMjN2MjkuMjE2YzAgLjc5Ni42MzQgMS40MzMgMS40MjcgMS40MzNoMjkuMDk4Yy0uNzUgMTUuNDc3LTEzLjUxMSAyNy44NDEtMjkuMDk4IDI3Ljg0MXoiLz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "LoC7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_dataLayer__ = __webpack_require__("k37b");



var DWELL_MS = 5000;
var INTERACTION_EVENTS = ['click', 'mouseover', 'touchstart', 'scroll'];

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.previewTracking = {
      firstSlotDone: false,
      firedForFirstSlot: false,
      dwellTimer: null,
      observer: null,
      interactionHandler: null,
      scrollFallbackTarget: null,
      scrollFallbackHandler: null,
      rafPending: false,
      lastAdvanceReason: '',
      currentGUID: ''
    };
  },

  watch: {
    selected: function selected(newItem) {
      this.handlePreviewSelectionChanged(newItem);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.teardownFirstStoryTracking();
  },

  methods: {
    handlePreviewSelectionChanged: function handlePreviewSelectionChanged(newItem) {
      var _this = this;

      this.teardownFirstStoryTracking();
      if (!newItem) return;
      if (!this.previewTracking.firstSlotDone) {
        this.previewTracking.firstSlotDone = true;
        this.$nextTick(function () {
          _this.setupFirstStoryTracking();
        });
      } else {
        // The shared <tabs> component always
        // auto-emits an initial tabChange created() even when the resolved tab is already current
        var reason = this.previewTracking.lastAdvanceReason;
        this.previewTracking.lastAdvanceReason = '';
        if (!reason) return;
        this.$nextTick(function () {
          _this.firePreviewUniqueView();
        });
      }
    },
    setupFirstStoryTracking: function setupFirstStoryTracking() {
      var _this2 = this;

      var activeStoryEl = this.getActiveStoryElement();
      if (!activeStoryEl) return;
      var state = this.previewTracking;
      state.firedForFirstSlot = false;

      var fire = function fire() {
        if (state.firedForFirstSlot) return;
        state.firedForFirstSlot = true;
        _this2.teardownFirstStoryTracking();
        _this2.firePreviewUniqueView();
      };

      var onInteraction = function onInteraction() {
        return fire();
      };
      state.interactionHandler = onInteraction;
      INTERACTION_EVENTS.forEach(function (eventName) {
        _this2.$el.addEventListener(eventName, onInteraction, { capture: true, passive: true });
      });

      if ('IntersectionObserver' in window) {
        state.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (!state.dwellTimer) {
                state.dwellTimer = setTimeout(fire, DWELL_MS);
              }
            } else if (state.dwellTimer) {
              clearTimeout(state.dwellTimer);
              state.dwellTimer = null;
            }
          });
        }, { root: null, threshold: 0 });
        state.observer.observe(activeStoryEl);
      } else {
        state.scrollFallbackTarget = activeStoryEl;
        state.scrollFallbackHandler = function () {
          if (state.rafPending) return;
          state.rafPending = true;
          window.requestAnimationFrame(function () {
            state.rafPending = false;
            if (!state.scrollFallbackTarget) return;
            var rect = state.scrollFallbackTarget.getBoundingClientRect();
            var isVisible = rect.top < window.innerHeight && rect.bottom > 0 && rect.left < window.innerWidth && rect.right > 0;
            if (isVisible) {
              if (!state.dwellTimer) {
                state.dwellTimer = setTimeout(fire, DWELL_MS);
              }
            } else if (state.dwellTimer) {
              clearTimeout(state.dwellTimer);
              state.dwellTimer = null;
            }
          });
        };
        window.addEventListener('scroll', state.scrollFallbackHandler, { passive: true });
        window.addEventListener('resize', state.scrollFallbackHandler);
        state.scrollFallbackHandler();
      }
    },
    teardownFirstStoryTracking: function teardownFirstStoryTracking() {
      var _this3 = this;

      var state = this.previewTracking;
      if (state.dwellTimer) {
        clearTimeout(state.dwellTimer);
        state.dwellTimer = null;
      }
      if (state.observer) {
        state.observer.disconnect();
        state.observer = null;
      }
      if (state.interactionHandler) {
        INTERACTION_EVENTS.forEach(function (eventName) {
          _this3.$el.removeEventListener(eventName, state.interactionHandler, { capture: true });
        });
        state.interactionHandler = null;
      }
      if (state.scrollFallbackHandler) {
        window.removeEventListener('scroll', state.scrollFallbackHandler);
        window.removeEventListener('resize', state.scrollFallbackHandler);
        state.scrollFallbackHandler = null;
      }
      state.scrollFallbackTarget = null;
    },
    getActiveStoryTrackingContext: function getActiveStoryTrackingContext() {
      var item = this.selected;
      var data = item && this.storyMap[item.index];
      if (!data) return {};
      var trackingIdField = this.isLayoutDesktop ? data.cmsDesktopTrackingId : data.cmsMobileTrackingId;

      var _split = (trackingIdField || '').split('-'),
          _split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_split, 2),
          storyId = _split2[0],
          sectionId = _split2[1];

      var sectionType = this.isLayoutDesktop ? 'Desktop' : 'Mobile';
      var activeStoryEl = this.getActiveStoryElement();
      var regionEl = activeStoryEl && activeStoryEl.querySelector('[data-analytics-id]');
      var analyticsIdRaw = regionEl && regionEl.getAttribute('data-analytics-id') || '';

      var _analyticsIdRaw$split = analyticsIdRaw.split(/[-]/),
          _analyticsIdRaw$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_analyticsIdRaw$split, 5),
          storyVersionId = _analyticsIdRaw$split2[1],
          regionId = _analyticsIdRaw$split2[3],
          regionTrackingId = _analyticsIdRaw$split2[4];

      return {
        storyId: storyId,
        storyVersionId: storyVersionId || 0,
        sectionId: sectionId,
        sectionType: sectionType,
        regionId: regionId,
        regionTrackingId: regionTrackingId
      };
    },
    firePreviewUniqueView: function firePreviewUniqueView() {
      var ctx = this.getActiveStoryTrackingContext();
      if (!ctx.storyId) return;
      var previewUniqueViewGUID = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_dataLayer__["f" /* getUniqueViewGUID */])();
      this.previewTracking.currentGUID = previewUniqueViewGUID;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_dataLayer__["g" /* pushPreviewUniqueView */])({
        storyId: ctx.storyId,
        storyVersionId: ctx.storyVersionId,
        sectionId: ctx.sectionId,
        sectionType: ctx.sectionType,
        previewUniqueViewGUID: previewUniqueViewGUID
      });
    },
    fireReadMoreInteraction: function fireReadMoreInteraction() {
      var ctx = this.getActiveStoryTrackingContext();
      if (!ctx.storyId) return;
      var payload = {
        interactionType: __WEBPACK_IMPORTED_MODULE_1__helpers_dataLayer__["e" /* INTERACTION_TYPE */].READ_MORE,
        storyId: ctx.storyId,
        storyVersionId: ctx.storyVersionId,
        sectionId: ctx.sectionId,
        regionId: ctx.regionId,
        regionTrackingId: ctx.regionTrackingId,
        previewUniqueViewGUID: this.previewTracking.currentGUID
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_dataLayer__["d" /* pushStoryInteraction */])(payload);
    }
  }
});

/***/ }),

/***/ "M+zr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_horizontal_sushi_common_betslip_js__ = __webpack_require__("I+ky");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4910596e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_horizontal_sushi_common_betslip_vue__ = __webpack_require__("dR6M");
function injectStyle (ssrContext) {
  __webpack_require__("SRAN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_horizontal_sushi_common_betslip_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4910596e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_horizontal_sushi_common_betslip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M32j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__ = __webpack_require__("GZXJ");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'multiselect',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__["multiselectMixin"], __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__["pointerMixin"], __WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__["a" /* default */]],
  props: {
    name: {
      type: String,
      default: ''
    },
    selectLabel: {
      type: String,
      default: 'Press enter to select'
    },
    selectedLabel: {
      type: String,
      default: 'Selected'
    },
    deselectLabel: {
      type: String,
      default: 'Press enter to remove'
    },
    showLabels: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 99999
    },
    maxHeight: {
      type: Number,
      default: 300
    },
    limitText: {
      type: Function,
      default: function _default(count) {
        return 'and ' + count + ' more';
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    openDirection: {
      type: String,
      default: ''
    },
    showNoResults: {
      type: Boolean,
      default: true
    },
    tabindex: {
      type: Number,
      default: 0
    },
    adjust: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    activate: function activate() {
      var _this = this;

      if (this.isOpen || this.disabled) return;
      if (this.adjust) {
        this.adjustPosition();
      }
      if (this.groupValues && this.pointer === 0 && this.filteredOptions.length) {
        this.pointer = 1;
      }

      this.isOpen = true;
      if (this.searchable) {
        if (!this.preserveSearch) this.search = '';
        this.$nextTick(function () {
          return _this.$refs.search.focus();
        });
      } else {
        this.$el.focus();
      }
      this.$emit('open', this.id);
    },
    addPointerElement: function addPointerElement() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Enter',
          key = _ref.key;

      if (this.filteredOptions.length > 0) {
        this.select(this.filteredOptions[this.pointer], key);
      }
      this.pointerReset();
    },
    pointerSet: function pointerSet(index, option) {
      this.pointer = index;
      this.pointerDirty = true;
      if (this.isIos) {
        this.select(option);
      }
    }
  },
  computed: {
    visibleValue: function visibleValue() {
      return this.multiple ? this.internalValue.slice(0, this.limit) : [];
    },
    deselectLabelText: function deselectLabelText() {
      return this.showLabels ? this.deselectLabel : '';
    },
    selectLabelText: function selectLabelText() {
      return this.showLabels ? this.selectLabel : '';
    },
    selectedLabelText: function selectedLabelText() {
      return this.showLabels ? this.selectedLabel : '';
    },
    inputStyle: function inputStyle() {
      if (this.multiple && this.value && this.value.length) {
        // Hide input by setting the width to 0 allowing it to receive focus
        return this.isOpen ? { width: 'auto' } : { width: '0', position: 'absolute' };
      }
      return {};
    },
    contentStyle: function contentStyle() {
      return this.options.length ? { display: 'inline-block' } : { display: 'block' };
    },
    isAbove: function isAbove() {
      if (this.openDirection === 'above' || this.openDirection === 'top') {
        return true;
      } else if (this.openDirection === 'below' || this.openDirection === 'bottom') {
        return false;
      }
      return this.prefferedOpenDirection === 'above';
    }
  }
});

/***/ }),

/***/ "M8zO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_container_js__ = __webpack_require__("+kDG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19bea2e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_container_vue__ = __webpack_require__("06wT");
function injectStyle (ssrContext) {
  __webpack_require__("rgkE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_container_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19bea2e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_container_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MEHD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['mobileMenuOpened']), {
    classModifiers: function classModifiers() {
      return {
        'hamburger-icon': true,
        'hamburger-icon--opened': this.mobileMenuOpened
      };
    },
    text: function text() {
      return this.mobileMenuOpened ? 'Close' : 'Menu';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['toggleMobileMenu']))
});

/***/ }),

/***/ "MGrt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      type: Number,
      default: 0
    },
    validate: Function,
    initial: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      lastCorrect: this.value,
      min: 5,
      max: 94, // coz 99 - 5
      invalid: false,
      val: 0,
      focused: false
    };
  },

  computed: {
    valueWithCent: function valueWithCent() {
      return this.focused ? this.val : this.val + '\xA2';
    }
  },
  created: function created() {
    this.val = this.value;
  },

  methods: {
    updateValue: function updateValue(value) {
      if (value === '') {
        return;
      }

      var parsed = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(value, 10);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(parsed)) {
        this.$refs.input.value = this.lastCorrect;
        return;
      }

      if ('' + parsed !== value) {
        this.$refs.input.value = this.lastCorrect;
        return;
      }

      if (value > this.max) {
        this.lastCorrect = this.max;
        this.$refs.input.value = this.max;
        return;
      }

      this.lastCorrect = parsed;
    },
    onFocus: function onFocus() {
      this.focused = true;
    },
    onBlur: function onBlur() {
      this.focused = false;
      this.val = this.lastCorrect;

      if (this.$refs.input.value === '') {
        this.val = this.min;
      }
      if (this.lastCorrect < this.min) {
        this.val = this.min;
      }

      if (this.lastCorrect > this.max) {
        this.val = this.max;
      }

      this.$refs.input.value = this.val + '\xA2';
      this.$emit('input', this.val);
    }
  }
});

/***/ }),

/***/ "MI6U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{class:_vm.symbolClassModifiers}),_vm._v(" "),_c('div',{staticClass:"document-to-review__info"},[_c('div',{staticClass:"document-to-review__label-wrapper"},[(_vm.showLabel)?_c('div',{staticClass:"document-to-review__label"},[(_vm.opened)?[_vm._v("Reviewed")]:[_vm._v("Unopened")]],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"document-to-review__label-suffix"},[(_vm.hasSlotSuffix)?[_vm._t("suffix")]:[_vm._v("\n          Doc #"+_vm._s(_vm.num)+"\n        ")]],2)]),_vm._v(" "),(_vm.title)?_c('div',{staticClass:"document-to-review__title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"document-to-review__description"},[_vm._v("\n      "+_vm._s(_vm.description)+"\n    ")]):_vm._e()]),_vm._v(" "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],staticClass:"document-to-review__button",attrs:{"href":_vm.link},on:{"click":_vm.onOpen}},[(_vm.markOpened && _vm.opened)?_c('div',{staticClass:"document-to-review__button-tick"}):[_vm._v("Open")]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MJqx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_item_dashboard_js__ = __webpack_require__("+++F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29a760ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_dashboard_vue__ = __webpack_require__("CLCK");
function injectStyle (ssrContext) {
  __webpack_require__("Gz6C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_item_dashboard_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29a760ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MKka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['button', 'button--large', 'button--submit', 'button--full-width', { 'button--loading': _vm.loading } ],attrs:{"type":_vm.type,"disabled":_vm.disabled || _vm.loading}},[_c('span',{staticClass:"button__label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"button__spinner"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MRVZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_hamburger_icon_js__ = __webpack_require__("MEHD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02088484_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hamburger_icon_vue__ = __webpack_require__("jNuG");
function injectStyle (ssrContext) {
  __webpack_require__("Q6IB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_hamburger_icon_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02088484_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hamburger_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MRk1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insight-panel",class:_vm.openModifier},[_c('div',{staticClass:"insight-panel__wrap"},[_vm._t("default")],2),_vm._v(" "),(_vm.showBottom)?_c('div',{staticClass:"insight-panel__bottom"},[_c('span',{staticClass:"insight-panel__link",class:_vm.moreModifier,on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.text))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MSvJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketDetailPageLoader_vue__ = __webpack_require__("2wse");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_665277e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketDetailPageLoader_vue__ = __webpack_require__("tvXx");
function injectStyle (ssrContext) {
  __webpack_require__("Ed2X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketDetailPageLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_665277e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketDetailPageLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MWul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('h2',{staticClass:"research-widget__title"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"research-widget__content"},[(_vm.shutdown)?[_c('p',{staticClass:"research-widget__para"},[_vm._v("\n        PredictIt started as a project of Victoria University of Wellington, to facilitate research into the way markets forecast events. Now through our application as a federally regulated Event Market platform we are expanding into markets beyond politics.\n      ")]),_vm._v(" "),_c('p',{staticClass:"research-widget__para"},[_vm._v("\n        We are excited for this transition and hope you follow us on Twitter to learn more about future market launches.\n      ")]),_vm._v(" "),_c('button',{staticClass:"button button--medium button--submit",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v("Learn More")])]:[_c('p',{staticClass:"research-widget__para"},[_vm._v("\n        A project of the Prediction Market Research Consortium, PredictIt has been established to facilitate research into the way markets forecast events.\n      ")]),_vm._v(" "),_c('p',{staticClass:"research-widget__para"},[_vm._v("\n        In order to enable researchers to take advantage of the opportunities presented by prediction markets, we make our data available to the academic community at no cost.\n      ")]),_vm._v(" "),_c('div',{staticClass:"research-widget__button"},[_c('button',{staticClass:"button button--medium button--submit",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v("Learn More")])])]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MYxc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"app-privacy-statement"},[_c('div',{staticClass:"app-privacy-statement__inner"},[_c('div',{staticClass:"app-privacy-statement__close",on:{"click":_vm.onHide}}),_vm._v(" "),_c('div',{staticClass:"app-privacy-statement__info"},[_vm._v("\n      By using our site, you acknowledge that you have read and understand our "),_c('router-link',{staticClass:"app-privacy-statement__link",attrs:{"to":{ name: 'privacy-policy' }}},[_vm._v("Privacy Policy")]),_vm._v(".\n    ")],1),_vm._v(" "),_c('div',{staticClass:"app-privacy-statement__agree"},[_c('button',{staticClass:"button button--primary",on:{"click":_vm.onAgree}},[_vm._v("\n        I Agree\n      ")])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MeDD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_accountVerify__["a" /* default */]],
  props: {
    isPopup: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'account-ssn-info-upload': true,
        'account-ssn-info-upload--modal': this.isPopup,
        'account-ssn-info-upload--embedded': !this.isPopup
      }, 'account-ssn-info-upload--' + this.theme, this.theme);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopupOptions', 'setCurrentPopup']), {
    onButtonClick: function onButtonClick() {
      var trigger = this.isPopup ? __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* FORM_TYPE_TRIGGERS */].MODAL : __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* FORM_TYPE_TRIGGERS */].STANDALONE;
      var options = { formType: __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* FORM_TYPE_IDV */].SSN4IDV, trigger: trigger };
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_modals_constants__["a" /* MODALS */].ACCOUNT_VERIFY);
      this.setCurrentPopupOptions(options);
    }
  })
});

/***/ }),

/***/ "MjTP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MluJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    source: {
      type: Number,
      default: 4
    },
    isPending: {
      type: Boolean,
      default: false
    },
    isPopup: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    isCard: function isCard() {
      return this.type === 'card';
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'account-upload-document': true,
        'account-upload-document--modal': this.isPopup,
        'account-upload-document--embedded': !this.isPopup
      }, 'account-upload-document--' + this.theme, this.theme);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getDocumentUploadLink']), {
    onButtonClick: function onButtonClick() {
      this.getDocumentUploadLink(this.source).then(function (link) {
        window.location.href = link;
      });
    }
  })
});

/***/ }),

/***/ "MnG9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.isYoutube)?[_c('youtube',{ref:"youtubePlayer",staticClass:"video-view__youtube",attrs:{"player-width":_vm.playerWidth,"player-height":_vm.playerHeight,"video-id":_vm.youtubeVideoId,"mute":_vm.mute,"player-vars":_vm.youtubePlayerVars},on:{"ended":_vm.youtubeEnded,"playing":_vm.onPlaying,"paused":_vm.onPaused}})]:(_vm.isVimeo)?[_c('vimeo-player',{staticClass:"video-view__vimeo",attrs:{"video-id":_vm.vimeoVideoId,"autoplay":_vm.autoPlay,"loop":_vm.loop,"options":_vm.vimeoPlayerVars,"player-width":_vm.playerWidth,"player-height":_vm.playerHeight},on:{"playing":_vm.onPlaying,"paused":_vm.onPaused}})]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Moaq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* eslint-disable no-console */

function set(key, value) {
  var ttl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var data = {
    value: value,
    expires_at: ttl !== null ? (new Date().getTime() + ttl * 1000) / 1 : null
  };

  try {
    localStorage.setItem(key.toString(), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
  } catch (e) {
    console.error(e);
  }
}

function del(key) {
  try {
    localStorage.removeItem(key.toString());
  } catch (e) {
    console.error(e);
  }
}

function get(key, defaultValue) {
  try {
    var data = JSON.parse(localStorage.getItem(key.toString()));
    if (data !== null) {
      if (data.expires_at !== null && data.expires_at < new Date().getTime()) {
        localStorage.removeItem(key.toString());
      } else {
        return data.value;
      }
    }
  } catch (e) {
    console.error(e);
    del(key);
  }
  return defaultValue || null;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  set: set,
  get: get,
  del: del
});

/***/ }),

/***/ "Mq7P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wallet_add_funds_bank_transfer_components_bank_account_bank_account_vue__ = __webpack_require__("5r1F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    bankAccount: __WEBPACK_IMPORTED_MODULE_2__components_wallet_add_funds_bank_transfer_components_bank_account_bank_account_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('wallet', ['currentDeposit', 'balance']), {
    amountFormatted: function amountFormatted() {
      return '&#36;' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["D" /* priceDisplay */])(this.currentDeposit.amount || 0);
    },
    matchedFormatted: function matchedFormatted() {
      return '&#36;' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["D" /* priceDisplay */])(this.currentDeposit.matched || 0);
    },
    promoAmountFormatted: function promoAmountFormatted() {
      var value = this.currentDeposit.promoAmount || 0;
      return '&#36;' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["D" /* priceDisplay */])(value);
    },
    hasPromotionalCredit: function hasPromotionalCredit() {
      var value = this.currentDeposit.matched || this.currentDeposit.promoAmount || 0;
      return value !== 0;
    },
    leftColClassModifiers: function leftColClassModifiers() {
      return {
        column: true,
        'small-4': this.hasPromotionalCredit,
        'small-6': !this.hasPromotionalCredit,
        deposited__divider: true
      };
    },
    rightColClassModifiers: function rightColClassModifiers() {
      return {
        column: true,
        'small-4': this.hasPromotionalCredit,
        'small-6': !this.hasPromotionalCredit
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['getStatus'])),
  created: function created() {
    this.getStatus(); // reload hasBeenFunded flag when showing Summary
  }
});

/***/ }),

/***/ "MyEa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__("G/BR");



var AEROSYNC_WIDGET_URL = 'https://cdn.sync.aero.inc/2.1.6/aerosync-widget.js';
var AEROSYNC_WIDGET_CONTAINER_ID = 'aerosync-widget-container';
var AEROSYNC_WIDGET_IFRAME_ID = 'aerosync-widget';
var WIDGET_READY_TIMEOUT_MS = 20000;
var SDK_LOAD_TIMEOUT_MS = 15000;
var WIDGET_DEFAULT_HEIGHT_PX = 720;
var WIDGET_DEFAULT_WIDTH_PX = 375;
var WIDGET_EDGE_GAP_PX = 12;
var WIDGET_EXIT_GAP_PX = 10;
var WIDGET_EXIT_HEIGHT_PX = 44;
var WIDGET_OPEN_BODY_CLASS = 'aerosync-widget-open';

var sdkPromise = null;

function setWidgetOpenState(isOpen) {
  if (!document.body) return;
  if (isOpen) {
    document.body.classList.add(WIDGET_OPEN_BODY_CLASS);
  } else {
    document.body.classList.remove(WIDGET_OPEN_BODY_CLASS);
  }
}

function loadSdk() {
  if (window.aerosync && typeof window.aerosync.initWidget === 'function') {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(window.aerosync);
  }
  if (!sdkPromise) {
    // Own this load rather than caching an invalid/unsettled shared script promise.
    sdkPromise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var script = document.createElement('script');
      var settled = false;
      var timer = null;
      var finish = function finish(error) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        script.onload = null;
        script.onerror = null;
        if (error) {
          if (script.parentNode) script.parentNode.removeChild(script);
          reject(error);
        } else {
          resolve(window.aerosync);
        }
      };
      script.type = 'text/javascript';
      script.src = AEROSYNC_WIDGET_URL;
      script.async = true;
      script.onload = function () {
        return finish(window.aerosync && typeof window.aerosync.initWidget === 'function' ? null : new Error('Aerosync widget SDK is unavailable.'));
      };
      script.onerror = function () {
        return finish(new Error('Aerosync widget SDK could not load.'));
      };
      timer = setTimeout(function () {
        return finish(new Error('Aerosync widget SDK timed out.'));
      }, SDK_LOAD_TIMEOUT_MS);
      document.body.appendChild(script);
    }).catch(function (error) {
      sdkPromise = null;
      throw error;
    });
  }
  return sdkPromise;
}

function normalizeSuccess(event) {
  var eventData = event && event.data ? event.data : event;
  return {
    connectionId: eventData && eventData.connectionId,
    userReference: eventData && eventData.aeroPassUserUuid
  };
}

function getErrorCode(error) {
  var payload = typeof error === 'string' ? error : error && (error.code || error.message);
  var match = String(payload || '').match(/\b(?:AC|AR)-\d+\b/i);
  return match ? match[0].toUpperCase() : 'UNKNOWN';
}

function getWidgetDimensions() {
  var visualViewport = window.visualViewport;
  var viewportHeight = Math.floor(visualViewport ? visualViewport.height : window.innerHeight);
  var viewportWidth = Math.floor(visualViewport ? visualViewport.width : window.innerWidth);
  var viewportTop = Math.floor(visualViewport ? visualViewport.offsetTop : 0);
  var availableTop = viewportTop + WIDGET_EDGE_GAP_PX;
  var availableBottom = viewportTop + viewportHeight - WIDGET_EDGE_GAP_PX;
  var availableHeight = Math.max(1, availableBottom - availableTop);
  var frameHeight = Math.max(1, Math.min(WIDGET_DEFAULT_HEIGHT_PX, availableHeight - WIDGET_EXIT_HEIGHT_PX - WIDGET_EXIT_GAP_PX));
  var frameWidth = Math.max(1, Math.min(WIDGET_DEFAULT_WIDTH_PX, viewportWidth - WIDGET_EDGE_GAP_PX * 2));
  var availableCenter = availableTop + availableHeight / 2;
  var layoutViewportCenter = window.innerHeight / 2;

  return {
    centerOffsetY: Math.round(availableCenter - layoutViewportCenter),
    frameHeight: frameHeight,
    frameWidth: frameWidth
  };
}

function applyWidgetDimensions(shell, clip, iframe) {
  var dimensions = getWidgetDimensions();
  shell.style.transform = 'translateY(' + dimensions.centerOffsetY + 'px)';
  shell.style.width = dimensions.frameWidth + 'px';
  clip.style.height = dimensions.frameHeight + 'px';
  iframe.style.height = dimensions.frameHeight + 'px';
  iframe.style.width = dimensions.frameWidth + 'px';
  return dimensions;
}

function addHostShell(elementId, onClose) {
  var target = document.getElementById(elementId);
  var container = target && target.querySelector('#' + AEROSYNC_WIDGET_CONTAINER_ID);
  var iframe = container && container.querySelector('#' + AEROSYNC_WIDGET_IFRAME_ID);
  if (!container || !iframe) return null;

  var shell = document.createElement('div');
  shell.className = 'bank-links__widget-shell';
  var clip = document.createElement('div');
  clip.className = 'bank-links__widget-clip';
  var exitButton = document.createElement('button');
  exitButton.className = 'bank-links__widget-exit';
  exitButton.type = 'button';
  var exitLabel = document.createElement('span');
  exitLabel.className = 'bank-links__widget-exit-label';
  exitLabel.textContent = 'Return to PredictIt';
  exitButton.appendChild(exitLabel);
  exitButton.addEventListener('click', onClose);

  container.insertBefore(shell, iframe);
  shell.appendChild(clip);
  clip.appendChild(iframe);
  shell.appendChild(exitButton);
  applyWidgetDimensions(shell, clip, iframe);

  var handleViewportChange = function handleViewportChange() {
    if (!shell.parentNode) return;
    applyWidgetDimensions(shell, clip, iframe);
  };
  window.addEventListener('resize', handleViewportChange);
  window.addEventListener('orientationchange', handleViewportChange);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', handleViewportChange);
  }

  return function () {
    exitButton.removeEventListener('click', onClose);
    window.removeEventListener('resize', handleViewportChange);
    window.removeEventListener('orientationchange', handleViewportChange);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', handleViewportChange);
    }
  };
}

function removeInjectedWidget(elementId) {
  var target = document.getElementById(elementId);
  var container = target && target.querySelector('#' + AEROSYNC_WIDGET_CONTAINER_ID);
  if (container && container.parentNode) {
    container.parentNode.removeChild(container);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  load: function load() {
    return loadSdk();
  },
  launch: function launch(_ref) {
    var elementId = _ref.elementId,
        session = _ref.session,
        _onSuccess = _ref.onSuccess,
        onClose = _ref.onClose,
        onError = _ref.onError,
        onReady = _ref.onReady,
        onDiagnostic = _ref.onDiagnostic;

    return loadSdk().then(function (sdk) {
      if (!sdk || !sdk.initWidget) {
        throw new Error('Aerosync widget SDK is unavailable.');
      }

      var controls = null;
      var isTerminal = false;
      var _isReady = false;
      var readyTimer = null;
      var removeShellListener = null;
      var handleEscape = null;

      var clearLifecycle = function clearLifecycle() {
        setWidgetOpenState(false);
        if (readyTimer) {
          clearTimeout(readyTimer);
          readyTimer = null;
        }
        if (handleEscape) {
          document.removeEventListener('keydown', handleEscape);
        }
        if (removeShellListener) {
          removeShellListener();
          removeShellListener = null;
        }
      };
      var markReady = function markReady(source) {
        if (isTerminal || _isReady) return;
        _isReady = true;
        if (readyTimer) {
          clearTimeout(readyTimer);
          readyTimer = null;
        }
        if (onReady) onReady(source);
        if (onDiagnostic) onDiagnostic('widget_ready');
      };
      var cleanup = function cleanup(_ref2) {
        var notifyClose = _ref2.notifyClose,
            source = _ref2.source,
            callExit = _ref2.callExit;

        if (isTerminal) return;
        isTerminal = true;
        clearLifecycle();
        if (controls && callExit && typeof controls.exit === 'function') {
          try {
            controls.exit();
          } catch (error) {
            // The host cleanup below remains authoritative.
          }
        }
        if (controls && typeof controls.destroy === 'function') {
          try {
            controls.destroy();
          } catch (error) {
            // The host cleanup below remains authoritative.
          }
        }
        removeInjectedWidget(elementId);
        if (notifyClose && onDiagnostic) onDiagnostic('widget_exit');
        if (notifyClose && onClose) onClose({ source: source });
      };
      handleEscape = function handleEscape(event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
          event.preventDefault();
          cleanup({ notifyClose: true, source: 'escape', callExit: true });
        }
      };
      var handleHostClose = function handleHostClose() {
        return cleanup({
          notifyClose: true,
          source: 'host',
          callExit: true
        });
      };
      var handleError = function handleError(error) {
        if (isTerminal) return;
        __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].warn('Aerosync widget reported a recoverable error.', {
          code: getErrorCode(error)
        });
        if (onDiagnostic) onDiagnostic('widget_error', getErrorCode(error));
        if (onError) onError(error);
      };
      var handleLoadTimeout = function handleLoadTimeout() {
        if (isTerminal) return;
        var error = { code: 'WIDGET_LOAD_TIMEOUT' };
        __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].warn('Aerosync widget did not become ready.', {
          code: error.code
        });
        cleanup({ notifyClose: false, source: 'timeout', callExit: true });
        if (onDiagnostic) onDiagnostic('widget_error', error.code);
        if (onError) onError(error);
      };

      var initialDimensions = getWidgetDimensions();
      var configuration = {
        elementId: elementId,
        iframeTitle: 'Connect a bank account',
        environment: session.environment,
        token: session.sessionToken,
        aeroPassUserUuid: session.userReference,
        zIndex: '10020',
        style: {
          width: initialDimensions.frameWidth + 'px',
          height: initialDimensions.frameHeight + 'px',
          bgColor: '#000000',
          opacity: 0.66
        },
        onEvent: function onEvent() {
          markReady('event');
          if (onDiagnostic) onDiagnostic('widget_event');
        },
        onLoad: function onLoad() {
          return markReady('load');
        },
        onSuccess: function onSuccess(event) {
          if (!isTerminal && onDiagnostic) onDiagnostic('widget_success');
          if (!isTerminal && _onSuccess) _onSuccess(normalizeSuccess(event));
        },
        onClose: function onClose() {
          return cleanup({
            notifyClose: true,
            source: 'provider',
            callExit: false
          });
        },
        onError: handleError
      };
      if (session.configurationId) {
        configuration.configurationId = session.configurationId;
      }
      if (session.additionalAuthenticationRequired) {
        configuration.handleMFA = true;
        configuration.jobId = session.jobReference;
        configuration.connectionId = session.connectionReference;
      }

      controls = sdk.initWidget(configuration);
      if (!controls || !controls.launch) {
        throw new Error('Aerosync widget controls are unavailable.');
      }
      controls.launch();
      if (onDiagnostic) onDiagnostic('widget_open');
      setWidgetOpenState(true);
      removeShellListener = addHostShell(elementId, handleHostClose);
      document.addEventListener('keydown', handleEscape);
      if (!_isReady) {
        readyTimer = setTimeout(function () {
          handleLoadTimeout();
        }, WIDGET_READY_TIMEOUT_MS);
      }

      return {
        close: handleHostClose,
        exit: handleHostClose,
        destroy: function destroy() {
          cleanup({ notifyClose: false, source: 'destroy', callExit: true });
        },
        isReady: function isReady() {
          return _isReady;
        }
      };
    });
  }
});

/***/ }),

/***/ "MzT2":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "N2Hf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__("c/9r");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    documentData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      openedIndexes: []
    };
  },

  methods: {
    parseDate: function parseDate(document) {
      if (document.displayDocumentCreatedDate) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(document.displayDocumentCreatedDate).format(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["t" /* DEFAULT_DATE_FORMAT */]);
      }
      return "-";
    },
    onOpen: function onOpen(document, index) {
      this.openedIndexes.push(index);
      window.open(document.displayDocumentPath);
    },
    rowClassModifiers: function rowClassModifiers(document, index) {
      return {
        'document-table-view__row': true,
        'document-table-view__row--clickable': true,
        'document-table-view__row--opened': this.openedIndexes.includes(index)
      };
    }
  }
});

/***/ }),

/***/ "N4a4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insight-news"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"insight-news__line"}),_vm._v(" "),_c('insight-panel',{attrs:{"text":"See All","href":_vm.allArticlesLink,"away":_vm.allArticlesAway}},[_c('div',{staticClass:"insight-news__articles"},_vm._l((_vm.analysis),function(link){return _c('insight-link',{key:link.title,attrs:{"title":link.title,"href":_vm.createLink(link.url),"date":_vm.createDate(link.date),"url":link.url}})}),1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insight-news__header"},[_c('div',{staticClass:"insight-news__header-title"},[_vm._v("\n      Insights\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N8e0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NGyh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_footer_facebook_svg__ = __webpack_require__("0tSq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_footer_facebook_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_icons_footer_facebook_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_footer_instagram_svg__ = __webpack_require__("ifvC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_footer_instagram_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_icons_footer_instagram_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_footer_x_svg__ = __webpack_require__("FGQd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_footer_x_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_icons_footer_x_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_footer_youtube_svg__ = __webpack_require__("GeXy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_footer_youtube_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_icons_footer_youtube_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      debugClickCount: 0,
      debugClickThreshold: 7,
      debugClickTimer: null,
      footerExpandRafId: null,
      screenWidth: 1024,
      visibleSections: ['legal'],
      expanded: true,
      items: [{ title: 'Instagram', href: "https://www.instagram.com/PredictIt/", icon: __WEBPACK_IMPORTED_MODULE_4__assets_icons_footer_instagram_svg___default.a }, { title: 'Youtube', href: "https://www.youtube.com/c/predictitofficial", icon: __WEBPACK_IMPORTED_MODULE_6__assets_icons_footer_youtube_svg___default.a }, { title: 'Twitter', href: "https://twitter.com/PredictIt", icon: __WEBPACK_IMPORTED_MODULE_5__assets_icons_footer_x_svg___default.a }, { title: 'Facebook', href: "https://www.facebook.com/PredictIt/", icon: __WEBPACK_IMPORTED_MODULE_3__assets_icons_footer_facebook_svg___default.a }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile', 'leaderboardsEnabled']), {
    classModifiers: function classModifiers() {
      return {
        footer: true,
        'footer--expanded': this.expanded
      };
    },
    isLayoutPhone: function isLayoutPhone() {
      return this.screenWidth < 640;
    },
    footerBottomChevronModifiers: function footerBottomChevronModifiers() {
      return {
        'footer__bottom-chevron': true,
        'footer__bottom-chevron--opened': this.expanded
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('search', ['toggleSearchBar']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('onboarding', ['showOnboardingStep']), {
    handleSecretTap: function handleSecretTap() {
      var _this = this;

      this.debugClickCount += 1;
      clearTimeout(this.debugClickTimer);
      this.debugClickTimer = setTimeout(function () {
        _this.debugClickCount = 0;
      }, 2000);
      if (this.debugClickCount >= this.debugClickThreshold) {
        this.debugClickCount = 0;
        this.$router.push({ name: 'user-status' });
      }
    },
    onDetailsToggle: function onDetailsToggle() {
      this.expanded = !this.expanded;
    },
    onFrame: function onFrame() {
      window.scrollTo(0, document.body.scrollHeight);
      this.footerExpandRafId = window.requestAnimationFrame(this.onFrame);
    },
    onFooterExpandStopFrame: function onFooterExpandStopFrame() {
      if (this.footerExpandRafId !== null) {
        window.cancelAnimationFrame(this.footerExpandRafId);
        this.footerExpandRafId = null;
      }
    },
    onFooterExpandEnter: function onFooterExpandEnter() {
      this.footerExpandRafId = window.requestAnimationFrame(this.onFrame);
    },
    resizeHandler: function resizeHandler() {
      this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
    },
    sectionClassModifiers: function sectionClassModifiers(name) {
      return {
        'footer__section-title': true,
        'footer__section-title--opened': this.visibleSections.includes(name)
      };
    },
    toggleSection: function toggleSection(name) {
      if (!this.isLayoutPhone) return;
      if (this.visibleSections.includes(name)) {
        this.visibleSections = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.visibleSections.filter(function (i) {
          return i !== name;
        })));
      } else {
        this.visibleSections = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.visibleSections), [name]);
      }
    },
    isSectionVisible: function isSectionVisible(name) {
      return !this.isLayoutPhone || this.isLayoutPhone && this.visibleSections.includes(name);
    },
    onLogin: function onLogin() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_modals_constants__["a" /* MODALS */].LOGIN);
    },
    onSignUp: function onSignUp() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_modals_constants__["a" /* MODALS */].REGISTER);
    }
  }),
  created: function created() {
    window.addEventListener('resize', this.resizeHandler);
    this.resizeHandler();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
    this.onFooterExpandStopFrame();
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_custom_polyfill__ = __webpack_require__("SRJW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_custom_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_custom_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_meta__ = __webpack_require__("p3jY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gtm__ = __webpack_require__("Sl4y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gtm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_gtm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_youtube_embed__ = __webpack_require__("5/be");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_clipboard2__ = __webpack_require__("wvfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_generics_vimeo_player_vimeo_player_vue__ = __webpack_require__("9xey");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_app_app_vue__ = __webpack_require__("IYz5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_animated_number_animated_number_vue__ = __webpack_require__("21pt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_market_market_state_tooltip_market_state_tooltip_vue__ = __webpack_require__("Vnj/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__directives_click_outside__ = __webpack_require__("oKYE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__directives_outer_link__ = __webpack_require__("dK2d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__directives_price_display__ = __webpack_require__("P3fZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__directives_large_number__ = __webpack_require__("+88x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__directives_sticky__ = __webpack_require__("1/qb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__directives_asset_cdn_src__ = __webpack_require__("6Bn/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__directives_contract_name__ = __webpack_require__("tmS5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_brand_name_brand_name_vue__ = __webpack_require__("LTL3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_redirect__ = __webpack_require__("FCbW");
/* global Sentry */
/* eslint-disable no-confusing-arrow */
























__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_meta___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_youtube_embed__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('click-outside', __WEBPACK_IMPORTED_MODULE_14__directives_click_outside__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('outer-link', __WEBPACK_IMPORTED_MODULE_15__directives_outer_link__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('price-display', __WEBPACK_IMPORTED_MODULE_16__directives_price_display__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('large-number', __WEBPACK_IMPORTED_MODULE_17__directives_large_number__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('sticky', __WEBPACK_IMPORTED_MODULE_18__directives_sticky__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('asset-cdn-src', __WEBPACK_IMPORTED_MODULE_19__directives_asset_cdn_src__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('contract-name', __WEBPACK_IMPORTED_MODULE_20__directives_contract_name__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('base32', function (value) {
  return value.toString(32).toUpperCase();
});
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('pluralize', function (value) {
  return value.charAt(value.length - 1) === 's' ? value : value + 's';
});
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('usernameDisplay', function (value) {
  var limit = 14;
  var username = value || '';
  if (username.length >= limit) {
    return username.substr(0, limit) + '...';
  }
  return username;
});
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('usernameDisplayLong', function (value) {
  var limit = 20;
  var username = value || '';
  if (username.length >= limit) {
    return username.substr(0, limit) + '...';
  }
  return username;
});
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('ordinal', function (value) {
  var symbols = ['th', 'st', 'nd', 'rd'];
  var v = value % 100;
  var suffix = symbols[(v - 20) % 10] || symbols[v] || symbols[0];
  return '' + value + suffix;
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('brand-name', __WEBPACK_IMPORTED_MODULE_21__components_brand_name_brand_name_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('animated-number', __WEBPACK_IMPORTED_MODULE_12__components_animated_number_animated_number_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('market-state-tooltip', __WEBPACK_IMPORTED_MODULE_13__components_market_market_state_tooltip_market_state_tooltip_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('vimeo-player', __WEBPACK_IMPORTED_MODULE_8__components_generics_vimeo_player_vimeo_player_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_gtm___default.a, {
  debug: "production" === 'development'
});

if (typeof Sentry !== 'undefined' && "production" !== 'development' && __webpack_require__.i({"NODE_ENV":"production","SENTRY_ENVIRONMENT":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","PI_YOUTUBE_LINK":"https://www.youtube.com/c/predictitofficial","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_SIGNALR":false,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","ATTACH_TO_HOME_POPUP_ENABLED":false,"PINNING_ENABLED":false,"DEPOSIT_PROMO_INPUT_BOX_ENABLED":false,"STORIES_PAGE_ENABLED":false,"DISABLE_TWO_FACTOR_PROMPT":true,"COLLEGE_AFFILIATION_ENABLED":true}).SENTRY_DSN) {
  Sentry.init({
    dsn: __webpack_require__.i({"NODE_ENV":"production","SENTRY_ENVIRONMENT":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","PI_YOUTUBE_LINK":"https://www.youtube.com/c/predictitofficial","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_SIGNALR":false,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","ATTACH_TO_HOME_POPUP_ENABLED":false,"PINNING_ENABLED":false,"DEPOSIT_PROMO_INPUT_BOX_ENABLED":false,"STORIES_PAGE_ENABLED":false,"DISABLE_TWO_FACTOR_PROMPT":true,"COLLEGE_AFFILIATION_ENABLED":true}).SENTRY_DSN,
    environment: "production" || "production"
  });
}

var index2RedirectUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_redirect__["a" /* default */])();
if (index2RedirectUrl) {
  window.location.replace(index2RedirectUrl);
} else {
  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */],
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_11__components_app_app_vue__["a" /* default */]);
    }
  });
}

/***/ }),

/***/ "NMl0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_collapsible_panel_js__ = __webpack_require__("6Ngg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3bc0e3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collapsible_panel_vue__ = __webpack_require__("SXEJ");
function injectStyle (ssrContext) {
  __webpack_require__("VYD9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_collapsible_panel_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3bc0e3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collapsible_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NRuh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    depositAmounts: {
      type: Array,
      default: function _default() {
        return [10, 25, 50];
      }
    },
    hasError: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedValue: function formattedValue() {
      if (!this.value && this.value !== 0) return '';
      var str = String(this.value);
      var dotIndex = str.indexOf('.');
      var intPart = (dotIndex >= 0 ? str.slice(0, dotIndex) : str).replace(/\D/g, '');
      var decPart = dotIndex >= 0 ? str.slice(dotIndex) : '';
      var formatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return formatted + decPart;
    }
  },
  methods: {
    handleInput: function handleInput(event) {
      var raw = event.target.value;
      var parts = raw.split('.');
      var intDigits = parts[0].replace(/\D/g, '').slice(0, 9);
      var decDigits = parts.length > 1 ? parts[1].replace(/\D/g, '').slice(0, 2) : null;
      var intFormatted = intDigits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var displayValue = decDigits !== null ? intFormatted + '.' + decDigits : intFormatted;
      var emitValue = decDigits !== null ? intDigits + '.' + decDigits : intDigits;
      event.target.value = displayValue;
      this.$emit('input', emitValue);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      if (_this.$refs.input) {
        _this.$refs.input.focus();
      }
    });
  }
});

/***/ }),

/***/ "NSIw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_snakeCase__ = __webpack_require__("OAqO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_snakeCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_snakeCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex__ = __webpack_require__("KgVm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_dataLayer__ = __webpack_require__("k37b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_recaptcha__ = __webpack_require__("dSZ5");






 /* eslint-disable no-mixed-operators,object-shorthand,max-len */









var CAPTCHA_FIELD = 'g-recaptcha-response';
var CACHE_NAME = 'register';
var MAX_CHARACTERS_USERNAME_PART = 5;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["a" /* formMixin */], __WEBPACK_IMPORTED_MODULE_9__mixins_popupPageModeMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_userAgent__["a" /* default */]],
  data: function data() {
    return {
      // attempt counter for v2 fallback rerenders
      attempt: 1,
      usernameShowed: false,
      usernameSource: '',
      fieldTypePassword: 'password',
      latestEmail: '',
      fields: {
        email: '',
        emailConfirmation: '',
        password: '',
        username: ''
      },
      timeout: null,
      // Pending payload for v2 fallback retry
      pendingPayload: null
    };
  },

  validations: {
    fields: {
      email: __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["b" /* validators */].email,
      emailConfirmation: __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["b" /* validators */].emailConfirmation('email'),
      password: __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["b" /* validators */].password,
      username: __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["b" /* validators */].username
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])('popup', ['formDataCache']), {
    showUsername: function showUsername() {
      if (this.usernameShowed) return true;
      var show = !this.$v.fields.email.$invalid && !this.$v.fields.emailConfirmation.$invalid;
      if (show) {
        if (this.fields.username === '') {
          var email = this.fields.email;
          this.usernameSource = __WEBPACK_IMPORTED_MODULE_4_lodash_snakeCase___default()(email.substr(0, email.indexOf('@')));
          this.fields.username = this.suggestUserName();
          this.$v.fields.username.$touch();
          this.tabTo('_', 'password');
          this.usernameShowed = true;
        }
      } else {
        this.fields.username = '';
      }
      return show;
    },
    registerButtonDisabled: function registerButtonDisabled() {
      return this.invalidOrDisabled;
    }
  }),
  watch: {
    'fields.email': function fieldsEmail(value) {
      if (this.latestEmail && value && value !== this.latestEmail && this.formIsValid() && this.errors.length > 0) {
        this.formReset();
      }
    },
    'fields.emailConfirmation': function fieldsEmailConfirmation(value) {
      if (this.latestEmail && value && value !== this.latestEmail && this.formIsValid() && this.errors.length > 0) {
        this.formReset();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapActions */])('user', ['login', 'register', 'startRegistrationFlow']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentSmallPopup', 'cacheFormData', 'setCurrentPopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapActions */])('profile', ['setProfileStatus']), {
    showPassword: function showPassword() {
      this.fieldTypePassword = this.fieldTypePassword === 'password' ? 'text' : 'password';
    },
    onLoginFail: function onLoginFail() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_modals_constants__["a" /* MODALS */].LOGIN);
    },


    // ========== LOGIN AFTER REGISTRATION ==========
    loginAfterRegistration: function loginAfterRegistration() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _payload, loginV3Token, payload;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Set registration flow flag - 2FA prompt will appear at end of registration flow
                _this.startRegistrationFlow();

                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_13__services_recaptcha__["a" /* default */].executeV3('login');

              case 4:
                loginV3Token = _context.sent;
                payload = (_payload = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, CAPTCHA_FIELD, loginV3Token), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'recaptcha-version', 'v3'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'email', _this.fields.email), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'password', _this.fields.password), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, 'grant_type', 'password'), _payload);


                _this.login(payload).then(function () {
                  // Close registration modal - app.js will handle showing ACCOUNT_VERIFY/Personal Details
                  _this.setCurrentPopup(null);
                  if (_this.isPage) {
                    _this.$router.push({ name: 'home' });
                  }
                }).catch(function (error) {
                  // Check if v3 failed and v2 challenge is needed
                  if (__WEBPACK_IMPORTED_MODULE_13__services_recaptcha__["a" /* default */].isV3ScoreFailure(error)) {
                    _this.pendingPayload = payload;
                    _this.attempt += 1;
                    _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_modals_constants__["a" /* MODALS */].RECAPTCHA_CHALLENGE);
                    _this.setCurrentPopupOptions({
                      attempt: _this.attempt,
                      onVerified: _this.onRecaptchaV2VerifiedForLogin
                    });
                    return;
                  }
                  // Other login error - show login modal
                  _this.onLoginFail();
                });
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

                // Error getting v3 token for login - fall back to login modal
                _this.formEnable();
                _this.onLoginFail();

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 9]]);
      }))();
    },


    // Called when user completes v2 challenge for login phase
    onRecaptchaV2VerifiedForLogin: function onRecaptchaV2VerifiedForLogin(v2Token) {
      var _extends2,
          _this2 = this;

      var payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.pendingPayload, (_extends2 = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, CAPTCHA_FIELD, v2Token), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, 'recaptcha-version', 'v2'), _extends2));

      this.login(payload).then(function () {
        _this2.setCurrentPopup(null);
        if (_this2.isPage) {
          _this2.$router.push({ name: 'home' });
        }
      }).catch(function (error) {
        // v2 login failed - redirect to login modal with error
        // Use setCurrentPopupOptions to pass the error to display
        _this2.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_modals_constants__["a" /* MODALS */].LOGIN);
        _this2.setCurrentPopupOptions({
          loginError: error
        });
      });
    },


    // ========== REGISTRATION SUBMIT ==========
    onSubmit: function onSubmit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var v3Token, payload;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers_dataLayer__["a" /* withMeta */])({
                  event: 'eventTrackerTrigger',
                  category: 'Registration',
                  action: 'submit',
                  label: 'Create Account'
                }));

                if (!(_this3.formIsValid() && _this3.formDisable())) {
                  _context2.next = 14;
                  break;
                }

                _context2.prev = 2;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_13__services_recaptcha__["a" /* default */].executeV3('register');

              case 5:
                v3Token = _context2.sent;
                payload = {
                  recaptchaToken: v3Token,
                  recaptchaVersion: 'v3',
                  email: _this3.fields.email,
                  password: _this3.fields.password,
                  username: _this3.fields.username
                };


                _this3.register(payload).then(function () {
                  return _this3.setProfileStatus({ event: 'registered' });
                }).then(function () {
                  return _this3.loginAfterRegistration();
                }).catch(function (e) {
                  // Check if v3 failed and v2 challenge is needed
                  if (__WEBPACK_IMPORTED_MODULE_13__services_recaptcha__["a" /* default */].isV3ScoreFailure(e)) {
                    _this3.pendingPayload = payload;
                    _this3.attempt += 1;
                    _this3.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_modals_constants__["a" /* MODALS */].RECAPTCHA_CHALLENGE);
                    _this3.setCurrentPopupOptions({
                      attempt: _this3.attempt,
                      onVerified: _this3.onRecaptchaV2VerifiedForRegistration
                    });
                    _this3.formEnable();
                    return;
                  }

                  // Handle other registration errors
                  var data = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(e, 'response.data', []);
                  var errorCodesEmailExist = ['emailAlreadyInUse'];
                  var emailExistsIndex = __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default()(data, function (i) {
                    return i.code && errorCodesEmailExist.includes(i.code);
                  });

                  if (emailExistsIndex !== -1) {
                    _this3.latestEmail = _this3.fields.email;
                    _this3.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_modals_constants__["a" /* MODALS */].ACCOUNT_ALREADY_EXISTS);
                    _this3.setCurrentPopupOptions({ email: _this3.fields.email });
                  } else {
                    _this3.latestEmail = '';
                  }

                  _this3.attempt += 1;
                  var errorCodesToSuggestUsername = ['restrictedTextInUsername', 'usernameAlreadyInUse'];
                  var isUsernameTakenIndex = __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default()(data, function (i) {
                    return i.code && errorCodesToSuggestUsername.includes(i.code);
                  });

                  if (isUsernameTakenIndex !== -1) {
                    _this3.fields.username = _this3.suggestUserName();
                  }

                  _this3.formEnable();
                  _this3.formHandleErrors(e);
                });
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](2);

                _this3.formEnable();
                _this3.formHandleErrors(_context2.t0);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[2, 10]]);
      }))();
    },


    // Called when user completes v2 challenge for registration phase
    onRecaptchaV2VerifiedForRegistration: function onRecaptchaV2VerifiedForRegistration(v2Token) {
      var _this4 = this;

      this.formDisable();

      var payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.pendingPayload, {
        recaptchaToken: v2Token,
        recaptchaVersion: 'v2'
      });

      this.register(payload).then(function () {
        return _this4.setProfileStatus({ event: 'registered' });
      }).then(function () {
        return _this4.loginAfterRegistration();
      }).catch(function (e) {
        // v2 registration failed - show error on registration form
        _this4.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_modals_constants__["a" /* MODALS */].REGISTER);
        _this4.formEnable();
        _this4.formHandleErrors(e);
      });
    },
    showUsernameInfo: function showUsernameInfo() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_modals_constants__["a" /* MODALS */].SMALL_USERNAME);
    },
    suggestUserName: function suggestUserName() {
      return '' + this.usernameSource.slice(0, MAX_CHARACTERS_USERNAME_PART) + this.randomNumber();
    },
    randomNumber: function randomNumber() {
      var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10000;
      var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 99999;

      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    onTermsAndConditions: function onTermsAndConditions() {
      var termsAndConditionsRoute = 'terms-and-conditions';
      if (this.$router.currentRoute.name === termsAndConditionsRoute) {
        this.setCurrentPopup();
      } else {
        this.$router.push({ name: termsAndConditionsRoute });
      }
    }
  }),
  created: function created() {
    if (this.formDataCache !== null && CACHE_NAME === this.formDataCache.route) {
      this.fields = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.fields, this.formDataCache);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.cacheFormData(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.fields, { route: CACHE_NAME }));
  }
});

/***/ }),

/***/ "NXsH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifier},[_c('div',{class:_vm.menuClassModifier},[_c('div',{staticClass:"market-filters-desktop-grid__menu-filters"},[_c('menu-button',{attrs:{"theme":"sushi-pill","type":"filters","name":_vm.filterMenuName,"active":_vm.filtersOpen,"filtersSelected":_vm.selectedFilters.length > 0},on:{"click":_vm.toggleFilters}})],1),_vm._v(" "),(_vm.shouldShowTimespanFilter)?_c('div',{staticClass:"market-filters-desktop-grid__menu-timespan"},[_c('menu-button',{attrs:{"type":"timespan","theme":"sushi-pill","name":_vm.selectedTimespan.name,"active":_vm.timespansOpen},on:{"click":_vm.toggleTimespans}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-filters-desktop-grid__menu-order"},[_c('menu-button',{attrs:{"theme":"sushi-pill","type":_vm.selectedOrder.sort,"name":_vm.orderMenuName,"active":_vm.ordersOpen},on:{"click":_vm.toggleOrder}})],1),_vm._v(" "),_c('div',{staticClass:"market-filters-desktop-grid__menu-title"},[_vm._v("\n      Sort By:\n    ")])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.ordersOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-desktop-grid__order"},_vm._l((_vm.orderList('markets')),function(order){return _c('menu-button',{key:order.sort,attrs:{"theme":_vm.theme,"type":order.sort,"name":order.fullName,"selected":_vm.orderSelected(order.sort)},on:{"click":_vm.selectOrderAndClose}})}),1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.filtersOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-desktop-grid__filters"},[_c('a',{staticClass:"market-filters-desktop-grid__clear-all",on:{"click":function($event){$event.preventDefault();return _vm.onClearFilters($event)}}},[_vm._v("Clear Selections")]),_vm._v(" "),_vm._l((_vm.filters),function(category){return _c('div',{staticClass:"market-filters-desktop-grid__filters-group"},[_c('h3',[_vm._v(_vm._s(category.name))]),_vm._v(" "),_vm._l((category.filters),function(filter){return _c('filter-button',{key:_vm.filterKey(filter),attrs:{"theme":_vm.theme,"id":filter.filterId,"name":filter.name,"selected":_vm.filterSelected(filter.filterId)},on:{"addFilter":_vm.onAddFilter,"removeFilter":_vm.onRemoveFilter}})})],2)})],2):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.timespansOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-desktop-grid__timespans"},_vm._l((_vm.availableTimespanOptions),function(timespan){return _c('menu-button',{key:timespan.parameter,attrs:{"theme":_vm.theme,"type":timespan.parameter,"name":timespan.name},on:{"click":_vm.selectTimespanAndClose}})}),1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NZ9J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ng05":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ngld":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_wallet_bank_links_bank_links_vue__ = __webpack_require__("U82S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_wallet_shared_deposit_amount_overview_deposit_amount_overview_vue__ = __webpack_require__("j8BG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_wallet_shared_deposit_amount_picker_deposit_amount_picker_vue__ = __webpack_require__("+Rub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_wallet_shared_deposit_disclaimer_deposit_disclaimer_vue__ = __webpack_require__("SmIQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_wallet_shared_deposit_done_links_deposit_done_links_vue__ = __webpack_require__("Fem6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_wallet_shared_deposit_info_overview_deposit_info_overview_vue__ = __webpack_require__("DMbv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_wallet_shared_deposit_result_deposit_result_vue__ = __webpack_require__("ny9f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_wallet_shared_fee_status_message_fee_status_message_vue__ = __webpack_require__("7IYw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_wallet_shared_fee_waived_banner_fee_waived_banner_vue__ = __webpack_require__("TBZZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_wallet_shared_promo_code_input_promo_code_input_vue__ = __webpack_require__("THaJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_wallet_shared_depositMethodTypes__ = __webpack_require__("LQTn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_icons_bank_svg__ = __webpack_require__("hkzh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_icons_bank_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_icons_bank_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_getValidationMessage__ = __webpack_require__("U7Hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__helpers_bankTransferIntent__ = __webpack_require__("g1e5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helpers_dataLayer__ = __webpack_require__("k37b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mixins_depositWarningMixin__ = __webpack_require__("Scap");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__mixins_documentUpload__ = __webpack_require__("9xQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__mixins_promoCode__ = __webpack_require__("nPqm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_helpers__ = __webpack_require__("c/9r");





























var DEPOSIT_CHIP_AMOUNTS = [10, 25, 50];

var STEPS = {
  SELECT_ACCOUNT: 1,
  ENTER_AMOUNT: 2,
  REVIEW: 3,
  SUCCESS: 4,
  FAILED: 5
};

var FAILURE_REASONS = {
  ACCOUNT_PERMISSION_DENIED: 3,
  BANK_ACCOUNT_NOT_FOUND: 9,
  SUBMISSION_STATUS_UNCONFIRMED: 11,
  PROCESSING_ERROR: 12,
  INTERNAL_ERROR: 16,
  BANK_CONNECTION_REAUTHENTICATION_REQUIRED: 17
};

var FAILURE_MESSAGES = {
  1: 'Identity verification is required before you can deposit.',
  2: 'This PredictIt account is not active.',
  3: 'Bank transfer deposits are not available for this account.',
  4: 'Please upload the requested documents before depositing.',
  5: 'Your uploaded documents are still being reviewed.',
  6: 'Enter a valid deposit amount.',
  7: 'This deposit exceeds your current deposit limit.',
  8: 'Please provide the requested identity information before depositing.',
  9: 'The selected bank account is no longer available. Choose or reconnect an account.',
  10: 'This deposit request could not be verified. Please review it and try again.',
  11: 'We could not confirm the final status of a recent deposit. Do not submit another deposit. Contact Support.',
  12: 'We could not process this deposit. Please try again.',
  13: 'The deposit request was invalid. Please review it and try again.',
  14: 'Deposits are temporarily unavailable while trading is suspended.',
  15: 'Your PredictIt account could not be found.',
  16: 'We could not process this deposit. Please try again later.',
  17: 'Sign in again to reconnect this bank account before depositing.',
  18: 'The selected bank account does not have enough available funds for this deposit.',
  19: 'The selected bank account is not eligible for this deposit.',
  20: 'We could not verify this bank account right now. Please try again later.',
  21: "We couldn't verify your bank balance right now. Please try again later."
};

function errorData(error) {
  return __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(error, 'response.data', {}) || {};
}

function responseMessage(data, fallback) {
  return data.errorMessage || data.message || data.Message || FAILURE_MESSAGES[Number(data.failureReason)] || fallback;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_21__mixins_depositWarningMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__components_forms_mixin__["a" /* formMixin */], __WEBPACK_IMPORTED_MODULE_23__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__mixins_popupPageModeMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__mixins_promoCode__["a" /* default */]],
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_4__components_generics_alert_box_alert_box_vue__["a" /* default */],
    bankLinks: __WEBPACK_IMPORTED_MODULE_5__components_wallet_bank_links_bank_links_vue__["a" /* default */],
    depositAmountOverview: __WEBPACK_IMPORTED_MODULE_6__components_wallet_shared_deposit_amount_overview_deposit_amount_overview_vue__["a" /* default */],
    depositAmountPicker: __WEBPACK_IMPORTED_MODULE_7__components_wallet_shared_deposit_amount_picker_deposit_amount_picker_vue__["a" /* default */],
    depositDisclaimer: __WEBPACK_IMPORTED_MODULE_8__components_wallet_shared_deposit_disclaimer_deposit_disclaimer_vue__["a" /* default */],
    depositDoneLinks: __WEBPACK_IMPORTED_MODULE_9__components_wallet_shared_deposit_done_links_deposit_done_links_vue__["a" /* default */],
    depositInfoOverview: __WEBPACK_IMPORTED_MODULE_10__components_wallet_shared_deposit_info_overview_deposit_info_overview_vue__["a" /* default */],
    depositResult: __WEBPACK_IMPORTED_MODULE_11__components_wallet_shared_deposit_result_deposit_result_vue__["a" /* default */],
    feeStatusMessage: __WEBPACK_IMPORTED_MODULE_12__components_wallet_shared_fee_status_message_fee_status_message_vue__["a" /* default */],
    feeWaivedBanner: __WEBPACK_IMPORTED_MODULE_13__components_wallet_shared_fee_waived_banner_fee_waived_banner_vue__["a" /* default */],
    promoCodeInput: __WEBPACK_IMPORTED_MODULE_14__components_wallet_shared_promo_code_input_promo_code_input_vue__["a" /* default */]
  },
  data: function data() {
    return {
      amount: '',
      activeOperation: '',
      operationStartedAt: 0,
      operationSeconds: 0,
      operationTimer: null,
      ownsLoader: false,
      isTransferViewDestroyed: false,
      requestGeneration: 0,
      canRetryPendingDeposit: false,
      canDeposit: false,
      confirmedPromoAmount: 0,
      confirmedPromoCampaignName: '',
      currentStep: STEPS.SELECT_ACCOUNT,
      defaultInstitutionLogo: __WEBPACK_IMPORTED_MODULE_16__assets_icons_bank_svg___default.a,
      depositAmounts: DEPOSIT_CHIP_AMOUNTS,
      depositMethodType: __WEBPACK_IMPORTED_MODULE_15__components_wallet_shared_depositMethodTypes__["a" /* DEPOSIT_METHOD_TYPE */].TRANSFERS,
      errorMessage: '',
      failureMessage: '',
      failureReason: null,
      feeFreeAmount: 0,
      formDisclaimer: '',
      processingFeeCap: null,
      processingFeeAmount: '0.00',
      processingFeePercent: 0,
      promoReviewErrorMessage: '',
      reusableSubmissionToken: '',
      selectedAccount: null,
      submissionFailureNeedsIdempotentRetry: false,
      submissionToken: '',
      totalToWallet: '0.00',
      wasFeeDiscountApplied: false,
      STEPS: STEPS
    };
  },
  validations: function validations() {
    return {
      amount: __WEBPACK_IMPORTED_MODULE_17__components_forms_mixin__["b" /* validators */].depositAmountCoinbase(this.minimumDepositAmount, this.maximumDepositAmount)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isDepositPromoInputBoxEnabled', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('wallet', ['minimumDepositAmount']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['ssnInfoVerified', 'status', 'userData']), {
    operationMessage: function operationMessage() {
      if (this.activeOperation === 'review') {
        return this.operationSeconds >= 5 ? 'Still preparing your deposit review. Please wait...' : 'Preparing your deposit review...';
      }
      if (this.activeOperation === 'submission') {
        return 'Checking your bank account and processing your deposit. Please do not submit another deposit.';
      }
      if (this.activeOperation === 'recovery') {
        return 'Checking the status of your existing deposit. No new deposit is being sent.';
      }
      return 'Preparing your bank account for this deposit...';
    },
    accountDescription: function accountDescription() {
      if (!this.selectedAccount) return 'Bank account';
      var accountName = this.selectedAccount.accountName || this.selectedAccount.accountType || 'Bank account';
      return this.selectedAccount.accountNumberLastFour ? accountName + ' - ' + this.selectedAccount.accountNumberLastFour : accountName;
    },
    accountSummary: function accountSummary() {
      if (!this.selectedAccount) return 'Bank account';
      var institutionName = this.selectedAccount.institutionName;
      if (!institutionName || institutionName === this.accountDescription) {
        return this.accountDescription;
      }
      return this.accountDescription === 'Bank account' ? institutionName : institutionName + ' \u2022 ' + this.accountDescription;
    },
    accountUploadDocumentTheme: function accountUploadDocumentTheme() {
      return this.isPage ? 'page-padded' : '';
    },
    amountHasError: function amountHasError() {
      return this.$v.amount.$error;
    },
    amountValidationMessage: function amountValidationMessage() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__helpers_getValidationMessage__["a" /* default */])(this.$v.amount);
    },
    classModifiers: function classModifiers() {
      return {
        'add-funds-transfers': true,
        'add-funds-transfers--page': this.isPage,
        'add-funds-transfers--popup': this.isPopup
      };
    },
    displayDisclaimer: function displayDisclaimer() {
      return this.formDisclaimer || this.disclaimer;
    },
    hasReviewPromo: function hasReviewPromo() {
      return this.confirmedPromoAmount > 0;
    },
    isAmbiguousSubmission: function isAmbiguousSubmission() {
      return this.submissionFailureNeedsIdempotentRetry || this.failureReason === FAILURE_REASONS.SUBMISSION_STATUS_UNCONFIRMED;
    },
    hasUnresolvedIntent: function hasUnresolvedIntent() {
      // Only a held submission token can be reconciled; an unconfirmed review has nothing to keep.
      return this.isAmbiguousSubmission && !!this.submissionToken;
    },
    isConfirmDisabled: function isConfirmDisabled() {
      return this.invalidOrDisabled || !this.canDeposit;
    },
    maximumDepositAmount: function maximumDepositAmount() {
      return 99999;
    },
    reviewPromoLabel: function reviewPromoLabel() {
      return this.promoAppliedCode || this.confirmedPromoCampaignName || 'Applied';
    },
    successAmount: function successAmount() {
      return '$' + Number(this.amount || 0).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('wallet', ['confirmDepositBankTransfer', 'getBalance', 'getDepositBankTransferForm', 'getDepositMethods', 'getLinkedBankAccounts', 'submitDepositBankTransfer', 'restoreBankTransferIntent', 'clearBankTransferIntent', 'getDepositBankTransferStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    applyFeeSnapshot: function applyFeeSnapshot(data) {
      var feePercent = Number(data.feePercent || 0);
      var net = data.net === null || typeof data.net === 'undefined' ? Number(this.amount || 0) : Number(data.net);
      this.processingFeePercent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_helpers__["i" /* roundToTwo */])(feePercent * 100);
      this.processingFeeAmount = Number(Math.abs(data.fee || 0)).toFixed(2);
      this.totalToWallet = Number(net + this.confirmedPromoAmount).toFixed(2);
      this.wasFeeDiscountApplied = data.wasFeeDiscountApplied === true;
      this.feeFreeAmount = Number(data.feeFreeAmount || 0);
      this.processingFeeCap = data.feeCap === null || typeof data.feeCap === 'undefined' ? null : Number(data.feeCap);
    },
    editAmount: function editAmount() {
      if (this.hasUnresolvedIntent || this.activeOperation) return;
      this.failureMessage = '';
      this.failureReason = null;
      // This remains only a reuse candidate until the server returns it from a new review.
      this.reusableSubmissionToken = this.submissionToken;
      this.submissionToken = '';
      this.currentStep = STEPS.ENTER_AMOUNT;
      if (!this.canDeposit) this.loadDepositForm();
    },
    finishRequest: function finishRequest() {
      if (this.ownsLoader) this.loaderRemoveLegacy();
      this.ownsLoader = false;
      if (this.operationTimer) clearInterval(this.operationTimer);
      this.operationTimer = null;
      this.activeOperation = '';
      this.formEnable();
    },
    startOperation: function startOperation(stage) {
      var _this = this;

      this.requestGeneration += 1;
      this.activeOperation = stage;
      this.operationStartedAt = Date.now();
      this.operationSeconds = 0;
      if (this.operationTimer) clearInterval(this.operationTimer);
      this.operationTimer = setInterval(function () {
        _this.operationSeconds = Math.floor((Date.now() - _this.operationStartedAt) / 1000);
      }, 1000);
      this.formDisable();
      // The shared mobile loader has a five-second watchdog; this operation owns
      // its persistent inline status instead of incrementing that shared counter.
      if (!this.isLayoutMobile) {
        this.loaderAddLegacy();
        this.ownsLoader = true;
      }
      this.$nextTick(function () {
        var progress = _this.$refs.operationProgress;
        if (!_this.isTransferViewDestroyed && _this.activeOperation && _this.isLayoutMobile && progress) progress.scrollIntoView({ block: 'center' });
      });
      return this.requestGeneration;
    },
    isCurrentOperation: function isCurrentOperation(generation) {
      return !this.isTransferViewDestroyed && generation === this.requestGeneration;
    },
    restorePendingDeposit: function restorePendingDeposit() {
      var _this2 = this;

      if (!this.userData.userName || this.activeOperation) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      var owner = this.userData.userName;
      var generation = this.requestGeneration;
      return this.restoreBankTransferIntent().then(function (intent) {
        if (!intent || !_this2.isCurrentOperation(generation) || _this2.userData.userName !== owner) return;
        _this2.selectedAccount = { linkedBankAccountId: intent.linkedBankAccountId };
        _this2.amount = String(intent.amount);
        _this2.submissionToken = intent.submissionToken;
        _this2.submissionFailureNeedsIdempotentRetry = true;
        _this2.failureMessage = 'The final status of your previous deposit is not confirmed yet. Do not submit another deposit.';
        _this2.currentStep = STEPS.FAILED;
        _this2.restorePendingAccountLabel(intent, owner);
        _this2.checkPendingDeposit();
      });
    },
    restorePendingAccountLabel: function restorePendingAccountLabel(intent, owner) {
      var _this3 = this;

      // Resolve display-only fields from owned accounts, never persist them with the intent.
      // This optional lookup must not delay checking the financial outcome.
      return this.getLinkedBankAccounts({ timeout: 4000 }).then(function (data) {
        if (_this3.isTransferViewDestroyed || _this3.userData.userName !== owner || _this3.submissionToken !== intent.submissionToken || !_this3.selectedAccount || _this3.selectedAccount.linkedBankAccountId !== intent.linkedBankAccountId) return;
        var accounts = data && data.success === true && data.linkedBankAccounts;
        var account = Array.isArray(accounts) && accounts.find(function (item) {
          return item.linkedBankAccountId === intent.linkedBankAccountId;
        });
        if (!account) return;
        _this3.selectedAccount = {
          linkedBankAccountId: intent.linkedBankAccountId,
          institutionName: account.institutionName,
          accountName: account.accountName,
          accountType: account.accountType,
          accountNumberLastFour: account.accountNumberLastFour
        };
      }).catch(function () {
        return null;
      });
    },
    checkPendingDeposit: function checkPendingDeposit() {
      var _this4 = this;

      if (this.activeOperation || !this.submissionToken || !this.selectedAccount) return;
      var generation = this.startOperation('recovery');
      var owner = this.userData.userName;
      var submissionToken = this.submissionToken;
      this.canRetryPendingDeposit = false;
      this.getDepositBankTransferStatus({
        submissionToken: submissionToken,
        linkedBankAccountId: this.selectedAccount.linkedBankAccountId,
        amount: Number(this.amount)
      }).then(function (data) {
        if (!_this4.isCurrentOperation(generation) || _this4.userData.userName !== owner || _this4.submissionToken !== submissionToken) return;
        _this4.finishRequest();
        if (data && (data.state === 'succeeded' || data.state === 'failed')) {
          _this4.clearBankTransferIntent({ owner: owner, submissionToken: submissionToken });
          _this4.submissionFailureNeedsIdempotentRetry = false;
          if (data.state === 'succeeded') {
            _this4.applyFeeSnapshot(data);
            _this4.failureReason = null;
            _this4.failureMessage = '';
            _this4.currentStep = STEPS.SUCCESS;
            _this4.getBalance().catch(function () {
              return null;
            });
          } else {
            _this4.failureReason = Number(data.failureReason) || FAILURE_REASONS.PROCESSING_ERROR;
            _this4.failureMessage = responseMessage(data, 'This deposit was not completed. You can review it again.');
            _this4.currentStep = STEPS.FAILED;
          }
          return;
        }
        _this4.submissionFailureNeedsIdempotentRetry = true;
        _this4.canRetryPendingDeposit = !!data && data.state === 'unknown';
        _this4.failureMessage = data && data.state === 'pending' ? 'Your deposit is still being processed. Check its status again shortly; do not submit another deposit.' : 'We cannot confirm the final deposit status yet. Check again later or contact Support. Do not submit another deposit.';
      }).catch(function () {
        if (!_this4.isCurrentOperation(generation) || _this4.userData.userName !== owner || _this4.submissionToken !== submissionToken) return;
        _this4.finishRequest();
        _this4.submissionFailureNeedsIdempotentRetry = true;
        _this4.failureMessage = 'We could not check this deposit right now. Check again later or contact Support. Do not submit another deposit.';
      });
    },
    retryPendingDeposit: function retryPendingDeposit() {
      if (!this.canRetryPendingDeposit || !this.isAmbiguousSubmission || this.activeOperation) return;
      this.canRetryPendingDeposit = false;
      // Deliberate same-intent replay only; the backend resolves it under its intent lock.
      this.onSubmitDeposit(true);
    },
    handleAmountBlur: function handleAmountBlur() {
      this.$v.amount.$touch();
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'fill',
        label: 'Amount'
      }));
    },
    handleFormFailure: function handleFormFailure(error) {
      if (this.isTransferViewDestroyed) return;
      var data = errorData(error);
      this.finishRequest();
      if (this.checkDocumentUploadFlags(data)) return;
      this.returnToAccounts(responseMessage(data, 'We could not prepare this bank account for a deposit. Please try again.'));
    },
    handleReviewFailure: function handleReviewFailure(error) {
      if (this.isTransferViewDestroyed) return;
      var data = errorData(error);
      this.finishRequest();
      if (this.checkDocumentUploadFlags(data)) return;
      this.failureReason = Number(data.failureReason) || null;
      this.failureMessage = responseMessage(data, 'We could not review this deposit. Please try again.');
      if (this.failureReason === FAILURE_REASONS.BANK_ACCOUNT_NOT_FOUND || this.failureReason === FAILURE_REASONS.BANK_CONNECTION_REAUTHENTICATION_REQUIRED) {
        this.returnToAccounts(this.failureMessage);
        return;
      }
      this.currentStep = STEPS.FAILED;
    },
    handleSubmitFailure: function handleSubmitFailure(error) {
      if (this.isTransferViewDestroyed) return;
      var data = errorData(error);
      var failureReason = Number(data.failureReason) || null;
      this.submissionFailureNeedsIdempotentRetry = !__WEBPACK_IMPORTED_MODULE_19__helpers_bankTransferIntent__["a" /* default */].isDefinitiveFailureResponse(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(error, 'response'));
      if (error.bankTransferNotSent) {
        this.submissionFailureNeedsIdempotentRetry = false;
      }
      this.finishRequest();
      if (error.existingBankTransferIntent) {
        this.restorePendingDeposit();
        return;
      }
      if (this.checkDocumentUploadFlags(data)) return;
      this.failureReason = failureReason;
      var fallbackMessage = 'We could not complete this deposit. Please try again.';
      if (this.submissionFailureNeedsIdempotentRetry) {
        fallbackMessage = 'The deposit status is not confirmed. Check its status before attempting another deposit.';
      } else if (error.bankTransferNotSent) {
        fallbackMessage = 'The deposit could not be sent. Please sign in again and allow browser session storage.';
      }
      this.failureMessage = responseMessage(data, fallbackMessage);
      if (this.failureReason === FAILURE_REASONS.BANK_ACCOUNT_NOT_FOUND || this.failureReason === FAILURE_REASONS.BANK_CONNECTION_REAUTHENTICATION_REQUIRED) {
        this.returnToAccounts(this.failureMessage);
        return;
      }
      this.currentStep = STEPS.FAILED;
    },
    isStep: function isStep(name) {
      return this.currentStep === STEPS[name];
    },
    onAccounts: function onAccounts() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.promoCodeDetail = data.promoCodeDetail || {};
    },
    loadDepositForm: function loadDepositForm() {
      var _this5 = this;

      if (!this.selectedAccount) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      var generation = this.startOperation('form');
      return this.getDepositBankTransferForm({
        linkedBankAccountId: this.selectedAccount.linkedBankAccountId,
        depositPromoCode: this.promoApplied ? this.promoAppliedCode : ''
      }).then(function (data) {
        if (!_this5.isCurrentOperation(generation)) return;
        _this5.finishRequest();
        if (_this5.checkDocumentUploadFlags(data)) return;
        _this5.canDeposit = data.canDeposit === true;
        _this5.errorMessage = data.errorMessage || '';
        _this5.formDisclaimer = data.disclaimer || '';
        _this5.promoCodeDetail = data.promoCodeDetail || {};
        if (!_this5.canDeposit) {
          _this5.returnToAccounts(_this5.errorMessage || 'Bank transfer deposits are not available right now.');
          return;
        }
        _this5.processingFeePercent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_helpers__["i" /* roundToTwo */])(Number(data.feePercent || 0) * 100);
        _this5.processingFeeCap = data.feeCap === null || typeof data.feeCap === 'undefined' ? null : Number(data.feeCap);
        _this5.errorMessage = '';
        _this5.currentStep = STEPS.ENTER_AMOUNT;
        _this5.$nextTick(function () {
          return _this5.$v.amount.$reset();
        });
      }).catch(function (error) {
        if (_this5.isCurrentOperation(generation)) _this5.handleFormFailure(error);
      });
    },
    onReviewAndConfirm: function onReviewAndConfirm() {
      var _this6 = this;

      this.$v.amount.$touch();
      if (!this.formIsValid() || !this.canDeposit || this.isFormDisabled) {
        return;
      }
      var generation = this.startOperation('review');
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'submit',
        label: 'Submit Deposit'
      }));
      this.confirmDepositBankTransfer({
        linkedBankAccountId: this.selectedAccount.linkedBankAccountId,
        amount: Number(this.amount),
        depositPromoCode: this.promoApplied ? this.promoAppliedCode : '',
        submissionToken: this.reusableSubmissionToken || null
      }).then(function (data) {
        if (!_this6.isCurrentOperation(generation)) return;
        _this6.finishRequest();
        if (_this6.checkDocumentUploadFlags(data)) return;
        if (!data.success || !data.canDeposit || !data.submissionToken) {
          _this6.failureReason = Number(data.failureReason) || null;
          _this6.failureMessage = responseMessage(data, 'We could not review this deposit. Please try again.');
          _this6.currentStep = STEPS.FAILED;
          return;
        }
        _this6.submissionToken = data.submissionToken;
        _this6.reusableSubmissionToken = data.submissionToken;
        _this6.confirmedPromoAmount = Number(data.promoAmount || 0);
        _this6.confirmedPromoCampaignName = data.promoCampaignName || '';
        _this6.promoReviewErrorMessage = data.promoErrorMessage || '';
        _this6.applyFeeSnapshot(data);
        _this6.currentStep = STEPS.REVIEW;
        _this6.scrollToTopIfPage();
      }).catch(function (error) {
        if (_this6.isCurrentOperation(generation)) _this6.handleReviewFailure(error);
      });
    },
    onSubmitDeposit: function onSubmitDeposit() {
      var _this7 = this;

      var isSameIntentRetry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.selectedAccount || !this.submissionToken || this.isFormDisabled || this.isAmbiguousSubmission && isSameIntentRetry !== true) return;
      var generation = this.startOperation('submission');
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Deposit Confirm',
        action: 'submit',
        label: 'Confirm Deposit'
      }));
      this.submitDepositBankTransfer({
        linkedBankAccountId: this.selectedAccount.linkedBankAccountId,
        amount: Number(this.amount),
        submissionToken: this.submissionToken
      }).then(function (data) {
        if (!_this7.isCurrentOperation(generation)) return;
        _this7.finishRequest();
        _this7.submissionFailureNeedsIdempotentRetry = !data || data.success !== true && !__WEBPACK_IMPORTED_MODULE_19__helpers_bankTransferIntent__["a" /* default */].isDefinitiveFailure(data);
        if (!data.success) {
          _this7.failureReason = Number(data.failureReason) || null;
          _this7.failureMessage = responseMessage(data, 'We could not complete this deposit. Please try again.');
          _this7.currentStep = STEPS.FAILED;
          return;
        }
        _this7.applyFeeSnapshot(data);
        _this7.failureMessage = '';
        _this7.failureReason = null;
        _this7.submissionFailureNeedsIdempotentRetry = false;
        _this7.currentStep = STEPS.SUCCESS;
        _this7.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__helpers_dataLayer__["a" /* withMeta */])({
          event: _this7.status && _this7.status.hasBeenFunded ? 'MultiDeposit' : 'Deposit'
        }));
        _this7.$emit('success');
        _this7.getBalance().catch(function () {
          return null;
        });
        _this7.getDepositMethods().catch(function () {
          return null;
        });
        _this7.scrollToTopIfPage();
      }).catch(function (error) {
        if (_this7.isCurrentOperation(generation)) _this7.handleSubmitFailure(error);
      });
    },
    onSuccessDone: function onSuccessDone() {
      this.resetFlow();
      if (this.isPopup) {
        this.setCurrentPopup(null);
      }
    },
    onUpdateAmount: function onUpdateAmount(value) {
      if (this.amount === '') {
        this.amount = value.toFixed(2);
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_helpers__["F" /* isNumber */])(this.amount) || !isNaN(Number(this.amount))) {
        this.amount = (Number(this.amount) + value).toFixed(2);
      }
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'click',
        label: 'Amount ' + value + ' Button'
      }));
    },
    resetFlow: function resetFlow() {
      var _this8 = this;

      if (this.hasUnresolvedIntent || this.activeOperation) return;
      this.amount = '';
      this.canDeposit = false;
      this.confirmedPromoAmount = 0;
      this.confirmedPromoCampaignName = '';
      this.currentStep = STEPS.SELECT_ACCOUNT;
      this.errorMessage = '';
      this.failureMessage = '';
      this.failureReason = null;
      this.feeFreeAmount = 0;
      this.formDisclaimer = '';
      this.processingFeeCap = null;
      this.processingFeeAmount = '0.00';
      this.promoCodeDetail = {};
      this.promoReviewErrorMessage = '';
      this.reusableSubmissionToken = '';
      this.selectedAccount = null;
      this.submissionFailureNeedsIdempotentRetry = false;
      this.canRetryPendingDeposit = false;
      this.submissionToken = '';
      this.totalToWallet = '0.00';
      this.wasFeeDiscountApplied = false;
      this.onResetPromoCode();
      this.formEnable();
      this.$nextTick(function () {
        return _this8.$v.amount.$reset();
      });
    },
    retryFailedRequest: function retryFailedRequest() {
      if (this.activeOperation) return;
      if (this.hasUnresolvedIntent) {
        this.checkPendingDeposit();
        return;
      }
      var failureReason = this.failureReason;
      this.failureMessage = '';
      this.failureReason = null;
      this.submissionFailureNeedsIdempotentRetry = false;

      // A confirmed terminal provider result has consumed this intent. Review
      // it again so the server can rotate the token while reusing an eligible
      // same-bank, same-or-lower 15-minute assessment.
      if (failureReason === FAILURE_REASONS.PROCESSING_ERROR && this.submissionToken) {
        this.reusableSubmissionToken = this.submissionToken;
        this.submissionToken = '';
        if (!this.canDeposit) {
          this.loadDepositForm();
          return;
        }
        this.onReviewAndConfirm();
        return;
      }

      if (this.submissionToken) {
        this.editAmount();
        return;
      }

      this.currentStep = STEPS.ENTER_AMOUNT;
    },
    returnToAccounts: function returnToAccounts(message) {
      var _this9 = this;

      if (this.hasUnresolvedIntent || this.activeOperation) return;
      this.amount = '';
      this.canDeposit = false;
      this.currentStep = STEPS.SELECT_ACCOUNT;
      this.errorMessage = message || '';
      this.failureMessage = '';
      this.failureReason = null;
      this.formDisclaimer = '';
      this.reusableSubmissionToken = '';
      this.selectedAccount = null;
      this.submissionFailureNeedsIdempotentRetry = false;
      this.submissionToken = '';
      this.formEnable();
      this.$nextTick(function () {
        return _this9.$v.amount.$reset();
      });
    },
    scrollToTopIfPage: function scrollToTopIfPage() {
      if (this.isLayoutMobile && this.isPage) {
        setTimeout(function () {
          return window.scrollTo(0, 0);
        }, 100);
      }
    },
    selectAccount: function selectAccount(account) {
      if (this.hasUnresolvedIntent || this.activeOperation) return;
      if (!account || !account.linkedBankAccountId) return;
      this.amount = '';
      this.errorMessage = '';
      this.failureMessage = '';
      this.failureReason = null;
      this.reusableSubmissionToken = '';
      this.selectedAccount = account;
      this.submissionFailureNeedsIdempotentRetry = false;
      this.submissionToken = '';
      this.loadDepositForm();
    }
  }),
  mounted: function mounted() {
    this.getDepositMethods();
    this.restorePendingDeposit();
  },
  beforeDestroy: function beforeDestroy() {
    this.requestGeneration += 1;
    this.finishRequest();
    this.isTransferViewDestroyed = true;
  },

  watch: {
    'userData.userName': function restoreForAuthenticatedAccount() {
      this.requestGeneration += 1;
      this.finishRequest();
      this.submissionFailureNeedsIdempotentRetry = false;
      this.failureReason = null;
      this.resetFlow();
      this.restorePendingDeposit();
    },
    ssnInfoVerified: function ssnInfoVerified(value) {
      if (value && this.selectedAccount) {
        this.collectSsnInfo = false;
        this.loadDepositForm();
      }
    }
  }
});

/***/ }),

/***/ "NmGr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NqVK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_socials_js__ = __webpack_require__("/b9a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a6a819e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_socials_vue__ = __webpack_require__("iSNB");
function injectStyle (ssrContext) {
  __webpack_require__("irZi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_socials_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a6a819e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_socials_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nu5K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_content_header_js__ = __webpack_require__("n2FT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c7c9832_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_content_header_vue__ = __webpack_require__("Kf7o");
function injectStyle (ssrContext) {
  __webpack_require__("tvM0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_content_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c7c9832_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_content_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O4V+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  props: {
    contract: {
      type: Object,
      required: true
    },
    hideOrdersLabel: {
      type: Boolean,
      default: false
    },
    symbol: {
      type: String,
      default: '&cent;'
    },
    theme: {
      type: String,
      default: ''
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_2__models_contract__["a" /* default */](this.contract);
    },
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {
        'market-ownership-and-orders-bar': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-ownership-and-orders-bar--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-ownership-and-orders-bar--yes', this.contractModel.mode === 'yes'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-ownership-and-orders-bar--no', this.contractModel.mode === 'no'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-ownership-and-orders-bar--mobile', this.isLayoutMobile), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-ownership-and-orders-bar--without-orders', !this.hasOrders), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-ownership-and-orders-bar--without-ownership', !this.hasOwnership), _ref;
    },
    ownershipClassModifiers: function ownershipClassModifiers() {
      return {
        'market-ownership-and-orders-bar__ownership--yes': this.contractModel.mode === 'yes',
        'market-ownership-and-orders-bar__ownership--no': this.contractModel.mode === 'no'
      };
    },
    hasOwnership: function hasOwnership() {
      return this.contractModel.userQuantity > 0;
    },
    hasOrders: function hasOrders() {
      return this.contractModel.userOpenOrders > 0;
    },
    showOrdersSummary: function showOrdersSummary() {
      return this.hasOrders || this.hasOwnership;
    },
    shouldRender: function shouldRender() {
      return this.hasOwnership || this.hasOrders;
    },
    showOwnershipIcon: function showOwnershipIcon() {
      return this.hasOwnership;
    },
    ownershipQuantityDisplay: function ownershipQuantityDisplay() {
      return Number(this.contractModel.userQuantity || 0).toLocaleString('en-US');
    },
    ownershipModeDisplay: function ownershipModeDisplay() {
      return this.contractModel.mode.toUpperCase();
    },
    ownershipAverage: function ownershipAverage() {
      return this.contractModel.userAveragePricePerShareAsCents;
    },
    ownershipDifference: function ownershipDifference() {
      return this.contractModel.userChangePriceAsCents;
    },
    buyOrdersDisplay: function buyOrdersDisplay() {
      return Number(this.contractModel.userOpenOrdersBuyQuantity || 0).toLocaleString('en-US');
    },
    sellOrdersDisplay: function sellOrdersDisplay() {
      return Number(this.contractModel.userOpenOrdersSellQuantity || 0).toLocaleString('en-US');
    }
  })
});

/***/ }),

/***/ "O4q7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O8vu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_secondary_nav_js__ = __webpack_require__("zV2+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_315b2671_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_secondary_nav_vue__ = __webpack_require__("FMYX");
function injectStyle (ssrContext) {
  __webpack_require__("e7+2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_secondary_nav_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_315b2671_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_secondary_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OCEH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OFB4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OFlW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{staticClass:"election-map-table"},[_c('div',{staticClass:"election-map-table__title"},[_vm._v("\n    Split Electoral Votes\n  ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"election-map-table__row"},[_c('div',{staticClass:"election-map-table__row-legend"},[_vm._v("\n      NE\n    ")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-state",style:(_vm.neStyleModifiers)},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-district"},[_c('div',{staticClass:"election-map-table__row-district-entry",style:(_vm.ne1StyleModifiers)},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-district-entry",style:(_vm.ne2StyleModifiers)},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-district-entry",style:(_vm.ne3StyleModifiers)},[_vm._v("1")])])]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row"},[_c('div',{staticClass:"election-map-table__row-legend"},[_vm._v("\n      ME\n    ")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-state",style:(_vm.meStyleModifiers)},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-district"},[_c('div',{staticClass:"election-map-table__row-district-entry",style:(_vm.me1StyleModifiers)},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-district-entry",style:(_vm.me2StyleModifiers)},[_vm._v("1")]),_vm._v(" "),(false)?_c('div',{staticClass:"election-map-table__row-district-entry",style:(_vm.me3StyleModifiers)},[_vm._v("x")]):_vm._e()])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"election-map-table__header"},[_c('div',{staticClass:"election-map-table__header-state"},[_c('div',[_vm._v("\n        State\n      ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-table__header-district"},[_c('div',{staticClass:"election-map-table__header-district-header"},[_vm._v("\n        District\n      ")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__header-district-num"},[_c('div',[_vm._v("1")]),_vm._v(" "),_c('div',[_vm._v("2")]),_vm._v(" "),_c('div',[_vm._v("3")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OGIm":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "OHuv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_appNotification__ = __webpack_require__("qtti");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_appNotification__["a" /* default */]],
  props: {
    icon: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']))
});

/***/ }),

/***/ "OIiS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_show_password_icon_js__ = __webpack_require__("UKGl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6993cd77_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_show_password_icon_vue__ = __webpack_require__("P764");
function injectStyle (ssrContext) {
  __webpack_require__("6ALX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_show_password_icon_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6993cd77_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_show_password_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OIwd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "OJH0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AVAILABLE_TIMESPANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DEFAULT_TIMESPANS; });
/* unused harmony export DEFAULT_TIMESPANS_MARKETS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ORDERS_WITH_TIMESPAN_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TIMESPANS; });
/* unused harmony export resolveTimespanDateRange */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return withDateRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectTimespan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectOrder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





var AVAILABLE_TIMESPANS = {
  TODAY: {
    parameter: 'TODAY',
    name: 'Today'
  },
  '3DAY': {
    parameter: '3DAY',
    name: '3 Days'
  },
  WEEK: {
    parameter: 'WEEK',
    name: 'Week'
  },
  MONTH: {
    parameter: 'MONTH',
    name: 'Month'
  },
  ALL: {
    parameter: 'ALL',
    name: 'All Time'
  },
  EMPTY: {
    parameter: '',
    name: ''
  }
};

var DEFAULT_TIMESPANS = {
  movers: AVAILABLE_TIMESPANS.TODAY,
  traded: AVAILABLE_TIMESPANS.ALL
};

var DEFAULT_TIMESPANS_MARKETS = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, DEFAULT_TIMESPANS, {
  traded: AVAILABLE_TIMESPANS.TODAY
});

var ORDERS = [{
  name: 'Volume',
  fullName: 'Trade Volume',
  sort: 'traded'
}, {
  name: 'Price',
  fullName: 'Price Change',
  sort: 'movers'
}, {
  name: 'New Arrivals',
  fullName: 'New Arrivals',
  sort: 'newest'
}, {
  name: 'Expiring',
  fullName: 'Expiring',
  sort: 'closing'
}, {
  name: 'Investment',
  fullName: 'Investment',
  sort: 'investment'
}, {
  name: 'Gain',
  fullName: 'Gain',
  sort: 'gain'
}, {
  name: 'Loss',
  fullName: 'Loss',
  sort: 'loss'
}];

var ORDERS_WITH_TIMESPAN_FILTER = ['movers', 'traded'];

var TIMESPANS = [AVAILABLE_TIMESPANS.TODAY, AVAILABLE_TIMESPANS['3DAY'], AVAILABLE_TIMESPANS.WEEK, AVAILABLE_TIMESPANS.MONTH, AVAILABLE_TIMESPANS.ALL];

var DATE_FORMAT = 'YYYY-MM-DD';

// Turns a relative timespan keyword into an absolute calendar-date range, so
// URLs carrying it stay reproducible (Google Search Central: avoid relative
// URL params like ?date=yesterday). ALL/EMPTY are already absolute - no range.
// `now` is passed in by the caller so a range is only ever resolved once, not
// recomputed on every read.
var resolveTimespanDateRange = function resolveTimespanDateRange(parameter, now) {
  var dateTo = __WEBPACK_IMPORTED_MODULE_2_moment___default()(now).format(DATE_FORMAT);
  switch (parameter) {
    case 'TODAY':
      return { dateFrom: dateTo, dateTo: dateTo };
    case '3DAY':
      return { dateFrom: __WEBPACK_IMPORTED_MODULE_2_moment___default()(now).subtract(3, 'days').format(DATE_FORMAT), dateTo: dateTo };
    case 'WEEK':
      return { dateFrom: __WEBPACK_IMPORTED_MODULE_2_moment___default()(now).subtract(7, 'days').format(DATE_FORMAT), dateTo: dateTo };
    case 'MONTH':
      return { dateFrom: __WEBPACK_IMPORTED_MODULE_2_moment___default()(now).subtract(1, 'month').format(DATE_FORMAT), dateTo: dateTo };
    default:
      return { dateFrom: null, dateTo: null };
  }
};

// AVAILABLE_TIMESPANS/TIMESPANS constants in place, since other store modules
// (dashboard, watchlist) hold their own references to the same objects.
var withDateRange = function withDateRange(timespan, now, overrides) {
  if (!timespan) return timespan;
  var range = overrides && overrides.dateFrom && overrides.dateTo ? { dateFrom: overrides.dateFrom, dateTo: overrides.dateTo } : resolveTimespanDateRange(timespan.parameter, now);
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, timespan, range);
};

var selectTimespan = function selectTimespan(state, parameter) {
  state.selectedTimespan = withDateRange(__WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(state.timespans, { parameter: parameter }), new Date());
};

var selectOrder = function selectOrder(state, sort) {
  state.selectedOrder = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(state.orders, { sort: sort });
  var timespan = DEFAULT_TIMESPANS_MARKETS[sort] || AVAILABLE_TIMESPANS.EMPTY;
  state.selectedTimespan = withDateRange(timespan, new Date());
  state.shouldShowTimespanFilter = ORDERS_WITH_TIMESPAN_FILTER.indexOf(state.selectedOrder.sort) !== -1;
};

/***/ }),

/***/ "OL8g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_search_bar_js__ = __webpack_require__("2SRW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f2e123a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_bar_vue__ = __webpack_require__("noAP");
function injectStyle (ssrContext) {
  __webpack_require__("JNNW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_search_bar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f2e123a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OLUT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_price_change_chart_market_price_change_chart_vue__ = __webpack_require__("ptZl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_contract__ = __webpack_require__("YZ+m");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_1__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    marketPriceChangeChart: __WEBPACK_IMPORTED_MODULE_2__components_market_market_price_change_chart_market_price_change_chart_vue__["a" /* default */]
  },
  props: {
    promo: {
      type: Object
    },
    header: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    contract: function contract() {
      return new __WEBPACK_IMPORTED_MODULE_3__models_contract__["a" /* default */](this.promo);
    },
    hasLastTradePrice: function hasLastTradePrice() {
      return this.contract.hasLastTradePrice;
    },
    iconModifiers: function iconModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'market-biggest-gains-element__icon': true
      }, 'market-biggest-gains-element__icon--' + this.iconTargetClass, this.iconTargetClass);
    },
    iconTargetClass: function iconTargetClass() {
      return this.promo.isGain ? 'price-up' : 'price-down';
    }
  }
});

/***/ }),

/***/ "OMZ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"input",class:_vm.inputModifiers,attrs:{"title":_vm.errorMessage}},[_c('label',{staticClass:"input__label",attrs:{"for":_vm.name}},[(_vm.placeholder)?_c('div',{staticClass:"input__placeholder"},[_vm._v(_vm._s(_vm.placeholder)),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.hasIcon)?_c('div',{staticClass:"input__icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_c('input',{staticClass:"input__value",style:(_vm.inputStyleModifiers),attrs:{"tabindex":_vm.tabindex,"type":_vm.type,"autocomplete":_vm.autocomplete,"disabled":_vm.disabled,"name":_vm.name,"id":_vm.name,"required":_vm.required,"maxlength":_vm.maxLength,"max":_vm.max,"min":_vm.min},domProps:{"value":_vm.value},on:{"input":_vm.updateValue,"blur":_vm.handleBlur,"focus":_vm.handleFocus}})]),_vm._v(" "),(_vm.showValidationWithin)?[(_vm.error)?_c('div',{staticClass:"input__validation-message"},[_vm._v("\n        "+_vm._s(_vm.errorMessage)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.successTick)?_c('div',{staticClass:"input__success-tick"}):_vm._e()]:_vm._e()],2),_vm._v(" "),(!_vm.showValidationWithin)?[(_vm.error)?_c('div',{staticClass:"input__validation-message input__validation-message--outer"},[_vm._v("\n      "+_vm._s(_vm.errorMessage)+"\n    ")]):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OOZ5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ORlq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_notifications_list_notifications_list_vue__ = __webpack_require__("R/N+");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    notificationsList: __WEBPACK_IMPORTED_MODULE_2__components_notifications_list_notifications_list_vue__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['closeNotificationsWidget']), {
    onClickOutside: function onClickOutside() {
      this.closeNotificationsWidget();
    }
  })
});

/***/ }),

/***/ "OUji":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_checkbox_js__ = __webpack_require__("5y3J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ceac93e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__ = __webpack_require__("A6L0");
function injectStyle (ssrContext) {
  __webpack_require__("b34n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_checkbox_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ceac93e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Oa0d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-result"},[(_vm.$slots.heading)?_c('div',{staticClass:"deposit-result__heading"},[_vm._t("heading")],2):_vm._e(),_vm._v(" "),(_vm.$slots.icon)?_c('div',{staticClass:"deposit-result__icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),(_vm.$slots.body)?_c('div',{staticClass:"deposit-result__body"},[_vm._t("body")],2):_vm._e(),_vm._v(" "),(_vm.$slots.actions)?_c('div',{staticClass:"deposit-result__actions"},[_vm._t("actions")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OdBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_settings_option_switch_js__ = __webpack_require__("n0gu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb58763_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_option_switch_vue__ = __webpack_require__("Ge07");
function injectStyle (ssrContext) {
  __webpack_require__("ZdYx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_settings_option_switch_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb58763_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_option_switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OfZf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getMarkets: function getMarkets() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Browse/FilteredMarkets/0?itemsPerPage=' + limit + '&page=' + page + '&filterIds=&sort=newest');
  }
});

/***/ }),

/***/ "Oota":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlay', ['visible']), {
    classObject: function classObject() {
      return { 'overlay--visible': this.visible };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('overlay', ['hide']))
});

/***/ }),

/***/ "OpRL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OprK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__("lHK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__ = __webpack_require__("5Oj8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");


 /* eslint-disable no-restricted-syntax,consistent-return */






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ready: false,
      showTooltip: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('market', ['mapStateDataSenate', 'marketMapTooltipVisible']), {
    ga2MarketData: function ga2MarketData() {
      return this.mapStateDataSenate.GA2 || {};
    },
    classModifiers: function classModifiers() {
      return {
        'election-map-special': true,
        'election-map-special--tooltip-visible': this.marketMapTooltipVisible
      };
    },
    legendStyleModifiers: function legendStyleModifiers() {
      return {
        background: this.color
      };
    },
    color: function color() {
      return this.pallette.color;
    },
    targetContract: function targetContract() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["s" /* getLeadingTradedContract */])(this.ga2MarketData.contracts || []);
    },
    targetContractInstance: function targetContractInstance() {
      return new __WEBPACK_IMPORTED_MODULE_5__models_contract__["a" /* default */](this.targetContract || {});
    },
    pallette: function pallette() {
      if (!this.targetContract) {
        return __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].GRAY[1];
      }

      var pallette = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["a" /* getColorForPalletteCandidate */])(this.targetContract.contractName);
      var factor = pallette[0].from + this.targetContract.lastTradePrice;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(pallette), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (factor <= item.to) {
            return item;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return pallette[pallette.length - 1];
    }
  }),
  watch: {
    mapStateDataSenate: {
      handler: 'mapStateDataHandler',
      immediate: true
    }
  },
  methods: {
    onClick: function onClick() {
      if (this.isLayoutMobile) {
        var marketId = this.ga2MarketData.marketId;
        if (marketId) {
          window.location.href = 'https://www.predictit.org/markets/detail/' + marketId;
        }
      }
    },
    onMouseEnter: function onMouseEnter() {
      this.showTooltip = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.showTooltip = false;
    },
    mapStateDataHandler: function mapStateDataHandler(value) {
      if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(value)) {
        this.ready = true;
      }
    }
  }
});

/***/ }),

/***/ "OqUx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"filter-button",class:_vm.buttonModifier,on:{"click":_vm.toggleFilter}},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Oz+7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_detail_charts_checkbox_checkbox_vue__ = __webpack_require__("OUji");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    formCheckbox: __WEBPACK_IMPORTED_MODULE_4__components_market_market_detail_charts_checkbox_checkbox_vue__["a" /* default */],
    swiper: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiperSlide"]
  },
  props: {
    contracts: {
      type: Array,
      required: true
    },
    chartOptions: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      canScrollLeft: false,
      canScrollRight: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('market', ['chartType']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    swiperOption: function swiperOption() {
      var self = this;
      return {
        slidesPerView: 'auto',
        freeMode: true,
        watchOverflow: true,
        spaceBetween: 10,
        roundLengths: true,
        onInit: function onInit(swiper) {
          self.updateNavigationState(swiper);
        },
        onTransitionEnd: function onTransitionEnd(swiper) {
          self.updateNavigationState(swiper);
        },
        onTouchEnd: function onTouchEnd(swiper) {
          self.updateNavigationState(swiper);
        },
        onReachBeginning: function onReachBeginning() {
          self.canScrollLeft = false;
        },
        onReachEnd: function onReachEnd() {
          self.canScrollRight = false;
        }
      };
    },
    showImage: function showImage() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'showContractImagesOnLegend', false);
    }
  }),
  methods: {
    updateNavigationState: function updateNavigationState(swiperInst) {
      var inst = swiperInst || this.$refs.swiper && this.$refs.swiper.swiper;
      if (inst) {
        this.canScrollLeft = !inst.isBeginning;
        this.canScrollRight = !inst.isEnd;
      }
    },
    scrollLeft: function scrollLeft() {
      this.$refs.swiper.swiper.slidePrev();
    },
    scrollRight: function scrollRight() {
      this.$refs.swiper.swiper.slideNext();
    },
    contractName: function contractName(item) {
      var regionUUID = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'regionUUID', null);
      if (regionUUID !== null) {
        return 'checkbox-' + regionUUID + '-' + item.contractName + '-' + item.marketId + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["a" /* uuidv4 */])();
      }
      return 'checkbox-' + item.contractName + '-' + item.marketId + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["a" /* uuidv4 */])();
    },
    imageStyleModifiers: function imageStyleModifiers(item) {
      return {
        'border-color': item.lineColor,
        'background-image': 'url(' + item.contractImageSmallUrl + ')'
      };
    },
    onChange: function onChange(item, checked) {
      this.$emit('toggleItem', item, checked);
    },
    checkboxColor: function checkboxColor(item) {
      return item.additional ? item.additionalLineColor : item.lineColor;
    }
  }
});

/***/ }),

/***/ "P26B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-chart-loader"},[_c('div',{staticClass:"market-chart-loader__sine-wave"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__content"},[_c('div',{staticClass:"market-chart-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__text-2"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__text-3"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__text-4"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__text-5"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__text-6"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__text-7"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__text-8"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__text-9"}),_vm._v(" "),_c('div',{staticClass:"market-chart-loader__text-10"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P3fZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


var CURRENCY_CENTS = '&cent;';
var CURRENCY_DOLLARS = '$';

function setPrice(el, binding) {
  var sourcePrice = binding.value || 0;
  var absolutePrice = Math.abs(sourcePrice);
  if (binding.modifiers.round2) {
    absolutePrice = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])(absolutePrice);
  }
  var currency = binding.modifiers.cents ? CURRENCY_CENTS : CURRENCY_DOLLARS;
  // Display 100cents as $1
  if (absolutePrice === 100 && currency === CURRENCY_CENTS) {
    currency = CURRENCY_DOLLARS;
    absolutePrice = 1;
  }
  var formattedPrice = absolutePrice;
  if (binding.modifiers.floor) {
    absolutePrice = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["S" /* roundDown */])(absolutePrice);
  }
  if (binding.modifiers.fixed) {
    formattedPrice = absolutePrice.toFixed(2);
  }
  if (binding.modifiers.fixed3) {
    formattedPrice = absolutePrice.toFixed(3);
  }
  if (binding.modifiers.fixedflex) {
    formattedPrice = absolutePrice > 1000 ? absolutePrice.toFixed(0) : absolutePrice.toFixed(2);
  }
  var p = formattedPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  var text = currency === CURRENCY_CENTS ? '' + p + currency : '' + currency + p;
  el.innerHTML = sourcePrice >= 0 ? text : '(' + text + ')';
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    setPrice(el, binding);
  },
  update: function update(el, binding) {
    setPrice(el, binding);
  }
});

/***/ }),

/***/ "P3oX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("8/3H");


/* eslint-disable no-console */







var ERROR_STATUS_CODES = [500, 501, 502, 503, 504];
var UNAUTHORIZED_STATUS_CODE = 401;

// These structured failures are rendered by the transfer flow. Do not hide unrelated
// outages or malformed responses behind a blanket 503 exception.
function isHandledTransferUnavailable(error) {
  var response = error.response || {};
  var request = error.config || response.config || {};
  var data = response.data;
  var path = (request.url || '').split('?')[0];
  return response.status === 503 && (request.method || '').toLowerCase() === 'post' && /(?:^|\/)api\/User\/Wallet\/(DepositBankTransfer|ConfirmDepositBankTransfer|DepositBankTransferForm)\/?$/i.test(path) && data && (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) === 'object' && !Array.isArray(data) && (data.success === false || data.canDeposit === false) && [11, 20, 21].includes(data.failureReason);
}

var refreshSubscribers = [];
var isRefreshing = false;

function tokenRefreshSubscribe(cb) {
  refreshSubscribers.push(cb);
}

function tokenRefreshComplete(token) {
  refreshSubscribers.map(function (cb) {
    return cb(token);
  });
  refreshSubscribers = [];
}

/* harmony default export */ __webpack_exports__["a"] = (function (error) {
  // Widget telemetry is best-effort; never let it raise the global error banner.
  if (error.config && error.config.bankDiagnostic) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  if (!error.response) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  }
  var config = error.config,
      status = error.response.status;

  var originalRequest = config;

  // Skip token refresh for 2FA login endpoints - they use a different token mechanism
  var isTwoFactorLoginEndpoint = config.url && (config.url.includes('TwoFactor/SendCode') || config.url.includes('TwoFactor/Verify'));
  var hasRefreshToken = !!__WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get('refreshToken', null);

  if (status === UNAUTHORIZED_STATUS_CODE && !isTwoFactorLoginEndpoint && hasRefreshToken) {
    __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[TOKEN] Unauthorized');
    if (!isRefreshing) {
      isRefreshing = true;
      var payload = {
        grant_type: 'refresh_token',
        refresh_token: __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get('refreshToken')
      };
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('user/login', payload).then(function () {
        isRefreshing = false;
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[TOKEN] REFRESHED');
        tokenRefreshComplete(__WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get('token'));
      }).catch(function () {
        isRefreshing = false;
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[TOKEN] CANNOT REFRESH');
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('user/clearAuthSession');
        tokenRefreshComplete(null);
      });
    }

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      tokenRefreshSubscribe(function (token) {
        if (!token) {
          reject(error);
          return;
        }
        originalRequest.headers.Authorization = 'Bearer ' + token;
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[TOKEN] Retry');
        resolve(__WEBPACK_IMPORTED_MODULE_2_axios___default()(originalRequest));
      });
    });
  }

  if (error.response) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* checkResponseForApiGoingOffline */])(error.response);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* checkResponseForMaintenance */])(error.response);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* checkResponseForTaxInfo */])(error.response);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["d" /* checkResponseForDocumentUpload */])(error.response);
    __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].error('API - ERROR', error.response.status, error.response.config.url);
    if (ERROR_STATUS_CODES.indexOf(error.response.status) !== -1 && !isHandledTransferUnavailable(error)) {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('app/setServerError', true);
    }
  } else if (error.request) {
    __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].error('The request was made but no response was received');
  } else {
    __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].error('Something happened in setting up the request that triggered an error');
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/***/ }),

/***/ "P71F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_content_loader__ = __webpack_require__("SHAV");




var contentLoaderMixin = {
  components: {
    AccountFormLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["a" /* AccountFormLoader */],
    AccountWithdrawalLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["b" /* AccountWithdrawalLoader */],
    LeaderboardsInfoLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["c" /* LeaderboardsInfoLoader */],
    MarketLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["d" /* MarketLoader */],
    MarketSharesItemLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["e" /* MarketSharesItemLoader */],
    MarketWidgetLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["f" /* MarketWidgetLoader */],
    NotificationLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["g" /* NotificationLoader */],
    BiggestGainsLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["h" /* BiggestGainsLoader */],
    TableRowsLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["i" /* TableRowsLoader */],
    OverviewMapLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["j" /* OverviewMapLoader */],
    MarketChartLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["k" /* MarketChartLoader */],
    PreviewCarouselLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["l" /* PreviewCarouselLoader */],
    StaticPageLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["m" /* StaticPageLoader */],
    MarketDetailPageLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["n" /* MarketDetailPageLoader */],
    SocialsLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["o" /* SocialsLoader */],
    ContractInfoLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["p" /* ContractInfoLoader */]
  },
  data: function data() {
    return {
      isComponentReady: false
    };
  },

  methods: {
    loaderItems: function loaderItems(number) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash_range___default()(0, number);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (contentLoaderMixin);

/***/ }),

/***/ "P764":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"show-password"}},[(_vm.show)?_c('button',{staticClass:"show-password",class:_vm.classModifiers,attrs:{"type":"button","tabindex":"-1","title":_vm.title},on:{"click":function($event){$event.stopPropagation();return _vm.onPasswordToggle($event)}}},[_vm._v("\n     \n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PBe4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.backgroundModifiers},[_c('div',{staticClass:"row row-xy row-100"},[_c('div',{staticClass:"column small-4 large-12 column-100 account-social-badge__avatar"},[_c('account-social-avatar',{attrs:{"avatar":_vm.userAvatar,"showProgress":!_vm.isTopLevelTrader,"percentage":_vm.progressPercentage,"progressStrokeColor":_vm.progressColor,"backgroundStrokeColor":_vm.levelColor,"theme":_vm.avatarTheme}})],1),_vm._v(" "),_c('div',{staticClass:"column small-8 large-12 large-text-center column-100 account-social-badge__text"},[(_vm.isSocialReady)?[_c('div',{staticClass:"account-social-badge__headline"},[_vm._v("\n          "+_vm._s(_vm.username)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"account-social-badge__level"},[_c('span',{staticClass:"account-social-badge__level-text"},[_vm._v(_vm._s(_vm.level.text))]),_vm._v(" "),_c('span',{staticClass:"account-social-badge__level-num"},[_vm._v("Level "+_vm._s(_vm.level.num))])]),_vm._v(" "),_c('div',{staticClass:"account-social-badge__progress"},[_c('div',{class:_vm.progressBarClassModifiers},[_vm._v(_vm._s(_vm.progressPercentage)+"%")]),_vm._v(" "),_c('div',{staticClass:"account-social-badge__progress-fill",style:(_vm.progressBarStyleModifiers)})]),_vm._v(" "),_c('div',{staticClass:"account-social-badge__footer"},[(_vm.isTopLevelTrader)?[_vm._v("\n            You are a top-level trader!\n          ")]:[_vm._v("\n            "+_vm._s(_vm.progressInfoText)+"\n          ")]],2),_vm._v(" "),(false)?_c('span',{staticClass:"account-social-badge__link",on:{"click":_vm.showBadgesPopup}},[_vm._v(" Your Badges »\n        ")]):_vm._e()]:_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PElc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_quotes_js__ = __webpack_require__("FITW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5433cd98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quotes_vue__ = __webpack_require__("mI5N");
function injectStyle (ssrContext) {
  __webpack_require__("8V4D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_quotes_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5433cd98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quotes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PMOm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_TYPES_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALL_YEARS_OPTION; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_notifications_proxy__ = __webpack_require__("a0yF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_dataLayer__ = __webpack_require__("k37b");

















var ITEMS_PER_HISTORY_PAGE = 10;
var DEFAULT_HISTORY = {
  data: [],
  page: 0,
  totalCount: -1,
  canLoadMore: true,
  marketId: -1
};
var DEFAULT_PRICE_CHANGE = 10;

var ALL_TYPES_OPTION = { label: 'All Transactions', value: 'ALL' };
var ALL_YEARS_OPTION = { label: 'All', value: '' };
var GUEST_LOGIN_MERGE_SETTING_KEYS = [__WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme, __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout, __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay];

var TYPE_OPTIONS = [ALL_TYPES_OPTION, { label: 'Deposits', value: 'DEPOSITS' }, { label: 'Withdrawals', value: 'WITHDRAWALS' }, { label: 'Promotions', value: 'PROMOTIONS' }];

function makeYearsOptions(obj) {
  var years = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(obj.keys())).sort().reduceRight(function (filter, year) {
    filter.push({ label: year, value: year.toString() });
    return filter;
  }, []);
  years.unshift(ALL_YEARS_OPTION);
  return years;
}

function getResolvedGuestSettingValue(rootState, keyName) {
  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme) {
    return rootState.app.settingColorPalette;
  }

  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay) {
    return rootState.app.settingShowOdds ? __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["d" /* APP_PRICE_DISPLAY */].ODDS : __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["d" /* APP_PRICE_DISPLAY */].TRADE_PRICES;
  }

  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout) {
    return rootState.app.settingMobileLayout;
  }

  return null;
}

function isGuestSettingDirty(rootState, keyName) {
  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme) {
    return rootState.app.guestSettingColorPaletteDirty;
  }

  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay) {
    return rootState.app.guestSettingPriceDisplayDirty;
  }

  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout) {
    return rootState.app.guestSettingMobileLayoutDirty;
  }

  return false;
}

function applyResolvedUxSetting(dispatch, keyName, value) {
  var numValue = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(value, 10);

  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme) {
    return dispatch('app/applySettingColorPalette', numValue, { root: true });
  }

  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout) {
    return dispatch('app/applySettingMobileLayout', numValue, { root: true });
  }

  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay) {
    return dispatch('app/applySettingShowOdds', numValue === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["d" /* APP_PRICE_DISPLAY */].ODDS, { root: true });
  }

  if (keyName === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingIsOBCollapsedOnOS) {
    return dispatch('app/applySettingOrderbookCollapsed', numValue === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["e" /* APP_MOBILE_ORDERBOOK_DISPLAY */].COLLAPSED, { root: true });
  }

  return null;
}

function clearGuestSettingDirty(dispatch, keyName) {
  return dispatch('app/setGuestSettingDirty', { keyName: keyName, value: false }, { root: true });
}

function resolveFetchedSettings(settings, rootState) {
  var dirtySettingsToClear = [];
  var settingsToPersist = [];

  var resolvedSettings = settings.map(function (setting) {
    if (setting.category !== 'ux' || !GUEST_LOGIN_MERGE_SETTING_KEYS.includes(setting.keyName)) {
      return setting;
    }

    var backendValue = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(setting.value, 10);

    if (setting.hasAccountOverride) {
      dirtySettingsToClear.push(setting.keyName);
      return setting;
    }

    if (!isGuestSettingDirty(rootState, setting.keyName)) {
      return setting;
    }

    var guestValue = getResolvedGuestSettingValue(rootState, setting.keyName);
    if (guestValue === null || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_nan___default()(backendValue)) {
      return setting;
    }

    settingsToPersist.push({
      category: setting.category,
      keyName: setting.keyName,
      value: guestValue
    });

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, setting, {
      value: guestValue.toString(),
      hasAccountOverride: true
    });
  });

  return {
    resolvedSettings: resolvedSettings,
    dirtySettingsToClear: dirtySettingsToClear,
    settingsToPersist: settingsToPersist
  };
}

/* harmony default export */ __webpack_exports__["c"] = ({
  namespaced: true,
  state: {
    portfolioChart: {
      history: []
    },
    userAffiliations: [],
    profileStatus: {},
    profileDetail: {},
    tradeHistory: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY),
    transactionHistory: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY),
    marketHistory: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY),
    pendingHistory: [],
    marketPayouts: null,
    tradedMarkets: [],
    tradedMarketsLoaded: false,
    isUCAffilSet: false,
    settings: {
      display: {},
      privacy: {},
      InAppNotifications: {},
      PushNotifications: {},
      ux: {}
    }
  },
  mutations: {
    resetTransactionHistory: function resetTransactionHistory(state) {
      state.transactionHistory = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY);
      state.pendingHistory = [];
    },
    resetTradeHistory: function resetTradeHistory(state) {
      state.tradeHistory = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY);
    },
    resetMarketHistory: function resetMarketHistory(state) {
      state.marketHistory = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY);
    },
    updateTransactionHistory: function updateTransactionHistory(state, payload) {
      var data = state.transactionHistory.data.concat(payload.data.fundsHistoryViewModel);
      state.pendingHistory = payload.data.fundsPendingViewModel;
      var page = payload.page;
      var totalCount = payload.data.totalItems;
      var canLoadMore = totalCount > data.length;

      state.transactionHistory = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.transactionHistory, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    updateTradeHistory: function updateTradeHistory(state, payload) {
      var current = state[payload.what];
      var history = void 0;

      if (current.marketId !== payload.marketId || payload.contractId !== current.contractId) {
        history = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY);
      } else {
        history = current;
      }
      var data = history.data.concat(payload.data.historyList);
      var page = payload.page;
      var marketId = payload.marketId;
      var contractId = payload.contractId;
      var totalCount = payload.data.totalCount;
      var canLoadMore = totalCount > data.length;

      state[payload.what] = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state[payload.what], {
        data: data,
        page: page,
        marketId: marketId,
        contractId: contractId,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    updateMarketPayouts: function updateMarketPayouts(state, payload) {
      state.marketPayouts = payload;
    },
    setProfileDetail: function setProfileDetail(state, data) {
      state.profileDetail = data;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_dataLayer__["i" /* pushUserIdentity */])(data.userGuid, data.otmUserId);
    },
    setProfileStatus: function setProfileStatus(state, data) {
      state.profileStatus = data;
    },
    updateTradedMarkets: function updateTradedMarkets(state, payload) {
      state.tradedMarkets = payload;
      state.tradedMarketsLoaded = true;
    },
    clearTradedMarkets: function clearTradedMarkets(state) {
      state.tradedMarkets = [];
      state.tradedMarketsLoaded = false;
    },
    updateTransactionFilters: function updateTransactionFilters(state, payload) {
      state.transactionFilters = payload;
    },
    setPortfolioChart: function setPortfolioChart(state, data) {
      state.portfolioChart = data;
    },
    clearSettings: function clearSettings(state) {
      state.settings = {
        display: {},
        privacy: {},
        InAppNotifications: {},
        PushNotifications: {},
        ux: {}
      };
    },
    updateSettingsCategory: function updateSettingsCategory(state, payload) {
      var categories = payload.reduce(function (acc, _ref) {
        var category = _ref.category,
            keyName = _ref.keyName,
            value = _ref.value;

        if (acc[category] === undefined) {
          acc[category] = {};
        }
        // converting to boolean if true/false
        var boolValue = null;
        if (value === 'true') {
          boolValue = true;
        }
        if (value === 'false') {
          boolValue = false;
        }
        var parsed = value;
        if (keyName === 'ContractPriceChangeAmount') {
          parsed = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(value, 10);
          if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_nan___default()(parsed)) {
            parsed = DEFAULT_PRICE_CHANGE;
          }
        }
        acc[category][keyName] = boolValue !== null ? boolValue : parsed;
        return acc;
      }, {});
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(categories).forEach(function (k) {
        state.settings[k] = categories[k];
      });
    },
    updateSettings: function updateSettings(state, _ref2) {
      var category = _ref2.category,
          key = _ref2.key,
          value = _ref2.value;

      state.settings[category][key] = value;
    },
    updateProfileFromNotification: function updateProfileFromNotification(state, data) {
      state.profileDetail = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["U" /* updateObjectValues */])(state.profileDetail, data, __WEBPACK_IMPORTED_MODULE_12__services_notifications_proxy__["f" /* ACCOUNT_FUNDS_MAP */]);
    },
    setUserAffiliations: function setUserAffiliations(state, data) {
      state.userAffiliations = data;
    },
    setIsUCAffilSet: function setIsUCAffilSet(state, data) {
      state.isUCAffilSet = data;
    }
  },
  getters: {
    transactionFilters: function transactionFilters(state) {
      if (state.transactionHistory.data) {
        var registrationYear = __WEBPACK_IMPORTED_MODULE_9_moment___default.a.utc(state.profileDetail.dateRegistered).year();
        var currentYear = new Date().getFullYear();
        var yearPairs = __WEBPACK_IMPORTED_MODULE_8_lodash_range___default()(registrationYear, currentYear + 1).map(function (i) {
          return [i, i];
        });
        var yearsMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a(yearPairs);
        var yearOptions = makeYearsOptions(yearsMap);
        return { yearOptions: yearOptions, typeOptions: TYPE_OPTIONS };
      }
      return { yearOptions: [], typeOptions: TYPE_OPTIONS };
    },
    showBidAsk: function showBidAsk(state) {
      return state.settings.display.ShowBidAsk;
    },
    settingsReady: function settingsReady(state) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.settings.privacy).length > 0 && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.settings.InAppNotifications).length > 0 && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.settings.PushNotifications).length > 0;
    }
  },
  actions: {
    getTradeHistory: function getTradeHistory(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$marketId = _ref4.marketId,
          marketId = _ref4$marketId === undefined ? '' : _ref4$marketId,
          _ref4$contractId = _ref4.contractId,
          contractId = _ref4$contractId === undefined ? '' : _ref4$contractId;

      var what = marketId === '' ? 'tradeHistory' : 'marketHistory';
      var history = state[what];
      var force = history.marketId !== marketId || contractId !== history.contractId;

      if (force || history.canLoadMore) {
        var page = force ? 1 : history.page + 1;
        return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getTradeHistory(ITEMS_PER_HISTORY_PAGE, page, marketId, contractId).then(function (response) {
          commit('updateTradeHistory', {
            page: page,
            data: response.data,
            marketId: marketId,
            contractId: contractId,
            what: what
          });
        });
      }
      return null;
    },
    getTransactionHistory: function getTransactionHistory(_ref5, _ref6) {
      var state = _ref5.state,
          commit = _ref5.commit;
      var _ref6$type = _ref6.type,
          type = _ref6$type === undefined ? 'ALL' : _ref6$type,
          _ref6$year = _ref6.year,
          year = _ref6$year === undefined ? '' : _ref6$year;

      if (state.transactionHistory.canLoadMore) {
        var page = state.transactionHistory.page + 1;
        return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getTransactionHistory(ITEMS_PER_HISTORY_PAGE, page, type, year).then(function (response) {
          commit('updateTransactionHistory', {
            page: page,
            data: response.data
          });
          return response.data;
        });
      }
      return null;
    },
    clearMarketPayouts: function clearMarketPayouts(_ref7) {
      var commit = _ref7.commit;

      commit('updateMarketPayouts', null);
    },
    getMarketPayouts: function getMarketPayouts(_ref8, marketId) {
      var commit = _ref8.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getMarketPayouts(marketId).then(function (response) {
        commit('updateMarketPayouts', response.data);
      });
    },
    getProfileDetail: function getProfileDetail(_ref9) {
      var commit = _ref9.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getProfileDetail().then(function (response) {
        commit('setProfileDetail', response.data);
        return response.data;
      });
    },
    getTradedMarkets: function getTradedMarkets(_ref10, _ref11) {
      var commit = _ref10.commit,
          state = _ref10.state;
      var _ref11$cache = _ref11.cache,
          cache = _ref11$cache === undefined ? false : _ref11$cache;

      if (cache && state.tradedMarketsLoaded) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.tradedMarkets);
      }
      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getTradeHistoryMarkets().then(function (response) {
        commit('updateTradedMarkets', response.data);
        return response.data;
      });
    },
    resetTransactionHistory: function resetTransactionHistory(_ref12) {
      var commit = _ref12.commit;

      commit('resetTransactionHistory');
    },
    resetTradeHistory: function resetTradeHistory(_ref13) {
      var commit = _ref13.commit;

      commit('resetTradeHistory');
    },
    resetMarketHistory: function resetMarketHistory(_ref14) {
      var commit = _ref14.commit;

      commit('resetMarketHistory');
    },
    addMarketToWatchList: function addMarketToWatchList(_ref15, marketId) {
      var commit = _ref15.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.putMarketWatch(marketId).then(function (response) {
        return response.data;
      });
    },
    removeMarketFromWatchList: function removeMarketFromWatchList(_ref16, marketId) {
      var commit = _ref16.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.deleteMarketWatch(marketId).then(function (response) {
        return response.data;
      });
    },
    getPortfolioChart: function getPortfolioChart(_ref17, _ref18) {
      var commit = _ref17.commit;
      var timespan = _ref18.timespan;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getPortfolioChart(timespan).then(function (response) {
        commit('setPortfolioChart', response.data);
        return response.data;
      });
    },
    updateSettings: function updateSettings(_ref19, payload) {
      var commit = _ref19.commit,
          dispatch = _ref19.dispatch;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.putSettings(payload.category, payload.key, payload.value).then(function (response) {
        commit('updateSettings', payload);
        if (payload.category === 'ux') {
          var numValue = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(payload.value, 10);
          if (payload.key === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme) {
            dispatch('app/applySettingColorPalette', numValue, { root: true });
            clearGuestSettingDirty(dispatch, payload.key);
          } else if (payload.key === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout) {
            dispatch('app/applySettingMobileLayout', numValue, { root: true });
            clearGuestSettingDirty(dispatch, payload.key);
          } else if (payload.key === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay) {
            dispatch('app/applySettingShowOdds', numValue === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["d" /* APP_PRICE_DISPLAY */].ODDS, { root: true });
            clearGuestSettingDirty(dispatch, payload.key);
          } else if (payload.key === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["b" /* UX_CATEGORY */].UXSettingIsOBCollapsedOnOS) {
            dispatch('app/applySettingOrderbookCollapsed', numValue === __WEBPACK_IMPORTED_MODULE_13__store_modules_app__["e" /* APP_MOBILE_ORDERBOOK_DISPLAY */].COLLAPSED, { root: true });
          }
        }
        return response.data;
      });
    },
    clearSettings: function clearSettings(_ref20) {
      var commit = _ref20.commit;

      commit('clearSettings');
    },
    getAllSettings: function getAllSettings(_ref21) {
      var commit = _ref21.commit,
          dispatch = _ref21.dispatch,
          rootState = _ref21.rootState;

      var categories = ['Display', 'InAppNotifications', 'PushNotifications', 'Privacy', 'ux'].map(function (i) {
        return i.toLowerCase();
      }).join();
      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getAllSettings(categories).then(function (response) {
        var _resolveFetchedSettin = resolveFetchedSettings(response.data, rootState),
            resolvedSettings = _resolveFetchedSettin.resolvedSettings,
            dirtySettingsToClear = _resolveFetchedSettin.dirtySettingsToClear,
            settingsToPersist = _resolveFetchedSettin.settingsToPersist;

        commit('updateSettingsCategory', resolvedSettings);

        var uxSettings = resolvedSettings.filter(function (item) {
          return item.category === 'ux';
        });
        uxSettings.forEach(function (_ref22) {
          var keyName = _ref22.keyName,
              value = _ref22.value;

          applyResolvedUxSetting(dispatch, keyName, value);
        });

        dirtySettingsToClear.forEach(function (keyName) {
          clearGuestSettingDirty(dispatch, keyName);
        });

        if (!settingsToPersist.length) {
          return resolvedSettings;
        }

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(settingsToPersist.map(function (_ref23) {
          var category = _ref23.category,
              keyName = _ref23.keyName,
              value = _ref23.value;
          return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.putSettings(category, keyName, value).then(function () {
            clearGuestSettingDirty(dispatch, keyName);
          }).catch(function () {
            return null;
          });
        })).then(function () {
          return resolvedSettings;
        });
      });
    },
    updateProfileFromNotification: function updateProfileFromNotification(_ref24, payload) {
      var commit = _ref24.commit;

      commit('updateProfileFromNotification', payload);
    },
    clearTradedMarkets: function clearTradedMarkets(_ref25) {
      var commit = _ref25.commit;

      commit('clearTradedMarkets');
    },
    setProfileStatus: function setProfileStatus(_ref26, data) {
      var commit = _ref26.commit;

      commit('setProfileStatus', data);
    },
    sendInviteEmail: function sendInviteEmail(_ref27, email) {
      var commit = _ref27.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.postSendInviteEmail(email).then(function (response) {
        return response.data;
      });
    },
    getUserAffiliations: function getUserAffiliations(_ref28) {
      var commit = _ref28.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getUserAffiliations().then(function (response) {
        var data = response.data;
        commit('setIsUCAffilSet', data.isUCAffilSet);
        commit('setUserAffiliations', data.affiliateEntities || []);
        return response.data;
      });
    },
    setUserAffiliations: function setUserAffiliations(_ref29, payload) {
      var commit = _ref29.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.setUserAffiliations(payload).then(function (response) {
        return response.data;
      });
    },
    removeUserAffiliations: function removeUserAffiliations(_ref30, payload) {
      var commit = _ref30.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.removeUserAffiliations(payload).then(function (response) {
        return response.data;
      });
    },
    getAffiliations: function getAffiliations(_ref31, search) {
      var _ = _ref31._;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getAffiliations(search).then(function (response) {
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "PQ7o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_onboarding_consts__ = __webpack_require__("yUpF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    editModeOn: false,
    currentStep: __WEBPACK_IMPORTED_MODULE_2__components_onboarding_consts__["a" /* ONBOARDING_STEPS */].REGISTER
  },
  mutations: {
    setCurrentStep: function setCurrentStep(state, step) {
      state.currentStep = step;
    },
    setOnboardingEditMode: function setOnboardingEditMode(state, flag) {
      state.editModeOn = flag;
    }
  },
  actions: {
    showOnboardingStepByCode: function showOnboardingStepByCode(_ref, _ref2) {
      var dispatch = _ref.dispatch,
          rootGetters = _ref.rootGetters;
      var stepCode = _ref2.stepCode;

      __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[ONBOARDING] showOnboardingStepByCode ' + stepCode);
      if (stepCode === __WEBPACK_IMPORTED_MODULE_2__components_onboarding_consts__["b" /* ONBOARDING_STEP_NAME_CODE_MAP */].ADD_FUNDS_OR_PENDING) {
        var step = rootGetters['user/showComplianceReviewBanner'] ? __WEBPACK_IMPORTED_MODULE_2__components_onboarding_consts__["a" /* ONBOARDING_STEPS */].PENDING_APPROVAL : __WEBPACK_IMPORTED_MODULE_2__components_onboarding_consts__["a" /* ONBOARDING_STEPS */].QUICK_DEPOSIT;
        dispatch('showOnboardingStep', { step: step });
      } else {
        dispatch('showOnboardingStep', { step: __WEBPACK_IMPORTED_MODULE_2__components_onboarding_consts__["c" /* ONBOARDING_STEP_CODE_NAME_MAP */][stepCode] });
      }
    },
    showOnboardingStep: function showOnboardingStep(_ref3, _ref4) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch,
          rootGetters = _ref3.rootGetters;
      var step = _ref4.step;

      if (step === __WEBPACK_IMPORTED_MODULE_2__components_onboarding_consts__["a" /* ONBOARDING_STEPS */].LOGIN) {
        dispatch('popup/setCurrentPopup', null, { root: true });
        if (rootGetters['app/isLoginEnabled']) {
          alert('login');
        } else {
          dispatch('popup/setCurrentSmallPopup', __WEBPACK_IMPORTED_MODULE_1__components_app_app_modals_modals_constants__["a" /* MODALS */].SMALL_PROCESS_ERROR, { root: true });
          dispatch('popup/setCurrentPopupOptions', { message: 'Due to site maintenance, it\'s not possible to log in at this time. Please try again later.' }, { root: true });
        }

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
      } else if (step === __WEBPACK_IMPORTED_MODULE_2__components_onboarding_consts__["a" /* ONBOARDING_STEPS */].REGISTER) {
        dispatch('popup/setCurrentPopup', null, { root: true });
        if (rootGetters['app/isSignUpEnabled']) {
          alert('logout');
        } else {
          dispatch('popup/setCurrentSmallPopup', __WEBPACK_IMPORTED_MODULE_1__components_app_app_modals_modals_constants__["a" /* MODALS */].SMALL_PROCESS_ERROR, { root: true });
          dispatch('popup/setCurrentPopupOptions', { message: 'Due to site maintenance, it\'s not possible to sign up at this time. Please try again later.' }, { root: true });
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
      }
      __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[ONBOARDING] showOnboardingStep ' + step);
      commit('setCurrentStep', step);
      return dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_1__components_app_app_modals_modals_constants__["a" /* MODALS */].ONBOARDING, { root: true });
    },
    setCurrentStep: function setCurrentStep(_ref5, _ref6) {
      var commit = _ref5.commit;
      var step = _ref6.step;

      commit('setCurrentStep', step);
    },
    setOnboardingEditMode: function setOnboardingEditMode(_ref7, flag) {
      var commit = _ref7.commit;

      commit('setOnboardingEditMode', flag);
    }
  }
});

/***/ }),

/***/ "PQLn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PSnM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PUmN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_horizontal_sushi_js__ = __webpack_require__("d/V8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15313497_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_horizontal_sushi_vue__ = __webpack_require__("vcCB");
function injectStyle (ssrContext) {
  __webpack_require__("OpRL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_horizontal_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15313497_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_horizontal_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PUuo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_modals_js__ = __webpack_require__("HP6i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b0fccf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_modals_vue__ = __webpack_require__("RDqn");
function injectStyle (ssrContext) {
  __webpack_require__("KzG7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_modals_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b0fccf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_modals_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Paoj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_1__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  props: {
    mode: {
      type: String,
      required: true
    },
    number: {
      type: Number,
      required: true
    },
    average: {
      type: Number,
      required: true
    },
    difference: {
      type: Number,
      required: true
    },
    lastClosePrice: {},
    numberOnly: {
      type: Boolean,
      default: false
    },
    avgPriceOnly: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    },
    changePriceTheme: {
      type: String,
      default: ''
    },
    symbol: {
      type: String,
      default: '&cent;'
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {
        'market-shares-bar': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-shares-bar--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-shares-bar--yes', this.mode === 'yes'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-shares-bar--no', this.mode === 'no'), _ref;
    }
  },
  methods: {
    onClickNumber: function onClickNumber() {
      this.$emit('click');
    }
  }
});

/***/ }),

/***/ "PbZj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PbpQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pf5Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_ownership_and_orders_bar_js__ = __webpack_require__("O4V+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_382ec28f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_ownership_and_orders_bar_vue__ = __webpack_require__("mt5D");
function injectStyle (ssrContext) {
  __webpack_require__("1EIf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_ownership_and_orders_bar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_382ec28f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_ownership_and_orders_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PlkO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLayoutMobile)?_c('router-link',{staticClass:"insight-link__link",attrs:{"to":_vm.href}},[_c('div',{staticClass:"insight-link__content"},[_vm._v("\n      "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"insight-link__date"},[_vm._v(_vm._s(_vm.date))])])]):_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],staticClass:"insight-link__link",attrs:{"href":_vm.url}},[_c('div',{staticClass:"insight-link__content"},[_vm._v("\n      "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"insight-link__date"},[_vm._v(_vm._s(_vm.date))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q+EN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ContractChartGroupStock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContractChartGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PriceChangeChart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ElectionMapChartOverall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ElectionMapChartParty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ElectionMapChartSenate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_market_market_state_tooltip_market_state_tooltip_vue__ = __webpack_require__("Vnj/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_market_market_contract_image_market_contract_image_vue__ = __webpack_require__("nygi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_pages_page_election_map_new_election_map_election_map_constants__ = __webpack_require__("5Oj8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_market_market_detail_charts_timeline_timeline_vue__ = __webpack_require__("GebD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__models_contract__ = __webpack_require__("YZ+m");
















 /* global Highcharts:false */
/* eslint-disable */












var DATE_MONTHLY_FORMAT = 'DD MMM';
var DATE_YEARLY_FORMAT = 'DD MMM YYYY';
var CONTRACT_BAR_CHART_GRADIENT = '#c6ebf2';
var CONTRACT_BAR_CHART_GRADIENT_STOCK = '#c6ebf2';
var CONTRACT_LINE_CHART_MARKER_FILL_COLOR = '#fff';
var CONTRACT_SELECTION_COLOR = '#c97575';
var CONTRACT_SELECTION_COLOR_ALT = '#fff';
var CHART_GROUP_STOCK_XAXIS_LABEL_X_SPACING = 8;

var MarketStateTooltipComponent = __WEBPACK_IMPORTED_MODULE_18_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_21__components_market_market_state_tooltip_market_state_tooltip_vue__["a" /* default */]);
var MarketContractImageComponent = __WEBPACK_IMPORTED_MODULE_18_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_22__components_market_market_contract_image_market_contract_image_vue__["a" /* default */]);

function splitArray(arr, size) {
  var result = [];
  var noOfChunks = Math.ceil(arr.length / size);
  for (var i = 0; i < noOfChunks; i += 1) {
    result.push(arr.slice(i * size, (i + 1) * size));
  }
  return result;
}

function volumeRoundUp(num, base) {
  return num % base !== 0 ? num - num % base + base : num;
}

function volumeGetBase(num) {
  if (num >= 10000) return 10000;
  if (num >= 5000) return 5000;
  if (num >= 2500) return 2500;
  if (num >= 1000) return 1000;
  if (num >= 500) return 500;
  if (num >= 250) return 250;
  if (num >= 100) return 100;
  if (num >= 10) return 10;
  return 1;
}

function volumeNormalize(num, base, parts) {
  var result = num;
  if (result % parts === 0) return result;
  do {
    result = result + base;
  } while (result % parts !== 0);
  return result;
}

function volumeGetRange(num) {
  var parts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

  var base = volumeGetBase(num);
  var max = volumeRoundUp(num, base);
  var normalizedMax = volumeNormalize(max, base, parts);
  var diff = normalizedMax / parts;
  return __WEBPACK_IMPORTED_MODULE_15_lodash_range___default()(0, normalizedMax + diff, diff);
}

function getTradeVolumeTickPositions(_ref) {
  var data = _ref.data,
      _ref$parts = _ref.parts,
      parts = _ref$parts === undefined ? 4 : _ref$parts,
      _ref$show = _ref.show,
      show = _ref$show === undefined ? false : _ref$show;

  var defaults = [0, 2, 4, 6, 8];
  if (!show) {
    return defaults;
  }
  var max = Math.max.apply(null, data);
  if (!max) {
    return defaults;
  }
  return volumeGetRange(max, parts);
}

if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_helpers__["w" /* isHighChartsReady */])()) {
  Highcharts.SVGRenderer.prototype.symbols.download = function (x, y, w, h) {
    return [
    // Arrow stem
    'M', x + w * 0.5, y, 'L', x + w * 0.5, y + h * 0.7,
    // Arrow head
    'M', x + w * 0.3, y + h * 0.5, 'L', x + w * 0.5, y + h * 0.7, 'L', x + w * 0.7, y + h * 0.5,
    // Box
    'M', x, y + h * 0.9, 'L', x, y + h, 'L', x + w, y + h, 'L', x + w, y + h * 0.9];
  };
}

function getExporting() {
  if (__WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].getters['app/isLayoutMobile']) {
    return {
      enabled: false
    };
  }
  return {
    enabled: false
  };
}

var ContractChartGroupStock = function () {
  function ContractChartGroupStock(_ref2) {
    var market = _ref2.market,
        timeline = _ref2.timeline,
        data = _ref2.data,
        _ref2$chartOptions = _ref2.chartOptions,
        chartOptions = _ref2$chartOptions === undefined ? {} : _ref2$chartOptions,
        _ref2$prepare = _ref2.prepare,
        prepare = _ref2$prepare === undefined ? true : _ref2$prepare;

    __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_classCallCheck___default()(this, ContractChartGroupStock);

    this.market = market;
    this.contracts = market.contracts;
    this.timeline = timeline;
    this.data = data;
    this.contractXaxis = [];
    this.volume = [];
    this.stock = [];
    this.lastXaxisLabelIndex = 0;
    this.contractXaxis = [];
    this.chartOptions = chartOptions;
    if (prepare) this.prepareChartGroupData();
  }

  __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_createClass___default()(ContractChartGroupStock, [{
    key: 'isTimelineDaily',
    value: function isTimelineDaily() {
      return this.timeline.includes('h');
    }
  }, {
    key: 'prepareDateString',
    value: function prepareDateString(contractData, index, total) {
      var label = void 0;
      if (this.isTimelineDaily()) {
        var value = -(total - index);
        label = value + 'h';
      } else {
        label = __WEBPACK_IMPORTED_MODULE_17_moment___default()(contractData.date).format(DATE_MONTHLY_FORMAT);
      }
      this.contractXaxis[index] = label;
    }
  }, {
    key: 'prepareChartGroupData',
    value: function prepareChartGroupData() {
      var _this = this;

      this.data.forEach(function (item, index) {
        _this.prepareDateString(item, index, _this.data.length);
        _this.prepareSeries(index, item);
      });
    }
  }, {
    key: 'getCandleStickChartData',
    value: function getCandleStickChartData() {
      var name = this.data.length > 0 ? this.data[0].contractName : '';
      var that = this;
      return {
        id: 'candle',
        type: 'candlestick',
        showInLegend: false,
        data: this.stock,
        name: name,
        yAxis: 0,
        tooltip: {
          valueSuffix: '¢',
          pointFormatter: function volumeTooltipFormatter(i) {
            var point = {
              open: this.open,
              low: this.low,
              high: this.high,
              close: this.close,
              date: that.contractXaxis[this.index]
            };
            return '<small>' + point.date + '</small><br><b>Open</b>: ' + point.open + '\xA2<br/><b>High</b>: ' + point.high + '\xA2<br/><b>Low</b>: ' + point.low + '\xA2<br/><b>Close</b>: ' + point.close + '\xA2';
          }
        }
      };
    }
  }, {
    key: 'getVolumeChartData',
    value: function getVolumeChartData() {
      var that = this;
      return {
        id: 'volume',
        yAxis: 1,
        color: {
          linearGradient: [0, 0, 0, 92],
          stops: [[0, CONTRACT_BAR_CHART_GRADIENT_STOCK], [1, CONTRACT_BAR_CHART_GRADIENT_STOCK]]
        },
        data: this.volume,
        showInLegend: false,
        name: 'Total Volume',
        borderRadius: 2,
        type: 'column',
        tooltip: {
          pointFormatter: function volumeTooltipFormatter() {
            return '<small>' + that.contractXaxis[this.index] + '</small><br>Total Volume: <strong>' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_helpers__["x" /* largeNumberDisplay */])(this.y, false) + '</strong><br>';
          }
        }
      };
    }
  }, {
    key: 'prepareSeries',
    value: function prepareSeries(index, item) {
      var timestamp = +__WEBPACK_IMPORTED_MODULE_17_moment___default()(item.date);
      this.volume[index] = [timestamp, Number((item.tradeVolume || 0).toFixed(1))];
      this.stock[index] = [timestamp, Number((100 * (item.openSharePrice || 0)).toFixed(2)), Number((100 * (item.highSharePrice || 0)).toFixed(2)), Number((100 * (item.lowSharePrice || 0)).toFixed(2)), Number((100 * (item.closeSharePrice || 0)).toFixed(2))];
    }
  }, {
    key: 'getXaxisLabel',
    value: function getXaxisLabel() {
      var label = this.contractXaxis[this.lastXaxisLabelIndex];
      this.lastXaxisLabelIndex += 1;
      return label;
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var showVolume = __WEBPACK_IMPORTED_MODULE_16_lodash_get___default()(this.chartOptions, 'showVolume', false);
      var showPriceAxisZoom = __WEBPACK_IMPORTED_MODULE_16_lodash_get___default()(this.chartOptions, 'showPriceAxisZoom', true);
      var volume = this.getVolumeChartData();
      var series = [];
      var upColor = this.data.length > 0 ? this.data[0].lineColor : '#07a0bb';

      series.push(this.getCandleStickChartData());

      if (showVolume) {
        series.push(volume);
      }

      var max = undefined;
      var tickPositions = undefined;
      var values = [];

      if (series.length) {
        series[0].data.forEach(function (i) {
          values.push(i[1]);
        });
      }
      if (!showPriceAxisZoom || values.length && values.every(function (v) {
        return v === values[0];
      })) {
        max = 100;
        tickPositions = [0, 20, 40, 60, 80, 100, 120];
      }

      return {
        navigator: {
          enabled: false
        },
        scrollbar: {
          enabled: false
        },
        rangeSelector: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        title: {
          text: ''
        },
        credits: {
          enabled: false
        },
        xAxis: [{
          tickLength: 0,
          lineWidth: 0,
          labels: {
            formatter: function xAxisLabelFormatter() {
              return '';
            }
          }
        }],
        yAxis: [{
          height: showVolume ? '55%' : '100%',
          max: max,
          tickPositions: tickPositions,
          allowDecimals: false,
          labels: {
            style: { color: '#B6B6B6' },
            formatter: function yAxisLabelFormatter() {
              if (this.value >= 0) {
                return this.value + '\xA2';
              }
            }
          },
          title: {
            text: ''
          },
          resize: {
            enabled: true
          },
          opposite: true
        }, {
          visible: showVolume,
          top: '60%',
          height: '40%',
          offset: 0,
          tickPositions: getTradeVolumeTickPositions({
            data: volume.data.map(function (i) {
              return i[1];
            }),
            parts: 2,
            show: showVolume
          }),
          allowDecimals: false,
          labels: {
            style: { color: '#B6B6B6' },
            formatter: function yAxisOppositeLabelFormatter() {
              if (this.value >= 0) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_helpers__["x" /* largeNumberDisplay */])(this.value, false);
              }
            }
          },
          title: {
            text: ''
          },
          opposite: false
        }],
        plotOptions: {
          candlestick: {
            color: '#fff',
            upColor: upColor
          }
        },
        tooltip: {
          split: true,
          shared: false,
          headerFormat: ''
        },
        series: series,
        exporting: {
          enabled: false
        }
      };
    }
  }, {
    key: 'draw',
    value: function draw(container) {
      var options = this.getOptions();
      return Highcharts.stockChart(container, options);
    }
  }], [{
    key: 'renderTimeout',
    value: function renderTimeout() {
      return 300;
    }
  }]);

  return ContractChartGroupStock;
}();

var ContractChartGroup = function () {
  function ContractChartGroup(_ref3) {
    var market = _ref3.market,
        timeline = _ref3.timeline,
        data = _ref3.data,
        _ref3$chartOptions = _ref3.chartOptions,
        chartOptions = _ref3$chartOptions === undefined ? {} : _ref3$chartOptions,
        _ref3$prepare = _ref3.prepare,
        prepare = _ref3$prepare === undefined ? true : _ref3$prepare;

    __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_classCallCheck___default()(this, ContractChartGroup);

    this.market = market;
    this.contracts = market.contracts;
    this.timeline = timeline;
    this.data = data;
    this.contractSeries = {};
    this.contractSeriesNameId = {};
    this.volume = {};
    this.contractXaxis = [];
    this.priceLineType = 'line';
    this.volumeLineType = 'column';
    this.chartOptions = chartOptions;
    if (prepare) this.prepareChartGroupData();
  }

  __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_createClass___default()(ContractChartGroup, [{
    key: 'getVolumeChartData',
    value: function getVolumeChartData() {
      return {
        yAxis: 1,
        color: {
          linearGradient: [0, 0, 0, 92],
          stops: [[0, CONTRACT_BAR_CHART_GRADIENT], [1, CONTRACT_BAR_CHART_GRADIENT]]
        },
        data: __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_values___default()(this.volume).map(function (el) {
          return Number(el.toFixed(1));
        }),
        showInLegend: false,
        name: 'Total Volume',
        borderRadius: 2,
        type: this.volumeLineType,
        tooltip: {
          pointFormatter: function volumeTooltipFormatter() {
            return 'Total Volume: <strong>' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_helpers__["x" /* largeNumberDisplay */])(this.y, false) + '</strong><br>';
          }
        }
      };
    }
  }, {
    key: 'isTimelineDaily',
    value: function isTimelineDaily() {
      return this.timeline.includes('h');
    }
  }, {
    key: 'isMarkerEnabledForTimeline',
    value: function isMarkerEnabledForTimeline(seriesSize) {
      // if (store.getters['app/isLayoutMobile']) {
      //   return this.timeline === TAB_SEVEN_DAYS;
      // }
      // return seriesSize <= 30;
      return false;
    }
  }, {
    key: 'prepareLabels',
    value: function prepareLabels(item) {
      if (!(item.contractId in this.contractSeries)) {
        var color = item.additional ? item.additionalLineColor : item.lineColor;
        this.contractSeriesNameId[item.contractName] = item.contractId;
        this.contractSeries[item.contractId] = {
          color: color,
          lineWidth: 2,
          marker: {
            enabled: false,
            symbol: 'circle',
            fillColor: CONTRACT_LINE_CHART_MARKER_FILL_COLOR,
            lineWidth: 1,
            lineColor: null,
            radius: 5
          },
          data: [],
          yAxis: 0,
          showInLegend: false,
          name: item.contractName,
          contractId: item.contractId,
          type: this.priceLineType,
          tooltip: {
            valueSuffix: '¢'
          }
        };
      }
    }
  }, {
    key: 'prepareSeries',
    value: function prepareSeries(index, item) {
      this.contractSeries[item.contractId].data.push(item.chartPrice);
      // volume is build as sum of contracts
      // on particular points in time
      if (!(index in this.volume)) {
        this.volume[index] = 0;
      }
      if (item.tradeVolume) {
        this.volume[index] += item.tradeVolume;
      }
    }
  }, {
    key: 'prepareDateString',
    value: function prepareDateString(contractData, index) {
      if (this.isTimelineDaily()) {
        var value = -(index + 1);
        return value + 'h';
      }
      var dt = __WEBPACK_IMPORTED_MODULE_17_moment___default()(contractData.date);
      var dateYear = dt.year();
      var currentYear = __WEBPACK_IMPORTED_MODULE_17_moment___default()().year();
      var format = dateYear === currentYear ? DATE_MONTHLY_FORMAT : DATE_YEARLY_FORMAT;
      return __WEBPACK_IMPORTED_MODULE_17_moment___default()(contractData.date).format(format);
    }
  }, {
    key: 'prepareChartGroupData',
    value: function prepareChartGroupData() {
      var _this2 = this;

      var lastContractId = null;
      var lastContractIndex = 0;
      var dateStrings = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_set___default.a();

      this.data.forEach(function (item, index) {
        if (index === 0 || item.contractId !== lastContractId) {
          lastContractIndex = 0;
        }
        dateStrings.add(_this2.prepareDateString(item, lastContractIndex));
        _this2.prepareLabels(item);
        _this2.prepareSeries(lastContractIndex, item);
        lastContractIndex += 1;
        lastContractId = item.contractId;
      });
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default()(this.contractSeries)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref4 = _step.value;

          var _ref5 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray___default()(_ref4, 2);

          var key = _ref5[0];
          var value = _ref5[1];

          this.contractSeries[key].marker.enabled = this.isMarkerEnabledForTimeline(this.contractSeries[key].data.length);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.contractXaxis = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_array_from___default()(dateStrings);
      // we relate to 24h hour format so respacting prepareDateString method
      // we have to reverse
      if (this.isTimelineDaily()) {
        this.contractXaxis = this.contractXaxis.reverse();
      }
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var showVolume = __WEBPACK_IMPORTED_MODULE_16_lodash_get___default()(this.chartOptions, 'showVolume', false);
      var showPriceAxisZoom = __WEBPACK_IMPORTED_MODULE_16_lodash_get___default()(this.chartOptions, 'showPriceAxisZoom', true);
      var showContractImagesOnChart = __WEBPACK_IMPORTED_MODULE_16_lodash_get___default()(this.chartOptions, 'showContractImagesOnChart', false);
      var volume = this.getVolumeChartData();
      var series = [];
      var isMobile = __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].getters['app/isLayoutMobile'];
      var totalContractSeries = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(this.contractSeries).length;

      if (showVolume) {
        series.push(volume);
      }

      __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_values___default()(this.contractSeries).forEach(function (contractSeries) {
        if (!showContractImagesOnChart && contractSeries.data.length > 0) {
          var data = contractSeries.data.slice();
          var lastIdx = data.length - 1;
          data[lastIdx] = {
            y: data[lastIdx],
            marker: {
              enabled: true,
              radius: 5,
              fillColor: contractSeries.color,
              lineWidth: 0
            }
          };
          series.push(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, contractSeries, { data: data }));
        } else {
          series.push(contractSeries);
        }
      });

      var max = undefined;
      var tickPositions = undefined;
      var endOnTick = false;
      var maxes = [];
      var sliceIndex = showVolume ? 1 : 0;

      series.slice(sliceIndex).forEach(function (i) {
        var values = i.data.map(function (p) {
          return (typeof p === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(p)) === 'object' && p !== null ? p.y : p;
        });
        maxes.push(Math.max.apply(null, values));
      });
      var totalMax = Math.max.apply(null, maxes);

      if (totalMax < 80) {
        endOnTick = true;
      }
      if (!showPriceAxisZoom || totalContractSeries === 1 && series[sliceIndex].data.every(function (v) {
        return v === series[sliceIndex].data[0];
      })) {
        max = 100;
        tickPositions = [0, 25, 50, 75, 100];
      }

      return {
        chart: {
          marginLeft: showVolume ? undefined : 0
        },
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        tooltip: {
          shared: true,
          outside: __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].getters['app/isLayoutDesktop'],
          formatter: function tooltipFormatter() {
            var points = this.points;
            var pricePoints = points.filter(function (p) {
              return p.series.name !== 'Total Volume';
            });
            var volumePoint = points.find(function (p) {
              return p.series.name === 'Total Volume';
            });

            pricePoints.sort(function (a, b) {
              return b.y - a.y;
            });

            var s = '<b>' + points[0].key + '</b><br/>';
            if (volumePoint) {
              s += 'Total Volume: <strong>' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_helpers__["x" /* largeNumberDisplay */])(volumePoint.y, false) + '</strong><br>';
            }
            pricePoints.forEach(function (p) {
              s += '<span style="color:' + p.color + '">\u25CF</span> ' + p.series.name + ': <b>' + p.y + '\xA2</b><br/>';
            });

            return s;
          }
        },
        credits: {
          enabled: false
        },
        yAxis: [{
          tickPositions: tickPositions,
          max: max,
          endOnTick: endOnTick,
          tickAmount: tickPositions ? undefined : 5,
          allowDecimals: false,
          title: { text: '' },
          gridLineWidth: 1,
          gridLineDashStyle: 'Dot',
          gridLineColor: '#c8c8c8',
          labels: {
            x: CHART_GROUP_STOCK_XAXIS_LABEL_X_SPACING,
            style: { color: '#B6B6B6' },
            formatter: function yAxisLabelFormatter() {
              if (this.value >= 0) {
                return this.value + '\xA2';
              }
            }
          },
          opposite: true
        }, {
          allowDecimals: false,
          tickPositions: getTradeVolumeTickPositions({
            data: volume.data,
            parts: 4,
            show: showVolume
          }),
          title: {
            text: ''
          },
          gridLineWidth: 0,
          tickInterval: 5,
          labels: {
            x: -1 * CHART_GROUP_STOCK_XAXIS_LABEL_X_SPACING,
            style: {
              opacity: showVolume ? 1 : 0,
              color: '#B6B6B6'
            },
            formatter: function yAxisOppositeLabelFormatter() {
              if (this.value >= 0) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_helpers__["x" /* largeNumberDisplay */])(this.value, false);
              }
            }
          }
        }],
        xAxis: [{
          categories: this.contractXaxis,
          min: 0,
          max: this.contractXaxis.length > 0 ? this.contractXaxis.length - 0.5 : undefined,
          crosshair: true,
          tickLength: 0,
          lineWidth: 0,
          labels: {
            style: { color: '#B6B6B6' }
          },
          tickPositioner: function tickPositioner() {
            var desktopBreak = 10;
            if (isMobile && this.categories && this.categories.length > 2) {
              return [0, Math.floor(this.categories.length / 2), this.categories.length - 1];
            }
            if (!isMobile && this.categories && this.categories.length > desktopBreak) {
              var length = this.categories.length;
              var positions = [];
              for (var k = 0; k < desktopBreak; k++) {
                positions.push(Math.round(k * (length - 1) / (desktopBreak - 1)));
              }
              return positions;
            }
            return this.tickPositions;
          }
        }],
        series: series,
        plotOptions: {
          series: {
            cursor: 'pointer',
            stickyTracking: false,
            pointPlacement: 'on'
          },
          line: {
            allowPointSelect: false
          },
          column: {
            allowPointSelect: false,
            pointPadding: 0,
            groupPadding: 0
          }
        },
        exporting: getExporting.bind(this)()
      };
    }
  }, {
    key: 'draw',
    value: function draw(container) {
      var _this3 = this;

      var options = this.getOptions();
      return Highcharts.chart(container, options, function (chart) {
        var xAxis = chart.xAxis[0];
        var yAxis = chart.yAxis[0];

        if (__WEBPACK_IMPORTED_MODULE_16_lodash_get___default()(_this3.chartOptions, 'showContractImagesOnChart', false)) {
          chart.series.forEach(function (s) {
            if (s.type === 'line') {
              var lastPoint = s.data[s.data.length - 1];
              var lastX = xAxis.toPixels(lastPoint.x);
              var lastY = yAxis.toPixels(lastPoint.y);
              var contractId = _this3.contractSeriesNameId[lastPoint.series.name];
              var contract = _this3.market.contracts.find(function (i) {
                return i.contractId === contractId;
              });
              if (contract) {
                var instance = new MarketContractImageComponent({
                  propsData: {
                    contract: contract,
                    color: lastPoint.series.color
                  }
                });
                instance.$mount();
                chart.renderer.text(instance.$el.outerHTML, lastX + 7, lastY - 5, true).add();
              }
            }
          });
        }
      });
    }
  }], [{
    key: 'renderTimeout',
    value: function renderTimeout() {
      return 300;
    }
  }]);

  return ContractChartGroup;
}();

var PriceChangeChart = function () {
  function PriceChangeChart(contract, data) {
    __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_classCallCheck___default()(this, PriceChangeChart);

    this.contract = contract;
    this.data = data;
    this.colorPositive = '#7dc671';
    this.colorNegative = '#c63540';
    this.colorGrid = '#fff';
    this.lineWidth = 1;
    this.lineType = 'line';
  }

  __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_createClass___default()(PriceChangeChart, [{
    key: 'getSeries',
    value: function getSeries() {
      var seriesData = this.data.map(function (el) {
        return 50 - (el.closeSharePrice || 0.5) * 100;
      });
      return [{
        data: seriesData,
        lineWidth: this.lineWidth,
        type: this.lineType,
        color: this.colorPositive,
        negativeColor: this.colorNegative,
        marker: { enabled: false, states: { hover: { enabled: false } } },
        states: { hover: { enabled: false } }
      }];
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      return {
        chart: {
          margin: [0, 0, 0, 0],
          spacingTop: 0,
          spacingBottom: 0,
          spacingLeft: 0,
          spacingRight: 0
        },
        plotOptions: {},
        legend: { enabled: false },
        credits: { enabled: false },
        tooltip: { enabled: false },
        series: this.getSeries(),
        title: { text: '', style: { display: 'none' }, margin: 0 },
        yAxis: { labels: { enabled: false }, gridLineColor: this.colorGrid },
        xAxis: { labels: { enabled: false }, gridLineColor: this.colorGrid },
        exporting: {
          enabled: false
        }
      };
    }
  }, {
    key: 'draw',
    value: function draw(container) {
      var options = this.getOptions();
      Highcharts.chart(container, options);
    }
  }], [{
    key: 'renderTimeout',
    value: function renderTimeout() {
      return 300;
    }
  }]);

  return PriceChangeChart;
}();

var ElectionMapChartOverall = function () {
  function ElectionMapChartOverall(data) {
    __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_classCallCheck___default()(this, ElectionMapChartOverall);

    this.data = data;
  }

  __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_createClass___default()(ElectionMapChartOverall, [{
    key: 'draw',
    value: function draw(container) {
      var options = this.getOptions();
      Highcharts.mapChart(container, options);
    }
  }, {
    key: 'getColorValue',
    value: function getColorValue(_ref6) {
      var marketData = _ref6.marketData,
          stateCode = _ref6.stateCode,
          stateName = _ref6.stateName,
          stateVotes = _ref6.stateVotes;

      if (!marketData.contracts) return 0;
      var targetContract = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_helpers__["s" /* getLeadingTradedContract */])(marketData.contracts);
      if (!targetContract || targetContract.lastTradePrice === 0.5) return 0;
      return targetContract.name === 'Democratic' ? 1 : 2;
    }
  }, {
    key: 'formatTooltip',
    value: function formatTooltip() {
      var index = this.point.index;
      var data = this.point.series.userOptions.data[index];
      var marketData = data.marketData;

      if (!marketData.contracts) return false;
      var instance = new MarketStateTooltipComponent({
        propsData: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, data)
      });
      instance.$mount();
      return instance.$el.outerHTML;
    }
  }, {
    key: 'formatDataLabel',
    value: function formatDataLabel() {
      if (this.point.stateCode === 'HI') return '';
      var contracts = this.point.marketData.contracts || [];
      var targetContract = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_helpers__["s" /* getLeadingTradedContract */])(contracts);
      var stateCode = this.point.properties['hc-a2'];
      var showStates = ['VT', 'NH', 'MA', 'RI', 'CT', 'NJ', 'DE', 'MD', 'DC'];
      if (!targetContract) {
        if (contracts.length > 0) {
          return '-';
        }
        return showStates.includes(stateCode) ? stateCode : '';
      }
      var contract = new __WEBPACK_IMPORTED_MODULE_26__models_contract__["a" /* default */](targetContract);
      return contract.lastTradePriceAsCents + '\xA2';
    }
  }, {
    key: 'prepareSeries',
    value: function prepareSeries() {
      var _this4 = this;

      var mapData = Highcharts.geojson(Highcharts.maps['countries/us/custom/us-small']);
      var statesData = [];

      mapData.forEach(function (value, index) {
        var path = value.geometry.coordinates;
        var copy = {
          path: path
        };

        if (path[0][1] === 9727) {
          Highcharts.seriesTypes.map.prototype.getBox.call({}, [copy]);
          value.middleX = ((path[0][1] + path[1][1]) / 2 - copy._minX) / (copy._maxX - copy._minX);
          value.middleY = ((path[0][2] + path[2][2]) / 2 - copy._minY) / (copy._maxY - copy._minY);
        }

        var stateCode = value.properties['hc-a2'];
        var stateName = value.name.toUpperCase();
        var marketData = _this4.data[stateCode] || {};
        value.stateName = stateName;
        var stateVotes = __WEBPACK_IMPORTED_MODULE_25__constants__["a" /* default */].statesCodeToElectoralVotesMap[stateCode];

        statesData[index] = {
          stateCode: stateCode,
          stateName: stateName,
          stateVotes: stateVotes,
          marketData: marketData,
          value: _this4.getColorValue({ marketData: marketData, stateCode: stateCode, stateName: stateName, stateVotes: stateVotes })
        };
      });

      return { mapData: mapData, statesData: statesData };
    }
  }, {
    key: 'getBaseOptions',
    value: function getBaseOptions(_ref7) {
      var mapData = _ref7.mapData,
          statesData = _ref7.statesData;

      return {
        plotOptions: {
          series: {
            cursor: 'pointer',
            dataLabels: {
              style: {
                textOutline: 0
              }
            }
          }
        },
        exporting: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        mapNavigation: {
          enabled: false,
          enableButtons: false
        },
        xAxis: {
          labels: {
            enabled: false
          }
        },
        title: {
          text: ''
        },
        chart: {
          margin: [0, 0, 0, 0],
          spacing: [0, 0, 0, 0]
        },
        colorAxis: {
          dataClasses: [, {
            from: 0,
            to: 0,
            color: '#c8c8c8',
            name: 'N/A'
          }, {
            from: 1,
            to: 1,
            color: '#2f88dc',
            name: 'Clinton'
          }, {
            from: 2,
            to: 2,
            color: '#bc1500',
            name: 'Trump'
          }]
        },
        tooltip: {
          enabled: __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].getters['app/isLayoutDesktop'],
          formatter: this.formatTooltip,
          hideDelay: 200,
          useHTML: true,
          borderRadius: 0,
          borderWidth: 0,
          backgroundColor: 'white',
          padding: 0,
          shadow: false,
          followPointer: true
        },
        series: [{
          mapData: mapData,
          data: statesData,
          joinBy: 'stateName',
          name: 'States',
          events: {
            mouseOut: function mouseOut(e) {
              __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].dispatch('market/setMarketMapTooltipVisible', false);
            },
            click: function click(e) {
              var marketId = __WEBPACK_IMPORTED_MODULE_16_lodash_get___default()(e, 'point.marketData.marketId', null);
              if (marketId) {
                window.location.href = 'https://www.predictit.org/markets/detail/' + marketId;
                // router.push({
                //   name: 'market-details',
                //   params: {
                //     marketId,
                //   }
                // });
              }
            }
          },
          dataLabels: {
            enabled: true,
            formatter: this.formatDataLabel,
            style: {
              fontSize: __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].getters['app/isLayoutMobile'] ? '10px' : '12px',
              color: 'white'
            }
          }
        }, {
          name: 'Separators',
          type: 'mapline',
          data: Highcharts.geojson(Highcharts.maps['countries/us/custom/us-small'], 'mapline'),
          color: 'silver',
          showInLegend: false,
          enableMouseTracking: false
        }]
      };
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var _prepareSeries = this.prepareSeries(),
          mapData = _prepareSeries.mapData,
          statesData = _prepareSeries.statesData;

      return this.getBaseOptions({ mapData: mapData, statesData: statesData });
    }
  }], [{
    key: 'renderTimeout',
    value: function renderTimeout() {
      return 300;
    }
  }]);

  return ElectionMapChartOverall;
}();

var ElectionMapChartParty = function (_ElectionMapChartOver) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ElectionMapChartParty, _ElectionMapChartOver);

  function ElectionMapChartParty() {
    __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_classCallCheck___default()(this, ElectionMapChartParty);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ElectionMapChartParty.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ElectionMapChartParty)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_createClass___default()(ElectionMapChartParty, [{
    key: 'getColorValue',
    value: function getColorValue(_ref8) {
      var marketData = _ref8.marketData,
          stateCode = _ref8.stateCode,
          stateName = _ref8.stateName,
          stateVotes = _ref8.stateVotes;

      if (!marketData.contracts) return 0;
      var targetContract = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_helpers__["s" /* getLeadingTradedContract */])(marketData.contracts);
      if (!targetContract) return 0;
      var pallette = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_pages_page_election_map_new_election_map_election_map_constants__["a" /* getColorForPalletteCandidate */])(targetContract.contractName);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_helpers__["i" /* roundToTwo */])(targetContract.lastTradePrice + pallette[0].from);
    }
  }, {
    key: 'getColorAxisStops',
    value: function getColorAxisStops() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_23__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].GRAY), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_23__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].BLUE), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_23__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].RED));
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var _prepareSeries2 = this.prepareSeries(),
          mapData = _prepareSeries2.mapData,
          statesData = _prepareSeries2.statesData;

      var options = this.getBaseOptions({ mapData: mapData, statesData: statesData });
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, options, {
        title: {
          text: ''
        },
        colorAxis: {
          min: 0,
          dataClasses: this.getColorAxisStops()
        }
      });
    }
  }]);

  return ElectionMapChartParty;
}(ElectionMapChartOverall);

var ElectionMapChartSenate = function (_ElectionMapChartOver2) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ElectionMapChartSenate, _ElectionMapChartOver2);

  function ElectionMapChartSenate() {
    __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_classCallCheck___default()(this, ElectionMapChartSenate);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ElectionMapChartSenate.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ElectionMapChartSenate)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_createClass___default()(ElectionMapChartSenate, [{
    key: 'getColorValue',
    value: function getColorValue(_ref9) {
      var marketData = _ref9.marketData,
          stateCode = _ref9.stateCode,
          stateName = _ref9.stateName,
          stateVotes = _ref9.stateVotes;

      var hardcodedDemocrats = ['CA', 'CT', 'HI', 'IL', 'MD', 'NY', 'OR', 'VT', 'WA'];
      var hardcodedRepublicans = ['AK', 'AL', 'AR', 'IA', 'ID', 'IN', 'KS', 'KY', 'LA', 'MO', 'ND', 'OK', 'SC', 'SD', 'UT'];
      if (hardcodedDemocrats.includes(stateCode)) {
        return __WEBPACK_IMPORTED_MODULE_23__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].BLUE[2].to;
      }
      if (hardcodedRepublicans.includes(stateCode)) {
        return __WEBPACK_IMPORTED_MODULE_23__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].RED[2].to;
      }
      if (!marketData.contracts) return 0;
      var targetContract = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_helpers__["s" /* getLeadingTradedContract */])(marketData.contracts);
      if (!targetContract) return 0;
      var pallette = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_pages_page_election_map_new_election_map_election_map_constants__["a" /* getColorForPalletteCandidate */])(targetContract.contractName);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_helpers__["i" /* roundToTwo */])(targetContract.lastTradePrice + pallette[0].from);
    }
  }, {
    key: 'formatDataLabel',
    value: function formatDataLabel() {
      // if (this.point.stateCode === 'HI') return '';
      var contracts = this.point.marketData.contracts || [];
      var targetContract = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_helpers__["s" /* getLeadingTradedContract */])(contracts);
      var stateCode = this.point.properties['hc-a2'];
      var showStates = ['VT', 'NH', 'MA', 'RI', 'CT', 'NJ', 'DE', 'MD', 'DC'];
      var markWhenRepublicansAhead = ['DE', 'IL', 'MA', 'NH', 'NJ', 'OR', 'RI', 'VA', 'MN', 'NM', 'MI', 'AL'];
      var markWhenDemocratsAhead = ['AZ', 'CO', 'ME', 'MT', 'NC', 'GA', 'IA', 'KS', 'AK', 'KY', 'SC', 'TX', 'AR', 'ID', 'LA', 'MS', 'NE', 'OK', 'SD', 'TN', 'WV', 'WY'];
      if (!targetContract) {
        if (contracts.length > 0) {
          return '-';
        }
        return showStates.includes(stateCode) ? stateCode : '';
        // return stateCode;
      }
      var contract = new __WEBPACK_IMPORTED_MODULE_26__models_contract__["a" /* default */](targetContract);

      var markPrice = targetContract.contractName === 'Republican' && markWhenRepublicansAhead.includes(stateCode) || targetContract.contractName === 'Democratic' && markWhenDemocratsAhead.includes(stateCode);
      if (markPrice) {
        return '<div>' + contract.lastTradePriceAsCents + '\xA2</div>';
      }

      return contract.lastTradePriceAsCents + '\xA2';
    }
  }, {
    key: 'formatTooltip',
    value: function formatTooltip() {
      var index = this.point.index;
      var data = this.point.series.userOptions.data[index];
      var marketData = data.marketData;

      if (!marketData.contracts) return false;
      var instance = new MarketStateTooltipComponent({
        propsData: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, data, {
          type: 'senate'
        })
      });
      instance.$mount();
      return instance.$el.outerHTML;
    }
  }, {
    key: 'getColorAxisStops',
    value: function getColorAxisStops() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_23__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].GRAY), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_23__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].BLUE), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_23__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].RED));
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var _prepareSeries3 = this.prepareSeries(),
          mapData = _prepareSeries3.mapData,
          statesData = _prepareSeries3.statesData;

      var options = this.getBaseOptions({ mapData: mapData, statesData: statesData });
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, options, {
        title: {
          text: ''
        },
        colorAxis: {
          min: 0,
          dataClasses: this.getColorAxisStops()
        }
      });
    }
  }]);

  return ElectionMapChartSenate;
}(ElectionMapChartOverall);

/***/ }),

/***/ "Q/ey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_menu_button_js__ = __webpack_require__("R1ks");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe4bf8da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_button_vue__ = __webpack_require__("rW2y");
function injectStyle (ssrContext) {
  __webpack_require__("UBij")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_menu_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe4bf8da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q334":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_multiselect_js__ = __webpack_require__("M32j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25ec894f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multiselect_vue__ = __webpack_require__("44Nf");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_multiselect_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25ec894f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multiselect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q4Vh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"mountEl"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q6IB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QNMw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NOTIFICATION_TRADE_CONFIRMED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NOTIFICATION_SIMPLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NOTIFICATION_ACCOUNT_FUNDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NOTIFICATION_MARKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NOTIFICATION_MARKET_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return NOTIFICATION_CONTRACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return NOTIFICATION_MARKET_OWNERSHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NOTIFICATION_CONTRACT_OWNERSHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NOTIFICATION_SHARES_TRADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NOTIFICATION_SITE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NOTIFICATION_TRADER_LEVEL_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return NOTIFICATION_PWMB_DEPOSIT_FINISHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NOTIFICATION_PWMB_DEPOSIT_SHOW_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return NOTIFICATION_PWMB_SHOW_ERROR; });
var NOTIFICATION_TRADE_CONFIRMED = 'tradeConfirmed_data';
var NOTIFICATION_SIMPLE = 'simple';
var NOTIFICATION_ACCOUNT_FUNDS = 'accountfunds_data';
var NOTIFICATION_MARKET = 'market_data';
var NOTIFICATION_MARKET_STATUS = 'market_status';
var NOTIFICATION_CONTRACT = 'contract_data';
var NOTIFICATION_MARKET_OWNERSHIP = 'marketOwnershipUpdate_data';
var NOTIFICATION_CONTRACT_OWNERSHIP = 'contractOwnershipUpdate_data';
var NOTIFICATION_SHARES_TRADED = 'notification_shares_traded';
var NOTIFICATION_SITE_STATUS = 'site_status';
var NOTIFICATION_TRADER_LEVEL_CHANGED = 'notification_trade_level_changed';
var NOTIFICATION_PWMB_DEPOSIT_FINISHED = 'notification_pwmb_deposit_finished';
var NOTIFICATION_PWMB_DEPOSIT_SHOW_CONFIRMATION = 'notification_pwmb_deposit_show_confirmation';
var NOTIFICATION_PWMB_SHOW_ERROR = 'notification_pwmb_show_error';

/***/ }),

/***/ "QV+F":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "QWrq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_range__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showHeader: {
      type: Boolean,
      default: true
    },
    num: {
      type: Number,
      default: 1
    }
  },
  computed: {
    dummyComponents: function dummyComponents() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash_range___default()(0, this.num);
    }
  }
});

/***/ }),

/***/ "QgOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_panel_js__ = __webpack_require__("GMue");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60aa162c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_panel_vue__ = __webpack_require__("MRk1");
function injectStyle (ssrContext) {
  __webpack_require__("PbpQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_panel_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60aa162c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QgYw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qo/9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qoh4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logger__ = __webpack_require__("G/BR");






var dashboardNotificationMixin = {
  props: {
    autoClose: {
      type: Boolean,
      required: false,
      default: false
    },
    closeButton: {
      type: Boolean,
      required: false,
      default: false
    },
    closeTimeout: {
      type: Number,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
    },
    data: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    theme: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      timeout: null,
      interacted: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['remove']), {
    onClose: function onClose() {
      this.remove(this.index);
    },
    onInteract: function onInteract() {
      this.interacted = true;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.$el.addEventListener('click', function () {
      return _this.onInteract();
    });
    if (this.autoClose && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__logger__["b" /* isDebugOn */])()) {
      this.timeout = setTimeout(function () {
        if (!_this.interacted) _this.onClose();
      }, this.closeTimeout);
    }
  },

  computed: {
    timeElapsed: function timeElapsed() {
      var elapsed = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(this.data.dateCreated).fromNow(true);
      return elapsed + ' ago';
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (dashboardNotificationMixin);

/***/ }),

/***/ "QrTx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_podcasts_js__ = __webpack_require__("Rx49");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_podcasts_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5063795a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_podcasts_vue__ = __webpack_require__("wSGJ");
function injectStyle (ssrContext) {
  __webpack_require__("h3sO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_podcasts_js__["b" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5063795a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_podcasts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R/N+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notifications_list_js__ = __webpack_require__("KUSN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fceef74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_list_vue__ = __webpack_require__("/3CK");
function injectStyle (ssrContext) {
  __webpack_require__("/s1U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notifications_list_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fceef74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R1ks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    arrow: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'sushi'
    },
    selected: {
      type: Boolean,
      default: false
    },
    filtersSelected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classModifier: function classModifier() {
      var _ref;

      return _ref = {
        'market-filters-menu-button': true,
        'market-filters-menu-button--active': this.active,
        'market-filters-menu-button--arrow': this.arrow,
        'market-filters-menu-button--selected': this.selected,
        'market-filters-menu-button--filters-selected': this.filtersSelected
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-filters-menu-button--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-filters-menu-button--' + this.type, this.type), _ref;
    }
  },
  methods: {
    click: function click(e) {
      e.stopPropagation();
      this.$emit('click', this.type);
    }
  }
});

/***/ }),

/***/ "R6p5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystring__ = __webpack_require__("1nuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_http__ = __webpack_require__("p1CT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__ = __webpack_require__("DECz");





/* harmony default export */ __webpack_exports__["a"] = ({
  getHeaders: function getHeaders() {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/Browse/Headers');
  },
  getFilters: function getFilters(headerId) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/Browse/Filters/' + headerId);
  },
  getFilteredMarkets: function getFilteredMarkets(headerId, itemsPerPage, page, filterIds, sort, sortParameter, dateFrom, dateTo) {
    var query = __WEBPACK_IMPORTED_MODULE_1_querystring___default.a.stringify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      itemsPerPage: itemsPerPage,
      page: page,
      filterIds: filterIds,
      sort: sort,
      sortParameter: sortParameter
    }, dateFrom && dateTo ? { dateFrom: dateFrom, dateTo: dateTo } : {}));
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/Browse/FilteredMarkets/' + headerId + '?' + query);
  },
  getNewArrivalMarkets: function getNewArrivalMarkets() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/Browse/FilteredMarkets/0?itemsPerPage=' + limit + '&page=1&filterIds=&sort=newest&excludeMarketsOutsidePriceLimit=true&sortParameter=');
  },
  getMostPredictedMarkets: function getMostPredictedMarkets() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/Browse/FilteredMarkets/0?itemsPerPage=' + limit + '&page=1&filterIds=&sort=traded&excludeMarketsOutsidePriceLimit=true&sortParameter=ALL');
  },
  getTrendingMarkets: function getTrendingMarkets() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/Browse/FilteredMarkets/0?itemsPerPage=' + limit + '&page=1&filterIds=&sort=traded&excludeMarketsOutsidePriceLimit=true&sortParameter=TODAY');
  },
  getBiggestMoverMarkets: function getBiggestMoverMarkets() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/Browse/FilteredMarkets/0?itemsPerPage=' + limit + '&page=1&filterIds=&sort=movers&excludeMarketsOutsidePriceLimit=true&sortParameter=TODAY');
  },
  getCarousel: function getCarousel() {
    var utmSource = __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__["a" /* default */].get('utm_source');
    if (utmSource) {
      utmSource = utmSource.value;
    }
    var utmCampaign = __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__["a" /* default */].get('utm_campaign');
    if (utmCampaign) {
      utmCampaign = utmCampaign.value;
    }
    var utmCode = __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__["a" /* default */].get('utm_code');
    if (utmCode) {
      utmCode = utmCode.value;
    }
    var PIReferral = __WEBPACK_IMPORTED_MODULE_3__helpers_sessionVars__["a" /* default */].get('PIReferral');
    if (PIReferral) {
      PIReferral = PIReferral.value;
    }
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/Browse/Carousel?promoCode=' + utmCode + '&marketingProgram=' + utmCampaign + '&marketingSource=' + utmSource + '&piReferral=' + PIReferral);
  },
  getSearch: function getSearch(query) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var itemsPerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;

    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/Browse/Search/' + query + '?page=' + page + '&itemsPerPage=' + itemsPerPage);
  },
  getHomePageGainModule: function getHomePageGainModule() {
    var isLoss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var days = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var contracts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/Browse/HomePage/GainModule?isLoss=' + isLoss + '&days=' + days + '&contracts=' + contracts);
  },
  getWidgets: function getWidgets() {
    // const url = process.env.USE_API_WRAPPER ?
    //   'api/Public/GetLiveData?url=/api/Browse/Widgets' :
    //   'api/Browse/Widgets';
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('/api/Browse/Widgets');
  },
  getStoriesNav: function getStoriesNav() {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/Browse/Stories/Nav');
  },
  getStoriesList: function getStoriesList(indexes) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/Browse/Stories/List?indexes=' + indexes.join(','));
  },
  getStory: function getStory(index) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/Browse/Stories/' + index);
  },
  getStoryDetail: function getStoryDetail(index) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/Browse/Stories/' + index + '/Detail');
  },
  getStaticPageDetail: function getStaticPageDetail(key) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/Browse/StaticPage/' + key);
  },
  getStaticPagePreview: function getStaticPagePreview(id) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/Browse/StaticPagePreview/' + id);
  },
  getStoryFullPreview: function getStoryFullPreview(id) {
    return __WEBPACK_IMPORTED_MODULE_2__services_api_http__["b" /* default */].get('api/Browse/StoryFullPreview/' + id);
  }
});

/***/ }),

/***/ "R7qn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RDqn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-modals"},[(_vm.isCurrentModal(_vm.MODALS.LOGIN))?_c('modal',{attrs:{"gtm":_vm.gtmLogin,"bodyClass":_vm.footerHideBodyClass,"closeButton":!_vm.isUserRestricted && _vm.canCloseAuth},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Login")]),_vm._v(" "),_c('account-login',{attrs:{"slot":"content","email":_vm.currentPopupOptions.email},slot:"content"}),_vm._v(" "),(!_vm.isUserRestricted && !_vm.isShutdownModeOn)?_c('account-login-footer',{attrs:{"slot":"footer"},slot:"footer"}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.FORGOTTEN))?_c('modal',{attrs:{"gtm":"forgotten","bodyClass":"modal__body--medium","closeButton":_vm.canCloseAuth},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Forgotten Password")]),_vm._v(" "),_c('account-forgotten',{attrs:{"slot":"content"},slot:"content"}),_vm._v(" "),_c('account-forgotten-footer',{attrs:{"slot":"footer"},slot:"footer"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ACCOUNT_ALREADY_EXISTS))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","closeButton":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Account Already Exists")]),_vm._v(" "),_c('account-already-exists',{attrs:{"slot":"content","email":_vm.currentPopupOptions.email},slot:"content"}),_vm._v(" "),_c('account-already-exists-footer',{attrs:{"slot":"footer"},slot:"footer"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ACCOUNT_ENABLE_CLASSIC))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","closeButton":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Enable PredictIt Classic")]),_vm._v(" "),_c('account-enable-classic-predictit',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.RESET_PASSWORD))?_c('modal',{attrs:{"gtm":"reset-password","bodyClass":"modal__body--medium","closeButton":_vm.canCloseAuth},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Reset Your Password")]),_vm._v(" "),_c('account-reset-password',{attrs:{"slot":"content","token":_vm.currentPopupOptions.token},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.REGISTER))?_c('modal',{attrs:{"gtm":_vm.gtmSignUp,"bodyClass":_vm.footerHideBodyClass,"closeButton":_vm.canCloseAuth},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Create an Account")]),_vm._v(" "),_c('account-register',{attrs:{"slot":"content"},slot:"content"}),_vm._v(" "),_c('account-register-footer',{attrs:{"slot":"footer"},slot:"footer"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.REGISTER_EXTERNAL))?_c('modal',{attrs:{"gtm":"SignUp-external","bodyClass":"modal__body--medium"},on:{"modalClose":function($event){return _vm.closeModalWithLogout()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Create an Account")]),_vm._v(" "),_c('account-register-external',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ACCOUNT_VERIFY))?_c('modal',{attrs:{"gtm":_vm.gtmAccountVerify,"bodyClass":"modal__body--medium"},on:{"modalClose":function($event){return _vm.closeAccountVerifyModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[(_vm.currentPopupOptions && _vm.currentPopupOptions.formType === _vm.constants.FORM_TYPE_IDV.SSN4IDV)?[_vm._v("\n          Identity Verification\n        ")]:[_vm._v("\n          Personal Details\n        ")]],2),_vm._v(" "),_c('account-details-verify',{attrs:{"slot":"content","formType":_vm.currentPopupOptions.formType || undefined,"trigger":_vm.currentPopupOptions.trigger || undefined},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.UPLOAD_ID))?_c('modal',{attrs:{"gtm":"upload-id","bodyClass":"modal__body--medium","headerClass":"modal__header--small modal__header--gray"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("We are unable to verfiy your identity")]),_vm._v(" "),_c('account-upload-id',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.UPLOAD_DOCUMENT))?_c('modal',{attrs:{"gtm":"upload-document","bodyClass":"modal__body--medium","headerClass":"modal__header--small modal__header--gray"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_vm._v("\n    >\n      "),_c('div',{attrs:{"slot":"header"},slot:"header"},[(_vm.currentPopupOptions.isPending)?[_vm._v("Identity Verification Pending ")]:[_vm._v("Document Upload Required ")]],2),_vm._v(" "),_c('account-upload-document',{attrs:{"slot":"content","source":_vm.currentPopupOptions.source,"isPending":_vm.currentPopupOptions.isPending,"isPopup":true},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.TAX_INFO))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","closeButton":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Tax Information")]),_vm._v(" "),_c('tax-info-notification',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ATTACH_TO_HOME))?_c('small-modal',{attrs:{"type":"top-alt","padding":false},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Add to Home Screen")]),_vm._v(" "),_c('attach-to-home',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ORIENTATION))?_c('modal',{attrs:{"bodyClass":"modal__body--full","closeButton":false,"fullScreen":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('orientation-info',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ACCOUNT_DETAIL_UPDATE) || _vm.isCurrentModal(_vm.MODALS.ACCOUNT_DETAIL_PASSWORD) || _vm.isCurrentModal(_vm.MODALS.ACCOUNT_DETAIL_PASSWORD_SET) || _vm.isCurrentModal(_vm.MODALS.ACCOUNT_ADDRESS_UPDATE))?_c('account-details-update-modal',{attrs:{"what":_vm.currentPopup}}):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ADD_FUNDS))?_c('modal',{attrs:{"bodyClass":"modal__body--quick-deposit modal__body--show-ready","closeButtonClass":"modal__close--quick-deposit","gtm":_vm.gtmAddFunds},on:{"modalClose":function($event){return _vm.addFundsClose()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Quick Deposit")]),_vm._v(" "),_c('add-funds-combined',{attrs:{"slot":"content","checkInstantCredit":_vm.currentPopupOptions.checkInstantCredit},slot:"content"}),_vm._v(" "),_c('add-funds-combined-footer',{attrs:{"slot":"footer"},slot:"footer"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.PAYMENT_SUCCESS))?_c('modal',{attrs:{"closeButton":!_vm.currentPopupOptions.noClose,"bodyClass":"modal__body--medium"},on:{"modalClose":function($event){return _vm.closePaymentSuccessModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.currentPopupOptions.title))]),_vm._v(" "),_c('generic-popup',{attrs:{"slot":"content"},slot:"content"},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('deposited'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button button--large button--submit button--full-width",on:{"click":_vm.paymentSuccessDone}},[_c('span',[_vm._v("\n              Done\n            ")])]),_vm._v(" "),_c('div',{staticClass:"app-modals__payment-success-get-in-actions"},[_vm._v("\n            Get in the action: "),_c('router-link',{attrs:{"to":{ name: 'market-list' }},nativeOn:{"click":function($event){return _vm.closePaymentSuccessModal($event)}}},[_vm._v("View All Markets")])],1)],1)])],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.PAYMENT_ERROR))?_c('modal',{attrs:{"bodyClass":"modal__body--medium"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.currentPopupOptions.title))]),_vm._v(" "),_c('generic-popup',{attrs:{"slot":"content"},slot:"content"},[_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.currentPopupOptions.error)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.currentPopupOptions.error)}}):_c('p',[_vm._v("Unfortunately, we could not process your payment.")])])])],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.POTENTIAL_PAYOUTS))?_c('potential-payouts',{attrs:{"market":_vm.currentPopupOptions.market},on:{"modalClose":function($event){return _vm.closeModal()}}}):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.MARKET_CONTRACT_STATS))?_c('market-contracts-stats-popup',{attrs:{"stats":_vm.currentPopupOptions.stats,"isFixed":_vm.currentPopupOptions.isFixed},on:{"modalClose":function($event){return _vm.closeModal()}}}):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_OFFERS_INDICATOR))?_c('offers-indicator-popup',{attrs:{"items":_vm.currentPopupOptions.items,"operationType":_vm.currentPopupOptions.operationType,"price":_vm.currentPopupOptions.price},on:{"modalClose":function($event){return _vm.closeSmallModal()}}}):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.RESEARCH))?_c('modal',{attrs:{"bodyClass":"modal__body--gray modal__body--medium","noPadding":true,"gtm":"research"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Research Opportunities")]),_vm._v(" "),_c('research',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.TWITTER))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","noPadding":true,"clickOutsideEnabled":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Latest Tweets")]),_vm._v(" "),_c('twitter-timeline',{attrs:{"slot":"content","inOverlay":true},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.NEWS_FEED))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","noPadding":true,"clickOutsideEnabled":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Latest News")]),_vm._v(" "),_c('news-feed',{attrs:{"slot":"content","inOverlay":true,"marketId":_vm.currentPopupOptions.marketId},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.PURCHASE_SUSHI_REVIEW))?_c('modal',{attrs:{"bodyClass":"modal__body--slim","noPadding":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Review and Confirm Order")]),_vm._v(" "),_c('purchase-review-and-confirm-sushi',{attrs:{"slot":"content","market":_vm.tradePopupOptions.market},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_SWIFT))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Info")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n        Text\n      ")])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_CVV))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Where is my CVV?")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("6M/o")}})])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_VERIFICATION_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),(_vm.currentPopupOptions.verificationStatus === 0)?_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          You need to have your identity verified in order to make a deposit. Click \"Verify\" to provide the necessary information.\n        ")]):_vm._e(),_vm._v(" "),(_vm.currentPopupOptions.verificationStatus === 1)?_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Some deposits and withdrawals will require us to perform an enhanced verification check. Click on \"Upgrade\" to prevent a delay in processing your transactions.\n        ")]):_vm._e(),_vm._v(" "),(_vm.currentPopupOptions.verificationStatus === 2)?_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Your identification documents are under review. We will notify you by email regarding your status within 72 hours of submission. You will be able to deposit funds once your identify has been confirmed. Thank you for your patience.\n        ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_ROUTING_NUMBER))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Sample Check")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/static/img/check.96fa935.jpg"),expression:"`/static/img/check.96fa935.jpg`"}]})])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_EDIT_IMAGE))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Change Profile Image")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('account-update-image')],1)]):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.INSIGHT))?_c('insight-modal',{on:{"modalClose":function($event){return _vm.closeModal()}}}):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.GENERIC))?_c('modal',{attrs:{"bodyClass":"modal__body--gray"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.currentPopupOptions.title))]),_vm._v(" "),_c('generic-popup',{attrs:{"slot":"content"},slot:"content"},[(_vm.currentPopupOptions.content)?_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n          "+_vm._s(_vm.currentPopupOptions.content)+"\n        ")]):_vm._e()])],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_MARKET_RULES))?_c('modal',{attrs:{"autoClose":false,"overlayTheme":"z-index-plus-one"},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.currentPopupOptions.title))]),_vm._v(" "),_c('div',{staticClass:"app-modals__rules",attrs:{"slot":"content"},slot:"content"},[_c('market-rules',{attrs:{"market":_vm.currentPopupOptions.market,"showExpanded":true,"dateEnd":_vm.currentPopupOptions.market.dateEndString,"rules":_vm.currentPopupOptions.market.rule}})],1)]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_GENERIC))?_c('small-modal',{attrs:{"autoClose":true},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.currentPopupOptions.title))]),_vm._v(" "),_c('generic-small-popup',{attrs:{"slot":"content"},slot:"content"},[(_vm.currentPopupOptions.content)?_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n          "+_vm._s(_vm.currentPopupOptions.content)+"\n        ")]):_vm._e()])],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.EXPORT_TRADE_HISTORY))?_c('small-modal',{attrs:{"padding":false},on:{"modalClose":function($event){return _vm.closeModalHideOverlay()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[(_vm.$route.query && _vm.$route.query.contractId)?[_vm._v("\n          Export Contract History\n        ")]:(_vm.$route.params.marketId && _vm.$route.params.marketId !== 'all')?[_vm._v("\n          Export Market History\n        ")]:[_vm._v("\n          Export Trade History\n        ")]],2),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('export-history',{attrs:{"kind":"trade"}})],1)]):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.EXPORT_TRANSACTION_HISTORY))?_c('small-modal',{attrs:{"padding":false},on:{"modalClose":function($event){return _vm.closeModalHideOverlay()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Export Transaction History")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('export-history',{attrs:{"kind":"transaction"}})],1)]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_USERNAME))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Username")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/static/img/avatar.9ff8844.svg"),expression:"`/static/img/avatar.9ff8844.svg`"}]}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n         A username is required to preserve your anominity when using third-party services.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_TRADE_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[(_vm.currentPopupOptions.completeInfo)?[_vm._v("\n          \"Net P/L\" is the sum of your profit/loss"),_c('br'),_vm._v(" and any trading fees. "),_c('br'),_c('br')]:_vm._e(),_vm._v("\n          Figures are calculated to the tenth of a cent, but rounded for display purposes.\n        ")],2)])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_OWNERSHIP_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Minimum Ownership")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Traders are required to purchase and maintain a minimum ownership of "+_vm._s(_vm.currentPopupOptions.shares)+" share"),(_vm.currentPopupOptions.shares > 1)?[_vm._v("s")]:_vm._e(),_vm._v(" in this contract.\n        ")],2)])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_ROI_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\nReturn on Investment (ROI) is calculated as the % gain or loss in the value of your portfolio over the time period. Deposits and withdrawals during that period are not included in this calculation. You must have a minimum portfolio value of $10 at both the beginning and end of the period to appear on the leaderboard.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_FEE_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\nThe fees listed here are the fees that PredictIt charges and do not include fees charged by any bank, crypto-network, or other 3rd party involved in transferring money.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_WINS_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          You are credited with a win whenever you sell a share at a profit.\n        ")]),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Trophies for Wins are awarded as follows:\n        ")]),_vm._v(" "),_c('leaderboards-trophy-pyramid')],1)]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_LEADERBOARDS_UPDATE_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Leaderboards are updated nightly. Your preference will be reflected in the next update.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_ANNOUNCEMENT))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Announcement")]),_vm._v(" "),_c('announcement',{attrs:{"slot":"content","announcement":_vm.currentPopupOptions.announcement},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_PUBLIC_PROFILE_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("About Your Profile")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          To make PredictIt more fun and social in the future we will allow traders to share information from their profiles. If there is anything you would rather keep private you can always mark it as hidden. On your profile pages hidden items are still shown but include an asterisk (*) to let you know they are hidden from other users.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_RESTRICTED_FUNDS_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Funds awarded as part of promotional offer cannot be withdrawn until traded.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_SHARE_INVITE_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Separate multiple email addresses with a semi-colon.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_MESSAGING_JOURNEY))?_c('small-modal',{attrs:{"closeButton":false}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('messaging-journey-info',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_PWMB_ACCOUNT_CONFIRM_DELETE))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Confirmation")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("\n          Are you sure you want to remove this bank authorization?\n        ")]),_vm._v(" "),_c('div',{staticClass:"add-funds-bank-transfer__buttons"},[_c('button',{staticClass:"button button--large button--primary button--full-width",on:{"click":function($event){$event.stopPropagation();return _vm.currentPopupOptions.onConfirm($event)}}},[_vm._v("\n            Yes\n          ")]),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width button--focused",attrs:{"autofocus":""},on:{"click":function($event){$event.stopPropagation();return _vm.closeSmallModal()}}},[_vm._v("\n            No\n          ")])])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_BADGES))?_c('modal',{attrs:{"headerClass":"modal__header--light modal__header--no-border","bodyClass":"modal__body--medium","autoClose":false},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Badges")]),_vm._v(" "),_c('account-badges-list',{staticClass:"modal__content--badges",attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_USER_PROFILE))?_c('modal',{attrs:{"headerClass":"modal__header--light modal__header--no-border","bodyClass":"modal__body--medium","autoClose":false},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('user-profile-overview-header',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('user-profile-overview',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_REPORT_USER))?_c('modal',{attrs:{"headerClass":"modal__header--light modal__header--no-border","bodyClass":"modal__body--medium","autoClose":false},on:{"modalClose":function($event){return _vm.closeUserReportModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Report User")]),_vm._v(" "),_c('user-report',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.COINBASE))?_c('small-modal',{attrs:{"wide":true,"padding":true},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n        Process Overview\n      ")]),_vm._v(" "),_c('coinbase-process-overview',{attrs:{"slot":"content","depositPayload":_vm.currentPopupOptions.depositPayload},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.collegeAffiliationEnabled && _vm.isCurrentModal(_vm.MODALS.COLLEGE_AFFILIATION))?_c('modal',{attrs:{"closeButton":!!_vm.currentPopupOptions.allowClose,"noPadding":true,"bodyClass":"modal__body--slim modal__body--show-ready modal__body--no-overflow"},on:{"modalClose":_vm.closeAffiliationsModal}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("College Affiliation")]),_vm._v(" "),_c('affiliations-popup',{attrs:{"slot":"content"},on:{"affiliationsSubmitted":_vm.onAffiliationsSubmitted},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.VIDEO))?_c('modal',{on:{"modalClose":_vm.closeModal}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.currentPopupOptions.title))]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('br'),_vm._v(" "),_c('youtube',{attrs:{"player-width":"100%","player-height":400,"video-id":_vm.currentPopupOptions.id}}),_vm._v(" "),_c('div',{staticClass:"app-modals__note"},[_vm._v("\n        For more information on how to trade on PredictIt, visit our "),_c('router-link',{staticClass:"app-modals__note-link",attrs:{"to":{name: 'HelpAndSupport'}}},[_vm._v("Support")]),_vm._v(" page.\n        ")],1)],1)]):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.MARKET_OWNERSHIP_CONFLICT))?_c('modal',{attrs:{"bodyClass":"modal__body--large","noPadding":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Market Ownership Conflict")]),_vm._v(" "),_c('market-ownership-conflict-modal',{attrs:{"slot":"content","restrictions":_vm.currentPopupOptions.restrictions,"restrictionPreamble":_vm.currentPopupOptions.restrictionPreamble},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_SHARE_INFO))?_c('small-modal',{attrs:{"wide":true,"padding":false},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Info")]),_vm._v(" "),_c('share-info-popup',{attrs:{"slot":"content","item":_vm.currentPopupOptions.item},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_PAYOUT_INFO))?_c('small-modal',{attrs:{"wide":true,"padding":false},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Info")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          This is the estimated payout if your order is matched at the minimum sell price. Actual figures may differ if your order is matched at more favorable prices.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.TWO_FACTOR))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","closeButton":false},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Two-Factor Authentication")]),_vm._v(" "),_c('account-two-factor-verify',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.TWO_FACTOR_PROMPT))?_c('modal',{attrs:{"bodyClass":"modal__body--medium"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Security Recommendation")]),_vm._v(" "),_c('account-two-factor-prompt',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.PHONE_UPDATE))?_c('modal',{attrs:{"bodyClass":"modal__body--medium"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Update Phone Number")]),_vm._v(" "),_c('account-phone-update',{attrs:{"slot":"content"},on:{"close":function($event){return _vm.closeModal()},"verified":function($event){return _vm.closeModal()}},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.RECAPTCHA_CHALLENGE))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","closeButton":false}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Additional Verification Required")]),_vm._v(" "),_c('div',{staticClass:"recaptcha-challenge-modal",attrs:{"slot":"content"},slot:"content"},[(_vm.recaptchaVerifying)?[_c('div',{staticClass:"recaptcha-challenge-modal__loading"},[_c('div',{staticClass:"recaptcha-challenge-modal__spinner"}),_vm._v(" "),_c('p',{staticClass:"recaptcha-challenge-modal__message"},[_vm._v("\n              Verification successful! Processing your request...\n            ")])])]:[_c('p',{staticClass:"recaptcha-challenge-modal__message"},[_vm._v("\n            Please verify that you are not a robot to continue.\n          ")]),_vm._v(" "),_c('captcha',{key:_vm.currentPopupOptions.attempt || 1,on:{"input":_vm.onRecaptchaChallengeComplete}})]],2)]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_PRICE_ODDS))?_c('small-modal',{attrs:{"info":true,"closeButton":true},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Info")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('price-odds-toggle-popup'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button button--large button--black button--full-width",on:{"click":_vm.closeSmallModal}},[_c('span',[_vm._v("\n              Close\n            ")])])],1)]):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.CUSTOMIZE_YOUR_PREDICTIT))?_c('modal',{attrs:{"bodyClass":"modal__body--xlarge","noPadding":true},on:{"modalClose":function($event){return _vm.closeWhatIsNewPopup()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Customize Your PredictIt")]),_vm._v(" "),_c('what-is-new-popup',{attrs:{"slot":"content"},slot:"content"}),_vm._v(" "),_c('what-is-new-popup-footer',{attrs:{"slot":"footer"},slot:"footer"})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RJiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__ = __webpack_require__("5Oj8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");



/* eslint-disable max-len */




var WIDTH_PERCENTAGE_THRESHOLD = 5;

var getWidth = function getWidth(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["i" /* roundToTwo */])(value) * 100;
};
var checkThreshold = function checkThreshold(obj) {
  var value = parseInt(obj.width.replace('%', ''), 10);
  return value >= WIDTH_PERCENTAGE_THRESHOLD;
};

var updateCounters = function updateCounters(_ref) {
  var price = _ref.price,
      counter = _ref.counter,
      stateVotes = _ref.stateVotes;

  if (price <= __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["e" /* PRICE_FACTORS */].LOW) {
    counter.low += stateVotes;
  } else if (price <= __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["e" /* PRICE_FACTORS */].MEDIUM) {
    counter.medium += stateVotes;
  } else if (price <= __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["e" /* PRICE_FACTORS */].HIGH) {
    counter.high += stateVotes;
  }
  counter.total += stateVotes;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mapStateData: {},
    type: {}
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    isSenate: function isSenate() {
      return this.type === 'senate';
    },
    show: function show() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.mapStateData).length > 0;
    },
    barStyleModifiers: function barStyleModifiers() {
      // to right pad in case width does not equal 100
      var color = __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["c" /* COLOR_INDEXES */].HIGH].color;
      if (this.republican.high === 0) {
        color = __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["c" /* COLOR_INDEXES */].MEDIUM].color;
      }
      return {
        background: color
      };
    },
    democratLabelStyleModifiers: function democratLabelStyleModifiers() {
      return {
        color: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].BLUE[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["c" /* COLOR_INDEXES */].HIGH].color
      };
    },
    republicanLabelStyleModifiers: function republicanLabelStyleModifiers() {
      return {
        color: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["c" /* COLOR_INDEXES */].HIGH].color
      };
    },
    democratic: function democratic() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.mapStateData).filter(function (i) {
        var targetContract = _this.getTargetContract(i);
        return targetContract && targetContract.contractName === __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["d" /* CONTRACTS */].DEMOCRATIC;
      });
    },
    democraticCounters: function democraticCounters() {
      var _this2 = this;

      var counter = {
        total: 5,
        low: 0,
        medium: 0,
        high: 5,
        predefinedReal: 0
      };
      if (this.isSenate) {
        counter.predefined = 14; // wont be displayed, used to reserve width
        counter.predefinedReal = 36;
        // 5 demo
        // 12 repub
      }
      this.democratic.forEach(function (i) {
        var targetContract = _this2.getTargetContract(i);
        if (!targetContract) {
          return;
        }
        var stateVotes = _this2.isSenate ? 1 : i.stateVotes;
        updateCounters({
          counter: counter,
          price: targetContract.lastTradePrice,
          stateVotes: stateVotes
        });
      });
      return counter;
    },
    republican: function republican() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.mapStateData).filter(function (i) {
        var targetContract = _this3.getTargetContract(i);
        return targetContract && targetContract.contractName === __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["d" /* CONTRACTS */].REPUBLICAN;
      });
    },
    republicanCounters: function republicanCounters() {
      var _this4 = this;

      var counter = {
        total: 12,
        low: 0,
        medium: 0,
        high: 12,
        predefinedReal: 0
      };
      if (this.isSenate) {
        counter.predefined = 8; // wont be displayed, used to reserve width
        counter.predefinedReal = 29;
      }
      this.republican.forEach(function (i) {
        var targetContract = _this4.getTargetContract(i);
        if (!targetContract) {
          return;
        }
        var stateVotes = _this4.isSenate ? 1 : i.stateVotes;
        updateCounters({
          counter: counter,
          price: targetContract.lastTradePrice,
          stateVotes: stateVotes
        });
      });
      return counter;
    },
    totalVotes: function totalVotes() {
      return this.republicanCounters.total + this.democraticCounters.total;
    },
    democraticPredefinedBarSectionStyleModifiers: function democraticPredefinedBarSectionStyleModifiers() {
      return {
        width: getWidth(this.democraticCounters.predefined / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].BLUE[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["c" /* COLOR_INDEXES */].HIGH].color
      };
    },
    democraticHighBarSectionStyleModifiers: function democraticHighBarSectionStyleModifiers() {
      return {
        width: getWidth(this.democraticCounters.high / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].BLUE[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["c" /* COLOR_INDEXES */].HIGH].color
      };
    },
    democraticMediumBarSectionStyleModifiers: function democraticMediumBarSectionStyleModifiers() {
      return {
        width: getWidth(this.democraticCounters.medium / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].BLUE[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["c" /* COLOR_INDEXES */].MEDIUM].color
      };
    },
    democraticLowBarSectionStyleModifiers: function democraticLowBarSectionStyleModifiers() {
      return {
        width: getWidth(this.democraticCounters.low / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].BLUE[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["c" /* COLOR_INDEXES */].LOW].color
      };
    },
    republicanPredefinedBarSectionStyleModifiers: function republicanPredefinedBarSectionStyleModifiers() {
      return {
        width: getWidth(this.republicanCounters.predefined / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["c" /* COLOR_INDEXES */].HIGH].color
      };
    },
    republicanHighBarSectionStyleModifiers: function republicanHighBarSectionStyleModifiers() {
      return {
        width: getWidth(this.republicanCounters.high / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["c" /* COLOR_INDEXES */].HIGH].color
      };
    },
    republicanMediumBarSectionStyleModifiers: function republicanMediumBarSectionStyleModifiers() {
      return {
        width: getWidth(this.republicanCounters.medium / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["c" /* COLOR_INDEXES */].MEDIUM].color
      };
    },
    republicanLowBarSectionStyleModifiers: function republicanLowBarSectionStyleModifiers() {
      return {
        width: getWidth(this.republicanCounters.low / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_constants__["c" /* COLOR_INDEXES */].LOW].color
      };
    },
    showDemocraticHighText: function showDemocraticHighText() {
      return this.democraticCounters.high > 0 && checkThreshold(this.democraticHighBarSectionStyleModifiers);
    },
    showDemocraticMediumText: function showDemocraticMediumText() {
      return this.democraticCounters.medium > 0 && checkThreshold(this.democraticMediumBarSectionStyleModifiers);
    },
    showDemocraticLowText: function showDemocraticLowText() {
      return this.democraticCounters.low > 0 && checkThreshold(this.democraticLowBarSectionStyleModifiers);
    },
    showRepublicanHighText: function showRepublicanHighText() {
      return this.republicanCounters.high > 0 && checkThreshold(this.republicanHighBarSectionStyleModifiers);
    },
    showRepublicanMediumText: function showRepublicanMediumText() {
      return this.republicanCounters.medium > 0 && checkThreshold(this.republicanMediumBarSectionStyleModifiers);
    },
    showRepublicanLowText: function showRepublicanLowText() {
      return this.republicanCounters.low > 0 && checkThreshold(this.republicanLowBarSectionStyleModifiers);
    },
    showDemocraticPredefinedText: function showDemocraticPredefinedText() {
      return true;
    },
    showRepublicanPredefinedText: function showRepublicanPredefinedText() {
      return true;
    },
    majorityText: function majorityText() {
      if (this.isSenate) {
        return this.isLayoutDesktop ? '50 Seats' : '50';
      }
      return 'Majority';
    }
  }),
  methods: {
    getTargetContract: function getTargetContract(data) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["s" /* getLeadingTradedContract */])(data && data.contracts || []);
    }
  }
});

/***/ }),

/***/ "ROsZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_social_avatar_js__ = __webpack_require__("dOsu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40b58ade_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_social_avatar_vue__ = __webpack_require__("JwZy");
function injectStyle (ssrContext) {
  __webpack_require__("sl5T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_social_avatar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40b58ade_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_social_avatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RQ5D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_hero_unit_slider_js__ = __webpack_require__("L8Dv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_566a5c2b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_unit_slider_vue__ = __webpack_require__("kGUT");
function injectStyle (ssrContext) {
  __webpack_require__("7lSu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_hero_unit_slider_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_566a5c2b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_unit_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RU3U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_news_feed_item_js__ = __webpack_require__("ygM9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be52743_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_feed_item_vue__ = __webpack_require__("Ijuz");
function injectStyle (ssrContext) {
  __webpack_require__("X/wz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_news_feed_item_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be52743_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_feed_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rbeg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-login-footer"},[_c('div',{staticClass:"account-login-footer__title"},[_vm._v("\n    Don't have an account?\n  ")]),_vm._v(" "),_c('span',{staticClass:"account-login-footer__link",on:{"click":function($event){$event.preventDefault();return _vm.onCreateAccount($event)}}},[_vm._v("\n    Create an Account\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rjwe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MODALS; });
var MODALS = {
  LOGIN: 'login',
  FORGOTTEN: 'forgotten',
  RESET_PASSWORD: 'reset-password',
  REGISTER: 'register',
  REGISTER_EXTERNAL: 'register-external',
  ACCOUNT_VERIFY: 'account-verify',
  UPLOAD_ID: 'upload-id',
  TAX_INFO: 'tax-info',
  ATTACH_TO_HOME: 'attach-to-home',
  ACCOUNT_DETAIL_UPDATE: 'account-detail-update',
  ACCOUNT_DETAIL_PASSWORD: 'account-detail-password',
  ACCOUNT_DETAIL_PASSWORD_SET: 'account-detail-password-set',
  ACCOUNT_ADDRESS_UPDATE: 'account-address-update',
  ADD_FUNDS: 'add-funds',
  PAYMENT_SUCCESS: 'payment-success',
  PAYMENT_ERROR: 'payment-error',
  POTENTIAL_PAYOUTS: 'potential-payouts',
  MARKET_CONTRACT_STATS: 'market-contracts-stats',
  RESEARCH: 'research',
  TWITTER: 'twitter',
  NEWS_FEED: 'news-feed',
  PURCHASE: 'purchase-modal',
  PURCHASE_SUSHI: 'purchase-modal-sushi',
  PURCHASE_SUSHI_REVIEW: 'purchase-modal-review-sushi',
  INSIGHT: 'insight-modal',
  GENERIC: 'generic',
  EXPORT_TRADE_HISTORY: 'export-trade-history',
  EXPORT_TRANSACTION_HISTORY: 'export-transaction-history',
  COINBASE: 'coinbase',
  SMALL_CVV: 'cvv',
  SMALL_SWIFT: 'swift',
  SMALL_ROUTING_NUMBER: 'routing-number',
  SMALL_EDIT_IMAGE: 'edit-image',
  SMALL_MARKET_RULES: 'market-rules',
  SMALL_GENERIC: 'generic-small',
  SMALL_USERNAME: 'username',
  SMALL_TRADE_INFO: 'account-trade-info',
  SMALL_OFFERS_INDICATOR: 'offers-indicator',
  SMALL_VERIFICATION_INFO: 'verfication-info',
  SMALL_BADGES: 'badges',
  SMALL_USER_PROFILE: 'user-profile',
  SMALL_REPORT_USER: 'report-user',
  SMALL_ROI_INFO: 'roi-info',
  SMALL_FEE_INFO: 'fee-info',
  SMALL_WINS_INFO: 'wins-info',
  SMALL_LEADERBOARDS_UPDATE_INFO: 'leaderboards-update-info',
  SMALL_SHARE_INVITE_INFO: 'share-invite-info',
  SMALL_PUBLIC_PROFILE_INFO: 'public-profile-info',
  SMALL_RESTRICTED_FUNDS_INFO: 'restricted-funds-info',
  SMALL_ANNOUNCEMENT: 'announcement',
  UPLOAD_DOCUMENT: 'upload-document',
  ORIENTATION: 'orientation',
  SMALL_MESSAGING_JOURNEY: 'messaging-journey',
  SMALL_PWMB_ACCOUNT_CONFIRM_DELETE: 'pwmb-account-confirm-delete',
  COLLEGE_AFFILIATION: 'college-affiliation',
  VIDEO: 'video',
  ACCOUNT_ALREADY_EXISTS: 'account-already-exists',
  ACCOUNT_ENABLE_CLASSIC: 'account-enable-classic',
  MARKET_OWNERSHIP_CONFLICT: 'market-ownership-conflict',
  TWO_FACTOR: 'two-factor',
  TWO_FACTOR_PROMPT: 'two-factor-prompt',
  PHONE_UPDATE: 'phone-update',
  SMALL_PRICE_ODDS: 'small-price-odds',
  SMALL_PREDICTIT_INDEX: 'small-predictit-index',
  SMALL_OWNERSHIP_INFO: 'ownership-info',
  SMALL_SHARE_INFO: 'small-share-info',
  SMALL_DEPOSIT_NUMBER_INFORMATION: 'small-deposit-number-information',
  SMALL_OFFER_INFO: 'small-offer-info',
  RECAPTCHA_CHALLENGE: 'recaptcha-challenge',
  SMALL_PAYOUT_INFO: 'payout-info',
  CUSTOMIZE_YOUR_PREDICTIT: 'customize-your-predictit'
};

/* unused harmony default export */ var _unused_webpack_default_export = (MODALS);

/***/ }),

/***/ "Rlrl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_home_old_home_old_vue__ = __webpack_require__("3Uxo");




var account = function account() {
  return Promise.all/* import() */([__webpack_require__.e(2), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "O43h"));
};
var accountDetails = function accountDetails() {
  return Promise.all/* import() */([__webpack_require__.e(2), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "DbLG"));
};
var history = function history() {
  return Promise.all/* import() */([__webpack_require__.e(2), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "kNWi"));
};
var settings = function settings() {
  return Promise.all/* import() */([__webpack_require__.e(2), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "YCiF"));
};
var profilePage = function profilePage() {
  return Promise.all/* import() */([__webpack_require__.e(2), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "8nLW"));
};
var wallet = function wallet() {
  return Promise.all/* import() */([__webpack_require__.e(2), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "sBpB"));
};
var accountSocialAuth = function accountSocialAuth() {
  return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, "cEur"));
};
var pageLogin = function pageLogin() {
  return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, "8G+U"));
};
var pageForgottenPassword = function pageForgottenPassword() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(40)]).then(__webpack_require__.bind(null, "FezS"));
};
var pageRegister = function pageRegister() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, "gVgM"));
};
var pageTaxDetail = function pageTaxDetail() {
  return Promise.all/* import() */([__webpack_require__.e(25), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "xth1"));
};
var accountDisqus = function accountDisqus() {
  return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, "IwtE"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/account',
  component: account,
  props: true,
  meta: {
    requiresAuth: true
  },
  children: [{
    path: 'wallet',
    name: 'wallet',
    component: wallet
  }, {
    path: '',
    name: 'profile',
    component: profilePage,
    props: true
  }, {
    path: 'details',
    name: 'account-details',
    component: accountDetails
  }, {
    path: 'details/update',
    name: 'details-update',
    component: accountDetails
  }, {
    path: 'address/update',
    name: 'address-update',
    component: accountDetails
  }, {
    path: 'password/update',
    name: 'password-update',
    component: accountDetails
  }, {
    path: 'password/set',
    name: 'password-set',
    component: accountDetails
  }, {
    path: 'history/:marketId?',
    name: 'account-history',
    component: history,
    props: true
  }, {
    path: 'settings',
    name: 'account-settings',
    component: settings
  }]
}, {
  path: '/account/password/reset',
  name: 'reset-password',
  component: __WEBPACK_IMPORTED_MODULE_2__components_home_home_old_home_old_vue__["a" /* default */],
  beforeEnter: function beforeEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_1__components_app_app_modals_modals_constants__["a" /* MODALS */].RESET_PASSWORD);
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('popup/setCurrentPopupOptions', {
      token: to.query.token
    });
    next();
  },
  meta: {
    appContentOverflowed: true
  }
}, {
  path: '/account/social/auth',
  name: 'social-auth',
  component: accountSocialAuth
}, {
  path: '/account/disqus',
  name: 'disqus-auth',
  component: accountDisqus,
  props: true
}, {
  path: '/account/disqus/logout/:routeName/:routeParams?',
  name: 'disqus-logout',
  component: accountDisqus,
  props: true
}, {
  path: '/account/login',
  name: 'account-page-login',
  component: pageLogin,
  meta: {
    requiresAnonymous: true
  }
}, {
  path: '/account/sign-up',
  name: 'account-page-register',
  component: pageRegister,
  meta: {
    requiresAnonymous: true
  }
}, {
  path: '/account/password/forgotten',
  name: 'account-password-forgotten',
  component: pageForgottenPassword,
  meta: {
    requiresAnonymous: true
  }
}, {
  path: '/account/taxdetail',
  name: 'account-page-tax-detail',
  component: pageTaxDetail,
  meta: {
    requiresAuth: true
  }
}]);

/***/ }),

/***/ "Rm0x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RuD/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_overlay_js__ = __webpack_require__("Oota");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49fcfaf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overlay_vue__ = __webpack_require__("1l9m");
function injectStyle (ssrContext) {
  __webpack_require__("nBFw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_overlay_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49fcfaf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overlay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rx49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PODCAST; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_shuffle__ = __webpack_require__("yG5q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_shuffle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__("IcnI");






 /* eslint-disable max-len */





var TRACK_RESIZE_MIN_HEIGHT = 120;
var SWIPER_LAYOUT_REFRESH_DELAYS = [0, 120, 400];
var PODCAST_RESIZE_EVENT = 'cms:podcast-resize';
var PODCAST_LAYOUT_REFRESH_EVENT = 'cms:podcast-layout-refresh';
var STORY_COLLAPSED_HEIGHTS = {
  appleShow: { desktop: 450, mobile: 450 },
  appleEpisode: { desktop: 175, mobile: 175 },
  default: { desktop: 450, mobile: 450 }
};

var PODCAST = {
  ITUNES: 'itunes',
  SOUNDCLOUD: 'soundcloud',
  BACKTRACKS: 'backtracks',
  POLITICAN_TRADER: 'politicantrader',
  APPLE: 'apple',
  STITCHER: 'stitcher'
};

/* harmony default export */ __webpack_exports__["b"] = ({
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_8_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_8_vue_awesome_swiper__["swiperSlide"]
  },
  props: {
    title: {
      type: String,
      default: 'Featured Podcasts'
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    theme: {
      type: String,
      default: 'default'
    },
    forceLayoutMode: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var _this = this;

    var isLayoutMobile = this.forceLayoutMode === 'mobile' ? true : this.forceLayoutMode === 'desktop' ? false : __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['app/isLayoutMobile'];
    var defaultTracks = __WEBPACK_IMPORTED_MODULE_6_lodash_shuffle___default()([{ id: 'id1437934639', type: PODCAST.APPLE }, { id: 'id1496616116', type: PODCAST.APPLE }, { id: 'id1510570053', type: PODCAST.APPLE }, { id: 'id1136826256', type: PODCAST.APPLE }]
    // { id: '505391', type: PODCAST.STITCHER },
    // { id: '', type: PODCAST.POLITICAN_TRADER },
    // { id: 'https://soundcloud.com/stratfortalks', type: PODCAST.SOUNDCLOUD },
    // { id: 'stratfor/stratfor-quick-take/m/a-second-u-s-north-korea-summit', type: PODCAST.BACKTRACKS },
    // { id: '1437934639', type: PODCAST.ITUNES },
    );
    return {
      PODCAST: PODCAST,
      activeIndex: 0,
      isPlaying: true,
      providerTrackHeights: {},
      resizeObserver: null,
      layoutRefreshTimeouts: [],
      tracks: this.items.length > 0 ? this.items : this.theme === 'story' ? [] : defaultTracks,
      swiperOptions: {
        loop: false,
        autoHeight: true,
        autoplay: this.theme === 'story' || isLayoutMobile ? false : 5000,
        direction: 'horizontal',
        spaceBetween: 0,
        onTransitionStart: function onTransitionStart(swp) {
          var nextIndex = swp.activeIndex;
          var didSlideChange = nextIndex !== _this.activeIndex;
          _this.activeIndex = nextIndex;
          if (didSlideChange) {
            _this.queueSwiperLayoutRefresh({ speed: 0 });
          }
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    isLayoutMobileView: function isLayoutMobileView() {
      if (this.forceLayoutMode === 'mobile') {
        return true;
      }
      if (this.forceLayoutMode === 'desktop') {
        return false;
      }
      return this.isLayoutMobile;
    },
    isStoryTheme: function isStoryTheme() {
      return this.theme === 'story';
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({
        podcasts: true
      }, 'podcasts--' + this.theme, this.theme);
    },
    activeTrack: function activeTrack() {
      return this.tracks[this.activeIndex] || this.tracks[0] || null;
    },
    height: function height() {
      if (this.isStoryTheme) {
        return 450;
      }
      return this.isLayoutMobileView ? 450 : 400;
    },
    styleItunesIframe: function styleItunesIframe() {
      if (this.isLayoutMobileView) {
        return 'overflow-x:hidden;overflow-y:hidden;height:300px;border:0px';
      }
      return 'overflow-x:hidden;overflow-y:hidden;height:300px;border:0px;width:100%';
    },
    showArrows: function showArrows() {
      return this.tracks.length > 1;
    },
    isPrevArrowDisabled: function isPrevArrowDisabled() {
      return this.activeIndex === 0;
    },
    isNextArrowDisabled: function isNextArrowDisabled() {
      return this.activeIndex === this.tracks.length - 1;
    },
    prevArrowModifiers: function prevArrowModifiers() {
      return {
        'podcasts__header-arrow': true,
        'podcasts__header-arrow--left': true,
        'podcasts__header-arrow--disabled': this.isPrevArrowDisabled
      };
    },
    nextArrowModifiers: function nextArrowModifiers() {
      return {
        'podcasts__header-arrow': true,
        'podcasts__header-arrow--right': true,
        'podcasts__header-arrow--disabled': this.isNextArrowDisabled
      };
    }
  }),
  methods: {
    getResponsiveHeight: function getResponsiveHeight(heightMap) {
      return this.isLayoutMobileView ? heightMap.mobile : heightMap.desktop;
    },
    getSwiperInstance: function getSwiperInstance() {
      return this.$refs.swiper && this.$refs.swiper.swiper ? this.$refs.swiper.swiper : null;
    },
    clearPendingLayoutRefreshes: function clearPendingLayoutRefreshes() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.layoutRefreshTimeouts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var timeoutId = _step.value;

          clearTimeout(timeoutId);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.layoutRefreshTimeouts = [];
    },
    queueSwiperLayoutRefresh: function queueSwiperLayoutRefresh() {
      var _this2 = this;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$speed = _ref2.speed,
          speed = _ref2$speed === undefined ? 0 : _ref2$speed;

      this.clearPendingLayoutRefreshes();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(SWIPER_LAYOUT_REFRESH_DELAYS), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var delay = _step2.value;

          var timeoutId = setTimeout(function () {
            _this2.$nextTick(function () {
              _this2.updateSwiperLayout(speed);
            });
          }, delay);
          this.layoutRefreshTimeouts.push(timeoutId);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    emitResizeSignal: function emitResizeSignal() {
      window.dispatchEvent(new Event(PODCAST_RESIZE_EVENT));
    },
    isVisibleInLayout: function isVisibleInLayout() {
      return !!(this.$el && this.$el.offsetParent !== null);
    },
    isTrackEpisode: function isTrackEpisode() {
      var track = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return track.type === PODCAST.APPLE && track.id && track.id.includes('?i=');
    },
    getTrackKey: function getTrackKey() {
      var track = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return (track.type || 'unknown') + ':' + (track.id || index);
    },
    getMeasuredTrackHeight: function getMeasuredTrackHeight(track, index) {
      var key = this.getTrackKey(track, index);
      var measured = this.providerTrackHeights[key];
      if (typeof measured !== 'number' || measured < TRACK_RESIZE_MIN_HEIGHT) {
        return null;
      }
      return measured;
    },
    getCollapsedStoryHeight: function getCollapsedStoryHeight(track) {
      if (track && track.type === PODCAST.APPLE) {
        return this.getResponsiveHeight(this.isTrackEpisode(track) ? STORY_COLLAPSED_HEIGHTS.appleEpisode : STORY_COLLAPSED_HEIGHTS.appleShow);
      }
      return this.getResponsiveHeight(STORY_COLLAPSED_HEIGHTS.default);
    },
    getTrackHeight: function getTrackHeight(track, index) {
      if (!this.isStoryTheme) {
        return this.height;
      }
      var collapsedHeight = this.getCollapsedStoryHeight(track);
      var measuredHeight = this.getMeasuredTrackHeight(track, index);
      return measuredHeight ? Math.max(collapsedHeight, measuredHeight) : collapsedHeight;
    },
    getTrackFrameStyle: function getTrackFrameStyle(track, index) {
      return {
        width: '100%',
        minHeight: this.getTrackHeight(track, index) + 'px',
        height: this.getTrackHeight(track, index) + 'px'
      };
    },
    getActiveTrackHeight: function getActiveTrackHeight() {
      if (!this.isStoryTheme || !this.activeTrack) {
        return null;
      }
      return this.getTrackHeight(this.activeTrack, this.activeIndex);
    },
    syncStoryThemeFrameHeights: function syncStoryThemeFrameHeights() {
      if (!this.isStoryTheme || !this.$el) {
        return;
      }
      var activeHeight = this.getActiveTrackHeight();
      if (!activeHeight) {
        return;
      }
      var activeHeightPx = activeHeight + 'px';
      var container = this.$el.querySelector('.swiper-container');
      var wrapper = this.$el.querySelector('.swiper-wrapper');
      var slides = this.$el.querySelectorAll('.swiper-slide');

      if (container) {
        container.style.setProperty('height', activeHeightPx, 'important');
      }
      if (wrapper) {
        wrapper.style.setProperty('height', activeHeightPx, 'important');
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(slides).entries()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _ref3 = _step3.value;

          var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

          var index = _ref4[0];
          var slide = _ref4[1];

          if (index === this.activeIndex) {
            slide.style.setProperty('height', activeHeightPx, 'important');
            var iframe = slide.querySelector('iframe');
            if (iframe) {
              iframe.style.setProperty('height', activeHeightPx, 'important');
            }
          } else {
            slide.style.removeProperty('height');
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    updateSwiperLayout: function updateSwiperLayout() {
      var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var swiperInstance = this.getSwiperInstance();
      if (!swiperInstance) {
        return;
      }
      if (typeof swiperInstance.update === 'function') {
        swiperInstance.update();
      }
      if (typeof swiperInstance.updateSize === 'function') {
        swiperInstance.updateSize();
      }
      if (typeof swiperInstance.updateSlides === 'function') {
        swiperInstance.updateSlides();
      }
      if (typeof swiperInstance.updateAutoHeight === 'function') {
        swiperInstance.updateAutoHeight(speed);
      }
      this.syncStoryThemeFrameHeights();
    },
    onTrackFrameLoad: function onTrackFrameLoad() {
      var _this3 = this;

      this.queueSwiperLayoutRefresh({ speed: 0 });
      this.$nextTick(function () {
        _this3.syncStoryThemeFrameHeights();
      });
      this.emitResizeSignal();
    },
    handleExternalLayoutRefresh: function handleExternalLayoutRefresh() {
      var _this4 = this;

      if (!this.isVisibleInLayout()) {
        return;
      }
      this.queueSwiperLayoutRefresh({ speed: 0 });
      this.$nextTick(function () {
        _this4.syncStoryThemeFrameHeights();
        _this4.emitResizeSignal();
      });
    },
    extractHeightFromMessage: function extractHeightFromMessage(data) {
      if (typeof data === 'number' && data >= TRACK_RESIZE_MIN_HEIGHT) {
        return data;
      }
      if (typeof data === 'string') {
        try {
          return this.extractHeightFromMessage(JSON.parse(data));
        } catch (e) {
          var match = data.match(/height\s*[:=]\s*"?(\d{2,4})"?/i);
          if (match) {
            return parseInt(match[1], 10);
          }
          return null;
        }
      }
      if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data)) !== 'object' || data === null) {
        return null;
      }
      var candidateKeys = ['height', 'frameHeight', 'playerHeight'];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(candidateKeys), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var key = _step4.value;

          if (typeof data[key] === 'number' && data[key] >= TRACK_RESIZE_MIN_HEIGHT) {
            return data[key];
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (typeof data.data !== 'undefined') {
        return this.extractHeightFromMessage(data.data);
      }
      return null;
    },
    handleProviderMessage: function handleProviderMessage(event) {
      var _this5 = this;

      if (!this.isStoryTheme || !event || !event.origin || event.origin.indexOf('podcasts.apple.com') === -1) {
        return;
      }
      var activeTrack = this.activeTrack;
      if (!activeTrack || activeTrack.type !== PODCAST.APPLE) {
        return;
      }
      var nextHeight = this.extractHeightFromMessage(event.data);
      if (!nextHeight || nextHeight < TRACK_RESIZE_MIN_HEIGHT) {
        return;
      }
      var key = this.getTrackKey(activeTrack, this.activeIndex);
      this.$set(this.providerTrackHeights, key, Math.ceil(nextHeight));
      this.queueSwiperLayoutRefresh({ speed: 0 });
      this.$nextTick(function () {
        _this5.syncStoryThemeFrameHeights();
      });
      this.emitResizeSignal();
    },
    stopSwiper: function stopSwiper() {
      this.isPlaying = false;
      if (this.$refs.swiper && this.$refs.swiper.swiper) {
        this.$refs.swiper.swiper.stopAutoplay();
      }
    },
    startSwiper: function startSwiper() {
      this.isPlaying = true;
      if (this.$refs.swiper && this.$refs.swiper.swiper) {
        this.$refs.swiper.swiper.startAutoplay();
      }
    },
    getPoliticanTraderUrl: function getPoliticanTraderUrl() {
      return '//html5-player.libsyn.com/embed/destination/id/1822847/height/300/theme/custom/thumbnail/yes/direction/backward/no-cache/true/render-playlist/yes/custom-color/2607ab/';
    },
    getBacktracksUrl: function getBacktracksUrl(id) {
      return 'https://player.backtracks.fm/' + id;
    },
    getSoundCloudUrl: function getSoundCloudUrl(track) {
      return 'https://w.soundcloud.com/player/?url=' + track + '&auto_play=false&show_artwork=false';
    },
    getItunesUrl: function getItunesUrl(ids) {
      var width = this.isLayoutMobileView ? '290' : '476';
      var query = '?c=us&d=Test&t=Test&m=podcast&e=podcast&w=' + width + '&h=300&ids=' + ids + '&wt=playlist';
      return '//widgets.itunes.apple.com/widget.html' + query;
    },
    getAppleUrl: function getAppleUrl(id) {
      var separator = id.includes('?') ? '&' : '?';
      return 'https://embed.podcasts.apple.com/us/podcast/star-spangled-gamblers/' + id + separator + 'itsct=podcast_box&amp;itscg=30200';
    },
    getStitcherUrl: function getStitcherUrl(id) {
      return 'https://www.stitcher.com/embed/' + id;
    },
    prevSlide: function prevSlide() {
      if (!this.isPrevArrowDisabled && this.$refs.swiper && this.$refs.swiper.swiper) {
        this.$refs.swiper.swiper.slidePrev();
      }
    },
    nextSlide: function nextSlide() {
      if (!this.isNextArrowDisabled && this.$refs.swiper && this.$refs.swiper.swiper) {
        this.$refs.swiper.swiper.slideNext();
      }
    }
  },
  watch: {
    isLayoutMobileView: function isLayoutMobileView() {
      var _this6 = this;

      this.queueSwiperLayoutRefresh({ speed: 0 });
      this.$nextTick(function () {
        _this6.syncStoryThemeFrameHeights();
      });
      this.emitResizeSignal();
    },
    tracks: function tracks() {
      var _this7 = this;

      this.queueSwiperLayoutRefresh({ speed: 0 });
      this.$nextTick(function () {
        _this7.syncStoryThemeFrameHeights();
      });
      this.emitResizeSignal();
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    window.addEventListener('message', this.handleProviderMessage);
    window.addEventListener('resize', this.onTrackFrameLoad);
    window.addEventListener(PODCAST_LAYOUT_REFRESH_EVENT, this.handleExternalLayoutRefresh);

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(function () {
        _this8.queueSwiperLayoutRefresh({ speed: 0 });
      });
      this.resizeObserver.observe(this.$el);
    }

    this.queueSwiperLayoutRefresh({ speed: 0 });
    this.$nextTick(function () {
      _this8.syncStoryThemeFrameHeights();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('message', this.handleProviderMessage);
    window.removeEventListener('resize', this.onTrackFrameLoad);
    window.removeEventListener(PODCAST_LAYOUT_REFRESH_EVENT, this.handleExternalLayoutRefresh);
    this.clearPendingLayoutRefreshes();
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }
});

/***/ }),

/***/ "S1Yq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    autoClose: {
      type: Boolean,
      required: false,
      default: false
    },
    closeTimeout: {
      type: Number,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DEFAULT_SMALL_POPUP_TIMEOUT
    },
    closeButton: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      required: false,
      default: 'top'
    },
    padding: {
      type: Boolean,
      default: true
    },
    overlay: {
      type: Boolean,
      default: true
    },
    wide: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classModifier: function classModifier() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'modal-small--' + this.type, this.type), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'modal-small--wide', this.wide), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'modal-small--no-padding', !this.padding), _ref;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.autoClose && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__logger__["b" /* isDebugOn */])()) {
      setTimeout(function () {
        return _this.close();
      }, this.closeTimeout);
    }
  },

  methods: {
    close: function close() {
      this.$emit('modalClose');
    }
  },
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["m" /* lockModal */])();
  },
  beforeDestroy: function beforeDestroy() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["n" /* unLockModal */])();
  }
});

/***/ }),

/***/ "S2j1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S9O8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__("gGqR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__("G/BR");
 /* eslint-disable no-console */
/* global MobileApp:false */




/* harmony default export */ __webpack_exports__["a"] = ({
  userLoggedIn: function userLoggedIn(token) {
    if (__WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__["g" /* iOSWrapper */]) {
      window.location.href = 'pred://userLoggedIn?token=' + token;
    } else {
      if (typeof MobileApp === 'undefined') return;
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(MobileApp.userLoggedIn)) return;
      try {
        MobileApp.userLoggedIn.bind(MobileApp)(token);
      } catch (err) {
        __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].error(err);
      }
    }
  },
  userLoggedOut: function userLoggedOut() {
    if (__WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__["g" /* iOSWrapper */]) {
      window.location.href = 'pred://userLoggedOut';
    } else {
      if (typeof MobileApp === 'undefined') return;
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(MobileApp.userLoggedOut)) return;
      try {
        MobileApp.userLoggedOut.bind(MobileApp)();
      } catch (err) {
        __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].error(err);
      }
    }
  }
});

/***/ }),

/***/ "SBPi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketChartLoader_vue__ = __webpack_require__("r5bH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5902708_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketChartLoader_vue__ = __webpack_require__("P26B");
function injectStyle (ssrContext) {
  __webpack_require__("ckGe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketChartLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5902708_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketChartLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SHAV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotificationLoader_vue__ = __webpack_require__("5aqh");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__NotificationLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarketLoader_vue__ = __webpack_require__("fzCn");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__MarketLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MarketSharesItemLoader_vue__ = __webpack_require__("W9Re");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__MarketSharesItemLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MarketWidgetLoader_vue__ = __webpack_require__("ucfo");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__MarketWidgetLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BiggestGainsLoader_vue__ = __webpack_require__("ZC+n");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__BiggestGainsLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TableRowsLoader_vue__ = __webpack_require__("XMP4");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__TableRowsLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccountWithdrawalLoader_vue__ = __webpack_require__("d2fJ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__AccountWithdrawalLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccountFormLoader_vue__ = __webpack_require__("8YSH");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__AccountFormLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LeaderboardsInfoLoader_vue__ = __webpack_require__("2uhI");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__LeaderboardsInfoLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OverviewMapLoader_vue__ = __webpack_require__("8zAU");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__OverviewMapLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MarketChartLoader_vue__ = __webpack_require__("SBPi");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__MarketChartLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StaticPageLoader_vue__ = __webpack_require__("hk1B");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_11__StaticPageLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PreviewCarouselLoader_vue__ = __webpack_require__("hE3l");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_12__PreviewCarouselLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__MarketDetailPageLoader_vue__ = __webpack_require__("MSvJ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_13__MarketDetailPageLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SocialsLoader_vue__ = __webpack_require__("tel1");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_14__SocialsLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ContractInfoLoader_vue__ = __webpack_require__("+6DW");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_15__ContractInfoLoader_vue__["a"]; });
/* eslint-disable */


















/***/ }),

/***/ "SRAN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SRJW":
/***/ (function(module, exports) {

/* eslint-disable */

try {
  new MouseEvent('test');
} catch (e) {
  var MouseEvent = function MouseEvent(eventType, params) {
    params = params || { bubbles: false, cancelable: false };
    var mouseEvent = document.createEvent('MouseEvent');
    mouseEvent.initMouseEvent(eventType, params.bubbles, params.cancelable, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);

    return mouseEvent;
  };

  MouseEvent.prototype = Event.prototype;

  window.MouseEvent = MouseEvent;
}

/***/ }),

/***/ "SV7z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  inheritAttrs: false,
  props: {
    stroke: {
      type: String,
      default: '#8E9EB1'
    }
  }
});

/***/ }),

/***/ "SVQh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__ = __webpack_require__("URu4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_libphonenumber_js__ = __webpack_require__("qkwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");
 /* eslint-disable no-unused-vars */








var COUNTRY_CODE_US = 'US';

var hasOneDigit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'hasOneDigit' }, function (value) {
  return (/\d/.test(value)
  );
});
var hasOneUpper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'hasOneUpper' }, function (value) {
  return (/[A-Z]/.test(value)
  );
});
var hasOneLower = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'hasOneLower' }, function (value) {
  return (/[a-z]/.test(value)
  );
});
var usernameIsValid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'usernameIsValid' }, function (value) {
  return (/^[a-zA-Z0-9_]+$/.test(value)
  );
});
var noSpaces = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'noSpaces' }, function (value) {
  return value.indexOf(' ') === -1;
});
var minLength = function minLength(min) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'minLength', min: min }, function (value) {
    return value.length >= min;
  });
};
var maxLength = function maxLength(max) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'maxLength', max: max }, function (value) {
    return value.length <= max;
  });
};
var minLengthDigit = function minLengthDigit(min) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'minLengthDigit', min: min }, function (value) {
    return value.length >= min;
  });
};
var maxLengthDigit = function maxLengthDigit(max) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'maxLengthDigit', max: max }, function (value) {
    return value.length <= max;
  });
};
var exactLength = function exactLength(target) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'exactLength', target: target }, function (value) {
    return value.length === target;
  });
};
var notEmptyMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'notEmptyMessage' }, function (value) {
  return (/\S\w*/.test(value)
  );
});
var onlyCharacters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'onlyCharacters' }, function (value) {
  return (/^[A-Za-záéíóú\s'`’.,\-()/]*$/.test(value)
  );
});
var requiredNoMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'requiredNoMessage' }, __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["req"]);
var emailNoMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'emailNoMessage' }, __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"]);
var price = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'price' }, function (value) {
  if (value && value.length > 1 && value.startsWith('0')) return false;
  return (/^\d+\.?\d{0,2}$/.test(value)
  );
});

var priceAllowZero = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'price' }, function (value) {
  if (value && value.length > 1 && value.startsWith('.')) return (/^\d+$/.test(value.slice(1))
  );
  return (/^\d+\.?\d{0,2}$/.test(value)
  );
});

var multipleEmails = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'multipleEmails' }, function (value) {
  var emails = value.split(';').map(function (i) {
    return i.replace(' ', '');
  });
  var isValid = true;
  emails.forEach(function (val) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"])(val)) {
      isValid = false;
    }
  });
  return isValid;
});

var minValue = function minValue(min) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'minValue', min: min }, function (value) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["req"])(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

var greaterThan = function greaterThan(min) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'greaterThan', min: min }, function (value) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["req"])(value) || (!/\s/.test(value) || value instanceof Date) && +value > +min;
  });
};

var minValueDeposit = function minValueDeposit(min) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'minValueDeposit', min: min }, function (value) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["req"])(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

var maxValueDeposit = function maxValueDeposit(max) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'maxValueDeposit', max: max }, function (value) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["req"])(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

// this one should work with "fields.email" built in does not
var sameAs = function sameAs(param) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'sameAs' }, function (value, parentVm) {
    var targetParam = parentVm[param];
    return value.toLowerCase() === targetParam.toLowerCase();
  });
};

var _validateIsAdult = function _validateIsAdult(parMonth, parDay) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'validateIsAdult' }, function (value, parentVm) {
    var yearSelect = value || {};
    var monthSelect = parentVm[parMonth] || {};
    var daySelect = parentVm[parDay] || {};
    if (yearSelect.value && monthSelect.value && daySelect.value) {
      var dateOfBirth = new Date(yearSelect.value, monthSelect.value - 1, daySelect.value);
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(dateOfBirth), 'years') >= 18;
    }
    return true;
  });
};

var _customPattern = function _customPattern(parPattern, parMessage) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: '' }, function (value) {
    return new RegExp(parPattern).test(value);
  });
};

var _validatenNscbStatus = function _validatenNscbStatus(parCountry) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'validatenNscbStatus' }, function (value, parentVm) {
    var countrySelect = parentVm[parCountry];
    if (countrySelect.value !== COUNTRY_CODE_US && !value) {
      return false;
    }
    return true;
  });
};

var _validateSSN = function _validateSSN(parCountry) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'validateSSN' }, function (value, parentVm) {
    var countrySelect = parentVm[parCountry];
    if (countrySelect.value === COUNTRY_CODE_US) {
      return (/^\d{4}$/.test(value)
      );
    }
    return true;
  });
};

var _validateUSZipCode = function _validateUSZipCode(parCountry) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'validateUSZipCode' }, function (value, parentVm) {
    var countrySelect = parentVm[parCountry];
    var isFieldRequired = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(countrySelect, 'required', true);

    if (!countrySelect || !countrySelect.value) {
      return true;
    }

    if (isFieldRequired && countrySelect.value === COUNTRY_CODE_US) {
      return (/^[0-9\s]*$/.test(value) && value.length === 5
      );
    }

    if (isFieldRequired && value.length === 0) {
      return false;
    }

    return true;
  });
};

var validateCardNumber = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'validateCardNumber' }, function (value, parentVm) {
  var trimmedValue = (value || '').replace(/ /g, '');
  var cardType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["e" /* getCardTypeForNumber */])(trimmedValue);
  return cardType !== __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* default */].CARDS.BLANK;
});

// Phone validator - required field, defaults to US if no country code prefix
var phone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'phone' }, function (value) {
  if (!value) return false;
  // If starts with +, validate as international; otherwise default to US
  if (value.startsWith('+')) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_libphonenumber_js__["a" /* isValidPhoneNumber */])(value);
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_libphonenumber_js__["a" /* isValidPhoneNumber */])(value, 'US');
});

// Phone validator - optional field, validates only if not empty
var phoneOptional = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'phoneOptional' }, function (value) {
  if (!value || value.trim() === '') return true; // Allow empty
  // If starts with +, validate as international; otherwise default to US
  if (value.startsWith('+')) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_libphonenumber_js__["a" /* isValidPhoneNumber */])(value);
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_libphonenumber_js__["a" /* isValidPhoneNumber */])(value, 'US');
});

/* harmony default export */ __webpack_exports__["a"] = ({
  withdrawalAmount: function withdrawalAmount(parFrom, parTo) {
    return {
      price: price,
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      between: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["between"])(parFrom, parTo)
    };
  },
  depositAmount: function depositAmount(parFrom, parTo) {
    return {
      price: price,
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      minValueDeposit: minValueDeposit(parFrom),
      maxValueDeposit: maxValueDeposit(parTo)
    };
  },
  depositAmountCoinbase: function depositAmountCoinbase(parFrom, parTo) {
    return {
      price: priceAllowZero,
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      minValueDeposit: minValueDeposit(parFrom),
      maxValueDeposit: maxValueDeposit(parTo)
    };
  },
  onlyCharacters: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    onlyCharacters: onlyCharacters
  },
  cardNumber: {
    validateCardNumber: validateCardNumber
  },
  taxId: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    exactLength: exactLength(9)
  },
  required: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
  },
  email: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"]
  },
  emailConfirmation: function emailConfirmation(par) {
    return {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      sameAs: sameAs(par)
    };
  },
  validateIsAdult: function validateIsAdult(parMonth, parDay) {
    return {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      validateIsAdult: _validateIsAdult(parMonth, parDay)
    };
  },
  validateUSZipCode: function validateUSZipCode(parCountry) {
    return {
      validateUSZipCode: _validateUSZipCode(parCountry)
    };
  },
  validatenNscbStatus: function validatenNscbStatus(parCountry) {
    return {
      validatenNscbStatus: _validatenNscbStatus(parCountry)
    };
  },
  validateSSN: function validateSSN(parCountry) {
    return {
      validateSSN: _validateSSN(parCountry)
    };
  },
  password: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    minLength: minLength(6),
    hasOneDigit: hasOneDigit,
    hasOneLower: hasOneLower,
    hasOneUpper: hasOneUpper
  },
  passwordConfirmation: function passwordConfirmation(par) {
    return {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      // minLength: minLength(6),
      // hasOneDigit,
      // hasOneLower,
      // hasOneUpper,
      sameAs: sameAs(par)
    };
  },
  username: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    noSpaces: noSpaces,
    usernameIsValid: usernameIsValid,
    minLength: minLength(3),
    maxLength: maxLength(14)
  },
  message: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    notEmptyMessage: notEmptyMessage
  },
  requiredNoMessage: { // not mapped in validatorsMessages so error does not display
    requiredNoMessage: requiredNoMessage
  },
  emailNoMessage: { // not mapped in validatorsMessages so error does not display
    emailNoMessage: emailNoMessage
  },
  cvv: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    numeric: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
    minLengthDigit: minLengthDigit(3),
    maxLengthDigit: maxLengthDigit(4)
  },
  accountNumber: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    numeric: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
    minValue: greaterThan(0)
  },
  routingNumber: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    numeric: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
    exactLength: exactLength(9)
  },
  multipleEmails: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    multipleEmails: multipleEmails
  },
  customPattern: function customPattern(parPattern, parMessage) {
    return {
      customPattern: _customPattern(parPattern, parMessage)
    };
  },
  captcha: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
  },
  phone: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    phone: phone
  },
  phoneOptional: {
    phoneOptional: phoneOptional
  }
});

/***/ }),

/***/ "SXEJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-panel",class:_vm.wrapperModifier},[_c('div',{staticClass:"collapsible-panel__header",class:_vm.darkHeaderModifier,on:{"click":_vm.toggle}},[(_vm.hasSlotTitle)?_c('div',{staticClass:"collapsible-panel__header-text"},[_vm._t("title")],2):_vm._e(),_vm._v(" "),(!_vm.hasSlotTitle)?_c('div',{staticClass:"collapsible-panel__header-text",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e()]),_vm._v(" "),(_vm.isOpenState)?_c('div',{staticClass:"collapsible-panel__content",class:_vm.noPaddingModifier},[(_vm.hasSlotContent)?[_vm._t("default")]:[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Scap":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_1__components_generics_alert_box_alert_box_vue__["a" /* default */]
  },
  data: function data() {
    return {
      depositWarning: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull'])),
  created: function created() {
    var _this = this;

    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* STATIC_PAGES */].DEPOSIT_WARNING).then(function (data) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["G" /* isEmptyHtml */])(data.renderedHTML)) {
        _this.depositWarning = data.renderedHTML;
      }
    }).catch(function () {
      _this.depositWarning = '';
    });
  }
});

/***/ }),

/***/ "Sedv":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDcgMTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01Ljc1IDEuMjVMMiA1TDUuNzUgOC43NSIgc3Ryb2tlPSIjNTU1NzVBIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "SfXH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Shp1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_overview_map_js__ = __webpack_require__("dcEQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e4316a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overview_map_vue__ = __webpack_require__("Tzaz");
function injectStyle (ssrContext) {
  __webpack_require__("R7qn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_overview_map_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e4316a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overview_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SmIQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_disclaimer_js__ = __webpack_require__("ExBi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79097934_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_disclaimer_vue__ = __webpack_require__("oyEw");
function injectStyle (ssrContext) {
  __webpack_require__("Ketp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_disclaimer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79097934_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_disclaimer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SpUV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-list-desktop-header"},[_c('div',{staticClass:"market-list-desktop-header__title"},[_c(_vm.embedded ? 'h2' : 'h1',{tag:"component",staticClass:"market-list-desktop-header__text"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),_c('span',{staticClass:"market-list-desktop-header__text--small"},[_vm._v("\n        "+_vm._s(_vm.count)+" Market"),(_vm.count !== 1)?[_vm._v("s")]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"market-list-desktop-header__filters"},[(_vm.layout == 'grid')?_c('market-filters-desktop-grid',{attrs:{"embedded":_vm.embedded}}):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SqAp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T2le":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_plus_minus_sign_js__ = __webpack_require__("0fyw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac417b44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_plus_minus_sign_vue__ = __webpack_require__("AJVw");
function injectStyle (ssrContext) {
  __webpack_require__("SqAp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_plus_minus_sign_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac417b44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_plus_minus_sign_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T6JC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-rows-loader"},[_c('div',{staticClass:"table-rows-loader__header"}),_vm._v(" "),_c('div',{staticClass:"table-rows-loader__content"},_vm._l((_vm.dummyComponents),function(index){return _c('div',{staticClass:"table-rows-loader__content-item"},[_c('div',{staticClass:"table-rows-loader__content-item-text-1"}),_vm._v(" "),_c('div',{staticClass:"table-rows-loader__content-item-text-2"}),_vm._v(" "),_c('div',{staticClass:"table-rows-loader__content-item-text-3"})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T7ic":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_maintenance_notification_js__ = __webpack_require__("Ffa9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_338f23ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_maintenance_notification_vue__ = __webpack_require__("F76i");
function injectStyle (ssrContext) {
  __webpack_require__("PbZj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_maintenance_notification_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_338f23ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_maintenance_notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TA6E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_preview_carousel_embed_js__ = __webpack_require__("sFos");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d59a392_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preview_carousel_embed_vue__ = __webpack_require__("edJ+");
function injectStyle (ssrContext) {
  __webpack_require__("5IfR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_preview_carousel_embed_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d59a392_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preview_carousel_embed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "TBZZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_fee_waived_banner_js__ = __webpack_require__("EOaG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_531ea174_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fee_waived_banner_vue__ = __webpack_require__("0XAA");
function injectStyle (ssrContext) {
  __webpack_require__("IMxR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_fee_waived_banner_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_531ea174_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fee_waived_banner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TD6b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c(_vm.layoutComponent,{tag:"component"}),_vm._v(" "),_c('app-loader'),_vm._v(" "),_c('app-modals'),_vm._v(" "),_c('app-privacy-statement')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "THaJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_promo_code_input_js__ = __webpack_require__("Y2B3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8721a9d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_promo_code_input_vue__ = __webpack_require__("5jLI");
function injectStyle (ssrContext) {
  __webpack_require__("1gzC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_promo_code_input_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8721a9d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_promo_code_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TKSN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_promotions_banner_js__ = __webpack_require__("EKBJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c8d2050_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_promotions_banner_vue__ = __webpack_require__("EAXV");
function injectStyle (ssrContext) {
  __webpack_require__("ryxd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_promotions_banner_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c8d2050_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_promotions_banner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TLs8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var MODE_POPUP = 'popup';
var MODE_PAGE = 'page';

var popupPageModeMixin = {
  props: {
    mode: {
      type: String,
      default: MODE_POPUP
    }
  },
  computed: {
    isPage: function isPage() {
      return this.mode === MODE_PAGE;
    },
    isPopup: function isPopup() {
      return this.mode === MODE_POPUP;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (popupPageModeMixin);

/***/ }),

/***/ "TYUd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__ = __webpack_require__("dDJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    openNewTab: {
      type: Boolean,
      default: false
    },
    contracts: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    trackingContext: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_4__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    marketContractInfoV2: __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__["a" /* default */]
  },
  data: function data() {
    return {
      MARKET_CONTRACT_INFO_VALUES_LAYOUT: __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_contract_info_v2_market_contract_info_v2_vue__["b" /* MARKET_CONTRACT_INFO_VALUES_LAYOUT */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    items: function items() {
      return this.contracts.map(function (i) {
        var instance = new __WEBPACK_IMPORTED_MODULE_2__models_contract__["a" /* default */](i);
        return {
          id: i.contractId,
          marketName: i.marketName,
          marketId: i.marketId,
          contractName: i.contractName,
          image: i.contractImageSmallUrl || i.contractImageUrl,
          price: instance.changePriceAsCents,
          priceAsCents: instance.lastTradePriceAsCents,
          hasLastTradePrice: instance.hasLastTradePrice,
          lastClosePrice: instance.lastClosePrice
        };
      });
    }
  }),
  methods: {
    itemLink: function itemLink(item) {
      return {
        name: 'market-details',
        params: { marketId: item.marketId },
        query: { contractId: item.id }
      };
    }
  }
});

/***/ }),

/***/ "Tp6y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_desktop_header_js__ = __webpack_require__("lZ3N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_403fe3ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_desktop_header_vue__ = __webpack_require__("nPGV");
function injectStyle (ssrContext) {
  __webpack_require__("fFIe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_desktop_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_403fe3ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_desktop_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tzaz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overview-map"},[(_vm.type === 'electoral')?_c('div',{staticClass:"overview-map__header"},[(_vm.isLayoutMobile)?[_vm._v("\n      Who will win the presidential election?\n    ")]:[_vm._v("\n      Presidential Election Winner?\n    ")]],2):_c('div',{staticClass:"overview-map__header"},[_vm._v("\n    Control of the Senate\n  ")]),_vm._v(" "),_c('div',{staticClass:"overview-map__content"},[(!_vm.isComponentReady)?[_c('div',{staticClass:"content-loader"},_vm._l((_vm.dummyComponents),function(index){return _c('div',{staticClass:"content-loader-item"},[_c('overview-map-loader')],1)}),0)]:_vm._l((_vm.items),function(item){return _c('overview-map-contract',{key:item.contractId,staticClass:"overview-map__content-contract",attrs:{"type":_vm.type,"item":item}})})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U+El":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "U2mR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U7Hf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getValidationMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validatorsMessages__ = __webpack_require__("FGdP");



function errorMessage(data) {
  var msg = __WEBPACK_IMPORTED_MODULE_1__validatorsMessages__["a" /* default */][data.type];
  if (typeof msg === 'undefined') return '';
  if (data.type === 'minValue' || data.type === 'minValueDeposit' || data.type === 'greaterThan') {
    var value = data.min < 1 ? data.min.toFixed(2) : data.min;
    return msg.replace(/%v/g, value);
  }
  if (data.type === 'maxValueDeposit') {
    return msg.replace(/%v/g, data.max.toLocaleString('en-US'));
  }
  if (data.type === 'minLength' || data.type === 'minLengthDigit') return msg.replace(/%v/g, data.min);
  if (data.type === 'maxLength' || data.type === 'maxLengthDigit') return msg.replace(/%v/g, data.max);
  if (data.type === 'between') return msg.replace(/%v1/g, data.min.toFixed(2)).replace(/%v2/g, data.max.toFixed(2));
  if (data.type === 'exactLength') return msg.replace(/%v/g, data.target);
  return msg;
}

function getValidationMessage(field) {
  if (field.$invalid) {
    if (field.required === false) {
      return __WEBPACK_IMPORTED_MODULE_1__validatorsMessages__["a" /* default */].required;
    }
    if (field.errorMessage) {
      return field.errorMessage;
    }
    var erMsg = '';
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(field.$params).some(function (obj) {
      if (!field[obj.type]) {
        erMsg = errorMessage(obj);
        return true;
      }
      return false;
    });
    return erMsg;
  }
  return '';
}

/***/ }),

/***/ "U7LV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "U82S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_bank_links_js__ = __webpack_require__("rR+P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_685e92f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bank_links_vue__ = __webpack_require__("YVc+");
function injectStyle (ssrContext) {
  __webpack_require__("CTjK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_bank_links_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_685e92f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bank_links_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U91k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_market_filters_market_filters_desktop_grid_market_filters_desktop_grid_vue__ = __webpack_require__("vxYz");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketFiltersDesktopGrid: __WEBPACK_IMPORTED_MODULE_1__components_market_market_filters_market_filters_desktop_grid_market_filters_desktop_grid_vue__["a" /* default */]
  },
  props: {
    title: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      required: true,
      default: 0
    },
    layout: {
      type: String,
      default: 'grid'
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentLayout: this.layout
    };
  },

  methods: {
    switchLayoutClicked: function switchLayoutClicked(layout) {
      this.currentLayout = layout;
      this.$emit('toggle', layout);
    },
    classModifier: function classModifier(layout) {
      var _ref;

      return _ref = {
        'market-list-desktop-header__switch-button': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-list-desktop-header__switch-button--' + layout, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-list-desktop-header__switch-button--active', this.currentLayout === layout), _ref;
    }
  }
});

/***/ }),

/***/ "U9Lo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    buyQuantity: {
      type: Number,
      default: 0
    },
    sellQuantity: {
      type: Number,
      default: 0
    },
    mode: {
      type: String,
      default: 'yes'
    }
  },
  computed: {
    hasOffers: function hasOffers() {
      return this.buyQuantity > 0 || this.sellQuantity > 0;
    },
    buyQuantityFormatted: function buyQuantityFormatted() {
      return this.buyQuantity.toLocaleString('en-US');
    },
    sellQuantityFormatted: function sellQuantityFormatted() {
      return this.sellQuantity.toLocaleString('en-US');
    },
    buyQuantityDisplay: function buyQuantityDisplay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["x" /* largeNumberDisplay */])(this.buyQuantity);
    },
    sellQuantityDisplay: function sellQuantityDisplay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["x" /* largeNumberDisplay */])(this.sellQuantity);
    },
    buyValueClass: function buyValueClass() {
      return ['market-contract-horizontal-sushi-orders__value', 'market-contract-horizontal-sushi-orders__value--buy-' + (this.mode || 'yes'), 'market-contract-horizontal-sushi-orders__tooltip'];
    },
    sellValueClass: function sellValueClass() {
      return ['market-contract-horizontal-sushi-orders__value', 'market-contract-horizontal-sushi-orders__value--sell-' + (this.mode || 'yes'), 'market-contract-horizontal-sushi-orders__tooltip'];
    }
  }
});

/***/ }),

/***/ "UBij":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UKGl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showPassword: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: true,
      isOn: this.showPassword
    };
  },

  computed: {
    classModifiers: function classModifiers() {
      return {
        'show-password--on': this.isOn,
        'show-password--off': !this.isOn
      };
    },
    title: function title() {
      return this.isOn ? 'Hide password' : 'Show password';
    }
  },
  methods: {
    onPasswordToggle: function onPasswordToggle() {
      var _this = this;

      this.$emit('showPassword');
      this.show = false;
      this.isOn = !this.isOn;
      setTimeout(function () {
        _this.show = true;
      }, 0);
    }
  }
});

/***/ }),

/***/ "UKic":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_accountVerify__ = __webpack_require__("yZQa");


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_accountVerify__["a" /* default */]],
  methods: {
    onGoToWallet: function onGoToWallet() {
      if (this.isUserVerified) {
        this.$router.push({ name: 'wallet' });
      } else {
        this.$router.push({ name: 'account-details' });
      }
    }
  }
});

/***/ }),

/***/ "ULMz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__ = __webpack_require__("sPnT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34f4d48b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("Rbeg");
function injectStyle (ssrContext) {
  __webpack_require__("NZ9J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34f4d48b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "URxZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-info-overview-wrapper"},[_c('div',{staticClass:"deposit-info-overview"},[_c('div',{staticClass:"deposit-info-overview__row"},[_c('span',{staticClass:"deposit-info-overview__label"},[_vm._v("Gross Amount")]),_vm._v(" "),_c('span',{staticClass:"deposit-info-overview__value"},[_vm._v("$"+_vm._s(_vm.formattedGrossAmount))])]),_vm._v(" "),_c('div',{staticClass:"deposit-info-overview__row"},[_c('span',{staticClass:"deposit-info-overview__label"},[_vm._v("From")]),_vm._v(" "),_c('span',{staticClass:"deposit-info-overview__value"},[_vm._v(_vm._s(_vm.cardMasked))])]),_vm._v(" "),_c('div',{staticClass:"deposit-info-overview__row"},[_c('span',{staticClass:"deposit-info-overview__label"},[_vm._v("Arrives")]),_vm._v(" "),_c('span',{staticClass:"deposit-info-overview__value"},[_vm._v(_vm._s(_vm.arrivesText))])]),_vm._v(" "),(_vm.hasFeeSplit)?[_c('div',{staticClass:"deposit-info-overview__row"},[_c('span',{staticClass:"deposit-info-overview__label deposit-info-overview__label--stacked"},[_vm._v("\n          Processing Fee\n          "),_c('span',{staticClass:"deposit-info-overview__sublabel"},[_vm._v("On first $"+_vm._s(_vm.formattedFirstAmountFree))])]),_vm._v(" "),_c('span',{staticClass:"deposit-info-overview__value"},[_vm._v("Free")])]),_vm._v(" "),(_vm.overLimitAmount > 0)?_c('div',{staticClass:"deposit-info-overview__row"},[_c('span',{staticClass:"deposit-info-overview__label deposit-info-overview__label--stacked"},[_vm._v("\n          "+_vm._s(_vm.overLimitFeeLabel)+"\n          "),_c('span',{staticClass:"deposit-info-overview__sublabel"},[_vm._v("On $"+_vm._s(_vm.formattedOverLimitAmount)+" beyond promo limit")])]),_vm._v(" "),(Number(_vm.feeAmount) === 0)?_c('span',{staticClass:"deposit-info-overview__value"},[_vm._v("Free")]):_c('span',{staticClass:"deposit-info-overview__value"},[_vm._v("\n          -$"+_vm._s(_vm.formattedFeeAmount)+"\n        ")])]):_vm._e()]:_c('div',{staticClass:"deposit-info-overview__row"},[_c('span',{staticClass:"deposit-info-overview__label"},[_vm._v(_vm._s((_vm.feePercent === 0 || Number(_vm.feeAmount) === 0) ? 'Processing Fee' : ("Processing Fee (" + _vm.feePercent + "%)")))]),_vm._v(" "),(Number(_vm.feeAmount) === 0)?_c('span',{staticClass:"deposit-info-overview__value"},[_vm._v("Free")]):_c('span',{staticClass:"deposit-info-overview__value"},[_vm._v("\n        -$"+_vm._s(_vm.formattedFeeAmount)+"\n      ")])]),_vm._v(" "),(_vm.hasPromo)?_c('div',{staticClass:"deposit-info-overview__row"},[_c('span',{staticClass:"deposit-info-overview__label"},[_vm._v("\n        Promo code\n        "),_c('span',{staticClass:"deposit-info-overview__promo-badge"},[_vm._v(_vm._s(_vm.promoCode))])]),_vm._v(" "),_c('span',{staticClass:"deposit-info-overview__value deposit-info-overview__value--promo"},[_vm._v("+$"+_vm._s(_vm.promoBonus))])]):_vm._e(),_vm._v(" "),(_vm.hasPromotionalCredit)?_c('div',{staticClass:"deposit-info-overview__row"},[_c('span',{staticClass:"deposit-info-overview__label"},[_vm._v("Promotional Credit")]),_vm._v(" "),_c('span',{staticClass:"deposit-info-overview__value"},[_vm._v("$"+_vm._s(_vm.formattedPromotionalCredit))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"deposit-info-overview__divider"}),_vm._v(" "),_c('div',{staticClass:"deposit-info-overview__row deposit-info-overview__row--total"},[_c('span',{staticClass:"deposit-info-overview__label deposit-info-overview__label--total"},[_vm._v("Total to wallet")]),_vm._v(" "),_c('span',{staticClass:"deposit-info-overview__value deposit-info-overview__value--total"},[_vm._v("$"+_vm._s(_vm.formattedTotalToWallet))])])],2),_vm._v(" "),(_vm.hasSeparateCredit)?_c('div',{staticClass:"deposit-info-overview__separate-credit"},[_c('span',{staticClass:"deposit-info-overview__separate-credit-label"},[_vm._v("\n      Promo code "),_c('strong',[_vm._v(_vm._s(_vm.separateCreditCode))]),_vm._v(":\n    ")]),_vm._v(" "),_c('span',[_vm._v("$"+_vm._s(_vm.formattedSeparateCredit)+" was already credited to your wallet separately.")])]):_vm._e(),_vm._v(" "),(_vm.wasFeeDiscountApplied && _vm.isFeeWaived)?_c('div',{staticClass:"deposit-info-overview__info-line"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"}},[_c('circle',{attrs:{"cx":"7","cy":"7","r":"7","fill":"#2A8856"}}),_vm._v(" "),_c('rect',{attrs:{"x":"6.25","y":"6","width":"1.5","height":"5","rx":"0.75","fill":"white"}}),_vm._v(" "),_c('rect',{attrs:{"x":"6.25","y":"3","width":"1.5","height":"1.5","rx":"0.75","fill":"white"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.feeDiscountMessage))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UTL5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLayoutDesktop)?_c('div',{class:_vm.classModifiers},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__content"},[((_vm.theme === 'currently' || _vm.theme === 'comments'))?[_c('div',{staticClass:"market-widget-loader__avatarised"},[_vm._m(1),_vm._v(" "),(_vm.theme === 'currently')?_c('div',{staticClass:"market-widget-loader__avatarised-item"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-text market-widget-loader__avatarised-text--short"})]):_vm._e()])]:_vm._e(),_vm._v(" "),(_vm.theme === 'money')?[_vm._m(3)]:_vm._e(),_vm._v(" "),(_vm.theme === 'stats')?[_vm._m(4)]:_vm._e()],2)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-widget-loader__header"},[_c('div',{staticClass:"market-widget-loader__header-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-widget-loader__avatarised-item"},[_c('div',{staticClass:"market-widget-loader__avatarised-head"},[_c('div',{staticClass:"market-widget-loader__avatarised-avatar"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-title"})]),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-text market-widget-loader__avatarised-text--short"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-widget-loader__avatarised-head"},[_c('div',{staticClass:"market-widget-loader__avatarised-avatar"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-title"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-widget-loader__simple"},[_c('div',{staticClass:"market-widget-loader__simple-text market-widget-loader__simple-text--large"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text market-widget-loader__simple-text--short"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-widget-loader__stats"},[_c('div',{staticClass:"market-widget-loader__simple"},[_c('div',{staticClass:"market-widget-loader__simple-text market-widget-loader__simple-text--large"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text market-widget-loader__simple-text--short"})]),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple"},[_c('div',{staticClass:"market-widget-loader__simple-text market-widget-loader__simple-text--large"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text market-widget-loader__simple-text--short"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UV+D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-item-simple"},[_c('div',{staticClass:"notification-item-simple__container"},[_c('div',{staticClass:"notification-item-simple__icon"},[(_vm.icon === 'pending')?_c('img',{attrs:{"src":__webpack_require__("U+El")}}):_vm._e(),_vm._v(" "),(_vm.icon === 'cancel')?_c('img',{attrs:{"src":__webpack_require__("VM/5")}}):_vm._e()]),_vm._v(" "),(_vm.title)?_c('h4',{staticClass:"notification-item-simple__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.showAutoCloseLoader)?_c('div',{staticClass:"notification-item-simple__loader",style:({ '--close-timeout': (_vm.closeTimeout + "ms") })},[_c('svg',{attrs:{"width":"32","height":"32","viewBox":"0 0 32 32"}},[_c('circle',{staticClass:"notification-item-simple__loader-ring",attrs:{"cx":"16","cy":"16","r":"13"}})])]):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.closeButton),expression:"closeButton"}],staticClass:"notification-item-simple__close",on:{"click":_vm.onClose}})]),_vm._v(" "),_c('div',{staticClass:"notification-item-simple__container notification-item-simple__container--simple"},[_c('div',{staticClass:"notification-item-simple__text"},[_vm._v("\n        "+_vm._s(_vm.text)+"\n      ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UVmH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createBankLinkDiagnostics;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var STAGES = ['sdk_requested', 'sdk_ready', 'sdk_failed', 'widget_open', 'widget_ready', 'widget_event', 'widget_success', 'widget_error', 'widget_exit', 'completion_requested', 'completion_succeeded', 'completion_failed', 'reconciliation_requested', 'completion_recovered', 'reconciliation_failed'];

function createId() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
    var value = Math.floor(Math.random() * 16);
    return (character === 'x' ? value : value % 4 + 8).toString(16);
  });
}

function createBankLinkDiagnostics(send) {
  var now = function now() {
    return typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
  };
  var started = now();
  var clientAttemptId = createId();
  var seen = {};
  var sequence = 0;
  var report = function report(stage, suppliedCode) {
    if (!STAGES.includes(stage) || sequence >= 32) return;
    var code = /^(?:(?:AC|AR)-[0-9]{1,5}|WIDGET_[A-Z_]{1,40})$/.test(suppliedCode || '') ? suppliedCode : '';
    var key = stage + ':' + code;
    if (seen[key]) return;
    seen[key] = true;
    sequence += 1;
    // No widget payload, contacts, provider token or bank data crosses this boundary.
    try {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(send({
        clientAttemptId: clientAttemptId,
        stage: stage,
        code: code,
        sequence: sequence,
        elapsedMs: Math.floor(Math.min(600000, Math.max(0, now() - started)))
      })).catch(function () {
        return null;
      });
    } catch (error) {
      // Diagnostics never become a linking failure or cause a replay.
    }
  };
  report.clientAttemptId = clientAttemptId;
  return report;
}

/***/ }),

/***/ "UWOG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.classModifiers,attrs:{"href":_vm.marketDetailUrl}},[(_vm.isLayoutMobile)?[_c('div',{staticClass:"overview-map-contract__image-wrapper"},[_c('div',{staticClass:"overview-map-contract__image",style:(_vm.imageStyleModifiers)}),_vm._v(" "),(false)?_c('div',{staticClass:"overview-map-contract__indicator",style:(_vm.bgColorStyleModifiers)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"overview-map-contract__info"},[_c('span',{staticClass:"overview-map-contract__current-price"},[(_vm.contractModel.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":_vm.contractModel.lastTradePriceAsCents}})]:[_vm._v("\n              -\n            ")]],2),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice}})],1)]),_vm._v(" "),_c('span',{staticClass:"overview-map-contract__title",style:(_vm.bgColorStyleModifiers)},[_vm._v("\n      "+_vm._s(_vm.item.shortName)+"\n    ")])]:[_c('div',{staticClass:"overview-map-contract__image-wrapper"},[_c('div',{staticClass:"overview-map-contract__image",style:(_vm.imageStyleModifiers)}),_vm._v(" "),(false)?_c('div',{staticClass:"overview-map-contract__indicator",style:(_vm.bgColorStyleModifiers)}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"overview-map-contract__info-wrapper"},[_c('span',{staticClass:"overview-map-contract__title",style:(_vm.bgColorStyleModifiers)},[_vm._v("\n        "+_vm._s(_vm.item.shortName)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"overview-map-contract__info"},[_c('span',{staticClass:"overview-map-contract__current-price"},[(_vm.contractModel.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":_vm.contractModel.lastTradePriceAsCents}})]:[_vm._v("\n              -\n            ")]],2),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice}})],1)])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UWgA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_input_js__ = __webpack_require__("V00F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4283b276_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_vue__ = __webpack_require__("OMZ0");
function injectStyle (ssrContext) {
  __webpack_require__("N8e0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_input_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4283b276_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UXtE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_list_v2_embed_compact_js__ = __webpack_require__("TYUd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0a8761a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_list_v2_embed_compact_vue__ = __webpack_require__("v4/W");
function injectStyle (ssrContext) {
  __webpack_require__("ofkw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_list_v2_embed_compact_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0a8761a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_list_v2_embed_compact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Uepp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboards-info-loader"},[_c('div',{staticClass:"leaderboards-info-loader__text"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-info-loader__position"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ufge":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    chartOptions: {
      type: Object,
      default: null
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('market', ['chartTimeline', 'chartType', 'market']), {
    showDownload: function showDownload() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'includeDownload', true);
    }
  }),
  methods: {
    onDownload: function onDownload() {
      var url = "/Resource/DownloadMarketChartData" + '?marketid=' + this.market.marketId + '&timespan=' + this.chartTimeline;
      window.open(url, '_blank');
    }
  }
});

/***/ }),

/***/ "UqqE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_most_predicted_js__ = __webpack_require__("eb91");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a0a58ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_most_predicted_vue__ = __webpack_require__("aIx/");
function injectStyle (ssrContext) {
  __webpack_require__("sIXq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_most_predicted_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a0a58ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_most_predicted_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UtW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatten__ = __webpack_require__("rCVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_notifications__ = __webpack_require__("tjp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__filters_consts__ = __webpack_require__("OJH0");










/* eslint-disable arrow-body-style, max-len, comma-dangle */







var KEY_SHOULD_SHOW_TIMESPAN = 'watchlist-should-show-timespan';
var KEY_SELECTED_ORDER = 'watchlist-selected-order';
var KEY_SELECTED_TIMESPAN = 'watchlist-selected-timespan';

var DEFAULT_WATCHLIST = {
  data: [],
  page: 0,
  totalCount: 0,
  canLoadMore: true
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    orders: __WEBPACK_IMPORTED_MODULE_13__filters_consts__["a" /* ORDERS */],
    timespans: __WEBPACK_IMPORTED_MODULE_13__filters_consts__["b" /* TIMESPANS */],
    watchlist: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_WATCHLIST),
    selectedOrder: __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].get(KEY_SELECTED_ORDER, __WEBPACK_IMPORTED_MODULE_13__filters_consts__["a" /* ORDERS */][0]),
    selectedTimespan: __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].get(KEY_SELECTED_TIMESPAN, __WEBPACK_IMPORTED_MODULE_13__filters_consts__["c" /* AVAILABLE_TIMESPANS */].ALL),
    shouldShowTimespanFilter: __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].get(KEY_SHOULD_SHOW_TIMESPAN, true)
  },
  mutations: {
    updateWatchlistFromNotification: function updateWatchlistFromNotification(state, data) {
      if (state.watchlist.data) {
        state.watchlist = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, state.watchlist, {
          data: state.watchlist.data.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["a" /* updateMarket */])(market, data);
          })
        });
      }
    },
    updateWatchlistContractFromNotification: function updateWatchlistContractFromNotification(state, data) {
      if (state.watchlist.data) {
        state.watchlist = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, state.watchlist, {
          data: state.watchlist.data.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["b" /* updateMarketContracts */])(market, data);
          })
        });
      }
    },
    selectOrder: function selectOrder(state, sort) {
      var selectedOrder = __WEBPACK_IMPORTED_MODULE_9_lodash_find___default()(state.orders, { sort: sort });
      var selectedTimespan = __WEBPACK_IMPORTED_MODULE_13__filters_consts__["d" /* DEFAULT_TIMESPANS */][sort] || __WEBPACK_IMPORTED_MODULE_13__filters_consts__["c" /* AVAILABLE_TIMESPANS */].EMPTY;
      var shouldShowTimespan = __WEBPACK_IMPORTED_MODULE_13__filters_consts__["e" /* ORDERS_WITH_TIMESPAN_FILTER */].indexOf(selectedOrder.sort) !== -1;
      state.selectedOrder = selectedOrder;
      state.selectedTimespan = selectedTimespan;
      state.shouldShowTimespanFilter = shouldShowTimespan;
      __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].set(KEY_SELECTED_TIMESPAN, selectedTimespan);
      __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].set(KEY_SHOULD_SHOW_TIMESPAN, shouldShowTimespan);
      __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].set(KEY_SELECTED_ORDER, selectedOrder);
    },
    selectTimespan: function selectTimespan(state, parameter) {
      var selectedTimespan = __WEBPACK_IMPORTED_MODULE_9_lodash_find___default()(state.timespans, { parameter: parameter });
      state.selectedTimespan = selectedTimespan;
      __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].set(KEY_SELECTED_TIMESPAN, selectedTimespan);
    },
    updateWatchList: function updateWatchList(state, payload) {
      var sourceData = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(state.watchlist.data));
      var data = __WEBPACK_IMPORTED_MODULE_8_lodash_uniqBy___default()(sourceData.concat(payload.data.markets || []), 'marketId');
      var page = payload.data.page;
      var totalCount = payload.data.totalMarkets;
      var canLoadMore = totalCount > data.length;

      state.watchlist = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, state.watchlist, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    setWatchlistData: function setWatchlistData(state, payload) {
      state.watchlist = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, state.watchlist, {
        data: payload.data,
        page: payload.page,
        totalCount: payload.totalCount,
        canLoadMore: payload.totalCount > payload.data.length
      });
    },
    resetWatchlist: function resetWatchlist(state) {
      state.watchlist = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_WATCHLIST);
    }
  },
  actions: {
    reloadWatchlist: function reloadWatchlist(_ref) {
      var _this = this;

      var state = _ref.state,
          commit = _ref.commit;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var totalPages, results, allMarkets, data, lastResult, totalMarkets;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                totalPages = state.watchlist.page;

                if (!(totalPages === 0)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()({ length: totalPages }, function (_, i) {
                  return i + 1;
                }).map(function (page) {
                  return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getMarketWatch(state.selectedOrder.sort, state.selectedTimespan.parameter, page);
                }));

              case 5:
                results = _context.sent;
                allMarkets = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(results.map(function (r) {
                  return r.data.markets || [];
                }));
                data = __WEBPACK_IMPORTED_MODULE_8_lodash_uniqBy___default()(allMarkets, 'marketId');
                lastResult = results[results.length - 1].data;
                totalMarkets = lastResult.totalMarkets || state.watchlist.totalCount;


                commit('setWatchlistData', {
                  data: data,
                  page: totalPages,
                  totalCount: totalMarkets
                });

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    resetWatchlist: function resetWatchlist(_ref2) {
      var commit = _ref2.commit;

      commit('resetWatchlist');
    },
    getWatchList: function getWatchList(_ref3) {
      var state = _ref3.state,
          commit = _ref3.commit;

      if (state.watchlist.canLoadMore) {
        var page = state.watchlist.page + 1;
        return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getMarketWatch(state.selectedOrder.sort, state.selectedTimespan.parameter, page).then(function (response) {
          commit('updateWatchList', {
            page: page,
            data: response.data
          });
          return response.data;
        });
      }
      return null;
    },
    selectOrder: function selectOrder(_ref4, sort) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      commit('selectOrder', sort);
    },
    selectTimespan: function selectTimespan(_ref5, timespan) {
      var state = _ref5.state,
          dispatch = _ref5.dispatch,
          commit = _ref5.commit;

      commit('selectTimespan', timespan);
    },
    updateWatchlistFromNotification: function updateWatchlistFromNotification(_ref6, payload) {
      var commit = _ref6.commit;

      commit('updateWatchlistFromNotification', payload);
    },
    updateWatchlistContractFromNotification: function updateWatchlistContractFromNotification(_ref7, payload) {
      var commit = _ref7.commit;

      commit('updateWatchlistContractFromNotification', payload);
    }
  }
});

/***/ }),

/***/ "UubQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.documentUploadInfoVisible)?_c('div',{staticClass:"add-funds-bank-transfer__content"},[_c('account-upload-document',{attrs:{"source":_vm.documentUploadSource,"isPending":_vm.documentUploadInfoPending,"theme":_vm.accountUploadDocumentTheme}})],1):(_vm.isStep(_vm.STEPS.INITIAL))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[(_vm.showPromoNotification && false)?_c('fee-waived-banner',{class:_vm.noticePromoModifiers,attrs:{"level":"success","text":_vm.promoCodeDetail.friendlyDescription}}):_vm._e(),_vm._v(" "),(_vm.depositWarning)?_c('div',{staticClass:"predictit-embedded-alert",domProps:{"innerHTML":_vm._s(_vm.depositWarning)}}):_vm._e(),_vm._v(" "),(_vm.showInstantCreditNotification && false)?_c('fee-waived-banner',{attrs:{"level":_vm.instantCreditBoxLevel,"text":_vm.instantCreditBoxMessage}}):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('alert-box',{staticClass:"add-funds-bank-transfer__notice add-funds-bank-transfer__notice--error",attrs:{"level":"warning"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})]):[(_vm.existingAccounts.length > 0)?_c('div',{staticClass:"add-funds-bank-transfer__accounts"},[_c('div',{staticClass:"add-funds-bank-transfer__title"},[_vm._v("\n          Use an Existing Account\n        ")]),_vm._v(" "),_vm._l((_vm.existingAccounts),function(account){return _c('bank-account',{key:account.authorizationId,staticClass:"add-funds-bank-transfer__account",attrs:{"account":account},on:{"select":function($event){return _vm.onSelect(account)},"remove":function($event){return _vm.onRemove(account)}}})})],2):_vm._e(),_vm._v(" "),_c('div',[_c('div',{ref:"paywithmybank",staticClass:"add-funds-bank-transfer__paywithmybank",attrs:{"id":_vm.payWithMyBankId}})]),_vm._v(" "),_c('deposit-disclaimer',{attrs:{"disclaimer":_vm.disclaimer}})]],2):(_vm.isStep(_vm.STEPS.AMOUNT_CONFIRM))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[(_vm.showPromoNotification && false)?_c('fee-waived-banner',{class:_vm.noticePromoModifiers,attrs:{"level":"success","text":_vm.promoCodeDetail.friendlyDescription}}):_vm._e(),_vm._v(" "),(_vm.showInstantCreditNotification && false)?_c('fee-waived-banner',{attrs:{"level":_vm.instantCreditBoxLevel,"text":_vm.instantCreditBoxMessage}}):_vm._e(),_vm._v(" "),_c('h4',{staticClass:"add-funds-bank-transfer__cancel-title"},[_c('span',{staticClass:"add-funds-bank-transfer__cancel",on:{"click":function($event){$event.preventDefault();return _vm.onLoadInitial($event)}}},[_vm._v("\n        Cancel\n      ")])]),_vm._v(" "),(_vm.account !== null)?_c('bank-account',{staticClass:"add-funds-bank-transfer__account",attrs:{"removable":false,"showMessage":false,"account":_vm.account},on:{"select":_vm.onLoadInitial}}):_vm._e(),_vm._v(" "),_c('h5',{staticClass:"form__title form__title--left form__title--margin"},[_vm._v("Deposit Amount ($"+_vm._s(_vm.minimumDepositAmount.toFixed(2))+" Minimum)")]),_vm._v(" "),_c('div',{staticClass:"row-x"},[(_vm.amountHasError)?_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"add-funds-bank-transfer__error"},[_vm._v("\n          "+_vm._s(_vm.amountValidationMessage)+"\n        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"small-12 medium-4 column"},[_c('div',{staticClass:"input-group input-group--large"},[_c('span',{staticClass:"input-group__addon"},[_vm._v("$")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],staticClass:"input-group__input",attrs:{"tabindex":"1","validation":_vm.$v.amount},domProps:{"value":(_vm.amount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value},_vm.$v.amount.$touch],"blur":_vm.handleAmountBlur}})])]),_vm._v(" "),_c('div',{staticClass:"small-12 medium-8 column"},[_c('div',{staticClass:"row-x"},_vm._l((_vm.depositAmounts),function(value){return _c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"button button--primary add-funds-bank-transfer__button",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onUpdateAmount(value)}}},[_c('span',{staticClass:"add-funds-bank-transfer__button-plus"},[_vm._v("+")]),_vm._v(" $"+_vm._s(value)+"\n              ")])])}),0)])]),_vm._v(" "),_c('button',{staticClass:"button button--large button--submit button--full-width add-funds-bank-transfer__confirm",attrs:{"disabled":_vm.isConfirmDisabled},on:{"click":_vm.onReviewAndConfirm}},[_c('span',[_vm._v("\n        Review and Confirm\n      ")])]),_vm._v(" "),_c('deposit-disclaimer',{attrs:{"disclaimer":_vm.disclaimer}})],1):(_vm.isStep(_vm.STEPS.CONFIRM))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[_c('h4',{staticClass:"add-funds-bank-transfer__cancel-title"},[_c('span',{staticClass:"add-funds-bank-transfer__cancel",on:{"click":function($event){$event.preventDefault();return _vm.onCancelConfirm($event)}}},[_vm._v("\n        Cancel\n      ")])]),_vm._v(" "),_c('div',{staticClass:"add-funds-bank-transfer__info"},[_c('p',{staticClass:"add-funds-bank-transfer__info-large-para"},[_vm._v("\n        Are you sure you want to deposit\n      ")]),_vm._v(" "),_c('p',{staticClass:"add-funds-bank-transfer__info-amount"},[_vm._v("\n        "+_vm._s(_vm.infoAmount)+"\n      ")]),_vm._v(" "),_c('p',{staticClass:"add-funds-bank-transfer__info-large-para"},[_vm._v("\n        using Online Banking?\n      ")]),_vm._v(" "),_c('bank-account',{staticClass:"add-funds-bank-transfer__account",attrs:{"account":_vm.account,"preview":true}}),_vm._v(" "),_c('button',{staticClass:"button button--large button--submit button--full-width add-funds-bank-transfer__submit",attrs:{"disabled":_vm.isConfirmDisabled},on:{"click":_vm.onSubmit}},[_c('span',[_vm._v("\n          Confirm And Deposit\n        ")])]),_vm._v(" "),_c('deposit-disclaimer',{attrs:{"disclaimer":_vm.disclaimer}})],1)]):(_vm.isStep(_vm.STEPS.PROCESSING))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[_c('processing-transaction')],1):(_vm.isStep(_vm.STEPS.FINISHED_SUCCESS))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[_c('div',{staticClass:"add-funds-bank-transfer__headline"},[_vm._m(0),_vm._v(" "),_c('h5',{staticClass:"add-funds-bank-transfer__icon-title add-funds-bank-transfer__icon-title--success"},[_vm._v("\n        Success!\n      ")]),_vm._v(" "),_c('deposited'),_vm._v(" "),_c('button',{staticClass:"button button--large button--submit button--full-width add-funds-bank-transfer__submit",on:{"click":_vm.onSuccess}},[_c('span',[_vm._v("\n          Done\n        ")])])],1)]):(_vm.isStep(_vm.STEPS.FINISHED_FAILED))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[_c('div',{staticClass:"add-funds-bank-transfer__headline"},[_vm._m(1),_vm._v(" "),_c('div',[(_vm.currentStepData && _vm.currentStepData.error)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentStepData.error)}}):_c('span',[_vm._v("Unfortunately, we could not process your payment.")])])]),_vm._v(" "),_c('button',{staticClass:"button button--large button--submit button--full-width add-funds-bank-transfer__submit",on:{"click":_vm.onLoadInitial}},[_c('span',[_vm._v("\n        Done\n      ")])])]):(_vm.isStep(_vm.STEPS.FINISHED_EXPIRED))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[_c('div',{staticClass:"add-funds-bank-transfer__headline"},[_c('h5',{staticClass:"add-funds-bank-transfer__title add-funds-bank-transfer__title--warn"},[_vm._v("\n        Bank Reauthorization Required\n      ")]),_vm._v(" "),_c('div',{staticClass:"add-funds-bank-transfer__expired-account"},[_c('bank-account',{staticClass:"add-funds-bank-transfer__account",attrs:{"account":_vm.account,"preview":true}})],1),_vm._v(" "),_c('div',[(_vm.currentStepData && _vm.currentStepData.error)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.currentStepData.error)}}):_c('p',[_vm._v("Unfortunately, we could not process your payment.")])]),_vm._v(" "),_c('div',{staticClass:"add-funds-bank-transfer__loader"}),_vm._v(" "),_c('div',[_c('div',{ref:"paywithmybank",staticClass:"add-funds-bank-transfer__paywithmybank add-funds-bank-transfer__paywithmybank--no-min-height",attrs:{"id":_vm.payWithMyBankId}})])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-funds-bank-transfer__icon"},[_c('img',{attrs:{"src":__webpack_require__("ihRI"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-funds-bank-transfer__icon"},[_c('img',{attrs:{"src":__webpack_require__("z6fO"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V00F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_getValidationMessage__ = __webpack_require__("U7Hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_dataLayer__ = __webpack_require__("k37b");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_userAgent__["a" /* default */]],
  props: {
    type: {
      type: String,
      default: 'text'
    },
    autocomplete: {
      type: String,
      required: false
    },
    disabled: Boolean,
    name: {
      type: String,
      required: true
    },
    required: Boolean,
    placeholder: String,
    maxLength: Number,
    max: Number,
    min: Number,
    value: [String, Number],
    // new stuff
    validation: Object,
    theme: {
      type: String,
      default: ''
    },
    tabindex: Number,
    gtm: {
      type: String,
      default: ''
    },
    hideIconOnValue: {
      type: Boolean,
      default: true
    },
    showValidationWithin: {
      type: Boolean,
      default: true
    },
    masked: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      focus: false
    };
  },

  computed: {
    inputStyleModifiers: function inputStyleModifiers() {
      if (this.masked) {
        return {
          'text-security': 'disc',
          '-webkit-text-security': 'disc',
          '-moz-text-security': 'disc'
        };
      }
      return {};
    },
    inputModifiers: function inputModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'input--no-placeholder': !this.placeholder,
        'input--has-value': this.value,
        'input--is-focused': this.focus,
        'input--is-disabled': this.disabled,
        'input--hide-icon': this.hideIconOnValue
      }, 'input--' + this.theme, this.theme);
    },
    errorMessage: function errorMessage() {
      return this.validation ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_getValidationMessage__["a" /* default */])(this.validation) : '';
    },
    error: function error() {
      return this.validation ? this.validation.$error : false;
    },
    successTick: function successTick() {
      // if (this.validation) {
      //   if (this.validation.required === undefined && this.value === '') {
      //     return false;
      //   }
      //   return this.validation.$dirty && !this.validation.$invalid;
      // }
      return false;
    },
    hasIcon: function hasIcon() {
      return !!this.$slots.icon;
    },
    gtmObject: function gtmObject() {
      var _gtm$split = this.gtm.split(','),
          _gtm$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_gtm$split, 2),
          category = _gtm$split2[0],
          label = _gtm$split2[1];

      return {
        event: 'eventTrackerTrigger',
        category: category,
        action: 'fill',
        label: label
      };
    }
  },
  methods: {
    handleBlur: function handleBlur(e) {
      this.focus = false;
      this.$emit('blur', e.target.name);
      if (this.gtm && this.value) {
        this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_dataLayer__["a" /* withMeta */])(this.gtmObject));
      }
    },
    handleFocus: function handleFocus(e) {
      this.focus = true;
      this.$emit('focus', e.target.name);

      if (this.isWrapperApp) {
        e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    updateValue: function updateValue(e) {
      this.$emit('input', e.target.value);
    }
  }
});

/***/ }),

/***/ "V1Kx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WIDGET_STATUS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api__ = __webpack_require__("H/Zg");





var WIDGET_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
  EMPTY: 'empty',
  REFRESHING: 'refreshing'
};

var defaultWidget = function defaultWidget() {
  return { status: WIDGET_STATUS.IDLE, data: null };
};

function manageFetch(name, commit, state, fetchFn) {
  var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var current = state.widgets[name] || defaultWidget();
  var status = current.status;


  if ((status === WIDGET_STATUS.SUCCESS || status === WIDGET_STATUS.LOADING) && !force) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(current.data);
  }

  var nextStatus = status === WIDGET_STATUS.SUCCESS ? WIDGET_STATUS.REFRESHING : WIDGET_STATUS.LOADING;

  commit('setWidgetStatus', { name: name, status: nextStatus });

  return fetchFn().then(function (data) {
    var resolved = data && data.length > 0 ? WIDGET_STATUS.SUCCESS : WIDGET_STATUS.EMPTY;
    commit('setWidgetData', { name: name, data: data, status: resolved });
    return data;
  }).catch(function () {
    commit('setWidgetStatus', { name: name, status: WIDGET_STATUS.ERROR });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    widgets: {}
  },
  getters: {
    getWidget: function getWidget(state) {
      return function (name) {
        return state.widgets[name] || defaultWidget();
      };
    }
  },
  mutations: {
    setWidgetStatus: function setWidgetStatus(state, _ref) {
      var name = _ref.name,
          status = _ref.status;

      state.widgets = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.widgets, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, name, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.widgets[name] || defaultWidget(), { status: status })));
    },
    setWidgetData: function setWidgetData(state, _ref2) {
      var name = _ref2.name,
          data = _ref2.data,
          status = _ref2.status;

      state.widgets = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.widgets, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, name, { data: data, status: status }));
    }
  },
  actions: {
    fetchNewArrivals: function fetchNewArrivals(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$limit = _ref4.limit,
          limit = _ref4$limit === undefined ? 5 : _ref4$limit,
          _ref4$force = _ref4.force,
          force = _ref4$force === undefined ? false : _ref4$force;

      return manageFetch('new-arrivals', commit, state, function () {
        return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].browse.getNewArrivalMarkets(limit).then(function (r) {
          return r.data.markets || r.data;
        });
      }, force);
    },
    fetchBiggestGains: function fetchBiggestGains(_ref5) {
      var commit = _ref5.commit,
          state = _ref5.state;

      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref6$force = _ref6.force,
          force = _ref6$force === undefined ? false : _ref6$force;

      return manageFetch('biggest-gains', commit, state, function () {
        return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].browse.getHomePageGainModule(false, 1, 2).then(function (r) {
          r.data.forEach(function (el) {
            el.isGain = true;
          });
          return r.data;
        });
      }, force);
    },
    fetchBiggestLoss: function fetchBiggestLoss(_ref7) {
      var commit = _ref7.commit,
          state = _ref7.state;

      var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref8$force = _ref8.force,
          force = _ref8$force === undefined ? false : _ref8$force;

      return manageFetch('biggest-losses', commit, state, function () {
        return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].browse.getHomePageGainModule(true, 1, 2).then(function (r) {
          r.data.forEach(function (el) {
            el.isGain = false;
          });
          return r.data;
        });
      }, force);
    }
  }
});

/***/ }),

/***/ "V3zd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_login_js__ = __webpack_require__("+poj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9658507e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_login_vue__ = __webpack_require__("AOlT");
function injectStyle (ssrContext) {
  __webpack_require__("0i9X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_login_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9658507e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VM/5":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MyIgaGVpZ2h0PSI0MyIgdmlld0JveD0iMCAwIDQzIDQzIj4KICAgIDxkZWZzPgogICAgICAgIDxmaWx0ZXIgaWQ9ImEiIHdpZHRoPSIxMDMuNyUiIGhlaWdodD0iMTIyLjIlIiB4PSItMS45JSIgeT0iLTcuOSUiIGZpbHRlclVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+CiAgICAgICAgICAgIDxmZU9mZnNldCBkeT0iMiIgaW49IlNvdXJjZUFscGhhIiByZXN1bHQ9InNoYWRvd09mZnNldE91dGVyMSIvPgogICAgICAgICAgICA8ZmVHYXVzc2lhbkJsdXIgaW49InNoYWRvd09mZnNldE91dGVyMSIgcmVzdWx0PSJzaGFkb3dCbHVyT3V0ZXIxIiBzdGREZXZpYXRpb249IjIiLz4KICAgICAgICAgICAgPGZlQ29sb3JNYXRyaXggaW49InNoYWRvd0JsdXJPdXRlcjEiIHJlc3VsdD0ic2hhZG93TWF0cml4T3V0ZXIxIiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAuMiAwIi8+CiAgICAgICAgICAgIDxmZU1lcmdlPgogICAgICAgICAgICAgICAgPGZlTWVyZ2VOb2RlIGluPSJzaGFkb3dNYXRyaXhPdXRlcjEiLz4KICAgICAgICAgICAgICAgIDxmZU1lcmdlTm9kZSBpbj0iU291cmNlR3JhcGhpYyIvPgogICAgICAgICAgICA8L2ZlTWVyZ2U+CiAgICAgICAgPC9maWx0ZXI+CiAgICA8L2RlZnM+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZpbHRlcj0idXJsKCNhKSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE1IC0xMikiPgogICAgICAgIDxwYXRoIGZpbGw9IiNkOTUzNGYiIHN0cm9rZT0iI2Q5NTM0ZiIgZD0iTTIwIDMxLjVDMjAgNDAuNjEyIDI3LjM4NiA0OCAzNi41IDQ4IDQ1LjYxMiA0OCA1MyA0MC42MTIgNTMgMzEuNVM0NS42MTIgMTUgMzYuNSAxNUMyNy4zODYgMTUgMjAgMjIuMzg4IDIwIDMxLjV6Ii8+CiAgICAgICAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTM5LjE5OSAzNy4wOGwtMi42OTQtMi42OTItMi43MDQgMi43YTIuMDQyIDIuMDQyIDAgMSAxLTIuODktMi44ODdsMi43MDMtMi43MDItMi43MDItMi43Yy0uOC0uNzk5LS44LTIuMDkxIDAtMi44ODhhMi4wNDIgMi4wNDIgMCAwIDEgMi44OSAwbDIuNzAzIDIuN0wzOS4yIDI1LjkyYTIuMDQyIDIuMDQyIDAgMSAxIDIuODkgMi44ODdsLTIuNjk0IDIuNjk0IDIuNjkzIDIuNjkyYy44Ljc5Ni44IDIuMDkgMCAyLjg4N2EyLjA0NiAyLjA0NiAwIDAgMS0yLjg5IDB6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "VYD9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VZTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vgd5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vgn4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_account_settings_settings__ = __webpack_require__("8p/V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */]],
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'small-modal': function smallModal() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "+CQ6"));
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['settingShowOdds', 'settingOrderbookCollapsed', 'settingColorPalette', 'settingMobileLayout']), {
    settingsModalOptions: function settingsModalOptions() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3__components_account_settings_settings__["c" /* UX_OPTIONS_WITHOUT_MOBILE_ORDERBOOK_SETTING */].filter(function (setting) {
        return _this.isLayoutMobile || setting.key !== __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout;
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['setSettingShowOdds', 'setSettingOrderbookCollapsed', 'setSettingColorPalette', 'setSettingMobileLayout']), {
    close: function close() {
      this.$emit('input', false);
    },
    isOptionDisabled: function isOptionDisabled(option) {
      return !!option.disabled;
    },
    onSettingOptionClick: function onSettingOptionClick(category, option) {
      if (this.isOptionDisabled(option) || this.isSelected(category, option.key)) {
        return;
      }
      this.setSettingValue(category, option.key);
    },
    setSettingValue: function setSettingValue(category, key) {
      var _this2 = this;

      if (category === __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay) {
        this.loaderAdd(document.body);
        this.setSettingShowOdds(key === __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["d" /* APP_PRICE_DISPLAY */].ODDS).then(function () {
          return _this2.loaderRemove(document.body);
        }).catch(function () {
          return _this2.loaderRemove(document.body);
        });
      } else if (category === __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingIsOBCollapsedOnOS) {
        this.loaderAdd(document.body);
        this.setSettingOrderbookCollapsed(key === __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["e" /* APP_MOBILE_ORDERBOOK_DISPLAY */].COLLAPSED).then(function () {
          return _this2.loaderRemove(document.body);
        }).catch(function () {
          return _this2.loaderRemove(document.body);
        });
      } else if (category === __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme) {
        this.loaderAdd(document.body);
        this.setSettingColorPalette(key).then(function () {
          return _this2.loaderRemove(document.body);
        }).catch(function () {
          return _this2.loaderRemove(document.body);
        });
      } else if (category === __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout) {
        this.loaderAdd(document.body);
        this.setSettingMobileLayout(key).then(function () {
          return _this2.loaderRemove(document.body);
        }).catch(function () {
          return _this2.loaderRemove(document.body);
        });
      }
    },
    isSelected: function isSelected(category, key) {
      switch (category) {
        case __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingPriceDisplay:
          return this.settingShowOdds === (key === __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["d" /* APP_PRICE_DISPLAY */].ODDS);
        case __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingIsOBCollapsedOnOS:
          return this.settingOrderbookCollapsed === (key === __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["e" /* APP_MOBILE_ORDERBOOK_DISPLAY */].COLLAPSED);
        case __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingBuyColorScheme:
          return this.settingColorPalette === key;
        case __WEBPACK_IMPORTED_MODULE_2__store_modules_app__["b" /* UX_CATEGORY */].UXSettingMobileContractLayout:
          return this.settingMobileLayout === key;
        default:
          return false;
      }
    }
  })
});

/***/ }),

/***/ "ViC8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.shouldShowMobileSlider)?_c('div',{staticClass:"market-biggest-gains__swiper-arrows"},[_c('span',{class:_vm.prevArrowModifiers,on:{"click":_vm.prevSlide}}),_vm._v(" "),_c('span',{class:_vm.nextArrowModifiers,on:{"click":_vm.nextSlide}})]):_vm._e(),_vm._v(" "),(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader"},_vm._l((_vm.dummyComponents),function(index){return _c('div',{key:index,staticClass:"content-loader-item"},[_c('biggest-gains-loader')],1)}),0):[(_vm.shouldShowMobileSlider)?_c('div',[_c('swiper',{ref:"market-biggest-gains-slider",staticClass:"market-biggest-gains__slider",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.items),function(group,idx){return _c('swiper-slide',{key:idx,staticClass:"market-biggest-gains__slide"},[_c('market-biggest-gains-element',{attrs:{"promo":group[0]}}),_vm._v(" "),(group[1])?_c('market-biggest-gains-element',{attrs:{"promo":group[1],"header":false}}):_vm._e()],1)}),1)],1):_vm._e(),_vm._v(" "),(_vm.shouldShowDesktopList)?_c('div',[(_vm.gainsData.length)?_c('div',{staticClass:"market-biggest-gains__slide"},[_c('div',{staticClass:"market-biggest-gains__header"},[_c('div',{staticClass:"market-biggest-gains__header-title"},[_vm._v("Biggest 24 hour Gains")]),_vm._v(" "),_vm._t("pin")],2),_vm._v(" "),_c('market-biggest-gains-element',{attrs:{"promo":_vm.gainsData[0],"header":false}})],1):_vm._e(),_vm._v(" "),(_vm.lossesData.length)?_c('div',{staticClass:"market-biggest-gains__slide"},[_c('div',{staticClass:"market-biggest-gains__header"},[_c('div',{staticClass:"market-biggest-gains__header-title"},[_vm._v("Biggest 24 hour Losses")]),_vm._v(" "),_vm._t("pin")],2),_vm._v(" "),_c('market-biggest-gains-element',{attrs:{"promo":_vm.lossesData[0],"header":false}})],1):_vm._e()]):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vngw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vnj/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_state_tooltip_js__ = __webpack_require__("CAq+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66e6d570_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_state_tooltip_vue__ = __webpack_require__("fZS5");
function injectStyle (ssrContext) {
  __webpack_require__("oLs4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_state_tooltip_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66e6d570_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_state_tooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VqOw":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "W4YR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W82P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'click'
  },
  props: {
    checked: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    black: Boolean
  },
  watch: {
    checked: function checked(val) {
      this.isChecked = val;
    }
  },
  data: function data() {
    return {
      isChecked: this.checked
    };
  },

  computed: {
    isOnModifier: function isOnModifier() {
      return {
        'switch-button--on': this.isChecked,
        'switch-button--disabled': this.disabled,
        'switch-button--black': this.black
      };
    }
  },
  methods: {
    toggle: function toggle() {
      if (!this.disabled) {
        this.isChecked = !this.isChecked;
        this.$emit('toggle', this.isChecked);
      }
    }
  }
});

/***/ }),

/***/ "W9Re":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketSharesItemLoader_vue__ = __webpack_require__("L6pp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60c1c5fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketSharesItemLoader_vue__ = __webpack_require__("ib9I");
function injectStyle (ssrContext) {
  __webpack_require__("IW6G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketSharesItemLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60c1c5fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketSharesItemLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WF/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    theme: String
  },
  methods: {
    onToggle: function onToggle() {
      if (this.disabled) return;
      this.$emit('input', !this.value);
    }
  }
});

/***/ }),

/***/ "WLny":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WOmE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"election-map-toolbar"},[_c('div',{staticClass:"election-map-toolbar__legend"},[_c('div',{staticClass:"election-map-toolbar__label",style:(_vm.democratLabelStyleModifiers)},[_vm._v("\n      Democratic "+_vm._s(_vm.democraticCounters.total + _vm.democraticCounters.predefinedReal)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__label",style:(_vm.republicanLabelStyleModifiers)},[_vm._v("\n      "+_vm._s(_vm.republicanCounters.total + _vm.republicanCounters.predefinedReal)+" Republican\n    ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar",style:(_vm.barStyleModifiers)},[_c('div',{staticClass:"election-map-toolbar__line"},[_c('div',{staticClass:"election-map-toolbar__line-content"},[_c('div',{staticClass:"election-map-toolbar__line-label election-map-toolbar__line-label--center"},[_vm._v("\n          "+_vm._s(_vm.majorityText)+"\n        ")])])]),_vm._v(" "),(_vm.isSenate)?_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--democratic-stripped",style:(_vm.democraticPredefinedBarSectionStyleModifiers),attrs:{"title":_vm.democraticCounters.predefinedReal}},[(_vm.showDemocraticPredefinedText)?_c('span',[_vm._v("\n        34 + 2 "),_c('div',{staticClass:"election-map-toolbar__bar-section-label election-map-toolbar__bar-section-label--right"},[_vm._v("No election")])]):_c('span',[_vm._v(" ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--democratic",style:(_vm.democraticHighBarSectionStyleModifiers),attrs:{"title":_vm.democraticCounters.high}},[(_vm.showDemocraticHighText)?_c('span',[_vm._v("\n        "+_vm._s(_vm.democraticCounters.high)+"\n      ")]):_c('span',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--democratic",style:(_vm.democraticMediumBarSectionStyleModifiers),attrs:{"title":_vm.democraticCounters.medium}},[(_vm.showDemocraticMediumText)?_c('span',[_vm._v("\n        "+_vm._s(_vm.democraticCounters.medium)+"\n      ")]):_c('span',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--democratic",style:(_vm.democraticLowBarSectionStyleModifiers),attrs:{"title":_vm.democraticCounters.low}},[(_vm.showDemocraticLowText)?_c('span',[_vm._v("\n        "+_vm._s(_vm.democraticCounters.low)+"\n      ")]):_c('span',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--republican",style:(_vm.republicanLowBarSectionStyleModifiers),attrs:{"title":_vm.republicanCounters.low}},[(_vm.showRepublicanLowText)?_c('span',[_vm._v("\n        "+_vm._s(_vm.republicanCounters.low)+"\n      ")]):_c('span',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--republican",style:(_vm.republicanMediumBarSectionStyleModifiers),attrs:{"title":_vm.republicanCounters.medium}},[(_vm.showRepublicanMediumText)?_c('span',[_vm._v("\n        "+_vm._s(_vm.republicanCounters.medium)+"\n      ")]):_c('span',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--republican",style:(_vm.republicanHighBarSectionStyleModifiers),attrs:{"title":_vm.republicanCounters.high}},[(_vm.showRepublicanHighText)?_c('span',[_vm._v("\n        "+_vm._s(_vm.republicanCounters.high)+"\n      ")]):_c('span',[_vm._v(" ")])]),_vm._v(" "),(_vm.isSenate)?_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--republican-stripped",style:(_vm.republicanPredefinedBarSectionStyleModifiers),attrs:{"title":_vm.republicanCounters.predefinedReal}},[(_vm.showRepublicanPredefinedText)?_c('span',[_c('div',{staticClass:"election-map-toolbar__bar-section-label election-map-toolbar__bar-section-label--left"},[_vm._v("No election")]),_vm._v(" "+_vm._s(_vm.republicanCounters.predefinedReal)+"\n      ")]):_c('span',[_vm._v(" ")])]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WRh2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_generic_small_js__ = __webpack_require__("b+hr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8ee8cf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_small_vue__ = __webpack_require__("/xcM");
function injectStyle (ssrContext) {
  __webpack_require__("h6O+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_generic_small_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8ee8cf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_small_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WSTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SETTING_SHOW_ODDS */
/* unused harmony export SETTING_COLOR_PALETTE_KEY */
/* unused harmony export SETTING_MOBILE_LAYOUT_KEY */
/* unused harmony export SETTING_ORDERBOOK_COLLAPSED_KEY */
/* unused harmony export SETTING_GUEST_COLOR_PALETTE_DIRTY_KEY */
/* unused harmony export SETTING_GUEST_PRICE_DISPLAY_DIRTY_KEY */
/* unused harmony export SETTING_GUEST_MOBILE_LAYOUT_DIRTY_KEY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APP_COLOR_PALETTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return APP_MOBILE_LAYOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return APP_PRICE_DISPLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return APP_MOBILE_ORDERBOOK_DISPLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UX_CATEGORY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__ = __webpack_require__("63Fj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_header_notification_app_header_notification_vue__ = __webpack_require__("dMVO");

/* eslint-disable */






var LAYOUT_MOBILE = 'mobile';
var LAYOUT_DESKTOP = 'desktop';
var LAYOUT_SWITCH_BREAKPOINT = 910;

function getDefaultLayout() {
  var width = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
  return width >= LAYOUT_SWITCH_BREAKPOINT ? LAYOUT_DESKTOP : LAYOUT_MOBILE;
}

var SETTING_SHOW_ODDS = 'settings-odds-key';
var SETTING_COLOR_PALETTE_KEY = 'settings-color-palette-key';
var SETTING_MOBILE_LAYOUT_KEY = 'settings-mobile-layout-key';
var SETTING_ORDERBOOK_COLLAPSED_KEY = 'settings-orderbook-collapsed-key';
var SETTING_GUEST_COLOR_PALETTE_DIRTY_KEY = 'guest-setting-color-palette-dirty';
var SETTING_GUEST_PRICE_DISPLAY_DIRTY_KEY = 'guest-setting-price-display-dirty';
var SETTING_GUEST_MOBILE_LAYOUT_DIRTY_KEY = 'guest-setting-mobile-layout-dirty';

var APP_COLOR_PALETTE = {
  BLUE_GREY: 2,
  GREEN_RED: 1
};

var APP_MOBILE_LAYOUT = {
  STANDARD: 1,
  SIMPLIFIED: 2,
  CONDENSED: 3
};

var APP_PRICE_DISPLAY = {
  TRADE_PRICES: 1,
  ODDS: 2 // settingShowOdds true
};

var APP_MOBILE_ORDERBOOK_DISPLAY = {
  COLLAPSED: 0, // settingOrderbookCollapsed true
  EXPANDED: 1
};

var UX_CATEGORY = {
  UXSettingBuyColorScheme: 'UXSettingBuyColorScheme',
  UXSettingMobileContractLayout: 'UXSettingMobileContractLayout',
  UXSettingPriceDisplay: 'UXSettingPriceDisplay',
  UXSettingIsOBCollapsedOnOS: 'UXSettingIsOBCollapsedOnOS',
  UXSettingAnnouncementCurState: 'UXSettingAnnouncementCurState'
};

/* harmony default export */ __webpack_exports__["f"] = ({
  namespaced: true,
  state: {
    previousRoute: null,
    initialVersion: null,
    serverVersion: null,
    pendingServerVersion: null,
    skipAttachToHomeNotification: __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].get('skipAttachToHomeNotification', false),
    skipBanner: __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].get('skipBanner', false),
    hasServerErrorOccurred: false,
    layout: getDefaultLayout(),
    isTaxNotificationMandatory: false,
    hiddenMaintenanceMessage: __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4__components_app_app_header_notification_app_header_notification_vue__["a" /* LS_MAINTENANCE_MESSAGE_KEY */]),
    maintenance: {
      isMaintenanceEnabled: false,
      isTradingEnabled: true,
      maintenanceMessage: '',
      suspendedMessage: '',
      systemMessage: ''
    },
    mobileMenuOpened: false,
    isTabActive: !document.hidden,
    liveUpdatesDisabled: false,
    firebaseInitialized: false,
    signalrInitialized: false,
    systemEmails: {
      support: "support@predictit.org",
      press: "press@predictit.org",
      markets: "markets@predictit.org"
    },
    newLoaderCounter: 0,
    settingShowOdds: __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].get(SETTING_SHOW_ODDS, true),
    settingOrderbookCollapsed: __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].get(SETTING_ORDERBOOK_COLLAPSED_KEY, false),
    settingColorPalette: __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].get(SETTING_COLOR_PALETTE_KEY, APP_COLOR_PALETTE.GREEN_RED),
    settingMobileLayout: __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].get(SETTING_MOBILE_LAYOUT_KEY, APP_MOBILE_LAYOUT.SIMPLIFIED),
    guestSettingColorPaletteDirty: __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].get(SETTING_GUEST_COLOR_PALETTE_DIRTY_KEY, false),
    guestSettingPriceDisplayDirty: __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].get(SETTING_GUEST_PRICE_DISPLAY_DIRTY_KEY, false),
    guestSettingMobileLayoutDirty: __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].get(SETTING_GUEST_MOBILE_LAYOUT_DIRTY_KEY, false),
    isPinboardSingleModeVisible: false,
    isPinboardDualModeVisible: false,
    sidebarVisible: __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].get('pinboard-sidebar-visible', true)
  },
  mutations: {
    setLiveUpdatesDisabled: function setLiveUpdatesDisabled(state, flag) {
      state.liveUpdatesDisabled = flag;
    },
    setIsTabActive: function setIsTabActive(state, data) {
      state.isTabActive = data;
    },
    setPreviousRoute: function setPreviousRoute(state, data) {
      state.previousRoute = data;
    },
    setInitialVersion: function setInitialVersion(state, version) {
      state.initialVersion = version;
    },
    setServerVersion: function setServerVersion(state, version) {
      state.serverVersion = version;
      state.pendingServerVersion = null;
    },
    setPendingServerVersion: function setPendingServerVersion(state, version) {
      state.pendingServerVersion = version;
    },
    setLayout: function setLayout(state, layout) {
      state.layout = layout;
    },
    setServerError: function setServerError(state, hasOccurred) {
      state.hasServerErrorOccurred = hasOccurred;
    },
    setFirebaseInitialized: function setFirebaseInitialized(state, flag) {
      state.firebaseInitialized = flag;
    },
    setSignalrInitialized: function setSignalrInitialized(state, flag) {
      state.signalrInitialized = flag;
    },
    setMaintenance: function setMaintenance(state, data) {
      state.maintenance = data;
    },
    setMandatoryTaxNotification: function setMandatoryTaxNotification(state, flag) {
      state.isTaxNotificationMandatory = flag;
    },
    dontShowAttachToHomeNotification: function dontShowAttachToHomeNotification(state) {
      var expiresAt = 31536000; // 1 year
      __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].set('skipAttachToHomeNotification', true, expiresAt);
      state.skipAttachToHomeNotification = true;
    },
    dontShowBanner: function dontShowBanner(state) {
      state.skipBanner = true;
    },
    toggleMobileMenu: function toggleMobileMenu(state) {
      state.mobileMenuOpened = !state.mobileMenuOpened;
    },
    closeMobileMenu: function closeMobileMenu(state) {
      state.mobileMenuOpened = false;
    },
    setHiddenMaintenanceMessage: function setHiddenMaintenanceMessage(state, value) {
      state.hiddenMaintenanceMessage = value;
    },
    incrNewLoaderCounter: function incrNewLoaderCounter(state) {
      state.newLoaderCounter = state.newLoaderCounter + 1;
    },
    decrNewLoaderCounter: function decrNewLoaderCounter(state) {
      state.newLoaderCounter = state.newLoaderCounter - 1;
      if (state.newLoaderCounter < 0) {
        state.newLoaderCounter = 0;
      }
    },
    resetLoaderCounter: function resetLoaderCounter(state) {
      state.newLoaderCounter = 0;
    },
    setSettingShowOdds: function setSettingShowOdds(state, flag) {
      __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].set(SETTING_SHOW_ODDS, flag);
      state.settingShowOdds = flag;
    },
    setSettingOrderbookCollapsed: function setSettingOrderbookCollapsed(state, flag) {
      __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].set(SETTING_ORDERBOOK_COLLAPSED_KEY, flag);
      state.settingOrderbookCollapsed = flag;
    },
    setSettingColorPalette: function setSettingColorPalette(state, value) {
      __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].set(SETTING_COLOR_PALETTE_KEY, value);
      state.settingColorPalette = value;
    },
    setSettingMobileLayout: function setSettingMobileLayout(state, value) {
      __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].set(SETTING_MOBILE_LAYOUT_KEY, value);
      state.settingMobileLayout = value;
    },
    setGuestSettingColorPaletteDirty: function setGuestSettingColorPaletteDirty(state, value) {
      if (value) {
        __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].set(SETTING_GUEST_COLOR_PALETTE_DIRTY_KEY, true);
      } else {
        __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].del(SETTING_GUEST_COLOR_PALETTE_DIRTY_KEY);
      }
      state.guestSettingColorPaletteDirty = value;
    },
    setGuestSettingPriceDisplayDirty: function setGuestSettingPriceDisplayDirty(state, value) {
      if (value) {
        __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].set(SETTING_GUEST_PRICE_DISPLAY_DIRTY_KEY, true);
      } else {
        __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].del(SETTING_GUEST_PRICE_DISPLAY_DIRTY_KEY);
      }
      state.guestSettingPriceDisplayDirty = value;
    },
    setGuestSettingMobileLayoutDirty: function setGuestSettingMobileLayoutDirty(state, value) {
      if (value) {
        __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].set(SETTING_GUEST_MOBILE_LAYOUT_DIRTY_KEY, true);
      } else {
        __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].del(SETTING_GUEST_MOBILE_LAYOUT_DIRTY_KEY);
      }
      state.guestSettingMobileLayoutDirty = value;
    },
    setPinboardModeVisible: function setPinboardModeVisible(state, _ref) {
      var single = _ref.single,
          dual = _ref.dual;

      state.isPinboardSingleModeVisible = single;
      state.isPinboardDualModeVisible = dual;
    },
    setSidebarVisible: function setSidebarVisible(state, flag) {
      state.sidebarVisible = flag;
      __WEBPACK_IMPORTED_MODULE_1__helpers_localStorage__["a" /* default */].set('pinboard-sidebar-visible', flag);
    }
  },
  getters: {
    isLayoutMobile: function isLayoutMobile(state) {
      return state.layout === LAYOUT_MOBILE;
    },
    isLayoutDesktop: function isLayoutDesktop(state) {
      return state.layout === LAYOUT_DESKTOP;
    },
    isShutdownModeOn: function isShutdownModeOn(state) {
      return !!false;
    },
    isPinningEnabled: function isPinningEnabled(state) {
      return !!false;
    },
    isDepositPromoInputBoxEnabled: function isDepositPromoInputBoxEnabled(state) {
      return !!false;
    },
    leaderboardsEnabled: function leaderboardsEnabled(state) {
      return !!false;
    },
    collegeAffiliationEnabled: function collegeAffiliationEnabled(state) {
      return !!true;
    },
    hasMaintenanceMessage: function hasMaintenanceMessage(state) {
      if (state.maintenance.maintenanceMessage) return true;
      var maintenanceMessage = state.maintenance.suspendedMessage || state.maintenance.systemMessage;
      // check if message was hidden by user;
      return maintenanceMessage && maintenanceMessage !== state.hiddenMaintenanceMessage;
    },
    hasMaintenance: function hasMaintenance(state) {
      return state.maintenance.maintenanceMessage || state.maintenance.suspendedMessage;
    },
    hasMaintenanceSuspended: function hasMaintenanceSuspended(state) {
      return !!state.maintenance.suspendedMessage;
    },
    hasBanner: function hasBanner(state, getters, rootState, rootGetters) {
      return false && !state.skipBanner && rootGetters['user/isLoggedIn'];
    },
    isAfterHours: function isAfterHours(state) {
      // if (state.maintenance.siteState === null) {
      //   return false;
      // }
      // return parseInt(state.maintenance.siteState, 10) === 2;
      return false;
    },
    isRegularMaintenance: function isRegularMaintenance(state) {
      // if (state.maintenance.siteState === null) {
      //   return false;
      // }
      // return parseInt(state.maintenance.siteState, 10) === 3;
      return false;
    },
    isExtendedMaintenance: function isExtendedMaintenance(state) {
      // if (state.maintenance.siteState === null) {
      //   return false;
      // }
      // return parseInt(state.maintenance.siteState, 10) === 4;
      return false;
    },
    isFullMaintenance: function isFullMaintenance(state) {
      // if (state.maintenance.siteState === null) {
      //   return false;
      // }
      // return parseInt(state.maintenance.siteState, 10) === 5;
      return false;
    },
    isTradingEnabled: function isTradingEnabled(state) {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    isCancelOrdersEnabled: function isCancelOrdersEnabled(state) {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1, 2, 3].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    isDepositEnabled: function isDepositEnabled(state) {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1, 2].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    isWithdrawEnabled: function isWithdrawEnabled(state) {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1, 2].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    isCommentEnabled: function isCommentEnabled(state) {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1, 2, 3, 4].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    isLoginEnabled: function isLoginEnabled(state) {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1, 2, 3, 4].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    isSignUpEnabled: function isSignUpEnabled(state) {
      // if (state.maintenance.siteState === null) {
      //   return true;
      // }
      // return [1, 2, 3, 4].includes(parseInt(state.maintenance.siteState, 10));
      return true;
    },
    newLoaderIsLoading: function newLoaderIsLoading(state) {
      return state.newLoaderCounter > 0;
    },
    currentPriceSymbol: function currentPriceSymbol(state) {
      return state.settingShowOdds ? '%' : '&cent;';
    },
    isPinboardSingleModeVisible: function isPinboardSingleModeVisible(state) {
      return state.isPinboardSingleModeVisible;
    },
    isPinboardDualModeVisible: function isPinboardDualModeVisible(state) {
      return state.isPinboardDualModeVisible;
    },
    sidebarVisible: function sidebarVisible(state) {
      return state.sidebarVisible;
    }
  },
  actions: {
    setHiddenMaintenanceMessage: function setHiddenMaintenanceMessage(_ref2, value) {
      var commit = _ref2.commit;

      commit('setHiddenMaintenanceMessage', value);
    },
    setInitialVersion: function setInitialVersion(_ref3, data) {
      var commit = _ref3.commit;

      commit('setInitialVersion', data);
    },
    setServerVersion: function setServerVersion(_ref4, data) {
      var commit = _ref4.commit;

      commit('setServerVersion', data);
    },

    // Multiple app-server instances behind the load balancer can report
    // different x-version headers for a few requests during a rolling
    // deploy. Only treat a new version as authoritative once it's been seen
    // twice, so a single stray response doesn't falsely trigger a reload.
    confirmServerVersion: function confirmServerVersion(_ref5, version) {
      var commit = _ref5.commit,
          state = _ref5.state;

      if (version === state.serverVersion) {
        if (state.pendingServerVersion !== null) commit('setPendingServerVersion', null);
        return;
      }
      if (version === state.pendingServerVersion) {
        commit('setServerVersion', version);
      } else {
        commit('setPendingServerVersion', version);
      }
    },
    setLayoutWidth: function setLayoutWidth(_ref6, width) {
      var commit = _ref6.commit;

      if (width >= LAYOUT_SWITCH_BREAKPOINT) {
        commit('setLayout', LAYOUT_DESKTOP);
      } else {
        commit('setLayout', LAYOUT_MOBILE);
      }
    },
    setServerError: function setServerError(_ref7, hasOccurred) {
      var commit = _ref7.commit;

      commit('setServerError', hasOccurred);
    },
    setMaintenance: function setMaintenance(_ref8, data) {
      var commit = _ref8.commit;

      commit('setMaintenance', data);
    },
    setMandatoryTaxNotification: function setMandatoryTaxNotification(_ref9, flag) {
      var commit = _ref9.commit;

      commit('setMandatoryTaxNotification', flag);
    },
    dontShowAttachToHomeNotification: function dontShowAttachToHomeNotification(_ref10) {
      var commit = _ref10.commit;

      commit('dontShowAttachToHomeNotification');
    },
    dontShowBanner: function dontShowBanner(_ref11) {
      var commit = _ref11.commit;

      commit('dontShowBanner');
    },
    setPreviousRoute: function setPreviousRoute(_ref12, data) {
      var commit = _ref12.commit;

      commit('setPreviousRoute', data);
    },
    toggleMobileMenu: function toggleMobileMenu(_ref13) {
      var commit = _ref13.commit;

      commit('toggleMobileMenu');
    },
    closeMobileMenu: function closeMobileMenu(_ref14) {
      var commit = _ref14.commit;

      commit('closeMobileMenu');
    },
    setIsTabActive: function setIsTabActive(_ref15, flag) {
      var commit = _ref15.commit;

      commit('setIsTabActive', flag);
    },
    setLiveUpdatesDisabled: function setLiveUpdatesDisabled(_ref16, flag) {
      var commit = _ref16.commit;

      commit('setLiveUpdatesDisabled', flag);
    },
    setFirebaseInitialized: function setFirebaseInitialized(_ref17, flag) {
      var commit = _ref17.commit;

      commit('setFirebaseInitialized', flag);
    },
    setSignalrInitialized: function setSignalrInitialized(_ref18, flag) {
      var commit = _ref18.commit;

      commit('setSignalrInitialized', flag);
    },
    incrNewLoaderCounter: function incrNewLoaderCounter(_ref19) {
      var commit = _ref19.commit;

      commit('incrNewLoaderCounter');
    },
    decrNewLoaderCounter: function decrNewLoaderCounter(_ref20) {
      var commit = _ref20.commit;

      commit('decrNewLoaderCounter');
    },
    resetLoaderCounter: function resetLoaderCounter(_ref21) {
      var commit = _ref21.commit;

      commit('resetLoaderCounter');
    },
    setSettingShowOdds: function setSettingShowOdds(_ref22, flag) {
      var commit = _ref22.commit,
          rootGetters = _ref22.rootGetters;

      commit('setSettingShowOdds', flag);
      if (rootGetters['user/isLoggedIn']) {
        commit('setGuestSettingPriceDisplayDirty', false);
        return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].profile.putSettings('ux', UX_CATEGORY.UXSettingPriceDisplay, flag ? APP_PRICE_DISPLAY.ODDS : APP_PRICE_DISPLAY.TRADE_PRICES);
      }
      commit('setGuestSettingPriceDisplayDirty', true);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    },
    setSettingOrderbookCollapsed: function setSettingOrderbookCollapsed(_ref23, flag) {
      var commit = _ref23.commit,
          rootGetters = _ref23.rootGetters;

      commit('setSettingOrderbookCollapsed', flag);
      if (rootGetters['user/isLoggedIn']) {
        return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].profile.putSettings('ux', UX_CATEGORY.UXSettingIsOBCollapsedOnOS, flag ? APP_MOBILE_ORDERBOOK_DISPLAY.COLLAPSED : APP_MOBILE_ORDERBOOK_DISPLAY.EXPANDED);
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    },
    setSettingColorPalette: function setSettingColorPalette(_ref24, value) {
      var commit = _ref24.commit,
          rootGetters = _ref24.rootGetters;

      commit('setSettingColorPalette', value);
      if (rootGetters['user/isLoggedIn']) {
        commit('setGuestSettingColorPaletteDirty', false);
        return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].profile.putSettings('ux', UX_CATEGORY.UXSettingBuyColorScheme, value);
      }
      commit('setGuestSettingColorPaletteDirty', true);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    },
    setSettingMobileLayout: function setSettingMobileLayout(_ref25, value) {
      var commit = _ref25.commit,
          rootGetters = _ref25.rootGetters;

      commit('setSettingMobileLayout', value);
      if (rootGetters['user/isLoggedIn']) {
        commit('setGuestSettingMobileLayoutDirty', false);
        return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].profile.putSettings('ux', UX_CATEGORY.UXSettingMobileContractLayout, value);
      }
      commit('setGuestSettingMobileLayoutDirty', true);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    },
    setSettingsAnnouncementCurState: function setSettingsAnnouncementCurState(_ref26, value) {
      var commit = _ref26.commit;

      return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].profile.putSettings('ux', UX_CATEGORY.UXSettingAnnouncementCurState, value);
    },
    applySettingShowOdds: function applySettingShowOdds(_ref27, flag) {
      var commit = _ref27.commit;

      commit('setSettingShowOdds', flag);
    },
    applySettingOrderbookCollapsed: function applySettingOrderbookCollapsed(_ref28, flag) {
      var commit = _ref28.commit;

      commit('setSettingOrderbookCollapsed', flag);
    },
    applySettingColorPalette: function applySettingColorPalette(_ref29, value) {
      var commit = _ref29.commit;

      commit('setSettingColorPalette', value);
    },
    applySettingMobileLayout: function applySettingMobileLayout(_ref30, value) {
      var commit = _ref30.commit;

      commit('setSettingMobileLayout', value);
    },
    setGuestSettingDirty: function setGuestSettingDirty(_ref31, _ref32) {
      var commit = _ref31.commit;
      var keyName = _ref32.keyName,
          value = _ref32.value;

      if (keyName === UX_CATEGORY.UXSettingBuyColorScheme) {
        commit('setGuestSettingColorPaletteDirty', value);
      } else if (keyName === UX_CATEGORY.UXSettingPriceDisplay) {
        commit('setGuestSettingPriceDisplayDirty', value);
      } else if (keyName === UX_CATEGORY.UXSettingMobileContractLayout) {
        commit('setGuestSettingMobileLayoutDirty', value);
      }
    },
    setPinboardModeVisible: function setPinboardModeVisible(_ref33, payload) {
      var commit = _ref33.commit;

      commit('setPinboardModeVisible', payload);
    },
    toggleSidebarVisible: function toggleSidebarVisible(_ref34) {
      var commit = _ref34.commit,
          state = _ref34.state;

      commit('setSidebarVisible', !state.sidebarVisible);
    }
  }
});

/***/ }),

/***/ "WXHk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposited_js__ = __webpack_require__("Mq7P");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b52a466_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposited_vue__ = __webpack_require__("zhes");
function injectStyle (ssrContext) {
  __webpack_require__("uBho")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposited_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b52a466_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposited_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "WhZX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_market_v2_market_list_item_v2_market_list_item_v2_vue__ = __webpack_require__("tPuv");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    markets: {
      type: Array,
      required: true
    },
    showTitle: {
      type: Boolean,
      default: false
    },
    dataNumColumnsDesktop: {
      type: Number,
      default: 3
    },
    renderStyle: {
      type: Number,
      default: 1 // 1 = Tiles (default), 2 = Vertical List
    },
    trackingContext: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    marketListItem: __WEBPACK_IMPORTED_MODULE_0__components_market_v2_market_list_item_v2_market_list_item_v2_vue__["a" /* default */]
  },
  computed: {
    isVerticalList: function isVerticalList() {
      return this.renderStyle === 2;
    },
    gridStyleModifiers: function gridStyleModifiers() {
      var n = this.dataNumColumnsDesktop;
      var gapTotal = (n - 1) * 20;
      return {
        'grid-template-columns': 'repeat(auto-fit, minmax(max(300px, calc((100% - ' + gapTotal + 'px) / ' + n + ')), 1fr))'
      };
    }
  }
});

/***/ }),

/***/ "Wx+w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-currently-predicting"},[_c('div',{staticClass:"market-currently-predicting__title"},[_vm._v(_vm._s(_vm.obj.title))]),_vm._v(" "),(!!_vm.widget)?_c('div',{staticClass:"market-currently-predicting__content"},[_c('swiper',{attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.traders),function(pred,index){return _c('swiper-slide',{key:index},[_c('div',{staticClass:"market-currently-predicting__element"},[_c('div',{staticClass:"market-currently-predicting__user-area",on:{"click":function($event){$event.stopPropagation();return _vm.showUserDetails(pred)}}},[_c('div',{staticClass:"market-currently-predicting__avatar"},[_c('account-social-avatar',{attrs:{"avatar":pred.avatarImage,"showProgress":true,"percentage":100,"progressStrokeColor":_vm.getLevelByPredictions(pred.profitablePredictions).currentColor,"showEdit":false,"theme":"markets"}})],1),_vm._v(" "),_c('div',{staticClass:"market-currently-predicting__name"},[_vm._v(_vm._s(pred.userName))]),_vm._v(" "),_c('div',{staticClass:"market-currently-predicting__info"},[_c('div',{staticClass:"market-currently-predicting__active"},[_vm._v("\n                 "+_vm._s(_vm.traderLevelDisplay(pred))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"market-currently-predicting__market",on:{"click":function($event){$event.stopPropagation();return _vm.onClick(pred)}}},[_vm._v(_vm._s(pred.marketName))]),_vm._v(" "),_c('div',{staticClass:"market-currently-predicting__footer"},[_c('div',{staticClass:"market-currently-predicting__wrap"},[_c('div',{staticClass:"market-currently-predicting__what"},[_vm._v(_vm._s(_vm.boughtSold(pred.tradeType)))]),_vm._v(" "),_c('div',{class:_vm.classModifier(pred.tradeType)},[_vm._v(_vm._s(_vm.yesNo(pred.tradeType)))]),_vm._v(" "),(!_vm.isMarketSingle(pred))?_c('div',{staticClass:"market-currently-predicting__contract"},[_c('span',[_vm._v("in")]),_vm._v(" "+_vm._s(pred.contractName)+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.priceClassModifiers(pred)},[(pred.pricePerShare)?_c('animated-number',{attrs:{"value":Number(pred.pricePerShare)}}):_c('span',[_vm._v(" ")])],1)])])])])}),1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WxRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overview-map-loader"},[_c('div',{staticClass:"overview-map-loader__avatar"},[_c('div',{staticClass:"overview-map-loader__avatar-circle"})]),_vm._v(" "),_c('div',{staticClass:"overview-map-loader__content"},[_c('div',{staticClass:"overview-map-loader__text-1"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X/Fy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    visible: false
  },
  mutations: {
    show: function show(state) {
      state.visible = true;
    },
    hide: function hide(state) {
      state.visible = false;
    }
  },
  actions: {
    show: function show(_ref) {
      var commit = _ref.commit;

      commit('show');
    },
    hide: function hide(_ref2) {
      var commit = _ref2.commit;

      commit('hide');
    }
  }
});

/***/ }),

/***/ "X/wz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X4WA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export thousandDisplay */
/* unused harmony export TITLE_LATEST_PRICE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OPERATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUTTONS; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getActiveButtonAfterSwitch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_market_shares_bar_market_shares_bar_vue__ = __webpack_require__("HvTw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_market_button_direction_market_button_direction_vue__ = __webpack_require__("jtVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_mutex__ = __webpack_require__("EOu+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_scrollTo__ = __webpack_require__("rrO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_market_v2_market_disabled_outcome_v2_market_disabled_outcome_v2_vue__ = __webpack_require__("tRmv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_market_v2_market_trading_unavailable_v2_market_trading_unavailable_v2_vue__ = __webpack_require__("azKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_market_market_shares_ownership_market_shares_ownership_vue__ = __webpack_require__("tyTh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_market_market_contract_horizontal_sushi_orders_market_contract_horizontal_sushi_orders_vue__ = __webpack_require__("G/7i");



/* eslint-disable */
















var thousandDisplay = function thousandDisplay(value) {
  if (value >= 1.0e+4) {
    return Math.round(value / 1.0e+3) + 'K';
  }
  return value >= 1.0e+3 ? Math.floor(10 * value / 1.0e+3) / 10 + 'K' : value;
};

var TITLE_LATEST_PRICE = 'Latest Price';
var firstNonEmptyString = function firstNonEmptyString() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.find(function (value) {
    return typeof value === 'string' && value.trim() !== '';
  });
};
var OPERATIONS = {
  BUY: 'buy',
  SELL: 'sell'
};
var VALUES = {
  YES: 'yes',
  NO: 'no'
};
var BUTTONS = {
  BUY_NO: {
    id: 'buy-no',
    type: OPERATIONS.BUY,
    value: VALUES.NO
  },
  BUY_YES: {
    id: 'buy-yes',
    type: OPERATIONS.BUY,
    value: VALUES.YES
  },
  SELL_NO: {
    id: 'sell-no',
    type: OPERATIONS.SELL,
    value: VALUES.NO
  },
  SELL_YES: {
    id: 'sell-yes',
    type: OPERATIONS.SELL,
    value: VALUES.YES
  }
};

function getActiveButtonAfterSwitch(contractModel, switchTo) {
  var button = null;

  if (switchTo === 'left') {
    button = BUTTONS.BUY_YES;;
  } else if (switchTo === 'right') {
    button = BUTTONS.BUY_NO;
  }

  return button;
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_accountVerify__["a" /* default */]],
  components: {
    marketButtonDirection: __WEBPACK_IMPORTED_MODULE_8__components_market_market_button_direction_market_button_direction_vue__["a" /* default */],
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_6__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    marketSharesBar: __WEBPACK_IMPORTED_MODULE_7__components_market_market_shares_bar_market_shares_bar_vue__["a" /* default */],
    marketDisabledOutcomeV2: __WEBPACK_IMPORTED_MODULE_13__components_market_v2_market_disabled_outcome_v2_market_disabled_outcome_v2_vue__["a" /* default */],
    marketTradingUnavailableV2: __WEBPACK_IMPORTED_MODULE_14__components_market_v2_market_trading_unavailable_v2_market_trading_unavailable_v2_vue__["a" /* default */],
    marketSharesOwnership: __WEBPACK_IMPORTED_MODULE_15__components_market_market_shares_ownership_market_shares_ownership_vue__["a" /* default */],
    marketContractHorizontalSushiOrders: __WEBPACK_IMPORTED_MODULE_16__components_market_market_contract_horizontal_sushi_orders_market_contract_horizontal_sushi_orders_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    contract: {
      type: Object,
      required: true
    },
    forCmsWidget: {
      type: Boolean,
      default: false
    },
    forceMobileLayout: {
      type: Boolean,
      default: false
    },
    dashboardMode: {
      type: Boolean,
      default: false
    },
    showSharesOwnedIconOnImage: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hovered: false,
      BUTTONS: BUTTONS,
      OPERATIONS: OPERATIONS,
      VALUES: VALUES,
      isWaiting: false,
      activeButton: null,
      chart: null
    };
  },
  mounted: function mounted() {
    this.initializePurchaseButtons();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop', 'isTradingEnabled', 'currentPriceSymbol']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'tradeOperationToggle', 'isInConfirmationMode']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['status']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['settingShowOdds']), {
    useMobileLayout: function useMobileLayout() {
      return this.forceMobileLayout || this.isLayoutMobile;
    },
    useDesktopLayout: function useDesktopLayout() {
      return !this.useMobileLayout;
    },
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_5__models_contract__["a" /* default */](this.contract);
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["k" /* isMarketSingle */])(this.market);
    },
    isMarketJourneyDisabled: function isMarketJourneyDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["A" /* isMarketJourneyDisabled */])(this.market);
    },
    singleMarketTitle: function singleMarketTitle() {
      return firstNonEmptyString(this.market && this.market.marketShortName, this.market && this.market.marketName, this.contractModel.marketName, this.contractModel.contractName) || TITLE_LATEST_PRICE;
    },
    cmsWidgetTitle: function cmsWidgetTitle() {
      return firstNonEmptyString(this.contract && this.contract.contractName) || TITLE_LATEST_PRICE;
    },
    title: function title() {
      if (this.forCmsWidget) {
        return this.cmsWidgetTitle;
      }

      return this.isMarketSingle ? this.singleMarketTitle : firstNonEmptyString(this.contractModel.contractName, this.contractModel.name);
    },
    classModifiers: function classModifiers() {
      return {
        'market-contract-horizontal-sushi': true,
        'market-contract-horizontal-sushi--show-shares-owned-on-image': this.showSharesOwnedIconOnImage,
        'market-contract-horizontal-sushi--dashboard': this.dashboardMode,
        'market-contract-horizontal-sushi--hovered': this.hovered,
        'market-contract-horizontal-sushi--forced-mobile': this.forceMobileLayout,
        'market-contract-horizontal-sushi--no-shares-or-offers': !this.showOffersOrShares,
        'market-contract-horizontal-sushi--settled-yes': this.isMarketSettled && this.isPayoutTypeYes,
        'market-contract-horizontal-sushi--settled-no': this.isMarketSettled && this.isPayoutTypeNo,
        'market-contract-horizontal-sushi--should-close': this.shouldClosePurchaseJourney,
        'market-contract-horizontal-sushi--cms-widget': this.forCmsWidget
      };
    },
    imageUrl: function imageUrl() {
      return this.contractModel.contractImageSmallUrl || this.contractModel.contractImageUrl;
    },
    contractImageStyleModifiers: function contractImageStyleModifiers() {
      return {
        'background-image': 'url(' + this.imageUrl + ')'
      };
    },
    showOpenOffers: function showOpenOffers() {
      return !this.isMarketSettled && this.contractModel.userOpenOrders > 0;
    },
    showSharesBar: function showSharesBar() {
      return !this.isMarketSettled && this.contractModel.userQuantity > 0;
    },
    sharesOwnedStyleModifiers: function sharesOwnedStyleModifiers() {
      return {
        'market-contract-horizontal-sushi__image-shares-owned': true,
        'market-contract-horizontal-sushi__image-shares-owned--no': this.contractModel.mode === 'no'
      };
    },
    showOffersOrShares: function showOffersOrShares() {
      return this.showSharesBar || this.showOpenOffers;
    },
    isMarketDisabled: function isMarketDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["z" /* isMarketDisabled */])(this.market);
    },
    isMarketSettled: function isMarketSettled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["o" /* isMarketSettled */])(this.market);
    },
    isPayoutTypeYes: function isPayoutTypeYes() {
      return this.contract.payoutType === 1;
    },
    isPayoutTypeNo: function isPayoutTypeNo() {
      return this.isMarketSingle && this.contract.payoutType === 0;
    },
    shouldClosePurchaseJourney: function shouldClosePurchaseJourney() {
      return this.tradeOptions && this.tradeOptions.contractId === this.contract.contractId;
    },
    currentPrice: function currentPrice() {
      return this.contractModel.lastTradePriceAsCents;
    },
    currentPriceDashboard: function currentPriceDashboard() {
      if (!this.contractModel.hasLastTradePrice) {
        return 0;
      }

      if (this.contractModel.mode === 'no') {
        return 100 - this.contractModel.lastTradePriceAsCents;
      }
      return this.contractModel.lastTradePriceAsCents;
    },
    volumeDisplay: function volumeDisplay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["x" /* largeNumberDisplay */])(this.contractModel.userQuantity);
    },
    buyOrdersDisplay: function buyOrdersDisplay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["x" /* largeNumberDisplay */])(this.contractModel.userOpenOrdersBuyQuantity);
    },
    sellOrdersDisplay: function sellOrdersDisplay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["x" /* largeNumberDisplay */])(this.contractModel.userOpenOrdersSellQuantity);
    },
    buyOrdersTooltip: function buyOrdersTooltip() {
      return 'Buy: ' + this.contractModel.userOpenOrdersBuyQuantity.toLocaleString('en-US');
    },
    sellOrdersTooltip: function sellOrdersTooltip() {
      return 'Sell: ' + this.contractModel.userOpenOrdersSellQuantity.toLocaleString('en-US');
    },
    showChangePriceIndicator: function showChangePriceIndicator() {
      if (!this.contractModel.changePriceAsCents) {
        return false;
      }
      if (this.contractModel.lastClosePrice === null) {
        return false;
      }
      return true;
    },
    showChangePriceIndicatorUserChange: function showChangePriceIndicatorUserChange() {
      if (!this.contractModel.userChangePriceAsCents) {
        return false;
      }
      if (this.contractModel.lastClosePrice === null) {
        return false;
      }
      return true;
    }
  }),
  watch: {
    // opposite side of order book was clicked -- switching sides
    tradeOperationToggle: function tradeOperationToggle(switchTo) {
      if (this.contract.contractId !== this.tradeOptions.contractId || !switchTo) return;
      var button = getActiveButtonAfterSwitch(this.contractModel, switchTo);
      this.toggleTradeOperation(null);
      this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, button.id);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'toggleTradeOperation']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('market', ['pushSessionHistoryContract']), {
    findActiveButton: function findActiveButton() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(BUTTONS).find(function (i) {
        return i.id === _this.activeButton;
      });
    },
    getTypeAndValueIfButtonActiveOrDefaults: function getTypeAndValueIfButtonActiveOrDefaults() {
      var type = this.tradeOptions.operationType;
      var value = this.tradeOptions.operationValue;
      if (this.activeButton) {
        var button = this.findActiveButton();
        type = button.type;
        value = button.value;
      }
      return { type: type, value: value };
    },
    onClickSharesBar: function onClickSharesBar() {
      var _getTypeAndValueIfBut = this.getTypeAndValueIfButtonActiveOrDefaults(),
          type = _getTypeAndValueIfBut.type,
          value = _getTypeAndValueIfBut.value;

      this.openPurchaseJourney(this.contractModel.contractId, type, value);
    },
    onClickOpenOffers: function onClickOpenOffers() {
      var tab = 'sell-offers';
      var operationType = this.tradeOptions.operationType || '';
      if (operationType === '' && this.contractModel.userOpenOrdersBuyQuantity || operationType === OPERATIONS.BUY && this.contractModel.userOpenOrdersBuyQuantity) {
        tab = 'buy-offers';
      }

      var _getTypeAndValueIfBut2 = this.getTypeAndValueIfButtonActiveOrDefaults(),
          type = _getTypeAndValueIfBut2.type,
          value = _getTypeAndValueIfBut2.value;

      this.openPurchaseJourney(this.contractModel.contractId, type, value);
    },
    initializePurchaseButtons: function initializePurchaseButtons() {
      var button = BUTTONS.BUY_YES;
      if (this.contractModel.mode === VALUES.NO) {
        button = this.contract.contractId === this.tradeOptions.contractId && this.tradeOptions.operationValue === 'no' ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
      } else if (this.contractModel.mode === VALUES.YES) {
        button = BUTTONS.BUY_YES;
      }
      this.activeButton = button.id;

      if ((!this.isMarketSingle || this.useMobileLayout) && this.tradeOptions && this.contract.contractId === this.tradeOptions.contractId && (button.type !== this.tradeOptions.operationType || button.value !== this.tradeOptions.operationValue)) {
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value);
      }
    },
    onMouseOver: function onMouseOver() {
      this.hovered = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.hovered = false;
    },
    onContractClick: function onContractClick() {
      if (this.shouldClosePurchaseJourney) {
        this.setTradeOptions(null);
        return;
      }
      if (this.activeButton) {
        var button = BUTTONS.BUY_YES;
        if (this.contractModel.mode) {
          button = this.contractModel.mode === VALUES.NO ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
        }
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, button.id);

        // const $el = this.$refs[this.activeButton];
        // if (!$el) return;
        // const ev = new MouseEvent('click');
        // $el.dispatchEvent(ev);
      } else {
        var _button = this.contractModel.mode === VALUES.NO ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
        this.openPurchaseJourney(this.contractModel.contractId, _button.type, _button.value);
      }
    },
    isButtonActive: function isButtonActive(index) {
      var isOn = this.activeButton === index;
      var isButtonActive = this.tradeOptions.contractId === this.contract.contractId;

      return {
        'market-contract-horizontal-sushi__button-single--active': isButtonActive,
        'market-contract-horizontal-sushi__button-single--on': isOn,
        'market-contract-horizontal-sushi__button-single--off': !isOn,
        'market-contract-horizontal-sushi__button-single--off-yes': this.tradeOptions.operationValue === VALUES.YES,
        'market-contract-horizontal-sushi__button-single--off-no': this.tradeOptions.operationValue === VALUES.NO
      };
    },
    openPurchaseJourney: function openPurchaseJourney(contractId, operationType, operationValue) {
      var _this2 = this;

      var activateButton = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      if (this.isWaiting) {
        return;
      }

      this.isWaiting = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_mutex__["a" /* waitForFirebaseInitialized */])().then(function () {
        if (_this2.isLoggedIn) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_mutex__["b" /* waitForStatusReady */])();
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
      }).then(function () {
        _this2.isWaiting = false;
        // contract does not modify tradeOptions, is simply used as a widget somewhere
        if (_this2.forCmsWidget) {
          _this2.$emit('contractClicked', { contractId: contractId, operationType: operationType, operationValue: operationValue });
          return;
        }

        if (_this2.isMarketJourneyDisabled) return;
        if (activateButton) {
          _this2.activeButton = activateButton;
        }
        _this2.pushSessionHistoryContract({
          value: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this2.contract, {
            marketName: _this2.market.marketShortName || _this2.market.marketName
          })
        });
        _this2.setTradeOptions({
          contractId: contractId,
          operationType: operationType,
          operationValue: operationValue !== null ? operationValue : _this2.contractModel.mode || VALUES.YES
        });
      });
    }
  })
});

/***/ }),

/***/ "X6LQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"account-ssn-info-upload__note"},[_vm._v("\n    In order to process a credit card deposit, we need to verify your identity. This will be quick. Please click the button below.\n  ")]),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width",on:{"click":function($event){$event.preventDefault();return _vm.onButtonClick($event)}}},[_vm._v("\n    Verify Identity\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-ssn-info-upload__icon"},[_c('img',{attrs:{"src":__webpack_require__("xgaP")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XLAI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"main-nav"},[_c('div',{staticClass:"main-nav__menu"},_vm._l((_vm.enabledLinks),function(item){return _c('div',{staticClass:"main-nav__item",on:{"click":function($event){return _vm.onLinkClick(item.href)}}},[_c('router-link',{class:_vm.classModifier(item.name),attrs:{"id":("nav-" + (item.name)),"to":item.href}},[_vm._v("\n          "+_vm._s(item.title.toString())+"\n      ")])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XMP4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableRowsLoader_vue__ = __webpack_require__("QWrq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44aca848_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableRowsLoader_vue__ = __webpack_require__("T6JC");
function injectStyle (ssrContext) {
  __webpack_require__("iaga")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableRowsLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44aca848_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableRowsLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XWIj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_bankTransferIntent__ = __webpack_require__("g1e5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_notifications_proxy__ = __webpack_require__("a0yF");










var BALANCE_DEFAULT = {
  accountBalance: '$0.00',
  accountBalanceDecimal: 0,
  portfolioBalance: '$0.00',
  portfolioBalanceDecimal: 0,
  shareValueDelta: '$0.00',
  shareValueDeltaDecimal: 0,
  isDefault: true
};

var DEFAULT_WIRE_SEARCH = {
  data: [],
  page: 0,
  totalCount: 0,
  canLoadMore: true
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    ach: {},
    check: {},
    wire: {},
    withdrawCoinbase: {},
    depositMethods: [],
    minimumDepositAmount: 0,
    balance: BALANCE_DEFAULT,
    wireSearchResults: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_WIRE_SEARCH),
    pendingRequests: [],
    pendingDepositsRequests: [],
    currentDeposit: {},
    firstDepositDone: __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].get('firstDepositDone', false),
    bankTransferStep: {},
    withdrawalStep: {},
    withdrawalCancelStep: {},
    cardDepositStep: {},
    unresolvedBankTransfer: null
  },
  getters: {
    depositMethodByType: function depositMethodByType(state) {
      return function (type) {
        return (state.depositMethods || []).find(function (method) {
          return method.type === type;
        });
      };
    },
    portfolioValueDecimal: function portfolioValueDecimal(state, getters, rotState, rootGetters) {
      var totalValue = state.balance.accountBalanceDecimal + state.balance.portfolioBalanceDecimal + rootGetters['dashboard/mySharesTotalGainLoss'];
      return Math.floor(totalValue * 100) / 100;
    },
    portfolioValue: function portfolioValue(state, getters) {
      var value = getters.portfolioValueDecimal.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return '$' + value;
    }
  },
  mutations: {
    setUnresolvedBankTransfer: function setUnresolvedBankTransfer(state, value) {
      state.unresolvedBankTransfer = value;
    },
    setBalance: function setBalance(state, payload) {
      state.balance = payload;
    },
    setCurrentDeposit: function setCurrentDeposit(state, payload) {
      state.currentDeposit = payload;
    },
    setWire: function setWire(state, data) {
      state.wire = data;
    },
    setAch: function setAch(state, data) {
      state.ach = data;
    },
    setCheck: function setCheck(state, data) {
      state.check = data;
    },
    setWithdrawCoinbase: function setWithdrawCoinbase(state, data) {
      state.withdrawCoinbase = data;
    },
    setPendingRequests: function setPendingRequests(state, data) {
      state.pendingRequests = data;
    },
    setPendingDepositsRequests: function setPendingDepositsRequests(state, data) {
      state.pendingDepositsRequests = data;
    },
    updateBalanceFromNotification: function updateBalanceFromNotification(state, data) {
      state.balance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["U" /* updateObjectValues */])(state.balance, data, __WEBPACK_IMPORTED_MODULE_8__services_notifications_proxy__["f" /* ACCOUNT_FUNDS_MAP */]);
    },
    markFirstDepositDone: function markFirstDepositDone(state) {
      var expiresAt = 31536000; // 1 year
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('firstDepositDone', true, expiresAt);
      state.firstDepositDone = true;
    },
    setDepositMethods: function setDepositMethods(state, value) {
      state.depositMethods = value;
    },
    setMinimumDepositAmount: function setMinimumDepositAmount(state, value) {
      state.minimumDepositAmount = value;
    },
    resetWireSearchResults: function resetWireSearchResults(state) {
      state.wireSearchResults = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_WIRE_SEARCH);
    },
    setWireSearchResults: function setWireSearchResults(state, payload) {
      var sourceData = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.wireSearchResults.data));
      var data = sourceData.concat(payload.data.results || []);
      var page = payload.data.page;
      var totalCount = payload.data.totalResults;
      var canLoadMore = totalCount > data.length;

      state.wireSearchResults = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.wireSearchResults, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    setBankTransferStep: function setBankTransferStep(state, data) {
      state.bankTransferStep = data;
    },
    setCardDepositStep: function setCardDepositStep(state, data) {
      state.cardDepositStep = data;
    },
    setWithdrawalStep: function setWithdrawalStep(state, data) {
      state.withdrawalStep = data;
    },
    setWithdrawalCancelStep: function setWithdrawalCancelStep(state, data) {
      state.withdrawalCancelStep = data;
    }
  },
  actions: {
    clearBalance: function clearBalance(_ref) {
      var commit = _ref.commit;

      commit('setBalance', BALANCE_DEFAULT);
    },
    getBalance: function getBalance(_ref2) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.getBalance().then(function (response) {
        commit('setBalance', response.data);
        return response.data;
      });
    },
    getDepositCard: function getDepositCard() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.getDepositCard().then(function (response) {
        return response.data;
      });
    },
    confirmDepositCard: function confirmDepositCard(_ref3, payload) {
      var commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postConfirmDepositCard(payload).then(function (response) {
        return response.data;
      });
    },
    submitDepositCard: function submitDepositCard(_ref4, payload) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postSubmitDepositCard(payload).then(function (response) {
        return response.data;
      });
    },
    submitDepositUSDCoin: function submitDepositUSDCoin(_ref5, payload) {
      var commit = _ref5.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postSubmitDepositUSDCoin(payload).then(function (response) {
        return response.data;
      });
    },
    setCurrentDeposit: function setCurrentDeposit(_ref6, value) {
      var commit = _ref6.commit;

      commit('setCurrentDeposit', value);
    },
    getPayNearMe: function getPayNearMe(_ref7, page) {
      var commit = _ref7.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.getPayNearMe(page).then(function (response) {
        return response.data;
      });
    },
    getDepositUSDCoin: function getDepositUSDCoin() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.getDepositUSDCoin().then(function (response) {
        return response.data;
      });
    },
    resetWireSearchResults: function resetWireSearchResults(_ref8) {
      var commit = _ref8.commit;

      commit('resetWireSearchResults');
    },
    getWithdrawWireBankSearch: function getWithdrawWireBankSearch(_ref9, _ref10) {
      var state = _ref9.state,
          commit = _ref9.commit;
      var _ref10$query = _ref10.query,
          query = _ref10$query === undefined ? '' : _ref10$query;

      if (state.wireSearchResults.canLoadMore) {
        var page = state.wireSearchResults.page + 1;
        return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.getWithdrawWireBankSearch(page, query).then(function (response) {
          commit('setWireSearchResults', {
            page: page,
            data: response.data
          });
          return response.data;
        });
      }
      return null;
    },
    getWithdrawWire: function getWithdrawWire(_ref11) {
      var commit = _ref11.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.getWithdrawWire().then(function (response) {
        commit('setWire', response.data);
        return response.data;
      });
    },
    getWithdrawAch: function getWithdrawAch(_ref12) {
      var commit = _ref12.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.getWithdrawAch().then(function (response) {
        commit('setAch', response.data);
        return response.data;
      });
    },
    getWithdrawCheck: function getWithdrawCheck(_ref13) {
      var commit = _ref13.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.getWithdrawCheck().then(function (response) {
        commit('setCheck', response.data);
        return response.data;
      });
    },
    getWithdrawCoinbase: function getWithdrawCoinbase(_ref14) {
      var commit = _ref14.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.getWithdrawUSDC().then(function (response) {
        commit('setWithdrawCoinbase', response.data);
        return response.data;
      });
    },
    postWithdrawAch: function postWithdrawAch(_ref15, payload) {
      var dispatch = _ref15.dispatch;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postWithdrawAch(payload).then(function (response) {
        dispatch('getBalance');
        return response.data;
      });
    },
    postWithdrawCheck: function postWithdrawCheck(_ref16, payload) {
      var dispatch = _ref16.dispatch;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postWithdrawCheck(payload).then(function (response) {
        dispatch('getBalance');
        return response.data;
      });
    },
    postWithdrawCoinbase: function postWithdrawCoinbase(_ref17, payload) {
      var dispatch = _ref17.dispatch;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postWithdrawUSDC(payload).then(function (response) {
        dispatch('getBalance');
        return response.data;
      });
    },
    postWithdrawWireBankInfo: function postWithdrawWireBankInfo(_ref18, payload) {
      var dispatch = _ref18.dispatch;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postWithdrawWireBankInfo(payload).then(function (response) {
        return response.data;
      });
    },
    postWithdrawWireConfirm: function postWithdrawWireConfirm(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postWithdrawWireConfirm(payload).then(function (response) {
        return response.data;
      });
    },
    postWithdrawWireSubmit: function postWithdrawWireSubmit(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postWithdrawWireSubmit(payload).then(function (response) {
        return response.data;
      });
    },
    getPendingWithdrawals: function getPendingWithdrawals(_ref19) {
      var commit = _ref19.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.getPendingWithdrawals().then(function (response) {
        commit('setPendingRequests', response.data);
        return response.data;
      });
    },
    getPendingDeposits: function getPendingDeposits(_ref20) {
      var commit = _ref20.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.getPendingDeposits().then(function (response) {
        commit('setPendingDepositsRequests', response.data);
        return response.data;
      });
    },
    cancelWithdrawal: function cancelWithdrawal(_ref21, payload) {
      var dispatch = _ref21.dispatch;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postCancelWithdrawal(payload).then(function (response) {
        dispatch('getBalance');
        return response.data;
      });
    },
    updateBalanceFromNotification: function updateBalanceFromNotification(_ref22, payload) {
      var commit = _ref22.commit;

      commit('updateBalanceFromNotification', payload);
    },
    getDepositMethods: function getDepositMethods(_ref23) {
      var commit = _ref23.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.getDepositMethods().then(function (response) {
        var _response$data = response.data,
            _response$data$deposi = _response$data.depositMethods,
            depositMethods = _response$data$deposi === undefined ? [] : _response$data$deposi,
            minimumDepositAmount = _response$data.minimumDepositAmount;

        commit('setDepositMethods', depositMethods);
        commit('setMinimumDepositAmount', minimumDepositAmount);
        return response.data;
      });
    },
    getWithdrawalMethods: function getWithdrawalMethods() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.getWithdrawalMethods().then(function (response) {
        return response.data;
      });
    },
    markFirstDepositDone: function markFirstDepositDone(_ref24) {
      var commit = _ref24.commit;

      commit('markFirstDepositDone');
    },
    getDepositPWMB: function getDepositPWMB(_) {
      var _ref25 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref25$authorizationI = _ref25.authorizationId,
          authorizationId = _ref25$authorizationI === undefined ? '' : _ref25$authorizationI,
          _ref25$returnUrl = _ref25.returnUrl,
          returnUrl = _ref25$returnUrl === undefined ? '' : _ref25$returnUrl,
          _ref25$cancelUrl = _ref25.cancelUrl,
          cancelUrl = _ref25$cancelUrl === undefined ? '' : _ref25$cancelUrl;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.getDepositPWMB({ authorizationId: authorizationId, returnUrl: returnUrl, cancelUrl: cancelUrl }).then(function (response) {
        return response.data;
      });
    },
    deletePWMBAccount: function deletePWMBAccount(_, authorizationId) {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.deletePWMBAuthorization(authorizationId).then(function (response) {
        return response.data;
      });
    },
    confirmDepositPWMB: function confirmDepositPWMB(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postConfirmDepositPWMB(payload).then(function (response) {
        return response.data;
      });
    },
    submitDepositPWMB: function submitDepositPWMB(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postSubmitDepositPWMB(payload).then(function (response) {
        return response.data;
      });
    },
    getPWMBAuthorization: function getPWMBAuthorization() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.getPWMBAuthorization().then(function (response) {
        return response.data;
      });
    },
    setBankTransferStep: function setBankTransferStep(_ref26, data) {
      var commit = _ref26.commit;

      commit('setBankTransferStep', data);
    },
    setCardDepositStep: function setCardDepositStep(_ref27, data) {
      var commit = _ref27.commit;

      commit('setCardDepositStep', data);
    },
    setWithdrawalStep: function setWithdrawalStep(_ref28, data) {
      var commit = _ref28.commit;

      commit('setWithdrawalStep', data);
    },
    setWithdrawalCancelStep: function setWithdrawalCancelStep(_ref29, data) {
      var commit = _ref29.commit;

      commit('setWithdrawalCancelStep', data);
    },
    submitInstantCredit: function submitInstantCredit(_, promoCodeText) {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postInstantCredit({ promoCodeText: promoCodeText }).then(function (response) {
        return response.data;
      });
    },
    createBankLinkSession: function createBankLinkSession(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postBankLinkCreateSession(payload).then(function (response) {
        return response.data;
      });
    },
    startBankLinkProviderConfirmation: function startBankLinkProviderConfirmation(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postBankLinkStartProviderConfirmation(payload).then(function (response) {
        return response.data;
      });
    },
    confirmBankLinkProviderUser: function confirmBankLinkProviderUser(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postBankLinkConfirmProviderUser(payload).then(function (response) {
        return response.data;
      });
    },
    createBankReconnectSession: function createBankReconnectSession(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postBankLinkCreateReconnectSession(payload).then(function (response) {
        return response.data;
      });
    },
    completeBankLink: function completeBankLink(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postBankLinkComplete(payload).then(function (response) {
        return response.data;
      });
    },
    getBankLinkCompletionStatus: function getBankLinkCompletionStatus(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postBankLinkCompletionStatus(payload).then(function (response) {
        return response.data;
      });
    },
    recordBankLinkDiagnostic: function recordBankLinkDiagnostic(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postBankLinkDiagnostic(payload).catch(function () {
        return null;
      });
    },
    getLinkedBankAccounts: function getLinkedBankAccounts(_, config) {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.getLinkedBankAccounts(config).then(function (response) {
        return response.data;
      });
    },
    removeLinkedBankAccount: function removeLinkedBankAccount(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postRemoveLinkedBankAccount(payload).then(function (response) {
        return response.data;
      });
    },
    getDepositBankTransferForm: function getDepositBankTransferForm(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postDepositBankTransferForm(payload).then(function (response) {
        return response.data;
      });
    },
    confirmDepositBankTransfer: function confirmDepositBankTransfer(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postConfirmDepositBankTransfer(payload).then(function (response) {
        return response.data;
      });
    },
    restoreBankTransferIntent: function restoreBankTransferIntent(_ref30) {
      var commit = _ref30.commit,
          rootState = _ref30.rootState;

      var owner = rootState.user.userData.userName;
      var intent = __WEBPACK_IMPORTED_MODULE_7__helpers_bankTransferIntent__["a" /* default */].read(owner);
      commit('setUnresolvedBankTransfer', intent);
      return intent;
    },
    clearBankTransferIntent: function clearBankTransferIntent(_ref31, reference) {
      var commit = _ref31.commit,
          rootState = _ref31.rootState;

      var submissionToken = typeof reference === 'string' ? reference : reference.submissionToken;
      var owner = reference && reference.owner || rootState.user.userData.userName;
      try {
        __WEBPACK_IMPORTED_MODULE_7__helpers_bankTransferIntent__["a" /* default */].clear(owner, submissionToken);
      } catch (error) {
        // A remaining recovery marker is safer than losing an unresolved intent.
      }
      if (rootState.user.userData.userName === owner) commit('setUnresolvedBankTransfer', null);
    },
    submitDepositBankTransfer: function submitDepositBankTransfer(_ref32, payload) {
      var commit = _ref32.commit,
          dispatch = _ref32.dispatch,
          rootState = _ref32.rootState;

      var owner = rootState.user.userData.userName;
      try {
        var existing = __WEBPACK_IMPORTED_MODULE_7__helpers_bankTransferIntent__["a" /* default */].read(owner);
        if (existing && (existing.submissionToken !== payload.submissionToken || Number(existing.linkedBankAccountId) !== Number(payload.linkedBankAccountId) || Number(existing.amount) !== Number(payload.amount))) {
          var error = new Error('A previous deposit still needs its status checked.');
          error.bankTransferNotSent = true;
          error.existingBankTransferIntent = true;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
        }
        commit('setUnresolvedBankTransfer', __WEBPACK_IMPORTED_MODULE_7__helpers_bankTransferIntent__["a" /* default */].save(owner, payload));
      } catch (error) {
        error.bankTransferNotSent = true;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      }
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postDepositBankTransfer(payload).then(function (response) {
        var data = response.data;
        if (data && (data.success === true || __WEBPACK_IMPORTED_MODULE_7__helpers_bankTransferIntent__["a" /* default */].isDefinitiveFailure(data))) {
          dispatch('clearBankTransferIntent', { owner: owner, submissionToken: payload.submissionToken });
        }
        return data;
      }).catch(function (error) {
        if (__WEBPACK_IMPORTED_MODULE_7__helpers_bankTransferIntent__["a" /* default */].isDefinitiveFailureResponse(error.response)) {
          dispatch('clearBankTransferIntent', { owner: owner, submissionToken: payload.submissionToken });
        }
        throw error;
      });
    },
    getDepositBankTransferStatus: function getDepositBankTransferStatus(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].wallet.postDepositBankTransferStatus(payload).then(function (response) {
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "XaR5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XiJB":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "XqpO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_biggest_gains_js__ = __webpack_require__("HzXs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2833d0fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_biggest_gains_vue__ = __webpack_require__("ViC8");
function injectStyle (ssrContext) {
  __webpack_require__("GbUI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_biggest_gains_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2833d0fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_biggest_gains_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XyfZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y+KT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__ = __webpack_require__("k37b");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    bodyClass: {
      type: String,
      default: ''
    },
    headerClass: {
      type: String,
      default: ''
    },
    closeButton: {
      type: Boolean,
      default: true
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    clickOutsideEnabled: {
      type: Boolean,
      default: false
    },
    gtm: [String, Object],
    fullScreen: {
      type: Boolean,
      default: false
    },
    overlayTheme: {
      type: String,
      default: 'default'
    },
    hideHeader: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    overlayClassModifiers: function overlayClassModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        modal__overlay: true
      }, 'modal__overlay--' + this.overlayTheme, this.overlayTheme);
    },
    classModifier: function classModifier() {
      return {
        'modal__content--full': this.fullScreen,
        'modal__content--no-padding': this.noPadding
      };
    }
  },
  methods: {
    hasHeader: function hasHeader() {
      return !!this.$slots.header && !this.hideHeader;
    },
    hasFooter: function hasFooter() {
      return !!this.$slots.footer;
    },
    close: function close() {
      if (this.gtm && this.gtm.closing) {
        this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__["a" /* withMeta */])(this.gtm.closing));
      }
      this.$emit('modalClose');
    },
    onClickOutside: function onClickOutside() {
      if (this.clickOutsideEnabled) this.close();
    },
    afterEnter: function afterEnter() {}
  },
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["m" /* lockModal */])();
    if (this.gtm) {
      var name = this.gtm.virtualPage || (typeof this.gtm === 'string' ? this.gtm : this.gtm.name);
      var virtualPage = this.gtm.virtualPage ? name : this.$route.path + '/' + name;

      if (virtualPage) {
        this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__["a" /* withMeta */])({
          event: 'pageviewTrackerEvent',
          virtualPage: virtualPage,
          virtualPageTitle: 'modal/' + name
        }));
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.gtm && this.$route && this.$route.fullPath) {
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__["a" /* withMeta */])({
        event: 'pageviewTrackerEvent',
        virtualPage: this.$route.fullPath,
        virtualPageTitle: this.$route.name,
        closing: this.gtm
      }));
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["n" /* unLockModal */])();
  }
});

/***/ }),

/***/ "Y/q+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_stats_js__ = __webpack_require__("ZllZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530978a3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_stats_vue__ = __webpack_require__("kjig");
function injectStyle (ssrContext) {
  __webpack_require__("2/KR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_stats_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530978a3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_stats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y2B3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_forms_input_input_vue__ = __webpack_require__("UWgA");


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    formInput: __WEBPACK_IMPORTED_MODULE_0__components_forms_input_input_vue__["a" /* default */]
  },
  props: {
    isInitial: {
      type: Boolean,
      default: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isApplied: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: "This code isn't valid. Try another."
    },
    appliedCode: {
      type: String,
      default: ''
    },
    appliedAmount: {
      type: [String, Number],
      default: '0.00'
    }
  },
  data: function data() {
    return {
      localCode: ''
    };
  },

  methods: {
    onApply: function onApply() {
      var trimmed = this.localCode.trim();
      if (trimmed) {
        this.$emit('apply', trimmed);
      }
    },
    onRemove: function onRemove() {
      this.localCode = '';
      this.$emit('remove');
    }
  }
});

/***/ }),

/***/ "Y8LD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YF1h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YHd0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_overview_map_contract_js__ = __webpack_require__("E5wa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05561034_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overview_map_contract_vue__ = __webpack_require__("UWOG");
function injectStyle (ssrContext) {
  __webpack_require__("Qo/9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_overview_map_contract_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05561034_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overview_map_contract_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YVc+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bank-links",class:{ 'bank-links--verification': _vm.isVerificationFlowActive },attrs:{"aria-busy":_vm.isBusy || _vm.isLoading ? 'true' : 'false'}},[_c('div',{staticClass:"bank-links__content"},[(_vm.errorMessage)?_c('alert-box',{staticClass:"bank-links__alert",attrs:{"level":"warning"}},[_c('span',[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),(_vm.errorSupport === 'aerosync')?[_c('span',[_vm._v(" Please try again later or contact ")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.providerSupportUrl,"rel":"noopener noreferrer","target":"_blank"}},[_vm._v("Aerosync Support")]),_vm._v(" "),_c('span',[_vm._v(" for assistance.")])]:(_vm.errorSupport === 'predictit')?[_c('span',[_vm._v(" If you believe this is an error, contact ")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/support","rel":"noopener noreferrer","target":"_blank"}},[_vm._v("PredictIt Support")]),_c('span',[_vm._v(".")])]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.advisoryMessage)?_c('alert-box',{staticClass:"bank-links__alert",attrs:{"level":"info"}},[_c('span',[_vm._v(_vm._s(_vm.advisoryMessage))]),_vm._v(" "),(_vm.advisoryActionUrl)?[_c('span',[_vm._v(" Contact ")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.advisoryActionUrl,"rel":"noopener noreferrer","target":"_blank"}},[_vm._v("Aerosync Support")])]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.isCompletingLink)?_c('alert-box',{staticClass:"bank-links__alert bank-links__alert--progress",attrs:{"level":"info"}},[_vm._v("\n      "+_vm._s(_vm.completionProgressText)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bank-links__content-header"},[(_vm.isManagingAccounts)?_c('div',{staticClass:"bank-links__content-header-left"},[_c('button',{staticClass:"bank-links__content-header-action bank-links__content-header-action--back",attrs:{"type":"button"},on:{"click":_vm.handleManageBack}},[_c('span',{staticClass:"bank-links__content-header-icon bank-links__content-header-icon--back"}),_vm._v(" "),_c('span',{staticClass:"bank-links__content-header-label"},[_vm._v("BACK")])]),_vm._v(" "),_c('div',{staticClass:"bank-links__content-header-title"},[_vm._v("Delete Account")])]):_c('div',{staticClass:"bank-links__content-header-title"},[_vm._v("\n        "+_vm._s(_vm.contentTitle)+"\n      ")]),_vm._v(" "),(!_vm.isPhoneVerificationRequired && !_vm.isProviderConfirmationReady && !_vm.isProviderConfirmationRequired && !_vm.isManagingAccounts && _vm.accounts.length > 0 && !_vm.isBusy)?_c('button',{staticClass:"bank-links__content-header-action",attrs:{"type":"button"},on:{"click":_vm.enterManageAccounts}},[_c('span',{staticClass:"bank-links__content-header-label"},[_vm._v("MANAGE")]),_vm._v(" "),_c('span',{staticClass:"bank-links__content-header-icon bank-links__content-header-icon--edit"})]):_vm._e()]),_vm._v(" "),(_vm.isVerificationFlowActive)?_c('div',{staticClass:"bank-links__verification-stage"},[(_vm.isPhoneVerificationRequired)?[(!_vm.isPhoneVerificationVisible)?_c('div',{staticClass:"bank-links__phone-required",attrs:{"aria-live":"polite"}},[_c('p',{staticClass:"bank-links__phone-required-message"},[_vm._v("\n            "+_vm._s(_vm.phoneRequirementMessage)+"\n          ")]),_vm._v(" "),_c('button',{ref:"addPhoneNumberButton",staticClass:"button button--primary button--full-width",attrs:{"type":"button"},on:{"click":_vm.showPhoneVerification}},[_vm._v("\n            "+_vm._s(_vm.phoneRequirementActionText)+"\n          ")])]):_c('account-phone-update',{attrs:{"bank-link":""},on:{"close":_vm.handlePhoneVerificationCancel,"verified":_vm.handlePhoneVerified}})]:(_vm.isProviderConfirmationReady)?_c('div',{staticClass:"bank-links__provider-confirmation",attrs:{"aria-live":"polite"}},[_c('p',{staticClass:"bank-links__provider-confirmation-message"},[_vm._v("\n          Aerosync, our bank-linking provider, needs to verify your identity\n          before you can link a bank account.\n        ")]),_vm._v(" "),(_vm.confirmationErrorMessage)?_c('alert-box',{staticClass:"bank-links__alert",attrs:{"level":"warning"}},[_vm._v("\n          "+_vm._s(_vm.confirmationErrorMessage)+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{ref:"sendProviderCodeButton",staticClass:"button button--primary button--full-width",attrs:{"type":"button","disabled":_vm.isSendingProviderConfirmation},on:{"click":function($event){return _vm.sendProviderVerificationCode(false)}}},[_vm._v("\n          "+_vm._s(_vm.isSendingProviderConfirmation ? 'Sending...' : 'Send Verification Code')+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"bank-links__verification-action",attrs:{"type":"button","disabled":_vm.isSendingProviderConfirmation},on:{"click":_vm.cancelProviderConfirmation}},[_vm._v("\n          Cancel\n        ")])],1):_c('form',{staticClass:"bank-links__provider-confirmation",on:{"submit":function($event){$event.preventDefault();return _vm.confirmProviderVerificationCode($event)}}},[_c('p',{staticClass:"bank-links__provider-confirmation-message"},[_vm._v("\n          "+_vm._s(_vm.confirmationPrompt)+"\n        ")]),_vm._v(" "),(_vm.confirmationErrorMessage)?_c('alert-box',{staticClass:"bank-links__alert",attrs:{"level":"warning"}},[_vm._v("\n          "+_vm._s(_vm.confirmationErrorMessage)+"\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bank-links__provider-confirmation-field"},[_c('label',{staticClass:"bank-links__provider-confirmation-label",attrs:{"for":_vm.widgetElementId + '-confirmation-code'}},[_vm._v("\n            Verification Code\n          ")]),_vm._v(" "),_c('input',{ref:"providerConfirmationCode",staticClass:"bank-links__provider-confirmation-input",attrs:{"id":_vm.widgetElementId + '-confirmation-code',"type":"text","inputmode":"numeric","autocomplete":"one-time-code","maxlength":"6","disabled":_vm.isConfirmingProviderUser || _vm.isSendingProviderConfirmation},domProps:{"value":_vm.confirmationCode},on:{"input":_vm.handleProviderConfirmationInput}})]),_vm._v(" "),_c('button',{staticClass:"button button--primary button--full-width",attrs:{"type":"submit","disabled":!_vm.canSubmitProviderConfirmation}},[_vm._v("\n          "+_vm._s(_vm.isConfirmingProviderUser ? 'Verifying...' : 'Verify and Continue')+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"bank-links__provider-confirmation-actions"},[_c('button',{staticClass:"bank-links__verification-action",attrs:{"type":"button","disabled":_vm.isSendingProviderConfirmation || _vm.confirmationSecondsUntilResend > 0},on:{"click":function($event){return _vm.sendProviderVerificationCode(true)}}},[_vm._v("\n            "+_vm._s(_vm.isSendingProviderConfirmation ? 'Sending...' : _vm.resendButtonText)+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"bank-links__verification-action",attrs:{"type":"button","disabled":_vm.isConfirmingProviderUser || _vm.isSendingProviderConfirmation},on:{"click":_vm.cancelProviderConfirmation}},[_vm._v("\n            Cancel\n          ")])])],1)],2):(!_vm.isManagingAccounts)?[(_vm.showEmptyState)?_c('no-data-dashed-box',[_vm._v("\n        You don't have any bank accounts added\n      ")]):_vm._e(),_vm._v(" "),(_vm.accounts.length > 0 || _vm.showAccountSkeleton)?_c('div',{staticClass:"bank-links__accounts"},[_vm._l((_vm.accounts),function(account){return _c('div',{key:account.linkedBankAccountId,staticClass:"bank-links__account",class:{
            'bank-links__account--reconnecting': _vm.accountIsReconnecting(account),
            'bank-links__account--selectable': _vm.accountIsSelectable(account),
          },attrs:{"aria-busy":_vm.accountIsReconnecting(account) ? 'true' : 'false',"aria-label":_vm.accountIsSelectable(account) ? 'Select ' + _vm.accountDescription(account) : null,"role":_vm.accountIsSelectable(account) ? 'button' : null,"tabindex":_vm.accountIsSelectable(account) ? 0 : null},on:{"click":function($event){return _vm.selectAccount(account)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.selectAccount(account)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.selectAccount(account)}]}},[_c('img',{staticClass:"bank-links__institution-logo",attrs:{"src":_vm.defaultInstitutionLogo,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"bank-links__account-info"},[_c('div',{staticClass:"bank-links__institution-name"},[_vm._v("\n              "+_vm._s(account.institutionName || 'Bank account')+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"bank-links__account-name"},[_vm._v("\n              "+_vm._s(_vm.accountDescription(account))+"\n            ")]),_vm._v(" "),(_vm.accountIsReconnecting(account))?_c('div',{staticClass:"bank-links__account-status bank-links__account-status--reconnecting",attrs:{"aria-live":"polite"}},[_vm._v("\n              Aerosync connected. Finishing reconnection...\n            ")]):(_vm.accountRequiresReconnect(account))?_c('div',{staticClass:"bank-links__account-status"},[_vm._v("\n              Sign in again to reconnect this account.\n            ")]):_vm._e()]),_vm._v(" "),(_vm.accountRequiresReconnect(account))?_c('div',{staticClass:"bank-links__account-actions"},[_c('button',{staticClass:"button button--white bank-links__reconnect-button",attrs:{"type":"button","data-linked-bank-account-id":account.linkedBankAccountId,"disabled":_vm.isBusy},on:{"click":function($event){$event.stopPropagation();return _vm.addAccount(account)}}},[_vm._v("\n              Reconnect\n            ")])]):_vm._e()])}),_vm._v(" "),(_vm.showAccountSkeleton)?_c('div',{staticClass:"bank-links__account bank-links__account--skeleton",attrs:{"role":"status","aria-label":"Finishing bank account setup"}},[_c('div',{staticClass:"bank-links__skeleton-logo"}),_vm._v(" "),_vm._m(0)]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('button',{ref:"addBankAccountButton",staticClass:"button button--bank-link button--full-width bank-links__add-button",attrs:{"type":"button","disabled":_vm.isBusy},on:{"click":function($event){return _vm.addAccount()}}},[(_vm.bankLinkButtonText)?_c('span',[_vm._v(_vm._s(_vm.bankLinkButtonText))]):[_c('span',[_vm._v("Add Account with")]),_vm._v(" "),_c('img',{staticClass:"bank-links__provider-logo",attrs:{"src":__webpack_require__("eVJx"),"alt":"Aerosync"}})]],2),_vm._v(" "),(_vm.showLinkingTip)?_c('alert-box',{staticClass:"bank-links__alert bank-links__alert--tip",attrs:{"level":"info"}},[_c('template',{slot:"title"},[_vm._v("Tip for Bank Linking Success")]),_vm._v(" "),_c('span',[_vm._v("\n          Aerosync only links with banks that conform to the highest technical and\n          security standards, so some regional banks or credit unions may not be able\n          to complete the link process. If you experience this, we recommend trying a\n          national bank or contacting\n        ")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.providerSupportUrl,"rel":"noopener noreferrer","target":"_blank"}},[_vm._v("Aerosync Support")]),_vm._v(" "),_c('span',[_vm._v(" for detailed assistance.")])],2):_vm._e(),_vm._v(" "),(_vm.featureNotice)?_c('p',{staticClass:"bank-links__notice"},[_vm._v("\n        "+_vm._s(_vm.featureNotice)+"\n      ")]):_vm._e()]:(!_vm.accountBeingRemoved)?[_c('div',{staticClass:"bank-links__accounts"},_vm._l((_vm.accounts),function(account){return _c('div',{key:account.linkedBankAccountId,staticClass:"bank-links__account"},[_c('img',{staticClass:"bank-links__institution-logo",attrs:{"src":_vm.defaultInstitutionLogo,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"bank-links__account-info"},[_c('div',{staticClass:"bank-links__institution-name"},[_vm._v("\n              "+_vm._s(account.institutionName || 'Bank account')+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"bank-links__account-name"},[_vm._v("\n              "+_vm._s(_vm.accountDescription(account))+"\n            ")])]),_vm._v(" "),_c('button',{staticClass:"bank-links__remove-icon",attrs:{"type":"button","aria-label":'Remove ' + (account.institutionName || 'bank account')},on:{"click":function($event){return _vm.requestRemoveAccount(account)}}})])}),0)]:[_c('div',{staticClass:"bank-links__confirm-remove"},[_c('p',{staticClass:"bank-links__confirm-remove-prompt"},[_vm._v("\n          Are you sure you want to remove this account?\n        ")]),_vm._v(" "),_c('div',{staticClass:"bank-links__account"},[_c('img',{staticClass:"bank-links__institution-logo",attrs:{"src":_vm.defaultInstitutionLogo,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"bank-links__account-info"},[_c('div',{staticClass:"bank-links__institution-name"},[_vm._v("\n              "+_vm._s(_vm.accountBeingRemoved.institutionName || 'Bank account')+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"bank-links__account-name"},[_vm._v("\n              "+_vm._s(_vm.accountDescription(_vm.accountBeingRemoved))+"\n            ")])])]),_vm._v(" "),_c('button',{staticClass:"button button--primary button--full-width",attrs:{"type":"button","disabled":_vm.isRemovingAccount},on:{"click":_vm.confirmRemoveAccount}},[_vm._v("\n          "+_vm._s(_vm.isRemovingAccount ? 'Removing...' : 'Yes')+"\n        ")])])]],2),_vm._v(" "),_c('div',{staticClass:"bank-links__widget",attrs:{"id":_vm.widgetElementId}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bank-links__skeleton-details"},[_c('div',{staticClass:"bank-links__skeleton-line bank-links__skeleton-line--name"}),_vm._v(" "),_c('div',{staticClass:"bank-links__skeleton-line bank-links__skeleton-line--account"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YZ+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");




/* eslint-disable no-mixed-operators */


var Contract = function () {
  function Contract(params) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Contract);

    var getters = ['hasLastTradePrice', 'lastTradePriceAsCents', 'lastClosePriceAsCents', 'changePriceAsCents', 'userAveragePricePerShareAsCents', 'userChangePriceAsCents', 'buyYesCostAsCents', 'buyNoCostAsCents', 'sellYesCostAsCents', 'sellNoCostAsCents', 'userOpenOrders', 'totalSharesTradedDisplay', 'mode', 'lastTradePriceAsCentsWithZeroBypass', 'investmentSizeAsCents'];
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
      if (getters.indexOf(key) < 0) {
        // to avoid setter exception
        _this[key] = params[key];
      }
    });
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Contract, [{
    key: 'hasLastTradePrice',
    get: function get() {
      return this.lastTradePriceAsCents > 0;
    }
  }, {
    key: 'lastTradePriceAsCents',
    get: function get() {
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["h" /* toCents */])(this.lastTradePrice);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(value) ? value : 0;
    }
  }, {
    key: 'lastTradePriceAsCentsWithZeroBypass',
    get: function get() {
      return this.hasLastTradePrice ? this.lastTradePriceAsCents : 0;
    }
  }, {
    key: 'lastClosePriceAsCents',
    get: function get() {
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["h" /* toCents */])(this.lastClosePrice);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(value) ? value : 0;
    }
  }, {
    key: 'changePriceAsCents',
    get: function get() {
      if (!this.hasLastTradePrice) {
        return 0;
      }

      return this.lastTradePriceAsCents - this.lastClosePriceAsCents;
    }
  }, {
    key: 'userAveragePricePerShareAsCents',
    get: function get() {
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["h" /* toCents */])(this.userAveragePricePerShare);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(value) ? value : 0;
    }
  }, {
    key: 'userChangePriceAsCents',
    get: function get() {
      if (!this.hasLastTradePrice) {
        return 0;
      }

      var roundedAverage = Math.round(this.userAveragePricePerShare * 100) / 100;
      if (this.mode === 'no') {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["h" /* toCents */])(1 - this.lastTradePrice - roundedAverage);
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["h" /* toCents */])(this.lastTradePrice - roundedAverage);
    }
  }, {
    key: 'buyYesCostAsCents',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* correctPrice */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["h" /* toCents */])(this.bestYesPrice || this.bestYesCost));
    }
  }, {
    key: 'buyNoCostAsCents',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* correctPrice */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["h" /* toCents */])(this.bestNoPrice || this.bestNoCost));
    }
  }, {
    key: 'sellYesCostAsCents',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* correctPrice */])(100 - this.buyNoCostAsCents);
    }
  }, {
    key: 'sellNoCostAsCents',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* correctPrice */])(100 - this.buyYesCostAsCents);
    }
  }, {
    key: 'userOpenOrders',
    get: function get() {
      return this.userOpenOrdersBuyQuantity + this.userOpenOrdersSellQuantity;
    }
  }, {
    key: 'mode',
    get: function get() {
      if (this.userQuantity === 0 && this.userOpenOrders === 0) return '';
      if (this.userPrediction === 0) return 'no';
      if (this.userPrediction === 1) return 'yes';
      return '';
    }
  }, {
    key: 'totalSharesTradedNumber',
    get: function get() {
      return this.totalSharesTraded || this.totalTrades || 0;
    }
  }, {
    key: 'totalSharesTradedDisplay',
    get: function get() {
      var value = this.totalSharesTradedNumber;
      return value.toLocaleString();
    }
  }, {
    key: 'investmentSizeAsCents',
    get: function get() {
      return this.lastTradePriceAsCents * this.totalSharesTradedNumber;
    }
  }]);

  return Contract;
}();

/* harmony default export */ __webpack_exports__["a"] = (Contract);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scrollState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_routes__ = __webpack_require__("KWv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_sessionVars__ = __webpack_require__("DECz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_dataLayer__ = __webpack_require__("k37b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_reloadOnChunkError__ = __webpack_require__("tkA1");

 /* eslint-disable arrow-body-style, max-len */












var scrollState = { pendingPosition: null };

var DISABLE_RESTRICTED_ACCESS_ROUTES = ['disqus-auth', 'social-auth', 'home'];

var DISABLE_CHECK_CLASSICS_ACCESS_ROUTES = ['terms-and-conditions'];

var PRERENDER_READY_FALLBACK_MS = 4000;

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

var RouterInstance = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  base: "/",
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to && __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(to, 'params.dontReload', false)) {
      return null;
    }
    if (savedPosition) {
      scrollState.pendingPosition = savedPosition;
      return null;
    }
    scrollState.pendingPosition = null;
    return { x: 0, y: 0 };
  },

  routes: __WEBPACK_IMPORTED_MODULE_5__router_routes__["a" /* default */]
});

RouterInstance.beforeEach(function (to, from, next) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers_reloadOnChunkError__["b" /* consumePendingChunkReload */])();

  if (from && from.name && from.fullPath) {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('app/setPreviousRoute', from.fullPath);
  }
  if (__WEBPACK_IMPORTED_MODULE_7__mixins_userAgent__["i" /* isStandalone */] && from.name && to.name && to.fullPath) {
    var expiresAt = 31536000;
    __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('currentRoutePath', to.fullPath, expiresAt);
  }

  var shouldCheckAccess = function shouldCheckAccess() {
    return false && !DISABLE_RESTRICTED_ACCESS_ROUTES.includes(to.name) || to.matched.some(function (record) {
      return record.meta.requiresAuth;
    });
  };

  var shouldCheckAnonymous = function shouldCheckAnonymous() {
    return to.matched.some(function (record) {
      return record.meta.requiresAnonymous;
    });
  };

  var shouldCheckClassicsEnabled = function shouldCheckClassicsEnabled() {
    return !DISABLE_CHECK_CLASSICS_ACCESS_ROUTES.includes(to.name);
  };

  var serverApiVersion = parseInt(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.app.serverVersion || 0, 10);
  var initialApiVersion = parseInt(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.app.initialVersion || 0, 10);

  if (serverApiVersion && initialApiVersion && serverApiVersion > initialApiVersion) {
    window.location.reload();
  }

  var hasClassicsNotEnabled = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.user.status.isClassicEnabled === false;

  if (shouldCheckAccess()) {
    if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['user/isLoggedIn'] === false) {
      next({
        name: 'home',
        query: { redirect: to.fullPath }
      });
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_modals_constants__["a" /* MODALS */].LOGIN);
    } else if (hasClassicsNotEnabled) {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_modals_constants__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC).then(function () {
        return next();
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('popup/setCurrentPopup').then(function () {
        return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('popup/setCurrentSmallPopup');
      }).then(function () {
        return next();
      });
    }
  } else if (shouldCheckAnonymous()) {
    if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['user/isLoggedIn'] === true) {
      next({ name: 'home', query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, to.query) });
    } else {
      next();
    }
  } else if (shouldCheckClassicsEnabled()) {
    if (hasClassicsNotEnabled) {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_modals_constants__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC).then(function () {
        return next();
      });
    } else {
      next();
    }
  } else {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('popup/setCurrentPopup').then(function () {
      return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('popup/setCurrentSmallPopup');
    }).then(function () {
      return next();
    });
  }
});

RouterInstance.afterEach(function (to) {
  __WEBPACK_IMPORTED_MODULE_8__helpers_sessionVars__["a" /* default */].check(to);
  if (to && to.fullPath) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers_dataLayer__["h" /* pushPageview */])(to.fullPath, to.name);
  setTimeout(function () {
    window.prerenderReady = true;
  }, PRERENDER_READY_FALLBACK_MS);
});

// Routes are lazy-loaded, so a navigation depends on fetching that route's
// chunk. If a deploy replaced the chunk hashes while an old client is still
// open, the fetch 404s; reload once to pull the fresh index.html + chunks.
RouterInstance.onError(__WEBPACK_IMPORTED_MODULE_11__helpers_reloadOnChunkError__["c" /* reloadOnChunkError */]);

/* harmony default export */ __webpack_exports__["a"] = (RouterInstance);

/***/ }),

/***/ "YfBz":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Im0xMS4zMzQgNy0zLjE3NyAzLjI2NmEuMjIyLjIyMiAwIDAgMS0uMTU3LjA2Ny4yMTYuMjE2IDAgMCAxLS4xNTctLjA2N0w0LjY2NyA3IiBzdHJva2U9IiMwQzBDMEMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ "Z05w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_how_it_works_js__ = __webpack_require__("8KbT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e19be50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_how_it_works_vue__ = __webpack_require__("IS7d");
function injectStyle (ssrContext) {
  __webpack_require__("Vgd5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_how_it_works_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e19be50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_how_it_works_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z4oj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOSIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE5IDE3Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTEuMTYgNi44NjNoMy4xMzl2Ni42MDFIMS4xNnpNMTQuNjkxIDEwLjI3NGgzLjEzOXYzLjE5MWgtMy4xMzl6Ii8+CiAgICAgICAgPHBhdGggZmlsbD0iIzY3OTk5RiIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMTguNDEgMTUuODE0SC41OGMtLjMyIDAtLjU4LjI2NC0uNTguNTkgMCAuMzI1LjI2LjU4OS41OC41ODloMTcuODNjLjMyIDAgLjU4LS4yNjQuNTgtLjU5IDAtLjMyNS0uMjYtLjU5LS41OC0uNTl6TTE4LjQxIDkuMDk1aC00LjNjLS4zMiAwLS41OC4yNjQtLjU4LjU5djQuMzdjMCAuMzI1LjI2LjU4OS41OC41ODloNC4zYy4zMiAwIC41OC0uMjY0LjU4LS41OXYtNC4zN2MwLS4zMjUtLjI2LS41OS0uNTgtLjU5em0tLjU4IDQuMzdoLTMuMTR2LTMuMTkxaDMuMTR2My4xOXpNLjU4IDE0LjY0NGg0LjNjLjMyIDAgLjU4LS4yNjQuNTgtLjU5di03Ljc4YzAtLjMyNi0uMjYtLjU5LS41OC0uNTlILjU4Yy0uMzIgMC0uNTguMjY0LS41OC41OXY3Ljc4YzAgLjMyNi4yNi41OS41OC41OXptLjU4LTcuNzhINC4zdjYuNkgxLjE2di02LjZ6TTcuMzQ1IDE0LjY0NGg0LjNjLjMyIDAgLjU4LS4yNjQuNTgtLjU5Vi42MzZjMC0uMzI1LS4yNi0uNTktLjU4LS41OWgtNC4zYy0uMzIgMC0uNTguMjY1LS41OC41OXYxMy40MThjMCAuMzI2LjI2LjU5LjU4LjU5em0uNTgtMTMuNDE4aDMuMTR2MTIuMjM5aC0zLjE0VjEuMjI1eiIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "ZAp9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZBib":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZC+n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BiggestGainsLoader_vue__ = __webpack_require__("tV9q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9907168e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BiggestGainsLoader_vue__ = __webpack_require__("LQ9G");
function injectStyle (ssrContext) {
  __webpack_require__("hBIN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BiggestGainsLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9907168e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BiggestGainsLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZFw9":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "ZJhQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_table_js__ = __webpack_require__("Oz+7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79df48c5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_vue__ = __webpack_require__("xnHd");
function injectStyle (ssrContext) {
  __webpack_require__("lDJT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_table_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79df48c5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZKEq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']))
});

/***/ }),

/***/ "ZKfp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zb6m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DepositAmountOverview',
  props: {
    amount: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    infoAmount: function infoAmount() {
      var number = Number(this.amount).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return '$' + number;
    }
  }
});

/***/ }),

/***/ "ZdYx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zdfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "Zi8f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_list_item_v2_market_list_item_v2_vue__ = __webpack_require__("tPuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_content_loader__ = __webpack_require__("SHAV");








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketListItem: __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_list_item_v2_market_list_item_v2_vue__["a" /* default */],
    marketLoader: __WEBPACK_IMPORTED_MODULE_5__components_content_loader__["d" /* MarketLoader */],
    swiper: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiperSlide"]
  },
  props: {
    num: { type: Number, default: 3 }
  },
  data: function data() {
    var _this = this;

    return {
      isComponentReady: false,
      activeIndex: 0,
      swiperOptions: {
        slidesPerView: 1,
        loop: true,
        direction: 'horizontal',
        spaceBetween: 0,
        onTransitionStart: function onTransitionStart(swp) {
          _this.activeIndex = swp.activeIndex;
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('widgets', ['getWidget']), {
    widget: function widget() {
      return this.getWidget('new-arrivals');
    },
    items: function items() {
      return (this.widget.data || []).slice(0, this.num);
    },
    dummyComponents: function dummyComponents() {
      if (this.isLayoutMobile) return __WEBPACK_IMPORTED_MODULE_1_lodash_range___default()(0, 1);
      return __WEBPACK_IMPORTED_MODULE_1_lodash_range___default()(0, this.num);
    },
    prevArrowModifiers: function prevArrowModifiers() {
      return {
        'most-predicted-list__header-arrow': true,
        'most-predicted-list__header-arrow--left': true
      };
    },
    nextArrowModifiers: function nextArrowModifiers() {
      return {
        'most-predicted-list__header-arrow': true,
        'most-predicted-list__header-arrow--right': true
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('widgets', ['fetchNewArrivals']), {
    prevSlide: function prevSlide() {
      this.$refs.swiper.swiper.slidePrev();
    },
    nextSlide: function nextSlide() {
      this.$refs.swiper.swiper.slideNext();
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.fetchNewArrivals({ limit: this.num }).then(function () {
      _this2.isComponentReady = true;
    });
  }
});

/***/ }),

/***/ "ZllZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_orderBy__ = __webpack_require__("Ba3q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    stats: {
      type: Array,
      required: true
    },
    isFixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      sortParam: 'totalSharesTraded',
      sortOrder: 'desc'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('market', ['market']), {
    isMarketSettled: function isMarketSettled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["o" /* isMarketSettled */])(this.market);
    },
    sortedItems: function sortedItems() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash_orderBy___default()(this.stats, [this.sortParam], [this.sortOrder]);
    },
    isSortable: function isSortable() {
      return this.stats.length > 1;
    },
    secondColumnModifiers: function secondColumnModifiers() {
      return {
        'market-contracts-stats--middle': this.isSortable && !this.isMarketSettled,
        'market-contracts-stats--last-volume': this.isSortable && this.isMarketSettled
      };
    },
    thirdColumnModifiers: function thirdColumnModifiers() {
      return {
        'market-contracts-stats--middle': this.isLayoutDesktop,
        'market-contracts-stats--last': !this.isLayoutDesktop
      };
    },
    totalSharesTradedSum: function totalSharesTradedSum() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(this.stats, function (x) {
        return x.totalSharesTraded;
      }).toLocaleString();
    },
    todaysVolumeSum: function todaysVolumeSum() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(this.stats, function (x) {
        return x.todaysVolume;
      }).toLocaleString();
    },
    openInterestSum: function openInterestSum() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(this.stats, function (x) {
        return x.openInterest;
      }).toLocaleString();
    }
  }),
  methods: {
    headerSortByModifiers: function headerSortByModifiers(name) {
      if (!this.isSortable) return {};

      return {
        'market-contracts-stats--sort-by': this.sortParam === name,
        'market-contracts-stats--asc': this.sortParam === name && this.sortOrder === 'asc',
        'market-contracts-stats--desc': this.sortParam === name && this.sortOrder === 'desc'
      };
    },
    sortBy: function sortBy(name) {
      if (this.sortParam === name) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortOrder = 'desc';
        this.sortParam = name;
      }
    }
  }
});

/***/ }),

/***/ "Zn+p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"market-money-widget__title"},[_vm._v(_vm._s(_vm.obj.title))]),_vm._v(" "),(!!_vm.widget)?_c('div',{staticClass:"market-money-widget__content",on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_c('div',{staticClass:"market-money-widget__percent-container"},[_c('div',{staticClass:"market-money-widget__percent"},[_vm._v(_vm._s(_vm.percent))]),_vm._v(" "),_c('div',{staticClass:"market-money-widget__percent-title"},[_c('div',{staticClass:"market-money-widget__percent-vertical"},[_vm._v(_vm._s(_vm.obj.percentTitle))])])]),_vm._v(" "),_c('div',{staticClass:"market-money-widget__market"},[_vm._v(_vm._s(_vm.obj.marketName))]),_vm._v(" "),_c('div',{staticClass:"market-money-widget__contract"},[_c('div',{staticClass:"market-money-widget__contract-title"},[_vm._v(_vm._s(_vm.contractName))]),_vm._v(" "),_c('div',{staticClass:"market-money-widget__contract-section"},[_c('span',{staticClass:"market-money-widget__contract-price"},[(_vm.hasPrice)?[_c('animated-number',{attrs:{"value":_vm.price}})]:[_vm._v("\n            -"),_c('span',{domProps:{"innerHTML":_vm._s('&cent;')}})]],2),_vm._v(" "),_c('market-change-price',{staticClass:"market-money-widget__contract-delta",attrs:{"price":_vm.delta}}),_vm._v(" "),(_vm.hasPrice)?_c('span',{class:_vm.iconModifiers}):_vm._e()],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZqrY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_section_header_js__ = __webpack_require__("mXqA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_391833b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_section_header_vue__ = __webpack_require__("J4k6");
function injectStyle (ssrContext) {
  __webpack_require__("Rm0x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_section_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_391833b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_section_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a0yF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ALLOWED_NOTIFICATION_TYPES; });
/* unused harmony export IGNORE_TIMESTAMP_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NOTIFICATION_MATCHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NOTIFICATION_SETTLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NOTIFICATION_PRICE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NOTIFICATION_LEVEL; });
/* unused harmony export NOTIFICATIONS_ONLINE_BANKING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return NOTIFICATION_TRADE_CONFIRMED_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NOTIFICATION_SHARES_TRADED_CLOSE_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MARKET_DATA_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return MY_SHARES_MARKET_DATA_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CONTRACT_DATA_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ACCOUNT_FUNDS_MAP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_camelCase__ = __webpack_require__("NRb0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_camelCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_reduce__ = __webpack_require__("M+Z9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_notifications_signal_r__ = __webpack_require__("ENdH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_notifications_firebase__ = __webpack_require__("2Pqz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_constants__ = __webpack_require__("rARD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__ = __webpack_require__("QNMw");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["e"]; });



/* eslint-disable no-console, arrow-body-style, no-case-declarations */







// import ss from '@/helpers/sessionStorage';




/*
  Notification type names moved to ./notification-types.js (import-free module)
  so consumers like utils/helpers.js don't need to import this proxy;
  re-exported here for backward compatibility.
 */


/*
  List of notification types that *should* display in top right corner of the app.
 */
var ALLOWED_NOTIFICATION_TYPES = [__WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["b" /* NOTIFICATION_SIMPLE */], __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["c" /* NOTIFICATION_TRADE_CONFIRMED */], __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["d" /* NOTIFICATION_SHARES_TRADED */], __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["e" /* NOTIFICATION_TRADER_LEVEL_CHANGED */]];

var IGNORE_TIMESTAMP_TYPES = [__WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["c" /* NOTIFICATION_TRADE_CONFIRMED */], __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["d" /* NOTIFICATION_SHARES_TRADED */], __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["f" /* NOTIFICATION_MARKET_STATUS */]];
/*
  Generic notification types that come from API (backend).
  The reason for separate list is determined by other typing mechanism used by
  API as opposed to signalr notifications.
  For now NOTIFICATION_SHARES_TRADED maps to NOTIFICATION_MATCHED.
  and NOTIFICATION_TRADER_LEVEL_CHANGED to NOTIFICATION_LEVEL
 */
var NOTIFICATION_MATCHED = 1;
var NOTIFICATION_SETTLED = 2;
var NOTIFICATION_PRICE_CHANGE = 3;
var NOTIFICATION_LEVEL = 12;
var NOTIFICATIONS_ONLINE_BANKING = [13, 14];
/*
  Number of milliseconds to delay confirmations so they do not appear instantly after submit click
  because simple notification should display first.
 */
var NOTIFICATION_TRADE_CONFIRMED_DELAY = 1250;
var NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY = 10000;
var NOTIFICATION_SHARES_TRADED_CLOSE_DELAY = 5000;

var MARKET_DATA_MAP = {
  TotalSharesTraded: 'totalSharesTraded',
  UserGainLoss: 'userGainLoss',
  UserInvestment: 'userInvestment',
  UserMaxPayout: 'userMaxPayout',
  Status: 'status',
  IsOpen: 'isOpen',
  IsActive: 'isActive',
  IsProcessed: 'isProcessed',
  UserHasOwnership: 'userHasOwnership'
};

// additional map because of TotalSharesTraded different mapping
var MY_SHARES_MARKET_DATA_MAP = {
  TotalSharesTraded: 'marketSharesTraded',
  UserGainLoss: 'userGainLoss',
  UserInvestment: 'userInvestment',
  UserMaxPayout: 'userMaxPayout',
  Status: 'status',
  IsOpen: 'isOpen',
  IsActive: 'isActive',
  IsProcessed: 'isProcessed',
  IsOpenStatusMessage: 'isOpenStatusMessage',
  UserHasOwnership: 'userHasOwnership'
};

var CONTRACT_DATA_MAP = {
  TimeStamp: 'timestamp',
  BestNoPrice: 'bestNoPrice',
  BestNoCost: 'bestNoPrice',
  BestYesPrice: 'bestYesPrice',
  BestYesCost: 'bestYesPrice',
  LastClosePrice: 'lastClosePrice',
  LastTradePrice: 'lastTradePrice',
  UserAveragePricePerShare: 'userAveragePricePerShare',
  UserQuantity: 'userQuantity',
  UserOpenOrdersBuyQuantity: 'userOpenOrdersBuyQuantity',
  UserOpenOrdersSellQuantity: 'userOpenOrdersSellQuantity',
  UserPrediction: 'userPrediction'
};

var ACCOUNT_FUNDS_MAP = {
  AccountBalance: 'accountBalance',
  AccountBalanceDecimal: 'accountBalanceDecimal',
  PortfolioBalance: 'portfolioBalance',
  PortfolioBalanceDecimal: 'portfolioBalanceDecimal',
  ShareValueDelta: 'shareValueDelta',
  ShareValueDeltaDecimal: 'shareValueDeltaDecimal',
  ProfitablePredictions: 'profitablePredictions'
};

var pageLoad = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
var processedGuids = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();

var updateOrResetCounters = function updateOrResetCounters() {
  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('dashboard/toggleNotifications');

  if (!__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.notifications.showNotificationsWidget) {
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('user/increaseUserUnreadNotificationsCount');
  } else {
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('user/setUserUnreadNotificationsCount', 0);
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('dashboard/markNotificationsAsRead');
  }
};

var addToStore = function addToStore(method, updateType, data) {
  if (!data) return;

  if (data && data.TimeStamp && !IGNORE_TIMESTAMP_TYPES.includes(updateType)) {
    if (__WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(data.TimeStamp).diff(pageLoad, 'seconds') < 0) {
      return;
    }
  }

  if (data.Guid) {
    if (processedGuids.has(data.Guid)) return;
    processedGuids.add(data.Guid);
  }

  data.UpdateType = updateType;
  switch (updateType) {
    case __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["g" /* NOTIFICATION_ACCOUNT_FUNDS */]:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('user/getStatus');
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/updateBalanceFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('profile/updateProfileFromNotification', data);
      break;
    case __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["h" /* NOTIFICATION_MARKET */]:
    case __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["i" /* NOTIFICATION_MARKET_OWNERSHIP */]:
    case __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["f" /* NOTIFICATION_MARKET_STATUS */]:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/updateMarketFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/updateRelatedMarketFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('browse/updateMarketFromNotification', data);
      // store.dispatch('browse/updateStoryMapFromMarketNotification', data);
      // store.dispatch('browse/updateGainsLossMarketFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('browse/updatePredictedTrendingMarketFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('dashboard/updateMySharesFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('search/updateMarketFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('watchlist/updateWatchlistFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('popup/updateTradePopupOptionsMarketFromNotification', data);
      break;
    case __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["j" /* NOTIFICATION_CONTRACT */]:
    case __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["a" /* NOTIFICATION_CONTRACT_OWNERSHIP */]:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/updateContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/updateRelatedContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('browse/updateContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('browse/updateGainsLossContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('browse/updatePredictedTrendingContractsFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('browse/updateMarketWidgetsContractsFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('dashboard/updateMySharesContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('search/updateContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('watchlist/updateWatchlistContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('popup/updateTradePopupOptionsContractsFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/updateMapOverviewDataFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/updateMapOverviewDataSenateFromNotification', data);
      // store.dispatch('browse/updateStoryMapFromContractNotification', data);
      break;
    case __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["k" /* NOTIFICATION_SITE_STATUS */]:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('app/setServerError', false);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('app/setMaintenance', {
        isMaintenanceEnabled: data.IsMaintenance,
        isTradingEnabled: !data.IsTradingSuspended,
        maintenanceMessage: data.MaintenanceMessage,
        suspendedMessage: data.TradingSuspendedMessage,
        systemMessage: data.SystemMessage
      });
      break;
    case __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["d" /* NOTIFICATION_SHARES_TRADED */]:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('notifications/add', {
        method: method,
        type: updateType,
        data: {
          contentJson: data,
          notificationType: NOTIFICATION_MATCHED
        }
      });
      updateOrResetCounters();
      break;
    case __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["e" /* NOTIFICATION_TRADER_LEVEL_CHANGED */]:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('notifications/add', {
        method: method,
        type: updateType,
        data: {
          contentJson: data,
          notificationType: NOTIFICATION_LEVEL
        }
      });
      updateOrResetCounters();
      break;
    case __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["l" /* NOTIFICATION_PWMB_DEPOSIT_SHOW_CONFIRMATION */]:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/setBankTransferStep', {
        step: data.PrefilledAmountToDeposit ? __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_constants__["a" /* STEPS */].CONFIRM : __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_constants__["a" /* STEPS */].AMOUNT_CONFIRM,
        stepData: __WEBPACK_IMPORTED_MODULE_2_lodash_reduce___default()(data, function (result, value, key) {
          result[__WEBPACK_IMPORTED_MODULE_1_lodash_camelCase___default()(key)] = value;
          return result;
        }, {})
      });
      break;
    case __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["m" /* NOTIFICATION_PWMB_SHOW_ERROR */]:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/setBankTransferStep', {
        step: __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_constants__["a" /* STEPS */].FINISHED_FAILED,
        stepData: {
          error: data.MessageForUser
        }
      });
      break;
    case __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["n" /* NOTIFICATION_PWMB_DEPOSIT_FINISHED */]:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/getBalance').then(function () {
        return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/setCurrentDeposit', {
          amount: data.TotalAmountDeposited,
          matched: data.AmountMatched,
          messageForUser: data.MessageForUser,
          confirmationNumber: data.PWMBCaptureId,
          type: 'bank-transfer',
          account: {
            accountStatus: 1,
            bankInfo: {
              bankIconUrl: data.BankIconURL,
              bankAccountDisplayName: data.BankAccountDisplayName,
              bankDisplayName: data.BankDisplayName
            }
          }
        });
      }).then(function () {
        if (data.Status === __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_constants__["b" /* FINISHED_STATUS */].SUCCESS) {
          __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/setBankTransferStep', {
            step: __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_constants__["a" /* STEPS */].FINISHED_SUCCESS,
            stepData: {}
          });
        } else if (data.Status === __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_constants__["b" /* FINISHED_STATUS */].FAILED) {
          __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/setBankTransferStep', {
            step: __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_constants__["a" /* STEPS */].FINISHED_FAILED,
            stepData: {
              error: data.MessageForUser
            }
          });
        } else if (data.Status === __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_constants__["b" /* FINISHED_STATUS */].EXPIRED) {
          __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/setBankTransferStep', {
            step: __WEBPACK_IMPORTED_MODULE_10__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_constants__["a" /* STEPS */].FINISHED_EXPIRED,
            stepData: {
              pwmbAuthorizationId: data.PWMBAuthorizationId,
              error: data.MessageForUser
            }
          });
        }
      });
      break;
    case __WEBPACK_IMPORTED_MODULE_11__services_notifications_notification_types__["c" /* NOTIFICATION_TRADE_CONFIRMED */]:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/incrReloadHistoryToggle');
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('notifications/add', {
        method: method,
        type: updateType,
        data: data
      });
      break;
    default:
      {
        var payload = {
          method: method,
          type: updateType,
          data: data
        };
        __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('notifications/add', payload);
      }
  }
};

var KEY_MESSAGING_STATE = 'messagingState';
var MESSAGING_STATES = {
  OPT_IN: 'opt-in',
  OPT_OUT: 'opt-out',
  NO_DECISION: 'no-decision'
};
/* harmony default export */ __webpack_exports__["a"] = ({
  initialisedFirebaseAnonymous: false,
  initialisedFirebase: false,
  initialisedSignalr: false,
  latestApiToken: null,
  init: function init() {
    this.initFirebase();
    this.initSignalr();
  },
  initFirebase: function initFirebase() {
    var apiToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    __WEBPACK_IMPORTED_MODULE_5__services_notifications_firebase__["a" /* connect */](apiToken, { onUpdate: addToStore });

    if (apiToken) {
      this.initialisedFirebase = true;
    } else {
      this.initialisedFirebaseAnonymous = true;
    }
  },
  initSignalr: function initSignalr() {
    var apiToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (!apiToken && !false) {
      return;
    }
    __WEBPACK_IMPORTED_MODULE_4__services_notifications_signal_r__["a" /* createConnection */]({ apiToken: apiToken, onUpdate: addToStore });
    this.initialisedSignalr = true;
  },
  authorize: function authorize(apiToken) {
    // reinitialise if it was switched off for anonymous users
    if (!this.initialisedFirebase) {
      __WEBPACK_IMPORTED_MODULE_8__logger__["a" /* default */].info('firebase::', 'authorize::', 'init::');
      this.initFirebase(apiToken);
    }
    if (!this.initialisedSignalr) {
      __WEBPACK_IMPORTED_MODULE_8__logger__["a" /* default */].info('socket::', 'authorize::', 'init::');
      this.initSignalr(apiToken);
      this.latestApiToken = apiToken;
    } else if (this.latestApiToken !== apiToken) {
      __WEBPACK_IMPORTED_MODULE_8__logger__["a" /* default */].info('socket::', 'authorize::', 'reinitializetoken::');
      __WEBPACK_IMPORTED_MODULE_4__services_notifications_signal_r__["b" /* forceReconnect */]({ apiToken: apiToken, onUpdate: addToStore });
      this.latestApiToken = apiToken;
    } else {
      __WEBPACK_IMPORTED_MODULE_8__logger__["a" /* default */].info('socket::', 'authorize::', 'stale::');
    }
  },
  logout: function logout() {
    __WEBPACK_IMPORTED_MODULE_4__services_notifications_signal_r__["c" /* forceDisconnect */]();
    this.initialisedSignalr = false;
    // firebase is for anonymous users right now, no need to logout
    // if (window.firebase.apps.length > 0) {
    //   window.firebase.app().delete().then(() => {
    //   });
    // }
  },
  setupMessaging: function setupMessaging() {
    __WEBPACK_IMPORTED_MODULE_5__services_notifications_firebase__["b" /* setupMessaging */]();
  },
  forceDisconnect: function forceDisconnect() {
    __WEBPACK_IMPORTED_MODULE_4__services_notifications_signal_r__["c" /* forceDisconnect */]();
  },
  shouldSetupMessaging: function shouldSetupMessaging() {
    if (!__webpack_require__.i({"NODE_ENV":"production","SENTRY_ENVIRONMENT":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","PI_YOUTUBE_LINK":"https://www.youtube.com/c/predictitofficial","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_SIGNALR":false,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","ATTACH_TO_HOME_POPUP_ENABLED":false,"PINNING_ENABLED":false,"DEPOSIT_PROMO_INPUT_BOX_ENABLED":false,"STORIES_PAGE_ENABLED":false,"DISABLE_TWO_FACTOR_PROMPT":true,"COLLEGE_AFFILIATION_ENABLED":true}).PUSH_NOTIFICATIONS_JOURNEY_ENABLED) return true;

    var state = __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].get(KEY_MESSAGING_STATE, MESSAGING_STATES.NO_DECISION);
    return state === MESSAGING_STATES.OPT_IN;
  },
  showMessagingJourney: function showMessagingJourney(isBuyTradeType) {
    if (!__webpack_require__.i({"NODE_ENV":"production","SENTRY_ENVIRONMENT":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","PI_YOUTUBE_LINK":"https://www.youtube.com/c/predictitofficial","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_SIGNALR":false,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","ATTACH_TO_HOME_POPUP_ENABLED":false,"PINNING_ENABLED":false,"DEPOSIT_PROMO_INPUT_BOX_ENABLED":false,"STORIES_PAGE_ENABLED":false,"DISABLE_TWO_FACTOR_PROMPT":true,"COLLEGE_AFFILIATION_ENABLED":true}).PUSH_NOTIFICATIONS_JOURNEY_ENABLED || !isBuyTradeType) return;

    var state = __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].get(KEY_MESSAGING_STATE, MESSAGING_STATES.NO_DECISION);
    if (state !== MESSAGING_STATES.NO_DECISION) return;

    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('popup/setCurrentSmallPopup', __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_modals_constants__["a" /* MODALS */].SMALL_MESSAGING_JOURNEY);
    }, 4000);
  },
  optOutMessaging: function optOutMessaging() {
    __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].set(KEY_MESSAGING_STATE, MESSAGING_STATES.OPT_OUT);
  },
  optInMessaging: function optInMessaging() {
    __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].set(KEY_MESSAGING_STATE, MESSAGING_STATES.OPT_IN);
  }
});

/***/ }),

/***/ "a8vN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    label: String,
    checked: Boolean,
    small: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classIsChecked: function classIsChecked() {
      return this.checked ? 'checkbox__tick--checked' : '';
    },
    checkboxModifiers: function checkboxModifiers() {
      return {
        'checkbox--small': this.small
      };
    }
  },
  methods: {
    onChange: function onChange(e) {
      this.$emit('change', e.target.checked);
    }
  }
});

/***/ }),

/***/ "aDe5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_captcha_js__ = __webpack_require__("EGLE");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b6bc078_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_captcha_vue__ = __webpack_require__("7DOx");
function injectStyle (ssrContext) {
  __webpack_require__("1deZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_captcha_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b6bc078_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_captcha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aHny":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_key_stats_js__ = __webpack_require__("2+il");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d40979d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_key_stats_vue__ = __webpack_require__("Bmi9");
function injectStyle (ssrContext) {
  __webpack_require__("n9uA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_key_stats_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d40979d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_key_stats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aIx/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"most-predicted"},[_c('div',{staticClass:"most-predicted__header"},[_c('div',[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),(_vm.isLayoutMobile)?_c('div',{staticClass:"most-predicted__header-arrows"},[_c('span',{class:_vm.prevArrowModifiers,on:{"click":_vm.prevSlide}}),_vm._v(" "),_c('span',{class:_vm.nextArrowModifiers,on:{"click":_vm.nextSlide}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row most-predicted__content"},[(_vm.isLayoutMobile)?_c('swiper',{ref:"swiper",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.items),function(item){return _c('swiper-slide',{key:item.marketId},[_c('market-list-item',{staticClass:"most-predicted__swiper-slide",attrs:{"market":item,"theme":"home"}})],1)}),1):_c('div',{staticClass:"row"},_vm._l((_vm.items),function(market){return _c('div',{key:market.marketId,staticClass:"large-4 column most-predicted__swiper-column"},[_c('market-list-item',{key:market.marketId,attrs:{"market":market,"theme":"home"}})],1)}),0)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aLRO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-price-change-chart"},[_c('div',{ref:"chart",staticClass:"market-price-change-chart__chart"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aMy0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

// Requires feeWaivedBannerMixin mixed in alongside this one (provides feeWaivedBannerTxt).
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      childNotifications: []
    };
  },

  computed: {
    notifications: function notifications() {
      var items = [];
      if (this.feeWaivedBannerTxt) {
        items.push({ key: 'fee-waived', text: this.feeWaivedBannerTxt, level: 'success' });
      }
      return [].concat(items, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.childNotifications));
    }
  },
  methods: {
    onChildNotification: function onChildNotification() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.childNotifications = items;
    },
    resetChildNotifications: function resetChildNotifications() {
      this.childNotifications = [];
    }
  }
});

/***/ }),

/***/ "aaFU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aeoD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


var DEFAULT_TIMELINE = 7;

/* harmony default export */ __webpack_exports__["a"] = ({
  getProfileDetail: function getProfileDetail() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Detail');
  },
  getMyShares: function getMyShares(sort, sortPar) {
    var sorting = sort ? '?sort=' + sort : '';
    var sortParameter = sorting && sortPar ? '&sortParameter=' + sortPar : '';
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Shares' + sorting + sortParameter);
  },
  getTradeHistory: function getTradeHistory(itemsPerPage, page, marketId) {
    var contractId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var tradeType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Trade/History?itemsPerPage=' + itemsPerPage + '&page=' + page + '&marketId=' + marketId + '&contractId=' + contractId + '&tradeType=' + tradeType);
  },
  getTransactionHistory: function getTransactionHistory(itemsPerPage, page) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ALL';
    var year = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    var url = 'api/User/Wallet/History?itemsPerPage=' + itemsPerPage + '&page=' + page + '&type=' + type;
    var restOfQueryString = year ? '&year=' + year : '';
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url.concat(restOfQueryString));
  },
  getMarketPayouts: function getMarketPayouts(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Market/' + marketId + '/Payouts');
  },
  getContractOffers: function getContractOffers(contractId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/contract/' + contractId + '/Offers');
  },
  getContractShares: function getContractShares(contractId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/contract/' + contractId + '/Shares');
  },
  getTradeHistoryMarkets: function getTradeHistoryMarkets() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Trade/History/Markets');
  },
  getMarketWatch: function getMarketWatch(sort, sortPar) {
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var itemsPerPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;

    var sorting = sort ? '?sort=' + sort : '';
    var sortParameter = sorting && sortPar ? '&sortParameter=' + sortPar : '';
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/MarketWatch' + sorting + sortParameter + '&itemsPerPage=' + itemsPerPage + '&page=' + page);
  },
  putMarketWatch: function putMarketWatch(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Profile/MarketWatch/' + marketId);
  },
  deleteMarketWatch: function deleteMarketWatch(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].delete('api/Profile/MarketWatch/' + marketId);
  },
  getPortfolioChart: function getPortfolioChart() {
    var timespan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TIMELINE;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('/api/Profile/Portfolio?timespan=' + timespan);
  },
  putSettings: function putSettings(category, key, value) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Profile/Settings/Categories/' + category + '/Keys/' + key + '/' + value);
  },
  getAllSettings: function getAllSettings(categories) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('/api/Profile/Settings/Categories?categories=' + categories);
  },
  getNotifications: function getNotifications() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var itemsPerPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Notifications?itemsPerPage=' + itemsPerPage + '&page=' + page);
  },
  putNotification: function putNotification(notificationId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Profile/Notifications/' + notificationId + '/read');
  },
  putNotifications: function putNotifications() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Profile/Notifications/markRead');
  },
  postSendInviteEmail: function postSendInviteEmail(email) {
    var payload = {
      email: email
    };
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Profile/invite/email', payload);
  },
  getUnreadNotificationsCount: function getUnreadNotificationsCount() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/UnreadNotificationsCount');
  },
  getUserAffiliations: function getUserAffiliations() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Affiliations');
  },
  setUserAffiliations: function setUserAffiliations(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Profile/Affiliations', payload);
  },
  removeUserAffiliations: function removeUserAffiliations(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].delete('api/Profile/Affiliations', payload);
  },
  getAffiliations: function getAffiliations(search) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Affiliations/Search/' + search);
  }
});

/***/ }),

/***/ "al65":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_button_price_js__ = __webpack_require__("1lzi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1d8cab8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_price_vue__ = __webpack_require__("tUhF");
function injectStyle (ssrContext) {
  __webpack_require__("SfXH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_button_price_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1d8cab8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_price_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "azKn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_trading_unavailable_v2_js__ = __webpack_require__("sS6v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_282d136a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_trading_unavailable_v2_vue__ = __webpack_require__("yOrf");
function injectStyle (ssrContext) {
  __webpack_require__("xLyB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_trading_unavailable_v2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_282d136a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_trading_unavailable_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b+hr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('popup', ['currentPopupOptions']), {
    classModifiers: function classModifiers() {
      return {
        'popup-generic-small': true,
        'popup-generic-small--icon': this.currentPopupOptions && this.currentPopupOptions.icon
      };
    }
  })
});

/***/ }),

/***/ "b34n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b4Ty":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api_http__ = __webpack_require__("p1CT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__ = __webpack_require__("a0yF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_mobile_wrapper__ = __webpack_require__("S9O8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generics_overlay_overlay_vue__ = __webpack_require__("RuD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app_layout_app_layout_vue__ = __webpack_require__("gjXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_app_app_modals_app_modals_vue__ = __webpack_require__("PUuo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_app_app_privacy_statement_app_privacy_statement_vue__ = __webpack_require__("z/nA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_instant_credit__ = __webpack_require__("zAJv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_dataLayer__ = __webpack_require__("k37b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_app_app_loader_app_loader_vue__ = __webpack_require__("EIVR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_what_is_new_popup_helpers__ = __webpack_require__("AyQu");


/* eslint-disable consistent-return, no-void */






















var RESIZE_HANDLER_TIMEOUT = 500;
var SOCIAL_AUTH_ROUTES = ['disqus-auth', 'social-auth'];

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__mixins_userAgent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__mixins_loader__["a" /* default */]],
  data: function data() {
    return {
      appFlowDisabled: false,
      appInitialPopupShown: false,
      initialised: false,
      disconnectTimeout: null,
      connectTimeout: null,
      connectTimeoutAnonymous: null,
      touchStartTop: 0
    };
  },

  components: {
    overlay: __WEBPACK_IMPORTED_MODULE_7__components_generics_overlay_overlay_vue__["a" /* default */],
    appPrivacyStatement: __WEBPACK_IMPORTED_MODULE_14__components_app_app_privacy_statement_app_privacy_statement_vue__["a" /* default */],
    appLayoutOld: __WEBPACK_IMPORTED_MODULE_8__components_app_app_layout_app_layout_vue__["a" /* default */],
    appModals: __WEBPACK_IMPORTED_MODULE_13__components_app_app_modals_app_modals_vue__["a" /* default */],
    appLoader: __WEBPACK_IMPORTED_MODULE_18__components_app_app_loader_app_loader_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['skipAttachToHomeNotification', 'isTabActive', 'newLoaderCounter', 'settingColorPalette']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['token']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('market', ['activeCategory']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('popup', ['currentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('profile', ['profileStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('user', ['loginWithDisqus', 'isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['hasMaintenance', 'isLayoutMobile', 'isShutdownModeOn', 'newLoaderIsLoading', 'collegeAffiliationEnabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['navigatingToTwoFactorSetup']), {
    layoutComponent: function layoutComponent() {
      return __WEBPACK_IMPORTED_MODULE_8__components_app_app_layout_app_layout_vue__["a" /* default */];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('app', ['setLayoutWidth', 'setIsTabActive', 'setLiveUpdatesDisabled', 'setSettingShowOdds', 'setSettingsAnnouncementCurState']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('browse', ['getHeaders']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('user', ['getStatus', 'getAccountDetail', 'getUserInfo', 'login', 'logout', 'clearAuthSession', 'setBareToken', 'setUserUnreadNotificationsCount', 'checkAndCacheTwoFactorStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('profile', ['getProfileDetail', 'getAllSettings', 'setProfileStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('wallet', ['getBalance', 'clearBalance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('market', ['getBiggestGains']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentPopupOptions']), {
    getUserDetailedInformation: function getUserDetailedInformation() {
      var _this = this;

      this.getAccountDetail().then(function (data) {
        _this.setUserUnreadNotificationsCount(data.userUnreadNotificationsCount);
        if (data.idVerified) {
          return _this.getBalance();
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
      }).then(this.getAllSettings).then(this.getStatus).then(function (data) {
        _this.appInitialPopupShown = false;
        var skipRoutes = ['terms-and-conditions', 'password-set'];
        var showVerifyPopup = !skipRoutes.includes(_this.$route.name) && !_this.hasMaintenance && !_this.checkDataIfUserIsVerified(_this.userData);

        if (showVerifyPopup && !_this.appInitialPopupShown) {
          _this.showAccountVerifyPopup();
          // Stop here - let modal close handler continue the flow
          return;
        } else if (!_this.appInitialPopupShown) {
          _this.showAttachToHomeNotification();
        }
        // Cache 2FA status for modal chain decisions (must complete before modals show)
        return _this.checkAndCacheTwoFactorStatus().then(function () {
          // Guard: skip ADD_FUNDS if navigating to 2FA setup or already on settings page
          var skipAddFunds = _this.navigatingToTwoFactorSetup || _this.$route.name === 'account-settings';

          if (_this.userData.idVerified) {
            if (
            // Fallback: if no ADD_FUNDS shown, check if we should show 2FA prompt directly
            !_this.appInitialPopupShown && !_this.currentPopup && _this.$store.state.user.twoFactorEnabled !== true && !__WEBPACK_IMPORTED_MODULE_10__constants__["a" /* default */].DISABLE_TWO_FACTOR_PROMPT) {
              // Verified user with positive balance and no 2FA - show prompt directly
              _this.appInitialPopupShown = true;
              _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_modals_constants__["a" /* MODALS */].TWO_FACTOR_PROMPT);
            } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__components_what_is_new_popup_helpers__["a" /* shouldShowWhatsIsNewPopup */])()) {
              _this.appInitialPopupShown = true;
              _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_modals_constants__["a" /* MODALS */].CUSTOMIZE_YOUR_PREDICTIT);
            }
            _this.routeQueryHandler();
          } else if (_this.collegeAffiliationEnabled && data.isUCAffilSet === null && !_this.appInitialPopupShown) {
            _this.appInitialPopupShown = true;
            _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_modals_constants__["a" /* MODALS */].COLLEGE_AFFILIATION);
          }
          return { skipAddFunds: skipAddFunds }; // Pass to next .then() for use in instant credit checks
        });
      }).then(this.getProfileDetail).then(function (data) {
        if (_this.appFlowDisabled) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
        }
        if (__WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].get('registeredExternal', false)) {
          __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].del('registeredExternal');
          _this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__helpers_dataLayer__["a" /* withMeta */])({
            event: 'SignUp',
            gtmUserID: data.userGuid,
            otmUserID: data.otmUserId,
            email: _this.userData.email
          }));
          // uncomment when we want frontend to migrate setting
          // return this.setSettingsAnnouncementCurState(VERSION_TO_MIGRATE_TO);
        } else if (_this.profileStatus.event && _this.profileStatus.event === 'registered') {
          _this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__helpers_dataLayer__["a" /* withMeta */])({
            event: 'SignUp',
            gtmUserID: data.userGuid,
            otmUserID: data.otmUserId,
            email: _this.userData.email
          }));
          _this.setProfileStatus({});
          // uncomment when we want frontend to migrate setting
          // return this.setSettingsAnnouncementCurState(VERSION_TO_MIGRATE_TO);
        } else if (_this.profileStatus.event && _this.profileStatus.event === 'login') {
          _this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__helpers_dataLayer__["a" /* withMeta */])({ event: 'Login' }));
          _this.setProfileStatus({});
          // Guard: skip ADD_FUNDS if navigating to 2FA setup
          var skipAddFunds = _this.navigatingToTwoFactorSetup || _this.$route.name === 'account-settings';
          if (__WEBPACK_IMPORTED_MODULE_16__services_instant_credit__["a" /* default */].checkIfCanRunAfterLogin() && !skipAddFunds) {
            // Firing quick deposit with instant credit check
            _this.appInitialPopupShown = true;
            _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_modals_constants__["a" /* MODALS */].ADD_FUNDS);
            _this.setCurrentPopupOptions({
              checkInstantCredit: true
            });
          }
        } else if (__WEBPACK_IMPORTED_MODULE_16__services_instant_credit__["a" /* default */].checkIfCanRunAfterLogin()) {
          // Guard: skip ADD_FUNDS if navigating to 2FA setup
          var _skipAddFunds = _this.navigatingToTwoFactorSetup || _this.$route.name === 'account-settings';
          if (!_skipAddFunds) {
            // Firing quick deposit with instant credit check
            _this.appInitialPopupShown = true;
            _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_modals_constants__["a" /* MODALS */].ADD_FUNDS);
            _this.setCurrentPopupOptions({
              checkInstantCredit: true
            });
          }
        }
      });
    },
    getUserData: function getUserData() {
      var _this2 = this;

      if (!this.token) return;

      if (SOCIAL_AUTH_ROUTES.includes(this.$route.name)) {
        this.getUserInfo().then(function (response) {
          if (response.data.hasRegistered) {
            _this2.getUserDetailedInformation();
          }
        });
      } else {
        this.getUserDetailedInformation();
      }
    },
    storageHandler: function storageHandler() {
      var storageToken = __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].get('token', null);
      // token removed from localstorage (user logged out in other tab/window)
      if (this.token && !storageToken) {
        this.logout();
        // token added to localstorage and it's different --> update app state
      } else if (this.token && this.token !== storageToken) {
        this.setBareToken(storageToken);
      }
    },
    resizeHandler: function resizeHandler() {
      var _this3 = this;

      setTimeout(function () {
        var width = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
        _this3.setLayoutWidth(width);
      }, RESIZE_HANDLER_TIMEOUT);
    },
    orientationChangeHandler: function orientationChangeHandler() {
      var _this4 = this;

      setTimeout(function () {
        if (document.querySelector('.bank-links__widget-shell')) {
          return;
        }

        if (_this4.isLayoutMobile && _this4.getOrientation() === 'landscape' && !_this4.isTablet) {
          _this4.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_modals_constants__["a" /* MODALS */].ORIENTATION);
        } else if (_this4.currentPopup === __WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_modals_constants__["a" /* MODALS */].ORIENTATION) {
          _this4.setCurrentPopup();
        }
      }, 10);
    },
    touchStartHandler: function touchStartHandler(event) {
      if (!this.isIos) return;
      if (event.touches && event.touches[0]) {
        this.touchStartTop = event.touches[0].pageY;
      }
    },
    touchMoveHandler: function touchMoveHandler(event) {
      if (!this.isIos) return;
      if (!event.touches || !event.touches[0]) return;

      var currentY = event.touches[0].pageY;
      var diffY = currentY - this.touchStartTop;

      if (window.pageYOffset === 0 && diffY > 30) {
        // Trigger a tiny scroll to force Safari to re-evaluate the viewport
        void document.body.offsetHeight;
        window.scrollBy(0, 1);
        window.scrollBy(0, -1);
      }
    },
    refreshAccessToken: function refreshAccessToken() {
      var _this5 = this;

      if (!this.token) return;
      var expiresAt = __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].get('tokenExpires', null);
      var threshold = -parseInt("60", 10);
      var hasExpired = expiresAt === null || __WEBPACK_IMPORTED_MODULE_2_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(expiresAt), 'seconds') > threshold;
      // no expires at or expires in less than a minute
      if (hasExpired) {
        var payload = {
          grant_type: 'refresh_token',
          refresh_token: __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].get('refreshToken')
        };
        this.login(payload).catch(function () {
          return _this5.clearAuthSession();
        });
      }
    },
    accessTokenRenewal: function accessTokenRenewal() {
      var _this6 = this;

      clearInterval(this.tokenInterval);
      this.tokenInterval = setInterval(function () {
        _this6.refreshAccessToken();
      }, parseInt("60", 10) * 1000);
    },
    showAttachToHomeNotification: function showAttachToHomeNotification() {
      // if (
      //   !this.token ||
      //   this.skipAttachToHomeNotification ||
      //   !this.isIos ||
      //   this.isStandalone ||
      //   this.currentPopup ||
      //   this.iOSWrapper ||
      //   !process.env.ATTACH_TO_HOME_POPUP_ENABLED ||
      //   !this.isLayoutMobile
      // ) return;
      // setTimeout(
      //   () => this.setCurrentPopup(MODALS.ATTACH_TO_HOME),
      //   constants.DEFAULT_SMALL_POPUP_TIMEOUT);
    },
    setupUI: function setupUI() {
      document.body.classList.remove('splash');
      if (this.isStandalone) document.body.classList.add('standalone');
      if (this.isIos) {
        document.documentElement.classList.add('ios');
        document.body.classList.add('ios');
      }
      if (this.isIE) {
        document.body.classList.add('ie');
      }
      if (this.isEdge) {
        document.body.classList.add('edge');
      }
      if (this.isWrapperApp) {
        document.body.classList.add('wrapper');
      }
      if (this.isShutdownModeOn) {
        document.body.classList.add('shutdown');
      }
    },
    pwaRedirect: function pwaRedirect() {
      var routePath = __WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].get('currentRoutePath', null);
      if (this.isStandalone && routePath && routePath !== '/') {
        this.$router.push(routePath);
      } else if (this.isStandalone && routePath === null) {
        this.$router.push({ name: 'home' });
      }
    },
    routeQueryHandler: function routeQueryHandler() {
      if (this.$route.query.coinbase === 'success') {
        this.$router.push({ name: 'market-list' });
      }
      if (this.popupShown) {
        return;
      }

      var hasQuickDeposit = this.$route.query.quickdeposit && this.$route.query.quickdeposit === 'true' || this.$route.query.quick_deposit && this.$route.query.quick_deposit === 'true' || this.$route.query.quickDeposit && this.$route.query.quickDeposit === 'true';

      if (this.$route.name !== 'wallet' && hasQuickDeposit && this.isDepositEnabled) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_modals_constants__["a" /* MODALS */].ADD_FUNDS);
        this.popupShown = true;
      }

      var hasSignUp = this.$route.query.signupModal && this.$route.query.signupModal === 'true';
      var hasLogin = this.$route.query.loginModal && this.$route.query.loginModal === 'true';

      if (hasSignUp && !this.isLoggedIn) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_modals_constants__["a" /* MODALS */].REGISTER);
        this.popupShown = true;
      } else if (hasLogin && !this.isLoggedIn) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_modals_constants__["a" /* MODALS */].LOGIN);
        this.popupShown = true;
      }
    },
    initializeUserData: function initializeUserData() {
      // when user comes from social login we need to fetch data manually
      // because he doesnt have refreshToken witch causes
      // token watch to trigger
      if (__WEBPACK_IMPORTED_MODULE_12__helpers_localStorage__["a" /* default */].get('refreshToken', null) && !SOCIAL_AUTH_ROUTES.includes(this.$route.name)) {
        this.refreshAccessToken();
      }
    },
    tokenHandler: function tokenHandler(newToken) {
      var _this7 = this;

      var secondsToDelay = parseInt("3", 10);

      if (this.initialised && !newToken) {
        clearTimeout(this.connectTimeout);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_api_http__["a" /* authorizeApi */])(null);
        var routeRequiresAuth = this.$route && this.$route.matched ? this.$route.matched.some(function (record) {
          return record.meta.requiresAuth;
        }) : true;
        __WEBPACK_IMPORTED_MODULE_6__services_mobile_wrapper__["a" /* default */].userLoggedOut();
        __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].logout();
        if (this.isWrapperApp) {
          this.loaderRemove(document.body);
          this.$router.push({ name: 'home' });
        } else {
          if (routeRequiresAuth) {
            window.location.href = "/";
          } else {
            this.routeQueryHandler();
          }
        }
      } else if (newToken) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_api_http__["a" /* authorizeApi */])(newToken);
        this.getUserData();
        __WEBPACK_IMPORTED_MODULE_6__services_mobile_wrapper__["a" /* default */].userLoggedIn(newToken);
        this.connectTimeout = setTimeout(function () {
          clearTimeout(_this7.connectTimeoutAnonymous);
          __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].init();
          __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].authorize(newToken);
          if (__WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].shouldSetupMessaging()) {
            __WEBPACK_IMPORTED_MODULE_11__logger__["a" /* default */].info('[MESSAGING] User is opted in. Setting up messaging');
            __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].setupMessaging();
          } else {
            __WEBPACK_IMPORTED_MODULE_11__logger__["a" /* default */].info('[MESSAGING] User is opted out or hasnt made messaging decision');
          }
        }, secondsToDelay * 1000);
        // this.accessTokenRenewal();
      } else {
        this.routeQueryHandler();
        this.connectTimeoutAnonymous = setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].init();
        }, secondsToDelay * 1000);
      }
      this.initialised = true;
    },
    windowOnFocusHandler: function windowOnFocusHandler() {
      this.setIsTabActive(true);
    },
    windowOnBlurHandler: function windowOnBlurHandler() {
      this.setIsTabActive(false);
    },
    isTabActiveHandler: function isTabActiveHandler(value) {
      var _this8 = this;

      var secondsToDelay = parseInt("0", 10);
      if (!secondsToDelay) return;
      // no need to do that on mobile as browser closes tabs there
      if (this.isLayoutMobile) return;
      if (!this.isLoggedIn && !false) return;

      if (value) {
        clearTimeout(this.disconnectTimeout);
      } else {
        this.disconnectTimeout = setTimeout(function () {
          _this8.setLiveUpdatesDisabled(true);
          __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].forceDisconnect();
        }, secondsToDelay * 1000);
      }
    }
  }),
  watch: {
    settingColorPalette: {
      immediate: true,
      handler: function handler(palette) {
        var name = palette === __WEBPACK_IMPORTED_MODULE_21__store_modules_app__["a" /* APP_COLOR_PALETTE */].GREEN_RED ? 'green-red' : 'blue-grey';
        document.body.setAttribute('data-color-palette', name);
      }
    },
    token: {
      handler: 'tokenHandler',
      immediate: true
    },
    isTabActive: {
      handler: 'isTabActiveHandler',
      immediate: true
    },
    newLoaderIsLoading: function newLoaderIsLoading(isLoading) {
      if (!isLoading) {
        window.prerenderReady = true;
      }
    }
  },
  created: function created() {
    this.setupUI();
    this.pwaRedirect();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_api_http__["a" /* authorizeApi */])(this.token);
    this.getHeaders();
    window.onfocus = this.windowOnFocusHandler;
    window.onblur = this.windowOnBlurHandler;
    window.addEventListener('orientationchange', this.orientationChangeHandler);
    window.addEventListener('resize', this.resizeHandler);
    window.addEventListener('storage', this.storageHandler);
    window.addEventListener('touchstart', this.touchStartHandler, { passive: true });
    window.addEventListener('touchmove', this.touchMoveHandler, { passive: true });
    this.resizeHandler();
    this.initializeUserData();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__helpers_dataLayer__["b" /* fireTrackMMPInstall */])();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__helpers_dataLayer__["c" /* fireTrackRetention */])();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('orientationchange', this.orientationChangeHandler);
    window.removeEventListener('resize', this.resizeHandler);
    window.removeEventListener('storage', this.storageHandler);
    window.removeEventListener('touchstart', this.touchStartHandler);
    window.removeEventListener('touchmove', this.touchMoveHandler);
  }
});

/***/ }),

/***/ "bAqS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],staticClass:"market-contracts-list-header-sushi__item-2"},[_c('div',{staticClass:"market-contracts-list-header-sushi__item-2-text",class:{ 'market-contracts-list-header-sushi__item-2-text--clickable': !_vm.forCmsWidget },on:{"click":_vm.onMenuToggle}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('transition',{attrs:{"name":"market-contracts-list-header-sushi"}},[(_vm.showMenu)?_c('div',{staticClass:"market-contracts-list-header-sushi__menu"},[_c('div',{staticClass:"market-contracts-list-header-sushi__menu-inner"},[_c('div',{staticClass:"market-contracts-list-header-sushi__menu-inner-item",on:{"click":function($event){return _vm.setOddsMode(true)}}},[_c('div',{staticClass:"market-contracts-list-header-sushi__menu-inner-icon",class:{ 'market-contracts-list-header-sushi__menu-inner-icon--empty': !_vm.settingShowOdds }}),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__menu-inner-item-operation",class:{ 'market-contracts-list-header-sushi__menu-inner-item-operation--selected': _vm.settingShowOdds }},[_vm._v("\n            Odds\n          ")])]),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__menu-inner-item",on:{"click":function($event){return _vm.setOddsMode(false)}}},[_c('div',{staticClass:"market-contracts-list-header-sushi__menu-inner-icon",class:{ 'market-contracts-list-header-sushi__menu-inner-icon--empty': _vm.settingShowOdds }}),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__menu-inner-item-operation",class:{ 'market-contracts-list-header-sushi__menu-inner-item-operation--selected': !_vm.settingShowOdds }},[_vm._v("\n            Trade Prices\n          ")])])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bBr+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-form-loader"},[(_vm.theme === 'details')?[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)]:_vm._e(),_vm._v(" "),(_vm.theme === 'withdraw')?[_c('div',{staticClass:"account-form-loader__alert"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__balance"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__input"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__line"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__button"})]:_vm._e(),_vm._v(" "),(_vm.theme === 'deposit')?[_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8)]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-form-loader__section"},[_c('div',{staticClass:"account-form-loader__section-title"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-row"},[_c('div',{staticClass:"account-form-loader__section-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-col-2"})]),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-row"},[_c('div',{staticClass:"account-form-loader__section-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-col-2"})]),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-row"},[_c('div',{staticClass:"account-form-loader__section-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-col-2"})]),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-row"},[_c('div',{staticClass:"account-form-loader__section-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-col-2"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-form-loader__section"},[_c('div',{staticClass:"account-form-loader__section-title"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-button"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-form-loader__section"},[_c('div',{staticClass:"account-form-loader__section-title"}),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-button"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-button"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-button"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-x"},[_c('div',{staticClass:"small-12 medium-4 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-12 medium-8 column"},[_c('div',{staticClass:"row-x"},[_c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"account-form-loader__block"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"account-form-loader__block"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"account-form-loader__block"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-x"},[_c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"account-form-loader__block"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-6 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-6 column"},[_c('div',{staticClass:"account-form-loader__block"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-x"},[_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"account-form-loader__block"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bFAx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_top_comment_js__ = __webpack_require__("xTWr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d00300fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_top_comment_vue__ = __webpack_require__("6WA/");
function injectStyle (ssrContext) {
  __webpack_require__("AzCe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_top_comment_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d00300fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_top_comment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bFdm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifier},[_c('div',{class:_vm.menuClassModifier},[_c('div',{staticClass:"market-filters-mobile__menu-order"},[_c('menu-button',{attrs:{"type":_vm.selectedOrder.sort,"theme":_vm.theme,"name":_vm.orderMenuName,"active":_vm.ordersOpen,"arrow":true},on:{"click":_vm.toggleOrder}})],1),_vm._v(" "),(_vm.shouldShowTimespanFilter)?_c('div',{staticClass:"market-filters-mobile__menu-timespans"},[_c('menu-button',{attrs:{"type":"timespan","theme":_vm.theme,"name":_vm.selectedTimespan.name,"active":_vm.timespansOpen,"arrow":true},on:{"click":_vm.toggleTimespans}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-filters-mobile__menu-filters"},[_c('menu-button',{attrs:{"type":"filters","theme":_vm.theme,"name":_vm.filterMenuName,"active":_vm.filtersOpen,"arrow":true},on:{"click":_vm.toggleFilters}})],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.ordersOpen)?_c('div',{staticClass:"market-filters-mobile__order"},_vm._l((_vm.orderList('markets')),function(order){return _c('menu-button',{key:order.sort,attrs:{"theme":_vm.theme,"type":order.sort,"name":order.fullName,"selected":_vm.orderSelected(order.sort)},on:{"click":_vm.selectOrderAndClose}})}),1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.filtersOpen)?_c('div',{staticClass:"market-filters-mobile__filters"},[_c('a',{staticClass:"market-filters-mobile__clear-all",on:{"click":function($event){$event.preventDefault();return _vm.onClearFilters($event)}}},[_vm._v("Clear Selections")]),_vm._v(" "),_vm._l((_vm.filters),function(category){return _c('div',{staticClass:"market-filters-mobile__filters-group"},[_c('h3',[_vm._v(_vm._s(category.name))]),_vm._v(" "),_vm._l((category.filters),function(filter){return _c('filter-button',{key:_vm.filterKey(filter),attrs:{"theme":_vm.theme,"id":filter.filterId,"name":filter.name,"selected":_vm.filterSelected(filter.filterId)},on:{"addFilter":_vm.onAddFilter,"removeFilter":_vm.onRemoveFilter}})})],2)})],2):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.timespansOpen)?_c('div',{staticClass:"market-filters-mobile__timespans"},_vm._l((_vm.availableTimespanOptions),function(timespan){return _c('menu-button',{key:timespan.parameter,attrs:{"theme":_vm.theme,"type":timespan.parameter,"name":timespan.name},on:{"click":_vm.selectTimespanAndClose}})}),1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bREw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_sessionVars__ = __webpack_require__("DECz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_instant_credit__ = __webpack_require__("zAJv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_notifications_firebase__ = __webpack_require__("2Pqz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__("oiih");




/* eslint-disable max-len */









var TOKEN_EXPIRES_IN_MINUTES = 28;
var TOKEN_EXPIRES_DATE_FMT = 'YYYY-MM-DD HH:mm:s';

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  getters: {
    isLoggedIn: function isLoggedIn(state) {
      return !!state.token;
    },
    loginWithDisqus: function loginWithDisqus(state) {
      return state.disqusLogin && state.status.useDisqus;
    },
    isUserRestricted: function isUserRestricted(state, getters) {
      return false && !getters.isLoggedIn;
    }
  },
  state: {
    userUnreadNotificationsCount: 0,
    userData: {},
    userInfo: {},
    loginIsBeingCalled: false,
    ssnInfoVerified: false,
    token: __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].get('token'),
    refreshToken: __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].get('refreshToken'),
    status: {},
    disqusLogin: __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].get('disqusLogin', true),
    marketDisplay: 'grid',
    usernameTries: 0,
    watchedUserDetails: {},
    // marketDisplay: ls.get('marketDisplay', 'grid'),

    // Two-Factor Authentication
    twoFactorRequired: false,
    twoFactorToken: null,
    twoFactorMethods: [],
    twoFactorEmailHint: '',
    twoFactorPhoneHint: '',
    twoFactorSecondsUntilExpiry: 0,
    showTwoFactorPrompt: false,
    pendingLoginPayload: null,

    // Registration flow tracking - used to ensure 2FA prompt appears after signup flow
    registrationFlowActive: false,

    // Cached 2FA enabled status (fetched at login to avoid modal race conditions)
    twoFactorEnabled: null,
    // Flag to suppress ADD_FUNDS when navigating to 2FA setup
    navigatingToTwoFactorSetup: false
  },
  mutations: {
    login: function login(state, user) {
      state.token = user.access_token;
      state.refreshToken = user.refresh_token;
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('token', user.access_token);
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('tokenExpires', __WEBPACK_IMPORTED_MODULE_4_moment___default()(user['.expires']).format(TOKEN_EXPIRES_DATE_FMT));
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('refreshToken', user.refresh_token);
    },
    logout: function logout(state) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      state.token = data;
      state.refreshToken = data;
      state.userData = {};
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].del('tokenExpires');
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].del('currentRoutePath');
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].del('token');
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].del('refreshToken');
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].del('disqusLogin');
      __WEBPACK_IMPORTED_MODULE_7__helpers_sessionVars__["a" /* default */].clear();
      __WEBPACK_IMPORTED_MODULE_8__services_instant_credit__["a" /* default */].clear();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__services_notifications_firebase__["e" /* cleanupMessaging */])();
    },
    clearRefreshToken: function clearRefreshToken(state) {
      state.refreshToken = null;
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].del('refreshToken');
    },
    setStatus: function setStatus(state, status) {
      state.status = status;
    },
    setUserData: function setUserData(state, data) {
      state.userData = data;
    },
    increaseUserUnreadNotificationsCount: function increaseUserUnreadNotificationsCount(state) {
      state.userUnreadNotificationsCount += 1;
    },
    setUserUnreadNotificationsCount: function setUserUnreadNotificationsCount(state, count) {
      state.userUnreadNotificationsCount = count;
    },
    setUserInfo: function setUserInfo(state, data) {
      state.userInfo = data;
    },
    setBareToken: function setBareToken(state, data) {
      state.token = data;
    },
    setToken: function setToken(state, data) {
      var expires = __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(TOKEN_EXPIRES_IN_MINUTES, 'minutes').format(TOKEN_EXPIRES_DATE_FMT);
      state.token = data;
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('token', data);
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('tokenExpires', expires);
    },
    setRefreshToken: function setRefreshToken(state, data) {
      state.refreshToken = data;
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('refreshToken', data);
    },
    updateMarketDisplay: function updateMarketDisplay(state, payload) {
      state.marketDisplay = payload;
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('marketDisplay', payload, "31536000");
    },
    setUseDisqus: function setUseDisqus(state, payload) {
      if (payload) {
        state.disqusLogin = true;
        __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('disqusLogin', payload, "31536000");
      } else {
        state.disqusLogin = false;
        __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].del('disqusLogin');
      }
    },
    setUsernameTries: function setUsernameTries(state, count) {
      state.usernameTries = count;
    },
    setLoginIsBeingCalled: function setLoginIsBeingCalled(state, value) {
      state.loginIsBeingCalled = value;
    },
    setWatchedUserDetails: function setWatchedUserDetails(state, trader) {
      state.watchedUserDetails = trader;
    },
    setSsnInfoVerified: function setSsnInfoVerified(state) {
      state.ssnInfoVerified = true;
    },


    // Two-Factor Authentication
    setTwoFactorChallenge: function setTwoFactorChallenge(state, data) {
      state.twoFactorRequired = true;
      state.twoFactorToken = data.two_factor_token;
      state.twoFactorMethods = data.available_methods || [];
      state.twoFactorEmailHint = data.email_hint || '';
      state.twoFactorPhoneHint = data.phone_hint || '';
      state.twoFactorSecondsUntilExpiry = data.seconds_until_expiry || 300;
    },
    clearTwoFactorChallenge: function clearTwoFactorChallenge(state) {
      state.twoFactorRequired = false;
      state.twoFactorToken = null;
      state.twoFactorMethods = [];
      state.twoFactorEmailHint = '';
      state.twoFactorPhoneHint = '';
      state.twoFactorSecondsUntilExpiry = 0;
      state.pendingLoginPayload = null;
    },
    setShowTwoFactorPrompt: function setShowTwoFactorPrompt(state, value) {
      state.showTwoFactorPrompt = value;
    },
    setPendingLoginPayload: function setPendingLoginPayload(state, payload) {
      state.pendingLoginPayload = payload;
    },


    // Registration flow
    setRegistrationFlowActive: function setRegistrationFlowActive(state) {
      state.registrationFlowActive = true;
    },
    clearRegistrationFlowActive: function clearRegistrationFlowActive(state) {
      state.registrationFlowActive = false;
    },
    setTwoFactorEnabled: function setTwoFactorEnabled(state, value) {
      state.twoFactorEnabled = value;
    },
    setNavigatingToTwoFactorSetup: function setNavigatingToTwoFactorSetup(state, value) {
      state.navigatingToTwoFactorSetup = value;
    }
  },
  actions: {
    loginDisqus: function loginDisqus() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getDisqusLogin().then(function (response) {
        return response.data;
      });
    },
    logoutDisqus: function logoutDisqus() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getDisqusLogout().then(function (response) {
        return response.data;
      });
    },
    getDisqusUserAuth: function getDisqusUserAuth() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getDisqusUserAuth().then(function (response) {
        return response.data;
      });
    },
    login: function login(_ref) {
      var commit = _ref.commit,
          state = _ref.state;
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (state.loginIsBeingCalled) return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve({});

      commit('setLoginIsBeingCalled', true);
      commit('setPendingLoginPayload', payload);

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postToken(payload).then(function (response) {
        commit('setLoginIsBeingCalled', false);
        commit('login', response.data);

        // Check if 2FA prompt should be shown for non-2FA users
        if (response.data.showTwoFactorPrompt === 'true') {
          commit('setShowTwoFactorPrompt', true);
        }

        return response.data;
      }).catch(function (error) {
        commit('setLoginIsBeingCalled', false);

        // Check for 2FA challenge response
        if (error.response && error.response.data && error.response.data.error === 'two_factor_required') {
          try {
            var twoFactorData = JSON.parse(error.response.data.error_description);
            commit('setTwoFactorChallenge', twoFactorData);
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ requiresTwoFactor: true }, twoFactorData);
          } catch (parseError) {
            // If parsing fails, throw original error
            throw error;
          }
        }

        throw error;
      });
    },
    logout: function logout(_ref2) {
      var commit = _ref2.commit;
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postLogout().then(function () {
        commit('logout', data);
      }).catch(function () {
        commit('logout', data);
      });
    },
    clearAuthSession: function clearAuthSession(_ref3) {
      var commit = _ref3.commit;
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      commit('logout', data);
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
    },
    register: function register(_ref4, payload) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postRegister(payload);
    },
    registerExternal: function registerExternal(_ref5, payload) {
      var commit = _ref5.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postRegisterExternal(payload);
    },
    getExternalLogins: function getExternalLogins(_ref6, _ref7) {
      var commit = _ref6.commit;
      var _ref7$pathname = _ref7.pathname,
          pathname = _ref7$pathname === undefined ? window.location.pathname : _ref7$pathname,
          _ref7$type = _ref7.type,
          type = _ref7$type === undefined ? __WEBPACK_IMPORTED_MODULE_10__constants__["a" /* default */].SOCIAL_LOGIN_OR_REGISTER : _ref7$type;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getExternalLogins(pathname, type);
    },
    addExternal: function addExternal(_ref8, payload) {
      var commit = _ref8.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postAddExternalLogin(payload).then(function (response) {
        return response.data;
      });
    },
    removeExternal: function removeExternal(_ref9, payload) {
      var commit = _ref9.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postRemoveLogin(payload).then(function (response) {
        return response.data;
      });
    },
    getUserInfo: function getUserInfo(_ref10) {
      var commit = _ref10.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getUserInfo().then(function (response) {
        commit('setUserInfo', response.data);
        return response;
      });
    },
    getManageInfo: function getManageInfo() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getManageInfo().then(function (response) {
        return response.data;
      });
    },
    getAccountDetail: function getAccountDetail(_ref11) {
      var commit = _ref11.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getAccountDetail().then(function (response) {
        commit('setUserData', response.data);
        return response.data;
      });
    },
    getVerifyID: function getVerifyID() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getVerifyID().then(function (response) {
        return response;
      });
    },
    verifyID: function verifyID(_ref12, payload) {
      var commit = _ref12.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postVerifyID(payload).then(function (response) {
        return response.data;
      });
    },
    getStatus: function getStatus(_ref13) {
      var commit = _ref13.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getStatus().then(function (response) {
        commit('setStatus', response.data);
        return response.data;
      });
    },
    resetPassword: function resetPassword(_ref14, payload) {
      var commit = _ref14.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postResetPassword(payload);
    },
    forgotPassword: function forgotPassword(_ref15, payload) {
      var commit = _ref15.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postForgotPassword(payload).then(function (response) {
        return response.data;
      });
    },
    changePassword: function changePassword(_ref16, payload) {
      var commit = _ref16.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postChangePassword(payload);
    },
    setPassword: function setPassword(_ref17, payload) {
      var commit = _ref17.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postSetPassword(payload);
    },
    uploadUserImage: function uploadUserImage(_ref18, payload) {
      var commit = _ref18.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postUploadUserImage(payload);
    },
    resetUserImage: function resetUserImage() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.putResetUserImage();
    },
    getCommunicationPreferences: function getCommunicationPreferences() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getCommunicationPreferences().then(function (response) {
        return response.data;
      });
    },
    setCommunicationPreferences: function setCommunicationPreferences(_ref19, payload) {
      var commit = _ref19.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postCommunicationPreferences(payload).then(function (response) {
        return response.data;
      });
    },
    setBareToken: function setBareToken(_ref20, payload) {
      var commit = _ref20.commit;

      commit('setBareToken', payload);
    },
    setToken: function setToken(_ref21, payload) {
      var commit = _ref21.commit;

      commit('setToken', payload);
    },
    setRefreshToken: function setRefreshToken(_ref22, payload) {
      var commit = _ref22.commit;

      commit('setRefreshToken', payload);
    },
    getCaptchaSiteKey: function getCaptchaSiteKey() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getCaptchaSiteKey().then(function (response) {
        return response.data;
      });
    },
    setUseDisqus: function setUseDisqus(_ref23) {
      var commit = _ref23.commit;
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        commit('setUseDisqus', payload);
        resolve();
      });
    },
    getIdUploadUrl: function getIdUploadUrl() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getIdUploadUrl().then(function (response) {
        return response.data;
      });
    },
    getTaxInfo: function getTaxInfo(_ref24, _ref25) {
      var commit = _ref24.commit;
      var _ref25$reasonCode = _ref25.reasonCode,
          reasonCode = _ref25$reasonCode === undefined ? '' : _ref25$reasonCode;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getTaxInfo({ reasonCode: reasonCode }).then(function (response) {
        return response.data;
      });
    },
    postTaxInfo: function postTaxInfo(_ref26, payload) {
      var commit = _ref26.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTaxInfo(payload).then(function (response) {
        return response.data;
      });
    },
    updateMarketDisplay: function updateMarketDisplay(_ref27, payload) {
      var commit = _ref27.commit;

      return commit('updateMarketDisplay', payload);
    },
    clearRefreshToken: function clearRefreshToken(_ref28) {
      var commit = _ref28.commit;

      commit('clearRefreshToken');
    },
    setUserUnreadNotificationsCount: function setUserUnreadNotificationsCount(_ref29, count) {
      var commit = _ref29.commit;

      commit('setUserUnreadNotificationsCount', count);
    },
    increaseUserUnreadNotificationsCount: function increaseUserUnreadNotificationsCount(_ref30) {
      var commit = _ref30.commit;

      commit('increaseUserUnreadNotificationsCount');
    },
    getUserNameTries: function getUserNameTries(_ref31) {
      var commit = _ref31.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getChangeUsername().then(function (response) {
        commit('setUsernameTries', response.data);
        return response.data;
      });
    },
    changeUserName: function changeUserName(_ref32, username) {
      var commit = _ref32.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postChangeUsername(username).then(function (response) {
        return response.data;
      });
    },
    getDocumentUploadLink: function getDocumentUploadLink(_ref33, source) {
      var commit = _ref33.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getDocumentUploadLink(source).then(function (response) {
        return response.data;
      });
    },
    setWatchedUserDetails: function setWatchedUserDetails(_ref34, trader) {
      var commit = _ref34.commit;

      commit('setWatchedUserDetails', trader);
    },
    agreeToTerms: function agreeToTerms(_ref35, payload) {
      var commit = _ref35.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.putAgreedToTerms(payload).then(function (response) {
        return response.data;
      });
    },
    setSsnInfoVerified: function setSsnInfoVerified(_ref36) {
      var commit = _ref36.commit;

      commit('setSsnInfoVerified');
    },


    // Two-Factor Authentication actions
    twoFactorSendCode: function twoFactorSendCode(_ref37, _ref38) {
      var state = _ref37.state;
      var method = _ref38.method;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTwoFactorSendCode({
        twoFactorToken: state.twoFactorToken,
        method: method
      }).then(function (response) {
        return response.data;
      });
    },
    twoFactorVerify: function twoFactorVerify(_ref39, _ref40) {
      var commit = _ref39.commit,
          state = _ref39.state;
      var method = _ref40.method,
          code = _ref40.code;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTwoFactorVerify({
        twoFactorToken: state.twoFactorToken,
        method: method,
        code: code
      }).then(function (response) {
        commit('clearTwoFactorChallenge');
        commit('login', response.data);
        return response.data;
      });
    },
    getTwoFactorStatus: function getTwoFactorStatus() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getTwoFactorStatus().then(function (response) {
        return response.data;
      });
    },
    twoFactorSetupEmailSendCode: function twoFactorSetupEmailSendCode() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTwoFactorSetupEmailSendCode().then(function (response) {
        return response.data;
      });
    },
    twoFactorSetupEmailVerify: function twoFactorSetupEmailVerify(_ref41, _ref42) {
      var commit = _ref41.commit;
      var code = _ref42.code;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTwoFactorSetupEmailVerify({ code: code }).then(function (response) {
        return response.data;
      });
    },
    twoFactorSetupPhoneSendCode: function twoFactorSetupPhoneSendCode() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTwoFactorSetupPhoneSendCode().then(function (response) {
        return response.data;
      });
    },
    twoFactorSetupPhoneVerify: function twoFactorSetupPhoneVerify(_ref43, _ref44) {
      var commit = _ref43.commit;
      var code = _ref44.code;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTwoFactorSetupPhoneVerify({ code: code }).then(function (response) {
        return response.data;
      });
    },
    getTwoFactorSetupAuthenticator: function getTwoFactorSetupAuthenticator() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getTwoFactorSetupAuthenticator().then(function (response) {
        return response.data;
      });
    },
    twoFactorSetupAuthenticatorVerify: function twoFactorSetupAuthenticatorVerify(_ref45, _ref46) {
      var commit = _ref45.commit;
      var code = _ref46.code,
          encryptedSecret = _ref46.encryptedSecret;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTwoFactorSetupAuthenticatorVerify({ code: code, encryptedSecret: encryptedSecret }).then(function (response) {
        return response.data;
      });
    },
    twoFactorEnable: function twoFactorEnable(_ref47) {
      var commit = _ref47.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTwoFactorEnable().then(function (response) {
        // Update cached state so modal handlers know 2FA is now enabled
        commit('setTwoFactorEnabled', true);
        return response.data;
      });
    },
    twoFactorDisable: function twoFactorDisable(_ref48) {
      var commit = _ref48.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postTwoFactorDisable().then(function (response) {
        // Update cached state so modal handlers know 2FA is now disabled
        commit('setTwoFactorEnabled', false);
        return response.data;
      });
    },


    // Phone Management actions
    getPhone: function getPhone() {
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getPhone().then(function (response) {
        return response.data;
      });
    },
    phoneUpdate: function phoneUpdate(_, _ref49) {
      var phoneNumber = _ref49.phoneNumber;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postPhoneUpdate({ phoneNumber: phoneNumber }).then(function (response) {
        return response.data;
      });
    },
    phoneVerify: function phoneVerify(_, _ref50) {
      var phoneNumber = _ref50.phoneNumber,
          code = _ref50.code;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.postPhoneVerify({ phoneNumber: phoneNumber, code: code }).then(function (response) {
        return response.data;
      });
    },
    dismissTwoFactorPrompt: function dismissTwoFactorPrompt(_ref51) {
      var commit = _ref51.commit;

      commit('setShowTwoFactorPrompt', false);
    },
    clearTwoFactorChallenge: function clearTwoFactorChallenge(_ref52) {
      var commit = _ref52.commit;

      commit('clearTwoFactorChallenge');
    },


    // Registration flow actions
    startRegistrationFlow: function startRegistrationFlow(_ref53) {
      var commit = _ref53.commit;

      commit('setRegistrationFlowActive');
    },
    endRegistrationFlow: function endRegistrationFlow(_ref54) {
      var commit = _ref54.commit;

      commit('clearRegistrationFlowActive');
    },


    // 2FA status caching for modal flow decisions
    checkAndCacheTwoFactorStatus: function checkAndCacheTwoFactorStatus(_ref55) {
      var _this = this;

      var commit = _ref55.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, status;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].account.getTwoFactorStatus();

              case 3:
                response = _context.sent;
                status = response.data;

                commit('setTwoFactorEnabled', status.is_two_factor_enabled);
                return _context.abrupt('return', status.is_two_factor_enabled);

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                // On error, assume 2FA not enabled (safe default, will show prompt)
                commit('setTwoFactorEnabled', false);
                return _context.abrupt('return', false);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    setNavigatingToTwoFactorSetup: function setNavigatingToTwoFactorSetup(_ref56, value) {
      var commit = _ref56.commit;

      commit('setNavigatingToTwoFactorSetup', value);
    }
  }
});

/***/ }),

/***/ "bWBf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bYWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_main_nav_app_main_nav_vue__ = __webpack_require__("3cKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_unreadNotification__ = __webpack_require__("BL43");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_notifications_widget_notifications_widget_vue__ = __webpack_require__("oY3V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_hamburger_icon_hamburger_icon_vue__ = __webpack_require__("MRVZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_headerNav__ = __webpack_require__("drLe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_app_app_header_header_search_header_search_vue__ = __webpack_require__("h41O");









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_headerNav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_unreadNotification__["a" /* default */]],
  components: {
    appMainNav: __WEBPACK_IMPORTED_MODULE_2__components_app_app_main_nav_app_main_nav_vue__["a" /* default */],
    hamburgerIcon: __WEBPACK_IMPORTED_MODULE_5__components_hamburger_icon_hamburger_icon_vue__["a" /* default */],
    notificationsWidget: __WEBPACK_IMPORTED_MODULE_4__components_notifications_widget_notifications_widget_vue__["a" /* default */],
    headerSearch: __WEBPACK_IMPORTED_MODULE_7__components_app_app_header_header_search_header_search_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['mobileMenuOpened']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('notifications', ['showNotificationsWidget']), {
    isNotificationsWidgetDisabled: function isNotificationsWidgetDisabled() {
      return this.$route && this.$route.name === 'dashboard-notifications' || this.mobileMenuOpened;
    },
    isNotificationIconActive: function isNotificationIconActive() {
      return this.$route.name === 'notifications' || this.showNotificationsWidget;
    },
    showUnreadNotificationCount: function showUnreadNotificationCount() {
      return !this.isNotificationIconActive && this.userUnreadNotificationsCountHeader > 0;
    },
    notificationsIconModifiers: function notificationsIconModifiers() {
      return {
        'app-header__notifications': true,
        'app-header__notifications--disabled': this.isNotificationsWidgetDisabled,
        'app-header__notifications--unread': this.showUnreadNotificationCount,
        'app-header__notifications--active': this.isNotificationIconActive
      };
    },
    depositClassModifiers: function depositClassModifiers() {
      var disabled = this.$route.name === 'wallet';
      return {
        'app-header__menu-item': true,
        'app-header__menu-item--deposit': true,
        'app-header__menu-item--disabled': disabled
      };
    }
  }),
  watch: {
    $route: function $route() {
      this.closeNotificationsWidget();
    },
    showNotificationsWidget: function showNotificationsWidget(value) {
      if (!value) {
        this.clearAllNotifications();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['toggleNotificationsWidget', 'closeNotificationsWidget']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('search', ['toggleSearchBar', 'closeSearchBar']), {
    onNotificationsClick: function onNotificationsClick() {
      if (!this.isNotificationsWidgetDisabled) {
        this.toggleNotificationsWidget();
        this.closeSearchBar();
      }
    }
  })
});

/***/ }),

/***/ "bbNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: String,
    text: String,
    url: String,
    styleVariant: {
      type: String,
      default: ''
    }
  },
  computed: {
    isLink: function isLink() {
      return this.type === 'link';
    },
    isButton: function isButton() {
      return this.type === 'button';
    },
    isStoryFooterCta: function isStoryFooterCta() {
      return this.styleVariant === 'story-footer-cta';
    },
    linkClass: function linkClass() {
      return {
        link: true,
        'link--regular': this.isLink,
        'link--story-footer-cta': this.isLink && this.isStoryFooterCta
      };
    },
    displayText: function displayText() {
      if (!this.isStoryFooterCta) {
        return this.text;
      }

      return (this.text || '').replace(/\s*→\s*$/, '').trim();
    }
  }
});

/***/ }),

/***/ "bfFv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bfxh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bkfp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_footer_js__ = __webpack_require__("NGyh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3ccd662_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_footer_vue__ = __webpack_require__("KQy8");
function injectStyle (ssrContext) {
  __webpack_require__("VZTi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3ccd662_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bvK5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    items: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'default'
    },
    activeTab: {
      type: String,
      default: null
    }
  },
  created: function created() {
    if (this.activeTab) {
      this.onChange(this.activeTab, true);
    } else if (this.items.length > 0) {
      this.onChange(this.items[0].name);
    }
  },
  data: function data() {
    return {
      currentTab: this.activeTab
    };
  },

  watch: {
    activeTab: function activeTab(tab) {
      if (tab !== this.currentTab) {
        this.onChange(tab);
      }
    }
  },
  methods: {
    tabLinkModifiers: function tabLinkModifiers(item) {
      var _ref;

      return _ref = {
        tabs__link: true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'tabs__link-name-' + item.name, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'tabs__link--with-icon', item.icon), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'tabs__link--' + this.theme + '-' + item.name, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'tabs__link--stats', item.kind && item.kind === 'stats'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'tabs__link--active', item.name === this.currentTab), _ref;
    },
    tabItemModifiers: function tabItemModifiers(item) {
      return {
        tabs__item: true,
        'tabs__item--stats': item.kind && item.kind === 'stats'
      };
    },
    tabIconModifiers: function tabIconModifiers(item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        tabs__icon: true
      }, 'tabs__icon--' + item.icon, item.icon);
    },
    onChange: function onChange(name) {
      var startedWithActiveTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (name !== this.currentTab) {
        this.currentTab = name;
        this.$emit('tabChange', name);
      } else if (startedWithActiveTab) {
        this.$emit('tabChange', this.currentTab);
      }
    }
  }
});

/***/ }),

/***/ "bwq/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__("H/Zg");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    mostPopular: null,
    analysis: null,
    news: []
  },
  mutations: {
    updateMostPopular: function updateMostPopular(state, payload) {
      state.mostPopular = payload;
    },
    updateAnalysis: function updateAnalysis(state, payload) {
      state.analysis = payload;
    },
    updateNews: function updateNews(state, payload) {
      state.news = payload;
    }
  },
  actions: {
    getMostPopular: function getMostPopular(_ref, payload) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].insight.getMostPopular(payload.interval, payload.count).then(function (response) {
        commit('updateMostPopular', response.data);
        return response.data;
      });
    },
    getAnalysis: function getAnalysis(_ref2, _ref3) {
      var commit = _ref2.commit;
      var _ref3$limit = _ref3.limit,
          limit = _ref3$limit === undefined ? 4 : _ref3$limit,
          _ref3$offset = _ref3.offset,
          offset = _ref3$offset === undefined ? 0 : _ref3$offset;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].insight.getAnalysis(limit, offset).then(function (response) {
        commit('updateAnalysis', response.data);
        return response.data;
      });
    },
    getFeeds: function getFeeds() {
      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].insight.getFeeds().then(function (response) {
        return response.data;
      });
    },
    getMarketFeeds: function getMarketFeeds(_ref4, marketId) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].insight.getMarketFeeds(marketId).then(function (response) {
        return response.data;
      });
    },
    getNews: function getNews(_ref5) {
      var commit = _ref5.commit;

      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref6$limit = _ref6.limit,
          limit = _ref6$limit === undefined ? 4 : _ref6$limit,
          _ref6$offset = _ref6.offset,
          offset = _ref6$offset === undefined ? 0 : _ref6$offset;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].insight.getNews(limit, offset).then(function (response) {
        commit('updateNews', response.data);
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "bzSr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c/9r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return capitalizeFirstLetter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRedirectUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DEFAULT_DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return dateToString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return priceDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return formatUsdValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return updateObjectValues; });
/* unused harmony export capitalize */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return toCents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return correctPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return isNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return hasLastTradePrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getLeadingTradedContract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isMarketSingle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return contractOwnershipNum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isMarketSettled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return isMarketExpired; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return isMarketSuspended; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return isMarketMaintenance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return isMarketStatusClosed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return isMarketClosed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return isMarketDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return isMarketJourneyDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return hasMarketPayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return hasMarketHiddenContracts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return isContractOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return isHighChartsReady; });
/* harmony export (immutable) */ __webpack_exports__["x"] = largeNumberDisplay;
/* unused harmony export elementOffset */
/* harmony export (immutable) */ __webpack_exports__["d"] = lockScroll;
/* harmony export (immutable) */ __webpack_exports__["c"] = unlockScroll;
/* harmony export (immutable) */ __webpack_exports__["m"] = lockModal;
/* harmony export (immutable) */ __webpack_exports__["n"] = unLockModal;
/* harmony export (immutable) */ __webpack_exports__["J"] = marketUserGainLoss;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return hasNoPositionInAMarketBesidesLoadedContract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return smartbtoa; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return smartatob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return groupByKeepOrder; });
/* harmony export (immutable) */ __webpack_exports__["i"] = roundToTwo;
/* harmony export (immutable) */ __webpack_exports__["S"] = roundDown;
/* unused harmony export roundTop */
/* harmony export (immutable) */ __webpack_exports__["T"] = calculateWithdrawalFee;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCardTypeForNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return getOrdinalSuffix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return loadScript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return parseQuery; });
/* unused harmony export checkIfKeyExist */
/* unused harmony export loginUrl */
/* unused harmony export signUpUrl */
/* unused harmony export editAccountDetailsUrl */
/* unused harmony export verifyDetailsUrl */
/* unused harmony export logoutUrl */
/* unused harmony export changeAvatarImageUrl */
/* unused harmony export registerPersonalDetailsUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getAssetPath; });
/* unused harmony export isVisibleInViewport */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return stripTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return isEmptyHtml; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return uuidv4; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_maxBy__ = __webpack_require__("K1hn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_notifications_notification_types__ = __webpack_require__("QNMw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_sessionVars__ = __webpack_require__("DECz");







/* global Highcharts:false */
/* eslint-disable */








var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
var getRedirectUrl = function getRedirectUrl(path) {
  var rootPath = "/".slice(0, -1);
  return window.location.protocol + '//' + window.location.host + rootPath + path;
};
var DEFAULT_DATE_FORMAT = 'MM/DD/YYYY hh:mm a';

var dateToString = function dateToString(string) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_DATE_FORMAT;
  return __WEBPACK_IMPORTED_MODULE_7_moment___default()(string).format(fmt) + ' (ET)';
};
var priceDisplay = function priceDisplay(num) {
  return num.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
var formatUsdValue = function formatUsdValue(value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$trimWhole = _ref.trimWhole,
      trimWhole = _ref$trimWhole === undefined ? false : _ref$trimWhole;

  var number = Number(value);
  var safeNumber = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default()(number) ? number : 0;
  var minimumFractionDigits = trimWhole && safeNumber % 1 === 0 ? 0 : 2;
  return safeNumber.toLocaleString('en-US', {
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: 2
  });
};
var updateObjectValues = function updateObjectValues(obj, data) {
  var map = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var setTimestampFor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [__WEBPACK_IMPORTED_MODULE_9__services_notifications_notification_types__["a" /* NOTIFICATION_CONTRACT_OWNERSHIP */]];

  var result = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, obj);
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
    var timestampKey = 'timestamp';
    var objKey = typeof map[key] !== 'undefined' ? map[key] : key;
    if (typeof result[objKey] !== 'undefined' && objKey !== timestampKey || setTimestampFor.includes(data.UpdateType) && objKey === timestampKey) {
      // timestamp prop is updated only for certain notifications
      result[objKey] = data[key];
    }
  });

  return result;
};
var capitalize = function capitalize(input) {
  return input.charAt(0).toUpperCase() + input.slice(1);
};
var toCents = function toCents(input) {
  return Math.round(100 * input);
};
var correctPrice = function correctPrice(input) {
  return !isNaN(input) && input < 100 ? input : 0;
};
var isNumber = function isNumber(input) {
  return !isNaN(parseFloat(input)) && isFinite(input);
};
var hasLastTradePrice = function hasLastTradePrice(contract) {
  var value = Number(contract && contract.lastTradePrice);
  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default()(value) && Math.round(100 * value) > 0;
};
var getLeadingTradedContract = function getLeadingTradedContract() {
  var contracts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var results = (contracts || []).filter(hasLastTradePrice);
  return results.length > 0 ? __WEBPACK_IMPORTED_MODULE_5_lodash_maxBy___default()(results, function (i) {
    return i.lastTradePrice;
  }) : null;
};
var isMarketSingle = function isMarketSingle(market) {
  return market && (market.type === 'Single' || market.marketType === 0 || market.MarketType === 0);
};
var contractOwnershipNum = function contractOwnershipNum(contract) {
  return contract.userQuantity + contract.userOpenOrdersBuyQuantity + contract.userOpenOrdersSellQuantity;
};
var isMarketSettled = function isMarketSettled(market) {
  return market && market.status === __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].MARKET_SETTLED;
};
var isMarketExpired = function isMarketExpired(market) {
  return market && market.status === __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].MARKET_EXPIRED;
};
var isMarketSuspended = function isMarketSuspended(market) {
  return market && market.status === __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].MARKET_SUSPENDED;
};
var isMarketMaintenance = function isMarketMaintenance(market) {
  return market && market.status === __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].MARKET_MAINTENANCE;
};
var isMarketStatusClosed = function isMarketStatusClosed(market) {
  return market && market.status === __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].MARKET_CLOSED;
};
var isMarketClosed = function isMarketClosed(market) {
  return market && !market.isOpen;
};
var isMarketDisabled = function isMarketDisabled(market) {
  return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters['app/hasMaintenance'] || isMarketSettled(market) || isMarketExpired(market) || isMarketSuspended(market) || isMarketMaintenance(market) || isMarketStatusClosed(market);
};
var isMarketJourneyDisabled = function isMarketJourneyDisabled(market) {
  return isMarketSettled(market);
};
var hasMarketPayout = function hasMarketPayout(market) {
  return market && (market.userInvestment !== 0 || market.userMaxPayout !== 0);
};
var hasMarketHiddenContracts = function hasMarketHiddenContracts(market) {
  var contracts = market.contracts || market.marketContracts || [];
  return typeof contracts.find(function (i) {
    return i.hiddenByDefault;
  }) !== 'undefined';
};
var isContractOpen = function isContractOpen(contract) {
  return typeof contract.isOpen !== 'undefined' && contract.isOpen || typeof contract.contractIsOpen !== 'undefined' && contract.contractIsOpen;
};

var isHighChartsReady = function isHighChartsReady() {
  return typeof Highcharts !== 'undefined';
};


/* unused harmony default export */ var _unused_webpack_default_export = ({});

function largeNumberDisplay(x) {
  var largeThousands = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var value = x;
  if (value >= 1.0e+6) {
    if ((value / 1.0e+6).toFixed(1).endsWith('.0')) {
      value = (value / 1.0e+6).toFixed(0) + 'M';
    } else {
      value = (value / 1.0e+6).toFixed(1) + 'M';
    }
  } else if (largeThousands && value >= 1.0e+5) {
    value = (value / 1.0e+3).toFixed(0) + 'K';
  } else if (!largeThousands && value >= 1.0e+3) {
    if ((value / 1.0e+3).toFixed(1).endsWith('.0')) {
      value = (value / 1.0e+3).toFixed(0) + 'K';
    } else {
      value = (value / 1.0e+3).toFixed(1) + 'K';
    }
  } else {
    value = value.toLocaleString('en-US');
  }
  return value;
}

function elementOffset(el) {
  var rect = el.getBoundingClientRect();
  var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

var scrollPosition = 0;
var lockCount = 0;
var lockedWithFixedBody = false;

function lockScroll() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$modal = _ref2.modal,
      modal = _ref2$modal === undefined ? false : _ref2$modal,
      _ref2$forceFixed = _ref2.forceFixed,
      forceFixed = _ref2$forceFixed === undefined ? false : _ref2$forceFixed,
      _ref2$fixedOffset = _ref2.fixedOffset,
      fixedOffset = _ref2$fixedOffset === undefined ? 0 : _ref2$fixedOffset;

  if (lockCount === 0) {
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    var isDesktop = !__WEBPACK_IMPORTED_MODULE_11__mixins_userAgent__["c" /* isIos */] && !__WEBPACK_IMPORTED_MODULE_11__mixins_userAgent__["d" /* isAndroid */] && !__WEBPACK_IMPORTED_MODULE_11__mixins_userAgent__["e" /* isTablet */];
    lockedWithFixedBody = __WEBPACK_IMPORTED_MODULE_11__mixins_userAgent__["c" /* isIos */] || forceFixed;

    if (lockedWithFixedBody) {
      __WEBPACK_IMPORTED_MODULE_12__logger__["a" /* default */].info('lockScroll ON ' + (__WEBPACK_IMPORTED_MODULE_11__mixins_userAgent__["c" /* isIos */] ? 'iOS' : 'Desktop'));
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + Math.max(0, scrollPosition - fixedOffset) + 'px';
      document.body.style.width = '100%';
    }

    if (isDesktop) {
      document.body.style.height = 'auto';
    }
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }
  lockCount += 1;
}

function unlockScroll() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$modal = _ref3.modal,
      modal = _ref3$modal === undefined ? false : _ref3$modal;

  if (lockCount <= 0) return;
  lockCount -= 1;
  if (lockCount === 0) {
    __WEBPACK_IMPORTED_MODULE_12__logger__["a" /* default */].info('lockScroll OFF');
    var isDesktop = !__WEBPACK_IMPORTED_MODULE_11__mixins_userAgent__["c" /* isIos */] && !__WEBPACK_IMPORTED_MODULE_11__mixins_userAgent__["d" /* isAndroid */] && !__WEBPACK_IMPORTED_MODULE_11__mixins_userAgent__["e" /* isTablet */];
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');
    if (lockedWithFixedBody) {
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('width');
      lockedWithFixedBody = false;
    }

    if (isDesktop) {
      document.body.style.removeProperty('height');
    }

    window.requestAnimationFrame(function () {
      window.scrollTo({
        top: scrollPosition,
        behavior: 'instant'
      });
    });

    void document.body.offsetHeight;
  }
}

function lockModal() {
  lockScroll({ modal: true });
}

function unLockModal() {
  unlockScroll({ modal: true });
}

function marketUserGainLoss(market) {
  var contracts = market.contracts || market.marketContracts || [];
  return __WEBPACK_IMPORTED_MODULE_4_lodash_sumBy___default()(contracts, function (c) {
    var gainLoss = 0;
    if (c.userPrediction === 0 && c.userOpenOrders !== 0) {
      gainLoss = (1 - c.lastTradePrice - c.userAveragePricePerShare) * c.userQuantity;
    } else {
      gainLoss = (c.lastTradePrice - c.userAveragePricePerShare) * c.userQuantity;
    }
    return gainLoss;
  });
}

var hasNoPositionInAMarketBesidesLoadedContract = function hasNoPositionInAMarketBesidesLoadedContract(_ref4) {
  var market = _ref4.market,
      contract = _ref4.contract;

  if (!market || !contract) return false;
  var contracts = market.contracts || market.marketContracts || [];
  var contractsWithout = contracts.filter(function (c) {
    return c.contractId !== contract.contractId;
  });
  if (contractsWithout.length === 0) return false;

  return contractsWithout.some(function (c) {
    return c.userPrediction === 0 && c.userQuantity > 0;
  });
};

var smartbtoa = function smartbtoa(input) {
  return btoa(unescape(encodeURIComponent(input)));
};
var smartatob = function smartatob(input) {
  return decodeURIComponent(escape(atob(input)));
};

var groupByKeepOrder = function groupByKeepOrder(arr, prop) {
  var newArr = [];
  var wrapObj = {};

  arr.forEach(function (item) {
    var propName = item[prop];
    if (propName) {
      propName = propName.toString();
      if (!wrapObj[propName]) {
        wrapObj[propName] = [];
        newArr.push(wrapObj[propName]);
      }
      wrapObj[propName].push(item);
    }
  });

  return newArr;
};

function roundToTwo(value) {
  return Math.round(value * 100) / 100;
}

function roundDown(value) {
  return Math.floor(value * 100) / 100;
}

function roundTop(value) {
  return Math.ceil(value * 100) / 100;
}

function normalizeDecimalString(value) {
  var numericValue = Number(value);
  if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default()(numericValue) || numericValue < 0) return null;

  var normalized = String(value).trim();
  if (/[eE]/.test(normalized)) {
    normalized = numericValue.toFixed(12).replace(/\.?0+$/, '');
  }

  if (normalized.startsWith('.')) {
    normalized = '0' + normalized;
  }

  return (/^\d+(?:\.\d+)?$/.test(normalized) ? normalized : null
  );
}

function decimalToCents(value) {
  var normalized = normalizeDecimalString(value);
  if (normalized === null) return 0;

  var parts = normalized.split('.');
  var whole = Number(parts[0]) || 0;
  var fraction = parts[1] || '';
  var centDigits = (fraction + '00').slice(0, 2);
  var remainder = fraction.slice(2);
  return whole * 100 + Number(centDigits) + (remainder && Number(remainder[0]) >= 5 ? 1 : 0);
}

function multiplyIntegerStrings(left, right) {
  if (left === '0' || right === '0') return '0';
  var result = new Array(left.length + right.length).fill(0);

  for (var leftIndex = left.length - 1; leftIndex >= 0; leftIndex -= 1) {
    for (var rightIndex = right.length - 1; rightIndex >= 0; rightIndex -= 1) {
      var resultIndex = leftIndex + rightIndex + 1;
      var product = Number(left[leftIndex]) * Number(right[rightIndex]) + result[resultIndex];
      result[resultIndex] = product % 10;
      result[resultIndex - 1] += Math.floor(product / 10);
    }
  }

  return result.join('').replace(/^0+/, '') || '0';
}

function ceilIntegerProductAtScale(product, scale) {
  if (scale <= 0) return Number(product);
  if (product.length <= scale) return (/^0+$/.test(product) ? 0 : 1
  );

  var splitIndex = product.length - scale;
  var whole = Number(product.slice(0, splitIndex));
  var fraction = product.slice(splitIndex);
  return whole + (/[^0]/.test(fraction) ? 1 : 0);
}

function calculateWithdrawalFee(_ref5) {
  var amount = _ref5.amount,
      feePercent = _ref5.feePercent,
      feeCap = _ref5.feeCap;

  var amountInCents = decimalToCents(amount);
  var normalizedRate = normalizeDecimalString(feePercent);
  if (amountInCents <= 0 || normalizedRate === null) return 0;

  var rateParts = normalizedRate.split('.');
  var rateFraction = (rateParts[1] || '').replace(/0+$/, '');
  var rateDigits = ('' + rateParts[0] + rateFraction).replace(/^0+/, '') || '0';
  var product = multiplyIntegerStrings(String(amountInCents), rateDigits);
  var feeInCents = ceilIntegerProductAtScale(product, rateFraction.length);

  if (feeCap !== null && typeof feeCap !== 'undefined') {
    feeInCents = Math.min(feeInCents, decimalToCents(Math.abs(Number(feeCap))));
  }

  return feeInCents / 100;
}

var getCardTypeForNumber = function getCardTypeForNumber(value) {
  if (/^(?:4\d{12}(?:\d{3})?)$/.test(value)) return __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].CARDS.VISA;
  if (/^(?:3[47]\d{13})$/.test(value)) return __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].CARDS.AMERICAN_EXPRESS;
  if (/^6(?:011\d{12,15}|5\d{14,17}|4[4-9]\d{13,16}|22(?:1(?:2[6-9]|[3-9]\d)|[2-8]\d{2}|9(?:[01]\d|2[0-5]))\d{10,13})$/.test(value)) return __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].CARDS.DISCOVER;
  if (/^(?:5[1-5]\d{14})$/.test(value)) return __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].CARDS.MASTERCARD;
  return __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* default */].CARDS.BLANK;
};

var getOrdinalSuffix = function getOrdinalSuffix(value) {
  var symbols = ['th', 'st', 'nd', 'rd'];
  var v = value % 100;
  return symbols[(v - 20) % 10] || symbols[v] || symbols[0];
};

var loadedScripts = {};
var loadScript = function loadScript(url, windowVariable) {
  if (!loadedScripts[url]) {
    loadedScripts[url] = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.addEventListener('load', function () {
        return resolve(windowVariable ? __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(window, windowVariable) : undefined);
      }, false);
      script.addEventListener('error', function (e) {
        delete loadedScripts[url];
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
        reject(e);
      }, false);
      document.body.appendChild(script);
    });
  }
  return loadedScripts[url];
};

var parseQuery = function parseQuery(queryString) {
  var query = {};
  var a = (queryString[0] === '?' || queryString[0] === '#' ? queryString.substr(1) : queryString).split('&');
  for (var i = 0; i < a.length; i += 1) {
    var b = a[i].split('=');
    query[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || '');
  }
  return query;
};
var checkIfKeyExist = function checkIfKeyExist(objectName, keyName) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(objectName).some(function (key) {
    return key === keyName;
  });
};

function getExtendedUrlWithSessionVarsInQuery(url) {
  var data = __WEBPACK_IMPORTED_MODULE_13__helpers_sessionVars__["a" /* default */].params();
  var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data);
  if (keys.length === 0) {
    return encodeURIComponent(url);
  }

  try {
    var urlObject = new URL(url);
    keys.forEach(function (key) {
      var value = data[key];
      if (value !== undefined && value !== null) {
        urlObject.searchParams.set(key, String(value));
      }
    });
    return encodeURIComponent(urlObject.toString());
  } catch (e) {
    return encodeURIComponent(url);
  }
}

var loginUrl = function loginUrl() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref6$returnTo = _ref6.returnTo,
      returnTo = _ref6$returnTo === undefined ? null : _ref6$returnTo;

  var url = returnTo || window.location.pathname + window.location.search;
  var isDev = "production" === 'development';
  var finalUrl = isDev ? window.location.href : url;
  var returnUrl = getExtendedUrlWithSessionVarsInQuery(finalUrl);
  return "/" + 'auth/login?returnUrl=' + returnUrl;
};
var signUpUrl = function signUpUrl() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref7$returnTo = _ref7.returnTo,
      returnTo = _ref7$returnTo === undefined ? null : _ref7$returnTo;

  var url = returnTo || window.location.pathname + window.location.search;
  var isDev = "production" === 'development';
  var finalUrl = isDev ? window.location.href : url;
  var returnUrl = getExtendedUrlWithSessionVarsInQuery(finalUrl);
  return "/" + 'auth/register?returnUrl=' + returnUrl;
};

var editAccountDetailsUrl = function editAccountDetailsUrl() {
  var url = window.location.pathname + window.location.search;
  var isDev = "production" === 'development';
  var finalUrl = isDev ? window.location.href : url;
  var returnUrl = getExtendedUrlWithSessionVarsInQuery(finalUrl);
  return "/" + 'auth/manage?returnUrl=' + returnUrl;
};

var verifyDetailsUrl = function verifyDetailsUrl() {
  var url = window.location.pathname + window.location.search;
  var isDev = "production" === 'development';
  var finalUrl = isDev ? window.location.href : url;
  var returnUrl = getExtendedUrlWithSessionVarsInQuery(finalUrl);
  return "/" + 'auth/profile?returnUrl=' + returnUrl;
};

var logoutUrl = function logoutUrl() {
  var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref8$routeRequiresAu = _ref8.routeRequiresAuth,
      routeRequiresAuth = _ref8$routeRequiresAu === undefined ? true : _ref8$routeRequiresAu;

  var url = routeRequiresAuth ? '/' : window.location.pathname + window.location.search;
  var isDev = "production" === 'development';
  var finalUrl = isDev ? window.location.href : url;
  var returnUrl = getExtendedUrlWithSessionVarsInQuery(finalUrl);
  return "/" + 'auth/logout?returnUrl=' + returnUrl;
};

var changeAvatarImageUrl = function changeAvatarImageUrl() {
  var url = window.location.pathname + window.location.search;
  var isDev = "production" === 'development';
  var finalUrl = isDev ? window.location.href : url;
  var returnUrl = getExtendedUrlWithSessionVarsInQuery(finalUrl);
  return "/" + 'auth/avatar?returnUrl=' + returnUrl;
};

var registerPersonalDetailsUrl = function registerPersonalDetailsUrl() {
  var url = window.location.pathname + window.location.search;
  var isDev = "production" === 'development';
  var finalUrl = isDev ? window.location.href : url;
  var returnUrl = getExtendedUrlWithSessionVarsInQuery(finalUrl);
  return "/" + 'auth/registration?returnUrl=' + returnUrl;
};

var getAssetPath = function getAssetPath(path) {
  return '' + "https://cdn1.predictit.org" + path;
};

var isVisibleInViewport = function isVisibleInViewport(element) {
  var elementStyle = window.getComputedStyle(element);
  //Particular cases when the element is not visible at all
  if (elementStyle.height == '0px' || elementStyle.display == 'none' || elementStyle.opacity == '0' || elementStyle.visibility == 'hidden' || elementStyle.clipPath == 'circle(0px at 50% 50%)' || elementStyle.transform == 'scale(0)' || element.hasAttribute('hidden')) {
    return false;
  }

  var rect = element.getBoundingClientRect();

  //Overlapping strict check
  var baseElementLeft = rect.left;
  var baseElementTop = rect.top;

  var elementFromStartingPoint = document.elementFromPoint(baseElementLeft, baseElementTop);

  if (elementFromStartingPoint != null && !element.isSameNode(elementFromStartingPoint)) {
    var elementZIndex = elementStyle.zIndex;
    var elementOverlappingZIndex = window.getComputedStyle(elementFromStartingPoint).zIndex;
    if (Number(elementZIndex) < Number(elementOverlappingZIndex)) {
      return false;
    }

    if (elementZIndex === '' && elementOverlappingZIndex === '') {
      /**
           		If two positioned elements overlap without a z-index specified, the element
      positioned last in the HTML code will be shown on top
           		**/
      if (element.compareDocumentPosition(elementFromStartingPoint) & Node.DOCUMENT_POSITION_FOLLOWING) {
        return false;
      }
    }
  }

  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};
var stripTags = function stripTags(string) {
  return (string || "").replace(/(<([^>]+)>)/gi, "");
};

var isEmptyHtml = function isEmptyHtml(html) {
  if (!html) return true;
  var stripped = html.replace(/<[^>]*>?/gm, '').trim();
  return stripped.length === 0;
};
var uuidv4 = function uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function (c) {
    return (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16);
  });
};

/***/ }),

/***/ "cOUW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_tabs_js__ = __webpack_require__("JJDO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_710eb020_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_tabs_vue__ = __webpack_require__("/Q1K");
function injectStyle (ssrContext) {
  __webpack_require__("ZAp9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_tabs_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_710eb020_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cQOb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-list-item-v2-embed",class:{ 'market-list-item-v2-embed--vertical': _vm.isVerticalList }},[(_vm.showTitle)?_c('div',{staticClass:"market-list-item-v2-embed__header"},[_c('div',{staticClass:"market-list-item-v2-embed__header-text"},[_vm._v("\n      Related Markets:\n    ")]),_vm._v(" "),_c('div',{staticClass:"market-list-item-v2-embed__header-text--small"},[_vm._v("\n      "+_vm._s(_vm.markets.length)+" Market"),(_vm.markets.length !== 1)?[_vm._v("s")]:_vm._e()],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-list-item-v2-embed__grid",style:(_vm.gridStyleModifiers)},_vm._l((_vm.markets),function(market){return _c('div',{staticClass:"market-list-item-v2-embed__grid-item"},[_c('market-list-item',{key:market.marketId,attrs:{"market":market,"trackingContext":_vm.trackingContext}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cRkn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-timeline"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabsPeriod.length > 0 && !_vm.isLayoutMobile),expression:"tabsPeriod.length > 0 && !isLayoutMobile"}],staticClass:"charts-timeline__tabs-period",class:{'charts-timeline__tabs-period--disabled': _vm.isChartLoading},style:(_vm.tabsPeriodStyleModifiers)},[_c('tabs',{attrs:{"activeTab":_vm.activeTabPeriod,"items":_vm.tabsPeriod,"theme":"timeline-sushi"},on:{"tabChange":_vm.tabChangePeriod}})],1),_vm._v(" "),(!_vm.isForStory)?_c('div',{staticClass:"charts-timeline__menu-control-stats",attrs:{"title":"View trading statistics"},on:{"click":_vm.onOpenStats}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"charts-timeline__menu-control-settings",on:{"click":_vm.onOpenSettings}}),_vm._v(" "),_c('div',{staticClass:"charts-timeline__logo"}),_vm._v(" "),(_vm.showMenu)?_c('small-modal',{on:{"modalClose":function($event){_vm.showMenu = false}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("\n      Chart Settings\n    ")]},proxy:true},{key:"content",fn:function(){return [(_vm.showMenu)?_c('div',{staticClass:"charts-timeline__menu"},[_c('div',{staticClass:"charts-timeline__menu-content"},[(_vm.tabsPeriod.length > 0 && _vm.isLayoutMobile)?[_c('div',{staticClass:"charts-timeline__menu-label"},[_vm._v("\n              Chart Timeline\n            ")]),_vm._v(" "),_c('div',{staticClass:"charts-timeline__menu-inner"},[_c('div',{staticClass:"charts-timeline__menu-inner-items",class:{'charts-timeline__menu-inner-items--disabled': _vm.isChartLoading}},_vm._l((_vm.tabsPeriod),function(tab){return _c('div',{key:tab.name,staticClass:"charts-timeline__menu-inner-item",class:{
                       'charts-timeline__menu-inner-item--selected': tab.name === _vm.activeTabPeriod,
                       'charts-timeline__menu-inner-item--disabled': _vm.isChartLoading
                     },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.tabChangePeriod(tab.name)}}},[_vm._v("\n                  "+_vm._s(tab.title)+"\n                ")])}),0)]),_vm._v(" "),_c('hr')]:_vm._e(),_vm._v(" "),(_vm.tabsType.length > 1)?[_c('div',{staticClass:"charts-timeline__menu-label"},[_vm._v("\n              Chart Type\n            ")]),_vm._v(" "),_c('div',{staticClass:"charts-timeline__menu-inner"},[_c('div',{staticClass:"charts-timeline__menu-inner-items",class:{'charts-timeline__menu-inner-items--disabled': _vm.isChartLoading}},_vm._l((_vm.tabsType),function(tab){return _c('div',{key:tab.name,staticClass:"charts-timeline__menu-inner-item",class:{
                       'charts-timeline__menu-inner-item--selected': tab.name === _vm.activeTabType,
                       'charts-timeline__menu-inner-item--disabled': _vm.isChartLoading
                     },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.tabChangeType(tab.name)}}},[_vm._v("\n                  "+_vm._s(tab.title)+"\n                ")])}),0)]),_vm._v(" "),_c('hr')]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"charts-timeline__menu-label"},[_vm._v("\n            Chart Settings\n          ")]),_vm._v(" "),_c('div',{staticClass:"charts-timeline__menu-inner"},[_c('div',{staticClass:"charts-timeline__toggle",class:{'charts-timeline__toggle--disabled': _vm.isChartLoading}},[_c('div',{staticClass:"charts-timeline__toggle-control",class:{
                  'charts-timeline__toggle-control--active': _vm.showVolumeChart,
                  'charts-timeline__toggle-control--disabled': _vm.isChartLoading
                },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onVolumeChartToggle($event)}}}),_vm._v(" "),_c('div',{staticClass:"charts-timeline__toggle-control-label"},[_vm._v("\n                Show Volume\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"charts-timeline__menu-inner"},[_c('div',{staticClass:"charts-timeline__toggle",class:{'charts-timeline__toggle--disabled': _vm.isChartLoading}},[_c('div',{staticClass:"charts-timeline__toggle-control",class:{
                  'charts-timeline__toggle-control--active': _vm.showPriceAxisZoomValue,
                  'charts-timeline__toggle-control--disabled': _vm.isChartLoading
                },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onPriceAxisZoomToggle($event)}}}),_vm._v(" "),_c('div',{staticClass:"charts-timeline__toggle-control-label"},[_vm._v("\n                Price Axis Zoom\n              ")])])]),_vm._v(" "),(!_vm.isForStory)?[_c('hr'),_vm._v(" "),_c('div',{staticClass:"charts-timeline__menu-stats",class:{'charts-timeline__menu-stats--disabled': _vm.isChartLoading},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onOpenStats($event)}}},[_vm._v("\n              Open Stats\n            ")])]:_vm._e(),_vm._v(" "),(_vm.isChartLoading)?_c('div',{staticClass:"charts-timeline__menu-loading"},[_c('div',{staticClass:"charts-timeline__menu-loading-spinner"})]):_vm._e()],2),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"button button--large button--black button--full-width",on:{"click":function($event){_vm.showMenu = false}}},[_vm._v("\n          Close\n        ")])]):_vm._e()]},proxy:true}],null,false,826266073)}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cT9C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_insight_insight_panel_insight_panel_vue__ = __webpack_require__("QgOX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_insight_insight_link_insight_link_vue__ = __webpack_require__("DXdo");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    insightPanel: __WEBPACK_IMPORTED_MODULE_3__components_insight_insight_panel_insight_panel_vue__["a" /* default */],
    insightLink: __WEBPACK_IMPORTED_MODULE_4__components_insight_insight_link_insight_link_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('insight', ['analysis']), {
    allArticlesAway: function allArticlesAway() {
      return !this.isLayoutMobile;
    },
    allArticlesLink: function allArticlesLink() {
      if (!this.isLayoutMobile) {
        return 'https://analysis.predictit.org/';
      }
      return {
        path: '/insight/' + btoa(encodeURI('//analysis.predictit.org/'))
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('insight', ['getAnalysis']), {
    createLink: function createLink(url) {
      return {
        path: '/insight/' + btoa(encodeURI(url))
      };
    },
    createDate: function createDate(date) {
      if (date) {
        var dt = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date.split(' ')[0]);
        var diff = __WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(dt, 'days');
        var map = {
          0: 'Today',
          1: 'Yesterday',
          2: dt.format('dddd'),
          3: dt.format('dddd'),
          4: dt.format('dddd'),
          5: dt.format('dddd'),
          6: dt.format('dddd')
        };
        return map[diff] || dt.format('MMM. D');
      }
      return '';
    }
  }),
  mounted: function mounted() {
    this.getAnalysis({});
  }
});

/***/ }),

/***/ "cVuz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__ = __webpack_require__("0O9D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b161a9d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("n71m");
function injectStyle (ssrContext) {
  __webpack_require__("wQrL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b161a9d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cW54":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__ = __webpack_require__("DECz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("oiih");
/* eslint-disable max-len */






/* harmony default export */ __webpack_exports__["a"] = ({
  getManageInfo: function getManageInfo() {
    var returnUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var generateState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'false';

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/ManageInfo?returnUrl=' + returnUrl + '&generateState=' + generateState);
  },
  postToken: function postToken() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/token', payload);
  },
  getUserInfo: function getUserInfo() {
    var options = {};
    var token = __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get('externalToken', null);
    if (token) {
      options.headers = {
        Authorization: 'Bearer ' + token
      };
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/UserInfo', options);
  },
  getAccountDetail: function getAccountDetail() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/Detail');
  },
  postLogout: function postLogout() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var options = {
      withCredentials: true
    };
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/Logout', payload, options);
  },
  getStatus: function getStatus() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/Status');
  },
  postRegister: function postRegister(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__["a" /* default */].payload(payload, 'PIReferral', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/Register', marketingPayload);
  },
  postRegisterExternal: function postRegisterExternal(payload) {
    var options = {};
    var token = __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get('externalToken', null);
    if (token) {
      options.headers = {
        Authorization: 'Bearer ' + token
      };
    }
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__["a" /* default */].payload(payload, 'PIReferral', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/RegisterExternal', marketingPayload, options);
  },
  postResetPassword: function postResetPassword(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/ResetPassword', payload);
  },
  postForgotPassword: function postForgotPassword(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/ForgotPassword', payload);
  },
  postChangePassword: function postChangePassword(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/ChangePassword', payload);
  },
  postSetPassword: function postSetPassword(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/SetPassword', payload);
  },
  postRemoveLogin: function postRemoveLogin(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/RemoveLogin', payload);
  },
  postAddExternalLogin: function postAddExternalLogin(payload) {
    var options = {
      withCredentials: true
    };
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/AddExternalLogin', payload, options);
  },
  getExternalLogins: function getExternalLogins() {
    var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.pathname;
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].SOCIAL_LOGIN_OR_REGISTER;

    var redirect = pathname.replace("/", '/');
    var accessToken = __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get('token');

    if (accessToken !== null || redirect.includes('account/login') || redirect.includes('account/sign-up')) {
      redirect = '/';
    }

    var options = {
      params: {
        returnUrl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["b" /* getRedirectUrl */])('/account/social/auth/?redirect=' + redirect + '&type=' + type),
        generateState: true
      }
    };
    var token = __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get('externalToken', null);
    if (token) {
      options.headers = {
        Authorization: 'Bearer ' + token
      };
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('/api/Account/ExternalLogins', options);
  },
  getVerifyID: function getVerifyID() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/VerifyID');
  },
  postVerifyID: function postVerifyID(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/VerifyID', payload);
  },
  postUploadUserImage: function postUploadUserImage(payload) {
    var options = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    };
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/UploadUserImage', payload, options);
  },
  putResetUserImage: function putResetUserImage() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Account/ResetUserImage');
  },
  getCommunicationPreferences: function getCommunicationPreferences() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/CommunicationPreferences');
  },
  postCommunicationPreferences: function postCommunicationPreferences(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/CommunicationPreferences', payload);
  },
  getCaptchaSiteKey: function getCaptchaSiteKey() {
    // Public endpoint - must not send Authorization header (may have stale token)
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/CaptchaSiteKey', {
      transformRequest: [function (data, headers) {
        delete headers.Authorization;
        return data;
      }]
    });
  },
  getCaptchaSiteKeyV3: function getCaptchaSiteKeyV3() {
    // Public endpoint - must not send Authorization header (may have stale token)
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/CaptchaSiteKeyV3', {
      transformRequest: [function (data, headers) {
        delete headers.Authorization;
        return data;
      }]
    });
  },
  getDisqusLogin: function getDisqusLogin() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/DisqusLogin');
  },
  getDisqusLogout: function getDisqusLogout() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/DisqusLogout');
  },
  getDisqusUserAuth: function getDisqusUserAuth() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/DisqusUserAuth');
  },
  getIdUploadUrl: function getIdUploadUrl() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/IdUploadUrl');
  },
  getTaxInfo: function getTaxInfo(_ref) {
    var _ref$reasonCode = _ref.reasonCode,
        reasonCode = _ref$reasonCode === undefined ? '' : _ref$reasonCode;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/TaxInfo?reasonCode=' + reasonCode);
  },
  postTaxInfo: function postTaxInfo(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TaxInfo', payload);
  },
  putMessagingToken: function putMessagingToken(token) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Account/MessagingToken?token=' + token);
  },
  getChangeUsername: function getChangeUsername() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/ChangeUsername');
  },
  postChangeUsername: function postChangeUsername(username) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/ChangeUsername?username=' + username);
  },
  getDocumentUploadLink: function getDocumentUploadLink(source) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/DocumentUploadLink?source=' + source);
  },
  putAgreedToTerms: function putAgreedToTerms(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Account/UpdateAgreedToTerms', payload);
  },


  // --- Two-Factor Authentication ---

  // Login flow (anonymous - uses encrypted 2FA token)
  postTwoFactorSendCode: function postTwoFactorSendCode(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/SendCode', payload);
  },
  postTwoFactorVerify: function postTwoFactorVerify(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Verify', payload);
  },


  // User management (authenticated)
  getTwoFactorStatus: function getTwoFactorStatus() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/TwoFactor/Status');
  },
  postTwoFactorSetupEmailSendCode: function postTwoFactorSetupEmailSendCode() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Setup/Email/SendCode');
  },
  postTwoFactorSetupEmailVerify: function postTwoFactorSetupEmailVerify(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Setup/Email/Verify', payload);
  },
  postTwoFactorSetupPhoneSendCode: function postTwoFactorSetupPhoneSendCode() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Setup/Phone/SendCode');
  },
  postTwoFactorSetupPhoneVerify: function postTwoFactorSetupPhoneVerify(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Setup/Phone/Verify', payload);
  },
  getTwoFactorSetupAuthenticator: function getTwoFactorSetupAuthenticator() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/TwoFactor/Setup/Authenticator');
  },
  postTwoFactorSetupAuthenticatorVerify: function postTwoFactorSetupAuthenticatorVerify(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Setup/Authenticator/Verify', payload);
  },
  postTwoFactorEnable: function postTwoFactorEnable() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Enable');
  },
  postTwoFactorDisable: function postTwoFactorDisable() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Disable');
  },


  // --- Phone Management ---
  getPhone: function getPhone() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/TwoFactor/Phone');
  },
  postPhoneUpdate: function postPhoneUpdate(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Phone/Update', payload);
  },
  postPhoneVerify: function postPhoneVerify(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TwoFactor/Phone/Verify', payload);
  }
});

/***/ }),

/***/ "cgm0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* global $:false */
/*
  Mixin used to move some meta tags used for SEO just after
  header's title node. Supposedly it affects prerender.io.
 */
var headerTagsMixin = {
  methods: {
    reorganizeTags: function reorganizeTags() {
      setTimeout(function () {
        if (!window.$) return;
        $('meta[name="description"]').detach().insertAfter('title');
        $('meta[itemprop]').detach().insertAfter('title');
        $('meta[property]').detach().insertAfter('title');
      }, 0);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (headerTagsMixin);

/***/ }),

/***/ "ckGe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cqOx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    theme: {
      type: String,
      default: ''
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'no-data-dashed-box': true
      }, 'no-data-dashed-box--' + this.theme, this.theme);
    }
  }
});

/***/ }),

/***/ "d/V8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export thousandDisplay */
/* unused harmony export TITLE_LATEST_PRICE */
/* unused harmony export OPERATIONS */
/* unused harmony export VALUES */
/* unused harmony export BUTTONS */
/* unused harmony export getActiveButtonAfterSwitch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_market_shares_bar_market_shares_bar_vue__ = __webpack_require__("HvTw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_market_button_direction_market_button_direction_vue__ = __webpack_require__("jtVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_mutex__ = __webpack_require__("EOu+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_scrollTo__ = __webpack_require__("rrO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_market_v2_market_disabled_outcome_v2_market_disabled_outcome_v2_vue__ = __webpack_require__("tRmv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_market_v2_market_trading_unavailable_v2_market_trading_unavailable_v2_vue__ = __webpack_require__("azKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_market_market_shares_ownership_market_shares_ownership_vue__ = __webpack_require__("tyTh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_market_market_contract_horizontal_sushi_orders_market_contract_horizontal_sushi_orders_vue__ = __webpack_require__("G/7i");



/* eslint-disable */
















var thousandDisplay = function thousandDisplay(value) {
  if (value >= 1.0e+4) {
    return Math.round(value / 1.0e+3) + 'K';
  }
  return value >= 1.0e+3 ? Math.floor(10 * value / 1.0e+3) / 10 + 'K' : value;
};

var TITLE_LATEST_PRICE = 'Latest Price';
var firstNonEmptyString = function firstNonEmptyString() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.find(function (value) {
    return typeof value === 'string' && value.trim() !== '';
  });
};
var OPERATIONS = {
  BUY: 'buy',
  SELL: 'sell'
};
var VALUES = {
  YES: 'yes',
  NO: 'no'
};
var BUTTONS = {
  BUY_NO: {
    id: 'buy-no',
    type: OPERATIONS.BUY,
    value: VALUES.NO
  },
  BUY_YES: {
    id: 'buy-yes',
    type: OPERATIONS.BUY,
    value: VALUES.YES
  },
  SELL_NO: {
    id: 'sell-no',
    type: OPERATIONS.SELL,
    value: VALUES.NO
  },
  SELL_YES: {
    id: 'sell-yes',
    type: OPERATIONS.SELL,
    value: VALUES.YES
  }
};

function getActiveButtonAfterSwitch(contractModel, switchTo) {
  var button = null;

  if (switchTo === 'left') {
    button = BUTTONS.BUY_YES;;
  } else if (switchTo === 'right') {
    button = BUTTONS.BUY_NO;
  }

  return button;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_accountVerify__["a" /* default */]],
  components: {
    marketButtonDirection: __WEBPACK_IMPORTED_MODULE_8__components_market_market_button_direction_market_button_direction_vue__["a" /* default */],
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_6__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    marketSharesBar: __WEBPACK_IMPORTED_MODULE_7__components_market_market_shares_bar_market_shares_bar_vue__["a" /* default */],
    marketDisabledOutcomeV2: __WEBPACK_IMPORTED_MODULE_13__components_market_v2_market_disabled_outcome_v2_market_disabled_outcome_v2_vue__["a" /* default */],
    marketTradingUnavailableV2: __WEBPACK_IMPORTED_MODULE_14__components_market_v2_market_trading_unavailable_v2_market_trading_unavailable_v2_vue__["a" /* default */],
    marketSharesOwnership: __WEBPACK_IMPORTED_MODULE_15__components_market_market_shares_ownership_market_shares_ownership_vue__["a" /* default */],
    marketContractHorizontalSushiOrders: __WEBPACK_IMPORTED_MODULE_16__components_market_market_contract_horizontal_sushi_orders_market_contract_horizontal_sushi_orders_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    contract: {
      type: Object,
      required: true
    },
    forCmsWidget: {
      type: Boolean,
      default: false
    },
    forceMobileLayout: {
      type: Boolean,
      default: false
    },
    dashboardMode: {
      type: Boolean,
      default: false
    },
    showSharesOwnedIconOnImage: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hovered: false,
      BUTTONS: BUTTONS,
      OPERATIONS: OPERATIONS,
      VALUES: VALUES,
      isWaiting: false,
      activeButton: null,
      chart: null
    };
  },
  mounted: function mounted() {
    this.initializePurchaseButtons();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop', 'isTradingEnabled', 'currentPriceSymbol']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'tradeOperationToggle', 'isInConfirmationMode']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['status']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['settingShowOdds']), {
    useMobileLayout: function useMobileLayout() {
      return this.forceMobileLayout || this.isLayoutMobile;
    },
    useDesktopLayout: function useDesktopLayout() {
      return !this.useMobileLayout;
    },
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_5__models_contract__["a" /* default */](this.contract);
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["k" /* isMarketSingle */])(this.market);
    },
    isMarketJourneyDisabled: function isMarketJourneyDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["A" /* isMarketJourneyDisabled */])(this.market);
    },
    singleMarketTitle: function singleMarketTitle() {
      return firstNonEmptyString(this.market && this.market.marketShortName, this.market && this.market.marketName, this.contractModel.marketName, this.contractModel.contractName) || TITLE_LATEST_PRICE;
    },
    cmsWidgetTitle: function cmsWidgetTitle() {
      return firstNonEmptyString(this.contract && this.contract.contractName) || TITLE_LATEST_PRICE;
    },
    title: function title() {
      if (this.forCmsWidget) {
        return this.cmsWidgetTitle;
      }

      return this.isMarketSingle ? this.singleMarketTitle : firstNonEmptyString(this.contractModel.contractName, this.contractModel.name);
    },
    classModifiers: function classModifiers() {
      return {
        'market-contract-horizontal-sushi': true,
        'market-contract-horizontal-sushi--show-shares-owned-on-image': this.showSharesOwnedIconOnImage,
        'market-contract-horizontal-sushi--dashboard': this.dashboardMode,
        'market-contract-horizontal-sushi--hovered': this.hovered,
        'market-contract-horizontal-sushi--forced-mobile': this.forceMobileLayout,
        'market-contract-horizontal-sushi--no-shares-or-offers': !this.showOffersOrShares,
        'market-contract-horizontal-sushi--settled-yes': this.isMarketSettled && this.isPayoutTypeYes,
        'market-contract-horizontal-sushi--settled-no': this.isMarketSettled && this.isPayoutTypeNo,
        'market-contract-horizontal-sushi--should-close': this.shouldClosePurchaseJourney,
        'market-contract-horizontal-sushi--cms-widget': this.forCmsWidget
      };
    },
    imageUrl: function imageUrl() {
      return this.contractModel.contractImageSmallUrl || this.contractModel.contractImageUrl;
    },
    contractImageStyleModifiers: function contractImageStyleModifiers() {
      return {
        'background-image': 'url(' + this.imageUrl + ')'
      };
    },
    showOpenOffers: function showOpenOffers() {
      return !this.isMarketSettled && this.contractModel.userOpenOrders > 0;
    },
    showSharesBar: function showSharesBar() {
      return !this.isMarketSettled && this.contractModel.userQuantity > 0;
    },
    sharesOwnedStyleModifiers: function sharesOwnedStyleModifiers() {
      return {
        'market-contract-horizontal-sushi__image-shares-owned': true,
        'market-contract-horizontal-sushi__image-shares-owned--no': this.contractModel.mode === 'no'
      };
    },
    showOffersOrShares: function showOffersOrShares() {
      return this.showSharesBar || this.showOpenOffers;
    },
    isMarketDisabled: function isMarketDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["z" /* isMarketDisabled */])(this.market);
    },
    isMarketSettled: function isMarketSettled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["o" /* isMarketSettled */])(this.market);
    },
    isPayoutTypeYes: function isPayoutTypeYes() {
      return this.contract.payoutType === 1;
    },
    isPayoutTypeNo: function isPayoutTypeNo() {
      return this.isMarketSingle && this.contract.payoutType === 0;
    },
    shouldClosePurchaseJourney: function shouldClosePurchaseJourney() {
      return this.tradeOptions && this.tradeOptions.contractId === this.contract.contractId;
    },
    currentPrice: function currentPrice() {
      return this.contractModel.lastTradePriceAsCents;
    },
    currentPriceDashboard: function currentPriceDashboard() {
      if (!this.contractModel.hasLastTradePrice) {
        return 0;
      }

      if (this.contractModel.mode === 'no') {
        return 100 - this.contractModel.lastTradePriceAsCents;
      }
      return this.contractModel.lastTradePriceAsCents;
    },
    volumeDisplay: function volumeDisplay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["x" /* largeNumberDisplay */])(this.contractModel.userQuantity);
    },
    buyOrdersDisplay: function buyOrdersDisplay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["x" /* largeNumberDisplay */])(this.contractModel.userOpenOrdersBuyQuantity);
    },
    sellOrdersDisplay: function sellOrdersDisplay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["x" /* largeNumberDisplay */])(this.contractModel.userOpenOrdersSellQuantity);
    },
    buyOrdersTooltip: function buyOrdersTooltip() {
      return 'Buy: ' + this.contractModel.userOpenOrdersBuyQuantity.toLocaleString('en-US');
    },
    sellOrdersTooltip: function sellOrdersTooltip() {
      return 'Sell: ' + this.contractModel.userOpenOrdersSellQuantity.toLocaleString('en-US');
    },
    showChangePriceIndicator: function showChangePriceIndicator() {
      if (!this.contractModel.changePriceAsCents) {
        return false;
      }
      if (this.contractModel.lastClosePrice === null) {
        return false;
      }
      return true;
    },
    showChangePriceIndicatorUserChange: function showChangePriceIndicatorUserChange() {
      if (!this.contractModel.userChangePriceAsCents) {
        return false;
      }
      if (this.contractModel.lastClosePrice === null) {
        return false;
      }
      return true;
    }
  }),
  watch: {
    // opposite side of order book was clicked -- switching sides
    tradeOperationToggle: function tradeOperationToggle(switchTo) {
      if (this.contract.contractId !== this.tradeOptions.contractId || !switchTo) return;
      var button = getActiveButtonAfterSwitch(this.contractModel, switchTo);
      this.toggleTradeOperation(null);
      this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, button.id);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'toggleTradeOperation']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('market', ['pushSessionHistoryContract']), {
    findActiveButton: function findActiveButton() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(BUTTONS).find(function (i) {
        return i.id === _this.activeButton;
      });
    },
    getTypeAndValueIfButtonActiveOrDefaults: function getTypeAndValueIfButtonActiveOrDefaults() {
      var type = this.tradeOptions.operationType;
      var value = this.tradeOptions.operationValue;
      if (this.activeButton) {
        var button = this.findActiveButton();
        type = button.type;
        value = button.value;
      }
      return { type: type, value: value };
    },
    onClickSharesBar: function onClickSharesBar() {
      var _getTypeAndValueIfBut = this.getTypeAndValueIfButtonActiveOrDefaults(),
          type = _getTypeAndValueIfBut.type,
          value = _getTypeAndValueIfBut.value;

      this.openPurchaseJourney(this.contractModel.contractId, type, value);
    },
    onClickOpenOffers: function onClickOpenOffers() {
      var tab = 'sell-offers';
      var operationType = this.tradeOptions.operationType || '';
      if (operationType === '' && this.contractModel.userOpenOrdersBuyQuantity || operationType === OPERATIONS.BUY && this.contractModel.userOpenOrdersBuyQuantity) {
        tab = 'buy-offers';
      }

      var _getTypeAndValueIfBut2 = this.getTypeAndValueIfButtonActiveOrDefaults(),
          type = _getTypeAndValueIfBut2.type,
          value = _getTypeAndValueIfBut2.value;

      this.openPurchaseJourney(this.contractModel.contractId, type, value);
    },
    initializePurchaseButtons: function initializePurchaseButtons() {
      var button = BUTTONS.BUY_YES;
      if (this.contractModel.mode === VALUES.NO) {
        button = this.contract.contractId === this.tradeOptions.contractId && this.tradeOptions.operationValue === 'no' ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
      } else if (this.contractModel.mode === VALUES.YES) {
        button = BUTTONS.BUY_YES;
      }
      this.activeButton = button.id;

      if ((!this.isMarketSingle || this.useMobileLayout) && this.tradeOptions && this.contract.contractId === this.tradeOptions.contractId && (button.type !== this.tradeOptions.operationType || button.value !== this.tradeOptions.operationValue)) {
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value);
      }
    },
    onMouseOver: function onMouseOver() {
      this.hovered = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.hovered = false;
    },
    onContractClick: function onContractClick() {
      if (this.shouldClosePurchaseJourney) {
        this.setTradeOptions(null);
        return;
      }
      if (this.activeButton) {
        var button = BUTTONS.BUY_YES;
        if (this.contractModel.mode) {
          button = this.contractModel.mode === VALUES.NO ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
        }
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, button.id);

        // const $el = this.$refs[this.activeButton];
        // if (!$el) return;
        // const ev = new MouseEvent('click');
        // $el.dispatchEvent(ev);
      } else {
        var _button = this.contractModel.mode === VALUES.NO ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
        this.openPurchaseJourney(this.contractModel.contractId, _button.type, _button.value);
      }
    },
    isButtonActive: function isButtonActive(index) {
      var isOn = this.activeButton === index;
      var isButtonActive = this.tradeOptions.contractId === this.contract.contractId;

      return {
        'market-contract-horizontal-sushi__button-single--active': isButtonActive,
        'market-contract-horizontal-sushi__button-single--on': isOn,
        'market-contract-horizontal-sushi__button-single--off': !isOn,
        'market-contract-horizontal-sushi__button-single--off-yes': this.tradeOptions.operationValue === VALUES.YES,
        'market-contract-horizontal-sushi__button-single--off-no': this.tradeOptions.operationValue === VALUES.NO
      };
    },
    openPurchaseJourney: function openPurchaseJourney(contractId, operationType, operationValue) {
      var _this2 = this;

      var activateButton = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      if (this.isWaiting) {
        return;
      }

      this.isWaiting = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_mutex__["a" /* waitForFirebaseInitialized */])().then(function () {
        if (_this2.isLoggedIn) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_mutex__["b" /* waitForStatusReady */])();
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
      }).then(function () {
        _this2.isWaiting = false;
        // contract does not modify tradeOptions, is simply used as a widget somewhere
        if (_this2.forCmsWidget) {
          _this2.$emit('contractClicked', { contractId: contractId, operationType: operationType, operationValue: operationValue });
          return;
        }

        if (_this2.isMarketJourneyDisabled) return;
        if (activateButton) {
          _this2.activeButton = activateButton;
        }
        _this2.pushSessionHistoryContract({
          value: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this2.contract, {
            marketName: _this2.market.marketShortName || _this2.market.marketName
          })
        });
        _this2.setTradeOptions({
          contractId: contractId,
          operationType: operationType,
          operationValue: operationValue !== null ? operationValue : _this2.contractModel.mode || VALUES.YES
        });
      });
    }
  })
});

/***/ }),

/***/ "d1aY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d2fJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountWithdrawalLoader_vue__ = __webpack_require__("6iuM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4d73298_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountWithdrawalLoader_vue__ = __webpack_require__("5v01");
function injectStyle (ssrContext) {
  __webpack_require__("9poZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountWithdrawalLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4d73298_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountWithdrawalLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d3y4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getMarket: function getMarket(marketId) {
    var commentThreadId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (commentThreadId) {
      return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '?commentThreadId=' + commentThreadId);
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId);
  },
  getCommentThread: function getCommentThread(_ref) {
    var marketId = _ref.marketId,
        threadId = _ref.threadId;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '/CommentThread/' + threadId);
  },
  getMarketTopComments: function getMarketTopComments(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '/TopComments');
  },
  getMarketRules: function getMarketRules(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '/Rule');
  },
  getContract: function getContract(contractId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/Contract/' + contractId);
  },
  getRelatedContracts: function getRelatedContracts(contractId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + contractId + '/RelatedContracts');
  },
  getMarketContracts: function getMarketContracts(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '/Contracts');
  },
  getMarketContractsStats: function getMarketContractsStats(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '/Contracts/Stats');
  },
  getMarketRelated: function getMarketRelated(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '/Related');
  },
  getMarketRelatedProducts: function getMarketRelatedProducts(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('/api/Market/' + marketId + '/RelatedProducts');
  }
});

/***/ }),

/***/ "dCA5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dDJX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_info_v2_js__ = __webpack_require__("v01n");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_info_v2_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_774ba748_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_info_v2_vue__ = __webpack_require__("Jub8");
function injectStyle (ssrContext) {
  __webpack_require__("D9Sb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_info_v2_js__["b" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_774ba748_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_info_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dI8L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_notifications__ = __webpack_require__("tjp7");





/* eslint-disable max-len */





var DEFAULT_SEARCH = {
  data: [],
  page: 0,
  totalCount: 0,
  canLoadMore: true
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    searchBarVisible: false,
    hasSearched: false,
    searchQuery: '',
    searchResults: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_SEARCH)
  },
  mutations: {
    toggleSearchBar: function toggleSearchBar(state) {
      state.searchBarVisible = !state.searchBarVisible;
    },
    closeSearchBar: function closeSearchBar(state) {
      state.searchBarVisible = false;
    },
    resetSearchResults: function resetSearchResults(state) {
      state.searchResults = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_SEARCH);
    },
    setSearchResults: function setSearchResults(state, payload) {
      var sourceData = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.searchResults.data));
      var data = __WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy___default()(sourceData.concat(payload.data.markets || []), 'marketId');
      var page = payload.data.page;
      var totalCount = payload.data.totalMarkets;
      var canLoadMore = totalCount > data.length;

      state.searchResults = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.searchResults, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    setHasSearched: function setHasSearched(state, flag) {
      state.hasSearched = flag;
    },
    setSearchQuery: function setSearchQuery(state, query) {
      state.searchQuery = query;
    },
    updateMarketFromNotification: function updateMarketFromNotification(state, data) {
      if (state.searchResults.data) {
        state.searchResults = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.searchResults, {
          data: state.searchResults.data.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_notifications__["a" /* updateMarket */])(market, data);
          })
        });
      }
    },
    updateContractFromNotification: function updateContractFromNotification(state, data) {
      if (state.searchResults.data) {
        state.searchResults = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.searchResults, {
          data: state.searchResults.data.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_notifications__["b" /* updateMarketContracts */])(market, data);
          })
        });
      }
    }
  },
  actions: {
    toggleSearchBar: function toggleSearchBar(_ref) {
      var commit = _ref.commit;

      commit('toggleSearchBar');
    },
    closeSearchBar: function closeSearchBar(_ref2) {
      var commit = _ref2.commit;

      commit('closeSearchBar');
    },
    getSearch: function getSearch(_ref3, query) {
      var state = _ref3.state,
          commit = _ref3.commit;

      if (state.searchResults.canLoadMore) {
        var page = state.searchResults.page + 1;
        return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].browse.getSearch(query, page).then(function (response) {
          commit('setHasSearched', true);
          commit('setSearchResults', {
            page: page,
            data: response.data
          });
          return response.data;
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({ TotalMarkets: 0 });
    },
    resetSearchResults: function resetSearchResults(_ref4, query) {
      var commit = _ref4.commit;

      commit('resetSearchResults');
      commit('setSearchQuery', query);
      if (!query) {
        commit('setHasSearched', false);
      }
    },
    updateMarketFromNotification: function updateMarketFromNotification(_ref5, payload) {
      var commit = _ref5.commit;

      commit('updateMarketFromNotification', payload);
    },
    updateContractFromNotification: function updateContractFromNotification(_ref6, payload) {
      var commit = _ref6.commit;

      commit('updateContractFromNotification', payload);
    }
  }
});

/***/ }),

/***/ "dK2d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_userAgent__ = __webpack_require__("GZXJ");


/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el) {
    if (!__WEBPACK_IMPORTED_MODULE_0__mixins_userAgent__["i" /* isStandalone */] && !__WEBPACK_IMPORTED_MODULE_0__mixins_userAgent__["h" /* isWrapperApp */]) {
      el.setAttribute('target', '_blank');
      el.setAttribute('rel', 'noopener noreferrer');
    }
  }
});

/***/ }),

/***/ "dMVO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_notification_js__ = __webpack_require__("qidN");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_notification_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bcbe727_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_notification_vue__ = __webpack_require__("7P8z");
function injectStyle (ssrContext) {
  __webpack_require__("YF1h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_notification_js__["b" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bcbe727_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["b"] = (Component.exports);


/***/ }),

/***/ "dOsu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_userAgent__["a" /* default */]],
  props: {
    avatar: {},
    theme: {
      type: String,
      default: ''
    },
    radius: {
      type: Number,
      default: 58
    },
    percentage: {
      type: Number,
      default: 5
    },
    progressStrokeColor: {
      type: String,
      default: ''
    },
    backgroundStrokeColor: {
      type: String,
      default: '#e6e6e6'
    },
    showProgress: {
      type: Boolean,
      default: true
    },
    showEdit: {
      type: Boolean,
      default: true
    },
    notificationsCount: {
      type: Number,
      required: false,
      default: -1
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['hasBanner', 'hasMaintenanceMessage', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('app', ['hasServerErrorOccurred']), {
    isRouteActive: function isRouteActive() {
      return this.$route.name === 'portfolio';
    },
    strokeWidth: function strokeWidth() {
      if (this.isRouteActive && this.theme === 'nav-top') return 7;
      return 5;
    },
    size: function size() {
      if (this.theme === 'profile') return this.isLayoutMobile ? 90 : 140;
      if (this.theme === 'markets') return 45;
      if (this.theme === 'nav-top') return 32;
      if (this.theme === 'nav-bottom' && !this.isRouteActive) return 30;
      if (this.theme === 'nav-bottom' && this.isRouteActive) return 30;
      if (this.theme === 'large') return 100;
      if (this.theme === 'leaderboards') return 32;
      if (this.theme === 'mobile-menu') return 32;
      if (this.theme === 'user-profile') return 100;
      return 84;
    },
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {
        'account-social-avatar': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'account-social-avatar--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'account-social-avatar--active', this.isRouteActive), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'account-social-avatar--server-error', this.hasServerErrorOccurred || this.hasMaintenanceMessage || this.hasBanner), _ref;
    },
    imageClassModifiers: function imageClassModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'account-social-avatar__oval': true
      }, 'account-social-avatar__oval--' + this.theme, this.theme);
    },
    imageStyleModifiers: function imageStyleModifiers() {
      return {
        'background-image': 'url(\'' + this.avatar + '\')',
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    labelClassModifiers: function labelClassModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'account-social-avatar__label': true
      }, 'account-social-avatar__label--' + this.theme, this.theme);
    },
    circReference: function circReference() {
      return 2 * Math.PI * this.radius;
    },
    styleModifiers: function styleModifiers() {
      return {
        strokeDashoffset: this.circReference * (1 - this.percentage / 100),
        strokeDasharray: this.circReference,
        stroke: this.progressStrokeColor
      };
    },
    isEditEnabled: function isEditEnabled() {
      // return this.showEdit && !(this.isIos && this.isStandalone);
      return this.showEdit;
    },
    showNotificationsCount: function showNotificationsCount() {
      return this.avatar && this.notificationsCount > 0;
    },
    hasLabel: function hasLabel() {
      return !!this.$slots.label;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    onShowEditPopup: function onShowEditPopup() {
      if (this.isEditEnabled) this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_modals_constants__["a" /* MODALS */].SMALL_EDIT_IMAGE);
    }
  })
});

/***/ }),

/***/ "dR6M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers,on:{"click":_vm.onContractClick,"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseLeave}},[_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__header"},[_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__image-title",class:{
        'market-contract-horizontal-sushi-common-betslip__image-title--disabled-desktop-market-page': _vm.isLayoutDesktop && _vm.isMarketDisabled && !_vm.forCmsWidget && !_vm.dashboardMode
      }},[(!_vm.isCondensedMobileLayout)?_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__image",style:(_vm.contractImageStyleModifiers)},[(_vm.showSharesBar)?_c('div',{class:_vm.sharesOwnedStyleModifiers}):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__title"},[_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__title-text"},[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")])]),_vm._v(" "),(_vm.isLayoutDesktop || (_vm.isLayoutMobile && (!_vm.isMarketDisabled || _vm.forCmsWidget)))?_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__last-trade"},[(_vm.showNoPriceHintTitle)?_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__last-trade-price-title"},[_vm._v("\n          "+_vm._s(_vm.noPriceHintTitle)+"\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__last-trade-price",class:{ 'market-contract-horizontal-sushi-common-betslip__last-trade-price--align-right': (_vm.isStandardMobileLayout || _vm.isSimplifiedMobileLayout) }},[(_vm.currentPrice > 0)?[(_vm.showChangePriceIndicator && _vm.isStandardMobileLayout)?_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice,"symbol":_vm.currentPriceSymbol}}):_vm._e(),_vm._v(" "),_c('animated-number',{staticClass:"market-contract-horizontal-sushi-common-betslip__last-trade-price-value",attrs:{"value":_vm.currentPrice,"symbol":_vm.currentPriceSymbol}}),_vm._v(" "),(_vm.showChangePriceIndicator && !_vm.isStandardMobileLayout)?_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice,"symbol":_vm.currentPriceSymbol}}):_vm._e()]:[(_vm.forCmsWidget)?_c('span',[_vm._v(" ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"market-contract-horizontal-sushi-common-betslip__last-trade-price-new"},[_vm._v("NEW")])]],2)]):_vm._e(),_vm._v(" "),(_vm.isLayoutMobile && _vm.isMarketDisabled && !_vm.forCmsWidget)?_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__outcome"},[_c('market-disabled-outcome-v2',{attrs:{"market":_vm.market,"contract":_vm.contract}})],1):_vm._e()]),_vm._v(" "),(!_vm.hideButtons)?_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__ownership-buttons",class:{
        'market-contract-horizontal-sushi-common-betslip__ownership-buttons--disabled': _vm.isMarketDisabled
      }},[(_vm.showSharesBarBottom || (_vm.isLayoutDesktop && _vm.isMarketDisabled))?_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__ownership"},[_vm._v("\n          ")]):(_vm.isLayoutMobile && !_vm.isCondensedMobileLayout)?_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__empty-space"}):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop && _vm.isMarketDisabled)?_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__outcome"},[_c('market-disabled-outcome-v2',{attrs:{"market":_vm.market,"contract":_vm.contract}})],1):_vm._e(),_vm._v(" "),(!_vm.isMarketDisabled)?_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__buttons"},[_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__buttons--left"},[(_vm.contractModel.mode === _vm.VALUES.NO)?[_c('button',{staticClass:"market-contract-horizontal-sushi-common-betslip__button-single market-contract-horizontal-sushi-common-betslip__button-single--buy-no",class:_vm.isButtonActiveClassModifiers(_vm.BUTTONS.BUY_NO.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.BUY_NO.type, _vm.BUTTONS.BUY_NO.value)}}},[_c('button-price',{key:_vm.contractModel.buyNoCostAsCents,staticClass:"market-contract-horizontal-sushi-common-betslip__button-price",attrs:{"price":_vm.contractModel.buyNoCostAsCents,"active":_vm.showActiveButtonSecondaryPrice,"win":_vm.contractModel.sellYesCostAsCents,"text":"NO"}})],1)]:(_vm.contractModel.mode === _vm.VALUES.YES)?[_c('button',{staticClass:"market-contract-horizontal-sushi-common-betslip__button-single market-contract-horizontal-sushi-common-betslip__button-single--buy-yes",class:_vm.isButtonActiveClassModifiers(_vm.BUTTONS.BUY_YES.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.BUY_YES.type, _vm.BUTTONS.BUY_YES.value)}}},[_c('button-price',{key:_vm.contractModel.buyYesCostAsCents,staticClass:"market-contract-horizontal-sushi-common-betslip__button-price",attrs:{"price":_vm.contractModel.buyYesCostAsCents,"active":_vm.showActiveButtonSecondaryPrice,"win":_vm.contractModel.sellNoCostAsCents,"text":"YES"}})],1)]:[_c('button',{staticClass:"market-contract-horizontal-sushi-common-betslip__button-single market-contract-horizontal-sushi-common-betslip__button-single--buy-yes",class:_vm.isButtonActiveClassModifiers(_vm.BUTTONS.BUY_YES.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.BUY_YES.type, _vm.BUTTONS.BUY_YES.value)}}},[_c('button-price',{key:_vm.contractModel.buyYesCostAsCents,staticClass:"market-contract-horizontal-sushi-common-betslip__button-price",attrs:{"price":_vm.contractModel.buyYesCostAsCents,"win":_vm.contractModel.sellNoCostAsCents,"active":_vm.showActiveButtonSecondaryPrice,"text":"YES"}})],1)]],2),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi-common-betslip__buttons--right"},[(_vm.contractModel.mode === _vm.VALUES.NO)?[_c('button',{staticClass:"market-contract-horizontal-sushi-common-betslip__button-single market-contract-horizontal-sushi-common-betslip__button-single--sell-no",class:[_vm.isButtonActiveClassModifiers(_vm.BUTTONS.SELL_NO.id), { 'market-contract-horizontal-sushi-common-betslip__button-single--sell-disabled': _vm.isContractSaleDisabled }],attrs:{"data-tooltip":_vm.isContractSaleDisabled ? _vm.sellDisabledTooltipText : null},on:{"click":function($event){$event.stopPropagation();!_vm.isContractSaleDisabled && _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.SELL_NO.type, _vm.BUTTONS.SELL_NO.value)}}},[_c('button-price',{key:_vm.contractModel.sellNoCostAsCents,staticClass:"market-contract-horizontal-sushi-common-betslip__button-price",attrs:{"price":_vm.contractModel.sellNoCostAsCents,"active":_vm.showActiveButtonSecondaryPrice,"text":"Sell"}})],1)]:(_vm.contractModel.mode === _vm.VALUES.YES)?[_c('button',{staticClass:"market-contract-horizontal-sushi-common-betslip__button-single market-contract-horizontal-sushi-common-betslip__button-single--sell-yes",class:[_vm.isButtonActiveClassModifiers(_vm.BUTTONS.SELL_YES.id), { 'market-contract-horizontal-sushi-common-betslip__button-single--sell-disabled': _vm.isContractSaleDisabled }],attrs:{"data-tooltip":_vm.isContractSaleDisabled ? _vm.sellDisabledTooltipText : null},on:{"click":function($event){$event.stopPropagation();!_vm.isContractSaleDisabled && _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.SELL_YES.type, _vm.BUTTONS.SELL_YES.value)}}},[_c('button-price',{key:_vm.contractModel.sellYesCostAsCents,staticClass:"market-contract-horizontal-sushi-common-betslip__button-price",attrs:{"price":_vm.contractModel.sellYesCostAsCents,"active":_vm.showActiveButtonSecondaryPrice,"text":"Sell"}})],1)]:[_c('button',{staticClass:"market-contract-horizontal-sushi-common-betslip__button-single market-contract-horizontal-sushi-common-betslip__button-single--buy-no",class:_vm.isButtonActiveClassModifiers(_vm.BUTTONS.BUY_NO.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.BUY_NO.type, _vm.BUTTONS.BUY_NO.value)}}},[_c('button-price',{key:_vm.contractModel.buyNoCostAsCents,staticClass:"market-contract-horizontal-sushi-common-betslip__button-price",attrs:{"price":_vm.contractModel.buyNoCostAsCents,"win":_vm.contractModel.sellYesCostAsCents,"active":_vm.showActiveButtonSecondaryPrice,"text":"NO"}})],1)]],2)]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.showOwnershipAndOrdersSummary)?_c('market-ownership-and-orders-bar',{staticClass:"market-contract-horizontal-sushi-common-betslip__ownership-and-orders",class:{
      'market-contract-horizontal-sushi-common-betslip__ownership-and-orders--condensed': _vm.isCondensedMobileLayout,
      'market-contract-horizontal-sushi-common-betslip__ownership-and-orders--dashboard': _vm.dashboardMode,
      'market-contract-horizontal-sushi-common-betslip__ownership-and-orders--disabled-market-mobile': (_vm.isMarketDisabled && !_vm.dashboardMode && _vm.isLayoutMobile),
      'market-contract-horizontal-sushi-common-betslip__ownership-and-orders--disabled-market-mobile-dashboard': (_vm.isMarketDisabled && _vm.dashboardMode && _vm.isLayoutMobile)

    },attrs:{"contract":_vm.contract,"symbol":_vm.currentPriceSymbol}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dSDn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header"},[_c('div',{staticClass:"app-header__content"},[_c('div',{staticClass:"app-header__logo"},[_c('router-link',{attrs:{"to":{name: 'home'},"id":"pl-logo"}},[_c('img',{attrs:{"src":__webpack_require__("Kcew")}})])],1),_vm._v(" "),_c('div',{staticClass:"app-header__nav"},[_c('app-main-nav')],1),_vm._v(" "),_c('div',{staticClass:"app-header__side"},[(_vm.isLoggedIn)?_c('div',{class:_vm.notificationsIconModifiers,on:{"click":function($event){$event.stopPropagation();return _vm.onNotificationsClick($event)}}},[(_vm.showUnreadNotificationCount)?_c('div',{staticClass:"app-header__notifications-count"},[_vm._v("\n          "+_vm._s(_vm.userUnreadNotificationsCountHeader)+"\n        ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"app-header__notifications-widget"}},[(_vm.showNotificationsWidget)?_c('div',{staticClass:"app-header__notifications-widget"},[_c('notifications-widget')],1):_vm._e()]),_vm._v(" "),(_vm.isLayoutMobile)?_c('hamburger-icon',{staticClass:"app-header__burger"}):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('div',{staticClass:"app-header__menu"},[(_vm.isLoggedIn && _vm.showBalanceHeader)?[_c('router-link',{staticClass:"app-header__menu-item app-header__menu-item--investment app-header__menu-item--border-right",attrs:{"id":"investment","tag":"div","to":{ name: 'portfolio' }}},[_c('div',{directives:[{name:"price-display",rawName:"v-price-display.floor.fixedflex",value:(_vm.balance.portfolioBalanceDecimal),expression:"balance.portfolioBalanceDecimal",modifiers:{"floor":true,"fixedflex":true}}],staticClass:"app-header__menu-item-value"}),_vm._v(" "),_c('div',{staticClass:"app-header__menu-item-text"},[_vm._v("Investment")])]),_vm._v(" "),_c('div',{staticClass:"app-header__menu-item app-header__menu-item--cash app-header__menu-item--border-right",attrs:{"id":"cash"},on:{"click":function($event){$event.preventDefault();return _vm.onCashClick($event)}}},[_c('div',{directives:[{name:"price-display",rawName:"v-price-display.floor.fixedflex",value:(_vm.balance.accountBalanceDecimal),expression:"balance.accountBalanceDecimal",modifiers:{"floor":true,"fixedflex":true}}],staticClass:"app-header__menu-item-value"}),_vm._v(" "),_c('div',{staticClass:"app-header__menu-item-text"},[_vm._v("Cash")])]),_vm._v(" "),_c('div',{class:_vm.depositClassModifiers,attrs:{"id":"nav-deposit"},on:{"click":function($event){$event.preventDefault();return _vm.openDepositPopup($event)}}},[_c('div',{staticClass:"app-header__menu-item-icon app-header__menu-item-icon--deposit app-header__menu-item--border-right"}),_vm._v(" "),_c('div',{staticClass:"app-header__menu-item-text"},[_vm._v("Deposit")])])]:(!_vm.isLoggedIn)?[_c('header-search'),_vm._v(" "),(!_vm.isUserRestricted)?_c('div',{staticClass:"app-header__menu-item app-header__menu-item--register app-header__menu-item--border-right",attrs:{"id":"signup"},on:{"click":_vm.onSignUp}},[_c('div',[_vm._v("SIGN UP")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-header__menu-item app-header__menu-item--login",attrs:{"id":"login"},on:{"click":_vm.onLogin}},[_c('div',[_vm._v("LOGIN")])])]:_vm._e(),_vm._v(" "),(!_vm.isUserRestricted && _vm.isLoggedIn)?_c('div',{staticClass:"app-header__menu-item app-header__menu-item--search",attrs:{"id":"search"},on:{"click":_vm.toggleSearchBar}},[_c('div',{staticClass:"app-header__menu-item-icon app-header__menu-item-icon--search"}),_vm._v(" "),_c('div',{staticClass:"app-header__menu-item-text"},[_vm._v("Search")])]):_vm._e()],2):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dSN9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dSZ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");



 /**
                                * reCAPTCHA v3 + v2 Fallback Service
                                *
                                * Primary: Uses invisible reCAPTCHA v3 (no user interaction)
                                * Fallback: When v3 score fails, allows v2 challenge modal
                                */




var v3SiteKey = null;
var v2SiteKey = null;
var grecaptchaInstance = null;

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * Initialize the v3 reCAPTCHA script
   * @returns {Promise<object>} The grecaptcha instance
   */
  initV3: function initV3() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var scriptUrl;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(grecaptchaInstance && v3SiteKey)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return', grecaptchaInstance);

            case 2:
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].account.getCaptchaSiteKeyV3().then(function (r) {
                return r.data;
              });

            case 4:
              v3SiteKey = _context.sent;
              scriptUrl = 'https://www.google.com/recaptcha/api.js?render=' + v3SiteKey;
              _context.next = 8;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["f" /* loadScript */])(scriptUrl, 'grecaptcha');

            case 8:
              grecaptchaInstance = _context.sent;
              return _context.abrupt('return', grecaptchaInstance);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  /**
   * Execute invisible v3 reCAPTCHA and get token
   * @param {string} action - The action name for scoring (e.g., 'login', 'register')
   * @returns {Promise<string>} The reCAPTCHA token
   */
  executeV3: function executeV3(action) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var grecaptcha;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.initV3();

            case 2:
              grecaptcha = _context2.sent;
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                grecaptcha.ready(function () {
                  grecaptcha.execute(v3SiteKey, { action: action }).then(resolve);
                });
              }));

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },


  /**
   * Get the v2 site key for fallback challenge modal
   * @returns {Promise<string>} The v2 site key
   */
  getV2SiteKey: function getV2SiteKey() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (v2SiteKey) {
                _context3.next = 4;
                break;
              }

              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].account.getCaptchaSiteKey().then(function (r) {
                return r.data;
              });

            case 3:
              v2SiteKey = _context3.sent;

            case 4:
              return _context3.abrupt('return', v2SiteKey);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },


  /**
   * Check if an error response indicates v3 score failed and v2 challenge is needed
   * @param {object} error - Axios error object
   * @returns {boolean} True if v2 challenge is required
   */
  isV3ScoreFailure: function isV3ScoreFailure(error) {
    // Check for OAuth token endpoint error format
    var oauthError = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(error, 'response.data.error');
    if (oauthError === 'recaptcha_challenge_required') {
      return true;
    }
    // Check for standard API error format
    var data = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(error, 'response.data', []);
    if (Array.isArray(data)) {
      return data.some(function (e) {
        return e.code === 'recaptcha_challenge_required';
      });
    }
    return false;
  }
});

/***/ }),

/***/ "dcEQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_overview_map_overview_map_contract_overview_map_contract_vue__ = __webpack_require__("YHd0");








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  components: {
    overviewMapContract: __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_overview_map_overview_map_contract_overview_map_contract_vue__["a" /* default */]
  },
  props: {
    mapOverviewData: {},
    type: {
      type: String,
      default: 'electoral'
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), {
    num: function num() {
      return 2;
    },
    dummyComponents: function dummyComponents() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_range___default()(0, this.num);
    },
    items: function items() {
      return this.mapOverviewData.slice(0, this.num);
    }
  }),
  methods: {
    mapOverviewDataHandler: function mapOverviewDataHandler(value) {
      if (value.length > 0) {
        this.isComponentReady = true;
      }
    }
  },
  watch: {
    mapOverviewData: {
      handler: 'mapOverviewDataHandler',
      immediate: true
    }
  }
});

/***/ }),

/***/ "dh9S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__("c/9r");




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('browse', ['userBrowseHeaders']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('browse', ['showNavBrowseOverlay'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['toggleNavBrowseCategoriesOverlay']), {
    closeOverlay: function closeOverlay() {
      this.toggleNavBrowseCategoriesOverlay();
    }
  }),
  watch: {
    showNavBrowseOverlay: function showNavBrowseOverlay(value) {
      if (value) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["m" /* lockModal */])();
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["n" /* unLockModal */])();
      }
    }
  }
});

/***/ }),

/***/ "dimc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_errors_js__ = __webpack_require__("zNKi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ed38a6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_errors_vue__ = __webpack_require__("JD5z");
function injectStyle (ssrContext) {
  __webpack_require__("f9W8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_errors_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ed38a6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_errors_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "drLe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__ = __webpack_require__("GOBe");






var BALANCE_THRESHOLD = 0;
var DONT_SHOW_LOGIN_AND_SIGN_UP_BUTTONS_ROUTES = ['account-page-login', 'account-page-register', 'account-password-forgotten', 'index1', 'index2'];

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn', 'isUserRestricted']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('wallet', ['balance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['settings']), {
    showLoginAndSignUpButtons: function showLoginAndSignUpButtons() {
      return !DONT_SHOW_LOGIN_AND_SIGN_UP_BUTTONS_ROUTES.includes(this.$route.name);
    },
    showBalanceHeader: function showBalanceHeader() {
      return this.settings.display ? this.settings.display.ShowBalanceHeader : true;
    },
    notifyOnLowBalance: function notifyOnLowBalance() {
      return this.balance.accountBalanceDecimal <= BALANCE_THRESHOLD;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['closeMobileMenu']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setSideNotification', 'toggleNotificationsWidget']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('search', ['toggleSearchBar', 'closeSearchBar']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onCashClick: function onCashClick() {
      this.closeMobileMenu();
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_modals_constants__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
        return;
      } else if (!this.isUserVerified) {
        this.showAccountVerifyPopup();
        return;
      }
      this.$router.push({ name: 'wallet' });
    },
    onInvestmentClick: function onInvestmentClick() {
      this.closeMobileMenu();
      this.$router.push({ name: 'portfolio' });
    },
    onSignUp: function onSignUp() {
      this.closeMobileMenu();
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_modals_constants__["a" /* MODALS */].REGISTER);
    },
    onLogin: function onLogin() {
      this.closeMobileMenu();
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_modals_constants__["a" /* MODALS */].LOGIN);
    },
    openDepositPopup: function openDepositPopup() {
      if (!this.hasUserClassicEnabled) {
        this.closeMobileMenu();
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_modals_constants__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
      } else if (this.isUserVerified) {
        if (this.$route.name !== 'wallet') {
          this.closeMobileMenu();
          this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_modals_constants__["a" /* MODALS */].ADD_FUNDS);
        }
      } else {
        this.closeMobileMenu();
        this.showAccountVerifyPopup();
      }
    },
    onAvatarClick: function onAvatarClick() {
      this.$router.push({ name: 'portfolio' });
    }
  })
});

/***/ }),

/***/ "drjh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring__ = __webpack_require__("1nuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__ = __webpack_require__("Moaq");

/* eslint-disable */







var refreshSubscribers = [];
var isRefreshing = false;

function tokenRefreshSubscribe(cb) {
  refreshSubscribers.push(cb);
}

function tokenRefreshComplete(token) {
  refreshSubscribers.map(function (cb) {
    return cb(token);
  });
  refreshSubscribers = [];
}

var skipFromInterceptor = ['api/Account/UploadUserImage', 'api/Support/Ticket', 'api/Profile/SetUserAffiliations', 'api/Profile/RemoveUserAffiliations', "/" + 'api/Account/UploadUserImage', "/" + 'api/Support/Ticket', "/" + 'api/Profile/SetUserAffiliations', "/" + 'api/Profile/RemoveUserAffiliations'];

function checkRequest(request) {
  return request.method === 'post' && skipFromInterceptor.indexOf(request.url) === -1;
}

/* harmony default export */ __webpack_exports__["a"] = (function (request) {
  if (checkRequest(request)) {
    request.data = __WEBPACK_IMPORTED_MODULE_2_querystring___default.a.stringify(request.data);
  }
  if (!__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['user/isLoggedIn']) return request;

  var expiresAt = __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get('tokenExpires', null);
  var threshold = -60;
  var expiresOrIsAboutToExpires = expiresAt === null || __WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(expiresAt), 'seconds') > threshold;

  if (expiresOrIsAboutToExpires && !isRefreshing) {
    isRefreshing = true;
    var payload = {
      grant_type: 'refresh_token',
      refresh_token: __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get('refreshToken')
    };
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('user/login', payload).then(function () {
      isRefreshing = false;
      __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[TOKEN] REFRESHED');
      tokenRefreshComplete(__WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get('token'));
    }).catch(function () {
      isRefreshing = false;
      __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[TOKEN] CANNOT REFRESH');
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('user/clearAuthSession');
      tokenRefreshComplete(null);
    });

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      tokenRefreshSubscribe(function (token) {
        if (token) {
          request.headers.Authorization = 'Bearer ' + token;
        } else if (request.headers) {
          delete request.headers.Authorization;
          if (request.headers.common) {
            delete request.headers.common.Authorization;
          }
        }
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[TOKEN] Retry');
        resolve(request);
      });
    });
  }

  return request;
});

/***/ }),

/***/ "dx0n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dxV0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_link_js__ = __webpack_require__("bbNg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e09f9a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_link_vue__ = __webpack_require__("svCT");
function injectStyle (ssrContext) {
  __webpack_require__("naY1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_link_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e09f9a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e0++":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_document_to_review_js__ = __webpack_require__("o3i4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43091980_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_document_to_review_vue__ = __webpack_require__("MI6U");
function injectStyle (ssrContext) {
  __webpack_require__("q3Wh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_document_to_review_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43091980_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_document_to_review_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e1V1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e69X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e7+2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eFwA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    },
    forCmsWidget: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showMenu: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['settingShowOdds'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['setSettingShowOdds']), {
    onMenuToggle: function onMenuToggle() {
      if (this.forCmsWidget) return;
      this.showMenu = !this.showMenu;
    },
    onClickOutside: function onClickOutside() {
      this.showMenu = false;
    },
    setOddsMode: function setOddsMode(value) {
      this.setSettingShowOdds(value);
      this.showMenu = false;
    }
  })
});

/***/ }),

/***/ "eGtO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_processing_transaction_js__ = __webpack_require__("vJHd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_038c8f8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processing_transaction_vue__ = __webpack_require__("+j07");
function injectStyle (ssrContext) {
  __webpack_require__("F06B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_processing_transaction_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_038c8f8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processing_transaction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eVJx":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "eb91":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_list_item_v2_market_list_item_v2_vue__ = __webpack_require__("tPuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */]],
  props: {
    num: {
      type: Number,
      default: 3
    }
  },
  components: {
    marketListItem: __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_list_item_v2_market_list_item_v2_vue__["a" /* default */],
    swiper: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    var _this = this;

    return {
      activeIndex: 0,
      swiperOptions: {
        slidesPerView: 1,
        direction: 'horizontal',
        spaceBetween: 0,
        onTransitionStart: function onTransitionStart(swp) {
          _this.activeIndex = swp.activeIndex;
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('browse', ['newArrivalMarkets']), {
    title: function title() {
      return 'New Arrivals';
    },
    items: function items() {
      return this.newArrivalMarkets;
    },
    isPrevArrowDisabled: function isPrevArrowDisabled() {
      return this.activeIndex === 0;
    },
    isNextArrowDisabled: function isNextArrowDisabled() {
      return this.items.length === 0 || this.activeIndex === this.num - 1;
    },
    prevArrowModifiers: function prevArrowModifiers() {
      return {
        'most-predicted__header-arrow': true,
        'most-predicted__header-arrow--left': true,
        'most-predicted__header-arrow--disabled': this.isPrevArrowDisabled
      };
    },
    nextArrowModifiers: function nextArrowModifiers() {
      return {
        'most-predicted__header-arrow': true,
        'most-predicted__header-arrow--right': true,
        'most-predicted__header-arrow--disabled': this.isNextArrowDisabled
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getNewArrivalMarkets']), {
    prevSlide: function prevSlide() {
      if (!this.isPrevArrowDisabled) this.$refs.swiper.swiper.slidePrev();
    },
    nextSlide: function nextSlide() {
      if (!this.isNextArrowDisabled) this.$refs.swiper.swiper.slideNext();
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    var payload = {
      limit: this.num
    };

    this.loaderAdd();

    this.getNewArrivalMarkets(payload).then(function () {
      _this2.loaderRemove();
      _this2.isComponentReady = true;
    }).catch(function () {
      return _this2.loaderRemove();
    });
  }
});

/***/ }),

/***/ "ed4I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_switch_button_js__ = __webpack_require__("W82P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb742ad8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_switch_button_vue__ = __webpack_require__("f/U3");
function injectStyle (ssrContext) {
  __webpack_require__("dCA5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_switch_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb742ad8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_switch_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "edJ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(!_vm.isComponentReady)?_c('preview-carousel-loader'):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNav),expression:"showNav"}],class:_vm.tabsClassModifiers},[(_vm.showNavigationArrows)?_c('button',{staticClass:"preview-carousel__arrow preview-carousel__arrow--left",attrs:{"disabled":!_vm.canScrollLeft,"aria-label":"Scroll left"},on:{"click":_vm.scrollLeft}}):_vm._e(),_vm._v(" "),_c('div',{ref:"tabsList",staticClass:"preview-carousel__nav-container"},[_c('tabs',{attrs:{"items":_vm.navigationTabs,"theme":"carousel","activeTab":_vm.activeTab},on:{"tabChange":_vm.navigationTabChange},nativeOn:{"click":function($event){return _vm.tabsClicked($event)}}})],1),_vm._v(" "),(_vm.showNavigationArrows)?_c('button',{staticClass:"preview-carousel__arrow preview-carousel__arrow--right",attrs:{"disabled":!_vm.canScrollRight,"aria-label":"Scroll right"},on:{"click":_vm.scrollRight}}):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isComponentReady),expression:"isComponentReady"}],ref:"content",class:_vm.contentClassModifiers,style:(_vm.contentStyleModifiers)},_vm._l((_vm.storyMap),function(data,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(parseInt(index, 10) === _vm.currentStoryIndex),expression:"parseInt(index, 10) === currentStoryIndex"}],key:(_vm.refreshIndex + "-" + index),staticClass:"preview-carousel__story"},[_c('div',{staticClass:"preview-carousel__story-html",domProps:{"innerHTML":_vm._s(_vm.storyContentMap[index])}})])}),0),_vm._v(" "),(_vm.showExpandControl)?_c('div',{class:_vm.expandClassModifiers,on:{"click":_vm.toggleExpand}},[(!_vm.isExpanded)?_c('span',[_vm._v("Read More ▾")]):_c('span',[_vm._v("Show Less ▴")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "egIo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-info-loader"},[_c('div',{staticClass:"contract-info-loader__image"}),_vm._v(" "),_c('div',{staticClass:"contract-info-loader__content"},[_c('div',{staticClass:"contract-info-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"contract-info-loader__text-2"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ei5i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select",class:_vm.selectModifiers},[(_vm.disabled)?_c('div',{staticClass:"select__disabled"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"select__placeholder"},[_vm._v(_vm._s(_vm.placeholder)),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('multiselect',{attrs:{"adjust":_vm.adjust,"value":_vm.value,"show-no-results":_vm.showNoResults,"options":_vm.options,"track-by":_vm.trackBy,"label":_vm.label,"placeholder":"","show-labels":false,"searchable":_vm.searchable,"allow-empty":false,"max-height":_vm.maxHeight,"custom-label":_vm.customLabel,"tabindex":_vm.tabindex},on:{"close":function (e) { return _vm.$emit('close', e); },"select":function (e) { return _vm.$emit('select', e); },"input":_vm.updateValue}},[_c('div',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v("No elements found.")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "emeG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-header"},[(_vm.isLayoutDesktop)?_c('div',{staticClass:"charts-header--clear"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"charts-header--right"},[(_vm.showDownload)?_c('div',{staticClass:"charts-header__download",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onDownload($event)}}},[_c('div',{staticClass:"charts-header__download-icon"})]):_vm._e()])]):_vm._e(),_vm._v(" "),(false)?_c('div',{staticClass:"charts-header--clear"},[_vm._m(1),_vm._v(" "),_vm._m(2)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-header--left"},[_c('div',{staticClass:"charts-header__logo"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-header--left"},[_vm._v("\n      Volume "),_c('img',{attrs:{"src":__webpack_require__("Z4oj")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-header--right"},[_c('img',{attrs:{"src":__webpack_require__("7wmZ")}}),_vm._v(" Price\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "epoI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"most-predicted-list"},[_c('div',{staticClass:"most-predicted-list__header"},[_c('div',{staticClass:"most-predicted-list__header-title"},[_vm._v("New Arrivals")]),_vm._v(" "),_vm._t("pin"),_vm._v(" "),(_vm.isLayoutMobile)?_c('div',{staticClass:"most-predicted-list__header-arrows"},[_c('span',{class:_vm.prevArrowModifiers,on:{"click":_vm.prevSlide}}),_vm._v(" "),_c('span',{class:_vm.nextArrowModifiers,on:{"click":_vm.nextSlide}})]):_vm._e()],2),_vm._v(" "),(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader"},_vm._l((_vm.dummyComponents),function(index){return _c('div',{key:index,staticClass:"content-loader-item"},[_c('market-loader')],1)}),0):_c('div',{staticClass:"most-predicted-list__content"},[(_vm.isLayoutDesktop)?_vm._l((_vm.items),function(market){return _c('market-list-item',{key:market.marketId,staticClass:"most-predicted-list__item",attrs:{"market":market,"theme":"home"}})}):_vm._e(),_vm._v(" "),(_vm.isLayoutMobile)?[_c('swiper',{ref:"swiper",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.items),function(item){return _c('swiper-slide',{key:item.marketId},[_c('market-list-item',{staticClass:"most-predicted-list__item",attrs:{"market":item,"theme":"home"}})],1)}),1)]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "erdd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f+P6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('small-modal',{on:{"modalClose":_vm.close},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("\n    Trade Experience Settings\n  ")]},proxy:true},{key:"content",fn:function(){return [_c('div',{staticClass:"market-settings-modal__menu"},[_vm._l((_vm.settingsModalOptions),function(setting){return _c('div',{key:setting.key,staticClass:"market-settings-modal__option"},[_c('div',{staticClass:"market-settings-modal__label"},[_vm._v("\n          "+_vm._s(setting.info)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"market-settings-modal__inner"},[_c('div',{staticClass:"market-settings-modal__inner-items"},_vm._l((setting.options),function(option){return _c('div',{key:option.key,staticClass:"market-settings-modal__inner-item",class:{
                'market-settings-modal__inner-item--selected': _vm.isSelected(setting.key, option.key),
                'market-settings-modal__inner-item--disabled': _vm.isOptionDisabled(option)
              },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onSettingOptionClick(setting.key, option)}}},[_vm._v("\n              "+_vm._s(option.info)+"\n            ")])}),0)])])}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"button button--large button--black button--full-width",on:{"click":_vm.close}},[_vm._v("\n        Close\n      ")])],2)]},proxy:true}],null,false,2646511922)}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f/U3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-button",class:_vm.isOnModifier,on:{"click":_vm.toggle}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-button__inner"},[_c('div',{staticClass:"switch-button__toggle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f9W8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fFIe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fHHP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:_vm.classModifiers},[_c('div',{staticClass:"app-bottom-nav__menu"},_vm._l((_vm.enabledLinks),function(item){return _c('div',{class:_vm.itemClassModifier(item),on:{"click":function($event){return _vm.onLinkClick(item.href)}}},[(_vm.showRegularItem(item))?_c('router-link',{class:_vm.linkClassModifiers(item.name),attrs:{"id":("nav-" + (item.name)),"to":item.href}},[_vm._v("\n          "+_vm._s(item.title.toString())+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.showSocialAvatarOnMobile(item))?_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.onAvatarClick($event)}}},[_vm._v("\n         \n        "),_c('account-social-avatar',{attrs:{"theme":"nav-bottom","avatar":_vm.userAvatar,"showProgress":true,"percentage":100,"progressStrokeColor":_vm.levelColorWithRespectToNav,"showEdit":false}},[_c('span',{attrs:{"slot":"label"},on:{"click":function($event){$event.stopPropagation();return _vm.onAvatarClick($event)}},slot:"label"},[_vm._v("Dashboard")])])],1):_vm._e()],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fI94":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-funds-combined-footer"},[_c('h4',{staticClass:"add-funds-combined-footer__title"},[_vm._v("\n    Looking for Additional Deposit Methods?\n  ")]),_vm._v(" "),_c('span',{staticClass:"add-funds-combined-footer__link",on:{"click":function($event){$event.preventDefault();return _vm.onGoToWallet($event)}}},[_vm._v("\n    Open Your Wallet\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fZS5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers,style:(_vm.styleModifiers),on:{"click":_vm.onTooltipClick}},[_c('div',{class:_vm.titleClassModifiers,style:(_vm.titleStyleModifiers)},[_vm._v("\n    "+_vm._s(_vm.stateName)+" "),(!_vm.isSenate)?[_vm._v("("+_vm._s(_vm.marketData.stateVotes)),(_vm.showNote)?_c('span',[_vm._v(" STATEWIDE")]):_vm._e(),_vm._v(")")]:(_vm.isSenate && _vm.stateCode === 'GA')?[_vm._v("(REGULAR)")]:(_vm.isSenate && _vm.stateCode === 'GA2')?[_vm._v("(SPECIAL)")]:_vm._e()],2),_vm._v(" "),(_vm.winnerMode)?[_c('div',{staticClass:"market-state-tooltip__winner"},[_c('div',{staticClass:"market-state-tooltip__winner-title"},[_vm._v("\n        "+_vm._s(_vm.targetContract.contractName)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"market-state-tooltip__winner-image",style:(_vm.imageStyleModifiers(_vm.targetContract))}),_vm._v(" "),(_vm.showNote)?_c('div',{staticClass:"market-state-tooltip__winner-name",style:(_vm.winnerBgColorStyleModifiers)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-state-tooltip__winner-price"},[_c('span',{staticClass:"market-state-tooltip__winner-current-price"},[(_vm.targetContractInstance.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":_vm.targetContractInstance.lastTradePriceAsCents}})]:[_vm._v("\n            -\n          ")]],2),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.targetContractInstance.changePriceAsCents,"lastClosePrice":_vm.targetContractInstance.lastClosePrice,"theme":"chart"}})],1)])]:_vm._l((_vm.contracts),function(contract,index){return _c('div',{key:contract.contractId,class:_vm.contractClassModifiers(contract, index)},[_c('div',{staticClass:"market-state-tooltip__contract-image",style:(_vm.imageStyleModifiers(contract))}),_vm._v(" "),_c('div',{staticClass:"market-state-tooltip__contract-info"},[_c('div',{staticClass:"market-state-tooltip__contract-name"},[_vm._v("\n          "+_vm._s(_vm.getNameDisplay(contract))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"market-state-tooltip__contract-price"},[_c('span',{staticClass:"market-state-tooltip__contract-current-price"},[(contract.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":contract.lastTradePriceAsCents}})]:[_vm._v("\n              -\n            ")]],2),_vm._v(" "),_c('market-change-price',{attrs:{"price":contract.changePriceAsCents,"lastClosePrice":contract.lastClosePrice,"theme":"chart"}})],1)])])}),_vm._v(" "),(_vm.showNote)?_c('div',{staticClass:"market-state-tooltip__note"},[_vm._v("\n    See separate markets for individual "),_c('br'),_vm._v("congressional districts in "+_vm._s(_vm.capitalizeFirstLetter(_vm.stateName.toLowerCase()))+".\n  ")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fmhl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_ORDER_BOOK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOTTOM_WIDGET_FOOTER_MODES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_notifications_firebase__ = __webpack_require__("2Pqz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__ = __webpack_require__("Moaq");







// import constants from '@/constants';

var DEFAULT_ORDER_BOOK = {
  noOrders: 0,
  yesOrders: 0
};

function makeTradeOptions() {
  return {
    contractId: null,
    operationType: 'buy', // buy | sell
    operationValue: 'yes', // yes | no
    pricePerShare: null,
    skipConfirmation: __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].get('skipConfirmation', false),
    quantity: null
  };
}

function getPricePerShare(value) {
  var min = 1;
  var max = 99;
  var price = parseInt(value, 10);

  if (price < min) {
    price = min;
  }
  if (price > max) {
    price = max;
  }
  return price;
}

var KEY_BOTTOM_WIDGET_FOOTER_MODE = 'bottom-widget-footer-mode';
var BOTTOM_WIDGET_FOOTER_MODES = {
  BETSLIP: 'betslip',
  PINNED: 'pinned',
  TOGGlE: 'toggle',
  QUICK_SWITCH: 'quick-switch'
};
var BOTTOM_WIDGET_DEFAULT_MODE = BOTTOM_WIDGET_FOOTER_MODES.BETSLIP;
var BOTTOM_WIDGET_KEYS_TO_STORE_IN_LS = [BOTTOM_WIDGET_FOOTER_MODES.BETSLIP, BOTTOM_WIDGET_FOOTER_MODES.PINNED, BOTTOM_WIDGET_FOOTER_MODES.QUICK_SWITCH];

function getStoredBottomWidgetFooterMode() {
  var storedMode = __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].get(KEY_BOTTOM_WIDGET_FOOTER_MODE, null);

  if (BOTTOM_WIDGET_KEYS_TO_STORE_IN_LS.includes(storedMode)) {
    return storedMode;
  }

  return null;
}

var STORED_BOTTOM_WIDGET_FOOTER_MODE = getStoredBottomWidgetFooterMode();
var INITIAL_BOTTOM_WIDGET_FOOTER_MODE = STORED_BOTTOM_WIDGET_FOOTER_MODE || BOTTOM_WIDGET_DEFAULT_MODE;

var REMEMBER_TRADE_DIRECTION = true;
var PREFER_GLOBAL_TRADE_DIRECTION = false;
var GLOBAL_TRADE_DIRECTION_KEY = '__global__';
function tradeDirectionKey(marketId) {
  if (!REMEMBER_TRADE_DIRECTION) return null;
  return PREFER_GLOBAL_TRADE_DIRECTION ? GLOBAL_TRADE_DIRECTION_KEY : marketId;
}

/* harmony default export */ __webpack_exports__["b"] = ({
  namespaced: true,
  getters: {
    tradeDirectionForMarket: function tradeDirectionForMarket(state) {
      return function (marketId) {
        return state.marketTradeDirections[tradeDirectionKey(marketId)];
      };
    }
  },
  state: {
    orderBook: null,
    hidePurchaseForContractId: null,
    contractShares: [],
    contractOffers: [],
    tradeOptions: makeTradeOptions(),
    masterTradeOptions: {},
    marketTradeDirections: {},
    tradeSuccess: false,
    keyboardDoubleSelected: false,
    cancelToggle: false,
    tradeOperationToggle: null,
    isInConfirmationMode: false,
    confirmationDoneData: null,
    confirmationData: null,
    bottomBetslipExtended: false,
    bottomWidgetFooterMode: INITIAL_BOTTOM_WIDGET_FOOTER_MODE,
    bottomWidgetFooterModeContractsSection: INITIAL_BOTTOM_WIDGET_FOOTER_MODE,
    previousBottomWidgetFooterMode: INITIAL_BOTTOM_WIDGET_FOOTER_MODE,
    hasStoredBottomWidgetFooterModePreference: STORED_BOTTOM_WIDGET_FOOTER_MODE !== null
  },
  mutations: {
    toggleHidePurchaseForContractId: function toggleHidePurchaseForContractId(state, contractId) {
      if (state.hidePurchaseForContractId === null) {
        state.hidePurchaseForContractId = contractId;
      } else {
        state.hidePurchaseForContractId = null;
      }
    },
    setOrderBook: function setOrderBook(state, payload) {
      state.orderBook = payload;
    },
    clearOrderBook: function clearOrderBook(state) {
      state.orderBook = null;
    },
    setContractShares: function setContractShares(state, payload) {
      state.contractShares = payload;
    },
    setContractOffers: function setContractOffers(state, payload) {
      state.contractOffers = payload;
    },
    setTradeOptions: function setTradeOptions(state, payload) {
      if (state.tradeOptions !== null && payload !== null && state.tradeOptions.contractId === payload.contractId && state.tradeOptions.operationType === payload.operationType && state.tradeOptions.operationValue === payload.operationValue) {
        state.tradeOptions = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.tradeOptions, payload);
      } else {
        var defaults = makeTradeOptions();
        var pricePerShare = defaults.pricePerShare;
        var skipConfirmation = defaults.skipConfirmation;
        if (payload && state.tradeOptions.contractId === payload.contractId) {
          pricePerShare = state.tradeOptions.pricePerShare;
          skipConfirmation = state.tradeOptions.skipConfirmation || false;
        }
        state.tradeOptions = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, defaults, payload, {
          pricePerShare: pricePerShare,
          skipConfirmation: skipConfirmation
        });
      }

      if (state.tradeOptions && state.tradeOptions.contractId) {
        state.hidePurchaseForContractId = null;
      }
    },
    setTradeSuccess: function setTradeSuccess(state, flag) {
      state.tradeSuccess = flag;
    },
    setTradeSkipConfirmation: function setTradeSkipConfirmation(state, skipConfirmation) {
      var value = !!skipConfirmation;
      var expiresAt = 31536000; // 1 year
      __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set('skipConfirmation', value, expiresAt);
      state.tradeOptions = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.tradeOptions, { skipConfirmation: value });
    },
    updateKeyboardDoubleSelected: function updateKeyboardDoubleSelected(state, selected) {
      state.keyboardDoubleSelected = selected;
    },
    setCancelToggle: function setCancelToggle(state, flag) {
      state.cancelToggle = flag;
    },
    setIsInConfirmationMode: function setIsInConfirmationMode(state, flag) {
      state.isInConfirmationMode = flag;
    },
    setConfirmationData: function setConfirmationData(state, data) {
      state.confirmationData = data;
    },
    setConfirmationDoneData: function setConfirmationDoneData(state, data) {
      state.confirmationDoneData = data;
    },
    toggleTradeOperation: function toggleTradeOperation(state, side) {
      state.tradeOperationToggle = side;
    },
    setBottomWidgetFooterMode: function setBottomWidgetFooterMode(state, value) {
      state.previousBottomWidgetFooterMode = state.bottomWidgetFooterMode;
      state.bottomWidgetFooterMode = value;
    },
    toggleBottomBetslipMode: function toggleBottomBetslipMode(state) {
      state.bottomBetslipExtended = !state.bottomBetslipExtended;
    },
    setBottomWidgetFooterModeContractsSection: function setBottomWidgetFooterModeContractsSection(state, value) {
      if (BOTTOM_WIDGET_KEYS_TO_STORE_IN_LS.includes(value)) {
        __WEBPACK_IMPORTED_MODULE_6__helpers_localStorage__["a" /* default */].set(KEY_BOTTOM_WIDGET_FOOTER_MODE, value);
        state.hasStoredBottomWidgetFooterModePreference = true;
      }
      state.bottomWidgetFooterModeContractsSection = value;
    },
    setTradeQuantity: function setTradeQuantity(state, quantity) {
      state.tradeOptions = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.tradeOptions, { quantity: parseInt(quantity, 10) || null });
    },
    setTradePrice: function setTradePrice(state, pricePerShare) {
      state.tradeOptions = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.tradeOptions, { pricePerShare: pricePerShare });
    },
    setMasterTradeOptions: function setMasterTradeOptions(state, data) {
      state.masterTradeOptions = data;
    },
    setBottomBetSlipExtendedMode: function setBottomBetSlipExtendedMode(state, extended) {
      state.bottomBetslipExtended = extended;
    },
    setMarketTradeDirection: function setMarketTradeDirection(state, _ref) {
      var marketId = _ref.marketId,
          value = _ref.value;

      var key = tradeDirectionKey(marketId);
      if (key == null) return;
      state.marketTradeDirections = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.marketTradeDirections, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, key, value));
    }
  },
  actions: {
    confirmTrade: function confirmTrade(_ref2, payload) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].trade.postConfirmTrade(payload);
    },
    submitTrade: function submitTrade(_ref3, payload) {
      var commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].trade.postSubmitTrade(payload);
    },
    getOrderBook: function getOrderBook(_ref4, contractId) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].trade.getOrderBook(contractId).then(function (response) {
        commit('setOrderBook', response.data);
        return response.data;
      });
    },
    updateOrderBookPeriodically: function updateOrderBookPeriodically(_ref5, contractId) {
      var commit = _ref5.commit;

      __WEBPACK_IMPORTED_MODULE_4__services_notifications_firebase__["c" /* addOrderBookListener */](contractId, function (data) {
        commit('setOrderBook', data);
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(DEFAULT_ORDER_BOOK));
    },
    clearOrderBookUpdates: function clearOrderBookUpdates(_ref6, contractId) {
      var commit = _ref6.commit;

      __WEBPACK_IMPORTED_MODULE_4__services_notifications_firebase__["d" /* clearOrderBookListeners */](contractId);
    },
    clearOrderBook: function clearOrderBook(_ref7) {
      var commit = _ref7.commit;

      commit('clearOrderBook');
    },
    getContractShares: function getContractShares(_ref8, contractId) {
      var commit = _ref8.commit;

      if (contractId === null) {
        commit('setContractShares', []);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve([]);
      }

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].profile.getContractShares(contractId).then(function (response) {
        commit('setContractShares', response.data.shares);
        return response.data.shares;
      });
    },
    getContractOffers: function getContractOffers(_ref9, contractId) {
      var commit = _ref9.commit;

      if (contractId === null) {
        commit('setContractOffers', []);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve([]);
      }

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].profile.getContractOffers(contractId).then(function (response) {
        commit('setContractOffers', response.data.offers);
        return response.data.offers;
      });
    },
    cancelAllOffers: function cancelAllOffers(_ref10, payload) {
      var commit = _ref10.commit;

      var contractId = payload.contractId;
      delete payload.contractId;
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].trade.postCancelAllOffers(contractId, payload).then(function (response) {
        commit('setCancelToggle', true);
        return response.data;
      });
    },
    cancelOffer: function cancelOffer(_ref11, offerId) {
      var commit = _ref11.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].trade.postCancelOffer(offerId).then(function (response) {
        commit('setCancelToggle', true);
        return response.data;
      });
    },
    setCancelToggle: function setCancelToggle(_ref12, flag) {
      var commit = _ref12.commit;

      commit('setCancelToggle', flag);
    },
    setIsInConfirmationMode: function setIsInConfirmationMode(_ref13, flag) {
      var commit = _ref13.commit;

      commit('setIsInConfirmationMode', flag);
    },
    setConfirmationData: function setConfirmationData(_ref14, data) {
      var commit = _ref14.commit;

      commit('setConfirmationData', data);
    },
    setConfirmationDoneData: function setConfirmationDoneData(_ref15, data) {
      var commit = _ref15.commit;

      commit('setConfirmationDoneData', data);
    },
    setTradeOptions: function setTradeOptions(_ref16, payload) {
      var commit = _ref16.commit;

      if (payload === null) {
        commit('setConfirmationData', null);
        commit('setConfirmationDoneData', null);
      }
      commit('setTradeOptions', payload);
    },
    setTradeQuantity: function setTradeQuantity(_ref17, quantity) {
      var commit = _ref17.commit,
          state = _ref17.state;

      commit('setTradeQuantity', quantity);
      commit('setMasterTradeOptions', {
        quantity: quantity,
        pricePerShare: state.tradeOptions.pricePerShare
      });
    },
    setTradePrice: function setTradePrice(_ref18, pricePerShare) {
      var commit = _ref18.commit,
          state = _ref18.state;

      var standardValue = getPricePerShare(pricePerShare);
      commit('setMasterTradeOptions', {
        pricePerShare: standardValue,
        quantity: state.tradeOptions.quantity
      });
      commit('setTradePrice', standardValue);
    },
    setMasterTradeOptions: function setMasterTradeOptions(_ref19, _ref20) {
      var commit = _ref19.commit;
      var quantity = _ref20.quantity,
          pricePerShare = _ref20.pricePerShare;

      commit('setMasterTradeOptions', { quantity: quantity, pricePerShare: pricePerShare });
    },
    setTradeSuccess: function setTradeSuccess(_ref21, flag) {
      var commit = _ref21.commit;

      commit('setTradeSuccess', flag);
    },
    setTradeSkipConfirmation: function setTradeSkipConfirmation(_ref22, skipConfirmation) {
      var commit = _ref22.commit;

      commit('setTradeSkipConfirmation', skipConfirmation);
    },
    toggleTradeOperation: function toggleTradeOperation(_ref23, side) {
      var commit = _ref23.commit;

      commit('toggleTradeOperation', side);
    },
    updateKeyboardDoubleSelected: function updateKeyboardDoubleSelected(_ref24, selected) {
      var commit = _ref24.commit;

      commit('updateKeyboardDoubleSelected', selected);
    },
    getOrderBookTradeInfo: function getOrderBookTradeInfo(_ref25, _ref26) {
      var commit = _ref25.commit;
      var contractId = _ref26.contractId,
          tradeType = _ref26.tradeType,
          price = _ref26.price;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].trade.getOrderBookTradeInfo(contractId, tradeType, price).then(function (response) {
        return response.data;
      });
    },
    setBottomWidgetFooterMode: function setBottomWidgetFooterMode(_ref27, value) {
      var commit = _ref27.commit;

      commit('setBottomWidgetFooterMode', value);
    },
    toggleHidePurchaseForContractId: function toggleHidePurchaseForContractId(_ref28, contractId) {
      var commit = _ref28.commit;

      commit('toggleHidePurchaseForContractId', contractId);
    },
    toggleBottomBetslipMode: function toggleBottomBetslipMode(_ref29) {
      var commit = _ref29.commit;

      commit('toggleBottomBetslipMode');
    },
    setBottomBetSlipExtendedMode: function setBottomBetSlipExtendedMode(_ref30, value) {
      var commit = _ref30.commit;

      commit('setBottomBetSlipExtendedMode', value);
    },
    setBottomWidgetFooterModeContractsSection: function setBottomWidgetFooterModeContractsSection(_ref31, value) {
      var commit = _ref31.commit;

      commit('setBottomWidgetFooterModeContractsSection', value);
    },
    setMarketTradeDirection: function setMarketTradeDirection(_ref32, payload) {
      var commit = _ref32.commit;

      commit('setMarketTradeDirection', payload);
    }
  }
});

/***/ }),

/***/ "fzCn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketLoader_vue__ = __webpack_require__("HPJt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ee7f171_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketLoader_vue__ = __webpack_require__("0syx");
function injectStyle (ssrContext) {
  __webpack_require__("pM6l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ee7f171_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g0D9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_dataLayer__ = __webpack_require__("k37b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_notification_icon_notification_icon_vue__ = __webpack_require__("qIn7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_cards_americanexpress_jpg__ = __webpack_require__("ZFw9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_cards_americanexpress_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_cards_americanexpress_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_cards_discover_jpg__ = __webpack_require__("OGIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_cards_discover_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_cards_discover_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_cards_mastercard_jpg__ = __webpack_require__("MzT2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_cards_mastercard_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_cards_mastercard_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_cards_visa_jpg__ = __webpack_require__("XiJB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_cards_visa_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_cards_visa_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_cards_blank_png__ = __webpack_require__("owqz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_cards_blank_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_cards_blank_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_getValidationMessage__ = __webpack_require__("U7Hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_documentUpload__ = __webpack_require__("9xQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_promoCode__ = __webpack_require__("nPqm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mixins_depositWarningMixin__ = __webpack_require__("Scap");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_wallet_shared_deposit_amount_picker_deposit_amount_picker_vue__ = __webpack_require__("+Rub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_wallet_shared_promo_code_input_promo_code_input_vue__ = __webpack_require__("THaJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_wallet_shared_deposit_info_overview_deposit_info_overview_vue__ = __webpack_require__("DMbv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_wallet_shared_deposit_result_deposit_result_vue__ = __webpack_require__("ny9f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_wallet_shared_deposit_amount_overview_deposit_amount_overview_vue__ = __webpack_require__("j8BG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_wallet_shared_fee_waived_banner_fee_waived_banner_vue__ = __webpack_require__("TBZZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_wallet_shared_fee_status_message_fee_status_message_vue__ = __webpack_require__("7IYw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_wallet_shared_deposit_disclaimer_deposit_disclaimer_vue__ = __webpack_require__("SmIQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_wallet_shared_deposit_done_links_deposit_done_links_vue__ = __webpack_require__("Fem6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_wallet_shared_depositMethodTypes__ = __webpack_require__("LQTn");




var _CARD_IMAGES;
































var DEPOSIT_CHIP_AMOUNTS = [10, 25, 50];

var STEPS = {
  INITIAL: 1,
  CONFIRM: 2,
  TRY_AGAIN: 3,
  SUCCESS: 4
};

var CARD_IMAGES = (_CARD_IMAGES = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CARD_IMAGES, __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].CARDS.AMERICAN_EXPRESS, __WEBPACK_IMPORTED_MODULE_8__assets_images_cards_americanexpress_jpg___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CARD_IMAGES, __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].CARDS.DISCOVER, __WEBPACK_IMPORTED_MODULE_9__assets_images_cards_discover_jpg___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CARD_IMAGES, __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].CARDS.MASTERCARD, __WEBPACK_IMPORTED_MODULE_10__assets_images_cards_mastercard_jpg___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CARD_IMAGES, __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].CARDS.VISA, __WEBPACK_IMPORTED_MODULE_11__assets_images_cards_visa_jpg___default.a), _CARD_IMAGES);

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_15__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__["a" /* formMixin */], __WEBPACK_IMPORTED_MODULE_14__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__mixins_popupPageModeMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__mixins_promoCode__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__mixins_depositWarningMixin__["a" /* default */]],
  validations: function validations() {
    var rules = {
      fields: {
        name: __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__["b" /* validators */].required,
        number: __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__["b" /* validators */].cardNumber,
        expiryDateMonth: __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__["b" /* validators */].required,
        expiryDateYear: __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__["b" /* validators */].required,
        cvv: __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__["b" /* validators */].cvv,
        amount: __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__["b" /* validators */].depositAmountCoinbase(this.minimumDepositAmount, this.maximumDepositAmount)
      }
    };

    if (this.avsFlag) {
      rules.fields.address = __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__["b" /* validators */].required;
      rules.fields.city = __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__["b" /* validators */].required;
      rules.fields.zipCode = __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__["b" /* validators */].validateUSZipCode('country');
    }
    return rules;
  },

  components: {
    notificationIcon: __WEBPACK_IMPORTED_MODULE_5__components_notification_icon_notification_icon_vue__["a" /* default */],
    depositAmountPicker: __WEBPACK_IMPORTED_MODULE_23__components_wallet_shared_deposit_amount_picker_deposit_amount_picker_vue__["a" /* default */],
    promoCodeInput: __WEBPACK_IMPORTED_MODULE_24__components_wallet_shared_promo_code_input_promo_code_input_vue__["a" /* default */],
    depositInfoOverview: __WEBPACK_IMPORTED_MODULE_25__components_wallet_shared_deposit_info_overview_deposit_info_overview_vue__["a" /* default */],
    depositResult: __WEBPACK_IMPORTED_MODULE_26__components_wallet_shared_deposit_result_deposit_result_vue__["a" /* default */],
    depositAmountOverview: __WEBPACK_IMPORTED_MODULE_27__components_wallet_shared_deposit_amount_overview_deposit_amount_overview_vue__["a" /* default */],
    feeWaivedBanner: __WEBPACK_IMPORTED_MODULE_28__components_wallet_shared_fee_waived_banner_fee_waived_banner_vue__["a" /* default */],
    feeStatusMessage: __WEBPACK_IMPORTED_MODULE_29__components_wallet_shared_fee_status_message_fee_status_message_vue__["a" /* default */],
    depositDisclaimer: __WEBPACK_IMPORTED_MODULE_30__components_wallet_shared_deposit_disclaimer_deposit_disclaimer_vue__["a" /* default */],
    depositDoneLinks: __WEBPACK_IMPORTED_MODULE_31__components_wallet_shared_deposit_done_links_deposit_done_links_vue__["a" /* default */]
  },
  data: function data() {
    return {
      depositMethodType: __WEBPACK_IMPORTED_MODULE_32__components_wallet_shared_depositMethodTypes__["a" /* DEPOSIT_METHOD_TYPE */].CREDIT_CARD,
      canDeposit: false,
      step: STEPS.INITIAL,
      years: __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].expiryYears,
      months: __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].months,
      depositAmounts: DEPOSIT_CHIP_AMOUNTS,
      errorMessage: '',
      errorMessageDepositFail: '',
      avsMessage: false,
      avsFlag: false,
      processingFeePercent: 0,
      processingFeeAmount: '0.00',
      totalToWallet: '0.00',
      wasFeeDiscountApplied: false,
      feeFreeAmount: 0,
      feeDiscountEligibility: false,
      feeFreeCap: 0,
      fields: {
        name: '',
        amount: '',
        number: '',
        expiryDateMonth: '',
        expiryDateYear: '',
        cvv: '',
        address: '',
        city: '',
        zipCode: ''
      }
    };
  },
  created: function created() {
    this.initialize();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile', 'isDepositPromoInputBoxEnabled', 'collegeAffiliationEnabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('wallet', ['currentDeposit', 'minimumDepositAmount', 'currentDeposit']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('user', ['status', 'userData', 'ssnInfoVerified', 'twoFactorEnabled']), {
    classModifiers: function classModifiers() {
      return {
        'add-funds-credit-card': true,
        'add-funds-credit-card--popup': this.isPopup,
        'add-funds-credit-card--regular': !this.isPopup
      };
    },
    availableCardTypes: function availableCardTypes() {
      return (this.method.subTypes || []).map(function (i) {
        return i.toLowerCase();
      });
    },
    maximumDepositAmount: function maximumDepositAmount() {
      return 99999;
    },
    accountUploadDocumentTheme: function accountUploadDocumentTheme() {
      return this.isPage ? 'page-padded' : '';
    },
    amountHasError: function amountHasError() {
      return this.$v.fields.amount.$error;
    },
    amountValidationMessage: function amountValidationMessage() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__helpers_getValidationMessage__["a" /* default */])(this.$v.fields.amount);
    },
    cardNumber: function cardNumber() {
      return (this.fields.number || '').replace(/ /g, '');
    },
    cardType: function cardType() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_helpers__["e" /* getCardTypeForNumber */])(this.cardNumber);
    },
    cardTypeHasError: function cardTypeHasError() {
      return this.cardType !== __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].CARDS.BLANK && !this.availableCardTypes.includes(this.cardType);
    },
    cardTypeValidationMessage: function cardTypeValidationMessage() {
      return 'This card is not supported';
    },
    cardTypeImage: function cardTypeImage() {
      return CARD_IMAGES[this.cardType] || __WEBPACK_IMPORTED_MODULE_12__assets_images_cards_blank_png___default.a;
    },
    isConfirmDisabled: function isConfirmDisabled() {
      return this.invalidOrDisabled || !this.canDeposit || this.cardTypeHasError;
    },
    depositPayload: function depositPayload() {
      var payload = {
        cardHoldersName: this.fields.name,
        amount: this.fields.amount,
        cardNumber: this.cardNumber,
        securityCode: this.fields.cvv,
        expirationMonth: this.fields.expiryDateMonth.value,
        expirationYear: this.fields.expiryDateYear.value,
        depositPromoCode: this.promoApplied ? this.promoAppliedCode : '',
        marketingSource: '',
        marketingProgram: '',
        cardType: this.cardType
      };
      if (this.avsFlag) {
        payload.address1 = this.fields.address;
        payload.city = this.fields.city;
        payload.postalCode = this.fields.zipCode;
      }
      return payload;
    },
    cardMasked: function cardMasked() {
      var num = this.cardNumber;
      var last4 = num.length >= 4 ? num.slice(-4) : num;
      var type = this.cardType;
      var label = type && type !== __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].CARDS.BLANK ? type.charAt(0).toUpperCase() + type.slice(1) : 'Card';
      return last4 ? label + ' \u2022\u2022\u2022 ' + last4 : label;
    },
    successAmount: function successAmount() {
      var amount = this.currentDeposit ? this.currentDeposit.amount || 0 : 0;
      return '$' + Number(amount).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('wallet', ['getDepositCard', 'confirmDepositCard', 'submitDepositCard', 'setCurrentDeposit', 'getBalance', 'getDepositMethods']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('popup', ['setGenericPopup', 'setCurrentPopup', 'setCurrentSmallPopup', 'setCurrentPopupOptions', 'setCurrentPopupWithDelay']), {
    initialize: function initialize() {
      var _this = this;

      this.loaderAdd();
      this.getBalance().then(this.getDepositCard).then(function (data) {
        _this.loaderRemove();
        _this.isComponentReady = true;
        _this.checkDocumentUploadFlags(data);
        _this.canDeposit = data.canDeposit;
        _this.errorMessage = data.errorMessage;
        _this.promoCodeDetail = data.promoCodeDetail || {};
        _this.fields.name = data.cardHoldersName;
        _this.avsFlag = data.avsFlag;
        _this.fields.city = data.city || '';
        _this.fields.address = data.address1 || '';
        _this.fields.zipCode = data.postalCode || '';
        _this.fields.country = { value: _this.userData.countryCode };
        _this.processingFeePercent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_helpers__["i" /* roundToTwo */])((data.feePercent || 0) * 100);
        _this.feeDiscountEligibility = !!data.feeDiscountEligibility;
        _this.feeFreeCap = Number(data.feeDiscountCap || 0);
      }).catch(function (error) {
        _this.isComponentReady = true;
        _this.errorMessage = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(error, 'response.data.message', null);
        _this.loaderRemove();
        _this.checkDocumentUploadFlags(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(error, 'response.data', {}));
      });

      this.getDepositMethods();
    },
    scrollToTopIfPage: function scrollToTopIfPage() {
      if (this.isLayoutMobile && this.isPage) {
        setTimeout(function () {
          window.scrollTo(0, 0);
        }, 100);
      }
    },
    onUpdateAmount: function onUpdateAmount(amount) {
      if (this.fields.amount === '') {
        this.fields.amount = amount.toFixed(2);
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_helpers__["F" /* isNumber */])(this.fields.amount)) {
        this.fields.amount = (Number(this.fields.amount) + amount).toFixed(2);
      }
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'click',
        label: 'Amount ' + amount + ' Button'
      }));
    },
    handleAmountBlur: function handleAmountBlur() {
      this.$v.fields.amount.$touch();
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'fill',
        label: 'Amount'
      }));
    },
    onConfirmDeposit: function onConfirmDeposit() {
      var _this2 = this;

      this.avsMessage = false;
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'submit',
        label: 'Submit Deposit'
      }));

      if (this.formIsValid() && this.formDisable()) {
        this.loaderAdd();
        this.confirmDepositCard(this.depositPayload).then(function (data) {
          _this2.loaderRemove();
          _this2.formEnable();
          if (_this2.checkDocumentUploadFlags(data)) return;
          if (data.dapFlag) {
            _this2.step = STEPS.INITIAL;
            _this2.canDeposit = false;
            _this2.errorMessage = data.dapMessage;
          } else if (data.avsFlag) {
            _this2.step = STEPS.INITIAL;
            _this2.avsFlag = true;
            _this2.avsMessage = true;
            _this2.getDepositCard().then(function (depositData) {
              _this2.checkDocumentUploadFlags(depositData);
              _this2.fields.city = depositData.city || '';
              _this2.fields.address = depositData.address1 || '';
              _this2.fields.zipCode = depositData.postalCode || '';
              _this2.fields.country = { value: _this2.userData.countryCode };
            }).catch(function (error) {
              _this2.errorMessage = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(error, 'response.data.message', null);
            });
          } else {
            _this2.processingFeePercent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_helpers__["i" /* roundToTwo */])((data.feePercent || 0) * 100);
            _this2.processingFeeAmount = Number(Math.abs(data.fee || 0)).toFixed(2);
            _this2.totalToWallet = Number(data.totalAmount || 0).toFixed(2);
            _this2.wasFeeDiscountApplied = !!data.wasFeeDiscountApplied;
            _this2.feeFreeAmount = Number(data.feeFreeAmount || 0);
            _this2.promotionalCreditAmount = data.promoAmount;
            _this2.step = STEPS.CONFIRM;
            _this2.scrollToTopIfPage();
          }
        }).catch(function (error) {
          _this2.loaderRemove();
          if (_this2.checkDocumentUploadFlags(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(error, 'response.data', {}))) return;
          _this2.formEnable();
          _this2.handleDepositFail(error);
        });
      }
    },
    onSubmitDeposit: function onSubmitDeposit() {
      var _this3 = this;

      this.formDisable();
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Deposit Confirm',
        action: 'submit',
        label: 'Confirm Deposit'
      }));
      this.loaderAdd();
      this.submitDepositCard(this.depositPayload).then(function (data) {
        _this3.loaderRemove();
        if (_this3.checkDocumentUploadFlags(data)) return;
        if (typeof data.feeFreeAmount !== 'undefined') {
          _this3.feeFreeAmount = Number(data.feeFreeAmount || 0);
        }
        _this3.setCurrentDeposit(data);
        _this3.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_dataLayer__["a" /* withMeta */])({
          event: _this3.status.hasBeenFunded ? 'MultiDeposit' : 'Deposit'
        }));
        _this3.formEnable();
        _this3.$emit('success');
        _this3.step = STEPS.SUCCESS;
      }).then(this.getBalance).catch(function (error) {
        _this3.loaderRemove();
        if (_this3.checkDocumentUploadFlags(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(error, 'response.data', {}))) return;
        _this3.formEnable();
        _this3.handleDepositFail(error);
      });
    },
    handleDepositFail: function handleDepositFail(error) {
      this.errorMessageDepositFail = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(error, 'response.data.message', '');
      this.step = STEPS.TRY_AGAIN;
    },
    onBack: function onBack() {
      this.step = STEPS.INITIAL;
      this.errorMessageDepositFail = '';
    },
    onUseDifferentCard: function onUseDifferentCard() {
      this.fields.number = '';
      this.fields.expiryDateYear = '';
      this.fields.expiryDateMonth = '';
      this.fields.cvv = '';
      this.$v.fields.number.$reset();
      this.$v.fields.expiryDateMonth.$reset();
      this.$v.fields.expiryDateYear.$reset();
      this.$v.fields.cvv.$reset();
      this.errorMessageDepositFail = '';
      this.step = STEPS.INITIAL;
    },
    onStartFromScratch: function onStartFromScratch() {
      this.onResetPromoCode();
      this.onUseDifferentCard();
      this.fields.amount = '';
      this.errorMessageDepositFail = '';
      this.step = STEPS.INITIAL;
      this.initialize();
    },
    onSuccessDone: function onSuccessDone() {
      var _this4 = this;

      this.getDepositMethods().then(function () {
        var shownPopup = false;
        if (_this4.collegeAffiliationEnabled && _this4.status && _this4.status.isUCAffilSet === null) {
          shownPopup = true;
          _this4.setCurrentPopupWithDelay({ name: __WEBPACK_IMPORTED_MODULE_22__components_app_app_modals_modals_constants__["a" /* MODALS */].COLLEGE_AFFILIATION });
        } else if (_this4.twoFactorEnabled !== true && !__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].DISABLE_TWO_FACTOR_PROMPT) {
          shownPopup = true;
          _this4.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_22__components_app_app_modals_modals_constants__["a" /* MODALS */].TWO_FACTOR_PROMPT);
        }
        if (_this4.isPage) {
          _this4.onStartFromScratch();
        } else if (!shownPopup) {
          _this4.setCurrentPopup(null);
        }
      });
    },
    showCVVModal: function showCVVModal() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_22__components_app_app_modals_modals_constants__["a" /* MODALS */].SMALL_CVV);
    },
    isStep: function isStep(stepName) {
      return this.step === STEPS[stepName];
    },
    fieldName: function fieldName(name) {
      return this.mode + '-' + name;
    }
  }),
  watch: {
    ssnInfoVerified: function ssnInfoVerified() {
      this.initialize();
    }
  }
});

/***/ }),

/***/ "g1e5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite__);



var STORAGE_KEY = 'predictit-bank-transfer-intent-v1';
var TOKEN_PATTERN = /^[a-f0-9-]{32,36}$/i;

function normalizeOwner(owner) {
  return typeof owner === 'string' ? owner.trim().toLowerCase() : '';
}

function read(owner) {
  try {
    var value = JSON.parse(sessionStorage.getItem(STORAGE_KEY + ':' + normalizeOwner(owner)) || 'null');
    if (!value || !normalizeOwner(owner) || value.owner !== normalizeOwner(owner) || !TOKEN_PATTERN.test(value.submissionToken || '') || !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default()(value.linkedBankAccountId) || !(value.linkedBankAccountId > 0) || !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default()(value.amount) || !(value.amount > 0)) return null;
    return value;
  } catch (error) {
    return null;
  }
}

function save(owner, payload) {
  if (!normalizeOwner(owner) || !TOKEN_PATTERN.test(payload.submissionToken || '') || !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default()(Number(payload.linkedBankAccountId)) || !(Number(payload.linkedBankAccountId) > 0) || !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default()(Number(payload.amount)) || !(Number(payload.amount) > 0)) {
    throw new Error('The deposit recovery reference could not be saved. Please sign in again.');
  }
  var value = {
    owner: normalizeOwner(owner),
    submissionToken: payload.submissionToken,
    linkedBankAccountId: Number(payload.linkedBankAccountId),
    amount: Number(payload.amount)
  };
  // Save before sending: navigation or a lost HTTP response must not lose the intent.
  sessionStorage.setItem(STORAGE_KEY + ':' + value.owner, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(value));
  return value;
}

function clear(owner, submissionToken) {
  var value = read(owner);
  if (value && value.submissionToken === submissionToken) {
    sessionStorage.removeItem(STORAGE_KEY + ':' + value.owner);
  }
}

function isDefinitiveFailure(data) {
  var reason = Number(data && data.failureReason);
  return data && data.success === false && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(reason) && reason >= 1 && reason <= 21 && reason !== 11 && reason !== 16;
}

function isUnconfirmedReason(data) {
  var reason = Number(data && data.failureReason);
  return reason === 11 || reason === 16;
}

// Any definite HTTP response below 500 that does not report an unconfirmed submission
// (validation, permission, declined assessment) means no transfer was sent.
function isDefinitiveFailureResponse(response) {
  if (!response) return false;
  if (isDefinitiveFailure(response.data)) return true;
  var status = Number(response.status);
  return status > 0 && status < 500 && !isUnconfirmedReason(response.data);
}

/* harmony default export */ __webpack_exports__["a"] = ({ read: read, save: save, clear: clear, isDefinitiveFailure: isDefinitiveFailure, isDefinitiveFailureResponse: isDefinitiveFailureResponse });

/***/ }),

/***/ "g919":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_credit_card_js__ = __webpack_require__("g0D9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f53e606_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_credit_card_vue__ = __webpack_require__("5haK");
function injectStyle (ssrContext) {
  __webpack_require__("hJns")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_credit_card_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f53e606_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_credit_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gJ7L":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "gQ0Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var firstLandingPage = function firstLandingPage() {
  return Promise.all/* import() */([__webpack_require__.e(50), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "b2pe"));
};
var secondLandingPage = function secondLandingPage() {
  return Promise.all/* import() */([__webpack_require__.e(13), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "gSES"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/index1',
  name: 'index1',
  component: firstLandingPage,
  meta: {
    requiresAnonymous: true
  }
}, {
  path: '/index2',
  name: 'index2',
  component: secondLandingPage,
  meta: {
    requiresAnonymous: true
  }
}]);

/***/ }),

/***/ "gSSJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "gTKa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.onClickNumber($event)}}},[_c('span',{staticClass:"market-shares-ownership__number"},[_vm._v(_vm._s(_vm.numberDisplay))]),_vm._v(" "),_c('span',{staticClass:"market-shares-ownership__mode"},[_vm._v(_vm._s(_vm.mode))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gatU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getMostPopular: function getMostPopular() {
    var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '12h';
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

    // from disqus api
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Insight/MostPopular/' + interval + '?count=' + count);
  },
  getAnalysis: function getAnalysis() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    // from tumblr api
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Insight/Analysis?limit=' + limit + '&offset=' + offset);
  },
  getFeeds: function getFeeds() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Insight/Feeds');
  },
  getMarketFeeds: function getMarketFeeds(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Insight/Feeds/Markets/' + marketId);
  },
  getNews: function getNews() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Insight/News?limit=' + limit + '&offset=' + offset);
  }
});

/***/ }),

/***/ "gdGR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_social_badge_js__ = __webpack_require__("3yfD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e9392fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_social_badge_vue__ = __webpack_require__("PBe4");
function injectStyle (ssrContext) {
  __webpack_require__("Dz7g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_social_badge_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e9392fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_social_badge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gi1v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-amount-overview"},[_c('div',{staticClass:"deposit-amount-overview__title"},[_vm._t("title")],2),_vm._v(" "),_c('div',{staticClass:"deposit-amount-overview__amount"},[_vm._v("\n    "+_vm._s(_vm.infoAmount)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"deposit-amount-overview__subtitle"},[_vm._t("subtitle")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gjXf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_layout_js__ = __webpack_require__("EyLR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3631c8b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_layout_vue__ = __webpack_require__("spPS");
function injectStyle (ssrContext) {
  __webpack_require__("AdHZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_layout_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3631c8b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gnYi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  desktop: { zIndex: 3, stickyTop: 90 },
  mobile: { zIndex: 3, stickyTop: 90 }
  // TODO change back
  // desktop: { zIndex: 3, stickyTop: 109 },
  // mobile: { zIndex: 3, stickyTop: 109 },
});

/***/ }),

/***/ "grAS":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDIxIDIxIj4KICAgIDxnIGZpbGw9IiNCQkM4QzkiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgPHBhdGggZD0iTTEwLjUgMEM0LjcxIDAgMCA0LjcxIDAgMTAuNVM0LjcxIDIxIDEwLjUgMjEgMjEgMTYuMjkgMjEgMTAuNSAxNi4yOSAwIDEwLjUgMHptMCAxOS4yYy00Ljc5NyAwLTguNy0zLjkwMy04LjctOC43IDAtNC43OTcgMy45MDMtOC43IDguNy04LjcgNC43OTcgMCA4LjcgMy45MDMgOC43IDguNyAwIDQuNzk3LTMuOTAzIDguNy04LjcgOC43eiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMC42NyA4LjQ5NWMuNjgyLjAwNiAxLjI0My0uNTcgMS4yNS0xLjI3NGExLjI2NiAxLjI2NiAwIDAgMC0xLjI0My0xLjI5M2MtLjY5NSAwLTEuMjY0LjU2Mi0xLjI3IDEuMjczIDAgLjcwNC41NjEgMS4yODcgMS4yNjMgMS4yOTR6TTEyLjE3NCAxNC4yNzJjLS4xMi4wNDctLjIzNC4xMzUtLjM1NC4xODJhMS45NDIgMS45NDIgMCAwIDEtLjQ2OC4xMzZjLS4xOTQuMDItLjMzNC0uMDgxLS4zODEtLjI3MWExLjQwNiAxLjQwNiAwIDAgMS0uMDQtLjQ0Yy4wMzMtLjMwNS4wOTMtLjYwMy4xNDctLjkwOC4xNi0uOTA3LjMzNC0xLjgxNS40ODgtMi43MjkuMDQtLjI0NC4wODctLjQ5NC4wOC0uNzQ1LS4wMDctLjI5OC0uMTgtLjQ0LS40NzUtLjQ0SDguNzkyYTIuMDUgMi4wNSAwIDAgMC0uMjg4LjAyYy0uMTguMDM0LS4yNjcuMTIyLS4yOC4yNjQtLjAxNC4xMjkuMDUzLjI1OC4yMi4zMTkuMTM0LjA0Ny4yNzQuMDYuNDE1LjA4LjMyLjA0OC40MjguMTYzLjQyOC40OTUgMCAuMDU0LS4wMDcuMTAyLS4wMTQuMTU2LS4xMzQuOC0uMjggMS41OTEtLjQxNCAyLjM5LS4wNzQuNDYxLS4xNDcuOTE1LS4yMDcgMS4zNzUtLjA5NC42Ny41NDggMS4zMDggMS4wNDkgMS4zNzUuMy4wNC42MDguMDU0LjkxNi4wNDguNjU1LS4wMDcgMS4yMDMtLjI5MiAxLjY2NC0uNzU5YS42OTYuNjk2IDAgMCAwIC4xNzQtLjMwNWMuMDUzLS4xOS0uMDk0LS4zMTgtLjI4MS0uMjQzeiIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "gwUB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_v2_market_contract_v2_market_contract_v2_vue__ = __webpack_require__("D5rx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_dataLayer__ = __webpack_require__("k37b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_loader__ = __webpack_require__("39kf");










var MAX_CONTRACTS_TO_DISPLAY = 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_loader__["a" /* default */]],
  components: {
    marketContract: __WEBPACK_IMPORTED_MODULE_5__components_market_v2_market_contract_v2_market_contract_v2_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    layout: {
      type: String,
      default: 'grid'
    },
    theme: {
      type: String
    },
    watchIcon: {
      type: Boolean,
      default: false
    },
    trackingContext: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      hovered: false,
      showMarketImages: this.showImage && this.market.marketImageUrl
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    totalSharesTraded: function totalSharesTraded() {
      return Number(this.market.totalSharesTraded) || 0;
    },
    showVolume: function showVolume() {
      var fallbackStartDate = this.market.contracts && this.market.contracts.length > 0 ? this.market.contracts[0].startDate : null;
      var openedDate = this.market.dateOpened || fallbackStartDate;
      var daysOld = openedDate && __WEBPACK_IMPORTED_MODULE_6_moment___default()(openedDate).isValid() ? __WEBPACK_IMPORTED_MODULE_6_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_6_moment___default()(openedDate), 'days') : 7;
      var isNewMarket = daysOld < 7 && this.totalSharesTraded <= 100;

      return !isNewMarket;
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({
        'market-list-item-v2': true,
        'market-list-item-v2--large': true,
        'market-list-item-v2--hovered': this.hovered,
        'market-list-item-v2--not-logged': !this.isLoggedIn
      }, 'market-list-item-v2--' + this.layout, true);
    },
    styleModifiers: function styleModifiers() {
      return {
        '--bg-url': 'url(' + this.market.marketImageUrl + ')'
      };
    },
    contracts: function contracts() {
      var results = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(this.market.contracts) || [];
      if (!results) return [];

      /* Add fake copy of a contract that represents NO contracts */
      if (results.length === 1) {
        var noContract = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ noContract: true }, results[0]);
        results.push(noContract);
      }

      return results.slice(0, MAX_CONTRACTS_TO_DISPLAY);
    },
    showSharesOwnedNotification: function showSharesOwnedNotification() {
      return this.market.userHasOwnership;
    },
    onClick: function onClick() {
      this.$router.push({
        name: 'market-details',
        params: {
          marketId: this.market.marketId,
          marketUrl: this.market.marketUrl
        }
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('profile', ['removeMarketFromWatchList']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('browse', ['updateMarketNotWatched']), {
    contractKey: function contractKey(contract) {
      var suffix = contract.noContract ? 'no' : 'yes';
      return contract.contractId + '-' + suffix;
    },
    onMouseOver: function onMouseOver() {
      this.hovered = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.hovered = false;
    },
    fireMarketTileClick: function fireMarketTileClick() {
      if (!this.trackingContext.storyId) return;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_dataLayer__["d" /* pushStoryInteraction */])(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ interactionType: __WEBPACK_IMPORTED_MODULE_7__helpers_dataLayer__["e" /* INTERACTION_TYPE */].MARKET_TILE }, this.trackingContext));
    },
    watchToggle: function watchToggle() {
      var _this = this;

      this.loaderAddLegacy(document.body);
      this.removeMarketFromWatchList(this.market.marketId).then(function () {
        _this.loaderRemoveLegacy(document.body);
        _this.updateMarketNotWatched(_this.market.marketId);
        _this.$emit('watchToggle');
      }).catch(function () {
        _this.loaderRemoveLegacy(document.body);
      });
    }
  })
});

/***/ }),

/***/ "h/F2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    account: {
      type: Object,
      required: true
    },
    removable: {
      type: Boolean,
      default: true
    },
    selectable: {
      type: Boolean,
      default: true
    },
    showMessage: {
      type: Boolean,
      default: true
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showStatusMessage: function showStatusMessage() {
      return this.showMessage && typeof this.account.accountStatus !== 'undefined' && this.account.accountStatus !== 1;
    },
    classModifiers: function classModifiers() {
      return {
        'bank-account': true,
        'bank-account--selectable': this.selectable
      };
    }
  }
});

/***/ }),

/***/ "h1Ye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    theme: {
      type: String,
      default: ''
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'account-form-loader': true
      }, 'account-form-loader--' + this.theme, this.theme);
    }
  }
});

/***/ }),

/***/ "h3sO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h41O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_header_search_js__ = __webpack_require__("vm2L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8628820_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_search_vue__ = __webpack_require__("G3f5");
function injectStyle (ssrContext) {
  __webpack_require__("aaFU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_header_search_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8628820_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h6O+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hBIN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hE3l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreviewCarouselLoader_vue__ = __webpack_require__("ZKEq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4d6492c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreviewCarouselLoader_vue__ = __webpack_require__("hqzU");
function injectStyle (ssrContext) {
  __webpack_require__("WLny")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreviewCarouselLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4d6492c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreviewCarouselLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hJns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hL+e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fee-status-message"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"8","height":"10","viewBox":"0 0 8 10","fill":"none"}},[_c('path',{attrs:{"d":"M4.50012 0L4.50912 0.000499964L4.51713 0.00100005L4.55862 0.00349998L4.56413 0.00450003H4.56962L4.58862 0.00899994L4.61462 0.013L4.62262 0.016L4.62812 0.0165L4.64262 0.022L4.66862 0.029L4.67812 0.0335L4.68563 0.0355L4.69963 0.0425L4.71962 0.051L4.73012 0.057L4.74113 0.062L4.75262 0.0695L4.76813 0.0779999L4.78512 0.09L4.79413 0.0955L4.80062 0.1015L4.81262 0.11L4.83162 0.127L4.84263 0.1355L4.84662 0.1405L4.85362 0.1465L4.87162 0.167L4.88462 0.1805L4.88762 0.185C4.94762 0.2585 4.98562 0.346 4.99662 0.4415L4.99713 0.4475L4.99813 0.468L5.00012 0.5V3.5H7.50012C7.58776 3.49998 7.67386 3.52299 7.74979 3.56672C7.82573 3.61046 7.88884 3.67339 7.9328 3.7492C7.97675 3.82501 8.00002 3.91104 8.00025 3.99867C8.00048 4.0863 7.97768 4.17246 7.93412 4.2485L7.90413 4.294L3.90412 9.794C3.62012 10.1855 3.00012 9.984 3.00012 9.5V6.5H0.500125C0.412493 6.50002 0.326393 6.47701 0.250456 6.43328C0.174518 6.38954 0.111409 6.32661 0.0674518 6.2508C0.023495 6.17499 0.000234678 6.08896 1.76651e-06 6.00133C-0.000231145 5.9137 0.0225716 5.82754 0.0661248 5.7515L0.0961247 5.706L4.09613 0.206L4.10112 0.1995L4.11013 0.1875L4.12663 0.1685L4.13562 0.1575L4.14012 0.1535L4.14663 0.1465L4.16663 0.1285L4.18062 0.1155L4.18463 0.1125C4.24323 0.0645406 4.31195 0.0305182 4.38562 0.013L4.39112 0.0125L4.40462 0.00999999L4.44163 0.00349998L4.44712 0.00300002L4.46763 0.00199997L4.50012 0Z","fill":"#949494"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.prefix)),_c('strong',[_vm._v(_vm._s(_vm.statusLabel))]),_vm._v(" on this deposit "+_vm._s(_vm.feeCapDisplayMessage))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hM2Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hPGJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_header_search_bar_search_bar_vue__ = __webpack_require__("OL8g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_headerNav__ = __webpack_require__("drLe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_dataLayer__ = __webpack_require__("k37b");











/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_headerNav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_accountVerify__["a" /* default */]],
  components: {
    searchBar: __WEBPACK_IMPORTED_MODULE_3__components_app_app_header_search_bar_search_bar_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('app', ['mobileMenuOpened']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['leaderboardsEnabled']), {
    enabledLinks: function enabledLinks() {
      return this.links.filter(function (i) {
        return i.enabled;
      });
    },
    links: function links() {
      if (this.isLoggedIn) {
        return [{
          title: 'Markets',
          name: 'markets',
          href: '/markets',
          nested: false,
          enabled: true
        }, {
          title: 'News',
          name: 'news',
          href: '/news',
          nested: false,
          enabled: true
        }, {
          title: 'Trends',
          name: 'trends',
          href: '/trends',
          nested: false,
          enabled: false
        }, {
          title: 'Dashboard',
          name: 'dashboard',
          href: '/dashboard',
          nested: false,
          enabled: true
        }, {
          title: 'Leaderboards',
          name: 'leaderboards',
          href: '/leaderboards',
          enabled: this.leaderboardsEnabled,
          nested: false
        }, {
          title: 'Account',
          name: 'account',
          href: '/account',
          nested: false,
          enabled: true
        }, {
          title: 'Support',
          name: 'help',
          href: '/support',
          nested: true,
          enabled: true
        }, {
          title: 'Wallet',
          name: 'wallet',
          href: '/account/wallet',
          nested: true,
          enabled: this.isUserVerified
        }];
      }

      return [{
        title: 'Markets',
        name: 'markets',
        href: '/markets',
        nested: false,
        enabled: true
      }, {
        title: 'News',
        name: 'news',
        href: '/news',
        nested: false,
        enabled: true
      }, {
        title: 'Support',
        name: 'help',
        href: '/support',
        nested: false,
        enabled: true
      }, {
        title: 'Insights',
        name: 'insight',
        href: '/insight',
        nested: false,
        enabled: false
      }, {
        title: 'Leaderboards',
        name: 'leaderboards',
        href: '/leaderboards',
        enabled: this.leaderboardsEnabled,
        nested: false
      }];
    }
  }),
  watch: {
    mobileMenuOpened: function mobileMenuOpened(value) {
      if (value) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["m" /* lockModal */])();
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["n" /* unLockModal */])();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('app', ['closeMobileMenu']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['logout']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onLinkClick: function onLinkClick(href) {
      if (this.$route && this.$route.path === href) {
        window.scrollTo(0, 0);
      }
      this.closeMobileMenu();
    },
    itemClassModifiers: function itemClassModifiers(item) {
      return {
        'app-mobile-menu__nav-item': true,
        'app-mobile-menu__nav-item--nested': item.nested,
        'app-mobile-menu__nav-item--active': this.$route.path.includes(item.href)
      };
    },
    itemIconClassModifiers: function itemIconClassModifiers(item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'app-mobile-menu__nav-item-icon': true
      }, 'app-mobile-menu__nav-item-icon--' + item.name, item.name);
    },
    logoutButton: function logoutButton() {
      this.loaderAdd(document.body);
      this.logout();
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers_dataLayer__["a" /* withMeta */])({ event: 'Logout' }));
    },
    showLeavingPopup: function showLeavingPopup() {
      if (this.mobileMenuOpened) {
        window.scrollTo(0, 0);
        this.closeMobileMenu();
      }
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_7__components_app_app_modals_modals_constants__["a" /* MODALS */].LEAVING_POPUP);
    }
  }),
  beforeDestroy: function beforeDestroy() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["n" /* unLockModal */])();
  }
});

/***/ }),

/***/ "ha/Z":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "hbUY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hk1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaticPageLoader_vue__ = __webpack_require__("paCg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b535a4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StaticPageLoader_vue__ = __webpack_require__("4DPA");
function injectStyle (ssrContext) {
  __webpack_require__("JqZZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaticPageLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b535a4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StaticPageLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hkzh":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNSA5LjE2MTEzSDQuNVYxOC4xNjExSDcuNVY5LjE2MTEzWiIgc3Ryb2tlPSIjOTQ5NDk0IiBzdHJva2Utd2lkdGg9IjAuNzUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTMuNSA5LjE2MTEzSDEwLjVWMTguMTYxMUgxMy41VjkuMTYxMTNaIiBzdHJva2U9IiM5NDk0OTQiIHN0cm9rZS13aWR0aD0iMC43NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xOS41IDkuMTYxMTNIMTYuNVYxOC4xNjExSDE5LjVWOS4xNjExM1oiIHN0cm9rZT0iIzk0OTQ5NCIgc3Ryb2tlLXdpZHRoPSIwLjc1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIxIDIxLjE2MTFIM1YxOC45MTExQzMgMTguNzEyMiAzLjA3OTAyIDE4LjUyMTUgMy4yMTk2NyAxOC4zODA4QzMuMzYwMzIgMTguMjQwMiAzLjU1MTA5IDE4LjE2MTEgMy43NSAxOC4xNjExSDIwLjI1QzIwLjQ0ODkgMTguMTYxMSAyMC42Mzk3IDE4LjI0MDIgMjAuNzgwMyAxOC4zODA4QzIwLjkyMSAxOC41MjE1IDIxIDE4LjcxMjIgMjEgMTguOTExMVYyMS4xNjExWiIgc3Ryb2tlPSIjOTQ5NDk0IiBzdHJva2Utd2lkdGg9IjAuNzUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMS41IDIxLjE2MTFIMjIuNSIgc3Ryb2tlPSIjOTQ5NDk0IiBzdHJva2Utd2lkdGg9IjAuNzUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjEgNi4xNjA3NFY4LjQxMDc0QzIxIDguNjA5NjUgMjAuOTIxIDguODAwNDIgMjAuNzgwMyA4Ljk0MTA3QzIwLjYzOTcgOS4wODE3MiAyMC40NDg5IDkuMTYwNzQgMjAuMjUgOS4xNjA3NEgzLjc1QzMuNTUxMDkgOS4xNjA3NCAzLjM2MDMyIDkuMDgxNzIgMy4yMTk2NyA4Ljk0MTA3QzMuMDc5MDIgOC44MDA0MiAzIDguNjA5NjUgMyA4LjQxMDc0VjYuMTYwNzRMNy4zMzI1IDMuOTk0NzRMMTEuNjY1IDEuODI4NzRDMTEuNzY5MSAxLjc3Njk1IDExLjg4MzcgMS43NSAxMiAxLjc1QzEyLjExNjMgMS43NSAxMi4yMzA5IDEuNzc2OTUgMTIuMzM1IDEuODI4NzRMMjEgNi4xNjA3NFoiIHN0cm9rZT0iIzk0OTQ5NCIgc3Ryb2tlLXdpZHRoPSIwLjc1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMgNi4xNjExM0gyMSIgc3Ryb2tlPSIjOTQ5NDk0IiBzdHJva2Utd2lkdGg9IjAuNzUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ "hmLK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"election-map-special__label"},[_vm._v("\n    GA Special:\n  ")]),_vm._v(" "),_c('transition',{attrs:{"name":"election-map-special"}},[(_vm.showTooltip && _vm.isLayoutDesktop)?_c('div',{staticClass:"election-map-special__tooltip"},[_c('market-state-tooltip',{attrs:{"stateCode":"GA2","stateName":"Georgia","marketData":_vm.ga2MarketData,"type":"senate"}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"election-map-special__legend",style:(_vm.legendStyleModifiers),on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave,"click":_vm.onClick}},[(_vm.targetContractInstance.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":_vm.targetContractInstance.lastTradePriceAsCents}})]:[_vm._v("\n      -\n    ")]],2)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hqzU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-carousel-loader"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__content"},[_c('div',{staticClass:"preview-carousel-loader__story"},[_c('div',{staticClass:"preview-carousel-loader__title"}),_vm._v(" "),(_vm.isLayoutMobile)?[_c('div',{staticClass:"preview-carousel-loader__media"}),_vm._v(" "),_vm._m(1)]:_c('div',{staticClass:"preview-carousel-loader__main"},[_vm._m(2),_vm._v(" "),_vm._m(3)])],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-carousel-loader__nav"},[_c('div',{staticClass:"preview-carousel-loader__nav-item preview-carousel-loader__nav-item--active"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__nav-item"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__nav-item"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__nav-item"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__nav-item"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-carousel-loader__copy"},[_c('div',{staticClass:"preview-carousel-loader__copy-line preview-carousel-loader__copy-line--wide"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line preview-carousel-loader__copy-line--short"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-carousel-loader__media-column"},[_c('div',{staticClass:"preview-carousel-loader__media"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-carousel-loader__copy-column"},[_c('div',{staticClass:"preview-carousel-loader__copy"},[_c('div',{staticClass:"preview-carousel-loader__copy-line preview-carousel-loader__copy-line--wide"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line preview-carousel-loader__copy-line--short"})]),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-secondary"},[_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line"}),_vm._v(" "),_c('div',{staticClass:"preview-carousel-loader__copy-line preview-carousel-loader__copy-line--short"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "htEh":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "i3z8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_stickyConstants__ = __webpack_require__("gnYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_market_filters_market_filters_mobile_market_filters_mobile_vue__ = __webpack_require__("EvOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_market_market_section_header_market_section_header_vue__ = __webpack_require__("ZqrY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_market_market_list_desktop_header_market_list_desktop_header_vue__ = __webpack_require__("/v52");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_market_v2_market_list_item_v2_market_list_item_v2_vue__ = __webpack_require__("tPuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_headerTags__ = __webpack_require__("cgm0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_seoMeta__ = __webpack_require__("08z+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_canonical_url__ = __webpack_require__("9XaW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_json_ld__ = __webpack_require__("oE+L");






















var MARKET_LIST_JSON_LD_VMID = 'jsonld-market-list';

var HOMEPAGE_FONT_LOAD_FALLBACK_MS = 1200;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_headerTags__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_userAgent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__mixins_seoMeta__["a" /* default */]],
  components: {
    marketFiltersMobile: __WEBPACK_IMPORTED_MODULE_8__components_market_market_filters_market_filters_mobile_market_filters_mobile_vue__["a" /* default */],
    marketSectionHeader: __WEBPACK_IMPORTED_MODULE_9__components_market_market_section_header_market_section_header_vue__["a" /* default */],
    marketListDesktopHeader: __WEBPACK_IMPORTED_MODULE_10__components_market_market_list_desktop_header_market_list_desktop_header_vue__["a" /* default */],
    marketListItem: __WEBPACK_IMPORTED_MODULE_11__components_market_v2_market_list_item_v2_market_list_item_v2_vue__["a" /* default */]
  },
  props: {
    notificationText: {
      type: String,
      required: false
    },
    notificationLevel: {
      type: String,
      required: false
    },
    headerId: Number,
    headerUrl: String,
    page: {
      type: Number,
      default: 1
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isLoading: true,
      isFiltering: false,
      stickyOptions: __WEBPACK_IMPORTED_MODULE_7__helpers_stickyConstants__["a" /* default */].mobile,
      watchersDisabled: false,
      isInfiniteLoading: false,
      isLoadingPrevious: false,
      embeddedInitialFontsReady: false,
      canonicalUrl: null,
      currentDisplayedPage: this.page,
      observedBoundaryEls: new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a()
    };
  },
  metaInfo: function metaInfo() {
    var _this = this;

    if (this.embedded) return {};

    var isPaymentRoute = this.$route.name === 'payment-success' || this.$route.name === 'payment-fail';
    var noindexMeta = isPaymentRoute ? [{ name: 'robots', content: 'noindex,nofollow' }] : [];

    if (this.currentHeader !== null) {
      var _canonicalUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_canonical_url__["a" /* default */])(this.$router, 'market-list', {
        headerId: this.currentHeader.headerId,
        headerUrl: this.currentHeader.headerUrl
      });
      var jsonLdSchema = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_json_ld__["e" /* buildCollectionPageSchema */])({
        name: this.currentHeader.seoTitle,
        description: this.currentHeader.seoDescription,
        url: _canonicalUrl,
        items: this.items.map(function (market) {
          return {
            name: market.marketName,
            url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_canonical_url__["a" /* default */])(_this.$router, 'market-details', {
              marketId: market.marketId,
              marketUrl: market.marketUrl
            })
          };
        })
      });
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.buildSeoMeta({
        title: this.currentHeader.seoTitle || 'Markets',
        description: this.currentHeader.seoDescription,
        type: 'website',
        url: _canonicalUrl,
        extraMeta: noindexMeta
      }), {
        script: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_json_ld__["b" /* buildJsonLdTag */])(jsonLdSchema, MARKET_LIST_JSON_LD_VMID)],
        __dangerouslyDisableSanitizersByTagID: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_json_ld__["c" /* jsonLdSanitizerOverride */])(MARKET_LIST_JSON_LD_VMID)
      });
    }
    var canonicalUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_canonical_url__["a" /* default */])(this.$router, 'market-list');
    return this.buildSeoMeta({
      title: 'Political Prediction Markets: Trade the Odds | PredictIt',
      description: 'Trade on elections, politics and world events with real-money prediction markets. Explore every PredictIt market and see where the odds stand today.',
      type: 'website',
      url: canonicalUrl,
      extraMeta: noindexMeta
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('browse', ['selectedFilters', 'selectedOrder', 'selectedTimespan', 'filteredMarkets', 'headers', 'latestHeaderId', 'marketsPageInitialLoadDone', 'marketListCachedHeaderId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('user', ['marketDisplay']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('app', ['previousRoute']), {
    items: function items() {
      var markets = this.filteredMarkets.data === null ? [] : this.filteredMarkets.data;
      var statuses = [__WEBPACK_IMPORTED_MODULE_16__constants__["a" /* default */].MARKET_SETTLED, __WEBPACK_IMPORTED_MODULE_16__constants__["a" /* default */].MARKET_EXPIRED, __WEBPACK_IMPORTED_MODULE_16__constants__["a" /* default */].MARKET_SUSPENDED];
      return markets.filter(function (m) {
        return !statuses.includes(m.status);
      });
    },
    showNoMarketsMessage: function showNoMarketsMessage() {
      return !this.showInitialSpinner && !this.isLoading && !this.isInfiniteLoading && this.items.length === 0;
    },
    currentHeader: function currentHeader() {
      var _this2 = this;

      var header = this.headers ? this.headers.find(function (h) {
        return h.headerId === _this2.headerId;
      }) : null;
      return header || null;
    },
    currentHeaderName: function currentHeaderName() {
      var header = this.currentHeader;
      if (header) {
        return header.name;
      }
      return this.selectedFilters.length ? 'Filtered Markets' : 'All Markets';
    },
    filtering: function filtering() {
      return this.selectedFilters.toString() + this.selectedOrder.name + this.selectedTimespan.name;
    },
    showSpinner: function showSpinner() {
      return !this.embedded || this.embedded && this.marketsPageInitialLoadDone;
    },
    showInitialSpinner: function showInitialSpinner() {
      return this.embedded ? !this.embeddedInitialFontsReady && !this.marketsPageInitialLoadDone : !this.marketsPageInitialLoadDone;
    },
    marketSkeletonCount: function marketSkeletonCount() {
      return this.isLayoutDesktop ? 9 : 6;
    },
    nextPageRouteLocation: function nextPageRouteLocation() {
      if (this.embedded || !this.marketsPageInitialLoadDone) return null;
      if (!this.filteredMarkets.canLoadMore) return null;
      return {
        name: 'market-list',
        params: {
          headerId: this.headerId,
          headerUrl: this.headerUrl
        },
        query: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
          filterIds: this.selectedFilters.join(','),
          sort: this.selectedOrder.sort,
          sortParameter: this.selectedTimespan.parameter
        }, this.selectedTimespan.dateFrom && this.selectedTimespan.dateTo ? {
          dateFrom: this.selectedTimespan.dateFrom,
          dateTo: this.selectedTimespan.dateTo
        } : {}, {
          page: (this.filteredMarkets.page || 0) + 1
        })
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('browse', ['clearFilters', 'clearTimespan', 'clearOrder', 'getFilters', 'getFilteredMarkets', 'setLatestHeaderId', 'resetFilteredMarkets', 'setMarketsPageInitialLoadDone', 'setMarketListCachedHeaderId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('user', ['updateMarketDisplay']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('notifications', ['setSideNotification']), {
    fetchData: function fetchData() {
      var _this3 = this;

      this.isLoading = true;
      this.currentDisplayedPage = this.page;
      this.resetBoundaryTracking();
      if (this.embedded) {
        this.embeddedInitialFontsReady = false;
      }
      if (this.isFiltering) return;
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default()(this.headerId)) {
        this.notifyEmbeddedInitialLoadState(true);
        __WEBPACK_IMPORTED_MODULE_18__logger__["a" /* default */].info('[MARKETS] Fetching Data');
        this.isFiltering = true;
        this.reorganizeTags();
        this.getFilters(this.headerId).then(function () {
          _this3.getMarkets(true).then(function () {
            _this3.isFiltering = false;
            _this3.isLoading = false;
            _this3.setMarketsPageInitialLoadDone(true);
            _this3.setMarketListCachedHeaderId(_this3.headerId);
            _this3.redirectIfPageOutOfRange();
            _this3.upgradeLegacyTimespanUrl();
            _this3.waitForEmbeddedInitialFonts().then(function () {
              _this3.notifyEmbeddedInitialLoadState(false);
            });
          }).catch(function () {
            _this3.isLoading = false;
            _this3.isFiltering = false;
            _this3.setMarketsPageInitialLoadDone(true);
            _this3.waitForEmbeddedInitialFonts().then(function () {
              _this3.notifyEmbeddedInitialLoadState(false);
            });
          });
        }).catch(function (error) {
          _this3.isFiltering = false;
          _this3.isLoading = false;
          _this3.setMarketsPageInitialLoadDone(true);
          var status = error && error.response && error.response.status;
          if (status === 404) {
            _this3.$router.push({ name: 'not-found' });
            return;
          }
          _this3.waitForEmbeddedInitialFonts().then(function () {
            _this3.notifyEmbeddedInitialLoadState(false);
          });
        });
      }
    },
    getMarkets: function getMarkets() {
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return this.getFilteredMarkets({
        headerId: this.headerId || 0,
        reset: reset,
        page: reset ? this.page : null
      });
    },
    loadPrevious: function loadPrevious() {
      var _this4 = this;

      if (this.isLoadingPrevious || !this.filteredMarkets.canLoadPrevious) return;
      this.isLoadingPrevious = true;
      // Prepending shifts every element below the sentinel down, which would
      // otherwise yank the viewport - hold scroll position steady around it.
      var previousScrollHeight = document.documentElement.scrollHeight;
      var previousScrollTop = window.scrollY;
      this.getFilteredMarkets({ headerId: this.headerId || 0, prepend: true }).then(function () {
        _this4.$nextTick(function () {
          var heightDelta = document.documentElement.scrollHeight - previousScrollHeight;
          window.scrollTo(0, previousScrollTop + heightDelta);
          _this4.isLoadingPrevious = false;
        });
      }).catch(function () {
        _this4.isLoadingPrevious = false;
      });
    },
    redirectIfPageOutOfRange: function redirectIfPageOutOfRange() {
      if (this.embedded) return;
      var _filteredMarkets = this.filteredMarkets,
          data = _filteredMarkets.data,
          totalCount = _filteredMarkets.totalCount,
          totalPages = _filteredMarkets.totalPages;

      var outOfRange = this.page > 1 && totalCount > 0 && (!data || data.length === 0);
      if (!outOfRange) return;

      var currentQuery = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_helpers__["I" /* parseQuery */])(window.location.search || '');
      this.$router.replace({
        name: 'market-list',
        params: {
          headerId: this.headerId,
          headerUrl: this.headerUrl
        },
        query: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, currentQuery, {
          page: Math.max(1, totalPages || 1)
        })
      });
    },
    onLayoutToggle: function onLayoutToggle(layout) {
      this.updateMarketDisplay(layout);
    },
    notifyEmbeddedInitialLoadState: function notifyEmbeddedInitialLoadState(isLoading) {
      if (this.embedded) {
        this.$emit('embeddedInitialLoadStateChange', isLoading);
      }
    },
    waitForEmbeddedInitialFonts: function waitForEmbeddedInitialFonts() {
      var _this5 = this;

      if (!this.embedded || this.embeddedInitialFontsReady) {
        this.embeddedInitialFontsReady = true;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
      }

      if (typeof document === 'undefined' || !document.fonts || typeof document.fonts.load !== 'function') {
        this.embeddedInitialFontsReady = true;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
      }

      var requiredFontFaces = ['500 14px Roboto', '300 12px Roboto', '300 24px "Roboto Mono"'];

      if (requiredFontFaces.every(function (fontFace) {
        return document.fonts.check(fontFace);
      })) {
        this.embeddedInitialFontsReady = true;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
      }

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.race([__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(requiredFontFaces.map(function (fontFace) {
        return document.fonts.load(fontFace);
      })))), new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        setTimeout(resolve, HOMEPAGE_FONT_LOAD_FALLBACK_MS);
      })]).catch(function () {}).then(function () {
        _this5.embeddedInitialFontsReady = true;
      });
    },
    filteringChanged: function filteringChanged() {
      if (this.watchersDisabled) return;

      __WEBPACK_IMPORTED_MODULE_18__logger__["a" /* default */].info('[MARKETS] Filtering. Is in Progress: ' + this.isFiltering.toString());
      if (this.isFiltering) return;
      if (this.embedded) {
        this.fetchData();
      } else {
        this.$router.push({
          name: 'market-list',
          params: {
            headerId: this.headerId,
            headerUrl: this.headerUrl
          },
          query: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
            filterIds: this.selectedFilters.join(','),
            sort: this.selectedOrder.sort,
            sortParameter: this.selectedTimespan.parameter
          }, this.selectedTimespan.dateFrom && this.selectedTimespan.dateTo ? {
            dateFrom: this.selectedTimespan.dateFrom,
            dateTo: this.selectedTimespan.dateTo
          } : {}, {
            page: 1
          })
        });
        this.fetchData();
        this.currentDisplayedPage = 1;
      }
    },
    headerIdChanged: function headerIdChanged(newValue) {
      if (this.embedded) {
        this.resetFilteredMarkets();
        this.setLatestHeaderId(newValue);
        this.clearFilters();
        this.clearOrder();
        this.clearTimespan();
        this.fetchData();
      } else {
        if (this.marketsPageInitialLoadDone && this.marketListCachedHeaderId === newValue && this.filteredMarkets.data && this.filteredMarkets.data.length > 0) {
          return;
        }
        this.fetchData();
      }
    },
    loadMore: function loadMore() {
      var _this6 = this;

      if (this.isInfiniteLoading || !this.filteredMarkets.canLoadMore) return;
      this.isInfiniteLoading = true;
      __WEBPACK_IMPORTED_MODULE_18__logger__["a" /* default */].info('[MARKETS] load more, initialLoadDone=' + this.marketsPageInitialLoadDone);
      this.getMarkets(false).catch(function () {
        _this6.isInfiniteLoading = false;
      });
    },
    setupScrollObservers: function setupScrollObservers() {
      if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return;

      this.loadMoreObserver = new IntersectionObserver(this.onLoadMoreIntersect, {
        rootMargin: '0px 0px 600px 0px',
        threshold: 0
      });
      this.observeLoadMoreSentinel();

      // Not an IntersectionObserver: the sentinel sits at the very top of the list, so it's
      // already "intersecting" the instant the page loads - that fired loadPrevious before the
      // user ever touched the scrollbar. Instead only check it on a genuine upward scroll
      window.addEventListener('wheel', this.onWheel, { passive: true });
      window.addEventListener('touchstart', this.onTouchStart, { passive: true });
      window.addEventListener('touchmove', this.onTouchMove, { passive: true });

      if (!this.embedded) {
        this.pageBoundaryObserver = new IntersectionObserver(this.onPageBoundaryIntersect, {
          rootMargin: '-45% 0px -50% 0px',
          threshold: 0
        });
        this.observePageBoundaries();
      }
    },
    onLoadMoreIntersect: function onLoadMoreIntersect(entries) {
      var isVisible = entries.some(function (entry) {
        return entry.isIntersecting;
      });
      if (isVisible && this.marketsPageInitialLoadDone) this.loadMore();
    },
    observeLoadMoreSentinel: function observeLoadMoreSentinel() {
      var _this7 = this;

      if (!this.loadMoreObserver) return;
      this.$nextTick(function () {
        var sentinel = _this7.$refs.loadMoreSentinel;
        if (sentinel) _this7.loadMoreObserver.observe(sentinel);
      });
    },
    onWheel: function onWheel(event) {
      if (event.deltaY < 0) this.onScrolledUpward();
    },
    onTouchStart: function onTouchStart(event) {
      this.touchStartY = event.touches[0].clientY;
    },
    onTouchMove: function onTouchMove(event) {
      if (this.touchStartY == null) return;
      var currentY = event.touches[0].clientY;
      var swipingDown = currentY > this.touchStartY;
      this.touchStartY = currentY;
      if (swipingDown) this.onScrolledUpward();
    },
    onScrolledUpward: function onScrolledUpward() {
      this.checkLoadPrevious();
      this.syncCurrentPageFromBoundaries();
    },
    checkLoadPrevious: function checkLoadPrevious() {
      if (!this.marketsPageInitialLoadDone) return;
      var sentinel = this.$refs.loadPreviousSentinel;
      if (!sentinel) return;
      var rect = sentinel.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) this.loadPrevious();
    },
    syncCurrentPageFromBoundaries: function syncCurrentPageFromBoundaries() {
      if (this.embedded || !this.marketsPageInitialLoadDone || !this.$el) return;
      var referenceY = window.innerHeight / 2;
      var primaryPage = null;
      this.$el.querySelectorAll('[data-page-boundary]').forEach(function (el) {
        var pageNumber = parseInt(el.getAttribute('data-page-boundary'), 10);
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(pageNumber)) return;
        if (el.getBoundingClientRect().top <= referenceY && (primaryPage === null || pageNumber > primaryPage)) {
          primaryPage = pageNumber;
        }
      });
      if (primaryPage === null || primaryPage === this.currentDisplayedPage) return;
      this.currentDisplayedPage = primaryPage;
      this.syncQueryToUrl({ page: primaryPage > 1 ? primaryPage : undefined });
    },
    observePageBoundaries: function observePageBoundaries() {
      var _this8 = this;

      if (!this.pageBoundaryObserver) return;
      this.$nextTick(function () {
        _this8.resetBoundaryTracking();
        var boundaryEls = _this8.$el.querySelectorAll('[data-page-boundary]');
        boundaryEls.forEach(function (el) {
          _this8.observedBoundaryEls.add(el);
          _this8.pageBoundaryObserver.observe(el);
        });
      });
    },

    // observedBoundaryEls and the observer keep strong references
    // to detached nodes for the rest of the component's lifetime
    resetBoundaryTracking: function resetBoundaryTracking() {
      var _this9 = this;

      if (this.pageBoundaryObserver) {
        this.observedBoundaryEls.forEach(function (el) {
          return _this9.pageBoundaryObserver.unobserve(el);
        });
      }
      this.observedBoundaryEls.clear();
    },
    onPageBoundaryIntersect: function onPageBoundaryIntersect(entries) {
      var _this10 = this;

      var visiblePages = entries.filter(function (entry) {
        return entry.isIntersecting;
      }).map(function (entry) {
        return parseInt(entry.target.getAttribute('data-page-boundary'), 10);
      }).filter(function (pageNumber) {
        return !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(pageNumber);
      });
      if (!visiblePages.length) return;
      var primaryPage = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(visiblePages));
      if (primaryPage === this.currentDisplayedPage) return;

      clearTimeout(this.syncPageDebounceTimer);
      this.syncPageDebounceTimer = setTimeout(function () {
        _this10.currentDisplayedPage = primaryPage;
        _this10.syncQueryToUrl({ page: primaryPage > 1 ? primaryPage : undefined });
      }, 200);
    },

    // not $router.replace, to avoid re-triggering the $route watcher's filter/timespan reset
    syncQueryToUrl: function syncQueryToUrl(overrides) {
      var currentQuery = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_helpers__["I" /* parseQuery */])(window.location.search || '');
      var resolvedRoute = this.$router.resolve({
        name: 'market-list',
        params: {
          headerId: this.headerId,
          headerUrl: this.headerUrl
        },
        query: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, currentQuery, overrides)
      });
      window.history.replaceState(window.history.state, document.title, resolvedRoute.href);
      this.canonicalUrl = window.location.href;
    },

    // Self-heals legacy/bare links (?sortParameter=WEEK with no dates) once the
    // range is resolved, so shared/indexed URLs become absolute going forward.
    upgradeLegacyTimespanUrl: function upgradeLegacyTimespanUrl() {
      if (this.embedded) return;
      var _selectedTimespan = this.selectedTimespan,
          dateFrom = _selectedTimespan.dateFrom,
          dateTo = _selectedTimespan.dateTo;

      if (!dateFrom || !dateTo) return;
      if (this.$route.query.dateFrom === dateFrom && this.$route.query.dateTo === dateTo) return;
      this.syncQueryToUrl({ dateFrom: dateFrom, dateTo: dateTo });
    }
  }),
  watch: {
    $route: {
      handler: function handler(to, from) {
        var _this11 = this;

        this.canonicalUrl = window.location.href;
        var targetHeaderId = parseInt(to.params && to.params.headerId, 10) || 0;
        var previousHeaderId = from ? parseInt(from.params && from.params.headerId, 10) || 0 : null;
        var prevRoute = this.previousRoute || '';
        var returningFromMarketDetails = prevRoute.startsWith('/markets/detail/') && this.marketsPageInitialLoadDone && this.marketListCachedHeaderId === targetHeaderId && this.filteredMarkets.data && this.filteredMarkets.data.length > 0;

        if (returningFromMarketDetails) return;

        this.watchersDisabled = true;
        this.setMarketsPageInitialLoadDone(false);
        this.clearFilters();
        this.clearOrder();
        this.clearTimespan();

        if (to.query.filterIds) {
          to.query.filterIds.split(',').forEach(function (i) {
            var filterId = parseInt(i, 10);
            if (filterId) _this11.$store.dispatch('browse/addFilter', filterId);
          });
        }
        if (to.query.sortParameter) {
          this.$store.dispatch('browse/setTimespanFromQuery', {
            parameter: to.query.sortParameter,
            dateFrom: to.query.dateFrom,
            dateTo: to.query.dateTo
          });
        }
        if (to.query.sort) {
          this.$store.dispatch('browse/setOrderFromQuery', to.query.sort);
        }
        this.upgradeLegacyTimespanUrl();

        this.$nextTick(function () {
          _this11.watchersDisabled = false;
        });

        // to avoid firing two overlapping fetches for the same navigation.
        var headerIdChanging = previousHeaderId !== null && targetHeaderId !== previousHeaderId;
        if (from && !headerIdChanging && !this.isFiltering && !this.embedded) {
          var targetPage = Math.max(1, parseInt(to.query.page, 10) || 1);
          if (targetPage !== this.currentDisplayedPage) {
            this.currentDisplayedPage = targetPage;
            this.resetBoundaryTracking();
            this.getFilteredMarkets({ headerId: targetHeaderId, reset: true, page: targetPage }).then(function () {
              _this11.setMarketsPageInitialLoadDone(true);
              _this11.redirectIfPageOutOfRange();
            }).catch(function () {
              _this11.setMarketsPageInitialLoadDone(true);
            });
          }
        }
      },

      immediate: true
    },
    headerId: {
      handler: 'headerIdChanged',
      immediate: true
    },
    filtering: 'filteringChanged',
    isLoggedIn: 'fetchData',
    items: function items() {
      this.isInfiniteLoading = false;
      this.observeLoadMoreSentinel();
      this.observePageBoundaries();
    },

    // the first observe() call can run before the sentinel exists in the DOM
    marketsPageInitialLoadDone: function marketsPageInitialLoadDone(isDone) {
      if (!isDone) return;
      this.observeLoadMoreSentinel();
      this.observePageBoundaries();
    }
  },
  created: function created() {
    this.canonicalUrl = window.location.href;
    if (this.notificationText && this.notificationLevel) {
      this.setSideNotification({
        text: this.notificationText,
        level: this.notificationLevel
      });
    }
  },
  mounted: function mounted() {
    this.setupScrollObservers();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.loadMoreObserver) this.loadMoreObserver.disconnect();
    window.removeEventListener('wheel', this.onWheel);
    window.removeEventListener('touchstart', this.onTouchStart);
    window.removeEventListener('touchmove', this.onTouchMove);
    if (this.pageBoundaryObserver) this.pageBoundaryObserver.disconnect();
    clearTimeout(this.syncPageDebounceTimer);
    if (this.embedded) {
      this.watchersDisabled = true;
      this.resetFilteredMarkets();
      this.clearFilters();
      this.clearOrder();
      this.clearTimespan();
    }
  }
});

/***/ }),

/***/ "i8vA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_nav_browse_js__ = __webpack_require__("/Tgi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c47b5a0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_browse_vue__ = __webpack_require__("trS8");
function injectStyle (ssrContext) {
  __webpack_require__("kTXh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_nav_browse_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c47b5a0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_browse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iHgG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iOdY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iSNB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"socials"},[_c('h5',{staticClass:"socials__title"},[_vm._v(_vm._s(_vm.title)+" "+_vm._s(_vm.availableSocials))]),_vm._v(" "),(!_vm.isComponentReady)?_c('socials-loader'):_c('div',{staticClass:"socials__items"},[(_vm.facebookLink)?_c('div',{staticClass:"socials__item"},[_c('a',{staticClass:"socials__button socials__button--facebook",attrs:{"href":_vm.facebookLink},on:{"click":function($event){return _vm.registrationTrack('Facebook')}}})]):_vm._e(),_vm._v(" "),(_vm.googleLink)?_c('div',{staticClass:"socials__item"},[_c('a',{staticClass:"socials__button socials__button--google",attrs:{"href":_vm.googleLink},on:{"click":function($event){return _vm.registrationTrack('Google')}}})]):_vm._e(),_vm._v(" "),(_vm.twitterLink)?_c('div',{staticClass:"socials__item"},[_c('a',{staticClass:"socials__button socials__button--twitter",attrs:{"href":_vm.twitterLink},on:{"click":function($event){return _vm.registrationTrack('Twitter')}}})]):_vm._e()]),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"socials__line"},[_c('div',{staticClass:"socials__line-border"}),_vm._v(" "),_c('div',{staticClass:"socials__line-label"},[_vm._v("OR")]),_vm._v(" "),_c('div',{staticClass:"socials__line-border"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iYpn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    contract: {
      type: Object,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_2__models_contract__["a" /* default */](this.contract);
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["k" /* isMarketSingle */])(this.market);
    },
    title: function title() {
      if (!this.isMarketSingle) return this.contractModel.contractName || this.contractModel.name;
      return this.contract.noContract ? 'No' : 'Yes';
    },
    hasLastTradePrice: function hasLastTradePrice() {
      return this.contractModel.hasLastTradePrice;
    },
    price: function price() {
      var lastPrice = this.contractModel.lastTradePriceAsCents;
      if (!this.hasLastTradePrice) return 0;
      if (!this.isMarketSingle) return lastPrice;
      if (this.contract.noContract) {
        return 100 - lastPrice;
      }
      return lastPrice;
    },
    changePrice: function changePrice() {
      if (!this.hasLastTradePrice) return 0;
      var price = this.contractModel.changePriceAsCents;
      return this.contract.noContract ? -price : price;
    },
    classModifiers: function classModifiers() {
      return {
        'market-contract-v2': true
      };
    },
    isDisabled: function isDisabled() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["C" /* isContractOpen */])(this.contractModel);
    },
    contractRoute: function contractRoute() {
      var query = { contractId: this.contract.contractId };
      if (this.contract.noContract) {
        query.no = 'true';
      }
      return {
        name: 'market-details',
        params: { marketId: this.market.marketId },
        query: query
      };
    }
  })
});

/***/ }),

/***/ "iaga":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ib9I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-shares-item-loader"},[_c('div',{staticClass:"market-shares-item-loader__image"}),_vm._v(" "),_c('div',{staticClass:"market-shares-item-loader__content"},[_c('div',{staticClass:"market-shares-item-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"market-shares-item-loader__text-2"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ibDk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ifvC":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xMiAxNC4yM2MxLjM0OSAwIDIuNDM5LTEuMDM1IDIuNDM5LTIuMzE0IDAtMS4yOC0xLjA5Mi0yLjMxNi0yLjQzOC0yLjMxNi0xLjM2NyAwLTIuNDQgMS4wNTctMi40MzggMi4zMTUuMDAzIDEuMjgyIDEuMDg5IDIuMzE1IDIuNDM4IDIuMzE1em0zLjE0MS0uMTE0Yy0uNzQ2LjkyMi0xLjcyOCAxLjQzLTIuOTUxIDEuNDk5LS43MTcuMDQxLTEuNDMyLS4xMTUtMi4wNjYtLjQ1Mi0uNjMzLS4zMjItMS4xNjItLjgxOC0xLjUyMi0xLjQzLS41MDctLjg2My0uNjI3LTEuNzgtLjM3OC0yLjc0MmgtMS4xdjUuMDU2YzAgLjAyNSAwIC4wNS4wMDMuMDc1LjAxLjA5My4wNDYuMTgxLjEwNi4yNTMuMDYuMDcyLjE0LjEyNC4yMy4xNS4wNjMuMDE2LjEyNy4wMjQuMTkxLjAyMmg4LjY5N2MuMDQ2LjAwMS4wOTItLjAwMy4xMzctLjAxLjEwOC0uMDE4LjIwNy0uMDczLjI3OC0uMTU3LjA3LS4wODMuMTEtLjE4OC4xMS0uMjk4di01LjA4OUgxNS43OGMuMjggMS4xMzMuMDczIDIuMTc1LS42MzkgMy4xMjN6TTIyLjU5MSAwSDEuNDFDMS4wMzcuMDAxLjY4LjE1LjQxNC40MTUuMTUuNjc5LjAwMSAxLjAzOCAwIDEuNDEyVjIyLjU5Yy4wMDIuMzc0LjE1LjczMi40MTUuOTk2LjI2NC4yNjQuNjIyLjQxMy45OTYuNDE0aDIxLjE4Yy4zNzMtLjAwMi43My0uMTUuOTk0LS40MTUuMjY0LS4yNjQuNDEzLS42MjEuNDE1LS45OTVWMS40MTJjLS4wMDEtLjM3NC0uMTUtLjczMi0uNDE0LS45OTctLjI2NC0uMjY0LS42MjItLjQxNC0uOTk2LS40MTV6bS00LjUyNCAxNS43NjRjMCAxLjE4LS45OSAyLjE0NC0yLjIgMi4xNDRIOC4xMzVjLTEuMjEyIDAtMi4yLS45NjQtMi4yLTIuMTQ0VjguMjM4YzAtMS4xNzkuOTktMi4xNDQgMi4yLTIuMTQ0aDcuNzMyYzEuMjExIDAgMi4yLjk2NCAyLjIgMi4xNDR2Ny41Mjd6bS0xLjY4NS04LjQ4MWgtMS40NDRjLS4yODMgMC0uNDk3LjIwMi0uNDk4LjQ3djEuMzgxYzAgLjAyMi4wMDIuMDQ0LjAwNS4wNjUuMDIuMTE1LjA4LjIxOS4xNy4yOTMuMDkuMDc0LjIwMy4xMTMuMzIuMTEuMjQtLjAwMy40ODEgMCAuNzIyIDBoLjcyM2MuMDMxLjAwMS4wNjMgMCAuMDkzLS4wMDUuMTEyLS4wMTUuMjE1LS4wNy4yOS0uMTU0LjA3NC0uMDg1LjExNS0uMTk0LjExNS0uMzA3VjcuNzU0YzAtLjAyNS0uMDAxLS4wNS0uMDA1LS4wNzUtLjAyLS4xMTQtLjA4MS0uMjE3LS4xNzEtLjI5LS4wOS0uMDcyLS4yMDQtLjExLS4zMi0uMTA1di0uMDAxeiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "ihRI":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MiIgaGVpZ2h0PSI4MiIgdmlld0JveD0iMCAwIDgyIDgyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iNDAiIGN5PSI0MCIgcj0iNDAuNSIgc3Ryb2tlPSIjNDJDRjI2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDEpIi8+CiAgICAgICAgPHBhdGggZmlsbD0iIzQyQ0YyNiIgZD0iTTYwLjY0MiAzMS4yNDJsLTIxLjkyNCAyMi45NGEzLjQ5NSAzLjQ5NSAwIDAgMS01LjEwNiAwbC05LjE1OC05LjU3OWMtMS40MDgtMS40NzctMS40MDgtMy44NjkgMC01LjM0NmEzLjUwMSAzLjUwMSAwIDAgMSA1LjEwNiAwbDYuNjA1IDYuOTFMNTUuNTM1IDI1LjlhMy40OTUgMy40OTUgMCAwIDEgNS4xMDcgMGMxLjQxMiAxLjQ3NCAxLjQxMiAzLjg2NiAwIDUuMzQzIi8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "ikte":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{class:_vm.iconClassModifiers}),_vm._v(" "),_c('div',{staticClass:"market-disabled-outcome-v2__text"},[_vm._v("\n      "+_vm._s(_vm.buttonText)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iocs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contract-list-v2-embed",class:{ 'market-contract-list-v2-embed--narrow': _vm.isNarrowContainer }},[_c('market-contracts-list-header-sushi',{attrs:{"market":_vm.market,"forCmsWidget":true,"force-mobile-layout":_vm.isNarrowContainer}}),_vm._v(" "),_c('div',{staticClass:"market-contract-list-v2-embed__contracts",attrs:{"data-newtab":_vm.openNewTab.toString()}},_vm._l((_vm.market.contracts),function(contract,index){return _c('div',{key:contract.contractId,staticClass:"market-contract-list-v2-embed__contract",class:{ 'market-contract-list-v2-embed__contract--last': index === _vm.market.contracts.length - 1 }},[(_vm.isLayoutDesktop && !_vm.isNarrowContainer)?_c('market-contract-horizontal-sushi',{attrs:{"data-contract-id":contract.contractId,"market":_vm.market,"contract":contract,"forCmsWidget":true},on:{"contractClicked":_vm.onContractClick}}):_c('market-contract-horizontal-sushi-mobile',{attrs:{"data-contract-id":contract.contractId,"market":_vm.market,"contract":contract,"forCmsWidget":true},on:{"contractClicked":_vm.onContractClick}}),_vm._v(" "),(index !== _vm.market.contracts.length - 1)?_c('div',{staticClass:"market-contract-list-v2-embed__contract-line"}):_vm._e()],1)}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "irZi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ircP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_coinbase_js__ = __webpack_require__("/JWN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c86190a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_coinbase_vue__ = __webpack_require__("07Ut");
function injectStyle (ssrContext) {
  __webpack_require__("Cyq+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_coinbase_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c86190a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_coinbase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "itDa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iuvl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-key-stats-element",on:{"click":_vm.onClick}},[_c('div',{staticClass:"market-key-stats-element__title"},[_vm._v("\n    "+_vm._s(_vm.obj.title)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"market-key-stats-element__wrap market-key-stats-element__wrap--left"},[_c('div',{staticClass:"market-key-stats-element__center"},[_c('div',{staticClass:"market-key-stats-element__percent"},[_vm._v(_vm._s(Number(_vm.obj.valueA).toFixed(1))),_c('span',{staticClass:"market-key-stats-element__sign"},[_vm._v("%")])]),_vm._v(" "),(_vm.obj.valueAHasTrend)?_c('div',{staticClass:"market-key-stats-element__delta"},[_c('market-change-price',{attrs:{"price":_vm.obj.valueATrendPercentage,"percent":true}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"market-key-stats-element__sub-title"},[_vm._v(_vm._s(_vm.obj.valueASubtitle))])]),_vm._v(" "),_c('div',{staticClass:"market-key-stats-element__wrap market-key-stats-element__wrap--right"},[_c('div',{staticClass:"market-key-stats-element__center"},[_c('div',{staticClass:"market-key-stats-element__percent"},[_vm._v(_vm._s(Number(_vm.obj.valueB).toFixed(1))),_c('span',{staticClass:"market-key-stats-element__sign"},[_vm._v("%")])]),_vm._v(" "),(_vm.obj.valueBHasTrend)?_c('div',{staticClass:"market-key-stats-element__delta"},[_c('market-change-price',{attrs:{"price":_vm.obj.valueBTrendPercentage,"percent":true}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"market-key-stats-element__sub-title"},[_vm._v(_vm._s(_vm.obj.valueBSubtitle))])]),_vm._v(" "),_c('div',{staticClass:"market-key-stats-element__footer"},[(_vm.obj.urlData)?_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":_vm.obj.urlData},on:{"click":function($event){return $event.stopPropagation()}}},[_vm._v("\n      "+_vm._s(_vm.obj.source)+"\n    ")]):_c('a',{attrs:{"href":"#"}},[_vm._v("\n      "+_vm._s(_vm.obj.source)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j8BG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_amount_overview_js__ = __webpack_require__("Zb6m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11cfabe8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_amount_overview_vue__ = __webpack_require__("gi1v");
function injectStyle (ssrContext) {
  __webpack_require__("bfxh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11cfabe8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_amount_overview_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11cfabe8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_amount_overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jE9O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jLJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) {
  window.Swiper = __webpack_require__("gsqX");
  __webpack_require__("v2ns");
}
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function mount() {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    };
    this.options.notNextTick ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),

/***/ "jNuG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers,on:{"click":_vm.toggleMobileMenu}},[_c('div',{staticClass:"hamburger-icon__icon"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jPoG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return regularContractPrice; });
/* unused harmony export noContractPrice */
function regularContractPrice(contractData) {
  if (contractData.closeSharePrice === null) return null;
  return Number((100 * contractData.closeSharePrice).toFixed(2));
}

function noContractPrice(contractData) {
  if (contractData.closeSharePrice === null) return null;
  return Number((100 - contractData.closeSharePrice * 100).toFixed(2));
}



/***/ }),

/***/ "jWsT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-winner-v2"},[_c('div',{staticClass:"market-winner-v2__title"},[_vm._v("\n    Winner\n  ")]),_vm._v(" "),_c('div',{staticClass:"market-winner-v2__icon"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "joAC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    checked: {
      type: String
    },
    value: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('change', this.value);
    },
    onChange: function onChange(e) {
      this.$emit('change', e.target.value);
    }
  }
});

/***/ }),

/***/ "jtVE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_button_direction_js__ = __webpack_require__("GSOF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51ee3226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_button_direction_vue__ = __webpack_require__("utJg");
function injectStyle (ssrContext) {
  __webpack_require__("dSN9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_button_direction_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51ee3226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_button_direction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jtWA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['setWatchedUserDetails']), {
    showUserDetails: function showUserDetails(item) {
      var profitablePredictions = (typeof item.totalProfitablePredictions !== 'undefined' ? item.totalProfitablePredictions : item.profitablePredictions) || 0;
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_modals_constants__["a" /* MODALS */].SMALL_USER_PROFILE);
      var trader = {
        userName: item.userName,
        avatarImage: item.avatarImage,
        traderLevel: item.traderLevel || null,
        profitablePredictions: profitablePredictions
      };
      this.setWatchedUserDetails(trader);
    }
  })
});

/***/ }),

/***/ "k0c/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iNyIgc3Ryb2tlPSIjOTQ5NDk0IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "k37b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INTERACTION_TYPE; });
/* unused harmony export pushDataLayer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withMeta; });
/* unused harmony export pushInstall */
/* unused harmony export pushRetention */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return pushPageview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return pushUserIdentity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getUniqueViewGUID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return pushPreviewUniqueView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pushStoryInteraction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fireTrackMMPInstall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fireTrackRetention; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_sessionVars__ = __webpack_require__("DECz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");








var INSTALL_DATE_KEY = 'mmp_install_date';
var RETENTION_FIRED_KEY = 'mmp_retention_fired';
var RETENTION_DAYS = [1, 7, 30];

var INTERACTION_TYPE = {
  CONTRACT_CURRENT_PRICE_LIST: 'Contract_Current_Price_List',
  READ_MORE: 'Read_More',
  MARKET_TILE: 'Market_Tile',
  CHART_INTERACTION: 'Chart_Interaction',
  VIDEO_PLAY: 'Video_Play',
  VIEW_MARKET: 'View_Market'
};

var pushDataLayer = function pushDataLayer(payload) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

var withMeta = function withMeta(payload) {
  var event = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    wrapper: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__mixins_userAgent__["b" /* getWrapperForTracking */])()
  }, payload);
  __WEBPACK_IMPORTED_MODULE_5__logger__["a" /* default */].info('[DATALAYER] New event', event);
  return event;
};

var pushInstall = function pushInstall(mmpInstallId) {
  return pushDataLayer(withMeta({ event: 'install', mmpInstallId: mmpInstallId }));
};

var pushRetention = function pushRetention(retentionMark, day) {
  return pushDataLayer(withMeta({ event: 'retention', retentionMark: retentionMark, day: day }));
};

var pushPageview = function pushPageview(virtualPage, virtualPageTitle) {
  return pushDataLayer(withMeta({ event: 'pageviewTrackerEvent', virtualPage: virtualPage, virtualPageTitle: virtualPageTitle }));
};

var pushUserIdentity = function pushUserIdentity(gtmUserID, otmUserID) {
  return pushDataLayer(withMeta({ gtmUserID: gtmUserID, otmUserID: otmUserID }));
};

var getUniqueViewGUID = function getUniqueViewGUID() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["a" /* uuidv4 */])();
};

var pushPreviewUniqueView = function pushPreviewUniqueView(_ref) {
  var storyId = _ref.storyId,
      storyVersionId = _ref.storyVersionId,
      sectionId = _ref.sectionId,
      sectionType = _ref.sectionType,
      previewUniqueViewGUID = _ref.previewUniqueViewGUID;
  return pushDataLayer(withMeta({
    event: 'Preview_Unique_View',
    Story_Id: storyId,
    Story_Version_Id: storyVersionId,
    Section_Id: sectionId,
    Section_Type: sectionType,
    PreviewUniqueViewGUID: previewUniqueViewGUID
  }));
};

var pushStoryInteraction = function pushStoryInteraction(_ref2) {
  var interactionType = _ref2.interactionType,
      storyId = _ref2.storyId,
      storyVersionId = _ref2.storyVersionId,
      sectionId = _ref2.sectionId,
      regionId = _ref2.regionId,
      regionTrackingId = _ref2.regionTrackingId,
      previewUniqueViewGUID = _ref2.previewUniqueViewGUID;
  return pushDataLayer(withMeta({
    event: 'Story_Interaction',
    Interaction_Type: interactionType,
    Story_Id: storyId,
    Story_Version_Id: storyVersionId,
    Section_Id: sectionId,
    Region_Id: regionId,
    Region_Tracking_Id: regionTrackingId,
    PreviewUniqueViewGUID: previewUniqueViewGUID
  }));
};

var getDaysSinceInstall = function getDaysSinceInstall(installTimestamp) {
  var nowDay = new Date().setHours(0, 0, 0, 0);
  var installDay = new Date(installTimestamp).setHours(0, 0, 0, 0);
  return Math.floor((nowDay - installDay) / 86400000);
};

var fireTrackMMPInstall = function fireTrackMMPInstall() {
  var mmpInstallIdVar = __WEBPACK_IMPORTED_MODULE_4__helpers_sessionVars__["a" /* default */].get('mmpInstallId');
  if (!mmpInstallIdVar) return;
  pushInstall(mmpInstallIdVar.value);
};

var fireTrackRetention = function fireTrackRetention() {
  var installDate = __WEBPACK_IMPORTED_MODULE_2__helpers_localStorage__["a" /* default */].get(INSTALL_DATE_KEY);
  if (!installDate) {
    installDate = Date.now();
    __WEBPACK_IMPORTED_MODULE_2__helpers_localStorage__["a" /* default */].set(INSTALL_DATE_KEY, installDate);
  }

  var firedDays = __WEBPACK_IMPORTED_MODULE_2__helpers_localStorage__["a" /* default */].get(RETENTION_FIRED_KEY) || [];
  var daysSince = getDaysSinceInstall(installDate);
  var toFire = RETENTION_DAYS.filter(function (d) {
    return d <= daysSince && !firedDays.includes(d);
  });

  if (!toFire.length) return;

  toFire.forEach(function (mark) {
    return pushRetention(mark, daysSince);
  });
  __WEBPACK_IMPORTED_MODULE_2__helpers_localStorage__["a" /* default */].set(RETENTION_FIRED_KEY, [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(firedDays), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(toFire)));
};

/***/ }),

/***/ "kGUT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(!_vm.isComponentReady)?_c('div',{staticClass:"hero-unit-slider__loader"}):_c('swiper',{attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.items),function(banner){return _c('swiper-slide',{key:banner.carouselId,staticClass:"hero-unit-slider__slide"},[_c('div',{staticClass:"hero-unit-slider__image",style:(_vm.bannerImageStyleModifiers(banner.carouselData.image))}),_vm._v(" "),_c('div',{staticClass:"hero-unit-slider__content"},[(banner.carouselData.carouselItemHeader.secondLine)?_c('p',{staticClass:"hero-unit-slider__para",domProps:{"innerHTML":_vm._s(banner.carouselData.carouselItemHeader.secondLine)}}):_vm._e(),_vm._v(" "),(banner.carouselData.carouselItemHeader.firstLine)?_c('h2',{staticClass:"hero-unit-slider__headline",domProps:{"innerHTML":_vm._s(banner.carouselData.carouselItemHeader.firstLine)}}):_vm._e(),_vm._v(" "),(banner.carouselData.carouselItemButton)?[(_vm.isUrlExternal(banner))?_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],staticClass:"button button--medium button--submit hero-unit-slider__button",style:(_vm.buttonStyleModifiers(banner.carouselData.carouselItemButton)),attrs:{"href":_vm.getBannerUrl(banner)},domProps:{"innerHTML":_vm._s(banner.carouselData.carouselItemButton.text)}}):_c('router-link',{staticClass:"button button--medium button--submit hero-unit-slider__button",style:(_vm.buttonStyleModifiers(banner.carouselData.carouselItemButton)),attrs:{"to":_vm.getBannerUrl(banner)},domProps:{"innerHTML":_vm._s(banner.carouselData.carouselItemButton.text)}})]:_vm._e()],2)])}),_vm._v(" "),_c('div',{staticClass:"hero-unit-slider__pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kGlu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_filters_filter_button_filter_button_vue__ = __webpack_require__("3GDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_filters_menu_button_menu_button_vue__ = __webpack_require__("Q/ey");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    filterButton: __WEBPACK_IMPORTED_MODULE_4__components_market_market_filters_filter_button_filter_button_vue__["a" /* default */],
    menuButton: __WEBPACK_IMPORTED_MODULE_5__components_market_market_filters_menu_button_menu_button_vue__["a" /* default */]
  },
  props: {
    theme: {
      type: String,
      default: 'sushi'
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      ordersOpen: false,
      filtersOpen: false,
      timespansOpen: false,
      isDashboardOpen: false,
      isWatchlistOpen: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('browse', ['filters', 'orders', 'timespans', 'selectedFilters', 'selectedOrder', 'selectedTimespan', 'shouldShowTimespanFilter']), {
    mainClassName: function mainClassName() {
      return 'market-filters';
    },
    filterMenuName: function filterMenuName() {
      var prefix = 'Keywords';
      if (this.selectedFilters && this.selectedFilters.length > 0) {
        return prefix + ' (' + this.selectedFilters.length + ')';
      }
      return prefix;
    },
    orderMenuName: function orderMenuName() {
      return 'Sort By';
    },
    classModifier: function classModifier() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName, true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--embedded', this.embedded), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--is-open', this.filtersOpen || this.ordersOpen || this.timespansOpen), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--is-open-order', this.ordersOpen), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--is-open-filters', this.filtersOpen), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--is-open-timespans', this.timespansOpen), _ref;
    },
    availableTimespanOptions: function availableTimespanOptions() {
      if (this.selectedOrder && this.selectedOrder.sort === 'movers') {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.timespans)).filter(function (i) {
          return i.parameter !== 'ALL';
        });
      }
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.timespans)).filter(function (i) {
        return i.parameter !== '3DAY';
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('browse', ['addFilter', 'removeFilter', 'selectOrder', 'selectTimespan', 'clearFilters']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('overlay', {
    hideOverlay: 'hide',
    showOverlay: 'show'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('dashboard', {
    dashSelectOrder: 'selectOrder',
    dashSelectTimespan: 'selectTimespan'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('watchlist', {
    watchSelectOrder: 'selectOrder',
    watchSelectTimespan: 'selectTimespan'
  }), {
    orderList: function orderList(kind) {
      var marketsDisabledSorts = ['gain', 'loss', 'investment'];

      return kind === 'markets' ? this.orders.filter(function (i) {
        return !marketsDisabledSorts.includes(i.sort);
      }) : this.orders;
    },
    onAddFilter: function onAddFilter(filterId) {
      this.addFilter(filterId);
      if (this.embedded) {
        this.closeFilters();
      }
    },
    onRemoveFilter: function onRemoveFilter(filterId) {
      this.removeFilter(filterId);
      if (this.embedded) {
        this.closeFilters();
      }
    },
    onClearFilters: function onClearFilters() {
      this.clearFilters();
      if (this.embedded) {
        this.closeFilters();
      }
    },
    toggleFilters: function toggleFilters() {
      this.filtersOpen = !this.filtersOpen;
      this.ordersOpen = false;
      this.timespansOpen = false;
    },
    toggleOrder: function toggleOrder() {
      this.ordersOpen = !this.ordersOpen;
      this.filtersOpen = false;
      this.timespansOpen = false;
    },
    toggleTimespans: function toggleTimespans() {
      this.timespansOpen = !this.timespansOpen;
      this.filtersOpen = false;
      this.ordersOpen = false;
    },
    selectOrderAndClose: function selectOrderAndClose(sort) {
      if (this.isWatchlistOpen) {
        this.watchSelectOrder(sort);
      } else if (this.isDashboardOpen) {
        this.dashSelectOrder(sort);
      } else {
        this.selectOrder(sort);
      }
      this.toggleOrder();
    },
    selectTimespanAndClose: function selectTimespanAndClose(timespan) {
      if (this.isWatchlistOpen) {
        this.watchSelectTimespan(timespan);
      } else if (this.isDashboardOpen) {
        this.dashSelectTimespan(timespan);
      } else {
        this.selectTimespan(timespan);
      }
      this.toggleTimespans();
    },
    selectTimespanOnly: function selectTimespanOnly(timespan) {
      this.selectTimespan(timespan);
    },
    filterSelected: function filterSelected(filterId) {
      return this.selectedFilters.includes(filterId);
    },
    orderSelected: function orderSelected(sort) {
      return this.selectedOrder.sort === sort;
    },
    closeFilters: function closeFilters() {
      this.filtersOpen = false;
      this.ordersOpen = false;
      this.timespansOpen = false;
    },
    filterKey: function filterKey(filter) {
      return filter.filterId.toString() + this.filterSelected(filter.filterId).toString();
    }
  })
});

/***/ }),

/***/ "kHwo":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiByeD0iOSIgZmlsbD0iIzJBODg1NiIvPgo8cGF0aCBkPSJNMTEuODM1NyA2LjE0OTMxQzExLjY3IDUuNTQxNTcgMTAuODY3OCA0LjMyNjExIDguOTg0OTEgNC4zMjYxMUM4LjA3ODgzIDQuMzA0MDEgNi4yNjY2OCA0LjY1NzQ2IDYuMTY3MjMgNi41NDY5MUM2LjA3MzAxIDguMzM3MDIgOC4xODkzMyA4Ljc2ODA4IDguOTg0OTEgOS4wNjY0MkM5LjkzNTE5IDkuMjQzMTggMTEuODM1NyA5Ljk3NDU5IDExLjgzNTcgMTEuNDg2MkMxMS44MzU3IDEzLjM3NTcgOS40ODIxNSAxMy43NzM1IDguOTg0OTEgMTMuNzczNUM4LjQ4NzY3IDEzLjc3MzUgNi40NjU1OCAxMy42MDc3IDYuMTY3MjMgMTEuOTgzNE04Ljk4NDkxIDNMOC45ODQ5MSAxNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "kM50":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "kTXh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kdgD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kjig":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contracts-stats"},[(_vm.isLayoutDesktop)?_c('div',{staticClass:"market-contracts-stats__market-name"},[_vm._v(_vm._s(_vm.market.marketName))]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"market-contracts-stats__table"},[_c('thead',{staticClass:"market-contracts-stats__thead"},[(_vm.isSortable)?_c('th',{staticClass:"market-contracts-stats__table-name",on:{"click":function($event){return _vm.sortBy('displayOrder')}}},[_c('span',{class:_vm.headerSortByModifiers('displayOrder')},[_vm._v("\n          Contract\n        ")])]):_vm._e(),_vm._v(" "),_c('th',{class:_vm.secondColumnModifiers,on:{"click":function($event){return _vm.sortBy('totalSharesTraded')}}},[_c('span',{class:_vm.headerSortByModifiers('totalSharesTraded')},[_vm._v("\n          Total Volume\n        ")])]),_vm._v(" "),(!_vm.isMarketSettled)?[_c('th',{class:_vm.thirdColumnModifiers,on:{"click":function($event){return _vm.sortBy('todaysVolume')}}},[_c('span',{class:_vm.headerSortByModifiers('todaysVolume')},[_vm._v("\n            Today's Volume\n          ")])]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('th',{staticClass:"market-contracts-stats--last",on:{"click":function($event){return _vm.sortBy('openInterest')}}},[_c('span',{class:_vm.headerSortByModifiers('openInterest')},[_vm._v("\n            Active Shares\n          ")])]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('tbody',[_vm._l((_vm.sortedItems),function(item,index){return _c('tr',{key:index},[(_vm.isSortable)?_c('td',{staticClass:"market-contracts-stats__table-name"},[_vm._v("\n          "+_vm._s(item.contractName)+"\n        ")]):_vm._e(),_vm._v(" "),_c('td',{class:_vm.secondColumnModifiers},[_vm._v("\n          "+_vm._s(item.totalSharesTraded.toLocaleString())+"\n        ")]),_vm._v(" "),(!_vm.isMarketSettled)?[_c('td',{class:_vm.thirdColumnModifiers},[_vm._v("\n            "+_vm._s(item.todaysVolume.toLocaleString())+"\n          ")]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('td',{staticClass:"market-contracts-stats--last"},[_vm._v("\n            "+_vm._s(item.openInterest.toLocaleString())+"\n          ")]):_vm._e()]:_vm._e()],2)}),_vm._v(" "),(_vm.isSortable)?_c('tr',[_c('td',{staticClass:"market-contracts-stats__table-name market-contracts-stats__table-name--bold market-contracts-stats__table-summary"},[_vm._v("\n          Total\n        ")]),_vm._v(" "),_c('td',{staticClass:"market-contracts-stats__table-summary",class:_vm.secondColumnModifiers},[_vm._v("\n          "+_vm._s(_vm.totalSharesTradedSum)+"\n        ")]),_vm._v(" "),(!_vm.isMarketSettled)?[_c('td',{staticClass:"market-contracts-stats__table-summary",class:_vm.thirdColumnModifiers},[_vm._v("\n            "+_vm._s(_vm.todaysVolumeSum)+"\n          ")]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('td',{staticClass:"market-contracts-stats__table-summary market-contracts-stats--last"},[_vm._v("\n            "+_vm._s(_vm.openInterestSum)+"\n          ")]):_vm._e()]:_vm._e()],2):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l8Or":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_code_input_js__ = __webpack_require__("KNAh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65f46f47_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_code_input_vue__ = __webpack_require__("154o");
function injectStyle (ssrContext) {
  __webpack_require__("wRUy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_code_input_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65f46f47_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_code_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l9wN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_combined_js__ = __webpack_require__("oaFs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b27a8014_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_combined_vue__ = __webpack_require__("JLrH");
function injectStyle (ssrContext) {
  __webpack_require__("jE9O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_combined_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b27a8014_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_combined_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lBfC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lDJT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lPAh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lZ3N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    showExport: {
      type: Boolean,
      default: false
    },
    activeTab: {
      type: String,
      default: null
    }
  },
  methods: {
    onExport: function onExport() {
      this.$emit('export', this.activeTab);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['transactionHistory', 'tradeHistory']), {
    isExportAvailable: function isExportAvailable() {
      var hasItems = this.activeTab === 'trades' ? true : this.transactionHistory && this.transactionHistory.data && this.transactionHistory.data.length > 0;

      return this.showExport && hasItems;
    }
  })
});

/***/ }),

/***/ "lmGd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_profile_js__ = __webpack_require__("y8UT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b632c34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__ = __webpack_require__("Ivan");
function injectStyle (ssrContext) {
  __webpack_require__("CP5y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_profile_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b632c34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lp3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"currency-input"},[_c('input',{ref:"input",domProps:{"value":_vm.valueWithCent},on:{"input":function($event){return _vm.updateValue($event.target.value)},"blur":_vm.onBlur,"focus":_vm.onFocus,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onBlur($event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lyr+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_security_settings_js__ = __webpack_require__("Ellf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_229560a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_security_settings_vue__ = __webpack_require__("KfPg");
function injectStyle (ssrContext) {
  __webpack_require__("bWBf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_security_settings_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_229560a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_security_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mBiY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    lastClosePrice: {},
    price: {
      type: Number,
      default: 0
    },
    fixed: {
      type: Boolean,
      default: false
    },
    percent: {
      type: Boolean,
      default: false
    },
    plainStyle: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    },
    symbol: {
      type: String,
      default: '&cent;'
    }
  },
  computed: {
    isPriceEqual: function isPriceEqual() {
      // lastClosePrice === null must be checked so
      // new contracts does show price gain on day 1
      // null must be checked in case parameter is not passed (undefined)
      return this.price === 0 || this.lastClosePrice === null;
    },
    priceDisplay: function priceDisplay() {
      return this.fixed ? Math.abs(this.price).toFixed(2) : '' + Math.abs(this.price);
    },
    changeValue: function changeValue() {
      var symbol = this.percent ? '%' : this.symbol;
      if (this.fixed) {
        return !this.isPriceEqual ? '$' + this.priceDisplay : 'N/C';
      }
      return !this.isPriceEqual ? '' + this.priceDisplay + symbol : 'N/C';
    },
    objClass: function objClass() {
      var _ref;

      return _ref = {
        'market-change-price': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-change-price--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-change-price--plain', this.plainStyle), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-change-price--up', !this.isPriceEqual && this.price > 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-change-price--down', !this.isPriceEqual && this.price < 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-change-price--equal', this.isPriceEqual), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-change-price--wide', this.theme === 'page-market' && this.priceDisplay.length === 1), _ref;
    }
  }
});

/***/ }),

/***/ "mDCk":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "mI5N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-quotes"},[_c('swiper',{attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.items),function(quote){return _c('swiper-slide',{key:quote.id,staticClass:"main-quotes__slide"},[_c('div',{staticClass:"main-quotes__image"}),_vm._v(" "),_c('div',{staticClass:"main-quotes__content"},[_c('p',{staticClass:"main-quotes__item--text"},[_vm._v(_vm._s(quote.text))]),_vm._v(" "),_c('p',{staticClass:"main-quotes__item--author"},[_vm._v(_vm._s(quote.author))])])])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mRGp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_document_tile_view_js__ = __webpack_require__("7trC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc68f0c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_document_tile_view_vue__ = __webpack_require__("F+2w");
function injectStyle (ssrContext) {
  __webpack_require__("ibDk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_document_tile_view_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc68f0c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_document_tile_view_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mThu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_switch_button_switch_button_vue__ = __webpack_require__("ed4I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  props: {
    obj: Object,
    category: String
  },
  components: {
    switchButton: __WEBPACK_IMPORTED_MODULE_2__components_generics_switch_button_switch_button_vue__["a" /* default */]
  },
  data: function data() {
    return {
      checked: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['settings']), {
    classObject: function classObject() {
      return {
        'settings-option': true,
        'settings-option--disabled': this.disabled
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('profile', ['updateSettings']), {
    toggle: function toggle(e) {
      var _this = this;

      this.loaderAddLegacy();
      this.checked = e;
      this.updateSettings({
        category: this.category,
        key: this.obj.key,
        value: e
      }).then(function () {
        return _this.loaderRemoveLegacy();
      }).catch(function () {
        _this.loaderRemoveLegacy();
        _this.checked = !e;
        _this.$emit('error', 'Could not set "' + _this.obj.info + '"');
      });
      this.$emit('toggle', e);
    }
  }),
  created: function created() {
    var k = this.settings[this.category][this.obj.key];
    this.checked = k !== undefined ? k : false;
  }
});

/***/ }),

/***/ "mXqA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      required: true,
      default: 0
    },
    embedded: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "mbJS":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "mjGX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_close_button_js__ = __webpack_require__("0OLA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00d77be4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_close_button_vue__ = __webpack_require__("6X+t");
function injectStyle (ssrContext) {
  __webpack_require__("uEEg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_close_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00d77be4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_close_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mkEI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-funds-cash"},[(_vm.showPromoNotification && false)?_c('fee-waived-banner',{attrs:{"level":"success","text":_vm.promoCodeDetail.friendlyDescription}}):_vm._e(),_vm._v(" "),(_vm.showInstantCreditNotification && false)?_c('fee-waived-banner',{attrs:{"level":_vm.instantCreditBoxLevel,"text":_vm.instantCreditBoxMessage}}):_vm._e(),_vm._v(" "),(_vm.depositWarning)?_c('div',{staticClass:"predictit-embedded-alert",domProps:{"innerHTML":_vm._s(_vm.depositWarning)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"add-funds-cash__logo"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/static/img/paynearme.18d924a.jpg"),expression:"`/static/img/paynearme.18d924a.jpg`"}]})]),_vm._v(" "),(_vm.url)?_c('div',{staticClass:"add-funds-cash__button"},[_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"disabled":_vm.buttonDisabled},on:{"click":_vm.onDeposit}},[_vm._v("\n      Deposit\n    ")])]):_vm._e(),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"add-funds-cash__error"},[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.url)?[_c('p',{staticClass:"add-funds-cash__note"},[_vm._v("\n      After clicking on the Deposit button above, you will be taken to a third-party site to complete your transaction.\n    ")]),_vm._v(" "),_c('deposit-disclaimer',{attrs:{"disclaimer":_vm.disclaimer}})]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "moY3":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAuMzg0IiBoZWlnaHQ9IjQyLjU0MSIgdmlld0JveD0iMCAwIDMwLjM4NCA0Mi41NDEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMTUuMTkyIDM4LjU0MVY0TTMuNSAxNS42OTJMMTUuMTkyIDRMMjYuODg0IDE1LjY5MiIgc3Ryb2tlPSIjMDA5MTY1IiBzdHJva2Utd2lkdGg9IjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ "mt5D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldRender)?_c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"market-ownership-and-orders-bar__ownership",class:_vm.ownershipClassModifiers},[(_vm.hasOwnership)?[(_vm.showOwnershipIcon)?_c('span',{staticClass:"market-ownership-and-orders-bar__icon"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"market-ownership-and-orders-bar__quantity"},[_vm._v(_vm._s(_vm.ownershipQuantityDisplay))]),_vm._v(" "),_c('span',{staticClass:"market-ownership-and-orders-bar__mode"},[_vm._v(_vm._s(_vm.ownershipModeDisplay))]),_vm._v(" "),_c('span',{staticClass:"market-ownership-and-orders-bar__average"},[_vm._v("\n        ("),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.ownershipAverage),expression:"ownershipAverage",modifiers:{"cents":true}}]}),_vm._v(" avg)\n      ")]),_vm._v(" "),(_vm.ownershipDifference)?_c('market-change-price',{staticClass:"market-ownership-and-orders-bar__change",attrs:{"price":_vm.ownershipDifference}}):_vm._e()]:[_c('span',{staticClass:"market-ownership-and-orders-bar__ownership-empty"},[_vm._v("No ownership")])]],2),_vm._v(" "),(_vm.showOrdersSummary)?_c('div',{staticClass:"market-ownership-and-orders-bar__orders"},[(_vm.hasOrders)?[(!_vm.hideOrdersLabel)?_c('span',{staticClass:"market-ownership-and-orders-bar__orders-label"},[_vm._v("Orders:")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"market-ownership-and-orders-bar__orders-count market-ownership-and-orders-bar__orders-count--buy"},[_vm._v(_vm._s(_vm.buyOrdersDisplay))]),_vm._v(" "),_c('span',{staticClass:"market-ownership-and-orders-bar__orders-text"},[_vm._v("Buy")]),_vm._v(" "),_c('span',{staticClass:"market-ownership-and-orders-bar__orders-separator"},[_vm._v("/")]),_vm._v(" "),_c('span',{staticClass:"market-ownership-and-orders-bar__orders-count market-ownership-and-orders-bar__orders-count--sell"},[_vm._v(_vm._s(_vm.sellOrdersDisplay))]),_vm._v(" "),_c('span',{staticClass:"market-ownership-and-orders-bar__orders-text"},[_vm._v("Sell")])]:_c('span',{staticClass:"market-ownership-and-orders-bar__orders-empty"},[_vm._v("No orders")])],2):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n0gu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  props: {
    obj: Object,
    category: String,
    disabled: Boolean
  },
  data: function data() {
    return {
      modelValue: null,
      oldValue: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('profile', ['settings']), {
    classObject: function classObject() {
      return {
        'settings-option-switch': true,
        'settings-option-switch--disabled': this.disabled
      };
    },
    isDisabled: function isDisabled() {
      return this.disabled;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('profile', ['updateSettings']), {
    isOptionDisabled: function isOptionDisabled(option) {
      return this.isDisabled || !!option.disabled;
    },
    change: function change(value) {
      var _this = this;

      this.loaderAddLegacy();
      this.modelValue = value;
      this.updateSettings({
        category: this.category,
        key: this.obj.key,
        value: value
      }).then(function () {
        _this.oldValue = _this.modelValue;
        _this.loaderRemoveLegacy();
      }).catch(function () {
        _this.loaderRemoveLegacy();
        _this.modelValue = _this.oldValue;
        _this.$emit('error', 'Could not set "' + _this.obj.info + '"');
      });
      this.$emit('change', value);
    }
  }),
  created: function created() {
    var value = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.settings, [this.category, this.obj.key]);
    this.modelValue = value !== undefined ? value : this.obj.defaultValue;
    this.oldValue = this.modelValue;
  }
});

/***/ }),

/***/ "n1jK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n2FT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_generics_close_button_close_button_vue__ = __webpack_require__("mjGX");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: false
    },
    silent: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    returnRoute: {
      type: String
    },
    returnRouteGoTo: {
      type: String
    },
    theme: {
      type: String,
      default: ''
    }
  },
  components: {
    closeButton: __WEBPACK_IMPORTED_MODULE_1__components_generics_close_button_close_button_vue__["a" /* default */]
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'content-header': true,
        'content-header--closable': this.showCloseButton
      }, 'content-header--' + this.theme, this.theme);
    }
  },
  methods: {
    closeTitle: function closeTitle() {
      if (!this.showCloseButton) return;
      this.close();
    },
    close: function close() {
      this.$emit('close');
      if (this.silent) return;
      if (this.returnRoute) {
        var routeObj = { name: this.returnRoute };
        if (this.returnRouteGoTo) {
          routeObj.query = { el: this.returnRouteGoTo };
        }
        this.$router.push(routeObj);
      } else {
        this.$router.go(-1);
      }
    }
  }
});

/***/ }),

/***/ "n5Uq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-box",class:_vm.levelModifier},[(!!_vm.$slots.title)?_c('div',{staticClass:"alert-box__title"},[_vm._t("title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"alert-box__content"},[(_vm.iconSrc)?_c('img',{staticClass:"alert-box__content-icon",attrs:{"src":_vm.iconSrc}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"alert-box__content-text"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n71m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-register-footer"},[_c('div',{staticClass:"account-register-footer__title"},[_vm._v("\n        Already have an account?\n      ")]),_vm._v(" "),_c('span',{staticClass:"account-register-footer__link",on:{"click":function($event){$event.preventDefault();return _vm.onLogin($event)}}},[_vm._v("\n        Login to My Account\n      ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n8+9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_no_data_dashed_box_js__ = __webpack_require__("cqOx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fbbedf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_no_data_dashed_box_vue__ = __webpack_require__("/ELm");
function injectStyle (ssrContext) {
  __webpack_require__("ssDi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_no_data_dashed_box_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fbbedf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_no_data_dashed_box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n9uA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nBFw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nGgz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_page_daily_markets_details_daily_pages_constants__ = __webpack_require__("9MVc");


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{ link: __WEBPACK_IMPORTED_MODULE_0__components_pages_page_daily_markets_details_daily_pages_constants__["a" /* DAILY_PAGES */].MONDAY.id, title: __WEBPACK_IMPORTED_MODULE_0__components_pages_page_daily_markets_details_daily_pages_constants__["a" /* DAILY_PAGES */].MONDAY.title }, { link: __WEBPACK_IMPORTED_MODULE_0__components_pages_page_daily_markets_details_daily_pages_constants__["a" /* DAILY_PAGES */].TUESDAY.id, title: __WEBPACK_IMPORTED_MODULE_0__components_pages_page_daily_markets_details_daily_pages_constants__["a" /* DAILY_PAGES */].TUESDAY.title }]
    };
  },

  methods: {
    dailyMarketPageLink: function dailyMarketPageLink(item) {
      return { name: item.link };
    }
  }
});

/***/ }),

/***/ "nHn7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_cookie__ = __webpack_require__("o+KH");



var COOKIE_ACCEPTED = 'accepted';
var COOKIE_NAME = 'PrivacyStatement';

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hidden: false
    };
  },

  computed: {
    show: function show() {
      return false && __WEBPACK_IMPORTED_MODULE_1__helpers_cookie__["a" /* default */].get(COOKIE_NAME) === null && !this.hidden;
    }
  },
  methods: {
    onAgree: function onAgree() {
      __WEBPACK_IMPORTED_MODULE_1__helpers_cookie__["a" /* default */].setForever(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, COOKIE_NAME, COOKIE_ACCEPTED));
      this.onHide();
    },
    onHide: function onHide() {
      this.hidden = true;
    }
  }
});

/***/ }),

/***/ "nPGV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-desktop-header"},[_c('div',{staticClass:"account-desktop-header__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.isExportAvailable)?_c('button',{staticClass:"account-desktop-header__button account-desktop-header__button--export",on:{"click":_vm.onExport}},[_vm._v("Export")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nPqm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wallet_shared_depositMethodTypes__ = __webpack_require__("LQTn");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_1__components_generics_alert_box_alert_box_vue__["a" /* default */]
  },
  props: {
    instantCreditData: {}
  },
  data: function data() {
    return {
      promoCodeDetail: {},
      promotionalCreditAmount: 0,
      instantCreditDetail: this.instantCreditData || {},
      promoInit: true,
      promoAmount: 0,
      promoApplying: false,
      promoApplied: false,
      promoAppliedCode: '',
      promoHasError: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('wallet', ['depositMethodByType']), {
    method: function method() {
      return this.depositMethodByType(this.depositMethodType) || {};
    },
    showInstantCreditNotification: function showInstantCreditNotification() {
      return this.instantCreditDetail && typeof this.instantCreditDetail.success !== 'undefined' && !this.promoApplied;
    },
    instantCreditBoxLevel: function instantCreditBoxLevel() {
      return this.instantCreditDetail.success ? 'success' : 'warning';
    },
    instantCreditBoxMessage: function instantCreditBoxMessage() {
      return this.instantCreditDetail.success ? this.instantCreditDetail.friendlyDescription : this.instantCreditDetail.errorMessage;
    },
    showPromoNotification: function showPromoNotification() {
      return this.promoCodeDetail && this.promoCodeDetail.showPromoCodeBox;
    },
    isFeeWaived: function isFeeWaived() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__components_wallet_shared_depositMethodTypes__["c" /* isMethodFeeWaived */])(this.method);
    },
    feeStateBannerTxt: function feeStateBannerTxt() {
      return this.method.feeStateBannerTxt || '';
    },
    disclaimer: function disclaimer() {
      return this.method.disclaimerMsg || '';
    },
    timeframeMsg: function timeframeMsg() {
      return this.method.timeframeMsg || '';
    },
    noFeeMessagePrefix: function noFeeMessagePrefix() {
      return this.timeframeMsg ? this.timeframeMsg + ' \u2022 ' : '';
    },
    feeCap: function feeCap() {
      return this.method.feeCap;
    },
    promoBonus: function promoBonus() {
      if (this.promoApplied) {
        return Number(this.promoAmount).toFixed(2);
      }
      return '0.00';
    },
    notificationPayload: function notificationPayload() {
      var items = [];
      if (this.showPromoNotification) {
        items.push({ key: 'promo', text: this.promoCodeDetail.friendlyDescription, level: 'success' });
      }
      if (this.showInstantCreditNotification) {
        items.push({ key: 'instant-credit', text: this.instantCreditBoxMessage, level: this.instantCreditBoxLevel });
      }
      return items;
    }
  }),
  watch: {
    notificationPayload: {
      immediate: true,
      handler: function handler(items) {
        this.$emit('notification', items);
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('wallet', ['submitInstantCredit']), {
    onInitialisedPromoCode: function onInitialisedPromoCode() {
      this.promoInit = false;
    },
    onApplyPromoCode: function onApplyPromoCode(code) {
      var _this = this;

      this.promoApplying = true;
      this.promoHasError = false;
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__logger__["b" /* isDebugOn */])() && code === 'DEBUG_LOCAL') {
        this.promoApplied = true;
        this.promoAppliedCode = code;
        this.promoHasError = false;
        this.promoAmount = 13;
        this.promoApplying = false;
      } else {
        this.submitInstantCredit(code).then(function (data) {
          _this.promoApplying = false;
          if (data && data.success) {
            _this.promoApplied = true;
            _this.promoAppliedCode = code;
            _this.promoHasError = false;
            _this.promoAmount = data.amount;
          } else {
            _this.promoHasError = true;
          }
        }).catch(function () {
          _this.promoApplying = false;
          _this.promoHasError = true;
          _this.instantCreditDetail = { success: false };
        });
      }
    },
    onResetPromoCode: function onResetPromoCode() {
      this.instantCreditDetail = this.instantCreditData || {};
      this.promoApplied = false;
      this.promoAppliedCode = '';
      this.promoHasError = false;
      this.promoApplying = false;
      this.promoInit = true;
    },
    onRemovePromoCode: function onRemovePromoCode() {
      this.promoApplied = false;
      this.promoAppliedCode = '';
      this.promoHasError = false;
      this.instantCreditDetail = this.instantCreditData || {};
    }
  })
});

/***/ }),

/***/ "nYw4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_js__ = __webpack_require__("CAth");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b435be6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_vue__ = __webpack_require__("JNgs");
function injectStyle (ssrContext) {
  __webpack_require__("sJOz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b435be6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "na9c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "naY1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "neXN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nfG2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__("c/9r");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: {
      type: String,
      required: true
    },
    number: {
      type: Number,
      required: true
    }
  },
  computed: {
    numberDisplay: function numberDisplay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["x" /* largeNumberDisplay */])(this.number);
    },
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {
        'market-shares-ownership': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-shares-ownership--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-shares-ownership--yes', this.mode === 'yes'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-shares-ownership--no', this.mode === 'no'), _ref;
    }
  },
  methods: {
    onClickNumber: function onClickNumber() {
      this.$emit('click');
    }
  }
});

/***/ }),

/***/ "niuH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "nlkt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_account_login_account_login_vue__ = __webpack_require__("V3zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_account_account_login_footer_footer_vue__ = __webpack_require__("ULMz");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    accountLogin: __WEBPACK_IMPORTED_MODULE_0__components_account_account_login_account_login_vue__["a" /* default */],
    accountLoginFooter: __WEBPACK_IMPORTED_MODULE_1__components_account_account_login_footer_footer_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "nnUJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.documentUploadInfoVisible)?_c('account-upload-document',{attrs:{"source":_vm.documentUploadSource,"isPending":_vm.documentUploadInfoPending,"theme":_vm.accountUploadDocumentTheme}}):(_vm.collectSsnInfo)?_c('account-ssn-info-upload',{attrs:{"isPopup":_vm.isPopup,"theme":_vm.accountUploadDocumentTheme}}):[(_vm.activeOperation)?_c('div',{ref:"operationProgress",staticClass:"add-funds-transfers__progress",attrs:{"role":"status","aria-live":"polite"}},[_vm._v("\n      "+_vm._s(_vm.operationMessage)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('alert-box',{staticClass:"add-funds-transfers__alert",attrs:{"level":"warning"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})]):_vm._e(),_vm._v(" "),(_vm.depositWarning && !_vm.isStep('SUCCESS') && !_vm.isStep('FAILED'))?_c('div',{staticClass:"predictit-embedded-alert add-funds-transfers__alert",domProps:{"innerHTML":_vm._s(_vm.depositWarning)}}):_vm._e(),_vm._v(" "),(_vm.isStep('SELECT_ACCOUNT'))?[_c('bank-links',{attrs:{"notice-text":'',"selectable":true},on:{"accounts":_vm.onAccounts,"select":_vm.selectAccount}})]:(_vm.isStep('ENTER_AMOUNT'))?[_c('button',{staticClass:"add-funds-transfers__back",attrs:{"type":"button","disabled":_vm.isFormDisabled},on:{"click":function($event){return _vm.returnToAccounts()}}},[_c('span',{staticClass:"add-funds-transfers__back-icon"}),_vm._v(" "),_c('span',[_vm._v("BACK")])]),_vm._v(" "),(_vm.showPromoNotification && false)?_c('fee-waived-banner',{staticClass:"add-funds-transfers__alert",attrs:{"text":_vm.promoCodeDetail.friendlyDescription}}):_vm._e(),_vm._v(" "),(_vm.showInstantCreditNotification && false)?_c('fee-waived-banner',{staticClass:"add-funds-transfers__alert",attrs:{"level":_vm.instantCreditBoxLevel,"text":_vm.instantCreditBoxMessage}}):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onReviewAndConfirm($event)}}},[_c('div',{staticClass:"add-funds-transfers__amount-section"},[_c('div',{staticClass:"add-funds-transfers__section-label add-funds-transfers__section-label--center"},[_vm._v("\n            Deposit\n          ")]),_vm._v(" "),_c('deposit-amount-picker',{attrs:{"deposit-amounts":_vm.depositAmounts,"has-error":_vm.amountHasError,"error-message":_vm.amountValidationMessage,"disabled":_vm.isFormDisabled},on:{"add":_vm.onUpdateAmount,"blur":_vm.handleAmountBlur,"input":_vm.$v.amount.$touch},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}})],1),_vm._v(" "),_c('fee-status-message',{staticClass:"add-funds-transfers__no-fee-message",attrs:{"amount":_vm.amount,"fee-percent":0,"fee-free-cap":0,"fee-discount-eligibility":false,"fee-cap":0,"prefix":_vm.noFeeMessagePrefix}}),_vm._v(" "),_c('div',{staticClass:"add-funds-transfers__section-label"},[_vm._v("\n          Deposit from\n        ")]),_vm._v(" "),_c('div',{staticClass:"add-funds-transfers__account"},[_c('img',{staticClass:"add-funds-transfers__institution-logo",attrs:{"src":_vm.defaultInstitutionLogo,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"add-funds-transfers__account-info"},[_c('div',{staticClass:"add-funds-transfers__institution-name"},[_vm._v("\n              "+_vm._s(_vm.selectedAccount.institutionName || 'Bank account')+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"add-funds-transfers__account-name"},[_vm._v("\n              "+_vm._s(_vm.accountDescription)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"add-funds-transfers__line"}),_vm._v(" "),(_vm.isDepositPromoInputBoxEnabled)?[_c('div',{staticClass:"add-funds-transfers__promo-section"},[_c('promo-code-input',{attrs:{"is-initial":_vm.promoInit,"is-loading":_vm.promoApplying,"is-applied":_vm.promoApplied,"has-error":_vm.promoHasError,"applied-code":_vm.promoAppliedCode,"applied-amount":_vm.promoBonus},on:{"initialised":_vm.onInitialisedPromoCode,"apply":_vm.onApplyPromoCode,"remove":_vm.onRemovePromoCode}})],1),_vm._v(" "),_c('div',{staticClass:"add-funds-transfers__line"})]:_vm._e(),_vm._v(" "),_c('button',{staticClass:"button button--submit button--full-width add-funds-transfers__review-button",attrs:{"type":"submit","disabled":_vm.isConfirmDisabled}},[_vm._v("\n          Review and Confirm\n        ")])],2)]:(_vm.isStep('REVIEW'))?[_c('button',{staticClass:"add-funds-transfers__back",attrs:{"type":"button"},on:{"click":_vm.editAmount}},[_c('span',{staticClass:"add-funds-transfers__back-icon"}),_vm._v(" "),_c('span',[_vm._v("BACK")])]),_vm._v(" "),(_vm.promoReviewErrorMessage)?_c('alert-box',{staticClass:"add-funds-transfers__alert",attrs:{"level":"warning"}},[_vm._v("\n        "+_vm._s(_vm.promoReviewErrorMessage)+"\n      ")]):_vm._e(),_vm._v(" "),_c('deposit-amount-overview',{attrs:{"amount":_vm.amount}},[_c('template',{slot:"title"},[_vm._v("Deposit")]),_vm._v(" "),_c('template',{slot:"subtitle"},[_vm._v(_vm._s(_vm.accountSummary))])],2),_vm._v(" "),_c('deposit-info-overview',{staticClass:"add-funds-transfers__overview",attrs:{"card-masked":_vm.accountSummary,"amount":_vm.amount,"fee-percent":_vm.processingFeePercent,"fee-amount":_vm.processingFeeAmount,"fee-cap":_vm.processingFeeCap,"was-fee-discount-applied":_vm.wasFeeDiscountApplied,"is-fee-waived":_vm.isFeeWaived || _vm.wasFeeDiscountApplied,"fee-free-amount":_vm.feeFreeAmount,"has-promo":_vm.hasReviewPromo,"promo-code":_vm.reviewPromoLabel,"promo-bonus":_vm.confirmedPromoAmount,"total-to-wallet":_vm.totalToWallet,"arrives-text":_vm.timeframeMsg || 'Time Varies'}}),_vm._v(" "),_c('div',{staticClass:"add-funds-transfers__actions"},[_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"type":"button","disabled":_vm.isFormDisabled},on:{"click":_vm.onSubmitDeposit}},[_vm._v("\n          Confirm Deposit\n        ")]),_vm._v(" "),_c('button',{staticClass:"button button--large button--inverted button--full-width",attrs:{"type":"button","disabled":_vm.isFormDisabled},on:{"click":_vm.editAmount}},[_vm._v("\n          Edit Amount\n        ")])])]:(_vm.isStep('SUCCESS'))?_c('deposit-result',[_c('template',{slot:"heading"},[_vm._v("Deposit Submitted")]),_vm._v(" "),_c('template',{slot:"icon"},[_c('img',{attrs:{"src":__webpack_require__("ha/Z"),"alt":"Deposit submitted"}})]),_vm._v(" "),_c('template',{slot:"body"},[_c('div',{staticClass:"add-funds-transfers__success-amount"},[_vm._v(_vm._s(_vm.successAmount))]),_vm._v(" "),_c('div',{staticClass:"add-funds-transfers__success-note"},[_vm._v("\n          Your funds will be added to your wallet when the bank transfer settles, usually 1-3 days.\n        ")]),_vm._v(" "),_c('deposit-info-overview',{staticClass:"add-funds-transfers__overview add-funds-transfers__overview--full-margin",attrs:{"card-masked":_vm.accountSummary,"amount":_vm.amount,"fee-percent":_vm.processingFeePercent,"fee-amount":_vm.processingFeeAmount,"fee-cap":_vm.processingFeeCap,"was-fee-discount-applied":_vm.wasFeeDiscountApplied,"is-fee-waived":_vm.isFeeWaived || _vm.wasFeeDiscountApplied,"fee-free-amount":_vm.feeFreeAmount,"has-promo":_vm.hasReviewPromo,"promo-code":_vm.reviewPromoLabel,"promo-bonus":_vm.confirmedPromoAmount,"total-to-wallet":_vm.totalToWallet,"arrives-text":_vm.timeframeMsg || 'Time Varies'}})],1),_vm._v(" "),_c('template',{slot:"actions"},[_c('deposit-done-links',{on:{"done":_vm.onSuccessDone}})],1)],2):_c('deposit-result',[_c('template',{slot:"heading"},[_vm._v("\n        "+_vm._s(_vm.isAmbiguousSubmission ? 'Deposit Status Unconfirmed' : 'Deposit Failed')+"\n      ")]),_vm._v(" "),_c('template',{slot:"icon"},[_c('img',{attrs:{"src":__webpack_require__("6StG"),"alt":"Deposit not completed"}})]),_vm._v(" "),_c('template',{slot:"body"},[_c('div',{staticClass:"add-funds-transfers__fail-subtitle"},[_vm._v("\n          "+_vm._s(_vm.isAmbiguousSubmission ? 'Please contact Support' : 'We couldn’t complete your deposit')+"\n        ")]),_vm._v(" "),_c('p',{staticClass:"add-funds-transfers__fail-message"},[_vm._v(_vm._s(_vm.failureMessage))])]),_vm._v(" "),_c('template',{slot:"actions"},[(_vm.isAmbiguousSubmission && !_vm.submissionToken)?_c('deposit-done-links',{on:{"done":_vm.onSuccessDone}}):_vm._e(),_vm._v(" "),(_vm.isAmbiguousSubmission && _vm.submissionToken && _vm.selectedAccount)?_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"type":"button","disabled":_vm.isFormDisabled},on:{"click":_vm.checkPendingDeposit}},[_vm._v("\n          Check Deposit Status\n        ")]):_vm._e(),_vm._v(" "),(_vm.isAmbiguousSubmission && _vm.canRetryPendingDeposit)?_c('button',{staticClass:"button button--large button--inverted button--full-width",attrs:{"type":"button","disabled":_vm.isFormDisabled},on:{"click":_vm.retryPendingDeposit}},[_vm._v("\n          Retry Same Deposit\n        ")]):_vm._e(),_vm._v(" "),(_vm.isAmbiguousSubmission)?_c('div',{staticClass:"add-funds-transfers__support-link"},[_c('span',[_vm._v("Contact ")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/support","rel":"noopener noreferrer","target":"_blank"}},[_vm._v("PredictIt Support")])],1):_vm._e(),_vm._v(" "),(!_vm.isAmbiguousSubmission)?_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"type":"button","disabled":_vm.isFormDisabled},on:{"click":_vm.retryFailedRequest}},[_vm._v("\n          Try Again\n        ")]):_vm._e(),_vm._v(" "),(_vm.submissionToken && !_vm.isAmbiguousSubmission)?_c('button',{staticClass:"button button--large button--inverted button--full-width",attrs:{"type":"button"},on:{"click":_vm.editAmount}},[_vm._v("\n          Edit Amount\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isAmbiguousSubmission)?_c('button',{staticClass:"button button--large button--inverted button--full-width",attrs:{"type":"button"},on:{"click":function($event){return _vm.returnToAccounts()}}},[_vm._v("\n          Choose Another Account\n        ")]):_vm._e()],1)],2),_vm._v(" "),(!_vm.isStep('SUCCESS') && !_vm.isStep('FAILED'))?_c('deposit-disclaimer',{attrs:{"disclaimer":_vm.displayDisclaimer}}):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "noAP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-bar"}},[(_vm.show)?_c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"search-bar__inner"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('label',{staticClass:"search-bar__control",attrs:{"for":"search-query"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],ref:"searchInput",class:_vm.inputClassModifiers,attrs:{"id":"search-query","type":"text","placeholder":"SEARCH MARKETS..."},domProps:{"value":(_vm.searchQuery)},on:{"focus":_vm.handleFocus,"blur":_vm.handleBlur,"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-bar__submit",attrs:{"type":"submit"}})])]),_vm._v(" "),_c('div',{staticClass:"search-bar__close",on:{"click":_vm.onClose}},[_c('div',{staticClass:"search-bar__close-icon"}),_vm._v(" "),_c('div',{staticClass:"search-bar__close-text"},[_vm._v("Close")])])]),_vm._v(" "),(false)?_c('div',{class:_vm.summaryClassModifiers},[(_vm.searchTotal > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6 text-left"},[_c('strong',[_vm._v("Search Results")]),_vm._v(": "+_vm._s(_vm.searchFor)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"column small-6 text-right"},[_vm._v("\n          "+_vm._s(_vm.searchTotal)+" Market"),(_vm.searchTotal !== 1)?_c('span',[_vm._v("s")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.searchTotal === 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-8 text-left"},[_c('strong',[_vm._v("No Search Results")]),_vm._v(": "+_vm._s(_vm.searchFor)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"column small-4 text-right"},[_vm._v("\n          0 Markets\n        ")])]):_vm._e()]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ny9f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_result_js__ = __webpack_require__("kM50");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1593964_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_result_vue__ = __webpack_require__("Oa0d");
function injectStyle (ssrContext) {
  __webpack_require__("3vft")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_result_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1593964_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_result_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nygi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_image_js__ = __webpack_require__("J+13");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dcf159c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_image_vue__ = __webpack_require__("0Jvk");
function injectStyle (ssrContext) {
  __webpack_require__("uZm2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_image_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dcf159c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o+KH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EXPIRY_TIME */
/* unused harmony export EXPIRY_FOREVER */
/* unused harmony export extractHostname */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forOwn__ = __webpack_require__("AVgl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forOwn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_forOwn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cookie__ = __webpack_require__("sp77");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cookie__);




var EXPIRY_TIME = 5;
var EXPIRY_FOREVER = 'Fri, 31 Dec 9999 23:59:59 GMT';

var extractHostname = function extractHostname() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$delimiter = options.delimiter,
      delimiter = _options$delimiter === undefined ? '.' : _options$delimiter,
      _options$deep = options.deep,
      deep = _options$deep === undefined ? 2 : _options$deep;
  var hostname = window.location.hostname;

  var parts = hostname.split(delimiter);
  return parts.slice(-deep).join(delimiter);
};

var set = function set(data, expires) {
  var date = new Date();
  date.setMinutes(date.getMinutes() + EXPIRY_TIME);
  __WEBPACK_IMPORTED_MODULE_0_lodash_forOwn___default()(data, function (value, key) {
    document.cookie = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_cookie__["serialize"])(key, value, {
      expires: expires || date,
      domain: extractHostname()
    });
  });
};

var setForever = function setForever(data) {
  return set(data, new Date(EXPIRY_FOREVER));
};

var get = function get(key) {
  var cookie = document.cookie ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_cookie__["parse"])(document.cookie) : {};
  return cookie[key] || null;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  get: get,
  set: set,
  setForever: setForever
});

/***/ }),

/***/ "o3i4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    num: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    link: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    },
    markOpened: {
      type: Boolean,
      default: true
    },
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      opened: false
    };
  },

  computed: {
    hasSlotSuffix: function hasSlotSuffix() {
      return !!this.$slots.suffix;
    },
    classModifiers: function classModifiers() {
      return {
        'document-to-review': true,
        'document-to-review--opened': this.markOpened && this.opened
      };
    },
    symbolClassModifiers: function symbolClassModifiers() {
      return {
        'document-to-review__symbol': true,
        'document-to-review__symbol--pdf': this.link && this.link.endsWith('pdf')
      };
    }
  },
  methods: {
    onOpen: function onOpen() {
      this.opened = true;
      this.$emit('change', true);
    }
  }
});

/***/ }),

/***/ "o5X3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o6F4":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjE0IiB2aWV3Qm94PSIwIDAgOCAxNCI+CiAgICA8cGF0aCBmaWxsPSIjRkZGRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0uOTAyLjMzM2wtLjYwNC42NzNBMS4yMjQgMS4yMjQgMCAwIDAgMCAxLjgyNGMwIC4zMTguMS41ODcuMjk4LjgwOUw0LjIxMiA3IC4yOTggMTEuMzY3YTEuMTY5IDEuMTY5IDAgMCAwLS4yOTguODA5YzAgLjMxMS4xLjU4NC4yOTguODE4bC42MDQuNjY1YS45NTEuOTUxIDAgMCAwIC43MzMuMzQxYy4yOSAwIC41MzItLjExNC43MjUtLjM0MWw1LjI0My01Ljg1Yy4yMDQtLjIxNi4zMDYtLjQ4NS4zMDYtLjgwOSAwLS4zMTgtLjEwMi0uNTktLjMwNi0uODE4TDIuMzYuMzMyQS45MzguOTM4IDAgMCAwIDEuNjM1IDBjLS4yOCAwLS41MjMuMTEtLjczMy4zMzN6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "o9eX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oE+L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = buildJsonLdTag;
/* harmony export (immutable) */ __webpack_exports__["c"] = jsonLdSanitizerOverride;
/* harmony export (immutable) */ __webpack_exports__["e"] = buildCollectionPageSchema;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildMarketDetailSchema;
/* harmony export (immutable) */ __webpack_exports__["d"] = buildNewsArticleSchema;
/* harmony export (immutable) */ __webpack_exports__["f"] = buildOrganizationWebsiteSchema;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_contract__ = __webpack_require__("YZ+m");





var SCHEMA_CONTEXT = 'https://schema.org';

function escapeJsonLd(schema) {
  // '<' never appears in JSON syntax outside a string value, so replacing every
  // occurrence neutralizes `</script>`/`<!--` breakout attempts without touching validity.
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(schema).replace(/</g, '\\u003c');
}

function buildJsonLdTag(schema, vmid) {
  return {
    vmid: vmid,
    type: 'application/ld+json',
    innerHTML: escapeJsonLd(schema)
  };
}

function jsonLdSanitizerOverride(vmid) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, vmid, ['innerHTML']);
}

function buildCollectionPageSchema(_ref2) {
  var name = _ref2.name,
      description = _ref2.description,
      url = _ref2.url,
      items = _ref2.items;

  return {
    '@context': SCHEMA_CONTEXT,
    '@type': 'CollectionPage',
    name: name,
    description: description,
    url: url,
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: items.map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          name: item.name,
          url: item.url
        };
      })
    }
  };
}

function buildMarketDetailSchema(_ref3) {
  var origin = _ref3.origin,
      canonicalUrl = _ref3.canonicalUrl,
      market = _ref3.market,
      contracts = _ref3.contracts;

  return {
    '@context': SCHEMA_CONTEXT,
    '@graph': [{
      '@type': 'WebPage',
      '@id': canonicalUrl,
      url: canonicalUrl,
      name: market.seoTitle,
      description: market.seoDescription,
      image: market.imageName,
      isPartOf: { '@type': 'WebSite', name: 'PredictIt', url: origin },
      mainEntity: { '@id': '#contracts' }
    }, {
      '@type': 'BreadcrumbList',
      itemListElement: [{ '@type': 'ListItem', position: 1, name: 'Home', item: origin }, { '@type': 'ListItem', position: 2, name: 'Markets', item: origin + '/markets' }, { '@type': 'ListItem', position: 3, name: market.marketName }]
    }, {
      '@type': 'ItemList',
      '@id': '#contracts',
      name: 'Contracts in this market',
      numberOfItems: contracts.length,
      itemListElement: contracts.map(function (contract, index) {
        var contractModel = new __WEBPACK_IMPORTED_MODULE_3__models_contract__["a" /* default */](contract);
        var cents = contractModel.lastTradePriceAsCents;
        return {
          '@type': 'ListItem',
          position: index + 1,
          name: contractModel.contractName || contractModel.name,
          description: 'Latest trade price: ' + cents + '\xA2 per share (market-implied probability ~' + cents + '%).'
        };
      })
    }]
  };
}

function buildNewsArticleSchema(_ref4) {
  var origin = _ref4.origin,
      canonicalUrl = _ref4.canonicalUrl,
      story = _ref4.story,
      description = _ref4.description;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    '@context': SCHEMA_CONTEXT,
    '@type': 'NewsArticle',
    headline: story.seoTitle,
    description: description || story.seoDescription,
    image: story.imageName,
    mainEntityOfPage: canonicalUrl,
    author: { '@type': 'Organization', name: 'PredictIt' },
    publisher: {
      '@type': 'Organization',
      name: 'PredictIt',
      logo: { '@type': 'ImageObject', url: origin + '/static/logo.png' }
    }
  }, story.publishedDate ? { datePublished: story.publishedDate } : {}, story.modifiedDate ? { dateModified: story.modifiedDate } : {});
}

function buildOrganizationWebsiteSchema(_ref5) {
  var origin = _ref5.origin,
      homeName = _ref5.homeName,
      websiteDescription = _ref5.websiteDescription,
      sameAs = _ref5.sameAs;

  return {
    '@context': SCHEMA_CONTEXT,
    '@graph': [{
      '@type': 'Organization',
      '@id': origin + '/#organization',
      name: 'PredictIt',
      url: origin,
      logo: { '@type': 'ImageObject', url: origin + '/static/logo.png' },
      sameAs: sameAs.filter(Boolean)
    }, {
      '@type': 'WebSite',
      '@id': origin + '/#website',
      url: origin,
      name: 'PredictIt',
      description: websiteDescription,
      publisher: { '@id': origin + '/#organization' },
      potentialAction: {
        '@type': 'SearchAction',
        target: { '@type': 'EntryPoint', urlTemplate: origin + '/markets/search?query={search_term_string}' },
        'query-input': 'required name=search_term_string'
      }
    }, {
      '@type': 'WebPage',
      '@id': origin + '/#webpage',
      url: origin,
      name: homeName,
      isPartOf: { '@id': origin + '/#website' },
      about: { '@id': origin + '/#organization' }
    }]
  };
}

/***/ }),

/***/ "oKYE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint no-underscore-dangle: ["error", { "allow": ["__vueClickOutside__"] }] */

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    var bubble = binding.modifiers.bubble;
    var handler = function handler(e) {
      if (bubble || !el.contains(e.target) && el !== e.target) {
        binding.value(e);
      }
    };
    el.__vueClickOutside__ = handler;
    document.addEventListener('click', handler);
  },
  unbind: function unbind(el) {
    document.removeEventListener('click', el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  }
});

/***/ }),

/***/ "oLs4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oV6X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatten__ = __webpack_require__("rCVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_previewCarouselTracking__ = __webpack_require__("LoC7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_helpers__ = __webpack_require__("c/9r");








/* eslint-disable no-restricted-syntax */









var STORY_SWITCH_INTERVAL = 8 * 1000;
var CONTENT_COLLAPSED_HEIGHT = 475;
var CONTENT_OVERFLOW_TOLERANCE = 12;
var EXPANDED_HEIGHT_BUFFER = 8;
var EXPANDED_HEIGHT_MEASURE_DELAYS = [0, 150, 500, 1200];
var PODCAST_RESIZE_EVENT = 'cms:podcast-resize';
var PODCAST_LAYOUT_REFRESH_EVENT = 'cms:podcast-layout-refresh';
var LAST_STORY_ROW_CLASS = 'preview-carousel__story-row--last';
var interval = null;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_previewCarouselTracking__["a" /* default */]],
  components: {
    tabs: __WEBPACK_IMPORTED_MODULE_10__components_generics_tabs_tabs_vue__["a" /* default */]
  },
  data: function data() {
    return {
      stripTags: __WEBPACK_IMPORTED_MODULE_14__utils_helpers__["q" /* stripTags */],
      isLoading: false,
      selected: {},
      selectedManually: false,
      isTransitioning: false,
      storyContentMap: {},
      activeTab: null,
      showNavigationArrows: false,
      canScrollLeft: false,
      canScrollRight: false,
      isExpanded: false,
      isContentOverflowing: false,
      expandedContentHeight: null,
      contentMeasureTimeouts: [],
      contentResizeObserver: null,
      refreshIndex: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapState */])('browse', ['storiesNav', 'storyMap', 'currentStoryIndex']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapState */])('popup', ['currentPopup', 'currentSmallPopup']), {
    showNav: function showNav() {
      return this.storiesNav.length > 0 && !this.isLoading && this.isComponentReady;
    },
    navigationTabs: function navigationTabs() {
      return this.storiesNav.map(function (item) {
        return {
          name: 'story-' + item.index,
          title: item.navTitle || 'Story #' + (item.index + 1)
        };
      });
    },
    classModifiers: function classModifiers() {
      return {
        'preview-carousel': true
      };
    },
    contentClassModifiers: function contentClassModifiers() {
      return {
        'preview-carousel__content': true,
        'preview-carousel__content--collapsed': !this.isExpanded,
        'preview-carousel__content--overflowing': this.isContentOverflowing && !this.isExpanded
      };
    },
    contentStyleModifiers: function contentStyleModifiers() {
      var minHeightPx = CONTENT_COLLAPSED_HEIGHT;
      if (this.isExpanded && this.expandedContentHeight) {
        return {
          minHeight: Math.max(minHeightPx, this.expandedContentHeight) + 'px'
        };
      }
      return {
        minHeight: minHeightPx + 'px'
      };
    },
    expandClassModifiers: function expandClassModifiers() {
      return {
        'preview-carousel__expand': true,
        'preview-carousel__expand--floating': !this.isExpanded
      };
    },
    showExpandControl: function showExpandControl() {
      return this.isContentOverflowing && this.isComponentReady;
    },
    tabsClassModifiers: function tabsClassModifiers() {
      return {
        'preview-carousel__tabs': true,
        'preview-carousel__tabs--arrows': this.showNavigationArrows
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapActions */])('browse', ['getStoriesNav', 'getStory', 'getStoriesList', 'updateStoryMapFromContractNotification']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    getStoryContentForLayout: function getStoryContentForLayout(data) {
      return this.isLayoutDesktop ? data.desktopContent : data.mobileContent;
    },
    clearPendingExpandedMeasurements: function clearPendingExpandedMeasurements() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.contentMeasureTimeouts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var timeoutId = _step.value;

          clearTimeout(timeoutId);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.contentMeasureTimeouts = [];
    },
    teardownContentResizeObserver: function teardownContentResizeObserver() {
      if (this.contentResizeObserver) {
        this.contentResizeObserver.disconnect();
        this.contentResizeObserver = null;
      }
    },
    setupContentResizeObserver: function setupContentResizeObserver() {
      var _this = this;

      this.teardownContentResizeObserver();
      if (typeof ResizeObserver === 'undefined') {
        return;
      }

      var target = this.getActiveStoryElement() || this.$refs.content;
      if (!target) {
        return;
      }

      this.contentResizeObserver = new ResizeObserver(function () {
        if (_this.isExpanded) {
          _this.scheduleExpandedHeightRefresh();
        } else {
          _this.checkContentOverflow();
        }
      });
      this.contentResizeObserver.observe(target);
    },
    getActiveStoryElement: function getActiveStoryElement() {
      var content = this.$refs.content;
      if (!content) {
        return null;
      }
      var stories = content.querySelectorAll('.preview-carousel__story');
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(stories), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var story = _step2.value;

          if (window.getComputedStyle(story).display !== 'none') {
            return story;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return null;
    },
    isVisibleElement: function isVisibleElement(node) {
      var styles = window.getComputedStyle(node);
      if (styles.display === 'none' || styles.visibility === 'hidden') {
        return false;
      }
      var rect = node.getBoundingClientRect();
      return rect.width > 0 || rect.height > 0 || node.scrollHeight > 0;
    },
    getLastVisibleStoryRow: function getLastVisibleStoryRow() {
      var activeStory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getActiveStoryElement();

      if (!activeStory) {
        return null;
      }

      var rows = activeStory.querySelectorAll('.browse-story-content-region__items');
      for (var index = rows.length - 1; index >= 0; index -= 1) {
        var row = rows[index];
        if (this.isVisibleElement(row)) {
          return row;
        }
      }

      return null;
    },
    updateLastVisibleStoryRow: function updateLastVisibleStoryRow() {
      var activeStory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getActiveStoryElement();

      if (!activeStory) {
        return;
      }

      var markedRows = activeStory.querySelectorAll('.' + LAST_STORY_ROW_CLASS);
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(markedRows), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var row = _step3.value;

          row.classList.remove(LAST_STORY_ROW_CLASS);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var lastVisibleRow = this.getLastVisibleStoryRow(activeStory);
      if (lastVisibleRow) {
        lastVisibleRow.classList.add(LAST_STORY_ROW_CLASS);
      }
    },
    measureStoryHeight: function measureStoryHeight() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$includeBuffer = _ref.includeBuffer,
          includeBuffer = _ref$includeBuffer === undefined ? false : _ref$includeBuffer;

      var activeStory = this.getActiveStoryElement();
      if (!activeStory) {
        return null;
      }

      this.updateLastVisibleStoryRow(activeStory);

      var activeRect = activeStory.getBoundingClientRect();
      var measuredHeight = Math.max(activeStory.scrollHeight || 0, activeStory.offsetHeight || 0);
      var descendants = activeStory.querySelectorAll('*');

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(descendants), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var node = _step4.value;

          var styles = window.getComputedStyle(node);
          if (styles.display === 'none' || styles.visibility === 'hidden') {
            continue;
          }
          var rect = node.getBoundingClientRect();
          if (rect.width === 0 && rect.height === 0) {
            continue;
          }
          var nodeBottom = rect.bottom - activeRect.top;
          if (nodeBottom > measuredHeight) {
            measuredHeight = nodeBottom;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (measuredHeight <= 0) {
        return null;
      }

      return Math.ceil(measuredHeight + (includeBuffer ? EXPANDED_HEIGHT_BUFFER : 0));
    },
    measureExpandedContentHeight: function measureExpandedContentHeight() {
      return this.measureStoryHeight({ includeBuffer: true });
    },
    measureCollapsedContentHeight: function measureCollapsedContentHeight() {
      return this.measureStoryHeight();
    },
    scheduleExpandedHeightRefresh: function scheduleExpandedHeightRefresh() {
      var _this2 = this;

      if (!this.isExpanded) {
        return;
      }
      this.clearPendingExpandedMeasurements();
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(EXPANDED_HEIGHT_MEASURE_DELAYS), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var delay = _step5.value;

          var timeoutId = setTimeout(function () {
            if (!_this2.isExpanded) {
              return;
            }
            var measuredHeight = _this2.measureExpandedContentHeight();
            if (measuredHeight) {
              _this2.expandedContentHeight = measuredHeight;
            }
          }, delay);
          this.contentMeasureTimeouts.push(timeoutId);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    handleWindowResize: function handleWindowResize() {
      this.checkOverflow();
      if (this.isExpanded) {
        this.scheduleExpandedHeightRefresh();
      } else {
        this.checkContentOverflow();
      }
    },
    handleEmbeddedResizeEvent: function handleEmbeddedResizeEvent() {
      var _this3 = this;

      if (this.isExpanded) {
        this.scheduleExpandedHeightRefresh();
      } else {
        this.$nextTick(function () {
          _this3.checkContentOverflow();
        });
      }
    },
    emitPodcastLayoutRefresh: function emitPodcastLayoutRefresh() {
      window.dispatchEvent(new Event(PODCAST_LAYOUT_REFRESH_EVENT));
    },
    tabsClicked: function tabsClicked() {
      this.stopNavRotation();
      this.selectedManually = true;
      this.previewTracking.lastAdvanceReason = 'manual-click';
    },
    navigationTabChange: function navigationTabChange(name) {
      this.activeTab = name;
      var index = parseInt(name.replace('story-', ''), 10);
      this.onSelect({ item: this.storiesNav.find(function (i) {
          return i.index === index;
        }), stop: false });
    },
    installActiveStoryCharts: function installActiveStoryCharts() {
      var activeStoryElement = this.getActiveStoryElement();
      if (!activeStoryElement) {
        return;
      }
      this.installMarketCharts(activeStoryElement, { suppressGlobalLoader: true });
    },
    setupContent: function setupContent() {
      var _this4 = this;

      var totalCmsContent = [];
      this.storyContentMap = {};

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.storyMap)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var _ref2 = _step6.value;

          var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);

          var index = _ref3[0];
          var data = _ref3[1];

          var storyContent = this.getStoryContentForLayout(data);
          totalCmsContent.push(storyContent.cmsContent || {});
          __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].set(this.storyContentMap, index, '' + (storyContent.css || '') + (storyContent.html || ''));
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var accordionContentObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.accordionContentObjects || [];
      }));
      var podcastItemContentObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.podcastItemContentObjects || [];
      }));
      var contractListMarkets = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.contractListMarkets || [];
      }));
      var marketTileMarkets = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.marketTileMarkets || [];
      }));
      var chartWidgetObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.chartWidgetObjects || [];
      }));
      var docsWidgetObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.docsWidgetObjects || [];
      }));
      var videoWidgetObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.videoWidgetObjects || [];
      }));
      this.isComponentReady = true;

      setTimeout(function () {
        _this4.installDynamicControls({
          data: {
            cmsContentObject: {
              accordionContentObjects: accordionContentObjects,
              podcastItemContentObjects: podcastItemContentObjects,
              contractListMarkets: contractListMarkets,
              marketTileMarkets: marketTileMarkets,
              chartWidgetObjects: chartWidgetObjects,
              docsWidgetObjects: docsWidgetObjects,
              videoWidgetObjects: videoWidgetObjects
            }
          },
          skipMarketCharts: true
        });
        _this4.$nextTick(function () {
          _this4.installActiveStoryCharts();
          _this4.setupContentResizeObserver();
          _this4.checkContentOverflow();
          _this4.emitPodcastLayoutRefresh();
        });
      }, 0);
    },
    refreshLayoutContent: function refreshLayoutContent() {
      var _this5 = this;

      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$clearExpanded = _ref4.clearExpanded,
          clearExpanded = _ref4$clearExpanded === undefined ? true : _ref4$clearExpanded;

      if (!this.isComponentReady || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.storyMap).length === 0) {
        return;
      }
      if (clearExpanded) {
        this.isExpanded = false;
        this.expandedContentHeight = null;
        this.clearPendingExpandedMeasurements();
      }
      this.refreshIndex += 1;
      this.$nextTick(function () {
        _this5.setupContent();
        _this5.$nextTick(function () {
          _this5.setupContentResizeObserver();
          _this5.checkOverflow();
          _this5.emitPodcastLayoutRefresh();
        });
      });
    },
    onSelect: function onSelect(_ref5) {
      var _this6 = this;

      var item = _ref5.item,
          _ref5$stop = _ref5.stop,
          stop = _ref5$stop === undefined ? false : _ref5$stop;

      if (typeof item === 'undefined') return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
      var disableNavBarAutomaticProgression = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(item, 'disableNavBarAutomaticProgression', false);
      if (stop || disableNavBarAutomaticProgression) {
        this.stopNavRotation();
        this.selectedManually = true;
      }

      this.isTransitioning = true;
      return this.getStory({ index: item.index }).then(function (data) {
        var timeout = 0;
        if (stop) {
          window.scrollTo(0, 0);
        }
        _this6.selected = item;
        setTimeout(function () {
          _this6.isTransitioning = false;
        }, timeout);
      });
    },
    stopNavRotation: function stopNavRotation() {
      if (interval !== null) {
        clearInterval(interval);
      }
    },
    startNavRotation: function startNavRotation() {
      var _this7 = this;

      this.stopNavRotation();
      interval = setInterval(function () {
        var currentIndex = _this7.selected.index;
        var nextIndex = currentIndex === _this7.storiesNav.length - 1 ? 0 : currentIndex + 1;
        _this7.previewTracking.lastAdvanceReason = 'auto';
        _this7.onSelect({ item: _this7.storiesNav[nextIndex] });
      }, STORY_SWITCH_INTERVAL);
    },
    resolveInitialStoryItem: function resolveInitialStoryItem(data) {
      if (this.$route.query.story) {
        var indexToSelect = parseInt(this.$route.query.story, 10);
        var selectedItem = data[indexToSelect - 1];

        if (selectedItem) {
          this.activeTab = 'story-' + selectedItem.index;
          return selectedItem;
        }
      }

      var defaultItem = data[0];
      if (defaultItem) {
        this.activeTab = 'story-' + defaultItem.index;
      }

      return defaultItem;
    },
    start: function start() {
      var _this8 = this;

      this.stopNavRotation();
      this.isLoading = true;
      this.isComponentReady = false;
      this.getStoriesNav().then(function (data) {
        if (data.length === 0) {
          _this8.isLoading = false;
          _this8.isComponentReady = true;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
        }

        var item = _this8.resolveInitialStoryItem(data);
        if (!item) {
          _this8.isLoading = false;
          _this8.isComponentReady = true;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
        }

        return _this8.getStoriesList({ indexes: data.map(function (i) {
            return i.index;
          }), cache: true }).then(function () {
          return _this8.onSelect({ item: item }).then(function () {
            _this8.isLoading = false;
            _this8.setupContent();

            setTimeout(function () {
              _this8.checkOverflow();
            }, 0);

            var disableNavBarAutomaticProgression = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(item || {}, 'disableNavBarAutomaticProgression', false);
            if (!_this8.currentPopup && !disableNavBarAutomaticProgression) {
              _this8.startNavRotation();
            }
          });
        });
      }).catch(function (e) {
        console.error(e);
        _this8.isLoading = false;
        _this8.isComponentReady = true;
      });
    },
    checkScrollButtons: function checkScrollButtons() {
      var tabsList = this.$refs.tabsList;
      if (tabsList) {
        var tolerance = 25;
        this.canScrollLeft = tabsList.scrollLeft > tolerance;
        this.canScrollRight = tabsList.scrollLeft < tabsList.scrollWidth - tabsList.clientWidth - tolerance;
      }
    },
    checkOverflow: function checkOverflow() {
      var _this9 = this;

      var tabsList = this.$refs.tabsList;
      if (tabsList) {
        this.showNavigationArrows = tabsList.scrollWidth > tabsList.clientWidth;
        setTimeout(function () {
          _this9.checkScrollButtons();
        }, 250);
      }
    },
    scrollLeft: function scrollLeft() {
      var _this10 = this;

      var tabsList = this.$refs.tabsList;
      if (tabsList) {
        tabsList.scrollBy({
          left: -150, // Scroll left by 150px
          behavior: 'smooth'
        });
        setTimeout(function () {
          _this10.checkScrollButtons();
        }, 250);
      }
    },
    scrollRight: function scrollRight() {
      var _this11 = this;

      var tabsList = this.$refs.tabsList;
      if (tabsList) {
        tabsList.scrollBy({
          left: 150, // Scroll right by 150px
          behavior: 'smooth'
        });
        setTimeout(function () {
          _this11.checkScrollButtons();
        }, 250);
      }
    },
    toggleExpand: function toggleExpand() {
      var _this12 = this;

      if (!this.isExpanded) {
        this.fireReadMoreInteraction();
      }
      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) {
        this.scheduleExpandedHeightRefresh();
      } else {
        this.expandedContentHeight = null;
        this.clearPendingExpandedMeasurements();
      }
      this.stopNavRotation();
      this.selectedManually = true;
      this.$nextTick(function () {
        _this12.emitPodcastLayoutRefresh();
      });
    },
    checkContentOverflow: function checkContentOverflow() {
      var content = this.$refs.content;
      if (content) {
        var collapsedContentHeight = this.measureCollapsedContentHeight() || content.scrollHeight || 0;
        this.isContentOverflowing = collapsedContentHeight > CONTENT_COLLAPSED_HEIGHT + CONTENT_OVERFLOW_TOLERANCE;
        if (this.isExpanded) {
          var expandedContentHeight = this.measureExpandedContentHeight();
          if (expandedContentHeight) {
            this.expandedContentHeight = expandedContentHeight;
          }
        }
      }
    }
  }),
  created: function created() {
    this.start();
  },

  watch: {
    currentStoryIndex: function currentStoryIndex(val) {
      var _this13 = this;

      this.isExpanded = false;
      this.expandedContentHeight = null;
      this.clearPendingExpandedMeasurements();
      this.$nextTick(function () {
        _this13.installActiveStoryCharts();
        _this13.setupContentResizeObserver();
        _this13.checkContentOverflow();
        _this13.emitPodcastLayoutRefresh();
        setTimeout(function () {
          return _this13.emitPodcastLayoutRefresh();
        }, 200);
      });
      var activeTab = 'story-' + val;
      if (activeTab !== this.activeTab) {
        this.activeTab = activeTab;
      }
    },
    isLayoutDesktop: function isLayoutDesktop(value, oldValue) {
      var _this14 = this;

      if (value === oldValue) {
        return;
      }
      this.$nextTick(function () {
        _this14.refreshLayoutContent({ clearExpanded: true });
      });
    },
    currentPopup: function currentPopup(value) {
      if (this.selectedManually) return;
      if (value) {
        this.stopNavRotation();
      } else {
        this.startNavRotation();
      }
    },
    currentSmallPopup: function currentSmallPopup(value) {
      if (this.selectedManually) return;
      if (value) {
        this.stopNavRotation();
      } else {
        this.startNavRotation();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.stopNavRotation();
    this.clearPendingExpandedMeasurements();
    this.teardownContentResizeObserver();
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener(PODCAST_RESIZE_EVENT, this.handleEmbeddedResizeEvent);

    var tabsList = this.$refs.tabsList;
    if (tabsList) {
      tabsList.removeEventListener('scroll', this.checkScrollButtons);
    }
  },
  mounted: function mounted() {
    var _this15 = this;

    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener(PODCAST_RESIZE_EVENT, this.handleEmbeddedResizeEvent);

    this.$nextTick(function () {
      var tabsList = _this15.$refs.tabsList;
      if (tabsList) {
        tabsList.addEventListener('scroll', _this15.checkScrollButtons);
      }
    });
  }
});

/***/ }),

/***/ "oY3V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notifications_widget_js__ = __webpack_require__("ORlq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12b312f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_widget_vue__ = __webpack_require__("sp68");
function injectStyle (ssrContext) {
  __webpack_require__("1tQB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notifications_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12b312f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oaFs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wallet_add_funds_credit_card_add_funds_credit_card_vue__ = __webpack_require__("g919");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__ = __webpack_require__("t71M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_wallet_add_funds_transfers_add_funds_transfers_vue__ = __webpack_require__("BGMy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_wallet_add_funds_cash_add_funds_cash_vue__ = __webpack_require__("4OEB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_wallet_add_funds_coinbase_add_funds_coinbase_vue__ = __webpack_require__("ircP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_wallet_shared_deposit_tabs_deposit_tabs_vue__ = __webpack_require__("cOUW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_wallet_shared_deposit_promotions_banner_deposit_promotions_banner_vue__ = __webpack_require__("TKSN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_wallet_shared_fee_waived_banner_fee_waived_banner_vue__ = __webpack_require__("TBZZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_feeWaivedBannerMixin__ = __webpack_require__("JKVZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_depositNotificationsMixin__ = __webpack_require__("aMy0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_wallet_shared_depositMethodTypes__ = __webpack_require__("LQTn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_instant_credit__ = __webpack_require__("zAJv");

















var ALLOWED_TAB_TYPES = [__WEBPACK_IMPORTED_MODULE_14__components_wallet_shared_depositMethodTypes__["a" /* DEPOSIT_METHOD_TYPE */].ONLINE_BANKING, __WEBPACK_IMPORTED_MODULE_14__components_wallet_shared_depositMethodTypes__["a" /* DEPOSIT_METHOD_TYPE */].CREDIT_CARD, __WEBPACK_IMPORTED_MODULE_14__components_wallet_shared_depositMethodTypes__["a" /* DEPOSIT_METHOD_TYPE */].CASH, __WEBPACK_IMPORTED_MODULE_14__components_wallet_shared_depositMethodTypes__["a" /* DEPOSIT_METHOD_TYPE */].CRYPTO, __WEBPACK_IMPORTED_MODULE_14__components_wallet_shared_depositMethodTypes__["a" /* DEPOSIT_METHOD_TYPE */].TRANSFERS];

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_feeWaivedBannerMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_depositNotificationsMixin__["a" /* default */]],
  components: {
    addFundsBankTransfer: __WEBPACK_IMPORTED_MODULE_4__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["a" /* default */],
    addFundsTransfers: __WEBPACK_IMPORTED_MODULE_5__components_wallet_add_funds_transfers_add_funds_transfers_vue__["a" /* default */],
    addFundsCreditCard: __WEBPACK_IMPORTED_MODULE_3__components_wallet_add_funds_credit_card_add_funds_credit_card_vue__["a" /* default */],
    addFundsCash: __WEBPACK_IMPORTED_MODULE_6__components_wallet_add_funds_cash_add_funds_cash_vue__["a" /* default */],
    addFundsCoinbase: __WEBPACK_IMPORTED_MODULE_7__components_wallet_add_funds_coinbase_add_funds_coinbase_vue__["a" /* default */],
    depositTabs: __WEBPACK_IMPORTED_MODULE_8__components_wallet_shared_deposit_tabs_deposit_tabs_vue__["a" /* default */],
    depositPromotionsBanner: __WEBPACK_IMPORTED_MODULE_9__components_wallet_shared_deposit_promotions_banner_deposit_promotions_banner_vue__["a" /* default */],
    feeWaivedBanner: __WEBPACK_IMPORTED_MODULE_10__components_wallet_shared_fee_waived_banner_fee_waived_banner_vue__["a" /* default */]
  },
  props: {
    checkInstantCredit: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showTabs: false,
      hideTabs: false,
      activeTab: null,
      methods: [],
      instantCreditData: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('wallet', ['depositMethods']), {
    tabs: function tabs() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__components_wallet_shared_depositMethodTypes__["b" /* buildDepositMethodTabs */])(this.methods, {
        allowedTypes: ALLOWED_TAB_TYPES
      });
    },
    showCardTab: function showCardTab() {
      return this.activeTab === __WEBPACK_IMPORTED_MODULE_14__components_wallet_shared_depositMethodTypes__["a" /* DEPOSIT_METHOD_TYPE */].CREDIT_CARD;
    },
    showBankingTab: function showBankingTab() {
      return this.activeTab === __WEBPACK_IMPORTED_MODULE_14__components_wallet_shared_depositMethodTypes__["a" /* DEPOSIT_METHOD_TYPE */].ONLINE_BANKING;
    },
    showTransfersTab: function showTransfersTab() {
      return this.activeTab === __WEBPACK_IMPORTED_MODULE_14__components_wallet_shared_depositMethodTypes__["a" /* DEPOSIT_METHOD_TYPE */].TRANSFERS;
    },
    showCashTab: function showCashTab() {
      return this.activeTab === __WEBPACK_IMPORTED_MODULE_14__components_wallet_shared_depositMethodTypes__["a" /* DEPOSIT_METHOD_TYPE */].CASH;
    },
    showCoinBaseTab: function showCoinBaseTab() {
      return this.activeTab === __WEBPACK_IMPORTED_MODULE_14__components_wallet_shared_depositMethodTypes__["a" /* DEPOSIT_METHOD_TYPE */].CRYPTO;
    }
  }),
  watch: {
    depositMethods: function depositMethods() {
      var methods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.methods = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(methods)).sort(function (a, b) {
        return a.tabIndex - b.tabIndex;
      });
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('wallet', ['getDepositMethods']), {
    tabChange: function tabChange(name) {
      this.resetChildNotifications();
      this.activeTab = name;
      // upon initial tab change if there is one tab hide options
      if (this.tabs.length === 1) {
        this.hideTabs = true;
      }
    },
    onBankTransferStep: function onBankTransferStep(step) {
      if (step === 3) {
        this.hideTabs = true;
      } else if (step === 1 || step === 2) {
        this.hideTabs = false;
      }
    }
  }),
  created: function created() {
    var _this = this;

    this.getDepositMethods().then(function (data) {
      _this.methods = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.depositMethods)).sort(function (a, b) {
        return a.tabIndex - b.tabIndex;
      });

      var shouldGoToWalletPage = _this.tabs.length === 0 && _this.isUserVerifiedFully;

      if (shouldGoToWalletPage) {
        if (_this.$route.name === 'wallet') {
          _this.setCurrentPopup();
        } else {
          _this.$router.push({ name: 'wallet' });
        }
      } else if (_this.checkInstantCredit) {
        __WEBPACK_IMPORTED_MODULE_15__services_instant_credit__["a" /* default */].run().then(function (instantCreditData) {
          _this.instantCreditData = instantCreditData;
          _this.showTabs = true;

          if (_this.instantCreditData.success) {
            _this.getStatus();
          }
        });
      } else {
        _this.showTabs = true;
      }
    });
  }
});

/***/ }),

/***/ "ofkw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oiih":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STATIC_PAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FORM_TYPE_IDV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FORM_TYPE_TRIGGERS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

/* eslint-disable */

var DEFAULT_SMALL_POPUP_TIMEOUT = 3500;
var DEFAULT_SIMPLE_NOTIFICATION_TIMEOUT = 3500;
var DEFAULT_NOTIFICATION_CLOSE_TIMEOUT = 5000;
var DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT = 250;
var MARKET_OPEN = 'Open';
var MARKET_SUSPENDED = 'Suspended';
var MARKET_EXPIRED = 'Expired';
var MARKET_SETTLED = 'Settled';
var MARKET_CLOSED = 'Closed';
var MARKET_MAINTENANCE = 'Maintenance';
var SOCIAL_LOGIN_OR_REGISTER = 'login-register';
var SOCIAL_LOGIN_ADD = 'add';

// set to false to show 'setup 2FA' prompt on login and at end of registration flows
var DISABLE_TWO_FACTOR_PROMPT = true !== null && true !== undefined ? true : true;

var CARDS = {
  VISA: 'visa',
  AMERICAN_EXPRESS: 'americanexpress',
  DISCOVER: 'discover',
  MASTERCARD: 'mastercard',
  BLANK: 'blank'
};

function getDay(index) {
  var value = index + 1;
  return {
    label: value < 10 ? '0' + value.toString() : value.toString(),
    value: value
  };
}

function getMonth(index) {
  var value = index + 1;
  return {
    label: value < 10 ? '0' + value.toString() : value.toString(),
    value: value
  };
}

function getYear(index) {
  var year = new Date().getFullYear();
  var value = year - index;

  return {
    label: value.toString(),
    value: value
  };
}

function getExpiryYear(index) {
  var year = new Date().getFullYear();
  var value = year + index;

  return {
    label: value.toString(),
    value: value
  };
}

function getBirthYear(index) {
  var year = new Date().getFullYear() - 18;
  var value = year - index;

  return {
    label: value.toString(),
    value: value
  };
}

var days = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(new Array(31))).map(function (el, index) {
  return getDay(index);
});
var months = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(new Array(12))).map(function (el, index) {
  return getMonth(index);
});
var years = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(new Array(100))).map(function (el, index) {
  return getYear(index);
});
var expiryYears = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(new Array(13))).map(function (el, index) {
  return getExpiryYear(index);
});
var birthYears = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(new Array(101))).map(function (el, index) {
  return getBirthYear(index);
});

var statesCodeToNameMap = {
  "AL": "Alabama",
  "AK": "Alaska",
  "AS": "American Samoa",
  "AZ": "Arizona",
  "AR": "Arkansas",
  "CA": "California",
  "CO": "Colorado",
  "CT": "Connecticut",
  "DE": "Delaware",
  "DC": "District Of Columbia",
  "FM": "Federated States Of Micronesia",
  "FL": "Florida",
  "GA": "Georgia",
  "GU": "Guam",
  "HI": "Hawaii",
  "ID": "Idaho",
  "IL": "Illinois",
  "IN": "Indiana",
  "IA": "Iowa",
  "KS": "Kansas",
  "KY": "Kentucky",
  "LA": "Louisiana",
  "ME": "Maine",
  "MH": "Marshall Islands",
  "MD": "Maryland",
  "MA": "Massachusetts",
  "MI": "Michigan",
  "MN": "Minnesota",
  "MS": "Mississippi",
  "MO": "Missouri",
  "MT": "Montana",
  "NE": "Nebraska",
  "NV": "Nevada",
  "NH": "New Hampshire",
  "NJ": "New Jersey",
  "NM": "New Mexico",
  "NY": "New York",
  "NC": "North Carolina",
  "ND": "North Dakota",
  "MP": "Northern Mariana Islands",
  "OH": "Ohio",
  "OK": "Oklahoma",
  "OR": "Oregon",
  "PW": "Palau",
  "PA": "Pennsylvania",
  "PR": "Puerto Rico",
  "RI": "Rhode Island",
  "SC": "South Carolina",
  "SD": "South Dakota",
  "TN": "Tennessee",
  "TX": "Texas",
  "UT": "Utah",
  "VT": "Vermont",
  "VI": "Virgin Islands",
  "VA": "Virginia",
  "WA": "Washington",
  "WV": "West Virginia",
  "WI": "Wisconsin",
  "WY": "Wyoming"
};

var statesCodeToElectoralVotesMap = {
  "NE03": 1,
  "NE02": 1,
  "NE01": 1,
  "NE-03": 1,
  "NE-02": 1,
  "NE-01": 1,
  "WA": 12,
  "DE": 3,
  "DC": 3,
  "WI": 10,
  "WV": 5,
  "HI": 4,
  "FL": 29,
  "WY": 3,
  "NH": 4,
  "NJ": 14,
  "NM": 5,
  "TX": 38,
  "LA": 8,
  "NC": 15,
  "ND": 3,
  "NE": 2, // 5
  "TN": 11,
  "NY": 29,
  "PA": 20,
  "CA": 55,
  "NV": 6,
  "VA": 13,
  "CO": 9,
  "AK": 3,
  "AL": 9,
  "AR": 6,
  "VT": 3,
  "IL": 20,
  "GA": 16,
  "IN": 11,
  "IA": 6,
  "OK": 7,
  "AZ": 11,
  "ID": 4,
  "CT": 7,
  "ME": 2, // 4
  "MD": 10,
  "MA": 11,
  "OH": 18,
  "UT": 6,
  "MO": 10,
  "MN": 10,
  "MI": 16,
  "RI": 4,
  "KS": 6,
  "MT": 3,
  "ME02": 1,
  "MS": 6,
  "ME01": 1,
  "ME-01": 1,
  "ME-02": 1,
  "SC": 9,
  "KY": 8,
  "OR": 7,
  "SD": 3
};

var SMALL_STATE_CODES = ['VT', 'NH', 'MA', 'RI', 'CT', 'NJ', 'DE', 'MD', 'DC'];

var STATIC_PAGES = {
  TERMS: 'TandC',
  RESEARCH: 'ResearchPage',
  PRIVACY: 'PrivacyPolicy',
  WHAT_IS: 'WhatIsPredictIt',
  HOW_TO_TRADE: 'HowToTradeOnPredictIt',
  PLATFORM_ANNOUNCEMENTS: 'PlatformAnnouncements',
  DEPOSIT_WARNING: 'DepositWarning',
  NEWS: 'News',
  NEWS_ARCHIVE: 'NewsArchive',
  LEARN: 'Learn',
  RESPONSIBLE_TRADING: 'ResponsibleTrading'
};

var FORM_TYPE_IDV = {
  INITIAL: 1,
  CHANGE_ADDRESS: 2,
  SSN4IDV: 3
};

var FORM_TYPE_TRIGGERS = {
  MODAL: 'modal',
  STANDALONE: 'standalone'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  FORM_TYPE_IDV: FORM_TYPE_IDV,
  FORM_TYPE_TRIGGERS: FORM_TYPE_TRIGGERS,
  CARDS: CARDS,
  DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT: DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT,
  DEFAULT_NOTIFICATION_CLOSE_TIMEOUT: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
  DEFAULT_SIMPLE_NOTIFICATION_TIMEOUT: DEFAULT_SIMPLE_NOTIFICATION_TIMEOUT,
  DEFAULT_SMALL_POPUP_TIMEOUT: DEFAULT_SMALL_POPUP_TIMEOUT,
  MARKET_OPEN: MARKET_OPEN,
  MARKET_SUSPENDED: MARKET_SUSPENDED,
  MARKET_EXPIRED: MARKET_EXPIRED,
  MARKET_SETTLED: MARKET_SETTLED,
  MARKET_CLOSED: MARKET_CLOSED,
  MARKET_MAINTENANCE: MARKET_MAINTENANCE,
  DISABLE_TWO_FACTOR_PROMPT: DISABLE_TWO_FACTOR_PROMPT,
  SOCIAL_LOGIN_ADD: SOCIAL_LOGIN_ADD,
  SOCIAL_LOGIN_OR_REGISTER: SOCIAL_LOGIN_OR_REGISTER,
  SMALL_STATE_CODES: SMALL_STATE_CODES,
  birthYears: birthYears,
  expiryYears: expiryYears,
  years: years,
  months: months,
  days: days,
  statesCodeToNameMap: statesCodeToNameMap,
  statesCodeToElectoralVotesMap: statesCodeToElectoralVotesMap,
  STATIC_PAGES: STATIC_PAGES
});

/***/ }),

/***/ "okUC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tabs",class:("tabs--" + _vm.theme)},_vm._l((_vm.items),function(item){return _c('li',{class:_vm.tabItemModifiers(item),on:{"click":function($event){$event.preventDefault();return _vm.onChange(item.name)}}},[_c('a',{class:_vm.tabLinkModifiers(item),attrs:{"href":"#"}},[(item.icon)?[_c('span',{class:_vm.tabIconModifiers(item)})]:[_c('div',{staticClass:"tabs__title"},[_vm._v("\n          "+_vm._s(item.title)+"\n        ")]),_vm._v(" "),(item.subtitle)?_c('div',{staticClass:"tabs__subtitle",domProps:{"innerHTML":_vm._s(item.subtitle)}}):_vm._e(),_vm._v(" "),(item.meta && item.meta.numRuleComments > 0)?_c('div',{staticClass:"tabs__rule-comments-count"},[_vm._v("\n          "+_vm._s(item.meta.numRuleComments)+"\n        ")]):_vm._e()]],2)])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ooVM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNumber__ = __webpack_require__("J009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil__ = __webpack_require__("q16o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_omitBy__ = __webpack_require__("uN7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_omitBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_omitBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_promoCode__ = __webpack_require__("nPqm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_documentUpload__ = __webpack_require__("9xQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_getValidationMessage__ = __webpack_require__("U7Hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_wallet_deposited_deposited_vue__ = __webpack_require__("WXHk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_bank_account_bank_account_vue__ = __webpack_require__("5r1F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_processing_transaction_processing_transaction_vue__ = __webpack_require__("eGtO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_depositWarningMixin__ = __webpack_require__("Scap");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_dataLayer__ = __webpack_require__("k37b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_wallet_shared_deposit_disclaimer_deposit_disclaimer_vue__ = __webpack_require__("SmIQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_wallet_shared_depositMethodTypes__ = __webpack_require__("LQTn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_wallet_shared_fee_waived_banner_fee_waived_banner_vue__ = __webpack_require__("TBZZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__add_funds_bank_transfer_constants__ = __webpack_require__("rARD");





/* global PayWithMyBank */
/* eslint-disable */




















var AMOUNT_STEP_ONE = 10;
var AMOUNT_STEP_THREE = 50;
var AMOUNT_STEP_FOUR = 100;

var CLOSE_PAYMENT_SUCCESS_TIMEOUT = 1500;

var ERROR_MESSAGE_GENERIC = 'Unable to remove the authorization, please try again later.';

var randomNumber = function randomNumber() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 99999;
  return Math.floor(Math.random() * (max - min + 1) + min);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14_vuelidate__["validationMixin"], __WEBPACK_IMPORTED_MODULE_7__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_promoCode__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__mixins_depositWarningMixin__["a" /* default */]],
  components: {
    bankAccount: __WEBPACK_IMPORTED_MODULE_15__components_bank_account_bank_account_vue__["a" /* default */],
    processingTransaction: __WEBPACK_IMPORTED_MODULE_16__components_processing_transaction_processing_transaction_vue__["a" /* default */],
    deposited: __WEBPACK_IMPORTED_MODULE_13__components_wallet_deposited_deposited_vue__["default"],
    depositDisclaimer: __WEBPACK_IMPORTED_MODULE_19__components_wallet_shared_deposit_disclaimer_deposit_disclaimer_vue__["a" /* default */],
    feeWaivedBanner: __WEBPACK_IMPORTED_MODULE_21__components_wallet_shared_fee_waived_banner_fee_waived_banner_vue__["a" /* default */]
  },
  props: {
    isPopup: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      depositMethodType: __WEBPACK_IMPORTED_MODULE_20__components_wallet_shared_depositMethodTypes__["a" /* DEPOSIT_METHOD_TYPE */].ONLINE_BANKING,
      errors: [],
      fields: {},
      isFormEnabled: true,
      timeout: null,
      amount: 0,
      payWithMyBankId: 'paywithmybank-' + randomNumber(),
      canDeposit: false,
      smallPopupShown: false,
      depositAmounts: [AMOUNT_STEP_ONE, AMOUNT_STEP_THREE, AMOUNT_STEP_FOUR],
      currentStep: __WEBPACK_IMPORTED_MODULE_22__add_funds_bank_transfer_constants__["a" /* STEPS */].INITIAL,
      currentStepData: {},
      requestSignature: '',
      authorizationId: null,
      errorMessage: '',
      refreshDataObject: {},
      existingAccounts: [],
      account: null,
      STEPS: __WEBPACK_IMPORTED_MODULE_22__add_funds_bank_transfer_constants__["a" /* STEPS */]
    };
  },
  validations: function validations() {
    return {
      amount: __WEBPACK_IMPORTED_MODULE_11__components_forms_mixin__["b" /* validators */].depositAmountCoinbase(this.minimumDepositAmount, this.maximumDepositAmount)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('wallet', ['minimumDepositAmount', 'bankTransferStep']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('user', ['status']), {
    accountUploadDocumentTheme: function accountUploadDocumentTheme() {
      return this.isPopup ? '' : 'page-padded';
    },
    classModifiers: function classModifiers() {
      return {
        'add-funds-bank-transfer': true,
        'add-funds-bank-transfer--popup': this.isPopup,
        'add-funds-bank-transfer--regular': !this.isPopup
      };
    },
    noticePromoModifiers: function noticePromoModifiers() {
      return {
        'add-funds-bank-transfer__notice': true,
        'add-funds-bank-transfer__notice--promo-popup': this.isPopup
      };
    },
    infoAmount: function infoAmount() {
      var number = Number(this.amount).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return '$' + number;
    },
    isConfirmDisabled: function isConfirmDisabled() {
      return this.invalidOrDisabled || !this.canDeposit;
    },
    amountHasError: function amountHasError() {
      return this.$v.amount.$error;
    },
    amountValidationMessage: function amountValidationMessage() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helpers_getValidationMessage__["a" /* default */])(this.$v.amount);
    },
    maximumDepositAmount: function maximumDepositAmount() {
      return 99999;
    },
    isFormDisabled: function isFormDisabled() {
      return this.isFormEnabled === false;
    },
    invalidOrDisabled: function invalidOrDisabled() {
      return this.$v.$invalid || !this.isFormEnabled;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup', 'setCurrentPopupOptions', 'setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('wallet', ['getDepositPWMB', 'deletePWMBAccount', 'confirmDepositPWMB', 'submitDepositPWMB', 'getDepositMethods']), {
    formIsValid: function formIsValid() {
      return !this.$v.$invalid;
    },
    formEnable: function formEnable() {
      this.isFormEnabled = true;
    },
    formDisable: function formDisable() {
      this.formReset();
      this.isFormEnabled = false;
      return true;
    },
    formReset: function formReset() {
      this.errors = [];
    },
    onSuccess: function onSuccess() {
      if (this.isPopup) {
        this.setCurrentPopup();
      } else {
        this.onLoadInitial();
      }
    },
    isStep: function isStep(name) {
      return this.currentStep === name;
    },
    cleanup: function cleanup() {
      if (typeof PayWithMyBank !== 'undefined') {
        PayWithMyBank.destroy();
      }
    },
    handleAmountBlur: function handleAmountBlur() {
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'fill',
        label: 'Amount'
      }));
    },
    handleDepositFail: function handleDepositFail(error) {
      this.currentStepData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.currentStepData, {
        error: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', '')
      });
      this.currentStep = __WEBPACK_IMPORTED_MODULE_22__add_funds_bank_transfer_constants__["a" /* STEPS */].FINISHED_FAILED;
    },
    onRemove: function onRemove(account) {
      var _this = this;

      this.errorMessage = '';
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_modals_constants__["a" /* MODALS */].SMALL_PWMB_ACCOUNT_CONFIRM_DELETE);
      this.smallPopupShown = true;
      this.setCurrentPopupOptions({
        onConfirm: function onConfirm() {
          _this.loaderAdd();
          _this.deletePWMBAccount(account.authorizationId).then(function (data) {
            if (data) {
              _this.setup({ loadWidget: false });
            } else {
              _this.errorMessage = ERROR_MESSAGE_GENERIC;
            }
            _this.loaderRemove();
            _this.smallPopupShown = false;
            _this.setCurrentSmallPopup();
          }).catch(function () {
            _this.errorMessage = ERROR_MESSAGE_GENERIC;
            _this.loaderRemove();
            _this.smallPopupShown = false;
            _this.setCurrentSmallPopup();
          });
        }
      });
    },
    onSelect: function onSelect(account) {
      if (account.accountStatus === 2) {
        this.authorizationId = account.authorizationId;
        this.account = account;
        this.setup({ authorizationId: account.authorizationId });
      } else {
        this.authorizationId = account.authorizationId;
        this.account = account;
        this.cleanup();
        this.currentStep = __WEBPACK_IMPORTED_MODULE_22__add_funds_bank_transfer_constants__["a" /* STEPS */].AMOUNT_CONFIRM;
      }
    },
    onLoadInitial: function onLoadInitial() {
      this.currentStep = __WEBPACK_IMPORTED_MODULE_22__add_funds_bank_transfer_constants__["a" /* STEPS */].INITIAL;
      this.setup();
    },
    onCancelConfirm: function onCancelConfirm() {
      this.currentStep = __WEBPACK_IMPORTED_MODULE_22__add_funds_bank_transfer_constants__["a" /* STEPS */].AMOUNT_CONFIRM;
    },
    onReviewAndConfirm: function onReviewAndConfirm() {
      var _this2 = this;

      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'submit',
        label: 'Submit Deposit'
      }));
      if (this.formIsValid() && this.formDisable()) {
        this.loaderAdd();
        var payload = {
          amount: this.amount
        };
        this.confirmDepositPWMB(payload).then(function (data) {
          _this2.loaderRemove();
          _this2.formEnable();
          if (_this2.checkDocumentUploadFlags(data)) return;
          _this2.currentStep = __WEBPACK_IMPORTED_MODULE_22__add_funds_bank_transfer_constants__["a" /* STEPS */].CONFIRM;
        }).catch(function (error) {
          _this2.loaderRemove();
          if (_this2.checkDocumentUploadFlags(error.response.data)) return;
          _this2.formEnable();
          _this2.handleDepositFail(error);
        });
      }
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      this.formDisable();
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Deposit Confirm',
        action: 'submit',
        label: 'Confirm Deposit'
      }));
      this.loaderAdd();
      var payload = {
        amount: this.amount,
        pwmbAuthorizationId: this.authorizationId
      };
      this.submitDepositPWMB(payload).then(function (data) {
        _this3.loaderRemove();
        if (_this3.checkDocumentUploadFlags(data)) return;
        _this3.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__helpers_dataLayer__["a" /* withMeta */])({
          event: _this3.status.hasBeenFunded ? 'MultiDeposit' : 'Deposit'
        }));
        if (data.isBankReauthorizationRequired) {
          _this3.currentStep = __WEBPACK_IMPORTED_MODULE_22__add_funds_bank_transfer_constants__["a" /* STEPS */].FINISHED_EXPIRED;
          _this3.setupReauthorization();
        } else if (data.waitForResponseEvent) {
          _this3.currentStep = __WEBPACK_IMPORTED_MODULE_22__add_funds_bank_transfer_constants__["a" /* STEPS */].PROCESSING;
        } else {
          setTimeout(function () {
            _this3.setCurrentPopup();
          }, CLOSE_PAYMENT_SUCCESS_TIMEOUT);
        }
        _this3.formEnable();
      }).then(this.getBalance).catch(function (error) {
        _this3.loaderRemove();
        if (_this3.checkDocumentUploadFlags(error.response.data)) return;
        _this3.formEnable();
        _this3.handleDepositFail(error);
      });
    },
    setup: function setup() {
      var _this4 = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$loadWidget = _ref.loadWidget,
          loadWidget = _ref$loadWidget === undefined ? true : _ref$loadWidget,
          _ref$authorizationId = _ref.authorizationId,
          authorizationId = _ref$authorizationId === undefined ? '' : _ref$authorizationId;

      var url = window.location.origin + window.location.pathname;
      var payload = {
        returnUrl: url + '?pwmbDeposit=success',
        cancelUrl: url + '?pwmbDeposit=cancel',
        authorizationId: authorizationId
      };
      this.loaderAdd();
      return this.getDepositPWMB(payload).then(function (data) {
        _this4.loaderRemove();
        _this4.checkDocumentUploadFlags(data);
        _this4.errorMessage = data.errorMessage;
        _this4.promoCodeDetail = data.promoCodeDetail || {};
        _this4.canDeposit = data.canDeposit;
        _this4.existingAccounts = data.existingAccounts || [];
        if (loadWidget && data.refreshDataObject && _this4.$refs.paywithmybank) {
          _this4.loadWidget(data);
        }
        return data;
      }).catch(function (error) {
        _this4.loaderRemove();
        _this4.errorMessage = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', null);
      });
    },
    loadWidget: function loadWidget(apiData) {
      var _this5 = this;

      this.refreshDataObject = apiData.refreshDataObject;
      this.amount = apiData.refreshDataObject.amount;
      this.requestSignature = apiData.pwmbRequestSignature;
      var url = apiData.refreshDataObject.pwmbSDKUrl;
      if (this.$refs.paywithmybank) {
        this.loaderAdd(this.$refs.paywithmybank.parentElement, 'is-loading', false);
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["f" /* loadScript */])(url, 'PayWithMyBank').then(function () {
        setTimeout(function () {
          if (_this5.$refs.paywithmybank) {
            _this5.loaderRemove(_this5.$refs.paywithmybank.parentElement, 'is-loading', false);
          }
        }, 2000);
        var options = {
          closeButton: false,
          dragAndDrop: true,
          widgetContainerId: _this5.payWithMyBankId
        };
        var data = __WEBPACK_IMPORTED_MODULE_4_lodash_omitBy___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, apiData.refreshDataObject, {
          requestSignature: apiData.pwmbRequestSignature
        }), __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default.a);

        PayWithMyBank.addPanelListener(function (command, obj) {
          switch (command) {
            case 'event':
              switch (obj.type) {
                case 'close':
                  if (_this5.currentStep === __WEBPACK_IMPORTED_MODULE_22__add_funds_bank_transfer_constants__["a" /* STEPS */].FINISHED_EXPIRED) {
                    _this5.onLoadInitial();
                  }
                  break;
                case 'new_location':
                  obj.preventDefault();
                  break;
                default:
                  break;
              }
              break;
            default:
              break;
          }
        });
        if (apiData.refreshDataObject.authToken) {
          PayWithMyBank.establish(data, options);
        } else {
          PayWithMyBank.selectBankWidget(data, options);
        }
      });
    },
    onUpdateAmount: function onUpdateAmount(value) {
      if (this.amount === '' || Number(this.amount) === 0.0) {
        this.amount = value;
      } else if (__WEBPACK_IMPORTED_MODULE_2_lodash_isNumber___default()(this.amount)) {
        this.amount = Number(this.amount) + value;
      } else {
        this.amount = Number(this.amount) + value;
      }
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'click',
        label: 'Amount ' + value + ' Button'
      }));
    },
    setupReauthorization: function setupReauthorization() {
      var _this6 = this;

      this.timeout = window.setTimeout(function () {
        _this6.setup({
          authorizationId: _this6.account.authorizationId
        });
      }, 3500);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === 13 && this.smallPopupShown) {
        this.smallPopupShown = false;
        this.setCurrentSmallPopup();
      }
    },
    currentStepHandler: function currentStepHandler(value) {
      this.$emit('step', value);
    }
  }),
  watch: {
    bankTransferStep: function bankTransferStep(value) {
      var _this7 = this;

      this.currentStep = value.step;
      this.currentStepData = value.stepData;
      if (value.step === __WEBPACK_IMPORTED_MODULE_22__add_funds_bank_transfer_constants__["a" /* STEPS */].AMOUNT_CONFIRM) {
        this.cleanup();
        this.setup({ loadWidget: false }).then(function (data) {
          _this7.authorizationId = _this7.currentStepData.pwmbAuthorizationId;
          _this7.account = data.existingAccounts.find(function (i) {
            return i.authorizationId === _this7.authorizationId;
          });
        });
      } else if (value.step === __WEBPACK_IMPORTED_MODULE_22__add_funds_bank_transfer_constants__["a" /* STEPS */].FINISHED_EXPIRED) {
        this.cleanup();
        this.setup({ loadWidget: false }).then(function (data) {
          _this7.authorizationId = _this7.currentStepData.pwmbAuthorizationId;
          _this7.account = data.existingAccounts.find(function (i) {
            return i.authorizationId === _this7.authorizationId;
          });
        }).then(function () {
          return _this7.setupReauthorization();
        });
      } else if (value.step === __WEBPACK_IMPORTED_MODULE_22__add_funds_bank_transfer_constants__["a" /* STEPS */].CONFIRM) {
        this.amount = Number(this.currentStepData.prefilledAmountToDeposit);
      }
    },

    currentStep: {
      handler: 'currentStepHandler',
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.cleanup();
    window.removeEventListener('keyup', this.onKeyDown);
    if (this.timeout) {
      window.clearTimeout(this.timeout);
    }
  },
  mounted: function mounted() {
    this.setup();
    this.getDepositMethods();
    window.addEventListener('keyup', this.onKeyDown);
  }
});

/***/ }),

/***/ "owqz":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAt1BMVEUAAACzxsa5xsa3xcX///+5xce4xca7zMy4xca4xcW4xca5xce3xMa5xMe4xca7xMS4xca4w8O5w8i4xca4xca4xca3xca4xcW/v7+5xcW5xcW5xcWqqqq3w8e3xsa5udG4xcW4xce4xMS4xcW5xce3xsa4xcaxxMS4xca4xce4xMa3xcW4xsa4xsa5xcW5xsa4xMS4xca4xca4xsa3xMa2yMi5xce4xMa4xcW4xca5xca4xcYAAACBS8jKAAAAO3RSTlMAG0xYAW3mD7yf8pVjSdQe/C8z/tPXq6gMPlQsA0BRC13QK3PHQ+ENwoy7avS/FpxB6PmBixyRocbs4TuKakIAAAABYktHRACIBR1IAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4gwECBkTzGfTAQAAASpJREFUWMPtlnlPwkAQxRe2HC1XoYWCyqECHqAihwLv+38vuxuI2hLSnSGBkL5/Nt12ftl5M+mOEKlSXY4yWWmsbGYfbeXyICmfs1R8oUgLVyoWQoANOKWyeQrlkgPYQlSAao3mXK0KVMIDuHWq9w0vPIIPn169ZhjsokUHtOAKINg9tTtS3tzeHfrQ6kYc7PX1fgD8AgaOrsz9wwHAY6yAwxhg5O1ejZ9ogGd4L1IOXoEJLYUp3tTyDnwkN/EvILqeFjD7jFgwX5ilsIyZODYzcfUV/Nf3zKyMSTw42kiJAMdaORmAoKsBrM1/qHutNYCnUwA29BQ2GrClm7i9FgDbxPP3AbOV2ZerjyYdoK53G16DGq8HDPaIwx6y+GMee9BU4o26qVJdgH4ANBK/Pw4bXI4AAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMTItMDRUMDg6MjU6MTkrMDE6MDADEIs/AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTEyLTA0VDA4OjI1OjE5KzAxOjAwck0zgwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII="

/***/ }),

/***/ "oyEw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.disclaimer)?_c('div',{staticClass:"deposit-disclaimer"},[_c('div',{staticClass:"deposit-disclaimer__line"}),_vm._v(" "),_c('p',{staticClass:"deposit-disclaimer__text"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.disclaimer)}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p1CT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authorizeApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_interceptors_request__ = __webpack_require__("drjh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_interceptors_responseSuccess__ = __webpack_require__("rxGt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_interceptors_responseError__ = __webpack_require__("P3oX");





var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: "/"
});

http.interceptors.request.use(__WEBPACK_IMPORTED_MODULE_1__services_interceptors_request__["a" /* default */]);
http.interceptors.response.use(__WEBPACK_IMPORTED_MODULE_2__services_interceptors_responseSuccess__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__services_interceptors_responseError__["a" /* default */]);

function authorizeApi(token) {
  if (token) {
    http.defaults.headers.common.Authorization = 'Bearer ' + token;
  } else {
    delete http.defaults.headers.common.Authorization;
  }
}

/* harmony default export */ __webpack_exports__["b"] = (http);


/***/ }),

/***/ "p8N8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pM6l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "paCg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "pfo7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ptZl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_price_change_chart_js__ = __webpack_require__("1Lmp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eac342e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_price_change_chart_vue__ = __webpack_require__("aLRO");
function injectStyle (ssrContext) {
  __webpack_require__("iOdY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_price_change_chart_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eac342e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_price_change_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q/wu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q1K7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_winner_v2_js__ = __webpack_require__("4v/L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a1da946_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_winner_v2_vue__ = __webpack_require__("jWsT");
function injectStyle (ssrContext) {
  __webpack_require__("s8MB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_winner_v2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a1da946_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_winner_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q3Wh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qFzA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qIn7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_icon_js__ = __webpack_require__("4/Ye");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c632654_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_icon_vue__ = __webpack_require__("rHug");
function injectStyle (ssrContext) {
  __webpack_require__("/96V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_icon_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c632654_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qXT1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");






function getPriceOrZero(target) {
  // value may be empty or can come as fraction like 0.99 or 99
  if (isNaN(target)) return 0;
  return target < 1 ? Math.round(100 * target) : Math.round(target);
}

function _hasPrice(target) {
  return getPriceOrZero(target) > 0;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  props: {
    widget: Object,
    theme: {
      type: String,
      default: ''
    }
  },
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_2__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'market-money-widget': true
      }, 'market-money-widget--' + this.theme, this.theme);
    },
    iconModifiers: function iconModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'market-money-widget__icon': true
      }, 'market-money-widget__icon--' + this.iconTargetClass, this.iconTargetClass);
    },
    iconTargetClass: function iconTargetClass() {
      return this.delta ? 'price-up' : 'price-down';
    },
    obj: function obj() {
      return this.widget ? this.widget : {};
    },
    hasPrice: function hasPrice() {
      return _hasPrice(this.obj.lastTradePrice);
    },
    price: function price() {
      return getPriceOrZero(this.obj.lastTradePrice);
    },
    delta: function delta() {
      if (!this.hasPrice) {
        return 0;
      }
      return getPriceOrZero(this.obj.lastTradePrice) - getPriceOrZero(this.obj.lastClosePrice);
    },
    percent: function percent() {
      var value = (this.obj.percentValue || '0').toString();
      if (value.endsWith('%')) {
        return value;
      }
      var parsed = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(value, 10);
      return isNaN(parsed) ? '0%' : parsed + '%';
    },
    contractName: function contractName() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["k" /* isMarketSingle */])(this.obj) ? 'Latest Price' : this.obj.contractName;
    }
  },
  methods: {
    onClick: function onClick() {
      this.$router.push({
        name: 'market-details',
        params: {
          marketId: this.obj.marketId,
          marketUrl: this.obj.marketUrl
        }
      });
    }
  },
  watch: {
    widget: function widget(val) {
      if (val) {
        this.loaderRemove();
      }
    }
  },
  mounted: function mounted() {
    if (!this.widget) {
      this.loaderAdd();
    }
  }
});

/***/ }),

/***/ "qYhg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_icons_dollar_sign_round_green_svg__ = __webpack_require__("kHwo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_icons_dollar_sign_round_green_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_icons_dollar_sign_round_green_svg__);


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    level: {
      type: String,
      default: 'success'
    },
    icon: {
      type: String,
      default: null
    }
  },
  computed: {
    iconSrc: function iconSrc() {
      if (this.icon === 'dollar') {
        return __WEBPACK_IMPORTED_MODULE_0__assets_icons_dollar_sign_round_green_svg___default.a;
      }
      return null;
    },
    levelModifier: function levelModifier() {
      return 'alert-box--' + this.level;
    }
  }
});

/***/ }),

/***/ "qidN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LS_MAINTENANCE_MESSAGE_KEY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_localStorage__ = __webpack_require__("Moaq");




var LS_MAINTENANCE_MESSAGE_KEY = 'maintenanceMessageHidden';

/* harmony default export */ __webpack_exports__["b"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['hasBanner']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['hasServerErrorOccurred', 'maintenance', 'liveUpdatesDisabled', 'hiddenMaintenanceMessage']), {
    classModifiers: function classModifiers() {
      return {
        'app-header-notification__wrapper': true
      };
    },
    maintenanceMessageText: function maintenanceMessageText() {
      return this.maintenance.suspendedMessage || this.maintenance.systemMessage;
    },
    hasServerMessage: function hasServerMessage() {
      return !!this.maintenanceMessageText && this.maintenanceMessageText !== this.hiddenMaintenanceMessage;
    },
    showErrorNotification: function showErrorNotification() {
      return !this.hasServerMessage && this.hasServerErrorOccurred;
    },
    showBannerNotification: function showBannerNotification() {
      return !this.hasServerMessage && this.hasBanner && !this.hasServerErrorOccurred;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['dontShowBanner', 'setServerError', 'setHiddenMaintenanceMessage']), {
    onCloseMaintenanceMessage: function onCloseMaintenanceMessage() {
      var expiresAt = 86400 * 3; // 3 days
      __WEBPACK_IMPORTED_MODULE_2__helpers_localStorage__["a" /* default */].set(LS_MAINTENANCE_MESSAGE_KEY, this.maintenanceMessageText, expiresAt);
      this.setHiddenMaintenanceMessage(this.maintenanceMessageText);
    },
    onErrorClick: function onErrorClick() {
      this.setServerError(false);
      var dt = new Date();
      this.$router.go({
        path: this.$router.path,
        query: {
          t: +dt
        }
      });
    },
    onBannerClick: function onBannerClick() {
      this.dontShowBanner();
    },
    onSystemMessageClick: function onSystemMessageClick() {
      this.$router.push({ name: 'platform-announcements' });
    }
  })
});

/***/ }),

/***/ "qn2S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.classModifiers,attrs:{"to":{name: 'market-details', params: {marketId: _vm.market.marketId, marketUrl: _vm.market.marketUrl}}},nativeOn:{"click":function($event){return _vm.fireMarketTileClick($event)}}},[_c('div',{staticClass:"market-list-item-v2__container",on:{"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseLeave}},[_c('div',{staticClass:"market-list-item-v2__container-bg1",style:(_vm.styleModifiers)}),_vm._v(" "),_c('div',{staticClass:"market-list-item-v2__container-bg2"}),_vm._v(" "),_c('div',{staticClass:"market-list-item-v2__main-section"},[_c('div',{staticClass:"market-list-item-v2__main-section-container"},[_c('h3',{staticClass:"market-list-item-v2__title"},[_vm._v("\n            "+_vm._s(_vm.market.marketName)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"market-list-item-v2__contracts"},_vm._l((_vm.contracts),function(item){return _c('market-contract',{key:_vm.contractKey(item),attrs:{"market":_vm.market,"contract":item}})}),1),_vm._v(" "),_c('div',{staticClass:"market-list-item-v2__shares"},[(!_vm.showVolume)?_c('span',{staticClass:"market-list-item-v2__shares-new"},[_vm._v("\n              NEW\n            ")]):[_c('span',{directives:[{name:"large-number",rawName:"v-large-number",value:(_vm.totalSharesTraded),expression:"totalSharesTraded"}]}),_vm._v(" Share"),(_vm.totalSharesTraded !== 1)?_c('span',[_vm._v("s")]):_vm._e(),_vm._v(" Traded\n            ")]],2)])]),_vm._v(" "),(_vm.watchIcon)?_c('div',{staticClass:"market-list-item-v2__right"},[_c('div',{staticClass:"market-list-item-v2__watch",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.watchToggle($event)}}},[_c('div',{staticClass:"market-list-item-v2__watch-icon"})])]):_vm._e(),_vm._v(" "),(_vm.showSharesOwnedNotification)?[_c('div',{staticClass:"market-list-item-v2__shares-owned"})]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qtti":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__("G/BR");





var appNotificationMixin = {
  props: {
    autoClose: {
      type: Boolean,
      required: false,
      default: true
    },
    closeTimeout: {
      type: Number,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
    },
    index: {
      type: Number,
      required: true
    },
    closeButton: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      timeout: null,
      interacted: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['remove']), {
    onClose: function onClose() {
      this.remove(this.index);
    },
    onInteract: function onInteract() {
      this.interacted = true;
    }
  }),
  computed: {
    isDebug: function isDebug() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__logger__["b" /* isDebugOn */])();
    },
    showAutoCloseLoader: function showAutoCloseLoader() {
      return this.autoClose && this.closeTimeout > 0 && !this.interacted && !this.isDebug;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$el.addEventListener('click', function () {
      return _this.onInteract();
    });
    if (this.autoClose && !this.isDebug) {
      this.timeout = setTimeout(function () {
        if (!_this.interacted) _this.onClose();
      }, this.closeTimeout);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.onClose();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (appNotificationMixin);

/***/ }),

/***/ "r5bH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "rARD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STEPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FINISHED_STATUS; });
var STEPS = {
  INITIAL: 1,
  AMOUNT_CONFIRM: 2,
  CONFIRM: 3,
  PROCESSING: 4,
  FINISHED_SUCCESS: 5,
  FINISHED_FAILED: 6,
  FINISHED_EXPIRED: 7
};

var FINISHED_STATUS = {
  SUCCESS: 1,
  FAILED: 2,
  EXPIRED: 3
};

/***/ }),

/***/ "rEDR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_items_js__ = __webpack_require__("EcaT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8786f2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_items_vue__ = __webpack_require__("ypi2");
function injectStyle (ssrContext) {
  __webpack_require__("KJ3Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_items_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8786f2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_items_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rHug":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-icon"},[(!_vm.reversed)?_c('div',[_c('img',{staticClass:"notification-icon__img",attrs:{"src":__webpack_require__("grAS")},on:{"mousedown":function($event){$event.preventDefault();},"click":function($event){$event.preventDefault();return _vm.onClick($event)}}}),_vm._v(" "),_c('span',{staticClass:"notification-icon__text"},[_vm._v(_vm._s(_vm.text))])]):_vm._e(),_vm._v(" "),(_vm.reversed)?_c('div',[_c('span',{staticClass:"notification-icon__text"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('img',{staticClass:"notification-icon__img",attrs:{"src":__webpack_require__("grAS")},on:{"mousedown":function($event){$event.preventDefault();},"click":function($event){$event.preventDefault();return _vm.onClick($event)}}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rR+P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_account_account_phone_update_account_phone_update_vue__ = __webpack_require__("AORQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_no_data_dashed_box_no_data_dashed_box_vue__ = __webpack_require__("n8+9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_bank_svg__ = __webpack_require__("hkzh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_bank_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_icons_bank_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_bankLinkDiagnostics__ = __webpack_require__("UVmH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__aerosync_widget_adapter__ = __webpack_require__("MyEa");










var COMPLETION_RECONCILIATION_ATTEMPTS = 4;
var COMPLETION_RECONCILIATION_DELAY_MS = 1500;
var UNCERTAIN_COMPLETION_CODES = ['BANK_LINK_COMPLETION_FAILED', 'BANK_LINK_COMPLETION_TIMEOUT'];
var PHONE_VERIFICATION_REQUIRED_REASON_CODE = 'BANK_LINK_PHONE_VERIFICATION_REQUIRED';
var PROVIDER_IDENTITY_ALREADY_LINKED_REASON_CODE = 'BANK_LINK_PROVIDER_IDENTITY_ALREADY_LINKED';
var PROVIDER_CONFIRMATION_READY_REASON_CODE = 'BANK_LINK_PROVIDER_CONFIRMATION_READY';
// Ownership and blacklist rejections are PredictIt policy; every other link failure
// is something the provider can look into for the customer.
var PREDICTIT_SUPPORT_REASON_CODES = ['ACCOUNT_USED_BY_ANOTHER_CUSTOMER', 'ACCOUNT_BLACKLISTED'];
var PROVIDER_SUPPORT_URL = 'https://www.aeropay.com/personal/support';
var PROVIDER_CONFIRMATION_REQUIRED_REASON_CODE = 'BANK_LINK_PROVIDER_CONFIRMATION_REQUIRED';
var PROVIDER_CONFIRMATION_CODE_LENGTH = 6;

function wait(delayMs) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    return setTimeout(resolve, delayMs);
  });
}

function canReconcileCompletion(result) {
  return !!result && result.retryable === true && UNCERTAIN_COMPLETION_CODES.includes(result.reasonCode);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    accountPhoneUpdate: __WEBPACK_IMPORTED_MODULE_4__components_account_account_phone_update_account_phone_update_vue__["default"],
    alertBox: __WEBPACK_IMPORTED_MODULE_3__components_generics_alert_box_alert_box_vue__["a" /* default */],
    noDataDashedBox: __WEBPACK_IMPORTED_MODULE_5__components_generics_no_data_dashed_box_no_data_dashed_box_vue__["a" /* default */]
  },
  props: {
    purpose: {
      type: String,
      default: 'deposit',
      validator: function validator(value) {
        return ['deposit', 'withdrawal'].includes(value);
      }
    },
    noticeText: {
      type: String,
      default: null
    },
    selectable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      accountBeingRemoved: null,
      accounts: [],
      advisoryActionUrl: '',
      advisoryMessage: '',
      completionConnectionId: null,
      confirmationChannel: '',
      confirmationCode: '',
      confirmationDestination: '',
      confirmationErrorMessage: '',
      confirmationResendAvailableAt: null,
      confirmationSecondsUntilResend: 0,
      confirmationTimer: null,
      defaultInstitutionLogo: __WEBPACK_IMPORTED_MODULE_6__assets_icons_bank_svg___default.a,
      errorMessage: '',
      errorReasonCode: '',
      errorIsLinkFailure: false,
      hasProviderLinkFailure: false,
      providerSupportUrl: PROVIDER_SUPPORT_URL,
      isCompletingLink: false,
      isDestroyed: false,
      isLinking: false,
      isLoading: true,
      isManagingAccounts: false,
      isPhoneVerificationRequired: false,
      isPhoneVerificationVisible: false,
      isProviderConfirmationReady: false,
      isProviderConfirmationRequired: false,
      isSendingProviderConfirmation: false,
      isConfirmingProviderUser: false,
      isRemovingAccount: false,
      isWidgetLoading: false,
      isWidgetReady: false,
      linkSession: null,
      linkPurpose: 'deposit',
      linkingAccountId: null,
      phoneRequirementActionText: 'Add Phone Number',
      phoneRequirementMessage: '',
      widgetControls: null,
      reportDiagnostic: null,
      widgetLaunchGeneration: 0,
      widgetElementId: 'bank-link-widget-' + Date.now() + '-' + Math.random().toString(36).slice(2)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['userData']), {
    bankLinkButtonText: function bankLinkButtonText() {
      if (this.isCompletingReconnect) {
        return 'Finishing account reconnection...';
      }
      if (this.isCompletingLink) {
        return 'Finishing bank connection...';
      }
      if (this.isLinking) {
        return 'Finish connecting in Aerosync...';
      }
      if (this.isWidgetLoading) {
        return 'Loading Aerosync...';
      }
      return '';
    },
    confirmationPrompt: function confirmationPrompt() {
      if (this.confirmationChannel === 'sms' && this.confirmationDestination) {
        return 'Enter the 6-digit code Aerosync sent to ' + this.confirmationDestination + '.';
      }
      if (this.confirmationChannel === 'email' && this.confirmationDestination) {
        return 'Enter the 6-digit code Aerosync sent to ' + this.confirmationDestination + '.';
      }
      return 'Enter the 6-digit verification code sent by Aerosync.';
    },
    contentTitle: function contentTitle() {
      if (this.isPhoneVerificationRequired) return 'PredictIt Phone Verification';
      if (this.isProviderConfirmationRequired || this.isProviderConfirmationReady) return 'Aerosync Verification';
      return 'Select Account';
    },
    canSubmitProviderConfirmation: function canSubmitProviderConfirmation() {
      return this.confirmationCode.length === PROVIDER_CONFIRMATION_CODE_LENGTH && !this.isConfirmingProviderUser && !this.isSendingProviderConfirmation;
    },
    resendButtonText: function resendButtonText() {
      return this.confirmationSecondsUntilResend > 0 ? 'Resend code in ' + this.confirmationSecondsUntilResend + 's' : 'Resend Code';
    },
    completionProgressText: function completionProgressText() {
      if (this.isCompletingReconnect) {
        return "Aerosync has connected. We're securely finishing your account reconnection.";
      }
      return "Aerosync has connected. We're securely finishing your bank account setup.";
    },
    isBusy: function isBusy() {
      return this.isCompletingLink || this.isLinking || this.isRemovingAccount || this.isSendingProviderConfirmation || this.isConfirmingProviderUser || this.isWidgetLoading;
    },
    isCompletingReconnect: function isCompletingReconnect() {
      return this.isCompletingLink && this.linkingAccountId !== null;
    },
    isVerificationFlowActive: function isVerificationFlowActive() {
      return this.isPhoneVerificationRequired || this.isProviderConfirmationReady || this.isProviderConfirmationRequired;
    },
    errorSupport: function errorSupport() {
      if (!this.errorMessage || !this.errorIsLinkFailure) return '';
      return PREDICTIT_SUPPORT_REASON_CODES.includes(this.errorReasonCode) ? 'predictit' : 'aerosync';
    },
    featureNotice: function featureNotice() {
      return this.noticeText === null ? '' : this.noticeText;
    },
    showLinkingTip: function showLinkingTip() {
      return this.hasProviderLinkFailure && !this.isManagingAccounts && !this.isVerificationFlowActive;
    },
    showAccountSkeleton: function showAccountSkeleton() {
      return this.isLoading || this.isCompletingLink && !this.isCompletingReconnect;
    },
    showEmptyState: function showEmptyState() {
      return !this.showAccountSkeleton && this.accounts.length === 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('wallet', ['completeBankLink', 'getBankLinkCompletionStatus', 'createBankLinkSession', 'startBankLinkProviderConfirmation', 'confirmBankLinkProviderUser', 'createBankReconnectSession', 'getLinkedBankAccounts', 'removeLinkedBankAccount', 'recordBankLinkDiagnostic']), {
    clearError: function clearError() {
      this.errorMessage = '';
      this.errorReasonCode = '';
      this.errorIsLinkFailure = false;
    },
    setLinkFailure: function setLinkFailure(message, reasonCode) {
      this.errorMessage = message || 'The bank account could not be linked.';
      this.errorReasonCode = reasonCode || '';
      this.errorIsLinkFailure = true;
      if (!PREDICTIT_SUPPORT_REASON_CODES.includes(this.errorReasonCode)) {
        this.hasProviderLinkFailure = true;
      }
    },
    accountDescription: function accountDescription(account) {
      if (!account) return 'Bank account';
      var accountName = account.accountName || account.accountType || 'Bank account';
      return account.accountNumberLastFour ? accountName + ' - ' + account.accountNumberLastFour : accountName;
    },
    accountIsReconnecting: function accountIsReconnecting(account) {
      return this.isCompletingReconnect && account && account.linkedBankAccountId === this.linkingAccountId;
    },
    accountIsSelectable: function accountIsSelectable(account) {
      return this.selectable && !this.isBusy && account && account.connectionStatus === 'Connected';
    },
    accountRequiresReconnect: function accountRequiresReconnect(account) {
      return account && (account.connectionStatus === 'ReauthenticationRequired' || account.connectionStatus === 'Failed');
    },
    applyAccountsResponse: function applyAccountsResponse(data) {
      this.accounts = data && data.linkedBankAccounts ? data.linkedBankAccounts : [];
      this.hasProviderLinkFailure = !!(data && data.hasProviderLinkFailure);
      this.$emit('accounts', data);
    },
    loadWidget: function loadWidget() {
      var _this = this;

      var generation = this.widgetLaunchGeneration;
      this.isWidgetLoading = true;
      this.reportDiagnostic('sdk_requested');
      return __WEBPACK_IMPORTED_MODULE_8__aerosync_widget_adapter__["a" /* default */].load().then(function () {
        if (_this.isDestroyed || generation !== _this.widgetLaunchGeneration) return false;
        _this.isWidgetReady = true;
        _this.reportDiagnostic('sdk_ready');
        _this.clearError();
        return true;
      }).catch(function () {
        if (_this.isDestroyed || generation !== _this.widgetLaunchGeneration) return false;
        _this.isWidgetReady = false;
        _this.reportDiagnostic('sdk_failed', 'WIDGET_SDK_LOAD_FAILED');
        _this.errorMessage = 'The secure bank-linking window could not be loaded. Please try again.';
        return false;
      }).then(function (isReady) {
        if (!_this.isDestroyed && generation === _this.widgetLaunchGeneration) {
          _this.isWidgetLoading = false;
        }
        return isReady;
      });
    },
    loadAccounts: function loadAccounts(options) {
      var _this2 = this;

      var owner = this.userData.userName;
      var isCurrent = function isCurrent() {
        return !_this2.isDestroyed && _this2.userData.userName === owner;
      };
      var settings = options || {};
      var showLoading = settings.showLoading !== false;
      var showError = settings.showError !== false;
      if (showLoading) {
        this.isLoading = true;
      }
      if (settings.clearError !== false) {
        this.clearError();
      }

      return this.getLinkedBankAccounts().then(function (data) {
        if (!isCurrent()) return null;
        if (!data || !data.success) {
          if (showError) {
            _this2.errorMessage = data && data.message ? data.message : 'Bank accounts could not be loaded.';
          }
          if (showLoading) {
            _this2.accounts = [];
          }
          return null;
        }
        _this2.applyAccountsResponse(data);
        return data;
      }).catch(function () {
        if (!isCurrent()) return null;
        if (showError) {
          _this2.errorMessage = 'Bank accounts could not be loaded. Please try again.';
        }
        if (showLoading) {
          _this2.accounts = [];
        }
        return null;
      }).then(function (data) {
        if (isCurrent() && showLoading) {
          _this2.isLoading = false;
        }
        return data;
      });
    },
    clearConfirmationTimer: function clearConfirmationTimer() {
      if (this.confirmationTimer) {
        clearInterval(this.confirmationTimer);
        this.confirmationTimer = null;
      }
    },
    updateConfirmationCountdown: function updateConfirmationCountdown() {
      var availableAt = Date.parse(this.confirmationResendAvailableAt || '');
      this.confirmationSecondsUntilResend = isNaN(availableAt) ? 0 : Math.max(0, Math.ceil((availableAt - Date.now()) / 1000));
      if (this.confirmationSecondsUntilResend === 0) {
        this.clearConfirmationTimer();
      }
    },
    startConfirmationTimer: function startConfirmationTimer() {
      var _this3 = this;

      this.clearConfirmationTimer();
      this.updateConfirmationCountdown();
      if (this.confirmationSecondsUntilResend > 0) {
        this.confirmationTimer = setInterval(function () {
          return _this3.updateConfirmationCountdown();
        }, 1000);
      }
    },
    resetProviderConfirmationState: function resetProviderConfirmationState() {
      this.clearConfirmationTimer();
      this.confirmationChannel = '';
      this.confirmationCode = '';
      this.confirmationDestination = '';
      this.confirmationErrorMessage = '';
      this.confirmationResendAvailableAt = null;
      this.confirmationSecondsUntilResend = 0;
      this.isProviderConfirmationReady = false;
      this.isProviderConfirmationRequired = false;
      this.isSendingProviderConfirmation = false;
      this.isConfirmingProviderUser = false;
    },
    setProviderConfirmationState: function setProviderConfirmationState(session, isReady) {
      var _this4 = this;

      var wasRequired = this.isProviderConfirmationRequired;
      this.clearConfirmationTimer();
      this.isProviderConfirmationReady = isReady;
      this.isProviderConfirmationRequired = !isReady;
      this.isLinking = false;
      if (isReady) {
        this.confirmationCode = '';
        this.confirmationChannel = '';
        this.confirmationDestination = '';
        this.confirmationErrorMessage = '';
        this.confirmationResendAvailableAt = null;
      } else {
        this.confirmationChannel = session.confirmationChannel || '';
        this.confirmationDestination = session.confirmationDestination || '';
        this.confirmationResendAvailableAt = session.confirmationResendAvailableAt || null;
        if (!wasRequired || session.reasonCode === PROVIDER_CONFIRMATION_REQUIRED_REASON_CODE) {
          this.confirmationCode = '';
        }
        this.confirmationErrorMessage = session.reasonCode === PROVIDER_CONFIRMATION_REQUIRED_REASON_CODE ? '' : session.message || 'We could not verify that code.';
        this.startConfirmationTimer();
      }
      this.$nextTick(function () {
        if (_this4.isDestroyed) return;
        var target = isReady ? _this4.$refs.sendProviderCodeButton : _this4.$refs.providerConfirmationCode;
        if (target) target.focus();
      });
    },
    showPhoneRequirement: function showPhoneRequirement(session) {
      var _this5 = this;

      this.resetProviderConfirmationState();
      this.phoneRequirementActionText = session.reasonCode === PROVIDER_IDENTITY_ALREADY_LINKED_REASON_CODE ? 'Use a Different Phone Number' : 'Add Phone Number';
      this.phoneRequirementMessage = session.message || 'To link a bank account, add and verify a mobile phone number on your PredictIt account.';
      this.isPhoneVerificationRequired = true;
      this.isPhoneVerificationVisible = false;
      this.isLinking = false;
      this.$nextTick(function () {
        if (!_this5.isDestroyed && _this5.$refs.addPhoneNumberButton) {
          _this5.$refs.addPhoneNumberButton.focus();
        }
      });
    },
    handleSessionResponse: function handleSessionResponse(session, options) {
      var settings = options || {};
      if (this.isDestroyed || !session) return null;
      if (!session.success) {
        if (session.reasonCode === PHONE_VERIFICATION_REQUIRED_REASON_CODE || session.reasonCode === PROVIDER_IDENTITY_ALREADY_LINKED_REASON_CODE) {
          this.showPhoneRequirement(session);
          return null;
        }
        if (session.reasonCode === PROVIDER_CONFIRMATION_READY_REASON_CODE) {
          this.setProviderConfirmationState(session, true);
          return null;
        }
        if ((session.reasonCode || '').indexOf('BANK_LINK_PROVIDER_CONFIRMATION_') === 0) {
          this.setProviderConfirmationState(session, false);
          return null;
        }
        if (settings.confirmationRequest) {
          this.confirmationErrorMessage = session.message || 'The verification request could not be completed. Please try again.';
        } else {
          this.setLinkFailure(session.message || 'Bank linking could not be started.', session.reasonCode);
        }
        this.isLinking = false;
        return null;
      }

      this.resetProviderConfirmationState();
      this.advisoryActionUrl = session.advisoryActionUrl || '';
      this.advisoryMessage = session.advisoryMessage || '';
      this.linkSession = session;
      this.isLinking = true;
      return this.launchWidgetSession(session);
    },
    launchWidgetSession: function launchWidgetSession(session) {
      var _this6 = this;

      this.destroyWidgetControls();
      this.widgetLaunchGeneration += 1;
      var generation = this.widgetLaunchGeneration;
      var purpose = this.linkPurpose;
      return __WEBPACK_IMPORTED_MODULE_8__aerosync_widget_adapter__["a" /* default */].launch({
        elementId: this.widgetElementId,
        session: session,
        onSuccess: function onSuccess(result) {
          return _this6.handleWidgetSuccess(result, generation, purpose);
        },
        onClose: function onClose() {
          return _this6.handleWidgetClose(generation);
        },
        onError: function onError(error) {
          return _this6.handleWidgetError(error, generation);
        },
        onDiagnostic: this.reportDiagnostic
      }).then(function (controls) {
        if (_this6.isDestroyed || generation !== _this6.widgetLaunchGeneration) {
          if (controls && typeof controls.destroy === 'function') {
            controls.destroy();
          }
          return null;
        }
        _this6.widgetControls = controls;
        return controls;
      }).catch(function () {
        if (_this6.isDestroyed || generation !== _this6.widgetLaunchGeneration) {
          return null;
        }
        var linkedBankAccountId = _this6.linkingAccountId;
        _this6.errorMessage = 'The secure bank-linking window could not be opened. Please try again.';
        _this6.isLinking = false;
        _this6.linkingAccountId = null;
        _this6.focusLinkOrigin(linkedBankAccountId);
        return null;
      });
    },
    destroyWidgetControls: function destroyWidgetControls() {
      this.widgetLaunchGeneration += 1;
      var controls = this.widgetControls;
      this.widgetControls = null;
      if (controls && typeof controls.destroy === 'function') {
        controls.destroy();
      }
    },
    focusLinkOrigin: function focusLinkOrigin(linkedBankAccountId) {
      var _this7 = this;

      this.$nextTick(function () {
        if (_this7.isDestroyed) return;
        var target = null;
        if (linkedBankAccountId) {
          target = _this7.$el.querySelector('[data-linked-bank-account-id="' + linkedBankAccountId + '"]');
        }
        if (!target) target = _this7.$refs.addBankAccountButton;
        if (target) target.focus();
      });
    },
    addAccount: function addAccount(account) {
      var _this8 = this;

      if (this.isBusy) return null;
      if (!this.isWidgetReady) {
        var _generation = this.widgetLaunchGeneration;
        return this.loadWidget().then(function (isReady) {
          if (isReady && !_this8.isDestroyed && _generation === _this8.widgetLaunchGeneration) {
            return _this8.addAccount(account);
          }
          return null;
        });
      }

      this.destroyWidgetControls();
      this.resetProviderConfirmationState();
      this.reportDiagnostic = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_bankLinkDiagnostics__["a" /* default */])(this.recordBankLinkDiagnostic);
      this.reportDiagnostic('sdk_ready');
      this.completionConnectionId = null;
      this.advisoryActionUrl = '';
      this.advisoryMessage = '';
      this.clearError();
      this.isLinking = true;
      this.linkingAccountId = account ? account.linkedBankAccountId : null;

      // Keep direction with this attempt, including OTP and late widget callbacks.
      this.linkPurpose = this.purpose;
      var generation = this.widgetLaunchGeneration;
      var sessionRequest = account && account.linkedBankAccountId ? this.createBankReconnectSession({
        linkedBankAccountId: account.linkedBankAccountId,
        purpose: this.linkPurpose,
        clientAttemptId: this.reportDiagnostic.clientAttemptId
      }) : this.createBankLinkSession({
        purpose: this.linkPurpose, clientAttemptId: this.reportDiagnostic.clientAttemptId
      });

      return sessionRequest.then(function (session) {
        return generation === _this8.widgetLaunchGeneration ? _this8.handleSessionResponse(session) : null;
      }).catch(function () {
        if (_this8.isDestroyed || generation !== _this8.widgetLaunchGeneration) return null;
        var linkedBankAccountId = _this8.linkingAccountId;
        _this8.errorMessage = 'Bank linking could not be started. Please try again.';
        _this8.isLinking = false;
        _this8.linkingAccountId = null;
        _this8.focusLinkOrigin(linkedBankAccountId);
        return null;
      });
    },
    sendProviderVerificationCode: function sendProviderVerificationCode(resend) {
      var _this9 = this;

      if (this.isSendingProviderConfirmation || resend && this.confirmationSecondsUntilResend > 0) {
        return null;
      }

      this.isSendingProviderConfirmation = true;
      var generation = this.widgetLaunchGeneration;
      this.confirmationErrorMessage = '';
      return this.startBankLinkProviderConfirmation({
        resend: resend === true,
        purpose: this.linkPurpose,
        clientAttemptId: this.reportDiagnostic.clientAttemptId
      }).then(function (session) {
        if (_this9.isDestroyed || generation !== _this9.widgetLaunchGeneration) return null;
        _this9.isSendingProviderConfirmation = false;
        if (resend && session && session.reasonCode === PROVIDER_CONFIRMATION_REQUIRED_REASON_CODE) {
          _this9.confirmationCode = '';
        }
        return _this9.handleSessionResponse(session, {
          confirmationRequest: true
        });
      }).catch(function () {
        if (!_this9.isDestroyed && generation === _this9.widgetLaunchGeneration) {
          _this9.isSendingProviderConfirmation = false;
          _this9.confirmationErrorMessage = 'The verification code could not be sent. Please try again.';
        }
        return null;
      });
    },
    confirmProviderVerificationCode: function confirmProviderVerificationCode() {
      var _this10 = this;

      if (!this.canSubmitProviderConfirmation) return null;
      this.isConfirmingProviderUser = true;
      var generation = this.widgetLaunchGeneration;
      this.confirmationErrorMessage = '';
      return this.confirmBankLinkProviderUser({
        code: this.confirmationCode,
        purpose: this.linkPurpose,
        clientAttemptId: this.reportDiagnostic.clientAttemptId
      }).then(function (session) {
        if (_this10.isDestroyed || generation !== _this10.widgetLaunchGeneration) return null;
        _this10.isConfirmingProviderUser = false;
        return _this10.handleSessionResponse(session, {
          confirmationRequest: true
        });
      }).catch(function () {
        if (!_this10.isDestroyed && generation === _this10.widgetLaunchGeneration) {
          _this10.isConfirmingProviderUser = false;
          _this10.confirmationErrorMessage = 'We could not verify that code. Please try again.';
        }
        return null;
      });
    },
    handleProviderConfirmationInput: function handleProviderConfirmationInput(event) {
      var value = (event.target.value || '').replace(/[^0-9]/g, '').slice(0, PROVIDER_CONFIRMATION_CODE_LENGTH);
      this.confirmationCode = value;
      event.target.value = value;
    },
    cancelProviderConfirmation: function cancelProviderConfirmation() {
      this.resetProviderConfirmationState();
      this.clearError();
      this.focusLinkOrigin(null);
    },
    handleWidgetError: function handleWidgetError(error, generation) {
      if (generation !== this.widgetLaunchGeneration || this.isDestroyed || this.completionConnectionId) return;
      if (error && error.code === 'WIDGET_LOAD_TIMEOUT') {
        var linkedBankAccountId = this.linkingAccountId;
        this.widgetControls = null;
        this.isLinking = false;
        this.linkingAccountId = null;
        this.errorMessage = 'The secure bank-linking window took too long to load. Please try again.';
        this.focusLinkOrigin(linkedBankAccountId);
      }
    },
    showPhoneVerification: function showPhoneVerification() {
      var _this11 = this;

      this.isPhoneVerificationVisible = true;
      this.$nextTick(function () {
        if (_this11.isDestroyed) return;
        var phoneInput = _this11.$el.querySelector('.account-phone-update__input');
        if (phoneInput) phoneInput.focus();
      });
    },
    handlePhoneVerificationCancel: function handlePhoneVerificationCancel() {
      var _this12 = this;

      this.isPhoneVerificationRequired = false;
      this.isPhoneVerificationVisible = false;
      this.phoneRequirementActionText = 'Add Phone Number';
      this.phoneRequirementMessage = '';
      this.$nextTick(function () {
        if (!_this12.isDestroyed && _this12.$refs.addBankAccountButton) {
          _this12.$refs.addBankAccountButton.focus();
        }
      });
    },
    handlePhoneVerified: function handlePhoneVerified() {
      if (this.isDestroyed) return null;
      this.isPhoneVerificationRequired = false;
      this.isPhoneVerificationVisible = false;
      this.phoneRequirementActionText = 'Add Phone Number';
      this.phoneRequirementMessage = '';
      return this.addAccount();
    },
    handleWidgetClose: function handleWidgetClose(generation) {
      if (generation !== this.widgetLaunchGeneration || this.isDestroyed || this.completionConnectionId) return;
      var linkedBankAccountId = this.linkingAccountId;
      this.widgetControls = null;
      this.isLinking = false;
      this.linkingAccountId = null;
      this.focusLinkOrigin(linkedBankAccountId);
    },
    handleWidgetSuccess: function handleWidgetSuccess(result, generation, purpose) {
      var _this13 = this;

      if (generation !== this.widgetLaunchGeneration || this.isDestroyed) return;
      var connectionId = result && result.connectionId;
      var userReference = result && result.userReference || this.linkSession && this.linkSession.userReference;
      if (!connectionId || !userReference) {
        var _linkedBankAccountId = this.linkingAccountId;
        this.destroyWidgetControls();
        this.errorMessage = 'The bank-linking window returned an incomplete result.';
        this.isLinking = false;
        this.linkingAccountId = null;
        this.focusLinkOrigin(_linkedBankAccountId);
        return;
      }
      if (this.completionConnectionId === connectionId) {
        return;
      }

      var linkedBankAccountId = this.linkingAccountId;
      this.completionConnectionId = connectionId;
      this.destroyWidgetControls();
      var completionGeneration = this.widgetLaunchGeneration;
      var isCurrent = function isCurrent() {
        return !_this13.isDestroyed && _this13.widgetLaunchGeneration === completionGeneration && _this13.completionConnectionId === connectionId;
      };
      var reference = {
        connectionId: connectionId,
        userReference: userReference,
        purpose: purpose,
        clientAttemptId: this.reportDiagnostic.clientAttemptId
      };
      this.clearError();
      this.isCompletingLink = true;
      this.isLinking = true;
      this.reportDiagnostic('completion_requested');

      var recover = function recover() {
        return _this13.reconcileCompletion(reference, completionGeneration, COMPLETION_RECONCILIATION_ATTEMPTS);
      };
      this.completeBankLink(reference).then(function (completion) {
        if (!isCurrent()) return false;
        if (completion && completion.success === true && Array.isArray(completion.linkedBankAccounts)) {
          _this13.accounts = completion.linkedBankAccounts;
          _this13.reportDiagnostic('completion_succeeded');
          return true;
        }
        // A provider-declared failure is definitive. Only a missing response, the
        // server's catch-all or its own timeout (either may follow a persisted
        // completion) may recover through the read-only status check.
        var ambiguous = !completion || typeof completion.success !== 'boolean' || canReconcileCompletion(completion);
        if (!ambiguous) {
          _this13.setLinkFailure(completion.message, completion.reasonCode);
          return false;
        }
        return recover();
      }).catch(function (error) {
        if (!isCurrent()) return false;
        var response = error && error.response;
        var data = response && response.data;
        if (!canReconcileCompletion(data) && (data && data.success === false || response && response.status < 500)) {
          _this13.setLinkFailure(data && data.message, data && data.reasonCode);
          return false;
        }
        return recover();
      }).then(function (completed) {
        if (!isCurrent()) return;
        _this13.isCompletingLink = false;
        _this13.isLinking = false;
        _this13.linkingAccountId = null;
        if (completed) {
          _this13.clearError();
          _this13.accountBeingRemoved = null;
          _this13.isManagingAccounts = false;
        } else {
          _this13.reportDiagnostic('completion_failed');
          if (!_this13.errorIsLinkFailure) {
            _this13.setLinkFailure(_this13.errorMessage, _this13.errorReasonCode);
          }
          _this13.focusLinkOrigin(linkedBankAccountId);
        }
      });
    },
    reconcileCompletion: function reconcileCompletion(reference, generation, attemptsRemaining) {
      var _this14 = this;

      var isCurrent = function isCurrent() {
        return !_this14.isDestroyed && _this14.widgetLaunchGeneration === generation && _this14.completionConnectionId === reference.connectionId;
      };
      if (!isCurrent()) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(false);
      this.reportDiagnostic('reconciliation_requested');
      return this.getBankLinkCompletionStatus(reference).then(function (status) {
        if (!isCurrent() || !status || status.completed !== true || !(Number(status.linkedBankAccountId) > 0)) return false;
        return _this14.getLinkedBankAccounts({ timeout: 5000 }).then(function (data) {
          if (!isCurrent() || !data || data.success !== true) return false;
          var accounts = data.linkedBankAccounts || [];
          var matched = accounts.some(function (account) {
            return Number(account.linkedBankAccountId) === Number(status.linkedBankAccountId) && account.connectionStatus === 'Connected';
          });
          if (matched) {
            _this14.applyAccountsResponse(data);
            _this14.reportDiagnostic('completion_recovered');
          }
          return matched;
        });
      }).catch(function () {
        return false;
      }).then(function (completed) {
        if (completed || attemptsRemaining <= 1 || !isCurrent()) {
          if (!completed) _this14.reportDiagnostic('reconciliation_failed');
          return completed;
        }
        return wait(COMPLETION_RECONCILIATION_DELAY_MS).then(function () {
          return _this14.reconcileCompletion(reference, generation, attemptsRemaining - 1);
        });
      });
    },
    enterManageAccounts: function enterManageAccounts() {
      if (this.isBusy) return;
      this.accountBeingRemoved = null;
      this.isManagingAccounts = true;
    },
    selectAccount: function selectAccount(account) {
      if (!this.accountIsSelectable(account)) return;
      this.$emit('select', account);
    },
    handleManageBack: function handleManageBack() {
      if (this.isRemovingAccount) return;
      if (this.accountBeingRemoved) {
        this.accountBeingRemoved = null;
        return;
      }
      this.isManagingAccounts = false;
    },
    requestRemoveAccount: function requestRemoveAccount(account) {
      if (this.isBusy || !account) return;
      this.accountBeingRemoved = account;
    },
    confirmRemoveAccount: function confirmRemoveAccount() {
      var _this15 = this;

      var account = this.accountBeingRemoved;
      if (!account || !account.linkedBankAccountId || this.isRemovingAccount) {
        return null;
      }

      this.isRemovingAccount = true;
      var owner = this.userData.userName;
      var isCurrent = function isCurrent() {
        return !_this15.isDestroyed && _this15.userData.userName === owner;
      };
      this.clearError();
      return this.removeLinkedBankAccount({
        linkedBankAccountId: account.linkedBankAccountId
      }).then(function (result) {
        if (!isCurrent()) return null;
        if (!result.success) {
          _this15.errorMessage = result.message || 'The bank account could not be removed.';
          return null;
        }
        _this15.accounts = _this15.accounts.filter(function (existingAccount) {
          return existingAccount.linkedBankAccountId !== account.linkedBankAccountId;
        });
        _this15.accountBeingRemoved = null;
        if (_this15.accounts.length === 0) {
          _this15.isManagingAccounts = false;
        }
        return _this15.loadAccounts({
          clearError: false,
          showError: false,
          showLoading: false
        });
      }).catch(function () {
        if (!isCurrent()) return null;
        _this15.errorMessage = 'The bank account could not be removed. Please try again.';
        return null;
      }).then(function (result) {
        if (isCurrent()) _this15.isRemovingAccount = false;
        return result;
      });
    }
  }),
  watch: {
    'userData.userName': function reloadForAuthenticatedAccount(userName, previous) {
      if (!userName || userName === previous || this.isDestroyed) return;
      // loadAccounts keeps only the response for the user it started with. When the
      // signed-in user arrives after this component was created, the first response is
      // discarded and the list would stay in its loading state; load it for the real owner.
      this.loadAccounts();
    }
  },
  created: function created() {
    this.reportDiagnostic = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_bankLinkDiagnostics__["a" /* default */])(this.recordBankLinkDiagnostic);
    this.loadAccounts();
  },
  mounted: function mounted() {
    this.loadWidget();
  },
  beforeDestroy: function beforeDestroy() {
    this.isDestroyed = true;
    this.clearConfirmationTimer();
    this.destroyWidgetControls();
  }
});

/***/ }),

/***/ "rW2y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classModifier,on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rgkE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rjQl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_news_js__ = __webpack_require__("cT9C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1d9a742_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_news_vue__ = __webpack_require__("N4a4");
function injectStyle (ssrContext) {
  __webpack_require__("rutz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_news_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1d9a742_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_news_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rm2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_icon_vue__ = __webpack_require__("SV7z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20c05880_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_icon_vue__ = __webpack_require__("9ub0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20c05880_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rpmV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rrO7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__("G/BR");

/* eslint-disable */


var currentAnimationFrame = null;
var currentInterruptionListeners = null;

var cancelCurrentScroll = function cancelCurrentScroll() {
  if (currentAnimationFrame) {
    cancelAnimationFrame(currentAnimationFrame);
    currentAnimationFrame = null;
  }
  if (currentInterruptionListeners) {
    var _currentInterruptionL = currentInterruptionListeners,
        container = _currentInterruptionL.container,
        listeners = _currentInterruptionL.listeners,
        windowListeners = _currentInterruptionL.windowListeners;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(listeners).forEach(function (event) {
      container.removeEventListener(event, listeners[event], { passive: true });
    });
    if (windowListeners) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(windowListeners).forEach(function (event) {
        window.removeEventListener(event, windowListeners[event], { passive: true });
      });
    }
    currentInterruptionListeners = null;
  }
};

function scrollTo(destination) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'linear';
  var container = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var topOffset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var callback = arguments[5];

  if (typeof container === 'function') {
    callback = container;
    container = null;
    topOffset = 0;
  }

  if (typeof topOffset === 'function') {
    callback = topOffset;
    topOffset = 0;
  }

  cancelCurrentScroll();

  var getScrollParent = function getScrollParent(node) {
    if (node === null || node === undefined || node === document.body || node === document.documentElement) {
      return window;
    }

    if (node.scrollHeight > node.clientHeight) {
      var style = window.getComputedStyle(node);
      var overflowY = style.overflowY;
      if (overflowY !== 'visible' && overflowY !== 'hidden') {
        return node;
      }
    }

    return getScrollParent(node.parentNode);
  };

  var easings = {
    linear: function linear(t) {
      return t;
    },
    easeInQuad: function easeInQuad(t) {
      return t * t;
    },
    easeOutQuad: function easeOutQuad(t) {
      return t * (2 - t);
    },
    easeInOutQuad: function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic: function easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic: function easeOutCubic(t) {
      return --t * t * t + 1;
    },
    easeInOutCubic: function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart: function easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart: function easeOutQuart(t) {
      return 1 - --t * t * t * t;
    },
    easeInOutQuart: function easeInOutQuart(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    easeInQuint: function easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint: function easeOutQuint(t) {
      return 1 + --t * t * t * t * t;
    },
    easeInOutQuint: function easeInOutQuint(t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    }
  };

  var actualContainer = container;
  if (!actualContainer && typeof destination !== 'number' && destination.nodeType) {
    actualContainer = getScrollParent(destination.parentNode);
  }
  if (!actualContainer) {
    actualContainer = window;
  }

  var isWindow = actualContainer === window;

  var getScrollPos = function getScrollPos() {
    if (isWindow) {
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    }
    return actualContainer.scrollTop;
  };

  var start = getScrollPos();
  var prevScrollPos = start;
  var scrollCheckCount = 20;
  var startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

  var destinationOffset = void 0;
  if (typeof destination === 'number') {
    destinationOffset = destination;
  } else if (isWindow) {
    destinationOffset = Math.round(destination.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) - topOffset);
  } else {
    destinationOffset = destination.offsetTop - topOffset;
  }

  var maxScroll = void 0;
  var viewportHeight = void 0;
  if (isWindow) {
    maxScroll = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) - window.innerHeight;
    viewportHeight = window.innerHeight;
  } else {
    maxScroll = actualContainer.scrollHeight - actualContainer.clientHeight;
    viewportHeight = actualContainer.clientHeight;
  }

  var destinationOffsetToScroll = Math.max(0, Math.min(destinationOffset, maxScroll));

  __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('[scrollTo] Starting scroll to:', destination, {
    duration: duration,
    easing: easing,
    container: actualContainer,
    isWindow: isWindow,
    topOffset: topOffset,
    start: start,
    destinationOffset: destinationOffset,
    maxScroll: maxScroll,
    destinationOffsetToScroll: destinationOffsetToScroll
  });

  var performScroll = function performScroll(pos) {
    if (isWindow) {
      window.scroll(0, pos);
    } else {
      actualContainer.scrollTop = pos;
    }
  };

  if ('requestAnimationFrame' in window === false) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('[scrollTo] requestAnimationFrame not supported, jumping to position');
    performScroll(destinationOffsetToScroll);
    if (callback) {
      callback();
    }
    return;
  }

  var interruptionEvents = ['wheel', 'touchstart', 'mousedown', 'keydown', 'MSPointerDown', 'pointerdown', 'touchmove'];
  var interruptionTarget = isWindow ? window : actualContainer;

  var onUserInterruption = function onUserInterruption() {
    var now = 'now' in window.performance ? performance.now() : new Date().getTime();
    if (now - startTime < 150) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('[scrollTo] Ignoring interruption during first 150ms');
      return;
    }

    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('[scrollTo] User interrupted scroll');
    cancelCurrentScroll();
  };

  var setupListeners = function setupListeners(target, listenersMap) {
    interruptionEvents.forEach(function (event) {
      listenersMap[event] = onUserInterruption;
      target.addEventListener(event, onUserInterruption, { passive: true });
    });
  };

  var containerListeners = {};
  setupListeners(interruptionTarget, containerListeners);
  var windowListeners = null;
  if (!isWindow) {
    windowListeners = {};
    setupListeners(window, windowListeners);
  }

  currentInterruptionListeners = {
    container: interruptionTarget,
    listeners: containerListeners,
    windowListeners: windowListeners
  };

  __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('[scrollTo] Starting animation');

  function scroll() {
    var now = 'now' in window.performance ? performance.now() : new Date().getTime();
    var time = Math.min(1, (now - startTime) / duration);
    var timeFunction = easings[easing](time);
    var nextPos = Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start);

    performScroll(nextPos);

    var currentScrollPos = getScrollPos();

    // Check if scroll is stuck (position not updating as expected)
    // Only if we're not already at the destination and expecting to move
    var hasPositionChanged = Math.abs(prevScrollPos - currentScrollPos) >= 1;
    var shouldHaveMoved = Math.abs(nextPos - prevScrollPos) > 1;

    if (!hasPositionChanged && shouldHaveMoved) {
      scrollCheckCount--;
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('[scrollTo] Scroll might be stuck:', {
        prevScrollPos: prevScrollPos,
        currentScrollPos: currentScrollPos,
        nextPos: nextPos,
        scrollCheckCount: scrollCheckCount
      });
    }

    if (Math.abs(currentScrollPos - destinationOffsetToScroll) <= 1 || scrollCheckCount < 0) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('[scrollTo] Scroll finished at:', currentScrollPos, {
        reason: Math.abs(currentScrollPos - destinationOffsetToScroll) <= 1 ? 'reached destination' : 'scroll stuck (scrollCheckCount < 0)'
      });
      cancelCurrentScroll();
      if (callback) {
        callback();
      }
      return;
    }

    prevScrollPos = currentScrollPos;
    currentAnimationFrame = requestAnimationFrame(scroll);
  }

  // wait a bit for initialisation to avoid premature interruption from touch events
  setTimeout(function () {
    currentAnimationFrame = requestAnimationFrame(scroll);
  }, 50);
}

/***/ }),

/***/ "rreX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rutz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rxGt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("8/3H");



/* harmony default export */ __webpack_exports__["a"] = (function (response) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* checkResponseForMaintenance */])(response);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* checkResponseForTaxInfo */])(response);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* checkResponseForDocumentUpload */])(response);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* checkResponseVersion */])(response);
  var isSensitiveResponse = /api\/(?:User\/Wallet\/(?:BankLinks|.*DepositBankTransfer)|Account\/token)/i.test(response.config.url || '');
  if (!response.config.bankDiagnostic) {
    // Banking session responses include provider credentials; never dump the body.
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('API - SUCCESS', response.status, response.config.method, response.config.url, isSensitiveResponse ? '[sensitive response omitted]' : response);
  }
  return response;
});

/***/ }),

/***/ "ryxd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s+vV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s8MB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sCGU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "sFos":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatten__ = __webpack_require__("rCVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_previewCarouselTracking__ = __webpack_require__("LoC7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_dataLayer__ = __webpack_require__("k37b");








/* eslint-disable no-restricted-syntax */











var STORY_SWITCH_INTERVAL = 8 * 1000;
var CONTENT_COLLAPSED_HEIGHT = 475;
var CONTENT_OVERFLOW_TOLERANCE = 12;
var EXPANDED_HEIGHT_BUFFER = 8;
var EXPANDED_HEIGHT_MEASURE_DELAYS = [0, 150, 500, 1200];
var PODCAST_RESIZE_EVENT = 'cms:podcast-resize';
var PODCAST_LAYOUT_REFRESH_EVENT = 'cms:podcast-layout-refresh';
var LAST_STORY_ROW_CLASS = 'preview-carousel-embed__story-row--last';
var interval = null;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_previewCarouselTracking__["a" /* default */]],
  components: {
    tabs: __WEBPACK_IMPORTED_MODULE_10__components_generics_tabs_tabs_vue__["a" /* default */]
  },
  props: {
    indexes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    trackingContext: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      stripTags: __WEBPACK_IMPORTED_MODULE_14__utils_helpers__["q" /* stripTags */],
      isLoading: false,
      selected: {},
      selectedManually: false,
      isTransitioning: false,
      storyContentMap: {},
      activeTab: null,
      showNavigationArrows: false,
      canScrollLeft: false,
      canScrollRight: false,
      isExpanded: false,
      isContentOverflowing: false,
      expandedContentHeight: null,
      contentMeasureTimeouts: [],
      contentResizeObserver: null,
      refreshIndex: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapState */])('browse', ['storiesNav', 'storyMap', 'currentStoryIndex']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapState */])('popup', ['currentPopup', 'currentSmallPopup']), {
    localStoriesNav: function localStoriesNav() {
      var _this = this;

      if (this.indexes.length === 0) {
        return this.storiesNav;
      }
      return this.storiesNav.filter(function (i) {
        return _this.indexes.includes(String(i.index));
      });
    },
    showNav: function showNav() {
      return this.navigationTabs.length > 1 && !this.isLoading && this.isComponentReady;
    },
    navigationTabs: function navigationTabs() {
      return this.localStoriesNav.map(function (item) {
        return {
          name: 'story-' + item.index,
          title: item.navTitle || 'Story #' + (item.index + 1)
        };
      });
    },
    classModifiers: function classModifiers() {
      return {
        'preview-carousel-embed': true
      };
    },
    contentClassModifiers: function contentClassModifiers() {
      return {
        'preview-carousel-embed__content': true,
        'preview-carousel-embed__content--collapsed': !this.isExpanded,
        'preview-carousel-embed__content--overflowing': this.isContentOverflowing && !this.isExpanded
      };
    },
    contentStyleModifiers: function contentStyleModifiers() {
      var minHeightPx = CONTENT_COLLAPSED_HEIGHT;
      if (this.isExpanded && this.expandedContentHeight) {
        return {
          minHeight: Math.max(minHeightPx, this.expandedContentHeight) + 'px'
        };
      }
      return {
        minHeight: minHeightPx + 'px'
      };
    },
    expandClassModifiers: function expandClassModifiers() {
      return {
        'preview-carousel-embed__expand': true,
        'preview-carousel-embed__expand--floating': !this.isExpanded
      };
    },
    showExpandControl: function showExpandControl() {
      return this.isContentOverflowing && this.isComponentReady;
    },
    tabsClassModifiers: function tabsClassModifiers() {
      return {
        'preview-carousel-embed__tabs': true,
        'preview-carousel-embed__tabs--arrows': this.showNavigationArrows
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapActions */])('browse', ['getStoriesNav', 'getStory', 'getStoriesList', 'updateStoryMapFromContractNotification']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    getStoryContentForLayout: function getStoryContentForLayout(data) {
      return this.isLayoutDesktop ? data.desktopContent : data.mobileContent;
    },
    clearPendingExpandedMeasurements: function clearPendingExpandedMeasurements() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.contentMeasureTimeouts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var timeoutId = _step.value;

          clearTimeout(timeoutId);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.contentMeasureTimeouts = [];
    },
    teardownContentResizeObserver: function teardownContentResizeObserver() {
      if (this.contentResizeObserver) {
        this.contentResizeObserver.disconnect();
        this.contentResizeObserver = null;
      }
    },
    setupContentResizeObserver: function setupContentResizeObserver() {
      var _this2 = this;

      this.teardownContentResizeObserver();
      if (typeof ResizeObserver === 'undefined') {
        return;
      }

      var target = this.getActiveStoryElement() || this.$refs.content;
      if (!target) {
        return;
      }

      // eslint-disable-next-line no-undef
      this.contentResizeObserver = new ResizeObserver(function () {
        if (_this2.isExpanded) {
          _this2.scheduleExpandedHeightRefresh();
        } else {
          _this2.checkContentOverflow();
        }
      });
      this.contentResizeObserver.observe(target);
    },
    getActiveStoryElement: function getActiveStoryElement() {
      var content = this.$refs.content;
      if (!content) {
        return null;
      }
      var stories = content.querySelectorAll('.preview-carousel__story');
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(stories), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var story = _step2.value;

          if (window.getComputedStyle(story).display !== 'none') {
            return story;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return null;
    },
    isVisibleElement: function isVisibleElement(node) {
      var styles = window.getComputedStyle(node);
      if (styles.display === 'none' || styles.visibility === 'hidden') {
        return false;
      }
      var rect = node.getBoundingClientRect();
      return rect.width > 0 || rect.height > 0 || node.scrollHeight > 0;
    },
    getLastVisibleStoryRow: function getLastVisibleStoryRow() {
      var activeStory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getActiveStoryElement();

      if (!activeStory) {
        return null;
      }

      var rows = activeStory.querySelectorAll('.browse-story-content-region__items');
      for (var index = rows.length - 1; index >= 0; index -= 1) {
        var row = rows[index];
        if (this.isVisibleElement(row)) {
          return row;
        }
      }

      return null;
    },
    updateLastVisibleStoryRow: function updateLastVisibleStoryRow() {
      var activeStory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getActiveStoryElement();

      if (!activeStory) {
        return;
      }

      var markedRows = activeStory.querySelectorAll('.' + LAST_STORY_ROW_CLASS);
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(markedRows), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var row = _step3.value;

          row.classList.remove(LAST_STORY_ROW_CLASS);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var lastVisibleRow = this.getLastVisibleStoryRow(activeStory);
      if (lastVisibleRow) {
        lastVisibleRow.classList.add(LAST_STORY_ROW_CLASS);
      }
    },
    measureStoryHeight: function measureStoryHeight() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$includeBuffer = _ref.includeBuffer,
          includeBuffer = _ref$includeBuffer === undefined ? false : _ref$includeBuffer;

      var activeStory = this.getActiveStoryElement();
      if (!activeStory) {
        return null;
      }

      this.updateLastVisibleStoryRow(activeStory);

      var activeRect = activeStory.getBoundingClientRect();
      var measuredHeight = Math.max(activeStory.scrollHeight || 0, activeStory.offsetHeight || 0);
      var descendants = activeStory.querySelectorAll('*');

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(descendants), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var node = _step4.value;

          var styles = window.getComputedStyle(node);
          if (styles.display !== 'none' && styles.visibility !== 'hidden') {
            var rect = node.getBoundingClientRect();
            if (rect.width !== 0 || rect.height !== 0) {
              var nodeBottom = rect.bottom - activeRect.top;
              if (nodeBottom > measuredHeight) {
                measuredHeight = nodeBottom;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (measuredHeight <= 0) {
        return null;
      }

      return Math.ceil(measuredHeight + (includeBuffer ? EXPANDED_HEIGHT_BUFFER : 0));
    },
    measureExpandedContentHeight: function measureExpandedContentHeight() {
      return this.measureStoryHeight({ includeBuffer: true });
    },
    measureCollapsedContentHeight: function measureCollapsedContentHeight() {
      return this.measureStoryHeight();
    },
    scheduleExpandedHeightRefresh: function scheduleExpandedHeightRefresh() {
      var _this3 = this;

      if (!this.isExpanded) {
        return;
      }
      this.clearPendingExpandedMeasurements();
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(EXPANDED_HEIGHT_MEASURE_DELAYS), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var delay = _step5.value;

          var timeoutId = setTimeout(function () {
            if (!_this3.isExpanded) {
              return;
            }
            var measuredHeight = _this3.measureExpandedContentHeight();
            if (measuredHeight) {
              _this3.expandedContentHeight = measuredHeight;
            }
          }, delay);
          this.contentMeasureTimeouts.push(timeoutId);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    handleWindowResize: function handleWindowResize() {
      this.checkOverflow();
      if (this.isExpanded) {
        this.scheduleExpandedHeightRefresh();
      } else {
        this.checkContentOverflow();
      }
    },
    handleEmbeddedResizeEvent: function handleEmbeddedResizeEvent() {
      var _this4 = this;

      if (this.isExpanded) {
        this.scheduleExpandedHeightRefresh();
      } else {
        this.$nextTick(function () {
          _this4.checkContentOverflow();
        });
      }
    },
    emitPodcastLayoutRefresh: function emitPodcastLayoutRefresh() {
      window.dispatchEvent(new Event(PODCAST_LAYOUT_REFRESH_EVENT));
    },
    tabsClicked: function tabsClicked() {
      this.stopNavRotation();
      this.selectedManually = true;
      this.previewTracking.lastAdvanceReason = 'manual-click';
    },
    navigationTabChange: function navigationTabChange(name) {
      this.activeTab = name;
      var index = parseInt(name.replace('story-', ''), 10);
      this.onSelect({ item: this.localStoriesNav.find(function (i) {
          return i.index === index;
        }), stop: false });
    },
    installActiveStoryCharts: function installActiveStoryCharts() {
      var activeStoryElement = this.getActiveStoryElement();
      if (!activeStoryElement) {
        return;
      }
      this.installMarketCharts(activeStoryElement, { suppressGlobalLoader: true });
    },
    setupContent: function setupContent() {
      var _this5 = this;

      var totalCmsContent = [];
      this.storyContentMap = {};

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.storyMap)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var _ref2 = _step6.value;

          var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);

          var index = _ref3[0];
          var data = _ref3[1];

          var storyContent = this.getStoryContentForLayout(data);
          totalCmsContent.push(storyContent.cmsContent || {});
          __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].set(this.storyContentMap, index, '' + (storyContent.css || '') + (storyContent.html || ''));
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var accordionContentObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.accordionContentObjects || [];
      }));
      var podcastItemContentObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.podcastItemContentObjects || [];
      }));
      var contractListMarkets = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.contractListMarkets || [];
      }));
      var marketTileMarkets = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.marketTileMarkets || [];
      }));
      var chartWidgetObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.chartWidgetObjects || [];
      }));
      var docsWidgetObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.docsWidgetObjects || [];
      }));
      var videoWidgetObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(totalCmsContent.map(function (i) {
        return i.videoWidgetObjects || [];
      }));
      this.isComponentReady = true;

      setTimeout(function () {
        _this5.installDynamicControls({
          data: {
            cmsContentObject: {
              accordionContentObjects: accordionContentObjects,
              podcastItemContentObjects: podcastItemContentObjects,
              contractListMarkets: contractListMarkets,
              marketTileMarkets: marketTileMarkets,
              chartWidgetObjects: chartWidgetObjects,
              docsWidgetObjects: docsWidgetObjects,
              videoWidgetObjects: videoWidgetObjects
            }
          },
          skipMarketCharts: true,
          skipCarousel: true
        });
        _this5.$nextTick(function () {
          _this5.installActiveStoryCharts();
          _this5.setupContentResizeObserver();
          _this5.checkContentOverflow();
          _this5.emitPodcastLayoutRefresh();
        });
      }, 0);
    },
    refreshLayoutContent: function refreshLayoutContent() {
      var _this6 = this;

      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$clearExpanded = _ref4.clearExpanded,
          clearExpanded = _ref4$clearExpanded === undefined ? true : _ref4$clearExpanded;

      if (!this.isComponentReady || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.storyMap).length === 0) {
        return;
      }
      if (clearExpanded) {
        this.isExpanded = false;
        this.expandedContentHeight = null;
        this.clearPendingExpandedMeasurements();
      }
      this.refreshIndex += 1;
      this.$nextTick(function () {
        _this6.setupContent();
        _this6.$nextTick(function () {
          _this6.setupContentResizeObserver();
          _this6.checkOverflow();
          _this6.emitPodcastLayoutRefresh();
        });
      });
    },
    onSelect: function onSelect(_ref5) {
      var _this7 = this;

      var item = _ref5.item,
          _ref5$stop = _ref5.stop,
          stop = _ref5$stop === undefined ? false : _ref5$stop;

      if (typeof item === 'undefined') return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
      var disableNavBarAutomaticProgression = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(item, 'disableNavBarAutomaticProgression', false);
      if (stop || disableNavBarAutomaticProgression) {
        this.stopNavRotation();
        this.selectedManually = true;
      }

      this.isTransitioning = true;
      return this.getStory({ index: item.index }).then(function () {
        var timeout = 0;
        if (stop) {
          window.scrollTo(0, 0);
        }
        _this7.selected = item;
        setTimeout(function () {
          _this7.isTransitioning = false;
        }, timeout);
      });
    },
    stopNavRotation: function stopNavRotation() {
      if (interval !== null) {
        clearInterval(interval);
        interval = null;
      }
    },
    startNavRotation: function startNavRotation() {
      var _this8 = this;

      this.stopNavRotation();
      interval = setInterval(function () {
        var nav = _this8.localStoriesNav;
        if (nav.length === 0) {
          return;
        }
        var currentPosition = nav.findIndex(function (i) {
          return i.index === _this8.selected.index;
        });
        var nextPosition = currentPosition === -1 || currentPosition === nav.length - 1 ? 0 : currentPosition + 1;
        _this8.previewTracking.lastAdvanceReason = 'auto';
        _this8.onSelect({ item: nav[nextPosition] });
      }, STORY_SWITCH_INTERVAL);
    },
    resolveInitialStoryItem: function resolveInitialStoryItem(data) {
      if (this.$route.query.story) {
        var indexToSelect = parseInt(this.$route.query.story, 10);
        var selectedItem = data[indexToSelect - 1];

        if (selectedItem) {
          this.activeTab = 'story-' + selectedItem.index;
          return selectedItem;
        }
      }

      var defaultItem = data[0];
      if (defaultItem) {
        this.activeTab = 'story-' + defaultItem.index;
      }

      return defaultItem;
    },
    start: function start() {
      var _this9 = this;

      this.stopNavRotation();
      this.isLoading = true;
      this.isComponentReady = false;

      this.getStoriesNav({ indexes: this.indexes }).then(function (data) {
        if (data.length === 0) {
          _this9.isLoading = false;
          _this9.isComponentReady = true;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
        }

        var item = _this9.resolveInitialStoryItem(data);
        if (!item) {
          _this9.isLoading = false;
          _this9.isComponentReady = true;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
        }

        return _this9.getStoriesList({ indexes: _this9.indexes, cache: true }).then(function () {
          return _this9.onSelect({ item: item }).then(function () {
            _this9.isLoading = false;
            _this9.setupContent();

            setTimeout(function () {
              _this9.checkOverflow();
            }, 0);

            var disableNavBarAutomaticProgression = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(item || {}, 'disableNavBarAutomaticProgression', false);
            if (!_this9.currentPopup && !disableNavBarAutomaticProgression) {
              _this9.startNavRotation();
            }
          });
        });
      }).catch(function (e) {
        __WEBPACK_IMPORTED_MODULE_15__logger__["a" /* default */].error(e);
        _this9.isLoading = false;
        _this9.isComponentReady = true;
      });
    },
    checkScrollButtons: function checkScrollButtons() {
      var tabsList = this.$refs.tabsList;
      if (tabsList) {
        var tolerance = 25;
        this.canScrollLeft = tabsList.scrollLeft > tolerance;
        this.canScrollRight = tabsList.scrollLeft < tabsList.scrollWidth - tabsList.clientWidth - tolerance;
      }
    },
    checkOverflow: function checkOverflow() {
      var _this10 = this;

      var tabsList = this.$refs.tabsList;
      if (tabsList) {
        this.showNavigationArrows = tabsList.scrollWidth > tabsList.clientWidth;
        setTimeout(function () {
          _this10.checkScrollButtons();
        }, 250);
      }
    },
    scrollLeft: function scrollLeft() {
      var _this11 = this;

      var tabsList = this.$refs.tabsList;
      if (tabsList) {
        tabsList.scrollBy({
          left: -150, // Scroll left by 150px
          behavior: 'smooth'
        });
        setTimeout(function () {
          _this11.checkScrollButtons();
        }, 250);
      }
    },
    scrollRight: function scrollRight() {
      var _this12 = this;

      var tabsList = this.$refs.tabsList;
      if (tabsList) {
        tabsList.scrollBy({
          left: 150, // Scroll right by 150px
          behavior: 'smooth'
        });
        setTimeout(function () {
          _this12.checkScrollButtons();
        }, 250);
      }
    },
    toggleExpand: function toggleExpand() {
      var _this13 = this;

      if (!this.isExpanded && this.trackingContext.storyId) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__helpers_dataLayer__["d" /* pushStoryInteraction */])(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({ interactionType: __WEBPACK_IMPORTED_MODULE_16__helpers_dataLayer__["e" /* INTERACTION_TYPE */].READ_MORE }, this.trackingContext));
      }
      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) {
        this.scheduleExpandedHeightRefresh();
      } else {
        this.expandedContentHeight = null;
        this.clearPendingExpandedMeasurements();
      }
      this.stopNavRotation();
      this.selectedManually = true;
      this.$nextTick(function () {
        _this13.emitPodcastLayoutRefresh();
      });
    },
    checkContentOverflow: function checkContentOverflow() {
      var content = this.$refs.content;
      if (content) {
        var collapsedContentHeight = this.measureCollapsedContentHeight() || content.scrollHeight || 0;
        this.isContentOverflowing = collapsedContentHeight > CONTENT_COLLAPSED_HEIGHT + CONTENT_OVERFLOW_TOLERANCE;
        if (this.isExpanded) {
          var expandedContentHeight = this.measureExpandedContentHeight();
          if (expandedContentHeight) {
            this.expandedContentHeight = expandedContentHeight;
          }
        }
      }
    }
  }),
  created: function created() {
    this.start();
  },

  watch: {
    currentStoryIndex: function currentStoryIndex(val) {
      var _this14 = this;

      this.isExpanded = false;
      this.expandedContentHeight = null;
      this.clearPendingExpandedMeasurements();
      this.$nextTick(function () {
        _this14.installActiveStoryCharts();
        _this14.setupContentResizeObserver();
        _this14.checkContentOverflow();
        _this14.emitPodcastLayoutRefresh();
        setTimeout(function () {
          return _this14.emitPodcastLayoutRefresh();
        }, 200);
      });
      var activeTab = 'story-' + val;
      if (activeTab !== this.activeTab) {
        this.activeTab = activeTab;
      }
    },
    isLayoutDesktop: function isLayoutDesktop(value, oldValue) {
      var _this15 = this;

      if (value === oldValue) {
        return;
      }
      this.$nextTick(function () {
        _this15.refreshLayoutContent({ clearExpanded: true });
      });
    },
    currentPopup: function currentPopup(value) {
      if (this.selectedManually) return;
      if (value) {
        this.stopNavRotation();
      } else {
        this.startNavRotation();
      }
    },
    currentSmallPopup: function currentSmallPopup(value) {
      if (this.selectedManually) return;
      if (value) {
        this.stopNavRotation();
      } else {
        this.startNavRotation();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.stopNavRotation();
    this.clearPendingExpandedMeasurements();
    this.teardownContentResizeObserver();
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener(PODCAST_RESIZE_EVENT, this.handleEmbeddedResizeEvent);
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener(PODCAST_RESIZE_EVENT, this.handleEmbeddedResizeEvent);
  }
});

/***/ }),

/***/ "sIXq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sJOz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sJdJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_tabs_js__ = __webpack_require__("bvK5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2766d8f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabs_vue__ = __webpack_require__("okUC");
function injectStyle (ssrContext) {
  __webpack_require__("uqrF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_tabs_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2766d8f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sLBT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


/* eslint-disable no-restricted-syntax */
function stringifyQuery(obj) {
  var res = obj ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).map(function (key) {
    var value = obj[key];

    if (value === undefined) {
      return '';
    }

    if (value === null) {
      return encodeURIComponent(key);
    }

    if (Array.isArray(value)) {
      var result = [];
      value.forEach(function (el) {
        if (el === undefined) {
          return;
        }
        if (el === null) {
          result.push(encodeURIComponent(key));
        } else {
          result.push(encodeURIComponent(key) + '=' + encodeURIComponent(el));
        }
      });
      return result.join('&');
    }

    return encodeURIComponent(key) + '=' + encodeURIComponent(value);
  }).filter(function (x) {
    return x.length > 0;
  }).join('&') : null;
  return res ? '?' + res : '';
}

function unserializeQuery(url) {
  var searchParams = url.split('?')[1];
  var result = {};
  if (searchParams !== undefined) {
    var paramParts = searchParams.split('&');
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(paramParts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var part = _step.value;

        var paramValuePair = part.split('=');
        if (paramValuePair.length === 2) {
          result[paramValuePair[0]] = decodeURIComponent(paramValuePair[1]);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  stringifyQuery: stringifyQuery,
  unserializeQuery: unserializeQuery
});

/***/ }),

/***/ "sOc5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sPnT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onCreateAccount: function onCreateAccount() {
      if (this.isPage) {
        this.$router.push({ name: 'account-page-register' });
      } else {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_modals_constants__["a" /* MODALS */].REGISTER);
      }
    }
  })
});

/***/ }),

/***/ "sS6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    theme: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'market-trading-unavailable-v2': true
      }, 'market-trading-unavailable-v2--' + this.theme, this.theme);
    }
  }
});

/***/ }),

/***/ "sl5T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "smaH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flatten__ = __webpack_require__("rCVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_collapsible_panel_collapsible_panel_vue__ = __webpack_require__("NMl0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__news_feed_item_news_feed_item_vue__ = __webpack_require__("RU3U");









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    collapsiblePanel: __WEBPACK_IMPORTED_MODULE_5__components_collapsible_panel_collapsible_panel_vue__["a" /* default */],
    newsFeedItem: __WEBPACK_IMPORTED_MODULE_6__news_feed_item_news_feed_item_vue__["a" /* default */]
  },
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    inOverlay: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    },
    numArticles: {
      type: Number,
      default: 3
    },
    marketId: {
      type: Number,
      default: null
    },
    source: {
      type: Array,
      default: null
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    collapsible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showAllArticles: this.inOverlay,
      feeds: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    classModifiers: function classModifiers() {
      return {
        'news-feed': true,
        'news-feed--collapsible': this.collapsible
      };
    },
    contentClassModifiers: function contentClassModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'news-feed__content': true,
        'news-feed__content--no-more': !this.showMoreButton
      }, 'news-feed__content--' + this.theme, this.theme);
    },
    articles: function articles() {
      try {
        var articles = __WEBPACK_IMPORTED_MODULE_3_lodash_flatten___default()(this.feeds.map(function (feed) {
          return feed.items;
        }));
        var articlesWithoutDuplicates = __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy___default()(articles, 'id');
        return articlesWithoutDuplicates.sort(function (a, b) {
          return parseInt(b.published, 10) - parseInt(a.published, 10);
        });
      } catch (exc) {
        return [];
      }
    },
    items: function items() {
      return this.showAllArticles ? this.articles : this.articles.slice(0, this.numArticles);
    },
    showMoreButton: function showMoreButton() {
      return !this.showAllArticles && this.numArticles <= this.articles.length;
    },
    showNewsFeed: function showNewsFeed() {
      return this.marketId ? this.items.length > 0 : true;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('popup', ['setGenericPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('insight', ['getFeeds', 'getMarketFeeds']), {
    setupFeeds: function setupFeeds() {
      var _this = this;

      /* if source is passed then feed is not loaded via api calls */
      if (this.source) {
        this.feeds = this.source;
      } else if (this.marketId) {
        this.getMarketFeeds(this.marketId).then(function (data) {
          _this.feeds = data;
        });
      } else {
        this.getFeeds().then(function (data) {
          _this.feeds = data;
        });
      }
    },
    loadMore: function loadMore(e) {
      e.stopPropagation();
      if (this.isLayoutDesktop) {
        this.setGenericPopup({
          name: 'news-feed',
          options: {
            marketId: this.marketId
          }
        });
      } else {
        this.showAllArticles = true;
      }
    }
  }),
  created: function created() {
    this.setupFeeds();
  }
});

/***/ }),

/***/ "sp68":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],staticClass:"notifications-widget"},[_c('div',{staticClass:"notifications-widget__title"},[_c('div',{staticClass:"notifications-widget__title-text"},[_vm._v("\n      Notifications\n    ")]),_vm._v(" "),_c('button',{staticClass:"notifications-widget__title-close",on:{"click":_vm.closeNotificationsWidget}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"13","height":"14","viewBox":"0 0 13 14"}},[_c('path',{attrs:{"fill":"#263b3f","fill-rule":"nonzero","d":"M6.413 4.855L2.36.333A.938.938 0 0 0 1.635 0c-.28 0-.523.11-.733.333l-.604.673A1.224 1.224 0 0 0 0 1.824c0 .318.1.587.298.809L4.212 7 .298 11.367a1.169 1.169 0 0 0-.298.809c0 .311.1.584.298.818l.604.665a.951.951 0 0 0 .733.341c.29 0 .532-.114.725-.341l4.045-4.514 4.053 4.522c.199.222.44.333.725.333.28 0 .524-.11.733-.333l.604-.673c.199-.234.298-.507.298-.818 0-.318-.1-.587-.298-.809L8.606 7l3.914-4.367c.199-.222.298-.491.298-.809 0-.311-.1-.584-.298-.818l-.604-.665A.951.951 0 0 0 11.183 0a.912.912 0 0 0-.725.341L6.413 4.855z"}})])])]),_vm._v(" "),_c('div',{staticClass:"notifications-widget__content"},[_c('notifications-list',{attrs:{"limit":5,"theme":"widget"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "spPB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vimeo_player__ = __webpack_require__("IIvy");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    videoId: {
      type: [String, Number],
      default: null
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    playerWidth: {
      type: [String, Number],
      default: '100%'
    },
    playerHeight: {
      type: [String, Number],
      default: undefined
    }
  },
  data: function data() {
    return {
      player: null
    };
  },

  watch: {
    videoId: function videoId(_videoId) {
      if (this.player && _videoId) {
        this.player.loadVideo(_videoId);
      }
    }
  },
  methods: {
    createPlayer: function createPlayer() {
      var _this = this;

      this.player = new __WEBPACK_IMPORTED_MODULE_1__vimeo_player__["a" /* default */](this.$refs.mountEl, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        id: this.videoId,
        autoplay: this.autoplay,
        loop: this.loop,
        width: this.playerWidth,
        height: this.playerHeight
      }, this.options));
      this.player.ready().then(function () {
        return _this.$emit('ready');
      });
      this.player.on('play', function () {
        return _this.$emit('playing');
      });
      this.player.on('pause', function () {
        return _this.$emit('paused');
      });
      this.player.on('ended', function () {
        return _this.$emit('ended');
      });
      this.player.on('error', function (event) {
        return _this.$emit('error', event);
      });
    }
  },
  mounted: function mounted() {
    this.createPlayer();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.player) {
      this.player.destroy();
      this.player = null;
    }
  }
});

/***/ }),

/***/ "spPS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.appModifiers},[(!_vm.isSimpleLayout)?[_c('maintenance-notification'),_vm._v(" "),(_vm.searchBarVisible)?_c('div',{staticClass:"app-layout__search-overlay"}):_vm._e(),_vm._v(" "),_c('search-bar'),_vm._v(" "),_c('div',{staticClass:"app-layout__notifications"},[_c('transition',{attrs:{"name":"app-layout-side-notification"}},[(_vm.sideNotificationShouldDisplay)?_c('side-notification',{attrs:{"level":_vm.sideNotificationLevel,"text":_vm.sideNotificationText,"sideNotificationOnCloseCallback":_vm.sideNotificationOnCloseCallback}}):_vm._e()],1),_vm._v(" "),_c('notification-items')],1),_vm._v(" "),_c('div',{class:_vm.headerModifiers},[(!_vm.mobileMenuOpened)?_c('app-header-notification'):_vm._e(),_vm._v(" "),_c('app-header'),_vm._v(" "),_c('app-secondary-nav')],1)]:_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"app-layout","mode":"out-in"},on:{"before-leave":_vm.onBeforeLeave,"after-enter":_vm.onAfterEnter}},[_c('div',{key:_vm.$route.fullPath,class:_vm.contentModifiers},[_c('app-mobile-menu'),_vm._v(" "),_c('div',{staticClass:"app-layout__container"},[_c('transition',{attrs:{"name":"slide-left"}},[(_vm.showLeftPanel)?_c('div',{staticClass:"app-layout__left"},[_c('pinboard-panel',{attrs:{"showMenu":true,"hideWhenNoItemsSelected":_vm.activePinboardConfig.hideLeftWhenEmpty,"side":"left"}}),_vm._v(" "),(_vm.inSinglePanelMode)?_c('pinboard-panel',{attrs:{"showMenu":true,"hideWhenNoItemsSelected":_vm.activePinboardConfig.hideRightWhenEmpty,"side":"right"}}):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"app-layout__main"},[_c('router-view')],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-right"}},[(_vm.showRightPanel)?_c('div',{staticClass:"app-layout__right"},[(_vm.inSinglePanelMode)?_c('pinboard-panel',{attrs:{"showMenu":true,"hideWhenNoItemsSelected":_vm.activePinboardConfig.hideLeftWhenEmpty,"side":"left"}}):_vm._e(),_vm._v(" "),_c('pinboard-panel',{attrs:{"showMenu":true,"hideWhenNoItemsSelected":_vm.activePinboardConfig.hideRightWhenEmpty,"side":"right"}})],1):_vm._e()])],1)],1)]),_vm._v(" "),(!_vm.isSimpleLayout)?_c('div',{staticClass:"app-layout__footer"},[_c('app-footer')],1):_vm._e(),_vm._v(" "),(false)?_c('div',{staticClass:"app-layout__bottom-nav"},[_c('app-bottom-nav',{key:_vm.$router.currentRoute.path,attrs:{"showIcons":true}})],1):_vm._e(),_vm._v(" "),_c('nav-browse-categories-overlay')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "srjS":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDEzIDE1Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTYuNDEzIDUuMjY0TDIuMzYuNzQyYS45MzguOTM4IDAgMCAwLS43MjUtLjMzM2MtLjI4IDAtLjUyMy4xMS0uNzMzLjMzM2wtLjYwNC42NzNBMS4yMjQgMS4yMjQgMCAwIDAgMCAyLjIzM2MwIC4zMTguMS41ODcuMjk4LjgwOWwzLjkxNCA0LjM2Ny0zLjkxNCA0LjM2N2ExLjE2OSAxLjE2OSAwIDAgMC0uMjk4LjgwOWMwIC4zMTEuMS41ODQuMjk4LjgxOGwuNjA0LjY2NWEuOTUxLjk1MSAwIDAgMCAuNzMzLjM0MWMuMjkgMCAuNTMyLS4xMTQuNzI1LS4zNDFsNC4wNDUtNC41MTQgNC4wNTMgNC41MjJjLjE5OS4yMjIuNDQuMzMzLjcyNS4zMzMuMjggMCAuNTI0LS4xMS43MzMtLjMzM2wuNjA0LS42NzNjLjE5OS0uMjM0LjI5OC0uNTA3LjI5OC0uODE4IDAtLjMxOC0uMS0uNTg3LS4yOTgtLjgwOUw4LjYwNiA3LjQxbDMuOTE0LTQuMzY3Yy4xOTktLjIyMi4yOTgtLjQ5MS4yOTgtLjgwOSAwLS4zMTEtLjEtLjU4NC0uMjk4LS44MThMMTEuOTE2Ljc1YS45NTEuOTUxIDAgMCAwLS43MzMtLjM0MS45MTIuOTEyIDAgMCAwLS43MjUuMzQxTDYuNDEzIDUuMjY0eiIvPgo8L3N2Zz4="

/***/ }),

/***/ "ssDi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "svCT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLink)?_c('a',{class:_vm.linkClass,attrs:{"href":_vm.url}},[_vm._v("\n    "+_vm._s(_vm.displayText)),(_vm.isStoryFooterCta)?_c('span',[_vm._v(" →")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isButton)?_c('a',{staticClass:"link link--button",attrs:{"href":_vm.url}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t3/+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t45u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isOfferMatched;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__ = __webpack_require__("a0yF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");

/* eslint-disable */



function isOfferMatched(data) {
  return data.History !== null && data.History.length > 0 && data.Offer.RemainingQuantity === 0;
}

/* harmony default export */ __webpack_exports__["b"] = ({
  namespaced: true,
  state: {
    notificationList: [],
    sideNotificationLevel: '',
    sideNotificationText: '',
    sideNotificationOnCloseCallback: null,
    lastConfirmedContractData: {},
    showNotificationsWidget: false
  },
  mutations: {
    add: function add(state, notification) {
      notification.index = new Date().getTime() + Math.floor(Math.random() * 10000);
      state.notificationList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.notificationList), [notification]);
    },
    remove: function remove(state, index) {
      var target = state.notificationList.find(function (i) {
        return i.index === index;
      });
      var indexToSlice = state.notificationList.indexOf(target);
      if (indexToSlice === -1) return;
      var firstSlice = state.notificationList.slice(0, indexToSlice);
      var secondSlice = state.notificationList.slice(indexToSlice + 1);
      state.notificationList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(firstSlice), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(secondSlice));
    },
    clear: function clear(state) {
      state.notificationList = [];
    },
    setSideNotification: function setSideNotification(state, _ref) {
      var text = _ref.text,
          level = _ref.level,
          onCloseCallback = _ref.onCloseCallback;

      state.sideNotificationLevel = level;
      state.sideNotificationText = text;
      state.sideNotificationOnCloseCallback = onCloseCallback;
    },
    clearSideNotification: function clearSideNotification(state) {
      state.sideNotificationLevel = '';
      state.sideNotificationText = '';
      state.sideNotificationOnCloseCallback = null;
    },
    setLastConfirmedContractData: function setLastConfirmedContractData(state, payload) {
      state.lastConfirmedContractData = payload;
    },
    toggleNotificationsWidget: function toggleNotificationsWidget(state) {
      state.showNotificationsWidget = !state.showNotificationsWidget;
    },
    closeNotificationsWidget: function closeNotificationsWidget(state) {
      state.showNotificationsWidget = false;
    }
  },
  actions: {
    add: function add(_ref2, notification) {
      var commit = _ref2.commit,
          state = _ref2.state;

      if (notification.type === __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["j" /* NOTIFICATION_TRADE_CONFIRMED */]) {
        setTimeout(function () {
          commit('add', notification);
          commit('setLastConfirmedContractData', {
            id: notification.data.ContractId,
            matched: isOfferMatched(notification.data)
          });
          if (notification.data && notification.data.Offer && notification.data.Offer.OfferId) {
            var associatedNotification = state.notificationList.filter(function (i) {
              return i.type === 'simple';
            }).find(function (i) {
              return i.externalId === notification.data.Offer.OfferId;
            });

            if (!associatedNotification) return;
            commit('remove', associatedNotification.index);
          }
        }, __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["m" /* NOTIFICATION_TRADE_CONFIRMED_DELAY */]);
      } else if (notification.type === __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["k" /* NOTIFICATION_SHARES_TRADED */]) {
        commit('setLastConfirmedContractData', {
          id: notification.data.contentJson.ContractId,
          matched: true
        });
        commit('add', notification);
      } else if (__WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["n" /* ALLOWED_NOTIFICATION_TYPES */].includes(notification.type)) {
        commit('add', notification);
      }
    },
    remove: function remove(_ref3, notificationIndex) {
      var commit = _ref3.commit;

      commit('remove', notificationIndex);
    },
    clear: function clear(_ref4) {
      var commit = _ref4.commit;

      commit('clear');
    },
    addSimple: function addSimple(_ref5, _ref6) {
      var commit = _ref5.commit;
      var icon = _ref6.icon,
          text = _ref6.text,
          _ref6$externalId = _ref6.externalId,
          externalId = _ref6$externalId === undefined ? null : _ref6$externalId,
          _ref6$closeTimeout = _ref6.closeTimeout,
          closeTimeout = _ref6$closeTimeout === undefined ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DEFAULT_NOTIFICATION_CLOSE_TIMEOUT : _ref6$closeTimeout,
          _ref6$title = _ref6.title,
          title = _ref6$title === undefined ? '' : _ref6$title;

      var notification = {
        method: null,
        type: 'simple',
        externalId: externalId,
        data: {
          title: title,
          icon: icon,
          text: text,
          closeTimeout: closeTimeout
        }
      };
      commit('add', notification);
    },
    setSideNotification: function setSideNotification(_ref7, _ref8) {
      var commit = _ref7.commit;
      var text = _ref8.text,
          level = _ref8.level;

      commit('setSideNotification', { text: text, level: level });
    },
    setSuccessSideNotification: function setSuccessSideNotification(_ref9, text) {
      var commit = _ref9.commit;

      commit('setSideNotification', { text: text, level: 'success' });
    },
    setSuccessSideNotificationWithTimeoutCallback: function setSuccessSideNotificationWithTimeoutCallback(_ref10, _ref11) {
      var _this = this;

      var commit = _ref10.commit;
      var text = _ref11.text,
          _ref11$callback = _ref11.callback,
          callback = _ref11$callback === undefined ? function () {} : _ref11$callback;

      var callBackApplied = false;
      var timeout = setTimeout(function () {
        callBackApplied = true;
        callback.apply(_this);
      }, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT);
      commit('setSideNotification', {
        text: text,
        level: 'success',
        onCloseCallback: function onCloseCallback() {
          if (!callBackApplied) {
            clearTimeout(timeout);
            callback.apply(_this);
          }
        }
      });
    },
    setErrorSideNotification: function setErrorSideNotification(_ref12, text) {
      var commit = _ref12.commit;

      commit('setSideNotification', { text: text, level: 'danger' });
    },
    clearSideNotification: function clearSideNotification(_ref13) {
      var commit = _ref13.commit;

      commit('clearSideNotification');
    },
    toggleNotificationsWidget: function toggleNotificationsWidget(_ref14) {
      var commit = _ref14.commit;

      commit('toggleNotificationsWidget');
    },
    closeNotificationsWidget: function closeNotificationsWidget(_ref15) {
      var commit = _ref15.commit;

      commit('closeNotificationsWidget');
    }
  }
});

/***/ }),

/***/ "t71M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_bank_transfer_js__ = __webpack_require__("ooVM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47ceef1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_bank_transfer_vue__ = __webpack_require__("UubQ");
function injectStyle (ssrContext) {
  __webpack_require__("NmGr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_bank_transfer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47ceef1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_bank_transfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tE+S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_market_market_filters_market_filters_mixin_market_filters_mixin__ = __webpack_require__("kGlu");


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_market_market_filters_market_filters_mixin_market_filters_mixin__["a" /* default */]],
  computed: {
    orderMenuName: function orderMenuName() {
      return this.selectedOrder.name;
    },
    mainClassName: function mainClassName() {
      return 'market-filters-mobile';
    },
    menuClassModifier: function menuClassModifier() {
      return {
        'market-filters-mobile__menu': true,
        'market-filters-mobile__menu--with-timespan-filter': this.shouldShowTimespanFilter
      };
    }
  }
});

/***/ }),

/***/ "tLet":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tLhP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.classModifiers,attrs:{"to":_vm.contractRoute}},[_c('div',{directives:[{name:"contract-name",rawName:"v-contract-name"}],staticClass:"market-contract-v2__title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"market-contract-v2__current-price"},[(_vm.hasLastTradePrice)?[_c('animated-number',{attrs:{"value":_vm.price}})]:[_vm._v("\n      -"),_c('span',{domProps:{"innerHTML":_vm._s('&cent;')}})]],2),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.changePrice,"lastClosePrice":_vm.contractModel.lastClosePrice}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tPuv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_item_v2_js__ = __webpack_require__("gwUB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d0d9349_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_item_v2_vue__ = __webpack_require__("qn2S");
function injectStyle (ssrContext) {
  __webpack_require__("0Dp4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_item_v2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d0d9349_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_item_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tQfv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toArray__ = __webpack_require__("7nRM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_shuffle__ = __webpack_require__("yG5q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_shuffle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_collapsible_panel_collapsible_panel_vue__ = __webpack_require__("NMl0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_twitter_twitter__ = __webpack_require__("tWDM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_onboarding_consts__ = __webpack_require__("yUpF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_cms_account_combined_login_account_combined_login_vue__ = __webpack_require__("7GI3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_cms_market_list_item_v2_embed_market_list_item_v2_embed_vue__ = __webpack_require__("JSpR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_cms_market_contract_list_v2_embed_market_contract_list_v2_embed_vue__ = __webpack_require__("KsCZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_cms_market_contract_list_v2_embed_compact_market_contract_list_v2_embed_compact_vue__ = __webpack_require__("UXtE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_cms_document_table_view_document_table_view_vue__ = __webpack_require__("BiGr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_cms_document_tile_view_document_tile_view_vue__ = __webpack_require__("mRGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_generics_link_link_vue__ = __webpack_require__("dxV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_market_market_detail_charts_market_detail_charts_vue__ = __webpack_require__("1P9U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_home_home_old_podcasts_podcasts_vue__ = __webpack_require__("QrTx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_cms_video_view_video_view_vue__ = __webpack_require__("5jEk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_cms_map_widget_view_map_widget_view_vue__ = __webpack_require__("5Wmq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__helpers_dataLayer__ = __webpack_require__("k37b");







 /* eslint-disable */
























var LoginComponent = __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_15__components_cms_account_combined_login_account_combined_login_vue__["a" /* default */]);
var CollapsiblePanelComponent = __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_10__components_collapsible_panel_collapsible_panel_vue__["a" /* default */]);
var MarketListItemEmbedComponent = __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_16__components_cms_market_list_item_v2_embed_market_list_item_v2_embed_vue__["a" /* default */]);
var MarketContractListEmbedComponent = __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_17__components_cms_market_contract_list_v2_embed_market_contract_list_v2_embed_vue__["a" /* default */]);
var MarketContractListEmbedCompactComponent = __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_18__components_cms_market_contract_list_v2_embed_compact_market_contract_list_v2_embed_compact_vue__["a" /* default */]);
var LinkComponent = __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_21__components_generics_link_link_vue__["a" /* default */]);
var PodcastsComponent = __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_23__components_home_home_old_podcasts_podcasts_vue__["a" /* default */]);
var MarketChartsComponent = __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_22__components_market_market_detail_charts_market_detail_charts_vue__["a" /* default */]);
var DocumentTableViewComponent = __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_19__components_cms_document_table_view_document_table_view_vue__["a" /* default */]);
var DocumentTileViewComponent = __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_20__components_cms_document_tile_view_document_tile_view_vue__["a" /* default */]);
var VideoViewComponents = __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_24__components_cms_video_view_video_view_vue__["a" /* default */]);
var MapWidgetViewComponent = __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_25__components_cms_map_widget_view_map_widget_view_vue__["a" /* default */]);

var PreviewCarouselEmbedComponent = null;
var getPreviewCarouselEmbedComponent = function getPreviewCarouselEmbedComponent() {
  if (PreviewCarouselEmbedComponent) {
    return PreviewCarouselEmbedComponent;
  }
  var module = __webpack_require__("TA6E");
  PreviewCarouselEmbedComponent = __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].extend(module.default || module);
  return PreviewCarouselEmbedComponent;
};

var dateGoDisplay = function dateGoDisplay(dt) {
  var daysDiff = __WEBPACK_IMPORTED_MODULE_8_moment___default()().diff(dt, 'days');
  var hoursDiff = __WEBPACK_IMPORTED_MODULE_8_moment___default()().diff(dt, 'hours');
  if (daysDiff > 365) {
    var years = Math.floor(daysDiff / 365);
    return years === 1 ? '1 year ago' : years + ' years ago';
  } else if (daysDiff > 30) {
    var months = Math.floor(daysDiff / 30);
    return months === 1 ? '1 month ago' : months + ' months ago';
  } else if (hoursDiff > 24) {
    return daysDiff === 1 ? '1 day ago' : daysDiff + ' days ago';
  } else if (hoursDiff >= 1) {
    return hoursDiff === 1 ? '1 hour ago' : Math.floor(hoursDiff) + ' hours ago';
  }
  return 'Within the last hour';
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_27__mixins_accountVerify__["a" /* default */]],
  data: function data() {
    return {
      content: '',
      marketTileMarkets: [],
      contractListMarkets: [],
      cmsAccordionContentObjects: [],
      podcastItemContentObjects: [],
      chartWidgetObjects: [],
      docsWidgetObjects: [],
      videoWidgetObjects: [],
      mapWidgetObjects: [],
      cmsChartMarketCache: new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default.a()
    };
  },

  methods: {
    getTrackingContextForElement: function getTrackingContextForElement(el) {
      var regionEl = el.closest('[data-analytics-id]');
      var analyticsIdRaw = regionEl && regionEl.getAttribute('data-analytics-id') || '';

      var _analyticsIdRaw$split = analyticsIdRaw.split(/[-]/),
          _analyticsIdRaw$split2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toArray___default()(_analyticsIdRaw$split),
          storyId = _analyticsIdRaw$split2[0],
          storyVersionId = _analyticsIdRaw$split2[1],
          sectionId = _analyticsIdRaw$split2[2],
          regionId = _analyticsIdRaw$split2[3],
          regionTrackingId = _analyticsIdRaw$split2[4],
          rest = _analyticsIdRaw$split2.slice(5);

      return {
        storyId: storyId,
        storyVersionId: storyVersionId || 0,
        sectionId: sectionId,
        regionId: regionId,
        regionTrackingId: regionTrackingId,
        previewUniqueViewGUID: this.previewUniqueViewGUID
      };
    },
    installCarousels: function installCarousels() {
      var carousels = this.$el.querySelectorAll('.predictit__carousel');
      var PreviewCarouselComponent = getPreviewCarouselEmbedComponent();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(carousels), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var el = _step.value;

          var indicesString = el.getAttribute('data-carousel_indices');
          var indexes = indicesString ? indicesString.split(',').map(function (i) {
            return i.trim();
          }) : [];
          var trackingContext = this.getTrackingContextForElement(el);

          var instance = new PreviewCarouselComponent({
            parent: this,
            propsData: {
              indexes: indexes,
              trackingContext: trackingContext
            }
          });
          instance.$mount(el);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    installAccordions: function installAccordions() {
      var _this = this;

      var accordionHeaders = this.$el.querySelectorAll('.predictit__accordion');

      var _loop = function _loop(el) {
        var index = parseInt(el.getAttribute('data-accordionindex'), 10);
        var uuid = el.getAttribute('data-accordionuuid');
        var title = el.getAttribute('data-accordiontitle');
        var accordionObj = _this.cmsAccordionContentObjects.find(function (i) {
          if (uuid) {
            return i.regionUUID === uuid;
          } else {
            return i.accordionIndex === index;
          }
        });

        if (accordionObj) {
          var content = accordionObj.content || '';
          var instance = new CollapsiblePanelComponent({
            parent: _this,
            propsData: {
              title: title,
              content: content,
              isOpen: accordionObj.isOpenByDefault
            }
          });
          instance.$mount(el);
        }
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(accordionHeaders), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var el = _step2.value;

          _loop(el);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    installTweets: function installTweets() {
      var _this2 = this;

      if (__WEBPACK_IMPORTED_MODULE_12__mixins_userAgent__["h" /* isWrapperApp */]) return;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__components_twitter_twitter__["a" /* default */])().ready(function (twt) {
        var twitterWidgets = _this2.$el.querySelectorAll('.predictit__twitter');
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(twitterWidgets), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var widget = _step3.value;

            var tweetId = widget.getAttribute('data-tweetid');
            twt.widgets.createTweet(tweetId, widget, {
              theme: 'light'
            });
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      });
    },
    installDateElapsed: function installDateElapsed() {
      var dateEls = this.$el.querySelectorAll('.predictit__elapsedtime');
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(dateEls), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var el = _step4.value;

          var date = __WEBPACK_IMPORTED_MODULE_8_moment___default()(el.getAttribute('data-publishdate'));
          el.innerHTML = dateGoDisplay(date);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    },
    installWelcomePopupControls: function installWelcomePopupControls() {
      var buttons = this.$el.querySelectorAll('.predictit-leaving-button');
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(buttons), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var button = _step5.value;

          button.addEventListener('click', function () {
            __WEBPACK_IMPORTED_MODULE_26__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_13__components_app_app_modals_modals_constants__["a" /* MODALS */].LEAVING_POPUP);
          });
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    installLoginAndSignUpControls: function installLoginAndSignUpControls() {
      var _this3 = this;

      var loginButtons = this.$el.querySelectorAll('.predictit-login-button');
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(loginButtons), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var button = _step6.value;

          button.addEventListener('click', function () {
            if (__WEBPACK_IMPORTED_MODULE_26__store__["a" /* default */].getters['user/isLoggedIn']) {
              _this3.$router.push({ name: 'market-list' });
            } else {
              __WEBPACK_IMPORTED_MODULE_26__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_13__components_app_app_modals_modals_constants__["a" /* MODALS */].LOGIN);
            }
          });
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var loginControls = this.$el.querySelectorAll('.predictit-login-control');
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(loginControls), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var _button = _step7.value;

          if (__WEBPACK_IMPORTED_MODULE_26__store__["a" /* default */].getters['user/isLoggedIn']) {
            this.$router.push({ name: 'market-list' });
          } else {
            var instance = new LoginComponent({
              parent: this,
              propsData: {}
            });
            instance.$mount(_button);
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      var signUpButtons = this.$el.querySelectorAll('.predictit-signup-button');
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(signUpButtons), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var _button2 = _step8.value;

          _button2.addEventListener('click', function () {
            if (__WEBPACK_IMPORTED_MODULE_26__store__["a" /* default */].getters['user/isLoggedIn']) {
              _this3.$router.push({ name: 'market-list' });
            } else {
              __WEBPACK_IMPORTED_MODULE_26__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_13__components_app_app_modals_modals_constants__["a" /* MODALS */].REGISTER);
            }
          });
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
    },
    installMarketLists: function installMarketLists() {
      var _this4 = this;

      var marketListEls = this.$el.querySelectorAll('.predictit__markettilelist');

      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(marketListEls), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var el = _step9.value;

          var marketIds = el.getAttribute('data-marketids').replace(' ', '').split(',').map(function (i) {
            return parseInt(i, 10);
          });
          var markets = marketIds.map(function (marketId) {
            return _this4.marketTileMarkets.find(function (i) {
              return i.marketId === marketId;
            });
          }).filter(function (i) {
            return !!i;
          });
          var dataNumColumns = parseInt(el.getAttribute('data-num-columns') || 3, 10);
          var renderStyle = parseInt(el.getAttribute('data-render-style') || 1, 10);

          if (markets.length > 0) {
            var trackingContext = this.getTrackingContextForElement(el);
            var instance = new MarketListItemEmbedComponent({
              parent: this,
              propsData: {
                markets: markets,
                dataNumColumnsDesktop: dataNumColumns,
                renderStyle: renderStyle,
                trackingContext: trackingContext
              }
            });
            instance.$mount(el);
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }
    },
    installMarketContracts: function installMarketContracts() {
      var _this5 = this;

      var marketContractsEl = this.$el.querySelectorAll('.predictit__marketpreview');

      var _loop2 = function _loop2(el) {
        var marketId = parseInt(el.getAttribute('data-marketid'), 10);
        var market = _this5.contractListMarkets.find(function (i) {
          return i.marketId === marketId;
        });
        if (!market) {
          return 'continue';
        }
        var contractIds = el.getAttribute('data-contractids').replace(' ', '').split(',').map(function (i) {
          return parseInt(i, 10);
        });
        var contracts = market.contracts.filter(function (i) {
          return contractIds.includes(i.contractId);
        });
        var compactViewMode = (el.getAttribute('data-compactview') || '').toLowerCase() === 'true';
        var openNewTab = (el.getAttribute('data-opennewtab') || '').toLowerCase() === 'true';
        if (compactViewMode) {
          var trackingContext = _this5.getTrackingContextForElement(el);
          var instance = new MarketContractListEmbedCompactComponent({
            parent: _this5,
            propsData: {
              openNewTab: openNewTab,
              trackingContext: trackingContext,
              contracts: contracts.map(function (i) {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, i, {
                  marketName: market.marketName,
                  marketId: market.marketId
                });
              })
            }
          });
          instance.$mount(el);
        } else {
          var _trackingContext = _this5.getTrackingContextForElement(el);
          var _instance = new MarketContractListEmbedComponent({
            parent: _this5,
            propsData: {
              openNewTab: openNewTab,
              trackingContext: _trackingContext,
              market: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, market, {
                contracts: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(contracts))
              })
            }
          });
          _instance.$mount(el);
        }
      };

      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(marketContractsEl), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var el = _step10.value;

          var _ret2 = _loop2(el);

          if (_ret2 === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }
    },
    installViewMarketTracking: function installViewMarketTracking(el, url) {
      var MARKET_URL_PATTERN = /^\/markets\//;
      if (!MARKET_URL_PATTERN.test(url || '')) return;
      var trackingContext = this.getTrackingContextForElement(el);
      el.addEventListener('click', function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__helpers_dataLayer__["d" /* pushStoryInteraction */])(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ interactionType: __WEBPACK_IMPORTED_MODULE_28__helpers_dataLayer__["e" /* INTERACTION_TYPE */].VIEW_MARKET }, trackingContext));
      });
    },
    installButtonsAndLinks: function installButtonsAndLinks() {
      var links = this.$el.querySelectorAll('[data-buttontype="Link"]');
      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(links), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          var el = _step11.value;

          var url = el.getAttribute('data-detailpath');
          var isStoryFooterCta = (el.getAttribute('data-story-footer-cta') || '').toLowerCase() === 'true';
          var instance = new LinkComponent({
            parent: this,
            propsData: {
              type: 'link',
              text: el.innerHTML,
              url: url,
              styleVariant: isStoryFooterCta ? 'story-footer-cta' : ''
            }
          });
          instance.$mount(el);
          this.installViewMarketTracking(el, url);
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11.return) {
            _iterator11.return();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }

      var buttons = this.$el.querySelectorAll('[data-buttontype="Button"]');
      var _iteratorNormalCompletion12 = true;
      var _didIteratorError12 = false;
      var _iteratorError12 = undefined;

      try {
        for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(buttons), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
          var _el = _step12.value;

          var url = _el.getAttribute('data-detailpath');
          var instance = new LinkComponent({
            parent: this,
            propsData: {
              type: 'button',
              text: _el.innerHTML,
              url: url
            }
          });
          instance.$mount(_el);
          this.installViewMarketTracking(_el, url);
        }
      } catch (err) {
        _didIteratorError12 = true;
        _iteratorError12 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion12 && _iterator12.return) {
            _iterator12.return();
          }
        } finally {
          if (_didIteratorError12) {
            throw _iteratorError12;
          }
        }
      }
    },
    installPodcasts: function installPodcasts() {
      var _this6 = this;

      var podcastSliders = this.$el.querySelectorAll('.predictit__podcastslider');
      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(podcastSliders), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var el = _step13.value;

          var podcastUuids = (el.getAttribute('data-podcastuuids') || '').split(',').map(function (i) {
            return i.trim();
          }).filter(function (i) {
            return i.length > 0;
          });
          var podcasts = podcastUuids.map(function (index) {
            return _this6.podcastItemContentObjects.find(function (podcast) {
              return podcast.regionUUID === index;
            });
          }).filter(function (i) {
            return !!i;
          });
          var _title = el.getAttribute('data-podcasttitle');
          var isRandomized = (el.getAttribute('data-podcastisrandomized') || '').toLowerCase() === 'true';

          var items = podcasts.map(function (i) {
            var chunks = (i.podcastUrl || '').split('/').filter(function (chunk) {
              return chunk && chunk.length > 0;
            });
            return {
              id: chunks[chunks.length - 1] || '',
              type: __WEBPACK_IMPORTED_MODULE_23__components_home_home_old_podcasts_podcasts_vue__["b" /* PODCAST */].APPLE
            };
          }).filter(function (i) {
            return i.id.length > 0;
          });

          if (isRandomized) {
            items = __WEBPACK_IMPORTED_MODULE_6_lodash_shuffle___default()(items);
          }
          var forceLayoutMode = typeof this.getCmsForcedLayoutMode === 'function' ? this.getCmsForcedLayoutMode() : '';
          var instance = new PodcastsComponent({
            parent: this,
            propsData: {
              theme: 'story',
              title: _title,
              items: items,
              forceLayoutMode: forceLayoutMode
            }
          });
          instance.$mount(el);
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }
    },
    resolveChartMarket: function resolveChartMarket(marketId) {
      var _this7 = this;

      var normalizedMarketId = parseInt(marketId, 10);
      if (isNaN(normalizedMarketId)) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('Invalid market id: ' + marketId));
      }

      if (this.cmsChartMarketCache.has(normalizedMarketId)) {
        return this.cmsChartMarketCache.get(normalizedMarketId);
      }

      var request = __WEBPACK_IMPORTED_MODULE_26__store__["a" /* default */].dispatch('market/getMarket', { marketId: normalizedMarketId, modifyState: false }).then(function (market) {
        if (!market) {
          throw new Error('Market data not found for marketId=' + normalizedMarketId);
        }
        return market;
      }).catch(function (error) {
        _this7.cmsChartMarketCache.delete(normalizedMarketId);
        throw error;
      });

      this.cmsChartMarketCache.set(normalizedMarketId, request);
      return request;
    },
    installMarketCharts: function installMarketCharts() {
      var _this8 = this;

      var rootEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$suppressGlobalLo = _ref.suppressGlobalLoader,
          suppressGlobalLoader = _ref$suppressGlobalLo === undefined ? false : _ref$suppressGlobalLo;

      var root = rootEl || this.$el;
      if (!root) {
        return;
      }
      var marketChartsEl = root.querySelectorAll('.predictit__datachart');

      var _loop3 = function _loop3(el) {
        var mountState = el.getAttribute('data-cms-chart-mounted');
        if (mountState === 'pending' || mountState === 'true') {
          return 'continue';
        }

        var uuid = el.getAttribute('data-chartuuid');
        var versionId = el.getAttribute('data-chartstoryversionid');
        var storyId = el.getAttribute('data-chartstoryid');
        var maxHeight = el.getAttribute('data-max-height');

        var chartObj = _this8.chartWidgetObjects.find(function (i) {
          return i.regionUUID === uuid;
        });
        if (typeof chartObj === 'undefined') {
          return 'continue';
        }

        var trackingContext = _this8.getTrackingContextForElement(el);
        el.setAttribute('data-cms-chart-mounted', 'pending');
        _this8.resolveChartMarket(chartObj.marketId).then(function (market) {
          var result = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, market);
          if (chartObj.contractIds && chartObj.contractIds.length > 0 && result && result.contracts) {
            result = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, result, {
              contracts: result.contracts.filter(function (i) {
                return chartObj.contractIds.includes(i.contractId);
              })
            });
          }
          var instance = new MarketChartsComponent({
            parent: _this8,
            propsData: {
              market: result,
              chartOptions: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, chartObj, {
                cmsStoryId: storyId,
                cmsVersionId: versionId,
                includeDownload: false,
                maxHeight: maxHeight
                // showContractImagesOnLegend: true,
                // showContractImagesOnChart: true,
              }),
              trackingContext: trackingContext,
              suppressGlobalLoader: suppressGlobalLoader
            }
          });
          instance.$mount(el);
          el.setAttribute('data-cms-chart-mounted', 'true');
        }).catch(function () {
          el.removeAttribute('data-cms-chart-mounted');
        });
      };

      var _iteratorNormalCompletion14 = true;
      var _didIteratorError14 = false;
      var _iteratorError14 = undefined;

      try {
        for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(marketChartsEl), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
          var el = _step14.value;

          var _ret3 = _loop3(el);

          if (_ret3 === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError14 = true;
        _iteratorError14 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion14 && _iterator14.return) {
            _iterator14.return();
          }
        } finally {
          if (_didIteratorError14) {
            throw _iteratorError14;
          }
        }
      }
    },
    installVideoWidgets: function installVideoWidgets() {
      var _this9 = this;

      var videoEls = this.$el.querySelectorAll('.predictit__videowidget');

      var _loop4 = function _loop4(el) {
        var url = el.getAttribute('data-videourl');
        var maxHeight = el.getAttribute('data-max-height');
        var videoData = _this9.videoWidgetObjects.find(function (i) {
          return i.videoUrl === url;
        });
        var trackingContext = _this9.getTrackingContextForElement(el);
        var instance = new VideoViewComponents({
          parent: _this9,
          propsData: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, videoData, {
            maxHeight: maxHeight,
            trackingContext: trackingContext
          })
        });
        instance.$mount(el);
      };

      var _iteratorNormalCompletion15 = true;
      var _didIteratorError15 = false;
      var _iteratorError15 = undefined;

      try {
        for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(videoEls), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
          var el = _step15.value;

          _loop4(el);
        }
      } catch (err) {
        _didIteratorError15 = true;
        _iteratorError15 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion15 && _iterator15.return) {
            _iterator15.return();
          }
        } finally {
          if (_didIteratorError15) {
            throw _iteratorError15;
          }
        }
      }
    },
    installDocumentsWidgets: function installDocumentsWidgets() {
      var _this10 = this;

      var documentsEls = this.$el.querySelectorAll('.predictit__docswidget');

      var _loop5 = function _loop5(el) {
        var uuid = el.getAttribute('data-docsuuid');
        var viewType = parseInt(el.getAttribute('data-docsviewtype'), 10);
        var documentData = _this10.docsWidgetObjects.find(function (i) {
          return i.regionUUID === uuid;
        });
        if (documentData) {
          var componentClassMap = {
            1: DocumentTileViewComponent,
            2: DocumentTableViewComponent
          };
          var ComponentClass = componentClassMap[viewType] || DocumentTileViewComponent;
          var instance = new ComponentClass({
            parent: _this10,
            propsData: {
              documentData: documentData
            }
          });
          instance.$mount(el);
        }
      };

      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(documentsEls), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var el = _step16.value;

          _loop5(el);
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }
    },
    installMapWidgets: function installMapWidgets() {
      var _this11 = this;

      var mapEls = this.$el.querySelectorAll('.predictit__mapwidget');

      var _loop6 = function _loop6(el) {
        var uuid = el.getAttribute('data-mapwidgetuuid');
        var mapNameFromElement = el.getAttribute('data-mapname');
        var mapWidgetData = _this11.mapWidgetObjects.find(function (i) {
          return i.regionUUID === uuid;
        });
        var mapName = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(mapWidgetData, 'mapName', '') || mapNameFromElement;
        if (!mapName) {
          return 'continue';
        }

        var instance = new MapWidgetViewComponent({
          parent: _this11,
          propsData: {
            mapName: mapName
          }
        });
        instance.$mount(el);
      };

      var _iteratorNormalCompletion17 = true;
      var _didIteratorError17 = false;
      var _iteratorError17 = undefined;

      try {
        for (var _iterator17 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(mapEls), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
          var el = _step17.value;

          var _ret6 = _loop6(el);

          if (_ret6 === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError17 = true;
        _iteratorError17 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion17 && _iterator17.return) {
            _iterator17.return();
          }
        } finally {
          if (_didIteratorError17) {
            throw _iteratorError17;
          }
        }
      }
    },
    installDynamicControls: function installDynamicControls() {
      var _this12 = this;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$data = _ref2.data,
          data = _ref2$data === undefined ? {} : _ref2$data,
          _ref2$marketChartsRoo = _ref2.marketChartsRootEl,
          marketChartsRootEl = _ref2$marketChartsRoo === undefined ? null : _ref2$marketChartsRoo,
          _ref2$suppressMarketC = _ref2.suppressMarketChartsGlobalLoader,
          suppressMarketChartsGlobalLoader = _ref2$suppressMarketC === undefined ? false : _ref2$suppressMarketC,
          _ref2$skipMarketChart = _ref2.skipMarketCharts,
          skipMarketCharts = _ref2$skipMarketChart === undefined ? false : _ref2$skipMarketChart,
          _ref2$skipCarousel = _ref2.skipCarousel,
          skipCarousel = _ref2$skipCarousel === undefined ? false : _ref2$skipCarousel;

      this.css = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(data, 'renderedCSS', '') || '';
      this.content = '' + this.css + __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(data, 'renderedHTML', '');
      this.cmsAccordionContentObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(data, 'cmsContentObject.accordionContentObjects', []);
      this.podcastItemContentObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(data, 'cmsContentObject.podcastItemContentObjects', []);
      this.contractListMarkets = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(data, 'cmsContentObject.contractListMarkets', []);
      this.marketTileMarkets = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(data, 'cmsContentObject.marketTileMarkets', []);
      this.chartWidgetObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(data, 'cmsContentObject.chartWidgetObjects', []);
      this.docsWidgetObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(data, 'cmsContentObject.docsWidgetObjects', []);
      this.videoWidgetObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(data, 'cmsContentObject.videoWidgetObjects', []);
      this.mapWidgetObjects = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(data, 'cmsContentObject.mapWidgetObjects', []);

      this.$nextTick(function () {
        _this12.installAccordions();
        _this12.installTweets();
        _this12.installDateElapsed();
        _this12.installLoginAndSignUpControls();
        _this12.installWelcomePopupControls();
        _this12.installMarketLists();
        _this12.installMarketContracts();
        _this12.installButtonsAndLinks();
        _this12.installPodcasts();
        if (!skipMarketCharts) {
          _this12.installMarketCharts(marketChartsRootEl, { suppressGlobalLoader: suppressMarketChartsGlobalLoader });
        }
        _this12.installDocumentsWidgets();
        _this12.installVideoWidgets();
        if (!skipCarousel) {
          _this12.installCarousels();
        }
        _this12.installMapWidgets();
      });
    }
  }
});

/***/ }),

/***/ "tRmv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_disabled_outcome_v2_js__ = __webpack_require__("2A6V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4536ead8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_disabled_outcome_v2_vue__ = __webpack_require__("ikte");
function injectStyle (ssrContext) {
  __webpack_require__("sOc5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_disabled_outcome_v2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4536ead8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_disabled_outcome_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tUhF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers,on:{"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseLeave}},[(_vm.layout === 'inline')?[_c('span',{staticClass:"button-price__text"},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])]:[_c('span',{staticClass:"button-price__text"},[_vm._v("\n      "+_vm._s(_vm.text)+" "),(_vm.price > 0)?_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.price),expression:"price",modifiers:{"cents":true}}],staticClass:"button-price__text--bold"}):_vm._e()]),_vm._v(" "),(_vm.showWinOrSell)?[_c('transition',{attrs:{"name":"button-price"}},[(_vm.hovered || _vm.active)?_c('span',{staticClass:"button-price__price"},[(_vm.isSell)?_c('span',{staticClass:"button-price__price-alt"},[_vm._v("\n            Sell: "+_vm._s(_vm.sell)+"¢\n          ")]):(_vm.isWin && _vm.price > 0)?_c('span',{staticClass:"button-price__price-alt"},[_vm._v("\n            Win: "+_vm._s(_vm.multiple)+"X\n          ")]):(_vm.isWin && _vm.price === 0)?_c('span',{staticClass:"button-price__price-alt"},[_vm._v("\n            Set the Market\n          ")]):_vm._e()]):_vm._e()])]:_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tV9q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "tWDM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_userAgent__ = __webpack_require__("GZXJ");
/* eslint no-underscore-dangle: ["error", { "allow": ["_e"] }] */


var noopTwitter = { ready: function ready() {} };

var init = false;

function twitter() {
  if (__WEBPACK_IMPORTED_MODULE_0__mixins_userAgent__["h" /* isWrapperApp */]) {
    return noopTwitter;
  }

  if (init) {
    return window.twttr;
  }

  window.twttr = function (d, s, id) {
    var fjs = d.getElementsByTagName(s)[0];
    var t = {};
    var js = d.createElement(s);
    js.id = id;
    js.src = 'https://platform.twitter.com/widgets.js';
    fjs.parentNode.insertBefore(js, fjs);

    t._e = [];
    t.ready = function (f) {
      t._e.push(f);
    };
    return t;
  }(document, 'script', 'twitter-wjs');

  init = true;
  return window.twttr;
}

/* harmony default export */ __webpack_exports__["a"] = (twitter);

/***/ }),

/***/ "tdTh":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tdTh";

/***/ }),

/***/ "tel1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialsLoader_vue__ = __webpack_require__("H1Lz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6621e2b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialsLoader_vue__ = __webpack_require__("5XgW");
function injectStyle (ssrContext) {
  __webpack_require__("2LR/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialsLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6621e2b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialsLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tjp7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateMarket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateContract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateMarketContracts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateMySharesMarket; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__ = __webpack_require__("a0yF");



var updateMarket = function updateMarket(market, data) {
  if (market.marketId === data.MarketId) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["U" /* updateObjectValues */])(market, data, __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["o" /* MARKET_DATA_MAP */]);
  }
  return market;
};

var updateContract = function updateContract(contract, data) {
  if (contract.contractId === data.ContractId) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["U" /* updateObjectValues */])(contract, data, __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["p" /* CONTRACT_DATA_MAP */]);
  }
  return contract;
};

var updateMarketContracts = function updateMarketContracts(market, data) {
  if (market.contracts) {
    market.contracts = market.contracts.map(function (contract) {
      return updateContract(contract, data);
    });
  }
  if (market.marketContracts) {
    market.marketContracts = market.marketContracts.map(function (contract) {
      return updateContract(contract, data);
    });
  }
  return market;
};

var updateMySharesMarket = function updateMySharesMarket(market, data) {
  if (market.marketId === data.MarketId) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["U" /* updateObjectValues */])(market, data, __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["q" /* MY_SHARES_MARKET_DATA_MAP */]);
  }
  return market;
};

/***/ }),

/***/ "tkA1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isChunkLoadError */
/* harmony export (immutable) */ __webpack_exports__["c"] = reloadOnChunkError;
/* unused harmony export deferReloadOnChunkError */
/* harmony export (immutable) */ __webpack_exports__["b"] = consumePendingChunkReload;
/* harmony export (immutable) */ __webpack_exports__["d"] = lazyWithReload;
/* harmony export (immutable) */ __webpack_exports__["a"] = lazyComponents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var RELOAD_KEY = 'chunkReloadAt';
var PENDING_RELOAD_KEY = 'chunkReloadPending';
var RELOAD_THROTTLE_MS = 10000;
var CHUNK_FAILED = /Loading( CSS)? chunk [\w-]+ failed/i;

function isChunkLoadError(error) {
  return !!error && CHUNK_FAILED.test(error && error.message || '');
}

function doReload() {
  var last = parseInt(window.sessionStorage.getItem(RELOAD_KEY) || '0', 10);
  if (Date.now() - last <= RELOAD_THROTTLE_MS) return false;

  window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  window.location.reload();
  return true;
}

// Used for vue-router's onError: the user just navigated somewhere that
// depends on a stale chunk (e.g. after a deploy rotated the build's chunk
// hashes), so there's no unrelated in-progress interaction to interrupt.
function reloadOnChunkError(error) {
  if (!isChunkLoadError(error)) return false;
  doReload();
  return true;
}

// Used for lazy components loaded outside of navigation (modals, background
// widgets that can pop up seconds after the page already rendered). Reloading
// immediately here would yank the user out of whatever they're doing, so just
// remember the stale build and let the next real navigation do the reload.
function deferReloadOnChunkError(error) {
  if (!isChunkLoadError(error)) return false;
  window.sessionStorage.setItem(PENDING_RELOAD_KEY, '1');
  return true;
}

// Call from the router's navigation guard so a deferred reload happens at a
// natural transition point instead of mid-interaction.
function consumePendingChunkReload() {
  if (window.sessionStorage.getItem(PENDING_RELOAD_KEY) !== '1') return;
  if (doReload()) {
    window.sessionStorage.removeItem(PENDING_RELOAD_KEY);
  }
}

// Wraps a dynamic-import factory (e.g. `() => import('./x.vue')`) so a failed
// chunk fetch triggers the deferred reload guard. Re-throws so Vue does not
// try to render a broken async component. Use for lazy Vue components (async
// component load failures are not surfaced through vue-router's onError).
function lazyWithReload(loader) {
  return function () {
    return loader().catch(function (error) {
      deferReloadOnChunkError(error);
      throw error;
    });
  };
}

// Wraps every value of a { name: () => import(...) } map with lazyWithReload.
function lazyComponents(map) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(map).reduce(function (acc, key) {
    acc[key] = lazyWithReload(map[key]);
    return acc;
  }, {});
}

/***/ }),

/***/ "tmS5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var upperCaseOptions = ['yes', 'no'];

function setContractName(el) {
  var text = el.textContent.trim();
  if (upperCaseOptions.includes(text.toLowerCase())) {
    el.textContent = text.toUpperCase();
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el) {
    setContractName(el);
  },
  update: function update(el) {
    setContractName(el);
  }
});

/***/ }),

/***/ "trS8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"nav-browse__container"},[(_vm.showSidebarToggle)?_c('button',{class:['nav-browse__sidebar-toggle', { 'nav-browse__sidebar-toggle--active': _vm.sidebarVisible }],on:{"click":_vm.toggleSidebar}},[_c('sidebar-icon')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"nav-browse__slide nav-browse__slide--categories"},[_c('div',{staticClass:"nav-browse__item"},[_c('span',{staticClass:"nav-browse__link nav-browse__link--categories",on:{"click":_vm.toggleCategoriesLabel}},[_c('span',{class:_vm.categoriesIcon}),_vm._v(" "),_c('transition',{attrs:{"name":"nav-browse"}},[(_vm.isCategoriesLabelVisible)?_c('span',{staticClass:"nav-browse__link-text nav-browse__link-text--categories"},[_vm._v("Categories:")]):_vm._e()])],1)])]),_vm._v(" "),_vm._l((_vm.externalBrowseHeaders),function(item){return _c('div',{key:item.headerId,staticClass:"nav-browse__slide"},[_c('div',{staticClass:"nav-browse__item"},[(item.name)?_c('router-link',{staticClass:"nav-browse__link",attrs:{"to":{name: item.name}}},[(item.icon)?_c('span',{class:_vm.iconClassModifiers(item)}):_vm._e(),_vm._v(" "),_c('h2',[_vm._v(_vm._s(item.title))])]):(item.href)?_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],staticClass:"nav-browse__link",attrs:{"href":item.href}},[(item.icon)?_c('span',{class:_vm.iconClassModifiers(item)}):_vm._e(),_vm._v(" "),_c('h2',[_vm._v(_vm._s(item.title))])]):_vm._e()],1)])}),_vm._v(" "),(_vm.isLayoutMobile)?_c('div',{staticClass:"nav-browse__slide"},[_c('div',{staticClass:"nav-browse__item"},[_c('router-link',{staticClass:"nav-browse__link",class:{'router-link-exact-active': _vm.isAllMarketsLinkActive},attrs:{"to":{name: 'market-list', params: {headerId: 'all'}}}},[_c('h2',[_vm._v("All")])])],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.categoryBrowseHeaders),function(item){return _c('div',{key:item.headerId,staticClass:"nav-browse__slide"},[_c('div',{staticClass:"nav-browse__item"},[_c('router-link',{staticClass:"nav-browse__link",attrs:{"to":{name: 'market-list', params: {headerId: item.headerId, headerUrl: item.headerUrl}}}},[_c('h2',[_vm._v(_vm._s(item.name))])])],1)])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tumW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_twitter_twitter__ = __webpack_require__("tWDM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");






function styleTwitterTimeline($content) {
  if ($content) {
    var style = document.createElement('style');
    style.innerHTML += 'a {color:#67999f;}';
    style.innerHTML += '.timeline-Widget {padding:19px 13px;}';
    style.innerHTML += '.timeline-Header {margin-bottom:9px;padding:0;}';
    style.innerHTML += '.timeline-Header-title {color:#263b3f;font-size:26px;line-height:17px;letter-spacing:0.03em;font-weight:500;}';
    style.innerHTML += '.timeline-Header-byline {color:#263b3f;}';
    style.innerHTML += '.SandboxRoot.env-bp-430 .timeline-Tweet-text {font-size:14px;line-height:18px;font-weight:500;color:#263b3f;}';
    style.innerHTML += '.timeline-TweetList-tweet {border-top:1px solid #b8c5c6;}';
    style.innerHTML += '.timeline-Body {border-top:1px solid #b8c5c6;border-bottom:1px solid #b8c5c6;}';
    var head = $content.getElementsByTagName('head');

    if (head && head.length > 0) {
      head[0].appendChild(style);
    }
  }
}

function createTimeline(twt, el) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var width = window.innerWidth > 0 ? window.innerWidth : screen.width;

  var options = {
    chrome: 'nofooter'
  };

  if (width <= 320) {
    options.width = 300;
  }

  if (limit !== -1) options.tweetLimit = limit;
  twt.widgets.createTimeline({
    sourceType: 'profile',
    screenName: "PredictIt"
  }, el, options).then(function (iframeEl) {
    if (!iframeEl) return;
    // const $content = iframeEl.contentDocument;
    // styleTwitterTimeline($content);

    if (callback !== null && typeof callback === 'function') {
      callback();
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    inOverlay: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    },
    numTweets: {
      type: Number,
      default: 6
    }
  },
  data: function data() {
    return {
      identifier: +new Date(),
      loading: false,
      ready: false,
      hideFooter: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isShutdownModeOn']), {
    getMoreTweetsLabel: function getMoreTweetsLabel() {
      return this.isLayoutDesktop ? 'More Tweets' : 'Load more';
    },
    classModifiers: function classModifiers() {
      return {
        twittertimeline: true,
        'twittertimeline--loading': this.loading
      };
    },
    initClassModifiers: function initClassModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'twittertimeline__iframe-wrapper': true
      }, 'twittertimeline__iframe-wrapper--' + this.identifier, this.identifier);
    },
    contentClassModifiers: function contentClassModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        twittertimeline__content: true,
        'twittertimeline__content--shutdown': this.isShutdownModeOn
      }, 'twittertimeline__content--' + this.theme, this.theme);
    },
    showFooter: function showFooter() {
      return !this.inOverlay && !this.hideFooter;
    },
    tweetLimit: function tweetLimit() {
      return !this.inOverlay ? this.numTweets : undefined;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onFooterMoreButtonClick: function onFooterMoreButtonClick(e) {
      var _this = this;

      e.stopPropagation();
      if (this.isLayoutDesktop) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_modals_constants__["a" /* MODALS */].TWITTER);
      } else {
        this.loading = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_twitter_twitter__["a" /* default */])().ready(function (twt) {
          return createTimeline(twt, _this.$refs.more, undefined, function () {
            _this.loading = false;
            _this.hideFooter = true;
            _this.$refs.init.remove();
          });
        });
      }
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.loading = true;
    setTimeout(function () {
      _this2.loading = false;
    }, 5000);
    this.$nextTick(function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_twitter_twitter__["a" /* default */])().ready(function (twt) {
        twt.events.bind('loaded', function () {
          _this2.loading = false;
          _this2.ready = true;
        });
        createTimeline(twt, _this2.$refs.init, _this2.tweetLimit, function () {
          _this2.loading = false;
        });
      });
    });
  }
});

/***/ }),

/***/ "tvM0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvXx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-detail-page-loader"},[_c('div',{staticClass:"market-detail-page-loader__content"},[_c('div',{staticClass:"market-detail-page-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"market-detail-page-loader__text-2"}),_vm._v(" "),_c('div',{staticClass:"market-detail-page-loader__text-3"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tyTh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_shares_ownership_js__ = __webpack_require__("nfG2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2ab5582_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_shares_ownership_vue__ = __webpack_require__("gTKa");
function injectStyle (ssrContext) {
  __webpack_require__("tLet")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_shares_ownership_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2ab5582_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_shares_ownership_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u0d3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var support = function support() {
  return Promise.all/* import() */([__webpack_require__.e(1), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "0fv4"));
};
var helpAndSupport = function helpAndSupport() {
  return Promise.all/* import() */([__webpack_require__.e(1), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "wv8k"));
};
var learnTheBasics = function learnTheBasics() {
  return Promise.all/* import() */([__webpack_require__.e(1), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "imzz"));
};
var communityForums = function communityForums() {
  return Promise.all/* import() */([__webpack_require__.e(1), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "r78W"));
};
var faq = function faq() {
  return Promise.all/* import() */([__webpack_require__.e(1), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "ZIhC"));
};
var whatIsPredictIt = function whatIsPredictIt() {
  return Promise.all/* import() */([__webpack_require__.e(1), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "CCA8"));
};
var videos = function videos() {
  return Promise.all/* import() */([__webpack_require__.e(1), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "HSd1"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/support',
  component: support,
  props: true,
  children: [{
    path: '',
    name: 'HelpAndSupport',
    component: helpAndSupport,
    props: true
  }, {
    path: 'what-is-predictit',
    name: 'WhatIsPredictIt',
    component: whatIsPredictIt,
    props: true
  }, {
    path: 'how-to-trade-on-predictit',
    name: 'LearnTheBasics',
    component: learnTheBasics,
    props: true
  }, {
    path: 'community-forums',
    name: 'ComunityForums',
    component: communityForums,
    props: true
  }, {
    path: 'faq',
    name: 'Faq',
    component: faq,
    props: true
  }, {
    path: 'videos',
    name: 'Videos',
    component: videos,
    props: true
  }]
}]);

/***/ }),

/***/ "u9HT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_userDetails__ = __webpack_require__("jtWA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_socialLevel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_userDetails__["a" /* default */]],
  props: {
    widget: Object
  },
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    return {
      swiperOptions: {
        loop: true,
        autoplay: 5000,
        slidesPerGroup: 2,
        slidesPerView: 2,
        slidesPerColumn: 1,
        spaceBetween: 0,
        breakpoints: {
          768: {
            slidesPerGroup: 1,
            slidesPerView: 1,
            slidesPerColumn: 2
          }
        }
      }
    };
  },

  computed: {
    obj: function obj() {
      return this.widget ? this.widget : {};
    },
    traderCount: function traderCount() {
      return this.widget ? this.widget.activeTraderCount.toLocaleString('en-US') : '';
    },
    traders: function traders() {
      return this.obj.traders;
    }
  },
  watch: {
    widget: function widget(val) {
      if (val) {
        this.loaderRemove();
      }
    }
  },
  methods: {
    traderLevelDisplay: function traderLevelDisplay(item) {
      var level = this.getLevelByPredictions(item.profitablePredictions);
      return 'Level ' + level.num + ' (' + level.text + ')';
    },
    priceClassModifiers: function priceClassModifiers() {
      return {
        'market-currently-predicting__price': true
        // 'market-currently-predicting__price--multiple': !this.isMarketSingle(market),
        // 'market-currently-predicting__price--single': this.isMarketSingle(market),
      };
    },
    isMarketSingle: function isMarketSingle(market) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["k" /* isMarketSingle */])(market);
    },
    boughtSold: function boughtSold(type) {
      return type < 2 ? 'Bought' : 'Sold';
    },
    yesNo: function yesNo(type) {
      return type % 2 === 0 ? 'No' : 'Yes';
    },
    classModifier: function classModifier(type) {
      return {
        'market-currently-predicting__type': true,
        'market-currently-predicting__type--no': type % 2 === 0
      };
    },
    onClick: function onClick(pred) {
      if (pred.marketId) {
        this.$router.push({
          name: 'market-details',
          params: { marketId: pred.marketId, marketUrl: pred.marketUrl }
        });
      }
    }
  },
  mounted: function mounted() {
    if (!this.widget) {
      this.loaderAdd();
    }
  }
});

/***/ }),

/***/ "uBho":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDSN":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNSIgaGVpZ2h0PSIzNSIgdmlld0JveD0iMCAwIDM1IDM1Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTYuNSIgY3k9IjE2LjUiIHI9IjE3IiBzdHJva2U9IiM4M0M1NjgiIGZpbGw9IiM4M0M1NjgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMjUuMjYgMTMuNTUzbC04LjkxIDkuMTI1YTEuNDQyIDEuNDQyIDAgMCAxLTIuMDc1IDBsLTMuNzIyLTMuODFhMS41MzIgMS41MzIgMCAwIDEgMC0yLjEyNyAxLjQ0NCAxLjQ0NCAwIDAgMSAyLjA3NSAwbDIuNjg1IDIuNzUgNy44NzItOC4wNjNhMS40NDIgMS40NDIgMCAwIDEgMi4wNzYgMCAxLjUyNyAxLjUyNyAwIDAgMSAwIDIuMTI1Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "uEEg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uHZs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    cardMasked: {
      type: String,
      default: ''
    },
    amount: {
      type: [String, Number],
      default: 0
    },
    feePercent: {
      type: Number,
      required: true
    },
    feeAmount: {
      type: [String, Number],
      default: '0.00'
    },
    wasFeeDiscountApplied: {
      type: Boolean,
      default: false
    },
    isFeeWaived: {
      type: Boolean,
      default: false
    },
    feeFreeAmount: {
      type: Number,
      default: 0
    },
    feeCap: {
      type: Number,
      default: null
    },
    hasPromo: {
      type: Boolean,
      default: false
    },
    promotionalCreditAmount: {
      type: [String, Number],
      default: null
    },
    promoCode: {
      type: String,
      default: ''
    },
    promoBonus: {
      type: [String, Number],
      default: '0.00'
    },
    separateCreditCode: {
      type: String,
      default: ''
    },
    separateCreditAmount: {
      type: [String, Number],
      default: 0
    },
    totalToWallet: {
      type: [String, Number],
      default: '0.00'
    },
    arrivesText: {
      type: String,
      default: 'Instant'
    }
  },
  computed: {
    hasPromotionalCredit: function hasPromotionalCredit() {
      return this.promotionalCreditAmount !== '0.00' && this.promotionalCreditAmount !== 0 && this.promotionalCreditAmount !== null;
    },
    hasSeparateCredit: function hasSeparateCredit() {
      return Number(this.separateCreditAmount) > 0;
    },
    formattedAmount: function formattedAmount() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["H" /* formatUsdValue */])(this.amount);
    },
    hasFeeSplit: function hasFeeSplit() {
      return this.wasFeeDiscountApplied && Number(this.feeAmount) > 0;
    },
    freeTierAmount: function freeTierAmount() {
      return Math.min(Number(this.amount), Number(this.feeFreeAmount));
    },
    formattedFreeTierAmount: function formattedFreeTierAmount() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["H" /* formatUsdValue */])(this.freeTierAmount);
    },
    formattedFirstAmountFree: function formattedFirstAmountFree() {
      if (this.hasFeeSplit) {
        return this.formattedFreeTierAmount;
      }
      return this.formattedAmount;
    },
    overLimitAmount: function overLimitAmount() {
      return Math.max(0, Number(this.amount) - this.freeTierAmount);
    },
    formattedOverLimitAmount: function formattedOverLimitAmount() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["H" /* formatUsdValue */])(this.overLimitAmount);
    },
    formattedGrossAmount: function formattedGrossAmount() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["H" /* formatUsdValue */])(this.amount);
    },
    formattedPromotionalCredit: function formattedPromotionalCredit() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["H" /* formatUsdValue */])(this.promotionalCreditAmount);
    },
    formattedSeparateCredit: function formattedSeparateCredit() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["H" /* formatUsdValue */])(this.separateCreditAmount);
    },
    formattedFeeAmount: function formattedFeeAmount() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["H" /* formatUsdValue */])(this.feeAmount);
    },
    formattedTotalToWallet: function formattedTotalToWallet() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["H" /* formatUsdValue */])(this.totalToWallet);
    },
    overLimitFeeLabel: function overLimitFeeLabel() {
      if (this.feeCap !== null && this.feeCap !== undefined && Number(this.feeCap) > 0) {
        return 'Processing Fee (' + this.feePercent + '%, up to $' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["H" /* formatUsdValue */])(this.feeCap) + ')';
      }
      return 'Processing Fee (' + this.feePercent + '%)';
    },
    feeDiscountMessage: function feeDiscountMessage() {
      if (this.hasFeeSplit) {
        return 'Your first $' + this.formattedFreeTierAmount + ' is fee-free thanks to our FREE FIRST DEPOSIT promotion. The remaining $' + this.formattedOverLimitAmount + ' is charged the standard processing fee.';
      }
      return 'Your $' + this.formattedAmount + ' deposit is fee-free thanks to our FREE FIRST DEPOSIT promotion.';
    }
  }
});

/***/ }),

/***/ "uN8r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_list_header_sushi_js__ = __webpack_require__("zyjZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53208cd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_list_header_sushi_vue__ = __webpack_require__("zTpV");
function injectStyle (ssrContext) {
  __webpack_require__("I4Gm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_list_header_sushi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53208cd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_list_header_sushi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uVqX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_item_trade_confirmed_js__ = __webpack_require__("BmES");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_678b2a5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_trade_confirmed_vue__ = __webpack_require__("87t0");
function injectStyle (ssrContext) {
  __webpack_require__("vJKe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_item_trade_confirmed_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_678b2a5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_trade_confirmed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uZm2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ucfo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketWidgetLoader_vue__ = __webpack_require__("7Ymm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e23c9c30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketWidgetLoader_vue__ = __webpack_require__("UTL5");
function injectStyle (ssrContext) {
  __webpack_require__("DIeW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketWidgetLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e23c9c30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketWidgetLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ucfx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TAB_SEVEN_DAYS */
/* unused harmony export TAB_THIRTY_DAYS */
/* unused harmony export TAB_NINETY_DAYS */
/* unused harmony export TAB_TWENTY_FOUR_HOURS */
/* unused harmony export TAB_RANGE */
/* unused harmony export TAB_STATS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_generics_modal_small_small_vue__ = __webpack_require__("+CQ6");












var MARKET_OPEN_DAYS_TWENTY_HOUR_CHART = 2;
var TAB_SEVEN_DAYS = '7d';
var TAB_THIRTY_DAYS = '30d';
var TAB_NINETY_DAYS = '90d';
var TAB_TWENTY_FOUR_HOURS = '24h';
var TAB_RANGE = '0';
var TAB_STATS = 'stats';

var TAB_LINE = 'line';
var TAB_CANDLE = 'candle';

var LS_SHOW_VOLUME_CHART = 'showVolumeChart';
var LS_SHOW_PRICE_AXIS_ZOOM = 'showPriceAxisZoom';

var UNIT_OF_TIME_MAP = {
  1: 'h',
  2: 'd'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_loader__["a" /* default */]],
  components: {
    tabs: __WEBPACK_IMPORTED_MODULE_4__components_generics_tabs_tabs_vue__["a" /* default */],
    smallModal: __WEBPACK_IMPORTED_MODULE_9__components_generics_modal_small_small_vue__["default"]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    chartOptions: {
      type: Object,
      default: null
    },
    showVolume: {
      type: Boolean,
      default: false
    },
    showPriceAxisZoom: {
      type: Boolean,
      default: true
    },
    isChartLoading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showVolumeChart: __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get(LS_SHOW_VOLUME_CHART, this.showVolume),
      showPriceAxisZoomValue: __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get(LS_SHOW_PRICE_AXIS_ZOOM, this.showPriceAxisZoom),
      showMenu: false,
      activeTabPeriod: null,
      activeTabType: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    isForStory: function isForStory() {
      return !!__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'cmsStoryId', null);
    },
    tabsPeriodStyleModifiers: function tabsPeriodStyleModifiers() {
      return {};
    },

    /*
    *  Determines which timeframe mode to use. A chart can show a timeframe
    *  in one of two ways:
    *    1) Date Range - data between a start date and end date
    *    2) To Date: data from the last X days/hours to the current date
    */
    useDateRange: function useDateRange() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'useDateRange', false);
    },

    /*
    * "To Date" is a timeframe that shows the last X days/hours of data and is
    * used if not using the "Date Range" timeframe. Each option is formatted
    * {
    *   unit: Number (1 for hour, 2 for days)
    *   quantity: Number (integer representing how many days/hours)
    *   isDefault: Boolean (whether this option should be the default option)
    * }
    * These options will become the period tabs.
    */
    toDateOptions: function toDateOptions() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'toDateAvailableOptions');
    },
    dateRangeUnit: function dateRangeUnit() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'dateRangeUnit');
    },
    showDateRangeTab: function showDateRangeTab() {
      return this.useDateRange && __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'startDate', null) !== null && __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'endDate', null) !== null;
    },
    showToDateTab: function showToDateTab() {
      return !this.useDateRange && this.toDateOptions && this.toDateOptions.length > 0;
    },
    defaultRangeTab: function defaultRangeTab() {
      var suffix = this.dateRangeUnit ? UNIT_OF_TIME_MAP[this.dateRangeUnit] : 'd';
      return { name: '' + TAB_RANGE + suffix, title: null, icon: 'calendar' };
    },
    defaultToDateTab: function defaultToDateTab() {
      var defaultToDateOption = this.showToDateTab ? this.toDateOptions.find(function (option) {
        return option.isDefault;
      }) || this.toDateOptions[0] : null;
      return this.tabFromToDateOption(defaultToDateOption);
    },
    tabsPeriod: function tabsPeriod() {
      var _this = this;

      var items = [];

      if (this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'include24hr', false)) {
        items.push({ name: TAB_TWENTY_FOUR_HOURS, title: '24h' });
      }
      if (this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'include7day', false)) {
        items.push({ name: TAB_SEVEN_DAYS, title: '7d' });
      }
      if (this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'include30day', false)) {
        items.push({ name: TAB_THIRTY_DAYS, title: '30d' });
      }
      if (this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'include90day', false)) {
        items.push({ name: TAB_NINETY_DAYS, title: '90d' });
      }

      if (this.showDateRangeTab) {
        items.push(this.defaultRangeTab);
      } else if (this.showToDateTab) {
        this.toDateOptions.forEach(function (option) {
          return items.push(_this.tabFromToDateOption(option));
        });
      }
      return items;
    },
    tabsType: function tabsType() {
      var items = [];
      if (this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'includeCandle', false)) {
        items.push({ name: TAB_CANDLE, title: 'Candle' });
      }
      if (this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'includeLine', false)) {
        items.push({ name: TAB_LINE, title: 'Line' });
      }
      return items;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setGenericPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('market', ['setChartTimeline', 'getMarketContractsStats', 'setChartType']), {
    onOpenSettings: function onOpenSettings() {
      this.showMenu = !this.showMenu;
    },
    onClickOutside: function onClickOutside() {
      this.showMenu = false;
    },
    onOpenStats: function onOpenStats() {
      var _this2 = this;

      if (this.isChartLoading) {
        return;
      }
      this.loaderAdd(document.body);
      this.showMenu = false;
      this.getMarketContractsStats(this.market.marketId).then(function (data) {
        _this2.loaderRemove(document.body);
        _this2.setGenericPopup({
          name: 'market-contracts-stats',
          options: {
            stats: data,
            isFixed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["u" /* hasMarketHiddenContracts */])(_this2.market)
          }
        });
      }).catch(function () {
        return _this2.loaderRemove(document.body);
      });
    },
    tabChangePeriod: function tabChangePeriod(name) {
      if (this.isChartLoading) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_8__logger__["a" /* default */].info('[CHART][TIMELINE] tabChangePeriod to ' + name + ' for ' + this.market.marketId);
      this.activeTabPeriod = name;
      this.setChartTimeline(name);
      this.$emit('timelineChange', this.activeTabPeriod);
    },
    tabChangeType: function tabChangeType(name) {
      if (this.isChartLoading) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_8__logger__["a" /* default */].info('[CHART][TIMELINE] tabChangeType to ' + name + ' for ' + this.market.marketId);
      this.activeTabType = name;
      this.setChartType(name);
      this.$emit('typeChange', this.activeTabType);
    },
    tabsPeriodHandler: function tabsPeriodHandler(items) {
      var dateOpenedDayDiff = __WEBPACK_IMPORTED_MODULE_3_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.market.dateOpened), 'days');
      var activeTabPeriod = dateOpenedDayDiff < MARKET_OPEN_DAYS_TWENTY_HOUR_CHART ? TAB_TWENTY_FOUR_HOURS : TAB_SEVEN_DAYS;
      if (this.showDateRangeTab) {
        activeTabPeriod = this.defaultRangeTab.name;
      } else if (this.showToDateTab) {
        activeTabPeriod = this.defaultToDateTab.name;
      }

      var activeTab = items.find(function (tab) {
        return tab.name === activeTabPeriod;
      });
      if (activeTab) {
        this.activeTabPeriod = activeTabPeriod;
      } else if (items.length > 0) {
        this.activeTabPeriod = items[0].name;
      }
    },
    tabsTypeHandler: function tabsTypeHandler(value) {
      if (!value || value.length === 0) return;
      if (value.find(function (i) {
        return i.name === TAB_LINE;
      })) {
        this.activeTabType = TAB_LINE;
      } else {
        this.activeTabType = value[0].name;
      }
    },
    tabFromToDateOption: function tabFromToDateOption(toDateOption) {
      if (toDateOption) {
        var name = '' + toDateOption.quantity + UNIT_OF_TIME_MAP[toDateOption.unit];
        var title = name;
        return { name: name, title: title };
      }
      return {};
    },
    onVolumeChartToggle: function onVolumeChartToggle() {
      if (this.isChartLoading) {
        return;
      }
      this.showVolumeChart = !this.showVolumeChart;
      __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].set(LS_SHOW_VOLUME_CHART, this.showVolumeChart);
      this.$emit('volumeChartToggle', this.showVolumeChart);
    },
    onPriceAxisZoomToggle: function onPriceAxisZoomToggle() {
      if (this.isChartLoading) {
        return;
      }
      this.showPriceAxisZoomValue = !this.showPriceAxisZoomValue;
      __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].set(LS_SHOW_PRICE_AXIS_ZOOM, this.showPriceAxisZoomValue);
      this.$emit('priceAxisZoomToggle', this.showPriceAxisZoomValue);
    }
  }),
  watch: {
    tabsPeriod: {
      handler: 'tabsPeriodHandler',
      immediate: true
    },
    tabsType: {
      handler: 'tabsTypeHandler',
      immediate: true
    }
  },
  mounted: function mounted() {
    this.$emit('volumeChartToggle', this.showVolumeChart);
    this.$emit('priceAxisZoomToggle', this.showPriceAxisZoomValue);
    __WEBPACK_IMPORTED_MODULE_8__logger__["a" /* default */].info('[CHART][TIMELINE] got ' + this.tabsPeriod.length + ' period tabs and ' + this.tabsType.length + ' type tabs for ' + this.market.marketId);
  }
});

/***/ }),

/***/ "uo5Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__ = __webpack_require__("BL43");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__["a" /* default */]],
  props: {
    showIcons: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    classModifiers: function classModifiers() {
      return {
        'app-bottom-nav': true,
        'app-bottom-nav--logged-in': this.isLoggedIn
      };
    },
    enabledLinks: function enabledLinks() {
      return this.links.filter(function (i) {
        return i.enabled;
      });
    },
    links: function links() {
      if (this.isLoggedIn) {
        return [{
          title: 'Markets',
          name: 'markets',
          href: '/markets',
          enabled: true
        }, {
          title: 'Dashboard',
          name: 'dashboard',
          href: '/dashboard',
          enabled: true
        }, {
          title: 'Account',
          name: 'account',
          href: this.accountLink,
          enabled: true
        }];
      }

      return [{
        title: 'Markets',
        name: 'markets',
        href: '/markets',
        enabled: true
      }, {
        title: 'News',
        name: 'news',
        href: '/news',
        enabled: true
      }, {
        title: 'Learn',
        name: 'help',
        href: '/support',
        enabled: true
      }];
    }
  }),
  methods: {
    itemClassModifier: function itemClassModifier(item) {
      return {
        'app-bottom-nav__item': true,
        'app-bottom-nav__item--active': this.$route.path.includes(item.href),
        'app-bottom-nav__item--logged-in': this.isLoggedIn
      };
    },
    linkClassModifiers: function linkClassModifiers(name) {
      var _ref;

      var routes = ['market-details'];
      var dontHighlight = routes.includes(this.$route.name);
      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'app-bottom-nav__link-with-icon app-bottom-nav__link-with-icon--' + name, this.showIcons), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'app-bottom-nav__link--no-highlight', dontHighlight), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'app-bottom-nav__link', true), _ref;
    },
    showSocialAvatarOnMobile: function showSocialAvatarOnMobile(item) {
      return this.isLayoutMobile && item.name === 'dashboard' && this.isLoggedIn;
    },
    showRegularItem: function showRegularItem(item) {
      return this.isLayoutMobile ? item.name !== 'dashboard' : true;
    },
    onAvatarClick: function onAvatarClick() {
      this.$router.push({ name: 'portfolio' });
    },
    onLinkClick: function onLinkClick(href) {
      // scroll page to top if link is clicked again
      if (this.$route && this.$route.path === href) {
        window.scrollTo(0, 0);
      }
    }
  }
});

/***/ }),

/***/ "uqrF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "usGF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "utJg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonClass,attrs:{"data-tooltip":_vm.saleDisabled ? _vm.disabledTooltip : null},on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_c('button-price',{key:_vm.price,staticClass:"market-button-direction__price",attrs:{"price":_vm.price,"text":_vm.text,"win":_vm.win,"sell":_vm.sell,"active":_vm.isActive}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v01n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MARKET_CONTRACT_INFO_VALUES_LAYOUT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_winner_v2_market_winner_v2_vue__ = __webpack_require__("q1K7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_dataLayer__ = __webpack_require__("k37b");










var MARKET_CONTRACT_INFO_VALUES_LAYOUT = {
  BLANK: 'blank',
  BLANK_DETAILED: 'blank-detailed',
  CONTRACTS_SUMMARY: 'contracts-summary'
};

/* harmony default export */ __webpack_exports__["b"] = ({
  props: {
    market: {
      type: Object,
      required: false,
      default: null
    },
    contract: {
      type: Object,
      required: false,
      default: null
    },
    image: {
      type: String,
      required: false,
      default: null
    },
    link: {
      required: false,
      default: null
    },
    layout: {
      type: String,
      default: MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK
    },
    addFakeContracts: {
      type: Boolean,
      default: true
    },
    marketId: {},
    contractId: {},
    useCurrentPriceSymbol: {
      type: Boolean,
      default: false // set to true when we want layout to use current price symbol, false by default as its not necesaryy everywhere
    },
    trackingContext: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    marketWinnerV2: __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_winner_v2_market_winner_v2_vue__["a" /* default */],
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_6__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  data: function data() {
    return {
      MARKET_CONTRACT_INFO_VALUES_LAYOUT: MARKET_CONTRACT_INFO_VALUES_LAYOUT
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['currentPriceSymbol']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    isCompactLayout: function isCompactLayout() {
      var layouts = [MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK, MARKET_CONTRACT_INFO_VALUES_LAYOUT.CONTRACTS_SUMMARY];
      return layouts.includes(this.layout);
    },
    isDetailedLayout: function isDetailedLayout() {
      var layouts = [MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK_DETAILED];
      return layouts.includes(this.layout);
    },
    marketContracts: function marketContracts() {
      if (!this.market || !this.market.contracts) return [];
      var results = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(this.market.contracts || []);
      if (!results) return [];

      /* Add fake copy of a contract that represents NO contracts */
      var names = ['Yes', 'No'];
      if (this.addFakeContracts && results.length === 1 && names.includes(this.getContractName(results[0]))) {
        var noContract = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ noContract: true }, results[0]);
        results.push(noContract);
      }

      return results;
    },
    imageUrl: function imageUrl() {
      if (this.image !== null) {
        return this.image;
      }
      if (this.contract !== null) {
        return this.contract.contractImageUrl;
      }

      if (this.market !== null) {
        return this.market.marketImageUrl;
      }
      return null;
    },
    imageStyleModifiers: function imageStyleModifiers() {
      if (this.imageUrl !== null) {
        return {
          'background-image': 'url(\'' + this.imageUrl + '\')'
        };
      }
      return {};
    },
    title: function title() {
      if (this.contract !== null) {
        return this.contract;
      }

      if (this.market !== null) {
        return this.market.marketName;
      }

      return '';
    },
    isMarketSingle: function isMarketSingle() {
      return this.market !== null && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["k" /* isMarketSingle */])(this.market);
    },
    detailsLink: function detailsLink() {
      if (this.link) return this.link;
      if (this.market !== null) {
        return {
          name: 'market-details',
          params: { marketId: this.market.marketId }
        };
      }
      if (this.marketId !== null) {
        var query = {};
        if (this.contractId !== null) {
          query.contractId = this.contractId;
        }
        return {
          name: 'market-details',
          params: { marketId: this.marketId },
          query: query
        };
      }
      return '';
    },
    priceSymbol: function priceSymbol() {
      return this.useCurrentPriceSymbol ? this.currentPriceSymbol : undefined;
    }
  }),
  methods: {
    getContactInstance: function getContactInstance(data) {
      return new __WEBPACK_IMPORTED_MODULE_5__models_contract__["a" /* default */](data);
    },
    getContractName: function getContractName(data) {
      return data.contractShortName || data.contractName || data.name;
    },
    contractTitle: function contractTitle(data) {
      if (!this.isMarketSingle) {
        return this.getContractName(data);
      }
      return data.noContract ? 'No' : 'Yes';
    },
    contractPrice: function contractPrice(data) {
      var instance = this.getContactInstance(data);
      var lastPrice = instance.lastTradePriceAsCents;
      if (!instance.hasLastTradePrice) {
        return 0;
      }
      if (data.noContract) {
        return 100 - lastPrice;
      }
      return lastPrice;
    },
    contractHasLastTradePrice: function contractHasLastTradePrice(data) {
      var instance = this.getContactInstance(data);
      return instance.hasLastTradePrice;
    },
    contractChanePrice: function contractChanePrice(data) {
      var instance = this.getContactInstance(data);
      if (!instance.hasLastTradePrice) {
        return 0;
      }
      var price = instance.changePriceAsCents;
      return data.noContract ? -price : price;
    },
    contractLastClosePrice: function contractLastClosePrice(data) {
      var instance = this.getContactInstance(data);
      return instance.lastClosePrice;
    },
    contractKey: function contractKey(contract) {
      var suffix = contract.noContract ? 'no' : 'yes';
      return contract.contractId + '-' + suffix;
    },
    fireContractPriceListClick: function fireContractPriceListClick() {
      if (!this.trackingContext.storyId) return;
      var payload = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        interactionType: __WEBPACK_IMPORTED_MODULE_8__helpers_dataLayer__["e" /* INTERACTION_TYPE */].CONTRACT_CURRENT_PRICE_LIST
      }, this.trackingContext);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_dataLayer__["d" /* pushStoryInteraction */])(payload);
    }
  }
});

/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v4/W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contract-list-v2-embed-compact"},[_c('div',{staticClass:"market-contract-list-v2-embed-compact__title"},[_vm._v(_vm._s(_vm.items[0].marketName))]),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('div',{key:("market-contract-list-v2-embed-compact-" + index + "-" + (item.marketId)),staticClass:"market-contract-info-v2__widget-item"},[_c('market-contract-info-v2',{attrs:{"image":item.image,"link":_vm.itemLink(item),"trackingContext":_vm.trackingContext,"layout":_vm.MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"market-contract-info-v2__row"},[_c('div',{directives:[{name:"contract-name",rawName:"v-contract-name"}],staticClass:"market-contract-info-v2__value-light market-contract-list-v2-embed-compact__contract-name"},[_vm._v(_vm._s(item.contractName))]),_vm._v(" "),_c('div',{staticClass:"market-contract-info-v2__value-light-darker market-contract-info-v2--mono"},[_c('market-change-price',{attrs:{"price":item.price,"lastClosePrice":item.lastClosePrice}}),_vm._v(" "),(item.hasLastTradePrice)?[_c('animated-number',{staticClass:"market-contract-list-v2-embed-compact__item-price-box",attrs:{"value":item.priceAsCents}})]:[_c('span',{staticClass:"market-contract-list-v2-embed-compact__item-price-box"},[_vm._v("NEW")])]],2)])]},proxy:true}],null,true)})],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vEia":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"nav-browse-categories-overlay"}},[(_vm.showNavBrowseOverlay)?_c('div',{staticClass:"nav-browse-categories-overlay"},[_c('div',{staticClass:"nav-browse-categories-overlay__content",on:{"click":_vm.closeOverlay}},[_c('div',{staticClass:"nav-browse-categories-overlay__title"},[_vm._v("\n        Market Categories\n      ")]),_vm._v(" "),_c('div',{staticClass:"nav-browse-categories-overlay__items"},[_c('router-link',{staticClass:"nav-browse-categories-overlay__item",attrs:{"to":{name: 'market-list', params: {headerId: 'all'}}},on:{"click":_vm.closeOverlay}},[_vm._v("\n              All\n            ")]),_vm._v(" "),_vm._l((_vm.userBrowseHeaders),function(item){return [(item.external)?[(item.name)?_c('router-link',{key:("overlay-" + (item.headerId)),staticClass:"nav-browse-categories-overlay__item",attrs:{"to":{name: item.name}},on:{"click":_vm.closeOverlay}},[_vm._v("\n              "+_vm._s(item.title)+"\n            ")]):(item.href)?_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],key:("overlay-" + (item.headerId)),staticClass:"nav-browse-categories-overlay__item",attrs:{"href":item.href},on:{"click":_vm.closeOverlay}},[_vm._v("\n               "+_vm._s(item.title)+"\n            ")]):_vm._e()]:_c('router-link',{key:("overlay-" + (item.headerId)),staticClass:"nav-browse-categories-overlay__item",attrs:{"to":{name: 'market-list', params: {headerId: item.headerId, headerUrl: item.headerUrl}}},on:{"click":_vm.closeOverlay}},[_vm._v("\n            "+_vm._s(item.name)+"\n          ")])]})],2)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vGIz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-amount-picker"},[_c('div',{staticClass:"deposit-amount-picker__field-wrapper",class:{
      'deposit-amount-picker__field-wrapper--has-value': !!_vm.value,
      'deposit-amount-picker__field-wrapper--disabled': _vm.disabled
    },on:{"click":function($event){return _vm.$refs.input.focus()}}},[_c('span',{staticClass:"deposit-amount-picker__currency"},[_vm._v("$")]),_vm._v(" "),_c('div',{staticClass:"deposit-amount-picker__input-sizer"},[_c('span',{staticClass:"deposit-amount-picker__input-mirror",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.formattedValue || '0.00'))]),_vm._v(" "),_c('input',{ref:"input",staticClass:"deposit-amount-picker__input",attrs:{"type":"text","disabled":_vm.disabled,"placeholder":"0.00","size":"1","autofocus":""},domProps:{"value":_vm.formattedValue},on:{"input":_vm.handleInput,"blur":function($event){return _vm.$emit('blur')}}})])]),_vm._v(" "),(_vm.hasError)?_c('div',{staticClass:"deposit-amount-picker__error"},[_vm._v("\n    "+_vm._s(_vm.errorMessage)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"deposit-amount-picker__chips"},_vm._l((_vm.depositAmounts),function(amount){return _c('button',{key:amount,staticClass:"deposit-amount-picker__chip",attrs:{"type":"button","disabled":_vm.disabled},on:{"mousedown":function($event){$event.preventDefault();},"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('add', amount)}}},[_c('span',{staticClass:"deposit-amount-picker__chip-icon"}),_vm._v(" $"+_vm._s(amount)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vJHd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



var PROCESSING_TRANSACTION_TIMEOUT = 20;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      timeout: null,
      showTimeout: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['getBalance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    openDepositHistory: function openDepositHistory() {
      this.getBalance();
      this.setCurrentPopup();
      this.$router.push({ name: 'account-history', query: { tabId: 'deposit-withdrawals' } });
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.timeout = setTimeout(function () {
      _this.showTimeout = true;
    }, PROCESSING_TRANSACTION_TIMEOUT * 1000);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
});

/***/ }),

/***/ "vJKe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vJzj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_captcha_captcha_vue__ = __webpack_require__("aDe5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_checkbox_checkbox_vue__ = __webpack_require__("vXhB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_errors_errors_vue__ = __webpack_require__("dimc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_input_input_vue__ = __webpack_require__("UWgA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_radio_radio_vue__ = __webpack_require__("K2ud");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_select_select_vue__ = __webpack_require__("x+uv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_forms_socials_socials_vue__ = __webpack_require__("NqVK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_forms_submit_submit_vue__ = __webpack_require__("GgQs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_forms_textarea_textarea_vue__ = __webpack_require__("3ggI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_forms_password_requirements_password_requirements_vue__ = __webpack_require__("EjHU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_show_password_icon_show_password_icon_vue__ = __webpack_require__("OIiS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_validators__ = __webpack_require__("SVQh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_12__helpers_validators__["a"]; });















var ERROR_GENERIC = 'There was an error processing your request. Please try again.';
var ERROR_UNAUTHORIZED = '401 Unauthorized';
var ERROR_UNAUTHORIZED_MESSAGE = 'This account has been closed.';

var formMixin = {
  components: {
    formCaptcha: __WEBPACK_IMPORTED_MODULE_1__components_forms_captcha_captcha_vue__["default"],
    formCheckbox: __WEBPACK_IMPORTED_MODULE_2__components_forms_checkbox_checkbox_vue__["a" /* default */],
    formErrors: __WEBPACK_IMPORTED_MODULE_3__components_forms_errors_errors_vue__["a" /* default */],
    formInput: __WEBPACK_IMPORTED_MODULE_4__components_forms_input_input_vue__["a" /* default */],
    formRadio: __WEBPACK_IMPORTED_MODULE_5__components_forms_radio_radio_vue__["a" /* default */],
    formSelect: __WEBPACK_IMPORTED_MODULE_6__components_forms_select_select_vue__["a" /* default */],
    formSocials: __WEBPACK_IMPORTED_MODULE_7__components_forms_socials_socials_vue__["a" /* default */],
    formSubmit: __WEBPACK_IMPORTED_MODULE_8__components_forms_submit_submit_vue__["a" /* default */],
    formTextarea: __WEBPACK_IMPORTED_MODULE_9__components_forms_textarea_textarea_vue__["a" /* default */],
    passwordRequirements: __WEBPACK_IMPORTED_MODULE_10__components_forms_password_requirements_password_requirements_vue__["a" /* default */],
    showPasswordIcon: __WEBPACK_IMPORTED_MODULE_11__components_show_password_icon_show_password_icon_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      errors: [],
      fields: {},
      isFormEnabled: true
    };
  },

  computed: {
    isFormDisabled: function isFormDisabled() {
      return this.isFormEnabled === false;
    },
    invalidOrDisabled: function invalidOrDisabled() {
      return this.$v.$invalid || !this.isFormEnabled;
    }
  },
  methods: {
    formIsValid: function formIsValid() {
      return !this.$v.$invalid;
    },
    formEnable: function formEnable() {
      this.isFormEnabled = true;
    },
    formDisable: function formDisable() {
      this.formReset();
      this.isFormEnabled = false;
      return true;
    },
    formReset: function formReset() {
      this.errors = [];
    },
    formHandleErrors: function formHandleErrors(error) {
      var _this = this;

      this.formEnable();
      try {
        if (error && error.response && error.response.data) {
          if (error.response.data instanceof Array) {
            error.response.data.forEach(function (e) {
              return _this.errors.push(e.message);
            });
          } else if (error.response.data.error_description) {
            var description = error.response.data.error_description;
            if (typeof description === 'string') {
              description = JSON.parse(description);
            }
            description.forEach(function (e) {
              return _this.errors.push(e.Message);
            });
          } else if (error.response.data.message) {
            this.errors.push(error.response.data.message);
          } else if (error.response.data.error) {
            if (error.response.data.error === ERROR_UNAUTHORIZED) {
              this.errors.push(ERROR_UNAUTHORIZED_MESSAGE);
            } else {
              this.errors.push(error.response.data.error);
            }
          }
        }
      } catch (e) {
        this.errors.push(ERROR_GENERIC);
      }

      if (__WEBPACK_IMPORTED_MODULE_13__mixins_userAgent__["c" /* isIos */]) {
        this.$el.scrollIntoView(true);
      }
    },
    tabTo: function tabTo(e, next) {
      if (e) {
        if (!this.$refs[next]) return;
        var input = this.$refs[next].$el.getElementsByTagName('input')[0];
        if (input) {
          input.focus();
        }
      }
    }
  }
};


/* unused harmony default export */ var _unused_webpack_default_export = (formMixin);

/***/ }),

/***/ "vXhB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_checkbox_js__ = __webpack_require__("a8vN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b643906_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__ = __webpack_require__("9Z8S");
function injectStyle (ssrContext) {
  __webpack_require__("W4YR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_checkbox_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b643906_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vcCB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers,on:{"click":_vm.onContractClick,"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseLeave}},[_c('div',{staticClass:"market-contract-horizontal-sushi__header"},[_c('div',{staticClass:"market-contract-horizontal-sushi__image-title"},[_c('div',{staticClass:"market-contract-horizontal-sushi__image",style:(_vm.contractImageStyleModifiers)},[(_vm.showSharesBar)?_c('div',{class:_vm.sharesOwnedStyleModifiers}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__title"},[_c('div',{staticClass:"market-contract-horizontal-sushi__title-text"},[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__ownership-buttons"},[(_vm.dashboardMode && _vm.useDesktopLayout)?_c('div',{staticClass:"market-contract-horizontal-sushi__middle-columns"},[(!_vm.forCmsWidget)?[_c('div',{staticClass:"market-contract-horizontal-sushi__type"},[_vm._v("\n            "+_vm._s(_vm.contractModel.mode === 'no' ? 'NO' : 'YES')+"\n          ")])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__last-trade"},[_c('div',{staticClass:"market-contract-horizontal-sushi__last-trade-price"},[(_vm.currentPriceDashboard > 0)?[_c('div',{staticClass:"market-contract-horizontal-sushi__last-trade-price-value-col"},[_c('animated-number',{staticClass:"market-contract-horizontal-sushi__last-trade-price-value",attrs:{"value":_vm.currentPriceDashboard,"symbol":_vm.currentPriceSymbol}})],1),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__last-trade-price-change-col"},[(_vm.showChangePriceIndicator && _vm.useDesktopLayout)?_c('market-change-price',{attrs:{"price":_vm.contractModel.mode === 'no' ? -_vm.contractModel.changePriceAsCents : _vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice,"symbol":_vm.currentPriceSymbol}}):_vm._e()],1)]:_c('span',{staticClass:"market-contract-horizontal-sushi__last-trade-price-new"},[_vm._v("NEW")])],2)]),_vm._v(" "),(!_vm.forCmsWidget)?[_c('div',{staticClass:"market-contract-horizontal-sushi__volume"},[_c('div',{staticClass:"market-contract-horizontal-sushi__volume-value"},[(_vm.contract.userQuantity > 0)?_c('div',[_vm._v(_vm._s(_vm.volumeDisplay))]):_c('div',{staticClass:"market-dash-symbol"},[_vm._v("-")])])]),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__avg-paid"},[(_vm.contract.userQuantity === 0)?_c('div',{staticClass:"market-dash-symbol"},[_vm._v("-")]):[_c('div',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.contractModel.userAveragePricePerShareAsCents),expression:"contractModel.userAveragePricePerShareAsCents",modifiers:{"cents":true}}]}),_vm._v(" "),(_vm.showChangePriceIndicatorUserChange)?_c('market-change-price',{attrs:{"price":_vm.contractModel.userChangePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice}}):_vm._e()]],2),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__buy-orders\n            market-contract-horizontal-sushi__tooltip",attrs:{"data-tooltip":_vm.buyOrdersTooltip}},[(_vm.contractModel.userOpenOrdersBuyQuantity > 0)?_c('div',[_vm._v(_vm._s(_vm.buyOrdersDisplay))]):_c('div',{staticClass:"market-dash-symbol"},[_vm._v("-")])]),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__sell-orders\n            market-contract-horizontal-sushi__tooltip",attrs:{"data-tooltip":_vm.sellOrdersTooltip}},[(_vm.contractModel.userOpenOrdersSellQuantity > 0)?_c('div',[_vm._v(_vm._s(_vm.sellOrdersDisplay))]):_c('div',{staticClass:"market-dash-symbol"},[_vm._v("-")])])]:_vm._e()],2):[_c('div',{staticClass:"market-contract-horizontal-sushi__last-trade"},[_c('div',{staticClass:"market-contract-horizontal-sushi__last-trade-price"},[(_vm.currentPrice > 0)?[(_vm.contractModel.changePriceAsCents && _vm.isLayoutMobile)?_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice,"symbol":_vm.currentPriceSymbol}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__last-trade-price-value-col"},[_c('animated-number',{staticClass:"market-contract-horizontal-sushi__last-trade-price-value",attrs:{"value":_vm.currentPrice,"symbol":_vm.currentPriceSymbol}})],1),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__last-trade-price-change-col"},[(_vm.contractModel.changePriceAsCents && _vm.useDesktopLayout)?_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice,"symbol":_vm.currentPriceSymbol}}):_vm._e()],1)]:[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__last-trade-price-change-col"},[_vm._v("\n                 \n              ")])]],2)]),_vm._v(" "),(_vm.showSharesBar)?_c('div',{staticClass:"market-contract-horizontal-sushi__ownership"},[_c('market-shares-ownership',{attrs:{"mode":_vm.contractModel.mode,"number":_vm.contract.userQuantity},on:{"click":_vm.onClickSharesBar}})],1):(_vm.useDesktopLayout && !_vm.forCmsWidget)?_c('div',{staticClass:"market-contract-horizontal-sushi__volume"},[_vm._m(1)]):(_vm.useMobileLayout && _vm.isTradingEnabled)?_c('div',{staticClass:"market-contract-horizontal-sushi__empty-space"}):_vm._e(),_vm._v(" "),(_vm.useDesktopLayout && !_vm.forCmsWidget)?_c('div',{staticClass:"market-contract-horizontal-sushi__avg-paid"},[(_vm.contract.userQuantity === 0)?_c('span',{staticClass:"market-dash-symbol"},[_vm._v("-")]):[_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.contractModel.userAveragePricePerShareAsCents),expression:"contractModel.userAveragePricePerShareAsCents",modifiers:{"cents":true}}]}),_vm._v(" "),(_vm.showChangePriceIndicatorUserChange)?_c('market-change-price',{attrs:{"price":_vm.contractModel.userChangePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice,"symbol":_vm.currentPriceSymbol}}):_vm._e()]],2):_vm._e(),_vm._v(" "),(_vm.useDesktopLayout && !_vm.forCmsWidget)?_c('div',{staticClass:"market-contract-horizontal-sushi__orders"},[_c('market-contract-horizontal-sushi-orders',{attrs:{"buyQuantity":_vm.contractModel.userOpenOrdersBuyQuantity,"sellQuantity":_vm.contractModel.userOpenOrdersSellQuantity,"mode":_vm.contractModel.mode}})],1):_vm._e()],_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__buttons"},[(_vm.isMarketDisabled && !_vm.forCmsWidget)?[_c('market-disabled-outcome-v2',{attrs:{"market":_vm.market,"contract":_vm.contract}})]:[_c('div',{staticClass:"market-contract-horizontal-sushi__buttons--left"},[(_vm.forCmsWidget)?_c('market-button-direction',{attrs:{"variant":"buy-yes","price":_vm.contractModel.buyYesCostAsCents,"text":"YES","isActive":_vm.tradeOptions.contractId === _vm.contract.contractId,"isOn":_vm.activeButton === _vm.BUTTONS.BUY_YES.id,"operationValue":_vm.tradeOptions.operationValue},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.BUY_YES.type, _vm.BUTTONS.BUY_YES.value, _vm.BUTTONS.BUY_YES.id)}}}):(_vm.contractModel.mode === _vm.VALUES.NO)?_c('market-button-direction',{attrs:{"variant":"buy-no","price":_vm.contractModel.buyNoCostAsCents,"text":"NO","isActive":_vm.tradeOptions.contractId === _vm.contract.contractId,"isOn":_vm.activeButton === _vm.BUTTONS.BUY_NO.id,"operationValue":_vm.tradeOptions.operationValue},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.BUY_NO.type, _vm.BUTTONS.BUY_NO.value, _vm.BUTTONS.BUY_NO.id)}}}):_c('market-button-direction',{attrs:{"variant":"buy-yes","price":_vm.contractModel.buyYesCostAsCents,"text":"YES","isActive":_vm.tradeOptions.contractId === _vm.contract.contractId,"isOn":_vm.activeButton === _vm.BUTTONS.BUY_YES.id,"operationValue":_vm.tradeOptions.operationValue},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.BUY_YES.type, _vm.BUTTONS.BUY_YES.value, _vm.BUTTONS.BUY_YES.id)}}})],1),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-sushi__buttons--right"},[(_vm.forCmsWidget)?_c('market-button-direction',{attrs:{"variant":"buy-no","price":_vm.contractModel.buyNoCostAsCents,"text":"NO","isActive":_vm.tradeOptions.contractId === _vm.contract.contractId,"isOn":_vm.activeButton === _vm.BUTTONS.BUY_NO.id,"operationValue":_vm.tradeOptions.operationValue},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.BUY_NO.type, _vm.BUTTONS.BUY_NO.value, _vm.BUTTONS.BUY_NO.id)}}}):(_vm.contractModel.mode === _vm.VALUES.NO)?_c('market-button-direction',{attrs:{"variant":"sell-no","price":_vm.contractModel.sellNoCostAsCents,"text":"Sell","isActive":_vm.tradeOptions.contractId === _vm.contract.contractId,"isOn":_vm.activeButton === _vm.BUTTONS.SELL_NO.id,"operationValue":_vm.tradeOptions.operationValue,"saleDisabled":_vm.contractModel.userQuantity === 0},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.SELL_NO.type, _vm.BUTTONS.SELL_NO.value, _vm.BUTTONS.SELL_NO.id)}}}):(_vm.contractModel.mode === _vm.VALUES.YES)?_c('market-button-direction',{attrs:{"variant":"sell-yes","price":_vm.contractModel.sellYesCostAsCents,"text":"Sell","isActive":_vm.tradeOptions.contractId === _vm.contract.contractId,"isOn":_vm.activeButton === _vm.BUTTONS.SELL_YES.id,"operationValue":_vm.tradeOptions.operationValue,"saleDisabled":_vm.contractModel.userQuantity === 0},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.SELL_YES.type, _vm.BUTTONS.SELL_YES.value, _vm.BUTTONS.SELL_YES.id)}}}):_c('market-button-direction',{attrs:{"variant":"buy-no","price":_vm.contractModel.buyNoCostAsCents,"text":"NO","isActive":_vm.tradeOptions.contractId === _vm.contract.contractId,"isOn":_vm.activeButton === _vm.BUTTONS.BUY_NO.id,"operationValue":_vm.tradeOptions.operationValue},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId, _vm.BUTTONS.BUY_NO.type, _vm.BUTTONS.BUY_NO.value, _vm.BUTTONS.BUY_NO.id)}}})],1)]],2)],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contract-horizontal-sushi__last-trade-price-value-col"},[_c('span',{staticClass:"market-contract-horizontal-sushi__last-trade-price-new"},[_vm._v("NEW")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contract-horizontal-sushi__volume-value"},[_c('span',{staticClass:"market-dash-symbol"},[_vm._v("-")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vfWA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vm2L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: ''
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      var q = this.query.trim();
      if (!q) return;
      this.$router.push({ path: '/markets/search', query: { query: q } });
    }
  }
});

/***/ }),

/***/ "vxYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_desktop_grid_js__ = __webpack_require__("D+Yn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_279bb822_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_desktop_grid_vue__ = __webpack_require__("NXsH");
function injectStyle (ssrContext) {
  __webpack_require__("zZwI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_desktop_grid_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_279bb822_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_desktop_grid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w009":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_change_price_js__ = __webpack_require__("mBiY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94ebb4ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_change_price_vue__ = __webpack_require__("LMIZ");
function injectStyle (ssrContext) {
  __webpack_require__("Bo+i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_change_price_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94ebb4ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_change_price_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w0Aq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_widget_js__ = __webpack_require__("Efhk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c9b3c90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_widget_vue__ = __webpack_require__("CRTj");
function injectStyle (ssrContext) {
  __webpack_require__("lBfC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c9b3c90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w1pb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_youtube_embed__ = __webpack_require__("5/be");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    getYoutubeUrl: function getYoutubeUrl() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_youtube_embed__["b" /* getIdFromURL */])('https://www.youtube.com/watch?v=NfWU0Wiixuo');
    }
  }
});

/***/ }),

/***/ "w4vL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_nav_browse_categories_overlay_js__ = __webpack_require__("dh9S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_865af4c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_browse_categories_overlay_vue__ = __webpack_require__("vEia");
function injectStyle (ssrContext) {
  __webpack_require__("kdgD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_nav_browse_categories_overlay_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_865af4c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_browse_categories_overlay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w70/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    },
    href: {
      type: Object,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    date: {
      type: String,
      default: ''
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']))
});

/***/ }),

/***/ "w9QL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wLE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.preview)?_c('div',[_c('div',{staticClass:"bank-account bank-account--preview"},[_c('div',{staticClass:"bank-account__icon"},[_c('img',{attrs:{"src":_vm.account.bankInfo.bankIconUrl}})]),_vm._v(" "),_c('div',{staticClass:"bank-account__bank-title bank-account__bank-title--summary"},[_vm._v("\n        "+_vm._s(_vm.account.bankInfo.bankDisplayName)+"\n      ")]),_vm._v(" "),_c('div',[_vm._v("\n        "+_vm._s(_vm.account.bankInfo.bankAccountDisplayName)+"\n      ")])])]):_c('div',{class:_vm.classModifiers,on:{"click":function($event){return _vm.$emit('select')}}},[_c('div',{staticClass:"bank-account__icon"},[_c('img',{attrs:{"src":_vm.account.bankInfo.bankIconUrl}})]),_vm._v(" "),_c('div',{staticClass:"bank-account__bank"},[_c('div',{staticClass:"bank-account__bank-title"},[_vm._v("\n        "+_vm._s(_vm.account.bankInfo.bankDisplayName)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"bank-account__bank-account"},[_vm._v("\n        "+_vm._s(_vm.account.bankInfo.bankAccountDisplayName)+"\n      ")])]),_vm._v(" "),(_vm.removable)?_c('div',{staticClass:"bank-account__remove-wrapper",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('remove', _vm.account)}}},[_c('div',{staticClass:"bank-account__remove"})]):_vm._e(),_vm._v(" "),(_vm.showStatusMessage)?_c('div',{staticClass:"bank-account__message"},[_vm._v("\n      "+_vm._s(_vm.account.accountStatusMessage)+"\n    ")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wQrL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wRUy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wSGJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.title)?_c('div',{staticClass:"podcasts__header"},[_c('div',{staticClass:"podcasts__header-title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),(_vm.showArrows)?_c('div',{staticClass:"podcasts__header-arrows"},[_c('span',{class:_vm.prevArrowModifiers,on:{"click":_vm.prevSlide}}),_vm._v(" "),_c('span',{class:_vm.nextArrowModifiers,on:{"click":_vm.nextSlide}})]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"podcasts__content",on:{"mouseenter":_vm.stopSwiper,"mouseleave":_vm.startSwiper}},[_c('swiper',{ref:"swiper",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.tracks),function(track,index){return _c('swiper-slide',{key:index,staticClass:"podcasts__slide"},[(track.type === _vm.PODCAST.POLITICAN_TRADER)?_c('iframe',{style:(_vm.getTrackFrameStyle(track, index)),attrs:{"width":"100%","height":_vm.getTrackHeight(track, index),"scrolling":"no","frameborder":"no","allowfullscreen":"","webkitallowfullscreen":"","mozallowfullscreen":"","oallowfullscreen":"","msallowfullscreen":"","src":_vm.getPoliticanTraderUrl()},on:{"load":_vm.onTrackFrameLoad}}):_vm._e(),_vm._v(" "),(track.type === _vm.PODCAST.SOUNDCLOUD)?_c('iframe',{style:(_vm.getTrackFrameStyle(track, index)),attrs:{"width":"100%","height":_vm.getTrackHeight(track, index),"scrolling":"no","frameborder":"no","allow":"autoplay *; encrypted-media *; fullscreen *; clipboard-write","src":_vm.getSoundCloudUrl(track.id)},on:{"load":_vm.onTrackFrameLoad}}):_vm._e(),_vm._v(" "),(track.type === _vm.PODCAST.APPLE)?_c('iframe',{style:(_vm.getTrackFrameStyle(track, index)),attrs:{"width":"100%","height":_vm.getTrackHeight(track, index),"scrolling":"no","frameborder":"no","allow":"autoplay *; encrypted-media *; fullscreen *; clipboard-write","src":_vm.getAppleUrl(track.id)},on:{"load":_vm.onTrackFrameLoad}}):_vm._e(),_vm._v(" "),(track.type === _vm.PODCAST.STITCHER)?_c('iframe',{style:(_vm.getTrackFrameStyle(track, index)),attrs:{"width":"100%","height":_vm.getTrackHeight(track, index),"scrolling":"no","frameborder":"no","src":_vm.getStitcherUrl(track.id)},on:{"load":_vm.onTrackFrameLoad}}):_vm._e(),_vm._v(" "),(track.type === _vm.PODCAST.ITUNES)?_c('div',{staticClass:"podcasts__iframe podcasts__iframe--itunes"},[_c('iframe',{style:(_vm.styleItunesIframe),attrs:{"scrolling":"no","frameborder":"no","src":_vm.getItunesUrl(track.id)},on:{"load":_vm.onTrackFrameLoad}})]):_vm._e(),_vm._v(" "),(track.type === _vm.PODCAST.BACKTRACKS)?_c('div',{staticClass:"podcasts__backtrack",attrs:{"data-bt-embed":_vm.getBacktracksUrl(track.id),"data-bt-theme":"dark","data-bt-show-description":"false","data-bt-show-comments":"false","data-bt-show-art-cover":"false"}}):_vm._e()])}),1),_vm._v(" "),(false)?_c('div',{staticClass:"podcasts__link-wrapper"},[_c('strong',[_vm._v("Special Offer:")]),_vm._v(" "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],staticClass:"podcasts__link",attrs:{"href":"https://lp.stratfor.com/predictitoffer"}},[_vm._v("\n      Access Stratfor Worldview - Geopolitical Insights on What Moves Political Markets")])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wU6a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },

  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),

/***/ "wWzM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_query__ = __webpack_require__("sLBT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_4__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  props: {
    widget: Object
  },
  computed: {
    obj: function obj() {
      return this.widget ? this.widget : {};
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['addFilter', 'setTimespanFromQuery', 'setOrderFromQuery']), {
    onClick: function onClick() {
      var _this = this;

      if (this.obj.marketUrl) {
        var queryObj = __WEBPACK_IMPORTED_MODULE_3__helpers_query__["a" /* default */].unserializeQuery(this.obj.marketUrl);
        var storeModified = false;
        if (queryObj.filterIds) {
          queryObj.filterIds.split(',').forEach(function (i) {
            var filterId = parseInt(i, 10);
            __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].info('[MARKETS] filterId passed: ' + filterId);
            if (filterId) {
              storeModified = true;
              _this.addFilter(filterId);
            }
          });
        }
        if (queryObj.sortParameter) {
          storeModified = true;
          this.setTimespanFromQuery({
            parameter: queryObj.sortParameter,
            dateFrom: queryObj.dateFrom,
            dateTo: queryObj.dateTo
          });
        }
        if (queryObj.sort) {
          storeModified = true;
          this.setOrderFromQuery(queryObj.sort);
        }
        var url = storeModified ? this.obj.marketUrl + '&widget' : this.obj.marketUrl;
        this.$router.push(url);
      }
    }
  })
});

/***/ }),

/***/ "x+uv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_select_js__ = __webpack_require__("x3ff");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6100fcc9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_select_vue__ = __webpack_require__("ei5i");
function injectStyle (ssrContext) {
  __webpack_require__("neXN")
  __webpack_require__("vfWA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_select_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6100fcc9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x0s9":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "x3ff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__multiselect_vue__ = __webpack_require__("Q334");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__ = __webpack_require__("k37b");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    multiselect: __WEBPACK_IMPORTED_MODULE_1__multiselect_vue__["a" /* default */]
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    required: Boolean,
    placeholder: String,
    label: {
      type: String,
      required: true
    },
    trackBy: {
      type: String,
      required: true
    },
    value: [String, Object],
    small: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: Number,
      default: 200
    },
    customLabel: {
      type: Function
    },
    searchable: {
      type: Boolean,
      default: true
    },
    showNoResults: {
      type: Boolean,
      default: false
    },
    tabindex: Number,
    gtm: {
      type: String,
      default: ''
    },
    adjust: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    selectModifiers: function selectModifiers() {
      return {
        'select--has-value': this.value,
        'select--small': this.small
      };
    },
    gtmObject: function gtmObject() {
      var _gtm$split = this.gtm.split(','),
          _gtm$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_gtm$split, 2),
          category = _gtm$split2[0],
          label = _gtm$split2[1];

      return {
        event: 'eventTrackerTrigger',
        category: category,
        action: 'select',
        label: label
      };
    }
  },
  methods: {
    updateValue: function updateValue(e) {
      this.$emit('input', e);
      if (this.gtm && this.value) {
        this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__["a" /* withMeta */])(this.gtmObject));
      }
    }
  }
});

/***/ }),

/***/ "xCnb":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iNyIgc3Ryb2tlPSIjOTQ5NDk0IiBzdHJva2Utd2lkdGg9IjEuNSIvPgogIDxjaXJjbGUgY3g9IjgiIGN5PSI4IiByPSIzLjUiIGZpbGw9IiM5NDk0OTQiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "xJ4c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_news_feed_js__ = __webpack_require__("smaH");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_631127d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_feed_vue__ = __webpack_require__("4Iyt");
function injectStyle (ssrContext) {
  __webpack_require__("rpmV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_news_feed_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_631127d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_feed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xLyB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xMYI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_currency_input_js__ = __webpack_require__("MGrt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4907a2c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_currency_input_vue__ = __webpack_require__("lp3Y");
function injectStyle (ssrContext) {
  __webpack_require__("O4q7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_currency_input_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4907a2c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_currency_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xTWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_userDetails__ = __webpack_require__("jtWA");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_socialLevel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_userDetails__["a" /* default */]],
  props: {
    comment: Object
  },
  methods: {
    traderLevelDisplay: function traderLevelDisplay(item) {
      var level = this.getLevelByPredictions(item.profitablePredictions);
      return 'Level ' + level.num + ' (' + level.text + ')';
    },
    ellipsizeTextBox: function ellipsizeTextBox(el) {
      var wordArray = el.innerHTML.split(' ');
      while (el.scrollHeight > el.offsetHeight) {
        wordArray.pop();
        el.innerHTML = wordArray.join(' ') + '...';
      }
    },
    onClick: function onClick() {
      if (this.comment && this.comment.commentUrl && !__WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__["i" /* isStandalone */]) {
        window.location.href = this.comment.commentUrl;
      }
    }
  },
  mounted: function mounted() {
    // this.ellipsizeTextBox(this.$refs.text);
  }
});

/***/ }),

/***/ "xgaP":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "xnHd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-table"},[_c('div',{staticClass:"charts-table__wrapper",class:{
      'charts-table__wrapper--scroll-left': _vm.canScrollLeft,
      'charts-table__wrapper--scroll-right': _vm.canScrollRight,
    }},[(_vm.canScrollLeft)?_c('button',{staticClass:"charts-table__arrow charts-table__arrow--left",on:{"click":_vm.scrollLeft}}):_vm._e(),_vm._v(" "),_c('swiper',{ref:"swiper",staticClass:"charts-table__row",attrs:{"options":_vm.swiperOption}},_vm._l((_vm.contracts),function(item){return _c('swiper-slide',{key:item.contractId,class:{
          'charts-table__row-item': true,
          'charts-table__row-item--with-image': _vm.showImage,
        }},[_c('form-checkbox',{attrs:{"color":_vm.checkboxColor(item),"name":_vm.contractName(item)},on:{"change":function($event){return _vm.onChange(item, $event)}},model:{value:(item.checked),callback:function ($$v) {_vm.$set(item, "checked", $$v)},expression:"item.checked"}},[_c('div',{staticClass:"charts-table__item"},[(_vm.showImage)?_c('div',{staticClass:"charts-table__item-image",style:(_vm.imageStyleModifiers(item))}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"charts-table__item-label"},[_c('div',{directives:[{name:"contract-name",rawName:"v-contract-name"}]},[_vm._v("\n                "+_vm._s(item.contractName)+"\n              ")])])])])],1)}),1),_vm._v(" "),(_vm.canScrollRight)?_c('button',{staticClass:"charts-table__arrow charts-table__arrow--right",on:{"click":_vm.scrollRight}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xpMb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isVisible)?_c('div',{staticClass:"app-loader"},[_c('div',{staticClass:"app-loader__overlay"}),_vm._v(" "),_c('div',{staticClass:"app-loader__progress-bar"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xz2f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    amount: {
      type: [String, Number],
      default: 0
    },
    feePercent: {
      type: Number,
      default: 0
    },
    feeFreeCap: {
      type: [String, Number],
      default: 0
    },
    feeDiscountEligibility: {
      type: Boolean,
      default: false
    },
    feeCap: {
      type: Number,
      default: null
    },
    prefix: {
      type: String,
      default: ''
    }
  },
  computed: {
    freeTierAmount: function freeTierAmount() {
      return Number(this.feeFreeCap);
    },
    isReduced: function isReduced() {
      return Number(this.amount) > this.freeTierAmount;
    },
    statusLabel: function statusLabel() {
      if (!this.feePercent) {
        return 'No fees';
      }
      if (this.feeDiscountEligibility) {
        return this.isReduced ? 'Reduced fees' : 'No fees';
      }
      return this.feePercent + '% fee';
    },
    feeCapDisplayMessage: function feeCapDisplayMessage() {
      if (!this.feePercent || !this.feeCap || this.feeDiscountEligibility && !this.isReduced) {
        return '';
      }
      return 'up to a maximum of $' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["H" /* formatUsdValue */])(this.feeCap, { trimWhole: true });
    }
  }
});

/***/ }),

/***/ "y8UT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__ = __webpack_require__("k37b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_account_account_social_badge_account_social_badge_vue__ = __webpack_require__("gdGR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_userAgent__ = __webpack_require__("GZXJ");

/* eslint-disable no-unused-vars */








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_userAgent__["a" /* default */]],
  components: {
    accountSocialBadge: __WEBPACK_IMPORTED_MODULE_6__components_account_account_social_badge_account_social_badge_vue__["a" /* default */]
  },
  data: function data() {
    return {
      name: null,
      accountBalance: null,
      portfolioBalance: null,
      currency: null
    };
  },
  metaInfo: function metaInfo() {
    if (this.isLayoutMobile) {
      return {
        title: 'Account'
      };
    }
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('wallet', ['balance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['hasMaintenanceMessage', 'isLayoutMobile']), {
    enabledLinks: function enabledLinks() {
      return this.links.filter(function (i) {
        return i.enabled;
      });
    },
    links: function links() {
      var route = this.$route;
      var query = this.$route.query;

      return [{
        type: 'header',
        name: 'Wallet',
        enabled: true
      }, {
        name: 'Deposit',
        type: 'link',
        inner: true,
        to: { name: 'wallet', query: { tabId: 'deposit' } },
        active: route.name === 'wallet' && query.tabId === 'deposit',
        enabled: true
      }, {
        name: 'Withdraw',
        type: 'link',
        inner: true,
        to: { name: 'wallet', query: { tabId: 'withdraw' } },
        active: route.name === 'wallet' && query.tabId === 'withdraw',
        enabled: true
      }, {
        name: 'Pending',
        type: 'link',
        inner: true,
        to: { name: 'wallet', query: { tabId: 'pending' } },
        active: route.name === 'wallet' && query.tabId === 'pending',
        enabled: true
      }, {
        type: 'line',
        name: 'Line1',
        enabled: true
      }, {
        type: 'header',
        name: 'History',
        enabled: true
      }, {
        name: 'Trades',
        type: 'link',
        inner: true,
        to: { name: 'account-history', query: { tabId: 'trades' } },
        active: route.name === 'account-history' && (query.tabId === 'trades' || route.params.marketId),
        enabled: true
      }, {
        name: 'Deposits / Withdrawals',
        type: 'link',
        inner: true,
        to: { name: 'account-history', query: { tabId: 'deposit-withdrawals' } },
        active: route.name === 'account-history' && query.tabId === 'deposit-withdrawals',
        enabled: true
      }, {
        type: 'line',
        name: 'Line2',
        enabled: true
      }, {
        name: 'Account Details',
        type: 'link',
        to: { name: 'account-details' },
        active: route.name === 'account-details',
        enabled: true
      }, {
        name: 'Settings',
        type: 'link',
        to: { name: 'account-settings' },
        active: route.name === 'account-settings',
        enabled: true
      }, {
        name: 'Help and Support',
        type: 'link',
        to: { name: 'HelpAndSupport' },
        active: ['HelpAndSupport', 'WhatIsPredictIt', 'LearnTheBasics', 'ComunityForums', 'Faq', 'Videos'].includes(route.name),
        enabled: true
      }, {
        type: 'line',
        name: 'Line3',
        enabled: true
      }, {
        type: 'logout',
        name: 'LOGOUT',
        enabled: true
      }];
    },
    cash: function cash() {
      return (Math.floor(this.balance.accountBalanceDecimal * 100) / 100).toFixed(2);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['logout']), {
    profileButtonClass: function profileButtonClass(link) {
      return {
        profile__button: true,
        'profile__button--inner': link.inner,
        'profile__button--active': link.active
      };
    },
    logoutButton: function logoutButton() {
      this.loaderAdd(document.body);
      this.logout();
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_dataLayer__["a" /* withMeta */])({ event: 'Logout' }));
    },
    isLinkAvailable: function isLinkAvailable(link) {
      var walletCheckNames = ['Deposit', 'Withdraw', 'Pending', 'Wallet', 'Line1'];
      if (walletCheckNames.includes(link.name)) {
        return this.isWalletEnabled;
      }
      return true;
    }
  })
});

/***/ }),

/***/ "yCD8":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjE0IiB2aWV3Qm94PSIwIDAgOCAxNCI+CiAgICA8cGF0aCBmaWxsPSIjMjYzQjNGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0uOTAyLjMzM2wtLjYwNC42NzNBMS4yMjQgMS4yMjQgMCAwIDAgMCAxLjgyNGMwIC4zMTguMS41ODcuMjk4LjgwOUw0LjIxMiA3IC4yOTggMTEuMzY3YTEuMTY5IDEuMTY5IDAgMCAwLS4yOTguODA5YzAgLjMxMS4xLjU4NC4yOTguODE4bC42MDQuNjY1YS45NTEuOTUxIDAgMCAwIC43MzMuMzQxYy4yOSAwIC41MzItLjExNC43MjUtLjM0MWw1LjI0My01Ljg1Yy4yMDQtLjIxNi4zMDYtLjQ4NS4zMDYtLjgwOSAwLS4zMTgtLjEwMi0uNTktLjMwNi0uODE4TDIuMzYuMzMyQS45MzguOTM4IDAgMCAwIDEuNjM1IDBjLS4yOCAwLS41MjMuMTEtLjczMy4zMzN6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "yOrf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"market-trading-unavailable-v2__icon"}),_vm._v(" "),_c('div',{staticClass:"market-trading-unavailable-v2__text"},[_vm._t("text")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yUpF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ONBOARDING_STEPS_WITH_PROGRESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ONBOARDING_STEPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ONBOARDING_STEP_CODE_NAME_MAP; });
/* unused harmony export ONBOARDING_STEP_CODES_USER_VERIFIED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ONBOARDING_STEP_NAME_CODE_MAP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);



var _ONBOARDING_STEP_CODE;

/* eslint-disable */

var ONBOARDING_STEPS_WITH_PROGRESS = {
  // CONFIRM_EMAIL: 'confirm-email',
  PERSONAL_DETAILS: 'personal-details',
  COMPLIANCE: 'compliance',
  QUESTIONNAIRE: 'questionnaire',
  PENDING_APPROVAL: 'pending-approval',
  QUICK_DEPOSIT: 'quick-deposit'
};
var ONBOARDING_STEPS = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, ONBOARDING_STEPS_WITH_PROGRESS, {
  REGISTER: 'register',
  LOGIN: 'login',
  FORGOTTEN: 'forgotten'
});

var ONBOARDING_STEP_CODE_NAME_MAP = (_ONBOARDING_STEP_CODE = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ONBOARDING_STEP_CODE, 'ConfigureProfileAndIDV', ONBOARDING_STEPS.PERSONAL_DETAILS), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ONBOARDING_STEP_CODE, 'ComplianceDocumentReview', ONBOARDING_STEPS.COMPLIANCE), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ONBOARDING_STEP_CODE, 'ComplianceQuestionReview', ONBOARDING_STEPS.QUESTIONNAIRE), _ONBOARDING_STEP_CODE);

var ONBOARDING_STEP_CODES_USER_VERIFIED = ['SignupComplete', 'ComplianceFinalization'];

var ONBOARDING_STEP_NAME_CODE_MAP = {
  PERSONAL_DETAILS: 'ConfigureProfileAndIDV',
  COMPLIANCE: 'ComplianceDocumentReview',
  QUESTIONNAIRE: 'ComplianceQuestionReview',
  ADD_FUNDS_OR_PENDING: 'RequestDeposit',
  SIGNUP_COMPLETE: 'SignupComplete',
  COMPLIANCE_FINALIZATION: 'ComplianceFinalization'
};

/***/ }),

/***/ "yZQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_mutex__ = __webpack_require__("EOu+");





var STATUS_PENDING = 2;

var accountVerifyMixin = {
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['userData', 'status']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('wallet', ['balance']), {
    accountLink: function accountLink() {
      if (this.isLayoutMobile) return '/account';
      if (this.isWalletEnabled) return '/account/wallet';
      return '/account/details';
    },
    hasUserClassicEnabled: function hasUserClassicEnabled() {
      return !this.isLoggedIn || this.isLoggedIn && this.status.isClassicEnabled !== false;
    },
    isUserVerified: function isUserVerified() {
      var idVerified = this.userData.idVerified;
      var verificationStatus = this.userData.verificationStatus;
      if (!this.isLoggedIn) return true;
      return typeof idVerified !== 'undefined' ? idVerified || verificationStatus === STATUS_PENDING : false;
    },
    isUserVerifiedFully: function isUserVerifiedFully() {
      var idVerified = this.userData.idVerified;
      var verificationStatus = this.userData.verificationStatus;
      if (!this.isLoggedIn) return true;
      return typeof idVerified !== 'undefined' ? idVerified && verificationStatus !== STATUS_PENDING : false;
    },
    isWalletEnabled: function isWalletEnabled() {
      var idVerified = this.userData.idVerified;
      if (!this.isLoggedIn) return true;
      return typeof idVerified !== 'undefined' ? idVerified : false;
    },
    isUserBalanceEmpty: function isUserBalanceEmpty() {
      return this.balance && this.balance.accountBalanceDecimal === 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentPopupOptions']), {
    checkDataIfUserIsVerified: function checkDataIfUserIsVerified(data) {
      if (!this.isLoggedIn) return true;
      return data && (data.idVerified === true || data.verificationStatus === STATUS_PENDING);
    },
    showAccountVerifyPopup: function showAccountVerifyPopup() {
      var _this = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!this.isLoggedIn) return;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_mutex__["b" /* waitForStatusReady */])().then(function () {
        if (_this.isUserVerified) {
          return;
        }
        _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_modals_constants__["a" /* MODALS */].ACCOUNT_VERIFY);
        if (options !== null) {
          _this.setCurrentPopupOptions(options);
        }
      });
    },
    showAddFundsPopup: function showAddFundsPopup() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_modals_constants__["a" /* MODALS */].ADD_FUNDS);
    }
  })
};

/* harmony default export */ __webpack_exports__["a"] = (accountVerifyMixin);

/***/ }),

/***/ "ygM9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

/* eslint-disable no-useless-escape */


function isValidUrl(input) {
  var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
  return regex.test(input);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      imageLoadError: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    showSubtitle: function showSubtitle() {
      return this.data && this.data.origin && this.data.origin.title;
    },
    shouldShowImage: function shouldShowImage() {
      return !this.imageLoadError;
    },
    containerModifier: function containerModifier() {
      return {
        'news-feed-item--no-image': this.imageLoadError
      };
    },
    contentModifier: function contentModifier() {
      return {
        'small-8': !this.imageLoadError,
        'small-12': this.imageLoadError
      };
    },
    url: function url() {
      return this.data.originId;
    },
    target: function target() {
      return isValidUrl(this.url) && this.isLayoutDesktop ? '_blank' : '_self';
    }
  }),
  methods: {
    getItemImage: function getItemImage(item) {
      if (item.visual && item.visual.url) {
        return item.visual.url;
      }

      this.imageLoadError = true;
      return null;
    },
    onImageLoadError: function onImageLoadError() {
      this.imageLoadError = true;
    }
  }
});

/***/ }),

/***/ "yhSh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_toolbar_js__ = __webpack_require__("RJiU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41157d12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_toolbar_vue__ = __webpack_require__("WOmE");
function injectStyle (ssrContext) {
  __webpack_require__("t3/+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_toolbar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41157d12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_toolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yncl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-phone-update",class:{ 'account-phone-update--bank-link': _vm.bankLink }},[(_vm.error)?_c('div',{staticClass:"account-phone-update__error"},[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.step === 'input')?_c('div',{staticClass:"account-phone-update__step"},[_c('p',{staticClass:"account-phone-update__description"},[_vm._v("\n      "+_vm._s(_vm.inputDescription)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"account-phone-update__field"},[_c('label',{staticClass:"account-phone-update__label"},[_vm._v("Phone Number")]),_vm._v(" "),_c('div',{staticClass:"account-phone-update__input-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneNumber),expression:"phoneNumber"}],staticClass:"account-phone-update__input",attrs:{"type":"tel","placeholder":"+1 (555) 555-5555","autocomplete":"tel"},domProps:{"value":(_vm.phoneNumber)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.phoneNumber=$event.target.value},function($event){return _vm.$v.phoneNumber.$touch()}],"blur":function($event){return _vm.$v.phoneNumber.$touch()}}}),_vm._v(" "),(_vm.phoneError)?_c('div',{staticClass:"account-phone-update__field-error"},[_vm._v("\n          "+_vm._s(_vm.phoneError)+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"button button--primary button--full-width",attrs:{"type":"button","disabled":!_vm.canSendCode},on:{"click":_vm.sendCode}},[_vm._v("\n      "+_vm._s(_vm.isSending ? "Sending..." : "Send Verification Code")+"\n    ")])]):_vm._e(),_vm._v(" "),(_vm.step === 'verify')?_c('div',{staticClass:"account-phone-update__step"},[_c('p',{staticClass:"account-phone-update__description"},[_vm._v("\n      Enter the 6-digit code sent to "+_vm._s(_vm.verificationDestination)+".\n    ")]),_vm._v(" "),_c('div',{staticClass:"account-phone-update__field"},[_c('label',{staticClass:"account-phone-update__label"},[_vm._v("Verification Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.verificationCode),expression:"verificationCode"}],staticClass:"account-phone-update__input",attrs:{"type":"text","placeholder":"000000","maxlength":"6","inputmode":"numeric","autocomplete":"one-time-code"},domProps:{"value":(_vm.verificationCode)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.verifyCode($event)},"input":function($event){if($event.target.composing){ return; }_vm.verificationCode=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"account-phone-update__resend"},[_c('button',{staticClass:"account-phone-update__resend-btn",attrs:{"type":"button","disabled":_vm.secondsUntilResend > 0},on:{"click":_vm.sendCode}},[_vm._v("\n        "+_vm._s(_vm.secondsUntilResend > 0
            ? ("Resend code in " + _vm.secondsUntilResend + "s")
            : "Resend code")+"\n      ")])]),_vm._v(" "),_c('button',{staticClass:"button button--primary button--full-width",attrs:{"type":"button","disabled":!_vm.canVerify},on:{"click":_vm.verifyCode}},[_vm._v("\n      "+_vm._s(_vm.isVerifying ? "Verifying..." : _vm.verificationActionText)+"\n    ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"account-phone-update__footer"},[_c('button',{staticClass:"account-phone-update__cancel-btn",attrs:{"type":"button"},on:{"click":_vm.onCancel}},[_vm._v("\n      Cancel\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yoSF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"animated-number"},[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('span',{key:_vm.value,staticClass:"animated-number__value"},[_vm._v(_vm._s(_vm.value)),_c('span',{domProps:{"innerHTML":_vm._s(_vm.symbol)}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ypi2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-notification-items"}},[(_vm.shouldDisplayNotifications)?_c('div',{staticClass:"notification-items"},[_c('div',{staticClass:"notification-items__container"},[_c('transition-group',{attrs:{"name":"slide-notification","tag":"div"}},[_vm._l((_vm.notificationsToDisplay),function(notification){return [(_vm.shouldDisplayNotificationSimple(notification))?_c('notification-item-simple',{key:notification.index,attrs:{"autoClose":true,"text":notification.data.text,"icon":notification.data.icon,"title":notification.data.title,"closeTimeout":notification.data.closeTimeout,"index":notification.index}}):_vm._e(),_vm._v(" "),(_vm.shouldDisplayNotificationTradeConfirmed(notification))?_c('notification-item-trade-confirmed',{key:notification.index,attrs:{"autoClose":true,"closeTimeout":_vm.NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY,"index":notification.index,"data":notification.data}}):_vm._e(),_vm._v(" "),(_vm.shouldDisplayDashboardNotification(notification))?_c('notification-item-dashboard',{key:notification.index,attrs:{"autoClose":true,"closeButton":true,"closeTimeout":_vm.NOTIFICATION_SHARES_TRADED_CLOSE_DELAY,"theme":"notifications","index":notification.index,"data":notification.data}}):_vm._e()]})],2)],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ys9T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_dataLayer__ = __webpack_require__("k37b");

 /* eslint-disable */





var externalLinksMixin = {
  data: function data() {
    return {
      links: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getExternalLogins']), {
    registrationTrack: function registrationTrack(label) {
      this.$gtm.trackEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_dataLayer__["a" /* withMeta */])({
        event: 'eventTrackerTrigger',
        category: 'Registration',
        action: 'submit',
        label: label
      }));
    },
    twitterLinkClick: function twitterLinkClick() {
      this.registrationTrack('Twitter');
      __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('TWITTER LINK CLICKED', this.twitterLink);
      window.location.href = this.twitterLink;
    },
    facebookLinkClick: function facebookLinkClick() {
      this.registrationTrack('Facebook');
      __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('FACEBOOK LINK CLICKED', this.facebookLink);
      window.location.href = this.facebookLink;
    },
    googleLinkClick: function googleLinkClick() {
      this.registrationTrack('Google');
      __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('GOOGLE LINK CLICKED', this.googleLink);
      window.location.href = this.googleLink;
    }
  }),
  computed: {
    twitterLink: function twitterLink() {
      var data = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(this.links, function (l) {
        return l.name === 'Twitter';
      });
      return data ? '' + "" + data.url : null;
    },
    facebookLink: function facebookLink() {
      var data = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(this.links, function (l) {
        return l.name === 'Facebook';
      });
      return data ? '' + "" + data.url : null;
    },
    googleLink: function googleLink() {
      var data = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(this.links, function (l) {
        return l.name === 'Google';
      });
      return data ? '' + "" + data.url : null;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (externalLinksMixin);

/***/ }),

/***/ "z/nA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_privacy_statement_js__ = __webpack_require__("nHn7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45c03ab7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_privacy_statement_vue__ = __webpack_require__("MYxc");
function injectStyle (ssrContext) {
  __webpack_require__("bfFv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_privacy_statement_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45c03ab7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_privacy_statement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z6fO":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MiIgaGVpZ2h0PSI4MiIgdmlld0JveD0iMCAwIDgyIDgyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggc3Ryb2tlPSIjZDk1MzRmIiBkPSJNMSA0MWMwIDIyLjA5IDE3LjkwNSA0MCA0MCA0MCAyMi4wOSAwIDQwLTE3LjkxIDQwLTQwUzYzLjA5IDEgNDEgMUMxOC45MDUgMSAxIDE4LjkxIDEgNDF6Ii8+CiAgICAgICAgPHBhdGggZmlsbD0iI2Q5NTM0ZiIgZD0iTTQ3LjU0MyA1NC41MjhsLTYuNTMtNi41MjYtNi41NTYgNi41NDZhNC45NSA0Ljk1IDAgMCAxLTcuMDA0IDAgNC45NDIgNC45NDIgMCAwIDEgMC03bDYuNTUtNi41NS02LjU1LTYuNTQ2YTQuOTQyIDQuOTQyIDAgMCAxIDAtNyA0Ljk1IDQuOTUgMCAwIDEgNy4wMDQgMGw2LjU1NSA2LjU0NiA2LjUzLTYuNTI2YTQuOTUxIDQuOTUxIDAgMSAxIDcuMDA0IDdsLTYuNTI5IDYuNTMgNi41MyA2LjUyNmE0Ljk0MiA0Ljk0MiAwIDAgMSAwIDcgNC45NiA0Ljk2IDAgMCAxLTcuMDA0IDB6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "zAJv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__ = __webpack_require__("63Fj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* eslint-disable */



var STATUS_PENDING = 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  checkIfCanRunAfterVerification: function checkIfCanRunAfterVerification() {
    var lastInstantCredit = __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__["a" /* default */].get('lastInstantCredit', null);
    var instantCredit = __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__["a" /* default */].get('instant_credit', null);
    if (instantCredit && lastInstantCredit === instantCredit) {
      return false;
    }

    return instantCredit !== null;
  },
  checkIfCanRunAfterLogin: function checkIfCanRunAfterLogin() {
    var checkIfCanRunAfterVerification = this.checkIfCanRunAfterVerification();
    var userData = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.user.userData;
    var verificationStatus = userData.verificationStatus;
    var idVerified = userData.idVerified;
    var isUserVerified = typeof idVerified !== 'undefined' ? idVerified || verificationStatus === STATUS_PENDING : true;
    return checkIfCanRunAfterVerification && isUserVerified;
  },
  run: function run() {
    var code = __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__["a" /* default */].get('instant_credit', null);

    return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('wallet/submitInstantCredit', code).then(function (data) {
      __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__["a" /* default */].set('lastInstantCredit', code);
      return data;
    });
  },
  clear: function clear() {
    __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__["a" /* default */].del('lastInstantCredit');
    __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__["a" /* default */].del('instant_credit');
  }
});

/***/ }),

/***/ "zKe2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zNKi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    errors: {
      type: Array,
      required: true
    }
  }
});

/***/ }),

/***/ "zTpV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contracts-list-header-sushi",class:{ 'market-contracts-list-header-sushi--forced-mobile': _vm.forceMobileLayout, 'market-contracts-list-header-sushi--cms-widget': _vm.forCmsWidget, 'market-contracts-list-header-sushi--dashboard': _vm.dashboardMode && !_vm.forCmsWidget }},[(_vm.useMobileLayout)?[(_vm.forCmsWidget)?_c('div',{staticClass:"market-contracts-list-header-sushi--cms-mobile"},[_c('div',{staticClass:"market-contracts-list-header-sushi__item-1"},[_vm._v("\n        "+_vm._s(_vm.titleFirst)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__item-2"},[_c('div',{staticClass:"market-contracts-list-header-sushi__item-2-text"},[_vm._v("\n          "+_vm._s(_vm.titleSecond)+"\n        ")])])]):_c('div',{class:_vm.mobileBarClassModifiers},[_c('market-settings-button',{attrs:{"theme":"details"},model:{value:(_vm.showSettingsModal),callback:function ($$v) {_vm.showSettingsModal=$$v},expression:"showSettingsModal"}}),_vm._v(" "),(!_vm.isMarketDisabled)?_c('div',{staticClass:"market-contracts-list-header-sushi__mobile-title"},[_vm._v("\n        "+_vm._s(_vm.titleSecond)+"\n      ")]):_vm._e()],1)]:[_c('div',{staticClass:"market-contracts-list-header-sushi__item-1"},[_vm._v("\n      "+_vm._s(_vm.titleFirst)+"\n    ")]),_vm._v(" "),(_vm.dashboardMode)?_c('div',{staticClass:"market-contracts-list-header-sushi__middle-columns"},[(!_vm.forCmsWidget)?[_c('div',{staticClass:"market-contracts-list-header-sushi__item-type"},[_vm._v(_vm._s(_vm.titleType))])]:_vm._e(),_vm._v(" "),_c('market-contracts-list-header-sushi-item2',{attrs:{"title":_vm.titleSecond,"for-cms-widget":_vm.forCmsWidget}}),_vm._v(" "),(!_vm.forCmsWidget)?[_c('div',{staticClass:"market-contracts-list-header-sushi__item-3"},[_vm._v(_vm._s(_vm.titleThird))]),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__item-4"},[_vm._v(_vm._s(_vm.titleFourth))]),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__item-buy-orders"},[_vm._v(_vm._s(_vm.titleBuyOrders))]),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__item-sell-orders"},[_vm._v(_vm._s(_vm.titleSellOrders))])]:_vm._e()],2):[_c('market-contracts-list-header-sushi-item2',{attrs:{"title":_vm.titleSecond,"for-cms-widget":_vm.forCmsWidget}}),_vm._v(" "),(!_vm.forCmsWidget)?[_c('div',{staticClass:"market-contracts-list-header-sushi__item-3"},[_vm._v(_vm._s(_vm.titleThird))]),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__item-4"},[_vm._v(_vm._s(_vm.titleFourth))]),_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__item-5"},[_vm._v(_vm._s(_vm.titleFifth))])]:_vm._e()],_vm._v(" "),_c('div',{staticClass:"market-contracts-list-header-sushi__item-6"},[(!_vm.forCmsWidget)?_c('market-settings-button',{model:{value:(_vm.showSettingsModal),callback:function ($$v) {_vm.showSettingsModal=$$v},expression:"showSettingsModal"}}):_vm._e()],1)],_vm._v(" "),(!_vm.forCmsWidget)?_c('market-settings-modal',{model:{value:(_vm.showSettingsModal),callback:function ($$v) {_vm.showSettingsModal=$$v},expression:"showSettingsModal"}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zV2+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nav_browse_nav_browse_vue__ = __webpack_require__("i8vA");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    navBrowse: __WEBPACK_IMPORTED_MODULE_2__nav_browse_nav_browse_vue__["a" /* default */]
  },
  data: function data() {
    return {
      rerender: false,
      rotationIndex: 1
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    showNavBrowser: function showNavBrowser() {
      return !this.rerender;
    },
    classModifier: function classModifier() {
      return {
        'page-secondary-nav': true,
        'page-secondary-nav--browser': this.showNavBrowser
      };
    }
  }),
  methods: {
    handleOrientationChange: function handleOrientationChange() {
      var _this = this;

      this.rerender = true;
      setTimeout(function () {
        _this.rerender = false;
        _this.rotationIndex += 1;
      }, 300);
    }
  },
  created: function created() {
    window.addEventListener('orientationchange', this.handleOrientationChange);
    this.handleOrientationChange();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('orientationchange', this.handleOrientationChange);
  }
});

/***/ }),

/***/ "zZwI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zckU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SESSION_HISTORY_EXPIRES_AT */
/* unused harmony export SESSION_HISTORY_SIZE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SESSION_HISTORY_KEY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_localStorage__ = __webpack_require__("Moaq");





var SESSION_HISTORY_EXPIRES_AT = 86400; // 1 day

var SESSION_HISTORY_SIZE = 10;
var SESSION_HISTORY_KEY = 'session-history';

var getContractsHistory = function getContractsHistory() {
  return __WEBPACK_IMPORTED_MODULE_2__helpers_localStorage__["a" /* default */].get(SESSION_HISTORY_KEY, []);
};
var pushContract = function pushContract(_ref) {
  var value = _ref.value;

  try {
    var history = getContractsHistory();

    /* append value at the beginning of the list and make sure its unique */
    var newHistory = __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy___default()([value].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(history)), function (el) {
      return el.contractId;
    });
    var result = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newHistory.slice(0, SESSION_HISTORY_SIZE)));
    __WEBPACK_IMPORTED_MODULE_2__helpers_localStorage__["a" /* default */].set(SESSION_HISTORY_KEY, result, SESSION_HISTORY_EXPIRES_AT);
    return result;
  } catch (e) {
    return [];
  }
};

/* harmony default export */ __webpack_exports__["b"] = ({
  pushContract: pushContract,
  getContractsHistory: getContractsHistory
});

/***/ }),

/***/ "zeud":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zhes":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposited"},[_c('div',{staticClass:"row"},[(_vm.currentDeposit.account && _vm.currentDeposit.matched > 0)?[_c('div',{class:_vm.leftColClassModifiers},[_c('div',{staticClass:"deposited__title deposited__title--small"},[_vm._v("Transferred")]),_vm._v(" "),_c('div',{staticClass:"deposited__amount deposited__amount--small",domProps:{"innerHTML":_vm._s(_vm.amountFormatted)}})]),_vm._v(" "),(_vm.hasPromotionalCredit)?_c('div',{staticClass:"small-4 column deposited__divider"},[_c('div',{staticClass:"deposited__title deposited__title--small"},[(_vm.isLayoutDesktop)?[_vm._v("\n            Promotional Credit\n          ")]:[_vm._v("\n            Credit\n          ")]],2),_vm._v(" "),_c('div',{staticClass:"deposited__amount deposited__amount--small",domProps:{"innerHTML":_vm._s(_vm.matchedFormatted)}})]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.rightColClassModifiers},[_c('div',{staticClass:"deposited__title deposited__title--small"},[_vm._v("Available")]),_vm._v(" "),_c('div',{staticClass:"deposited__amount deposited__amount--small"},[_vm._v(_vm._s(_vm.balance.accountBalance))])])]:[_c('div',{class:_vm.leftColClassModifiers},[_c('div',{staticClass:"deposited__title deposited__title--small"},[_vm._v("Deposited")]),_vm._v(" "),_c('div',{staticClass:"deposited__amount deposited__amount--small",domProps:{"innerHTML":_vm._s(_vm.amountFormatted)}})]),_vm._v(" "),(_vm.hasPromotionalCredit)?_c('div',{staticClass:"small-4 column deposited__divider"},[_c('div',{staticClass:"deposited__title deposited__title--small"},[(_vm.isLayoutDesktop)?[_vm._v("\n            Promotional Credit\n          ")]:[_vm._v("\n            Credit\n          ")]],2),_vm._v(" "),_c('div',{staticClass:"deposited__amount deposited__amount--small",domProps:{"innerHTML":_vm._s(_vm.promoAmountFormatted)}})]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.rightColClassModifiers},[_c('div',{staticClass:"deposited__title deposited__title--small"},[_vm._v("Available")]),_vm._v(" "),_c('div',{staticClass:"deposited__amount deposited__amount--small"},[_vm._v(_vm._s(_vm.balance.accountBalance))])])],_vm._v(" "),(_vm.currentDeposit.account || _vm.currentDeposit.confirmationNumber)?_c('div',{staticClass:"column small-12"},[(_vm.currentDeposit.account)?_c('div',{staticClass:"deposited__confirmation-number",domProps:{"innerHTML":_vm._s(_vm.currentDeposit.messageForUser)}}):_c('div',{staticClass:"deposited__confirmation-number"},[_vm._v("\n        Your confirmation number for this transaction is "+_vm._s(_vm.currentDeposit.confirmationNumber)+".\n      ")])]):_vm._e(),_vm._v(" "),(_vm.currentDeposit.account)?_c('div',{staticClass:"column small-12"},[_c('bank-account',{staticClass:"deposited__account",attrs:{"preview":true,"account":_vm.currentDeposit.account}})],1):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zhst":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-top-comments"},[_c('div',{staticClass:"market-top-comments__header"},[_c('div',{staticClass:"market-top-comments__title"},[_vm._v(_vm._s(_vm.obj.title))]),_vm._v(" "),_c('div',{staticClass:"market-top-comments__arrows"},[_c('span',{class:_vm.prevArrowModifiers,on:{"click":_vm.prevSlide}}),_vm._v(" "),_c('span',{class:_vm.nextArrowModifiers,on:{"click":_vm.nextSlide}})])]),_vm._v(" "),_c('div',{staticClass:"row market-top-comments__content"},[(!!_vm.obj)?_c('swiper',{ref:"swiper",staticClass:"market-top-comments__slider",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.items),function(comment,index){return _c('swiper-slide',{key:index,staticClass:"market-top-comments__slide"},[_c('top-comment',{attrs:{"comment":comment}})],1)}),1):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zyjZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__market_settings_button_market_settings_button_vue__ = __webpack_require__("4eDX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__market_settings_modal_market_settings_modal_vue__ = __webpack_require__("5n65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__market_contracts_list_header_sushi_item2_market_contracts_list_header_sushi_item2_vue__ = __webpack_require__("J2kF");











var firstNonEmptyString = function firstNonEmptyString() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.find(function (value) {
    return typeof value === 'string' && value.trim() !== '';
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketSettingsButton: __WEBPACK_IMPORTED_MODULE_5__market_settings_button_market_settings_button_vue__["default"],
    marketSettingsModal: __WEBPACK_IMPORTED_MODULE_6__market_settings_modal_market_settings_modal_vue__["default"],
    marketContractsListHeaderSushiItem2: __WEBPACK_IMPORTED_MODULE_7__market_contracts_list_header_sushi_item2_market_contracts_list_header_sushi_item2_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    forCmsWidget: {
      type: Boolean,
      default: false
    },
    dashboardMode: {
      type: Boolean,
      default: false
    },
    forceMobileLayout: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showSettingsModal: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isTradingEnabled', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('app', ['settingShowOdds', 'settingMobileLayout']), {
    useMobileLayout: function useMobileLayout() {
      return this.forceMobileLayout || this.isLayoutMobile;
    },
    isCondensedMobileLayout: function isCondensedMobileLayout() {
      return this.settingMobileLayout === __WEBPACK_IMPORTED_MODULE_4__store_modules_app__["c" /* APP_MOBILE_LAYOUT */].CONDENSED;
    },
    mobileBarClassModifiers: function mobileBarClassModifiers() {
      return {
        'market-contracts-list-header-sushi__mobile-bar': true,
        'market-contracts-list-header-sushi__mobile-bar--condensed': this.isCondensedMobileLayout
      };
    },
    hasOwnership: function hasOwnership() {
      if (this.market === null || !this.isLoggedIn) return false;
      return __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(this.market.contracts, function (i) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["y" /* contractOwnershipNum */])(i);
      }) > 0;
    },
    isMarketDisabled: function isMarketDisabled() {
      return this.market !== null && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["z" /* isMarketDisabled */])(this.market);
    },
    pricesTitle: function pricesTitle() {
      return this.isLayoutMobile ? 'Trade Prices' : 'Last Trade Price';
    },
    titleSecond: function titleSecond() {
      if (this.forCmsWidget) {
        return this.settingShowOdds ? 'Odds' : this.pricesTitle;
      }
      if (this.dashboardMode) {
        return this.settingShowOdds ? 'Last Odds' : 'Last Price';
      }
      return 'Latest';
    },
    titleType: function titleType() {
      return 'Type';
    },
    titleFirst: function titleFirst() {
      if (!this.forCmsWidget) {
        return 'Contract';
      }

      return firstNonEmptyString(this.market && this.market.marketShortName, this.market && this.market.marketName) || 'Contract';
    },
    titleThird: function titleThird() {
      return this.forCmsWidget ? 'Volume' : 'Ownership';
    },
    titleFourth: function titleFourth() {
      return 'Avg. Paid';
    },
    titleFifth: function titleFifth() {
      return 'Orders (Buy/Sell)';
    },
    titleBuyOrders: function titleBuyOrders() {
      return 'Buy Orders';
    },
    titleSellOrders: function titleSellOrders() {
      return 'Sell Orders';
    },
    titleSixth: function titleSixth() {
      return 'Trade';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']))
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ec8122d85eaab9f43575.js